// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZ0lEQVQ4y2NgGLKgquEuFxBPAGI2ahhWCsS/gDibUoO0gPgxEP8H4ttArEyuQYxAPBdqEAxPBImTY5gjEL9DM+wTENuQahAvEO9DMwiGdwAxOymGJQLxTyD+jgWDxCMZRsEoGAVoAADeemwtPcZI2wAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZUlEQVQ4y2NgGAWjYBSggaqGu5FA/BOIv2PBIPFEUgxjB+IdQPwfC94HxLykus4GiD+hGfQOiB3J8SojEE9EM2wuSJzcsFMG4ttQgx4DsRalkZENxL+AuJQaMcsGxBOAmGvopk8AVz1sLZgg0bsAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/nucleo-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/nucleo-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/nucleo-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fonts/nucleo-icons.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!

 =========================================================
 * Paper Dashboard PRO React - v1.3.0 based on Paper Dashboard 2 Pro - v2.0.1
 =========================================================

 * Product Page: https://dashboard.dcmarketing.ca/product/paper-dashboard-pro-react
 * Copyright 2021 Creative Tim (http://www.creative-tim.com)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  overflow: hidden;
  margin-bottom: 5px;
  line-height: 8px;
  width: 61px !important;
  height: 26px;
  outline: none;
  z-index: 0;
  margin-right: 1px;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 26px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 10px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}
.bootstrap-switch .bootstrap-switch-handle-on i,
.bootstrap-switch .bootstrap-switch-handle-off i,
.bootstrap-switch .bootstrap-switch-label i {
  font-size: 12px;
  line-height: 14px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  width: 50% !important;
  background-color: #66615B;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {
  color: #fff;
  background: #7A9E9F;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {
  color: #fff;
  background: #68B3C8;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {
  color: #fff;
  background: #7AC29A;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {
  background: #F3BB45;
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {
  color: #fff;
  background: #EB5E28;
}

.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
  color: #fff;
  background: #cfcfca;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 22px !important;
  height: 22px;
  margin: 2px -11px;
  border-radius: 12px;
  position: relative;
  float: left;
  padding: 0;
  background-color: #FFFFFF;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type=radio],
.bootstrap-switch input[type=checkbox] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch input[type=radio].form-control,
.bootstrap-switch input[type=checkbox].form-control {
  height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
  padding: 6px 16px;
  font-size: 18px;
  line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -37px !important;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px -13px -11px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {
  background-color: #66615B;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {
  background-color: #cfcfca;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {
  background-color: #EB5E28;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {
  background-color: #F3BB45;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {
  background-color: #7AC29A;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {
  background-color: #7A9E9F;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {
  background-color: #68B3C8;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {
  background-color: #66615B;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {
  background-color: #cfcfca;
}

/**
 * @author zhixin wen <wenzhixin2010@gmail.com>
 * version: 1.12.1
 * https://github.com/wenzhixin/bootstrap-table/
 */
.bootstrap-table .table {
  margin-bottom: 0 !important;
  border-bottom: 1px solid #dddddd;
  border-collapse: collapse !important;
  border-radius: 1px;
}

.bootstrap-table .table:not(.table-condensed),
.bootstrap-table .table:not(.table-condensed) > tbody > tr > th,
.bootstrap-table .table:not(.table-condensed) > tfoot > tr > th,
.bootstrap-table .table:not(.table-condensed) > thead > tr > td,
.bootstrap-table .table:not(.table-condensed) > tbody > tr > td,
.bootstrap-table .table:not(.table-condensed) > tfoot > tr > td {
  padding: 8px;
}

.bootstrap-table .table.table-no-bordered > thead > tr > th,
.bootstrap-table .table.table-no-bordered > tbody > tr > td {
  border-right: 2px solid transparent;
}

.bootstrap-table .table.table-no-bordered > tbody > tr > td:last-child {
  border-right: none;
}

.fixed-table-container {
  position: relative;
  clear: both;
  border: 1px solid #dddddd;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
}

.fixed-table-container.table-no-bordered {
  border: 1px solid transparent;
}

.fixed-table-footer,
.fixed-table-header {
  overflow: hidden;
}

.fixed-table-footer {
  border-top: 1px solid #dddddd;
}

.fixed-table-body {
  overflow-x: auto;
  overflow-y: auto;
  height: 100%;
}

.fixed-table-container table {
  width: 100%;
}

.fixed-table-container thead th {
  height: 0;
  padding: 0;
  margin: 0;
  border-left: 1px solid #dddddd;
}

.fixed-table-container thead th:focus {
  outline: 0 solid transparent;
}

.fixed-table-container thead th:first-child:not([data-not-first-th]) {
  border-left: none;
  border-top-left-radius: 4px;
  -webkit-border-top-left-radius: 4px;
  -moz-border-radius-topleft: 4px;
}

.fixed-table-container thead th .th-inner,
.fixed-table-container tbody td .th-inner {
  padding: 8px;
  line-height: 24px;
  vertical-align: top;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixed-table-container thead th .sortable {
  cursor: pointer;
  background-position: right;
  background-repeat: no-repeat;
  padding-right: 30px;
}

.fixed-table-container thead th .both {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.fixed-table-container thead th .asc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.fixed-table-container thead th .desc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.fixed-table-container th.detail {
  width: 30px;
}

.fixed-table-container tbody td {
  border-left: 1px solid #dddddd;
}

.fixed-table-container tbody tr:first-child td {
  border-top: none;
}

.fixed-table-container tbody td:first-child {
  border-left: none;
}

/* the same color with .active */
.fixed-table-container tbody .selected td {
  background-color: #f5f5f5;
}

.fixed-table-container .bs-checkbox {
  text-align: center;
}

.fixed-table-container input[type=radio],
.fixed-table-container input[type=checkbox] {
  margin: 0 auto !important;
}

.fixed-table-container .no-records-found {
  text-align: center;
}

.fixed-table-pagination div.pagination,
.fixed-table-pagination .pagination-detail {
  margin-top: 10px;
  margin-bottom: 10px;
}

.fixed-table-pagination div.pagination .pagination {
  margin: 0;
}

.fixed-table-pagination .pagination a {
  padding: 6px 12px;
  line-height: 1.428571429;
}

.fixed-table-pagination .pagination-info {
  line-height: 34px;
  margin-right: 5px;
}

.fixed-table-pagination .btn-group {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.fixed-table-pagination .dropup .dropdown-menu {
  margin-bottom: 0;
}

.fixed-table-pagination .page-list {
  display: inline-block;
}

.fixed-table-toolbar .columns-left {
  margin-right: 5px;
}

.fixed-table-toolbar .columns-right {
  margin-left: 5px;
}

.fixed-table-toolbar .columns label {
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: normal;
  line-height: 1.428571429;
}

.fixed-table-toolbar .bs-bars,
.fixed-table-toolbar .search,
.fixed-table-toolbar .columns {
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 34px;
}

.fixed-table-pagination li.disabled a {
  pointer-events: none;
  cursor: default;
}

.fixed-table-loading {
  display: none;
  position: absolute;
  top: 42px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: #fff;
  text-align: center;
}

.fixed-table-body .card-view .title {
  font-weight: bold;
  display: inline-block;
  min-width: 30%;
  text-align: left !important;
}

/* support bootstrap 2 */
.fixed-table-body thead th .th-inner {
  box-sizing: border-box;
}

.table th, .table td {
  vertical-align: middle;
  box-sizing: border-box;
}

.fixed-table-toolbar .dropdown-menu {
  text-align: left;
  max-height: 300px;
  overflow: auto;
}

.fixed-table-toolbar .btn-group > .btn-group {
  display: inline-block;
  margin-left: -1px !important;
}

.fixed-table-toolbar .btn-group > .btn-group > .btn {
  border-radius: 0;
}

.fixed-table-toolbar .btn-group > .btn-group:first-child > .btn {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.fixed-table-toolbar .btn-group > .btn-group:last-child > .btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.bootstrap-table .table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 1px solid #ddd;
}

/* support bootstrap 3 */
.bootstrap-table .table thead > tr > th {
  padding: 0;
  margin: 0;
}

.bootstrap-table .fixed-table-footer tbody > tr > td {
  padding: 0 !important;
}

.bootstrap-table .fixed-table-footer .table {
  border-bottom: none;
  border-radius: 0;
  padding: 0 !important;
}

.bootstrap-table .pull-right .dropdown-menu {
  right: 0;
  left: auto;
}

/* calculate scrollbar width */
p.fixed-table-scroll-inner {
  width: 100%;
  height: 200px;
}

div.fixed-table-scroll-outer {
  top: 0;
  left: 0;
  visibility: hidden;
  width: 200px;
  height: 150px;
  overflow: hidden;
}

/* for get correct heights  */
.fixed-table-toolbar:after, .fixed-table-pagination:after {
  content: "";
  display: block;
  clear: both;
}

.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100% !important;
  background: #FFF;
}

.bootstrap-table .btn-group:last-child .btn {
  border-top-right-radius: 30px !important;
  border-bottom-right-radius: 30px !important;
  margin-left: -2px;
}

/*! nouislider - 9.1.0 - 2016-12-10 16:00:32 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1; /* Fix 401 */
}

.noUi-connect {
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
}

.noUi-origin {
  position: absolute;
  height: 0;
  width: 0;
}

.noUi-handle {
  position: relative;
  z-index: 1;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Painting and performance;
 * Browsers can paint handles in their own layer.
 */
.noUi-base,
.noUi-handle {
  transform: translate3d(0, 0, 0);
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 8px;
}

.noUi-horizontal .noUi-handle {
  background: rgb(255, 255, 255); /* Old browsers */ /* FF3.6+ */ /* Chrome,Safari4+ */ /* Chrome10+,Safari5.1+ */ /* Opera 11.10+ */ /* IE10+ */
  background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(241, 241, 242) 100%); /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="\$white-color", endColorstr="#f1f1f2",GradientType=0 ); /* IE6-9 */
  border-radius: 50%;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 2px rgba(0, 0, 0, 0.4);
  height: 15px;
  width: 15px;
  cursor: pointer;
  margin-left: -10px;
  margin-top: -4px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

/* Styling;
 */
.noUi-target {
  background-color: #E5E5E5;
  border-radius: 3px;
}

.noUi-connect {
  background: #3FB8AF;
  border-radius: 3px;
  transition: background 450ms;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
}

.noUi-active {
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
}

/* Handle stripes;
 */
/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate3d(-50%, 50%, 0);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate3d(0, 50%, 0);
  padding-left: 25px;
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.slider.slider-info .noUi-connect, .slider.slider-info.noUi-connect {
  background-color: #51bcda;
}
.slider.slider-info .noUi-handle {
  border-color: #51bcda;
}
.slider.slider-success .noUi-connect, .slider.slider-success.noUi-connect {
  background-color: #6bd098;
}
.slider.slider-success .noUi-handle {
  border-color: #6bd098;
}
.slider.slider-warning .noUi-connect, .slider.slider-warning.noUi-connect {
  background-color: #fbc658;
}
.slider.slider-warning .noUi-handle {
  border-color: #fbc658;
}
.slider.slider-danger .noUi-connect, .slider.slider-danger.noUi-connect {
  background-color: #ef8157;
}
.slider.slider-danger .noUi-handle {
  border-color: #ef8157;
}

/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT

Copyright (c) 2015 Daniel Eden
*/
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.animated.infinite {
  animation-iteration-count: infinite;
}

.animated.hinge {
  animation-duration: 2s;
}

.animated.bounceIn,
.animated.bounceOut {
  animation-duration: 0.75s;
}

.animated.flipOutX,
.animated.flipOutY {
  animation-duration: 0.75s;
}
@keyframes shake {
  from, to {
    transform: translate3d(0, 0, 0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translate3d(-10px, 0, 0);
  }
  20%, 40%, 60%, 80% {
    transform: translate3d(10px, 0, 0);
  }
}
.shake {
  animation-name: shake;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
@keyframes fadeOutDown {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
.fadeOutDown {
  animation-name: fadeOutDown;
}
@keyframes fadeOutUp {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.fadeOutUp {
  animation-name: fadeOutUp;
}

/* perfect-scrollbar v0.6.13 */
.ps-container {
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}

@supports (-ms-overflow-style: none) {
  .ps-container {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps-container {
    overflow: auto !important;
  }
}
.ps-container.ps-active-x > .ps-scrollbar-x-rail,
.ps-container.ps-active-y > .ps-scrollbar-y-rail {
  display: block;
  background-color: transparent;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  background-color: #999;
  height: 11px;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #999;
  width: 11px;
}

.ps-container > .ps-scrollbar-x-rail {
  display: none;
  position: absolute;
  /* please don't change 'position' */
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  bottom: 0px;
  /* there must be 'bottom' for ps-scrollbar-x-rail */
  height: 15px;
}

.ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  position: absolute;
  /* please don't change 'position' */
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s linear, width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
  bottom: 2px;
  /* there must be 'bottom' for ps-scrollbar-x */
  height: 6px;
}

.ps-container > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x, .ps-container > .ps-scrollbar-x-rail:active > .ps-scrollbar-x {
  height: 11px;
}

.ps-container > .ps-scrollbar-y-rail {
  display: none;
  position: absolute;
  /* please don't change 'position' */
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  right: 0;
  /* there must be 'right' for ps-scrollbar-y-rail */
  width: 15px;
}

.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  position: absolute;
  /* please don't change 'position' */
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s linear, width 0.2s ease-in-out, border-radius 0.2s ease-in-out;
  right: 2px;
  /* there must be 'right' for ps-scrollbar-y */
  width: 6px;
}

.ps-container > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y, .ps-container > .ps-scrollbar-y-rail:active > .ps-scrollbar-y {
  width: 11px;
}

.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  background-color: #999;
  height: 11px;
}

.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #999;
  width: 11px;
}

.ps-container:hover > .ps-scrollbar-x-rail,
.ps-container:hover > .ps-scrollbar-y-rail {
  opacity: 0.6;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {
  background-color: #999;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {
  background-color: #999;
}

body.swal2-shown {
  overflow-y: hidden;
}

body.swal2-iosfix {
  position: fixed;
  left: 0;
  right: 0;
}

.swal2-container {
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 10px;
  background-color: transparent;
  z-index: 1060;
}

.swal2-container.swal2-fade {
  transition: background-color 0.1s;
}

.swal2-container.swal2-shown {
  background-color: rgba(0, 0, 0, 0.4);
}

.swal2-modal {
  background-color: #fff;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-radius: 5px;
  box-sizing: border-box;
  text-align: center;
  margin: auto;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  overflow-x: hidden;
  overflow-y: auto;
  display: none;
  position: relative;
  max-width: 100%;
}

.swal2-modal:focus {
  outline: none;
}

.swal2-modal.swal2-loading {
  overflow-y: hidden;
}

.swal2-modal .swal2-title {
  color: #595959;
  font-size: 30px;
  text-align: center;
  font-weight: 600;
  text-transform: none;
  position: relative;
  margin: 0 0 0.4em;
  padding: 0;
  display: block;
  word-wrap: break-word;
}

.swal2-modal .swal2-buttonswrapper {
  margin-top: 15px;
}

.swal2-modal .swal2-buttonswrapper:not(.swal2-loading) .swal2-styled[disabled] {
  opacity: 0.4;
  cursor: no-drop;
}

.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-confirm {
  box-sizing: border-box;
  border: 4px solid transparent;
  border-color: transparent;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 7.5px;
  vertical-align: top;
  background-color: transparent !important;
  color: transparent;
  cursor: default;
  border-radius: 100%;
  animation: rotate-loading 1.5s linear 0s infinite normal;
  -webkit-user-select: none;
  user-select: none;
}

.swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-cancel {
  margin-left: 30px;
  margin-right: 30px;
}

.swal2-modal .swal2-buttonswrapper.swal2-loading :not(.swal2-styled).swal2-confirm::after {
  display: inline-block;
  content: "";
  margin-left: 5px;
  vertical-align: -1px;
  height: 15px;
  width: 15px;
  border: 3px solid #999999;
  box-shadow: 1px 1px 1px #fff;
  border-right-color: transparent;
  border-radius: 50%;
  animation: rotate-loading 1.5s linear 0s infinite normal;
}

.swal2-modal .swal2-styled {
  border: 0;
  border-radius: 3px;
  box-shadow: none;
  color: #fff;
  cursor: pointer;
  font-size: 17px;
  font-weight: 500;
  margin: 15px 5px 0;
  padding: 10px 32px;
}

.swal2-modal .swal2-styled:focus {
  outline: none;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4);
}

.swal2-modal .swal2-image {
  margin: 20px auto;
  max-width: 100%;
}

.swal2-modal .swal2-close {
  background: transparent;
  border: 0;
  margin: 0;
  padding: 0;
  width: 38px;
  height: 40px;
  font-size: 36px;
  line-height: 40px;
  font-family: serif;
  position: absolute;
  top: 5px;
  right: 8px;
  cursor: pointer;
  color: #cccccc;
  transition: color 0.1s ease;
}

.swal2-modal .swal2-close:hover {
  color: #d55;
}

.swal2-modal > .swal2-input,
.swal2-modal > .swal2-file,
.swal2-modal > .swal2-textarea,
.swal2-modal > .swal2-select,
.swal2-modal > .swal2-radio,
.swal2-modal > .swal2-checkbox {
  display: none;
}

.swal2-modal .swal2-content {
  font-size: 18px;
  text-align: center;
  font-weight: 300;
  position: relative;
  float: none;
  margin: 0;
  padding: 0;
  line-height: normal;
  color: #545454;
  word-wrap: break-word;
}

.swal2-modal .swal2-input,
.swal2-modal .swal2-file,
.swal2-modal .swal2-textarea,
.swal2-modal .swal2-select,
.swal2-modal .swal2-radio,
.swal2-modal .swal2-checkbox {
  margin: 20px auto;
}

.swal2-modal .swal2-input,
.swal2-modal .swal2-file,
.swal2-modal .swal2-textarea {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  border-radius: 3px;
  border: 1px solid #d9d9d9;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);
  transition: border-color 0.3s, box-shadow 0.3s;
}

.swal2-modal .swal2-input.swal2-inputerror,
.swal2-modal .swal2-file.swal2-inputerror,
.swal2-modal .swal2-textarea.swal2-inputerror {
  border-color: #f27474 !important;
  box-shadow: 0 0 2px #f27474 !important;
}

.swal2-modal .swal2-input:focus,
.swal2-modal .swal2-file:focus,
.swal2-modal .swal2-textarea:focus {
  outline: none;
  border: 1px solid #b4dbed;
  box-shadow: 0 0 3px #c4e6f5;
}

.swal2-modal .swal2-input::placeholder,
.swal2-modal .swal2-file::placeholder,
.swal2-modal .swal2-textarea::placeholder {
  color: #cccccc;
}

.swal2-modal .swal2-range input {
  float: left;
  width: 80%;
}

.swal2-modal .swal2-range output {
  float: right;
  width: 20%;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.swal2-modal .swal2-range input,
.swal2-modal .swal2-range output {
  height: 43px;
  line-height: 43px;
  vertical-align: middle;
  margin: 20px auto;
  padding: 0;
}

.swal2-modal .swal2-input {
  height: 43px;
  padding: 0 12px;
}

.swal2-modal .swal2-input[type=number] {
  max-width: 150px;
}

.swal2-modal .swal2-file {
  font-size: 20px;
}

.swal2-modal .swal2-textarea {
  height: 108px;
  padding: 12px;
}

.swal2-modal .swal2-select {
  color: #545454;
  font-size: inherit;
  padding: 5px 10px;
  min-width: 40%;
  max-width: 100%;
}

.swal2-modal .swal2-radio {
  border: 0;
}

.swal2-modal .swal2-radio label:not(:first-child) {
  margin-left: 20px;
}

.swal2-modal .swal2-radio input,
.swal2-modal .swal2-radio span {
  vertical-align: middle;
}

.swal2-modal .swal2-radio input {
  margin: 0 3px 0 0;
}

.swal2-modal .swal2-checkbox {
  color: #545454;
}

.swal2-modal .swal2-checkbox input,
.swal2-modal .swal2-checkbox span {
  vertical-align: middle;
}

.swal2-modal .swal2-validationerror {
  background-color: #f0f0f0;
  margin: 0 -20px;
  overflow: hidden;
  padding: 10px;
  color: gray;
  font-size: 16px;
  font-weight: 300;
  display: none;
}

.swal2-modal .swal2-validationerror::before {
  content: "!";
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ea7d7d;
  color: #fff;
  line-height: 24px;
  text-align: center;
  margin-right: 10px;
}

@supports (-ms-accelerator: true) {
  .swal2-range input {
    width: 100% !important;
  }
  .swal2-range output {
    display: none;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .swal2-range input {
    width: 100% !important;
  }
  .swal2-range output {
    display: none;
  }
}
.swal2-icon {
  width: 80px;
  height: 80px;
  border: 4px solid transparent;
  border-radius: 50%;
  margin: 20px auto 30px;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
}

.swal2-icon.swal2-error {
  border-color: rgba(255, 54, 54, 0.3);
}

.swal2-icon.swal2-error .swal2-x-mark {
  position: relative;
  display: block;
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line] {
  position: absolute;
  height: 5px;
  width: 47px;
  background-color: #FF3636;
  display: block;
  top: 37px;
  border-radius: 2px;
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=left] {
  transform: rotate(45deg);
  left: 17px;
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=right] {
  transform: rotate(-45deg);
  right: 16px;
}

.swal2-icon.swal2-warning {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #FFB236;
  border-color: #FFB236;
  font-size: 60px;
  line-height: 80px;
  text-align: center;
}

.swal2-icon.swal2-info {
  font-family: "Open Sans", sans-serif;
  color: #3fc3ee;
  border-color: #9de0f6;
  font-size: 60px;
  line-height: 80px;
  text-align: center;
}

.swal2-icon.swal2-question {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #87adbd;
  border-color: #c9dae1;
  font-size: 60px;
  line-height: 80px;
  text-align: center;
}

.swal2-icon.swal2-success {
  border-color: #a5dc86;
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line] {
  border-radius: 50%;
  position: absolute;
  width: 60px;
  height: 120px;
  transform: rotate(45deg);
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line][class\$=left] {
  border-radius: 120px 0 0 120px;
  top: -7px;
  left: -33px;
  transform: rotate(-45deg);
  transform-origin: 60px 60px;
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line][class\$=right] {
  border-radius: 0 120px 120px 0;
  top: -11px;
  left: 30px;
  transform: rotate(-45deg);
  transform-origin: 0 60px;
}

.swal2-icon.swal2-success .swal2-success-ring {
  width: 80px;
  height: 80px;
  border: 4px solid rgba(24, 206, 15, 0.3);
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 2;
}

.swal2-icon.swal2-success .swal2-success-fix {
  width: 7px;
  height: 90px;
  position: absolute;
  left: 28px;
  top: 8px;
  z-index: 1;
  transform: rotate(-45deg);
}

.swal2-icon.swal2-success [class^=swal2-success-line] {
  height: 5px;
  background-color: #18ce0f;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 2;
}

.swal2-icon.swal2-success [class^=swal2-success-line][class\$=tip] {
  width: 25px;
  left: 14px;
  top: 46px;
  transform: rotate(45deg);
}

.swal2-icon.swal2-success [class^=swal2-success-line][class\$=long] {
  width: 47px;
  right: 8px;
  top: 38px;
  transform: rotate(-45deg);
}

.swal2-progresssteps {
  font-weight: 600;
  margin: 0 0 20px;
  padding: 0;
}

.swal2-progresssteps li {
  display: inline-block;
  position: relative;
}

.swal2-progresssteps .swal2-progresscircle {
  background: #3085d6;
  border-radius: 2em;
  color: #fff;
  height: 2em;
  line-height: 2em;
  text-align: center;
  width: 2em;
  z-index: 20;
}

.swal2-progresssteps .swal2-progresscircle:first-child {
  margin-left: 0;
}

.swal2-progresssteps .swal2-progresscircle:last-child {
  margin-right: 0;
}

.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep {
  background: #3085d6;
}

.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep ~ .swal2-progresscircle {
  background: #add8e6;
}

.swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep ~ .swal2-progressline {
  background: #add8e6;
}

.swal2-progresssteps .swal2-progressline {
  background: #3085d6;
  height: 0.4em;
  margin: 0 -1px;
  z-index: 10;
}

[class^=swal2] {
  -webkit-tap-highlight-color: transparent;
}
@keyframes showSweetAlert {
  0% {
    transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes hideSweetAlert {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}
.swal2-show {
  animation: showSweetAlert 0.3s;
}

.swal2-show.swal2-noanimation {
  animation: none;
}

.swal2-hide {
  animation: hideSweetAlert 0.15s forwards;
}

.swal2-hide.swal2-noanimation {
  animation: none;
}
@keyframes animate-success-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animate-success-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
@keyframes rotatePlaceholder {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
.swal2-animate-success-line-tip {
  animation: animate-success-tip 0.75s;
}

.swal2-animate-success-line-long {
  animation: animate-success-long 0.75s;
}

.swal2-success.swal2-animate-success-icon .swal2-success-circular-line-right {
  animation: rotatePlaceholder 4.25s ease-in;
}
@keyframes animate-error-icon {
  0% {
    transform: rotateX(100deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    opacity: 1;
  }
}
.swal2-animate-error-icon {
  animation: animate-error-icon 0.5s;
}
@keyframes animate-x-mark {
  0% {
    transform: scale(0.4);
    margin-top: 26px;
    opacity: 0;
  }
  50% {
    transform: scale(0.4);
    margin-top: 26px;
    opacity: 0;
  }
  80% {
    transform: scale(1.15);
    margin-top: -6px;
  }
  100% {
    transform: scale(1);
    margin-top: 0;
    opacity: 1;
  }
}
.swal2-animate-x-mark {
  animation: animate-x-mark 0.5s;
}
@keyframes rotate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.card-wizard {
  min-height: 410px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  opacity: 0;
  transition: all 300ms linear;
}
.card-wizard.active {
  opacity: 1;
}
.card-wizard .card-header {
  padding: 15px 0 !important;
  padding-bottom: 40px;
}
.card-wizard .nav-pills .nav-item .nav-link {
  padding: 12px;
}
.card-wizard .nav-pills .nav-item .nav-link,
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link:hover,
.card-wizard .nav-pills .nav-item .nav-link:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
  background-color: transparent;
  box-shadow: none;
}
.card-wizard .picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}
.card-wizard .wizard-navigation {
  position: relative;
}
.card-wizard .wizard-navigation .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-wizard .wizard-navigation .nav-link i,
.card-wizard .moving-tab i {
  display: inline-block;
  font-size: 19px;
  line-height: normal;
  line-height: initial;
  margin-right: 6px;
  padding: 0;
  vertical-align: bottom;
}
.card-wizard .picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 1px solid #E3E3E3;
  color: #FFFFFF;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .picture:hover {
  border-color: #2ca8ff;
}
.card-wizard .moving-tab {
  position: absolute;
  text-align: center;
  padding: 12px;
  font-size: 12px;
  text-transform: uppercase;
  -webkit-font-smoothing: subpixel-antialiased;
  top: 0px;
  left: 0px;
  background-color: #66615B;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #FFFFFF !important;
  cursor: pointer;
  font-weight: 500;
}
.card-wizard[data-color=primary] .moving-tab {
  color: #51cbce;
}
.card-wizard[data-color=primary] .picture:hover {
  border-color: #51cbce;
}
.card-wizard[data-color=primary] .choice:hover .icon, .card-wizard[data-color=primary] .choice.active .icon {
  border-color: #51cbce;
  color: #51cbce;
}
.card-wizard[data-color=primary] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #51cbce;
}
.card-wizard[data-color=primary] .radio input[type=radio]:checked ~ .check {
  background-color: #51cbce;
}
.card-wizard[data-color=primary] .radio input[type=radio]:checked ~ .circle {
  border-color: #51cbce;
}
.card-wizard[data-color=white] .moving-tab {
  color: #FFFFFF;
}
.card-wizard[data-color=white] .picture:hover {
  border-color: #FFFFFF;
}
.card-wizard[data-color=white] .choice:hover .icon, .card-wizard[data-color=white] .choice.active .icon {
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.card-wizard[data-color=white] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #FFFFFF;
}
.card-wizard[data-color=white] .radio input[type=radio]:checked ~ .check {
  background-color: #FFFFFF;
}
.card-wizard[data-color=white] .radio input[type=radio]:checked ~ .circle {
  border-color: #FFFFFF;
}
.card-wizard[data-color=green] .moving-tab {
  color: #6bd098;
}
.card-wizard[data-color=green] .picture:hover {
  border-color: #6bd098;
}
.card-wizard[data-color=green] .choice:hover .icon, .card-wizard[data-color=green] .choice.active .icon {
  border-color: #6bd098;
  color: #6bd098;
}
.card-wizard[data-color=green] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #6bd098;
}
.card-wizard[data-color=green] .radio input[type=radio]:checked ~ .check {
  background-color: #6bd098;
}
.card-wizard[data-color=green] .radio input[type=radio]:checked ~ .circle {
  border-color: #6bd098;
}
.card-wizard[data-color=blue] .moving-tab {
  color: #51bcda;
}
.card-wizard[data-color=blue] .picture:hover {
  border-color: #51bcda;
}
.card-wizard[data-color=blue] .choice:hover .icon, .card-wizard[data-color=blue] .choice.active .icon {
  border-color: #51bcda;
  color: #51bcda;
}
.card-wizard[data-color=blue] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #51bcda;
}
.card-wizard[data-color=blue] .radio input[type=radio]:checked ~ .check {
  background-color: #51bcda;
}
.card-wizard[data-color=blue] .radio input[type=radio]:checked ~ .circle {
  border-color: #51bcda;
}
.card-wizard[data-color=orange] .moving-tab {
  color: #fbc658;
}
.card-wizard[data-color=orange] .picture:hover {
  border-color: #fbc658;
}
.card-wizard[data-color=orange] .choice:hover .icon, .card-wizard[data-color=orange] .choice.active .icon {
  border-color: #fbc658;
  color: #fbc658;
}
.card-wizard[data-color=orange] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #fbc658;
}
.card-wizard[data-color=orange] .radio input[type=radio]:checked ~ .check {
  background-color: #fbc658;
}
.card-wizard[data-color=orange] .radio input[type=radio]:checked ~ .circle {
  border-color: #fbc658;
}
.card-wizard[data-color=red] .moving-tab {
  color: #ef8157;
}
.card-wizard[data-color=red] .picture:hover {
  border-color: #ef8157;
}
.card-wizard[data-color=red] .choice:hover .icon, .card-wizard[data-color=red] .choice.active .icon {
  border-color: #ef8157;
  color: #ef8157;
}
.card-wizard[data-color=red] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #ef8157;
}
.card-wizard[data-color=red] .radio input[type=radio]:checked ~ .check {
  background-color: #ef8157;
}
.card-wizard[data-color=red] .radio input[type=radio]:checked ~ .circle {
  border-color: #ef8157;
}
.card-wizard .picture input[type=file] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
.card-wizard .picture-src {
  width: 100%;
}
.card-wizard .tab-content {
  min-height: 355px;
  padding: 20px 0;
}
.card-wizard .wizard-footer {
  padding: 0 15px;
}
.card-wizard .wizard-footer .checkbox {
  margin-top: 16px;
}
.card-wizard .disabled {
  display: none;
}
.card-wizard .wizard-header {
  text-align: center;
  padding: 25px 0 35px;
}
.card-wizard .wizard-header h5 {
  margin: 5px 0 0;
}
.card-wizard .nav-pills > li {
  text-align: center;
}
.card-wizard .btn {
  text-transform: uppercase;
}
.card-wizard .info-text {
  text-align: center;
  font-weight: 300;
  margin: 10px 0 30px;
}
.card-wizard .choice {
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.card-wizard .choice[disabled] {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.card-wizard .choice .icon {
  text-align: center;
  vertical-align: middle;
  height: 116px;
  width: 116px;
  border-radius: 50%;
  color: #66615B;
  margin: 0 auto 20px;
  border: 1px solid #E3E3E3;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .choice i {
  font-size: 30px;
  line-height: 116px;
  position: absolute;
  left: 0;
  right: 0;
}
.card-wizard .choice:hover .icon, .card-wizard .choice.active .icon {
  border-color: #2ca8ff;
}
.card-wizard .choice input[type=radio],
.card-wizard .choice input[type=checkbox] {
  position: absolute;
  left: -10000px;
  z-index: -1;
}
.card-wizard .btn-finish {
  display: none;
}
.card-wizard .card-title + .description {
  font-size: 17px;
  margin-bottom: 32px;
}
.card-wizard .wizard-title {
  margin: 0;
}
.card-wizard .nav-pills {
  background-color: #9A9A9A;
}
.card-wizard .nav-pills > li + li {
  margin-left: 0;
}
.card-wizard .nav-pills > li > a {
  border: 0 !important;
  border-radius: 0;
  line-height: 18px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  min-width: 100px;
  text-align: center;
  color: #FFFFFF !important;
}
.card-wizard .nav-pills > li.active > a,
.card-wizard .nav-pills > li.active > a:hover,
.card-wizard .nav-pills > li.active > a:focus,
.card-wizard .nav-pills > li > a:hover,
.card-wizard .nav-pills > li > a:focus {
  background-color: inherit;
  box-shadow: none;
}
.card-wizard .nav-pills > li i {
  display: block;
  font-size: 30px;
  padding: 15px 0;
}
.card-wizard .form-group.select-wizard {
  margin-top: 15px;
}
.card-wizard .dropdown.show .dropdown-menu,
.card-wizard .dropup.show .dropdown-menu {
  transform: translate3d(0, 0px, 0) !important;
}

/*!
 * Datetimepicker for Bootstrap 3
 * ! version : 4.7.14
 * https://github.com/Eonasdan/bootstrap-datetimepicker/
 */
.sr-only,
.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=showHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after,
.bootstrap-datetimepicker-widget .btn[data-action=clear]::after,
.bootstrap-datetimepicker-widget .btn[data-action=today]::after,
.bootstrap-datetimepicker-widget .picker-switch::after,
.bootstrap-datetimepicker-widget table th.prev::after,
.bootstrap-datetimepicker-widget table th.next::after {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.bootstrap-datetimepicker-widget {
  list-style: none;
}

.bootstrap-datetimepicker-widget a .btn:hover {
  background-color: transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu {
  padding: 4px;
  width: 16em;
}

@media (min-width: 768px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 992px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 1200px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  border-bottom: 11px solid #F1EAE0;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  left: auto;
  top: -12px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {
  border-bottom: 11px solid #FFFFFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  left: auto;
  top: -11px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top {
  margin-top: auto;
  margin-bottom: -20px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top.open {
  margin-top: auto;
  margin-bottom: 5px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {
  left: auto;
  right: 6px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {
  left: auto;
  right: 7px;
}

.bootstrap-datetimepicker-widget .list-unstyled {
  margin: 0;
}

.bootstrap-datetimepicker-widget a[data-action] {
  padding: 6px 0;
  border-width: 0;
  color: #66615B;
  background-color: transparent;
}

.bootstrap-datetimepicker-widget a[data-action=togglePicker],
.bootstrap-datetimepicker-widget a[data-action=togglePicker]:hover {
  color: #429cb6 !important;
}

.bootstrap-datetimepicker-widget a[data-action]:hover {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.85);
}

.bootstrap-datetimepicker-widget a[data-action]:active {
  box-shadow: none;
}

.bootstrap-datetimepicker-widget .timepicker-hour,
.bootstrap-datetimepicker-widget .timepicker-minute,
.bootstrap-datetimepicker-widget .timepicker-second {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-weight: 300;
  font-size: 1.5em;
  margin: 3px;
  border-radius: 50%;
}

.bootstrap-datetimepicker-widget button[data-action] {
  width: 38px;
  height: 38px;
  padding: 0;
}

.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after {
  content: "Increment Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after {
  content: "Increment Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after {
  content: "Decrement Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after {
  content: "Decrement Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=showHours]::after {
  content: "Show Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after {
  content: "Show Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after {
  content: "Toggle AM/PM";
}

.bootstrap-datetimepicker-widget .btn[data-action=clear]::after {
  content: "Clear the picker";
}

.bootstrap-datetimepicker-widget .btn[data-action=today]::after {
  content: "Set the date to today";
}

.bootstrap-datetimepicker-widget .picker-switch {
  text-align: center;
  border-radius: 4px;
}

.bootstrap-datetimepicker-widget .picker-switch::after {
  content: "Toggle Date and Time Screens";
}

.bootstrap-datetimepicker-widget .picker-switch td {
  padding: 0;
  margin: 0;
  height: auto;
  width: auto;
  line-height: inherit;
}

.bootstrap-datetimepicker-widget .picker-switch td span {
  line-height: 2.5;
  height: 2.5em;
  width: 100%;
  border-radius: 4px;
  margin: 2px 0px !important;
}

.bootstrap-datetimepicker-widget table {
  width: 100%;
  margin: 0;
}

.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {
  text-align: center;
}

.bootstrap-datetimepicker-widget table th {
  height: 20px;
  line-height: 20px;
  width: 20px;
}

.bootstrap-datetimepicker-widget table th.picker-switch {
  width: 145px;
}

.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {
  border-radius: 4px;
  height: 27px;
  width: 27px;
  line-height: 28px;
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
}

.bootstrap-datetimepicker-widget table th.prev::after {
  content: "Previous Month";
}

.bootstrap-datetimepicker-widget table th.next::after {
  content: "Next Month";
}

.bootstrap-datetimepicker-widget table th.dow {
  text-align: center;
  border-bottom: 1px solid #E3E3E3;
  font-size: 12px;
  text-transform: uppercase;
  color: #9A9A9A;
  font-weight: 400;
  padding-bottom: 5px;
  padding-top: 10px;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th {
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {
  background: #E3E3E3;
}

.bootstrap-datetimepicker-widget table td > div {
  border-radius: 4px;
  height: 54px;
  line-height: 54px;
  width: 54px;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td.cw > div {
  font-size: 0.8em;
  height: 20px;
  line-height: 20px;
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.day > div {
  height: 30px;
  line-height: 31px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
  margin: 0 auto;
  z-index: -1;
  position: relative;
}

.table-condensed .day:hover div {
  transition: all 150ms linear;
}

.bootstrap-datetimepicker-widget table td.minute > div, .bootstrap-datetimepicker-widget table td.hour > div {
  border-radius: 50%;
}

.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {
  background: #E3E3E3;
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.today > div:before {
  content: "";
  display: inline-block;
  border: 0 0 7px 7px solid transparent;
  border-bottom-color: #68B3C8;
  border-top-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 4px;
  right: 4px;
}

.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {
  background-color: #68B3C8;
  color: #FFFFFF;
}

.bootstrap-datetimepicker-widget table td.active.today:before > div {
  border-bottom-color: #FFFFFF;
}

.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table td span {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td span:hover {
  background: #E3E3E3;
}

.bootstrap-datetimepicker-widget table td span.active {
  background-color: #68B3C8;
  color: #FFFFFF;
}

.bootstrap-datetimepicker-widget table td span.old {
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget .timepicker-picker span,
.bootstrap-datetimepicker-widget .timepicker-hours span,
.bootstrap-datetimepicker-widget .timepicker-minutes span {
  border-radius: 50% !important;
}

.bootstrap-datetimepicker-widget.usetwentyfour td.hour {
  height: 27px;
  line-height: 27px;
}

.input-group.date .input-group-addon {
  cursor: pointer;
}

.table-condensed > tbody > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > thead > tr > th {
  padding: 1px;
  text-align: center;
  z-index: 1;
  cursor: pointer;
}

.bootstrap-datetimepicker-widget {
  opacity: 0;
  box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);
  transform: translate3d(0, -10px, 0) !important;
}
.bootstrap-datetimepicker-widget.top {
  transform: translate3d(0, 10px, 0) !important;
  opacity: 0;
}
.bootstrap-datetimepicker-widget.open {
  opacity: 1;
  transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
  transform: translate3d(0, 2px, 0) !important;
}

.bootstrap-datetimepicker-widget.top.open {
  opacity: 1;
  transform: translate3d(0, -7px, 0) !important;
  transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
}
.bootstrap-datetimepicker-widget.top.open:before {
  border-top: 11px solid #DCD9D1;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -12px;
}
.bootstrap-datetimepicker-widget.top.open:after {
  border-top: 11px solid #FFFFFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -11px;
}

/*!
 * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)
 *
 * Copyright 2013-2017 bootstrap-select
 * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
 */
select.bs-select-hidden,
select.selectpicker {
  display: none !important;
}

.bootstrap-select {
  width: 220px; /*IE9 and below*/
}
.bootstrap-select > .dropdown-toggle {
  width: 100%;
  padding-right: 25px;
  z-index: 1;
}
.bootstrap-select > select {
  position: absolute !important;
  bottom: 0;
  left: 50%;
  display: block !important;
  width: 0.5px !important;
  height: 100% !important;
  padding: 0 !important;
  opacity: 0 !important;
  border: none;
}
.bootstrap-select > select.mobile-device {
  top: 0;
  left: 0;
  display: block !important;
  width: 100% !important;
  z-index: 2;
}
.has-error .bootstrap-select .dropdown-toggle, .error .bootstrap-select .dropdown-toggle {
  border-color: rgb(185, 74, 72);
}
.bootstrap-select.fit-width {
  width: auto !important;
}
.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn) {
  width: 150px;
}

.bootstrap-select.form-control {
  margin-bottom: 0;
  padding: 0;
  border: none;
}
.bootstrap-select.form-control:not([class*=col-]) {
  width: 100%;
}
.bootstrap-select.form-control.input-group-btn {
  z-index: auto;
}
.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}

.bootstrap-select.btn-group:not(.input-group-btn), .bootstrap-select.btn-group[class*=col-] {
  float: none;
  display: inline-block;
  margin-left: 0;
}
.bootstrap-select.btn-group.dropdown-menu-right, .bootstrap-select.btn-group[class*=col-].dropdown-menu-right, .row .bootstrap-select.btn-group[class*=col-].dropdown-menu-right {
  float: right;
}
.form-inline .bootstrap-select.btn-group, .form-horizontal .bootstrap-select.btn-group, .form-group .bootstrap-select.btn-group {
  margin-bottom: 0;
}
.form-group-lg .bootstrap-select.btn-group.form-control, .form-group-sm .bootstrap-select.btn-group.form-control {
  padding: 0;
}
.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle, .form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {
  height: 100%;
  font-size: inherit;
  line-height: inherit;
  border-radius: inherit;
}
.form-inline .bootstrap-select.btn-group .form-control {
  width: 100%;
}
.bootstrap-select.btn-group.disabled,
.bootstrap-select.btn-group > .disabled {
  cursor: not-allowed;
}
.bootstrap-select.btn-group.disabled:focus,
.bootstrap-select.btn-group > .disabled:focus {
  outline: none !important;
}
.bootstrap-select.btn-group.bs-container {
  position: absolute;
  height: 0 !important;
  padding: 0 !important;
}
.bootstrap-select.btn-group.bs-container .dropdown-menu {
  z-index: 1060;
}
.bootstrap-select.btn-group .dropdown-toggle .filter-option {
  display: inline-block;
  overflow: hidden;
  width: 100%;
  text-align: left;
}
.bootstrap-select.btn-group[class*=col-] .dropdown-toggle {
  width: 100%;
}
.bootstrap-select.btn-group .dropdown-menu {
  min-width: 100%;
  box-sizing: border-box;
}
.bootstrap-select.btn-group .dropdown-menu.inner {
  position: static;
  float: none;
  border: 0;
  padding: 0;
  margin: 0;
}
.bootstrap-select.btn-group .dropdown-menu li {
  position: relative;
}
.bootstrap-select.btn-group .dropdown-menu li.active small {
  color: #fff;
}
.bootstrap-select.btn-group .dropdown-menu li.disabled a {
  cursor: not-allowed;
}
.bootstrap-select.btn-group .dropdown-menu li a {
  color: #66615b;
  font-size: 16px;
  padding: 5px 45px 5px 15px;
  clear: both;
  white-space: nowrap;
  width: 100%;
  display: block;
}
.bootstrap-select.btn-group .dropdown-menu li a:hover {
  background-color: #66615B;
  color: rgba(255, 255, 255, 0.7);
  opacity: 1;
  text-decoration: none;
}
.bootstrap-select.btn-group .dropdown-menu li a.opt {
  position: relative;
  padding-left: 2.25em;
}
.bootstrap-select.btn-group .dropdown-menu li a span.check-mark {
  display: none;
}
.bootstrap-select.btn-group .dropdown-menu li a span.text {
  display: inline-block;
}
.bootstrap-select.btn-group .dropdown-menu li small {
  padding-left: 0.5em;
}
.bootstrap-select.btn-group .dropdown-menu .notify {
  position: absolute;
  bottom: 5px;
  width: 96%;
  margin: 0 2%;
  min-height: 26px;
  padding: 3px 5px;
  background: rgb(245, 245, 245);
  border: 1px solid rgb(227, 227, 227);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  pointer-events: none;
  opacity: 0.9;
  box-sizing: border-box;
}
.bootstrap-select.btn-group .no-results {
  padding: 3px;
  background: #f5f5f5;
  margin: 0 5px;
  white-space: nowrap;
}
.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {
  position: static;
}
.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark {
  position: absolute;
  display: inline-block;
  right: 15px;
  margin-top: 5px;
}
.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {
  margin-right: 34px;
}

.bootstrap-select.show-menu-arrow.show > .dropdown-toggle {
  z-index: 1061;
}
.bootstrap-select.show-menu-arrow .dropdown-toggle:before {
  content: "";
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(204, 204, 204, 0.2);
  position: absolute;
  bottom: -4px;
  left: 9px;
  display: none;
}
.bootstrap-select.show-menu-arrow .dropdown-toggle:after {
  content: "";
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  position: absolute;
  bottom: -4px;
  left: 10px;
  display: none;
}
.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {
  bottom: auto;
  top: -3px;
  border-top: 7px solid rgba(204, 204, 204, 0.2);
  border-bottom: 0;
}
.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {
  bottom: auto;
  top: -3px;
  border-top: 6px solid white;
  border-bottom: 0;
}
.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {
  right: 12px;
  left: auto;
}
.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {
  right: 13px;
  left: auto;
}
.bootstrap-select.show-menu-arrow.show > .dropdown-toggle:before, .bootstrap-select.show-menu-arrow.show > .dropdown-toggle:after {
  display: block;
}

.bs-searchbox,
.bs-actionsbox,
.bs-donebutton {
  padding: 4px 8px;
}

.bs-actionsbox {
  width: 100%;
  box-sizing: border-box;
}
.bs-actionsbox .btn-group button {
  width: 50%;
}

.bs-donebutton {
  float: left;
  width: 100%;
  box-sizing: border-box;
}
.bs-donebutton .btn-group button {
  width: 100%;
}

.bs-searchbox + .bs-actionsbox {
  padding: 0 8px 4px;
}
.bs-searchbox .form-control {
  margin-bottom: 0;
  width: 100%;
  float: none;
}

.bootstrap-select.show:before {
  border-bottom: 11px solid #F1EAE0;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 50px;
}

.bootstrap-select.show:after {
  border-bottom: 11px solid #FFFCF5;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 51px;
}

.bootstrap-select.dropup.show:before {
  border-top: 11px solid #DCD9D1;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-bottom: none;
  right: 15px;
  top: -11px;
}

.bootstrap-select.dropup.show:after {
  border-top: 11px solid #FFFFFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-bottom: none;
  right: 15px;
  top: -12px;
}

.bootstrap-select .dropdown-menu .dropdown-menu {
  transform: translate3d(0, 0, 0) !important;
}
.bootstrap-select .dropdown-menu .dropdown-menu:after, .bootstrap-select .dropdown-menu .dropdown-menu:before {
  display: none;
}
.bootstrap-select.dropup .dropdown-menu.show {
  transform: translate3d(0, -60px, 0) !important;
}

.btn-file {
  position: relative;
  overflow: hidden;
  vertical-align: middle;
}

.btn-file > input {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 23px;
  cursor: pointer;
  filter: alpha(opacity=0);
  opacity: 0;
  direction: ltr;
}

.fileinput {
  display: inline-block;
  margin-bottom: 9px;
}

.fileinput .form-control {
  display: inline-block;
  padding-top: 7px;
  padding-bottom: 5px;
  margin-bottom: 0;
  vertical-align: middle;
  cursor: text;
}

.fileinput .thumbnail {
  display: inline-block;
  margin-bottom: 10px;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  max-width: 250px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.fileinput .thumbnail.img-circle {
  border-radius: 50%;
  max-width: 100px;
}

.fileinput .thumbnail > img {
  max-height: 100%;
}

.fileinput .btn {
  vertical-align: middle;
}

.fileinput-exists .fileinput-new,
.fileinput-new .fileinput-exists {
  display: none;
}

.fileinput-inline .fileinput-controls {
  display: inline;
}

.fileinput-filename {
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
}

.form-control .fileinput-filename {
  vertical-align: bottom;
}

.fileinput.input-group {
  display: table;
}

.fileinput.input-group > * {
  position: relative;
  z-index: 2;
}

.fileinput.input-group > .btn-file {
  z-index: 1;
}

.fileinput-new.input-group .btn-file,
.fileinput-new .input-group .btn-file {
  border-radius: 0 4px 4px 0;
}

.fileinput-new.input-group .btn-file.btn-xs,
.fileinput-new .input-group .btn-file.btn-xs,
.fileinput-new.input-group .btn-file.btn-sm,
.fileinput-new .input-group .btn-file.btn-sm {
  border-radius: 0 3px 3px 0;
}

.fileinput-new.input-group .btn-file.btn-lg,
.fileinput-new .input-group .btn-file.btn-lg {
  border-radius: 0 6px 6px 0;
}

.form-group.has-warning .fileinput .fileinput-preview {
  color: #fbc658;
}

.form-group.has-warning .fileinput .thumbnail {
  border-color: #fbc658;
}

.form-group.has-error .fileinput .fileinput-preview {
  color: #ef8157;
}

.form-group.has-error .fileinput .thumbnail {
  border-color: #ef8157;
}

.form-group.has-success .fileinput .fileinput-preview {
  color: #6bd098;
}

.form-group.has-success .fileinput .thumbnail {
  border-color: #6bd098;
}

.input-group-addon:not(:first-child) {
  border-left: 0;
}

.thumbnail {
  border: 0 none;
  border-radius: 3px;
  padding: 0;
}

.bootstrap-tagsinput {
  background-color: transparent;
  display: inline-block;
  padding: 4px 6px;
  vertical-align: middle;
  border-radius: 4px;
  width: 100%;
  line-height: 22px;
  cursor: text;
}
.bootstrap-tagsinput input {
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0 6px;
  margin: 0;
  width: auto;
  max-width: inherit;
}
.bootstrap-tagsinput input:focus {
  border: none;
  box-shadow: none;
}
.bootstrap-tagsinput input::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.bootstrap-tagsinput input:-ms-input-placeholder {
  color: #999;
}
.bootstrap-tagsinput input::-webkit-input-placeholder {
  color: #999;
}
.bootstrap-tagsinput.form-control input::-moz-placeholder {
  color: #999;
}
.bootstrap-tagsinput.form-control input:-ms-input-placeholder {
  color: #999;
}
.bootstrap-tagsinput.form-control input::-webkit-input-placeholder {
  color: #999;
}
.bootstrap-tagsinput .badge {
  transition: all 170ms linear;
}
.bootstrap-tagsinput .badge {
  cursor: pointer;
  margin: 5px 3px 5px 0;
  position: relative;
  padding: 4px 8px 3px 0.8em;
  border-radius: 12px;
  color: #fff;
  font-size: 0.75em;
  font-weight: 500;
  display: inline-block;
  line-height: 1.5em;
  text-transform: uppercase;
}
.bootstrap-tagsinput .badge:hover {
  padding-right: 25px;
}
.bootstrap-tagsinput .badge:hover [data-role=remove] {
  opacity: 1;
  padding-right: 6px;
}
.bootstrap-tagsinput .badge [data-role=remove] {
  cursor: pointer;
  position: absolute;
  top: 3.5px;
  right: 0;
  opacity: 0;
}
.bootstrap-tagsinput .badge [data-role=remove]:after {
  content: "\\f00d";
  padding: 0px 4px;
  font-size: 18px;
  font: normal normal normal 10px/1 FontAwesome;
}
.bootstrap-tagsinput .badge [data-role=remove]:hover:active {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  opacity: 1;
}

.badge-success {
  background-color: #7ac29a;
}

/*
 * This combined file was created by the DataTables downloader builder:
 *   https://datatables.net/download
 *
 * To rebuild or modify this file with the latest versions of the included
 * software please visit:
 *   https://datatables.net/download/#bs4/dt-1.10.16/cr-1.4.1/fc-3.2.3/fh-3.1.3/r-2.2.0/rg-1.0.2/rr-1.2.3/sc-1.4.3/sl-1.2.3
 *
 * Included libraries:
 *   DataTables 1.10.16, ColReorder 1.4.1, FixedColumns 3.2.3, FixedHeader 3.1.3, Responsive 2.2.0, RowGroup 1.0.2, RowReorder 1.2.3, Scroller 1.4.3, Select 1.2.3
 */
table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;
  border-collapse: separate !important;
}

table.dataTable td,
table.dataTable th {
  box-sizing: content-box;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length select {
  width: 75px;
  display: inline-block;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: right;
}

div.dataTables_wrapper div.dataTables_filter label {
  font-weight: normal;
  white-space: nowrap;
  text-align: left;
}

div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0.5em;
  display: inline-block;
  width: auto;
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 8px;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_paginate {
  margin: 0;
  white-space: nowrap;
  text-align: right;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  margin: 2px 0;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_processing {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  margin-left: -100px;
  margin-top: -26px;
  text-align: center;
  padding: 1em 0;
}

table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting {
  padding-right: 30px;
}

table.dataTable thead > tr > th:active,
table.dataTable thead > tr > td:active {
  outline: none;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
  cursor: pointer;
  position: relative;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: block;
  font-family: "Glyphicons Halflings";
  opacity: 0.5;
}

table.dataTable thead .sorting:after {
  opacity: 0.2;
  content: "\\e150";
  /* sort */
}

table.dataTable thead .sorting_asc:after {
  content: "\\e155";
  /* sort-by-attributes */
}

table.dataTable thead .sorting_desc:after {
  content: "\\e156";
  /* sort-by-attributes-alt */
}

table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  color: #eee;
}

div.dataTables_scrollHead table.dataTable {
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table {
  border-top: none;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
  display: none;
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
  border-top: none;
}

div.dataTables_scrollFoot table {
  margin-top: 0 !important;
  border-top: none;
}

@media screen and (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_length,
  div.dataTables_wrapper div.dataTables_filter,
  div.dataTables_wrapper div.dataTables_info,
  div.dataTables_wrapper div.dataTables_paginate {
    text-align: center;
  }
}
table.dataTable.table-condensed > thead > tr > th {
  padding-right: 20px;
}

table.dataTable.table-condensed .sorting:after,
table.dataTable.table-condensed .sorting_asc:after,
table.dataTable.table-condensed .sorting_desc:after {
  top: 6px;
  right: 6px;
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
  border-left-width: 0;
}

table.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
  border-right-width: 0;
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
  border-bottom-width: 0;
}

div.dataTables_scrollHead table.table-bordered {
  border-bottom-width: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
  padding-left: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
  padding-right: 0;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  position: relative;
  display: inline-block;
  bottom: 0px;
  right: -7px;
  font-family: "FontAwesome";
  opacity: 0.8;
}
table.dataTable thead .disabled-sorting.sorting:after,
table.dataTable thead .disabled-sorting.sorting_asc:after,
table.dataTable thead .disabled-sorting.sorting_desc:after,
table.dataTable thead .disabled-sorting.sorting_asc_disabled:after,
table.dataTable thead .disabled-sorting.sorting_desc_disabled:after {
  display: none;
}
table.dataTable thead .sorting:after {
  opacity: 0.4;
  content: "\\f0dc";
}
table.dataTable thead .sorting_asc:after {
  content: "\\f0de";
  top: 3px;
}
table.dataTable thead .sorting_desc:after {
  content: "\\f0dd";
  top: -3px;
}
table.dataTable .table-hover > tbody > tr:hover {
  background-color: #fff4dc;
}
table.dataTable .table > thead > tr > th,
table.dataTable .table > tbody > tr > th,
table.dataTable .table > tfoot > tr > th,
table.dataTable .table > thead > tr > td,
table.dataTable .table > tbody > tr > td,
table.dataTable .table > tfoot > tr > td {
  padding: 8px !important;
  outline: 0;
}
table.dataTable .btn.btn-icon {
  margin: 0 3px;
  padding: 5px 8px;
}

.dataTables_paginate a {
  outline: 0;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty {
  cursor: default !important;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty:before {
  display: none !important;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child:before {
  top: 50%;
  margin-top: -9px;
  left: 4px;
  height: 18px;
  width: 18px;
  display: block;
  position: absolute;
  color: #518607;
  border: 0px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  font-family: "Courier New", Courier, monospace;
  line-height: 18px;
  content: "+";
  background-color: #FFF;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
  content: "-";
  color: #ED362C;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.child td:before {
  display: none;
}

table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child {
  padding-left: 27px;
}
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child:before,
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child:before {
  top: 5px;
  left: 4px;
  height: 14px;
  width: 14px;
  border-radius: 14px;
  line-height: 14px;
  text-indent: 3px;
}

table.dataTable.dtr-column > tbody > tr > td.control,
table.dataTable.dtr-column > tbody > tr > th.control {
  position: relative;
  cursor: pointer;
}
table.dataTable.dtr-column > tbody > tr > td.control:before,
table.dataTable.dtr-column > tbody > tr > th.control:before {
  top: 50%;
  left: 50%;
  height: 16px;
  width: 16px;
  margin-top: -10px;
  margin-left: -10px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  font-family: "Courier New", Courier, monospace;
  line-height: 14px;
  content: "+";
  background-color: #31b131;
}
table.dataTable.dtr-column > tbody > tr.parent td.control:before,
table.dataTable.dtr-column > tbody > tr.parent th.control:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable > tbody > tr.child {
  padding: 0.5em 1em;
}
table.dataTable > tbody > tr.child:hover {
  background: transparent !important;
}
table.dataTable > tbody > tr.child ul {
  display: inline-block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
table.dataTable > tbody > tr.child ul li {
  border-bottom: 1px solid #efefef;
  padding: 0.5em 0;
}
table.dataTable > tbody > tr.child ul li:first-child {
  padding-top: 0;
}
table.dataTable > tbody > tr.child ul li:last-child {
  border-bottom: none;
}
table.dataTable > tbody > tr.child span.dtr-title {
  display: inline-block;
  min-width: 75px;
  font-weight: bold;
}

div.dtr-modal {
  position: fixed;
  box-sizing: border-box;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  padding: 10em 1em;
}
div.dtr-modal div.dtr-modal-display {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50%;
  height: 50%;
  overflow: auto;
  margin: auto;
  z-index: 102;
  overflow: auto;
  background-color: #f5f5f7;
  border: 1px solid black;
  border-radius: 0.5em;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
}
div.dtr-modal div.dtr-modal-content {
  position: relative;
  padding: 1em;
}
div.dtr-modal div.dtr-modal-close {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border: 1px solid #eaeaea;
  background-color: #f9f9f9;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  z-index: 12;
}
div.dtr-modal div.dtr-modal-close:hover {
  background-color: #eaeaea;
}
div.dtr-modal div.dtr-modal-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(0, 0, 0, 0.6);
}

@media screen and (max-width: 767px) {
  div.dtr-modal div.dtr-modal-display {
    width: 95%;
  }
}
svg {
  touch-action: none;
}

.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #CDCDCD;
  border-radius: 3px;
  background: #292929;
  color: white;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
}

.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #292929;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin, .jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

/*!
 * FullCalendar v3.1.0 Stylesheet
 * Docs & License: http://fullcalendar.io/
 * (c) 2016 Adam Shaw
 */
.fc {
  direction: ltr;
  text-align: left;
}

.fc-rtl {
  text-align: right;
}

body .fc { /* extra precedence to overcome jqui */
  font-size: 1em;
}

/* Colors
--------------------------------------------------------------------------------------------------*/
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #ddd;
}

.fc-unthemed .fc-popover {
  background-color: #FFFFFF;
}

.fc-unthemed .fc-divider,
.fc-unthemed .fc-popover .fc-header {
  background: #E3E3E3;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  color: #666666;
}

.fc-unthemed .fc-today {
  background: #F5F5F5;
}

.fc-highlight { /* when user is selecting cells */
  background: #bce8f1;
  opacity: 0.3;
  filter: alpha(opacity=30); /* for IE */
}

.fc-bgevent { /* default look for background events */
  background: rgb(143, 223, 130);
  opacity: 0.3;
  filter: alpha(opacity=30); /* for IE */
}

.fc-nonbusiness { /* default look for non-business-hours areas */
  /* will inherit .fc-bgevent's styles */
  background: #d7d7d7;
}

/* Icons (inline elements with styled text that mock arrow icons)
--------------------------------------------------------------------------------------------------*/
.fc-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  line-height: 1em;
  font-size: 1em;
  text-align: center;
  overflow: hidden;
  font-family: "Courier New", Courier, monospace;
  /* don't allow browser text-selection */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

/*
Acceptable font-family overrides for individual icons:
	"Arial", sans-serif
	"Times New Roman", serif

NOTE: use percentage font sizes or else old IE chokes
*/
.fc-icon:after {
  position: relative;
  margin: 0 -1em; /* ensures character will be centered, regardless of width */
}

.fc-icon-left-single-arrow:after {
  content: "‹";
  font-weight: bold;
  font-size: 200%;
  top: -7%;
  left: 3%;
}

.fc-icon-right-single-arrow:after {
  content: "›";
  font-weight: bold;
  font-size: 200%;
  top: -7%;
  left: -3%;
}

.fc-icon-left-double-arrow:after {
  content: "«";
  font-size: 160%;
  top: -7%;
}

.fc-icon-right-double-arrow:after {
  content: "»";
  font-size: 160%;
  top: -7%;
}

.fc-icon-left-triangle:after {
  content: "◄";
  font-size: 125%;
  top: 3%;
  left: -2%;
}

.fc-icon-right-triangle:after {
  content: "►";
  font-size: 125%;
  top: 3%;
  left: 2%;
}

.fc-icon-down-triangle:after {
  content: "▼";
  font-size: 125%;
  top: 2%;
}

.fc-icon-x:after {
  content: "×";
  font-size: 200%;
  top: 6%;
}

/* Buttons (styled <button> tags, normalized to work cross-browser)
--------------------------------------------------------------------------------------------------*/
.fc button {
  border-radius: 20px;
  box-sizing: border-box;
  border-width: 2px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  padding: 0.5rem 0.7rem;
  background-color: #66615B;
  color: #FFFFFF;
  transition: all 150ms linear;
}
.fc button:hover, .fc button:focus, .fc button:active, .fc button.active, .fc button:active:focus, .fc button:active:hover, .fc button.active:focus, .fc button.active:hover, .show > .fc button.dropdown-toggle, .show > .fc button.dropdown-toggle:focus, .show > .fc button.dropdown-toggle:hover {
  background-color: #403D39 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.fc button:not([data-action]):hover {
  box-shadow: none;
}
.fc button.disabled, .fc button.disabled:hover, .fc button.disabled:focus, .fc button.disabled.focus, .fc button.disabled:active, .fc button.disabled.active, .fc button:disabled, .fc button:disabled:hover, .fc button:disabled:focus, .fc button:disabled.focus, .fc button:disabled:active, .fc button:disabled.active, .fc button[disabled], .fc button[disabled]:hover, .fc button[disabled]:focus, .fc button[disabled].focus, .fc button[disabled]:active, .fc button[disabled].active, fieldset[disabled] .fc button, fieldset[disabled] .fc button:hover, fieldset[disabled] .fc button:focus, fieldset[disabled] .fc button.focus, fieldset[disabled] .fc button:active, fieldset[disabled] .fc button.active {
  background-color: #66615B;
  border-color: #66615B;
}
.fc button.btn-simple {
  color: #66615B;
  border-color: #66615B;
}
.fc button.btn-simple:hover, .fc button.btn-simple:focus, .fc button.btn-simple:active {
  background-color: transparent;
  color: #403D39;
  border-color: #403D39;
  box-shadow: none;
}
.fc button.btn-link {
  color: #66615B;
}
.fc button.btn-link:hover, .fc button.btn-link:focus, .fc button.btn-link:active, .fc button.btn-link:active:focus {
  background-color: transparent;
  color: #403D39;
  text-decoration: none;
  box-shadow: none;
}
.fc button:hover, .fc button:focus {
  outline: 0 !important;
}
.fc button:active, .fc button.active, .open > .fc button.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.fc button.btn-icon {
  border-radius: 25px;
  padding: 6px 10px;
}
.fc button.btn-icon i {
  margin-right: 0px;
}

/* Firefox has an annoying inner border */
.fc button::-moz-focus-inner {
  margin: 0;
  padding: 0;
}

.fc-state-default { /* non-theme */
  border: 1px solid;
}

/* icons in buttons */
.fc button .fc-icon { /* non-theme */
  position: relative;
  top: -0.05em; /* seems to be a good adjustment across browsers */
  margin: 0 0.2em;
  vertical-align: middle;
}

/*
  button states
  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)
*/
.fc-state-hover,
.fc-state-active,
.fc-state-disabled {
  color: #2c2c2c;
  background-color: #e6e6e6;
}

.fc button[disabled],
.fc button[disabled]:focus,
.fc button[disabled]:hover {
  background-color: #E3E3E3;
  border-color: #E3E3E3;
  cursor: default;
  opacity: 0.65;
  filter: alpha(opacity=65);
  color: #66615b;
}

.fc-state-hover {
  background-color: #F5F5F5;
}

.fc .fc-state-active,
.fc .fc-state-active:focus,
.fc .fc-state-active:hover,
.fc .fc-state-active:active:focus,
.fc .fc-state-active:active:hover,
.fc .fc-state-active:active {
  background-color: #66615B;
  color: #FFFFFF;
}

/* Buttons Groups
--------------------------------------------------------------------------------------------------*/
.fc-button-group {
  display: inline-block;
}

/*
every button that is not first in a button group should scootch over one pixel and cover the
previous button's border...
*/
.fc .fc-button-group > * { /* extra precedence b/c buttons have margin set to zero */
  float: left;
  margin: 0 2px 0 0;
}

.fc .fc-button-group > :first-child { /* same */
  margin-left: 0;
}

/* Popover
--------------------------------------------------------------------------------------------------*/
.fc-popover {
  position: absolute;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
}

.fc-popover .fc-header { /* TODO: be more consistent with fc-head/fc-body */
  padding: 2px 4px;
}

.fc-popover .fc-header .fc-title {
  margin: 0 2px;
}

.fc-popover .fc-header .fc-close {
  cursor: pointer;
}

.fc-ltr .fc-popover .fc-header .fc-title,
.fc-rtl .fc-popover .fc-header .fc-close {
  float: left;
}

.fc-rtl .fc-popover .fc-header .fc-title,
.fc-ltr .fc-popover .fc-header .fc-close {
  float: right;
}

/* unthemed */
.fc-unthemed .fc-popover {
  border-width: 1px;
  border-style: solid;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  font-size: 0.9em;
  margin-top: 2px;
}

/* jqui themed */
.fc-popover > .ui-widget-header + .ui-widget-content {
  border-top: 0; /* where they meet, let the header have the border */
}

/* Misc Reusable Components
--------------------------------------------------------------------------------------------------*/
.fc-divider {
  border-style: solid;
  border-width: 1px;
}

hr.fc-divider {
  height: 0;
  margin: 0;
  padding: 0 0 2px; /* height is unreliable across browsers, so use padding */
  border-width: 1px 0;
}

.fc-clear {
  clear: both;
}

.fc-bg,
.fc-bgevent-skeleton,
.fc-highlight-skeleton,
.fc-helper-skeleton {
  /* these element should always cling to top-left/right corners */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-bg {
  bottom: 0; /* strech bg to bottom edge */
}

.fc-bg table {
  height: 100%; /* strech bg to bottom edge */
}

/* Tables
--------------------------------------------------------------------------------------------------*/
.fc table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em; /* normalize cross-browser */
}

.fc th {
  text-align: right;
  border-bottom-width: 1px;
  font-size: 1em;
  text-transform: uppercase;
  color: #9A9A9A;
  font-weight: 400;
  padding-bottom: 3px;
}

.fc td {
  border-style: solid;
  border-width: 1px;
  padding: 0;
  vertical-align: top;
}

.fc td.fc-today {
  border-style: double; /* overcome neighboring borders */
}

.fc .fc-widget-header {
  border: 0;
}

.fc .fc-head .fc-widget-header {
  margin-top: 15px;
}

/* Fake Table Rows
--------------------------------------------------------------------------------------------------*/
.fc .fc-row { /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */
  /* no visible border by default. but make available if need be (scrollbar width compensation) */
  border-style: solid;
  border-width: 0;
}

.fc-row table {
  /* don't put left/right border on anything within a fake row.
     the outer tbody will worry about this */
  border-left: 0 hidden transparent;
  border-right: 0 hidden transparent;
  /* no bottom borders on rows */
  border-bottom: 0 hidden transparent;
}

.fc-row:first-child table {
  border-top: 0 hidden transparent; /* no top border on first row */
}

/* Day Row (used within the header and the DayGrid)
--------------------------------------------------------------------------------------------------*/
.fc-row {
  position: relative;
}

.fc-row .fc-bg {
  z-index: 1;
}

/* highlighting cells & background event skeleton */
.fc-row .fc-bgevent-skeleton,
.fc-row .fc-highlight-skeleton {
  bottom: 0; /* stretch skeleton to bottom of row */
}

.fc-row .fc-bgevent-skeleton table,
.fc-row .fc-highlight-skeleton table {
  height: 100%; /* stretch skeleton to bottom of row */
}

.fc-row .fc-highlight-skeleton td,
.fc-row .fc-bgevent-skeleton td {
  border-color: transparent;
}

.fc-row .fc-bgevent-skeleton {
  z-index: 2;
}

.fc-row .fc-highlight-skeleton {
  z-index: 3;
}

/*
row content (which contains day/week numbers and events) as well as "helper" (which contains
temporary rendered events).
*/
.fc-row .fc-content-skeleton {
  position: relative;
  z-index: 4;
  padding-bottom: 2px; /* matches the space above the events */
}

.fc-row .fc-helper-skeleton {
  z-index: 5;
}

.fc-row .fc-content-skeleton td,
.fc-row .fc-helper-skeleton td {
  /* see-through to the background below */
  background: none; /* in case <td>s are globally styled */
  border-color: transparent;
  /* don't put a border between events and/or the day number */
  border-bottom: 0;
}

.fc-row .fc-content-skeleton tbody td,
.fc-row .fc-helper-skeleton tbody td {
  /* don't put a border between event cells */
  border-top: 0;
}

/* Scrolling Container
--------------------------------------------------------------------------------------------------*/
.fc-scroller { /* this class goes on elements for guaranteed vertical scrollbars */
  overflow-y: scroll;
  overflow-x: hidden;
}

.fc-scroller > * { /* we expect an immediate inner element */
  position: relative; /* re-scope all positions */
  width: 100%; /* hack to force re-sizing this inner element when scrollbars appear/disappear */
  overflow: hidden; /* don't let negative margins or absolute positioning create further scroll */
}

/* Global Event Styles
--------------------------------------------------------------------------------------------------*/
.fc-event {
  position: relative; /* for resize handle and other inner positioning */
  display: block; /* make the <a> tag block */
  font-size: 0.85em;
  line-height: 1.3;
  border-radius: 2px;
  background-color: rgba(81, 203, 206, 0.2); /* default BACKGROUND color */
  font-weight: normal; /* undo jqui's ui-widget-header bold */
}
.fc-event.event-azure {
  background-color: rgba(81, 188, 218, 0.2);
}
.fc-event.event-green {
  background-color: rgba(107, 208, 152, 0.2);
}
.fc-event.event-orange {
  background-color: rgba(251, 198, 88, 0.2);
}
.fc-event.event-red {
  background-color: rgba(239, 129, 87, 0.2);
}

/* overpower some of bootstrap's and jqui's styles on <a> tags */
.fc-event,
.fc-event:hover,
.ui-widget .fc-event {
  color: #2c2c2c; /* default TEXT color */
  text-decoration: none; /* if <a> has an href */
}

.fc-event[href],
.fc-event.fc-draggable {
  cursor: pointer; /* give events with links and draggable events a hand mouse pointer */
}

.fc-not-allowed,
.fc-not-allowed .fc-event { /* to override an event's custom cursor */
  cursor: not-allowed;
}

.fc-event .fc-bg { /* the generic .fc-bg already does position */
  z-index: 1;
  background: #FFFFFF;
  opacity: 0.25;
  filter: alpha(opacity=25); /* for IE */
}

.fc-event .fc-content {
  position: relative;
  z-index: 2;
}

.fc-event .fc-resizer {
  position: absolute;
  z-index: 3;
}

/* Horizontal Events
--------------------------------------------------------------------------------------------------*/
/* events that are continuing to/from another week. kill rounded corners and butt up against edge */
.fc-ltr .fc-h-event.fc-not-start,
.fc-rtl .fc-h-event.fc-not-end {
  margin-left: 0;
  border-left-width: 0;
  padding-left: 1px; /* replace the border with padding */
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc-ltr .fc-h-event.fc-not-end,
.fc-rtl .fc-h-event.fc-not-start {
  margin-right: 0;
  border-right-width: 0;
  padding-right: 1px; /* replace the border with padding */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

/* resizer */
.fc-h-event .fc-resizer { /* positioned it to overcome the event's borders */
  top: -1px;
  bottom: -1px;
  left: -1px;
  right: -1px;
  width: 5px;
}

/* left resizer  */
.fc-ltr .fc-h-event .fc-start-resizer,
.fc-ltr .fc-h-event .fc-start-resizer:before,
.fc-ltr .fc-h-event .fc-start-resizer:after,
.fc-rtl .fc-h-event .fc-end-resizer,
.fc-rtl .fc-h-event .fc-end-resizer:before,
.fc-rtl .fc-h-event .fc-end-resizer:after {
  right: auto; /* ignore the right and only use the left */
  cursor: w-resize;
}

/* right resizer */
.fc-ltr .fc-h-event .fc-end-resizer,
.fc-ltr .fc-h-event .fc-end-resizer:before,
.fc-ltr .fc-h-event .fc-end-resizer:after,
.fc-rtl .fc-h-event .fc-start-resizer,
.fc-rtl .fc-h-event .fc-start-resizer:before,
.fc-rtl .fc-h-event .fc-start-resizer:after {
  left: auto; /* ignore the left and only use the right */
  cursor: e-resize;
}

/* DayGrid events
----------------------------------------------------------------------------------------------------
We use the full "fc-day-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-day-grid-event {
  margin: 2px 5px 0; /* spacing between events and edges */
  padding: 1px 2px;
}

.fc-day-grid-event .fc-content { /* force events to be one-line tall */
  white-space: nowrap;
  overflow: hidden;
}

.fc-day-grid-event .fc-time {
  font-weight: bold;
}

.fc-day-grid-event .fc-resizer { /* enlarge the default hit area */
  left: -3px;
  right: -3px;
  width: 7px;
}

/* Event Limiting
--------------------------------------------------------------------------------------------------*/
/* "more" link that represents hidden events */
a.fc-more {
  margin: 1px 3px;
  font-size: 0.85em;
  cursor: pointer;
  text-decoration: none;
}

a.fc-more:hover {
  text-decoration: underline;
}

.fc-limited { /* rows and cells that are hidden because of a "more" link */
  display: none;
}

/* popover that appears when "more" link is clicked */
.fc-day-grid .fc-row {
  z-index: 1; /* make the "more" popover one higher than this */
}

.fc-more-popover {
  z-index: 2;
  width: 220px;
}

.fc-more-popover .fc-event-container {
  padding: 10px;
}

/* Toolbar
--------------------------------------------------------------------------------------------------*/
.fc-toolbar {
  text-align: center;
  margin-bottom: 1em;
}

.fc-toolbar .fc-left {
  float: left;
  min-width: 260px;
}

.fc-toolbar .fc-right {
  float: right;
}

.fc-toolbar .fc-center {
  display: inline-block;
}

/* the things within each left/right/center section */
.fc .fc-toolbar > * > * { /* extra precedence to override button border margins */
  float: left;
  margin-left: 0.75em;
}

/* the first thing within each left/center/right section */
.fc .fc-toolbar > * > :first-child { /* extra precedence to override button border margins */
  margin-left: 0;
}

/* title text */
.fc-toolbar h2 {
  margin: 0;
}

/* button layering (for border precedence) */
.fc-toolbar button {
  position: relative;
}

.fc-toolbar .fc-state-hover,
.fc-toolbar .ui-state-hover {
  z-index: 2;
}

.fc-toolbar .fc-state-down {
  z-index: 3;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active {
  z-index: 4;
}

.fc-toolbar button:focus {
  z-index: 5;
}

/* View Structure
--------------------------------------------------------------------------------------------------*/
/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */
/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */
.fc-view-container *,
.fc-view-container *:before,
.fc-view-container *:after {
  box-sizing: content-box;
}

.fc-view,
.fc-view > table { /* so dragged elements can be above the view's main element */
  position: relative;
  z-index: 1;
}

/* BasicView
--------------------------------------------------------------------------------------------------*/
/* day row structure */
.fc-basicWeek-view .fc-content-skeleton,
.fc-basicDay-view .fc-content-skeleton {
  /* we are sure there are no day numbers in these views, so... */
  padding-top: 1px; /* add a pixel to make sure there are 2px padding above events */
  padding-bottom: 1em; /* ensure a space at bottom of cell for user selecting/clicking */
}

.fc-basic-view .fc-body .fc-row {
  min-height: 4em; /* ensure that all rows are at least this tall */
}

/* a "rigid" row will take up a constant amount of height because content-skeleton is absolute */
.fc-row.fc-rigid {
  overflow: hidden;
}

.fc-row.fc-rigid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

/* week and day number styling */
.fc-basic-view .fc-week-number,
.fc-basic-view .fc-day-number {
  padding: 0 2px;
}

.fc-basic-view td.fc-week-number span,
.fc-basic-view td.fc-day-number {
  padding: 8px;
}

.fc-basic-view .fc-week-number {
  text-align: center;
}

.fc-basic-view .fc-week-number span {
  /* work around the way we do column resizing and ensure a minimum width */
  display: inline-block;
  min-width: 1.25em;
}

.fc-ltr .fc-basic-view .fc-day-number {
  text-align: right;
}

.fc-rtl .fc-basic-view .fc-day-number {
  text-align: left;
}

.fc-day-number.fc-other-month {
  opacity: 0.3;
  filter: alpha(opacity=30); /* for IE */
  /* opacity with small font can sometimes look too faded
     might want to set the 'color' property instead
     making day-numbers bold also fixes the problem */
}

/* AgendaView all-day area
--------------------------------------------------------------------------------------------------*/
.fc-agenda-view .fc-day-grid {
  position: relative;
  z-index: 2; /* so the "more.." popover will be over the time grid */
}

.fc-agenda-view .fc-day-grid .fc-row {
  min-height: 3em; /* all-day section will never get shorter than this */
}

.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {
  padding-top: 1px; /* add a pixel to make sure there are 2px padding above events */
  padding-bottom: 1em; /* give space underneath events for clicking/selecting days */
}

/* TimeGrid axis running down the side (for both the all-day area and the slot area)
--------------------------------------------------------------------------------------------------*/
.fc .fc-axis { /* .fc to overcome default cell styles */
  vertical-align: middle;
  padding: 0 4px;
  white-space: nowrap;
}

.fc-ltr .fc-axis {
  text-align: right;
}

.fc-rtl .fc-axis {
  text-align: left;
}

.ui-widget td.fc-axis {
  font-weight: normal; /* overcome jqui theme making it bold */
}

/* TimeGrid Structure
--------------------------------------------------------------------------------------------------*/
.fc-time-grid-container,
.fc-time-grid { /* so slats/bg/content/etc positions get scoped within here */
  position: relative;
  z-index: 1;
}

.fc-time-grid {
  min-height: 100%; /* so if height setting is 'auto', .fc-bg stretches to fill height */
}

.fc-time-grid table { /* don't put outer borders on slats/bg/content/etc */
  border: 0 hidden transparent;
}

.fc-time-grid > .fc-bg {
  z-index: 1;
}

.fc-time-grid .fc-slats,
.fc-time-grid > hr { /* the <hr> AgendaView injects when grid is shorter than scroller */
  position: relative;
  z-index: 2;
}

.fc-time-grid .fc-bgevent-skeleton,
.fc-time-grid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-time-grid .fc-bgevent-skeleton {
  z-index: 3;
}

.fc-time-grid .fc-highlight-skeleton {
  z-index: 4;
}

.fc-time-grid .fc-content-skeleton {
  z-index: 5;
}

.fc-time-grid .fc-helper-skeleton {
  z-index: 6;
}

/* TimeGrid Slats (lines that run horizontally)
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-slats td {
  height: 1.5em;
  border-bottom: 0; /* each cell is responsible for its top border */
}

.fc-time-grid .fc-slats .fc-minor td {
  border-top-style: dotted;
}

.fc-time-grid .fc-slats .ui-widget-content { /* for jqui theme */
  background: none; /* see through to fc-bg */
}

/* TimeGrid Highlighting Slots
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-highlight-container { /* a div within a cell within the fc-highlight-skeleton */
  position: relative; /* scopes the left/right of the fc-highlight to be in the column */
}

.fc-time-grid .fc-highlight {
  position: absolute;
  left: 0;
  right: 0;
  /* top and bottom will be in by JS */
}

/* TimeGrid Event Containment
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-event-container,
.fc-time-grid .fc-bgevent-container { /* a div within a cell within the fc-bgevent-skeleton */
  position: relative;
}

.fc-ltr .fc-time-grid .fc-event-container { /* space on the sides of events for LTR (default) */
  margin: 0 2.5% 0 2px;
}

.fc-rtl .fc-time-grid .fc-event-container { /* space on the sides of events for RTL */
  margin: 0 2px 0 2.5%;
}

.fc-time-grid .fc-event,
.fc-time-grid .fc-bgevent {
  position: absolute;
  z-index: 1; /* scope inner z-index's */
}

.fc-time-grid .fc-bgevent {
  /* background events always span full width */
  left: 0;
  right: 0;
}

/* Generic Vertical Event
--------------------------------------------------------------------------------------------------*/
.fc-v-event.fc-not-start { /* events that are continuing from another day */
  /* replace space made by the top border with padding */
  border-top-width: 0;
  padding-top: 1px;
  /* remove top rounded corners */
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.fc-v-event.fc-not-end {
  /* replace space made by the top border with padding */
  border-bottom-width: 0;
  padding-bottom: 1px;
  /* remove bottom rounded corners */
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

/* TimeGrid Event Styling
----------------------------------------------------------------------------------------------------
We use the full "fc-time-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-time-grid-event {
  overflow: hidden; /* don't let the bg flow over rounded corners */
}

.fc-time-grid-event .fc-time,
.fc-time-grid-event .fc-title {
  padding: 0 1px;
}

.fc-time-grid-event .fc-time {
  font-size: 0.85em;
  white-space: nowrap;
}

/* short mode, where time and title are on the same line */
.fc-time-grid-event.fc-short .fc-content {
  /* don't wrap to second line (now that contents will be inline) */
  white-space: nowrap;
}

.fc-time-grid-event.fc-short .fc-time,
.fc-time-grid-event.fc-short .fc-title {
  /* put the time and title on the same line */
  display: inline-block;
  vertical-align: top;
}

.fc-time-grid-event.fc-short .fc-time span {
  display: none; /* don't display the full time text... */
}

.fc-time-grid-event.fc-short .fc-time:before {
  content: attr(data-start); /* ...instead, display only the start time */
}

.fc-time-grid-event.fc-short .fc-time:after {
  content: " - "; /* seperate with a dash, wrapped in nbsp's */
}

.fc-time-grid-event.fc-short .fc-title {
  font-size: 0.85em; /* make the title text the same size as the time */
  padding: 0; /* undo padding from above */
}

/* resizer */
.fc-time-grid-event .fc-resizer {
  left: 0;
  right: 0;
  bottom: 0;
  height: 8px;
  overflow: hidden;
  line-height: 8px;
  font-size: 11px;
  font-family: monospace;
  text-align: center;
  cursor: s-resize;
}

.fc-time-grid-event .fc-resizer:after {
  content: "=";
}

.card-calendar .content {
  padding: 0 !important;
}
.card-calendar .fc-toolbar {
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
}
.card-calendar .fc td:first-child {
  border-left: 0;
}
.card-calendar .fc td:last-child {
  border-right: 0;
}
.card-calendar .fc-basic-view td:last-child.fc-week-number span,
.card-calendar .fc-basic-view td:last-child.fc-day-number {
  padding-right: 15px;
}
.card-calendar .fc .fc-day-header:last-child {
  padding-right: 15px;
}
.card-calendar .fc .fc-row:last-child td {
  border-bottom: 0;
}
.card-calendar .fc .fc-body .fc-widget-content {
  border-bottom: 0;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "nucleo-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
/*------------------------
	base class definition
-------------------------*/
.nc-icon {
  display: inline-block;
  font: normal normal normal 14px/1 "nucleo-icons";
  font-size: inherit;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*------------------------
  change icon size
-------------------------*/
.nc-icon.lg {
  font-size: 1.33333333em;
  vertical-align: -16%;
}

.nc-icon.x2 {
  font-size: 2em;
}

.nc-icon.x3 {
  font-size: 3em;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/
.nc-icon.square,
.nc-icon.circle {
  padding: 0.33333333em;
  vertical-align: -16%;
  background-color: #eee;
}

.nc-icon.circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.nc-icon-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.nc-icon-ul > li {
  position: relative;
}

.nc-icon-ul > li > .nc-icon {
  position: absolute;
  left: -1.57142857em;
  top: 0.14285714em;
  text-align: center;
}

.nc-icon-ul > li > .nc-icon.lg {
  top: 0;
  left: -1.35714286em;
}

.nc-icon-ul > li > .nc-icon.circle,
.nc-icon-ul > li > .nc-icon.square {
  top: -0.19047619em;
  left: -1.9047619em;
}

/*------------------------
  spinning icons
-------------------------*/
.nc-icon.spin {
  animation: nc-icon-spin 2s infinite linear;
}
@keyframes nc-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*------------------------
  rotated/flipped icons
-------------------------*/
.nc-icon.rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.nc-icon.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.nc-icon.rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.nc-icon.flip-y {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
  transform: scale(-1, 1);
}

.nc-icon.flip-x {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: scale(1, -1);
}

/*------------------------
	font icons
-------------------------*/
.nc-air-baloon::before {
  content: "\\ea01";
}

.nc-album-2::before {
  content: "\\ea02";
}

.nc-alert-circle-i::before {
  content: "\\ea04";
}

.nc-align-center::before {
  content: "\\ea03";
}

.nc-align-left-2::before {
  content: "\\ea05";
}

.nc-ambulance::before {
  content: "\\ea06";
}

.nc-app::before {
  content: "\\ea07";
}

.nc-atom::before {
  content: "\\ea08";
}

.nc-badge::before {
  content: "\\ea09";
}

.nc-bag-16::before {
  content: "\\ea0a";
}

.nc-bank::before {
  content: "\\ea0b";
}

.nc-basket::before {
  content: "\\ea0c";
}

.nc-bell-55::before {
  content: "\\ea0d";
}

.nc-bold::before {
  content: "\\ea0e";
}

.nc-book-bookmark::before {
  content: "\\ea0f";
}

.nc-bookmark-2::before {
  content: "\\ea10";
}

.nc-box-2::before {
  content: "\\ea11";
}

.nc-box::before {
  content: "\\ea12";
}

.nc-briefcase-24::before {
  content: "\\ea13";
}

.nc-bulb-63::before {
  content: "\\ea14";
}

.nc-bullet-list-67::before {
  content: "\\ea15";
}

.nc-bus-front-12::before {
  content: "\\ea16";
}

.nc-button-pause::before {
  content: "\\ea17";
}

.nc-button-play::before {
  content: "\\ea18";
}

.nc-button-power::before {
  content: "\\ea19";
}

.nc-calendar-60::before {
  content: "\\ea1a";
}

.nc-camera-compact::before {
  content: "\\ea1b";
}

.nc-caps-small::before {
  content: "\\ea1c";
}

.nc-cart-simple::before {
  content: "\\ea1d";
}

.nc-chart-bar-32::before {
  content: "\\ea1e";
}

.nc-chart-pie-36::before {
  content: "\\ea1f";
}

.nc-chat-33::before {
  content: "\\ea20";
}

.nc-check-2::before {
  content: "\\ea21";
}

.nc-circle-10::before {
  content: "\\ea22";
}

.nc-cloud-download-93::before {
  content: "\\ea23";
}

.nc-cloud-upload-94::before {
  content: "\\ea24";
}

.nc-compass-05::before {
  content: "\\ea25";
}

.nc-controller-modern::before {
  content: "\\ea26";
}

.nc-credit-card::before {
  content: "\\ea27";
}

.nc-delivery-fast::before {
  content: "\\ea28";
}

.nc-diamond::before {
  content: "\\ea29";
}

.nc-email-85::before {
  content: "\\ea2a";
}

.nc-favourite-28::before {
  content: "\\ea2b";
}

.nc-glasses-2::before {
  content: "\\ea2c";
}

.nc-globe-2::before {
  content: "\\ea2d";
}

.nc-globe::before {
  content: "\\ea2e";
}

.nc-hat-3::before {
  content: "\\ea2f";
}

.nc-headphones::before {
  content: "\\ea30";
}

.nc-html5::before {
  content: "\\ea31";
}

.nc-image::before {
  content: "\\ea32";
}

.nc-istanbul::before {
  content: "\\ea33";
}

.nc-key-25::before {
  content: "\\ea34";
}

.nc-laptop::before {
  content: "\\ea35";
}

.nc-layout-11::before {
  content: "\\ea36";
}

.nc-lock-circle-open::before {
  content: "\\ea37";
}

.nc-map-big::before {
  content: "\\ea38";
}

.nc-minimal-down::before {
  content: "\\ea39";
}

.nc-minimal-left::before {
  content: "\\ea3a";
}

.nc-minimal-right::before {
  content: "\\ea3b";
}

.nc-minimal-up::before {
  content: "\\ea3c";
}

.nc-mobile::before {
  content: "\\ea3d";
}

.nc-money-coins::before {
  content: "\\ea3e";
}

.nc-note-03::before {
  content: "\\ea3f";
}

.nc-palette::before {
  content: "\\ea40";
}

.nc-paper::before {
  content: "\\ea41";
}

.nc-pin-3::before {
  content: "\\ea42";
}

.nc-planet::before {
  content: "\\ea43";
}

.nc-refresh-69::before {
  content: "\\ea44";
}

.nc-ruler-pencil::before {
  content: "\\ea45";
}

.nc-satisfied::before {
  content: "\\ea46";
}

.nc-scissors::before {
  content: "\\ea47";
}

.nc-send::before {
  content: "\\ea48";
}

.nc-settings-gear-65::before {
  content: "\\ea49";
}

.nc-settings::before {
  content: "\\ea4a";
}

.nc-share-66::before {
  content: "\\ea4b";
}

.nc-shop::before {
  content: "\\ea4c";
}

.nc-simple-add::before {
  content: "\\ea4d";
}

.nc-simple-delete::before {
  content: "\\ea4e";
}

.nc-simple-remove::before {
  content: "\\ea4f";
}

.nc-single-02::before {
  content: "\\ea50";
}

.nc-single-copy-04::before {
  content: "\\ea51";
}

.nc-sound-wave::before {
  content: "\\ea52";
}

.nc-spaceship::before {
  content: "\\ea53";
}

.nc-sun-fog-29::before {
  content: "\\ea54";
}

.nc-support-17::before {
  content: "\\ea55";
}

.nc-tablet-2::before {
  content: "\\ea56";
}

.nc-tag-content::before {
  content: "\\ea57";
}

.nc-tap-01::before {
  content: "\\ea58";
}

.nc-tie-bow::before {
  content: "\\ea59";
}

.nc-tile-56::before {
  content: "\\ea5a";
}

.nc-time-alarm::before {
  content: "\\ea5b";
}

.nc-touch-id::before {
  content: "\\ea5c";
}

.nc-trophy::before {
  content: "\\ea5d";
}

.nc-tv-2::before {
  content: "\\ea5e";
}

.nc-umbrella-13::before {
  content: "\\ea5f";
}

.nc-user-run::before {
  content: "\\ea60";
}

.nc-vector::before {
  content: "\\ea61";
}

.nc-watch-time::before {
  content: "\\ea62";
}

.nc-world-2::before {
  content: "\\ea63";
}

.nc-zoom-split::before {
  content: "\\ea64";
}

/* all icon font classes list here */
.btn,
.navbar .navbar-nav > a.btn {
  border-width: 2px;
  font-weight: 600;
  font-size: 0.8571em;
  line-height: 1.35em;
  text-transform: uppercase;
  border: none;
  margin: 10px 1px;
  border-radius: 3px;
  padding: 11px 22px;
  cursor: pointer;
  background-color: #66615B;
  color: #FFFFFF;
  transition: all 150ms linear;
}
.btn:hover, .btn:focus, .btn:active, .btn.active, .btn:active:focus, .btn:active:hover, .btn.active:focus, .btn.active:hover, .show > .btn.dropdown-toggle, .show > .btn.dropdown-toggle:focus, .show > .btn.dropdown-toggle:hover,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.navbar .navbar-nav > a.btn:active:focus,
.navbar .navbar-nav > a.btn:active:hover,
.navbar .navbar-nav > a.btn.active:focus,
.navbar .navbar-nav > a.btn.active:hover,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:focus,
.show > .navbar .navbar-nav > a.btn.dropdown-toggle:hover {
  background-color: #403D39 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn:not([data-action]):hover,
.navbar .navbar-nav > a.btn:not([data-action]):hover {
  box-shadow: none;
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active,
.navbar .navbar-nav > a.btn.disabled,
.navbar .navbar-nav > a.btn.disabled:hover,
.navbar .navbar-nav > a.btn.disabled:focus,
.navbar .navbar-nav > a.btn.disabled.focus,
.navbar .navbar-nav > a.btn.disabled:active,
.navbar .navbar-nav > a.btn.disabled.active,
.navbar .navbar-nav > a.btn:disabled,
.navbar .navbar-nav > a.btn:disabled:hover,
.navbar .navbar-nav > a.btn:disabled:focus,
.navbar .navbar-nav > a.btn:disabled.focus,
.navbar .navbar-nav > a.btn:disabled:active,
.navbar .navbar-nav > a.btn:disabled.active,
.navbar .navbar-nav > a.btn[disabled],
.navbar .navbar-nav > a.btn[disabled]:hover,
.navbar .navbar-nav > a.btn[disabled]:focus,
.navbar .navbar-nav > a.btn[disabled].focus,
.navbar .navbar-nav > a.btn[disabled]:active,
.navbar .navbar-nav > a.btn[disabled].active,
fieldset[disabled] .navbar .navbar-nav > a.btn,
fieldset[disabled] .navbar .navbar-nav > a.btn:hover,
fieldset[disabled] .navbar .navbar-nav > a.btn:focus,
fieldset[disabled] .navbar .navbar-nav > a.btn.focus,
fieldset[disabled] .navbar .navbar-nav > a.btn:active,
fieldset[disabled] .navbar .navbar-nav > a.btn.active {
  background-color: #66615B;
  border-color: #66615B;
}
.btn.btn-simple,
.navbar .navbar-nav > a.btn.btn-simple {
  color: #66615B;
  border-color: #66615B;
}
.btn.btn-simple:hover, .btn.btn-simple:focus, .btn.btn-simple:active,
.navbar .navbar-nav > a.btn.btn-simple:hover,
.navbar .navbar-nav > a.btn.btn-simple:focus,
.navbar .navbar-nav > a.btn.btn-simple:active {
  background-color: transparent;
  color: #403D39;
  border-color: #403D39;
  box-shadow: none;
}
.btn.btn-link,
.navbar .navbar-nav > a.btn.btn-link {
  color: #66615B;
}
.btn.btn-link:hover, .btn.btn-link:focus, .btn.btn-link:active, .btn.btn-link:active:focus,
.navbar .navbar-nav > a.btn.btn-link:hover,
.navbar .navbar-nav > a.btn.btn-link:focus,
.navbar .navbar-nav > a.btn.btn-link:active,
.navbar .navbar-nav > a.btn.btn-link:active:focus {
  background-color: transparent;
  color: #403D39;
  text-decoration: none;
  box-shadow: none;
}
.btn:hover, .btn:focus,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.open > .navbar .navbar-nav > a.btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn .badge,
.navbar .navbar-nav > a.btn .badge {
  margin: 0;
}
.btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon {
  height: 2.375rem;
  min-width: 2.375rem;
  width: 2.375rem;
  padding: 0;
  font-size: 0.9375rem;
  overflow: hidden;
  position: relative;
  line-height: normal;
}
.btn.btn-icon.btn-simple,
.navbar .navbar-nav > a.btn.btn-icon.btn-simple {
  padding: 0;
}
.btn.btn-icon.btn-sm,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm {
  height: 1.875rem;
  min-width: 1.875rem;
  width: 1.875rem;
}
.btn.btn-icon.btn-sm .fa,
.btn.btn-icon.btn-sm .far,
.btn.btn-icon.btn-sm .fas,
.btn.btn-icon.btn-sm .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .nc-icon {
  font-size: 0.6875rem;
}
.btn.btn-icon.btn-lg,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg {
  height: 3.6rem;
  min-width: 3.6rem;
  width: 3.6rem;
}
.btn.btn-icon.btn-lg .fa,
.btn.btn-icon.btn-lg .far,
.btn.btn-icon.btn-lg .fas,
.btn.btn-icon.btn-lg .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .nc-icon {
  font-size: 1.325rem;
}
.btn.btn-icon:not(.btn-footer) .nc-icon, .btn.btn-icon:not(.btn-footer) .fa, .btn.btn-icon:not(.btn-footer) .far, .btn.btn-icon:not(.btn-footer) .fas,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .nc-icon,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fa,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .far,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-12px, -12px);
  line-height: 1.5626rem;
  width: 24px;
}
.btn.btn-icon.btn-neutral,
.navbar .navbar-nav > a.btn.btn-icon.btn-neutral {
  font-size: 20px;
}
.btn:not(.btn-icon) .nc-icon,
.navbar .navbar-nav > a.btn:not(.btn-icon) .nc-icon {
  position: relative;
  top: 1px;
}

.btn-primary {
  background-color: #51cbce;
  color: #FFFFFF;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .btn-primary:active:focus, .btn-primary:active:hover, .btn-primary.active:focus, .btn-primary.active:hover, .show > .btn-primary.dropdown-toggle, .show > .btn-primary.dropdown-toggle:focus, .show > .btn-primary.dropdown-toggle:hover {
  background-color: #34b5b8 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-primary:not([data-action]):hover {
  box-shadow: none;
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: #51cbce;
  border-color: #51cbce;
}
.btn-primary.btn-simple {
  color: #51cbce;
  border-color: #51cbce;
}
.btn-primary.btn-simple:hover, .btn-primary.btn-simple:focus, .btn-primary.btn-simple:active {
  background-color: transparent;
  color: #34b5b8;
  border-color: #34b5b8;
  box-shadow: none;
}
.btn-primary.btn-link {
  color: #51cbce;
}
.btn-primary.btn-link:hover, .btn-primary.btn-link:focus, .btn-primary.btn-link:active, .btn-primary.btn-link:active:focus {
  background-color: transparent;
  color: #34b5b8;
  text-decoration: none;
  box-shadow: none;
}

.btn-success {
  background-color: #6bd098;
  color: #FFFFFF;
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active, .btn-success:active:focus, .btn-success:active:hover, .btn-success.active:focus, .btn-success.active:hover, .show > .btn-success.dropdown-toggle, .show > .btn-success.dropdown-toggle:focus, .show > .btn-success.dropdown-toggle:hover {
  background-color: #44c47d !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-success:not([data-action]):hover {
  box-shadow: none;
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: #6bd098;
  border-color: #6bd098;
}
.btn-success.btn-simple {
  color: #6bd098;
  border-color: #6bd098;
}
.btn-success.btn-simple:hover, .btn-success.btn-simple:focus, .btn-success.btn-simple:active {
  background-color: transparent;
  color: #44c47d;
  border-color: #44c47d;
  box-shadow: none;
}
.btn-success.btn-link {
  color: #6bd098;
}
.btn-success.btn-link:hover, .btn-success.btn-link:focus, .btn-success.btn-link:active, .btn-success.btn-link:active:focus {
  background-color: transparent;
  color: #44c47d;
  text-decoration: none;
  box-shadow: none;
}

.btn-info {
  background-color: #51bcda;
  color: #FFFFFF;
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .btn-info:active:focus, .btn-info:active:hover, .btn-info.active:focus, .btn-info.active:hover, .show > .btn-info.dropdown-toggle, .show > .btn-info.dropdown-toggle:focus, .show > .btn-info.dropdown-toggle:hover {
  background-color: #2ba9cd !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-info:not([data-action]):hover {
  box-shadow: none;
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: #51bcda;
  border-color: #51bcda;
}
.btn-info.btn-simple {
  color: #51bcda;
  border-color: #51bcda;
}
.btn-info.btn-simple:hover, .btn-info.btn-simple:focus, .btn-info.btn-simple:active {
  background-color: transparent;
  color: #2ba9cd;
  border-color: #2ba9cd;
  box-shadow: none;
}
.btn-info.btn-link {
  color: #51bcda;
}
.btn-info.btn-link:hover, .btn-info.btn-link:focus, .btn-info.btn-link:active, .btn-info.btn-link:active:focus {
  background-color: transparent;
  color: #2ba9cd;
  text-decoration: none;
  box-shadow: none;
}

.btn-warning {
  background-color: #fbc658;
  color: #FFFFFF;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active, .btn-warning:active:focus, .btn-warning:active:hover, .btn-warning.active:focus, .btn-warning.active:hover, .show > .btn-warning.dropdown-toggle, .show > .btn-warning.dropdown-toggle:focus, .show > .btn-warning.dropdown-toggle:hover {
  background-color: #fab526 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-warning:not([data-action]):hover {
  box-shadow: none;
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: #fbc658;
  border-color: #fbc658;
}
.btn-warning.btn-simple {
  color: #fbc658;
  border-color: #fbc658;
}
.btn-warning.btn-simple:hover, .btn-warning.btn-simple:focus, .btn-warning.btn-simple:active {
  background-color: transparent;
  color: #fab526;
  border-color: #fab526;
  box-shadow: none;
}
.btn-warning.btn-link {
  color: #fbc658;
}
.btn-warning.btn-link:hover, .btn-warning.btn-link:focus, .btn-warning.btn-link:active, .btn-warning.btn-link:active:focus {
  background-color: transparent;
  color: #fab526;
  text-decoration: none;
  box-shadow: none;
}

.btn-danger {
  background-color: #ef8157;
  color: #FFFFFF;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active, .btn-danger:active:focus, .btn-danger:active:hover, .btn-danger.active:focus, .btn-danger.active:hover, .show > .btn-danger.dropdown-toggle, .show > .btn-danger.dropdown-toggle:focus, .show > .btn-danger.dropdown-toggle:hover {
  background-color: #eb6532 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-danger:not([data-action]):hover {
  box-shadow: none;
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: #ef8157;
  border-color: #ef8157;
}
.btn-danger.btn-simple {
  color: #ef8157;
  border-color: #ef8157;
}
.btn-danger.btn-simple:hover, .btn-danger.btn-simple:focus, .btn-danger.btn-simple:active {
  background-color: transparent;
  color: #eb6532;
  border-color: #eb6532;
  box-shadow: none;
}
.btn-danger.btn-link {
  color: #ef8157;
}
.btn-danger.btn-link:hover, .btn-danger.btn-link:focus, .btn-danger.btn-link:active, .btn-danger.btn-link:active:focus {
  background-color: transparent;
  color: #eb6532;
  text-decoration: none;
  box-shadow: none;
}

.btn-outline-default {
  background: transparent;
  border: 2px solid #66615B !important;
  color: #66615B;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-default:hover, .btn-outline-default:focus, .btn-outline-default:active, .btn-outline-default:focus:active, .btn-outline-default.active, .open > .btn-outline-default.dropdown-toggle {
  background-color: #66615B !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #66615B !important;
}
.btn-outline-default:hover .caret, .btn-outline-default:focus .caret, .btn-outline-default:active .caret, .btn-outline-default:focus:active .caret, .btn-outline-default.active .caret, .open > .btn-outline-default.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-default .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-default.disabled, .btn-outline-default.disabled:hover, .btn-outline-default.disabled:focus, .btn-outline-default.disabled.focus, .btn-outline-default.disabled:active, .btn-outline-default.disabled.active, .btn-outline-default:disabled, .btn-outline-default:disabled:hover, .btn-outline-default:disabled:focus, .btn-outline-default:disabled.focus, .btn-outline-default:disabled:active, .btn-outline-default:disabled.active, .btn-outline-default[disabled], .btn-outline-default[disabled]:hover, .btn-outline-default[disabled]:focus, .btn-outline-default[disabled].focus, .btn-outline-default[disabled]:active, .btn-outline-default[disabled].active, fieldset[disabled] .btn-outline-default, fieldset[disabled] .btn-outline-default:hover, fieldset[disabled] .btn-outline-default:focus, fieldset[disabled] .btn-outline-default.focus, fieldset[disabled] .btn-outline-default:active, fieldset[disabled] .btn-outline-default.active {
  background-color: transparent !important;
  border-color: #66615B !important;
}

.btn-outline-primary {
  background: transparent;
  border: 2px solid #51cbce !important;
  color: #51cbce;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:active, .btn-outline-primary:focus:active, .btn-outline-primary.active, .open > .btn-outline-primary.dropdown-toggle {
  background-color: #51cbce !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #51cbce !important;
}
.btn-outline-primary:hover .caret, .btn-outline-primary:focus .caret, .btn-outline-primary:active .caret, .btn-outline-primary:focus:active .caret, .btn-outline-primary.active .caret, .open > .btn-outline-primary.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-primary .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-primary.disabled, .btn-outline-primary.disabled:hover, .btn-outline-primary.disabled:focus, .btn-outline-primary.disabled.focus, .btn-outline-primary.disabled:active, .btn-outline-primary.disabled.active, .btn-outline-primary:disabled, .btn-outline-primary:disabled:hover, .btn-outline-primary:disabled:focus, .btn-outline-primary:disabled.focus, .btn-outline-primary:disabled:active, .btn-outline-primary:disabled.active, .btn-outline-primary[disabled], .btn-outline-primary[disabled]:hover, .btn-outline-primary[disabled]:focus, .btn-outline-primary[disabled].focus, .btn-outline-primary[disabled]:active, .btn-outline-primary[disabled].active, fieldset[disabled] .btn-outline-primary, fieldset[disabled] .btn-outline-primary:hover, fieldset[disabled] .btn-outline-primary:focus, fieldset[disabled] .btn-outline-primary.focus, fieldset[disabled] .btn-outline-primary:active, fieldset[disabled] .btn-outline-primary.active {
  background-color: transparent !important;
  border-color: #51cbce !important;
}

.btn-outline-success {
  background: transparent;
  border: 2px solid #6bd098 !important;
  color: #6bd098;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success:active, .btn-outline-success:focus:active, .btn-outline-success.active, .open > .btn-outline-success.dropdown-toggle {
  background-color: #6bd098 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #6bd098 !important;
}
.btn-outline-success:hover .caret, .btn-outline-success:focus .caret, .btn-outline-success:active .caret, .btn-outline-success:focus:active .caret, .btn-outline-success.active .caret, .open > .btn-outline-success.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-success .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-success.disabled, .btn-outline-success.disabled:hover, .btn-outline-success.disabled:focus, .btn-outline-success.disabled.focus, .btn-outline-success.disabled:active, .btn-outline-success.disabled.active, .btn-outline-success:disabled, .btn-outline-success:disabled:hover, .btn-outline-success:disabled:focus, .btn-outline-success:disabled.focus, .btn-outline-success:disabled:active, .btn-outline-success:disabled.active, .btn-outline-success[disabled], .btn-outline-success[disabled]:hover, .btn-outline-success[disabled]:focus, .btn-outline-success[disabled].focus, .btn-outline-success[disabled]:active, .btn-outline-success[disabled].active, fieldset[disabled] .btn-outline-success, fieldset[disabled] .btn-outline-success:hover, fieldset[disabled] .btn-outline-success:focus, fieldset[disabled] .btn-outline-success.focus, fieldset[disabled] .btn-outline-success:active, fieldset[disabled] .btn-outline-success.active {
  background-color: transparent !important;
  border-color: #6bd098 !important;
}

.btn-outline-info {
  background: transparent;
  border: 2px solid #51bcda !important;
  color: #51bcda;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info:active, .btn-outline-info:focus:active, .btn-outline-info.active, .open > .btn-outline-info.dropdown-toggle {
  background-color: #51bcda !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #51bcda !important;
}
.btn-outline-info:hover .caret, .btn-outline-info:focus .caret, .btn-outline-info:active .caret, .btn-outline-info:focus:active .caret, .btn-outline-info.active .caret, .open > .btn-outline-info.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-info .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-info.disabled, .btn-outline-info.disabled:hover, .btn-outline-info.disabled:focus, .btn-outline-info.disabled.focus, .btn-outline-info.disabled:active, .btn-outline-info.disabled.active, .btn-outline-info:disabled, .btn-outline-info:disabled:hover, .btn-outline-info:disabled:focus, .btn-outline-info:disabled.focus, .btn-outline-info:disabled:active, .btn-outline-info:disabled.active, .btn-outline-info[disabled], .btn-outline-info[disabled]:hover, .btn-outline-info[disabled]:focus, .btn-outline-info[disabled].focus, .btn-outline-info[disabled]:active, .btn-outline-info[disabled].active, fieldset[disabled] .btn-outline-info, fieldset[disabled] .btn-outline-info:hover, fieldset[disabled] .btn-outline-info:focus, fieldset[disabled] .btn-outline-info.focus, fieldset[disabled] .btn-outline-info:active, fieldset[disabled] .btn-outline-info.active {
  background-color: transparent !important;
  border-color: #51bcda !important;
}

.btn-outline-warning {
  background: transparent;
  border: 2px solid #fbc658 !important;
  color: #fbc658;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning:active, .btn-outline-warning:focus:active, .btn-outline-warning.active, .open > .btn-outline-warning.dropdown-toggle {
  background-color: #fbc658 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #fbc658 !important;
}
.btn-outline-warning:hover .caret, .btn-outline-warning:focus .caret, .btn-outline-warning:active .caret, .btn-outline-warning:focus:active .caret, .btn-outline-warning.active .caret, .open > .btn-outline-warning.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-warning .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-warning.disabled, .btn-outline-warning.disabled:hover, .btn-outline-warning.disabled:focus, .btn-outline-warning.disabled.focus, .btn-outline-warning.disabled:active, .btn-outline-warning.disabled.active, .btn-outline-warning:disabled, .btn-outline-warning:disabled:hover, .btn-outline-warning:disabled:focus, .btn-outline-warning:disabled.focus, .btn-outline-warning:disabled:active, .btn-outline-warning:disabled.active, .btn-outline-warning[disabled], .btn-outline-warning[disabled]:hover, .btn-outline-warning[disabled]:focus, .btn-outline-warning[disabled].focus, .btn-outline-warning[disabled]:active, .btn-outline-warning[disabled].active, fieldset[disabled] .btn-outline-warning, fieldset[disabled] .btn-outline-warning:hover, fieldset[disabled] .btn-outline-warning:focus, fieldset[disabled] .btn-outline-warning.focus, fieldset[disabled] .btn-outline-warning:active, fieldset[disabled] .btn-outline-warning.active {
  background-color: transparent !important;
  border-color: #fbc658 !important;
}

.btn-outline-danger {
  background: transparent;
  border: 2px solid #ef8157 !important;
  color: #ef8157;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger:active, .btn-outline-danger:focus:active, .btn-outline-danger.active, .open > .btn-outline-danger.dropdown-toggle {
  background-color: #ef8157 !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #ef8157 !important;
}
.btn-outline-danger:hover .caret, .btn-outline-danger:focus .caret, .btn-outline-danger:active .caret, .btn-outline-danger:focus:active .caret, .btn-outline-danger.active .caret, .open > .btn-outline-danger.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-danger .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-danger.disabled, .btn-outline-danger.disabled:hover, .btn-outline-danger.disabled:focus, .btn-outline-danger.disabled.focus, .btn-outline-danger.disabled:active, .btn-outline-danger.disabled.active, .btn-outline-danger:disabled, .btn-outline-danger:disabled:hover, .btn-outline-danger:disabled:focus, .btn-outline-danger:disabled.focus, .btn-outline-danger:disabled:active, .btn-outline-danger:disabled.active, .btn-outline-danger[disabled], .btn-outline-danger[disabled]:hover, .btn-outline-danger[disabled]:focus, .btn-outline-danger[disabled].focus, .btn-outline-danger[disabled]:active, .btn-outline-danger[disabled].active, fieldset[disabled] .btn-outline-danger, fieldset[disabled] .btn-outline-danger:hover, fieldset[disabled] .btn-outline-danger:focus, fieldset[disabled] .btn-outline-danger.focus, fieldset[disabled] .btn-outline-danger:active, fieldset[disabled] .btn-outline-danger.active {
  background-color: transparent !important;
  border-color: #ef8157 !important;
}

.btn-outline-neutral {
  background: transparent;
  border: 2px solid #FFFFFF !important;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-neutral:hover, .btn-outline-neutral:focus, .btn-outline-neutral:active, .btn-outline-neutral:focus:active, .btn-outline-neutral.active, .open > .btn-outline-neutral.dropdown-toggle {
  background-color: #FFFFFF !important;
  color: rgba(255, 255, 255, 0.8) !important;
  border-color: #FFFFFF !important;
}
.btn-outline-neutral:hover .caret, .btn-outline-neutral:focus .caret, .btn-outline-neutral:active .caret, .btn-outline-neutral:focus:active .caret, .btn-outline-neutral.active .caret, .open > .btn-outline-neutral.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8) !important;
}
.btn-outline-neutral .caret {
  border-top-color: #FFFFFF !important;
}
.btn-outline-neutral.disabled, .btn-outline-neutral.disabled:hover, .btn-outline-neutral.disabled:focus, .btn-outline-neutral.disabled.focus, .btn-outline-neutral.disabled:active, .btn-outline-neutral.disabled.active, .btn-outline-neutral:disabled, .btn-outline-neutral:disabled:hover, .btn-outline-neutral:disabled:focus, .btn-outline-neutral:disabled.focus, .btn-outline-neutral:disabled:active, .btn-outline-neutral:disabled.active, .btn-outline-neutral[disabled], .btn-outline-neutral[disabled]:hover, .btn-outline-neutral[disabled]:focus, .btn-outline-neutral[disabled].focus, .btn-outline-neutral[disabled]:active, .btn-outline-neutral[disabled].active, fieldset[disabled] .btn-outline-neutral, fieldset[disabled] .btn-outline-neutral:hover, fieldset[disabled] .btn-outline-neutral:focus, fieldset[disabled] .btn-outline-neutral.focus, fieldset[disabled] .btn-outline-neutral:active, fieldset[disabled] .btn-outline-neutral.active {
  background-color: transparent !important;
  border-color: #FFFFFF !important;
}
.btn-outline-neutral:hover, .btn-outline-neutral:focus {
  color: #403D39;
  background-color: #FFFFFF;
}

.btn-neutral {
  background-color: #FFFFFF;
  color: #51cbce;
  color: #66615B;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active, .btn-neutral.active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #FFFFFF !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.btn-neutral:not([data-action]):hover {
  box-shadow: none;
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.btn-danger {
  color: #ef8157;
}
.btn-neutral.btn-danger:hover, .btn-neutral.btn-danger:focus, .btn-neutral.btn-danger:active, .btn-neutral.btn-danger:active:focus {
  color: #eb6532 !important;
}
.btn-neutral.btn-info {
  color: #51bcda !important;
}
.btn-neutral.btn-info:hover, .btn-neutral.btn-info:focus, .btn-neutral.btn-info:active, .btn-neutral.btn-info:active:focus {
  color: #2ba9cd !important;
}
.btn-neutral.btn-warning {
  color: #fbc658 !important;
}
.btn-neutral.btn-warning:hover, .btn-neutral.btn-warning:focus, .btn-neutral.btn-warning:active, .btn-neutral.btn-warning:active:focus {
  color: #fab526 !important;
}
.btn-neutral.btn-success {
  color: #6bd098 !important;
}
.btn-neutral.btn-success:hover, .btn-neutral.btn-success:focus, .btn-neutral.btn-success:active, .btn-neutral.btn-success:active:focus {
  color: #44c47d !important;
}
.btn-neutral.btn-default {
  color: #66615B !important;
}
.btn-neutral.btn-default:hover, .btn-neutral.btn-default:focus, .btn-neutral.btn-default:active, .btn-neutral.btn-default:active:focus {
  color: #403D39 !important;
}
.btn-neutral.active, .btn-neutral:active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #FFFFFF !important;
  color: #34b5b8 !important;
  box-shadow: none !important;
}
.btn-neutral:hover, .btn-neutral:focus {
  color: #34b5b8 !important;
}
.btn-neutral:hover:not(.nav-link), .btn-neutral:focus:not(.nav-link) {
  box-shadow: none;
}
.btn-neutral.btn-simple {
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.btn-simple:hover, .btn-neutral.btn-simple:focus, .btn-neutral.btn-simple:active {
  background-color: transparent;
  color: #FFFFFF;
  border-color: #FFFFFF;
  box-shadow: none;
}
.btn-neutral.btn-link {
  color: #FFFFFF;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:active, .btn-neutral.btn-link:active:focus {
  background-color: transparent;
  color: #FFFFFF;
  text-decoration: none;
  box-shadow: none;
}
.btn-neutral:hover, .btn-neutral:focus {
  color: #403D39;
}
.btn-neutral.btn-border:hover, .btn-neutral.btn-border:focus {
  color: #66615B;
}
.btn-neutral.btn-border:active, .btn-neutral.btn-border.active, .open > .btn-neutral.btn-border.dropdown-toggle {
  background-color: #FFFFFF;
  color: #66615B;
}
.btn-neutral.btn-link:active, .btn-neutral.btn-link.active {
  background-color: transparent;
}

.btn:disabled, .btn[disabled], .btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
}

.btn-simple {
  border: 1px solid;
  border-color: #66615B;
  padding: 10px 22px;
  background-color: transparent;
}

.btn-simple.disabled, .btn-simple.disabled:hover, .btn-simple.disabled:focus, .btn-simple.disabled.focus, .btn-simple.disabled:active, .btn-simple.disabled.active, .btn-simple:disabled, .btn-simple:disabled:hover, .btn-simple:disabled:focus, .btn-simple:disabled.focus, .btn-simple:disabled:active, .btn-simple:disabled.active, .btn-simple[disabled], .btn-simple[disabled]:hover, .btn-simple[disabled]:focus, .btn-simple[disabled].focus, .btn-simple[disabled]:active, .btn-simple[disabled].active, fieldset[disabled] .btn-simple, fieldset[disabled] .btn-simple:hover, fieldset[disabled] .btn-simple:focus, fieldset[disabled] .btn-simple.focus, fieldset[disabled] .btn-simple:active, fieldset[disabled] .btn-simple.active,
.btn-link.disabled,
.btn-link.disabled:hover,
.btn-link.disabled:focus,
.btn-link.disabled.focus,
.btn-link.disabled:active,
.btn-link.disabled.active,
.btn-link:disabled,
.btn-link:disabled:hover,
.btn-link:disabled:focus,
.btn-link:disabled.focus,
.btn-link:disabled:active,
.btn-link:disabled.active,
.btn-link[disabled],
.btn-link[disabled]:hover,
.btn-link[disabled]:focus,
.btn-link[disabled].focus,
.btn-link[disabled]:active,
.btn-link[disabled].active,
fieldset[disabled] .btn-link,
fieldset[disabled] .btn-link:hover,
fieldset[disabled] .btn-link:focus,
fieldset[disabled] .btn-link.focus,
fieldset[disabled] .btn-link:active,
fieldset[disabled] .btn-link.active {
  background-color: transparent;
}

.btn-link {
  border: 0;
  padding: 0.5rem 0.7rem;
  background-color: transparent;
}

.btn-lg {
  font-size: 1rem;
  border-radius: 6px;
  padding: 15px 48px;
}
.btn-lg.btn-simple {
  padding: 14px 47px;
}

.btn-sm {
  font-size: 0.8571em;
  border-radius: 3px;
  padding: 5px 15px;
}
.btn-sm.btn-simple {
  padding: 4px 14px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-group .btn + .btn {
  margin-left: -3px;
}
.btn-group .btn:focus {
  background-color: #51bcda !important;
}

.btn-round {
  border-width: 1px;
  border-radius: 30px;
  padding-right: 23px;
  padding-left: 23px;
}
.btn-round.btn-simple {
  padding: 10px 22px;
}

.no-caret.dropdown-toggle::after {
  display: none;
}

button[type=button] {
  background: transparent;
  border: 0;
}

.btn.btn-facebook {
  background-color: #3b5998;
  color: #FFFFFF;
}
.btn.btn-facebook:focus, .btn.btn-facebook:active, .btn.btn-facebook:hover {
  background-color: #344e86 !important;
  color: #FFFFFF !important;
}
.btn.btn-facebook.btn-simple {
  color: #3b5998;
  background-color: transparent;
  box-shadow: none;
  border-color: #3b5998;
}
.btn.btn-facebook.btn-simple:hover, .btn.btn-facebook.btn-simple:focus, .btn.btn-facebook.btn-simple:active {
  color: #344e86;
  border-color: #344e86;
}
.btn.btn-facebook.btn-neutral {
  color: #3b5998;
  background-color: #FFFFFF;
}
.btn.btn-facebook.btn-neutral:hover, .btn.btn-facebook.btn-neutral:focus, .btn.btn-facebook.btn-neutral:active {
  color: #344e86 !important;
}
.btn.btn-twitter {
  background-color: #55acee;
  color: #FFFFFF;
}
.btn.btn-twitter:focus, .btn.btn-twitter:active, .btn.btn-twitter:hover {
  background-color: #3ea1ec !important;
  color: #FFFFFF !important;
}
.btn.btn-twitter.btn-simple {
  color: #55acee;
  background-color: transparent;
  box-shadow: none;
  border-color: #55acee;
}
.btn.btn-twitter.btn-simple:hover, .btn.btn-twitter.btn-simple:focus, .btn.btn-twitter.btn-simple:active {
  color: #3ea1ec;
  border-color: #3ea1ec;
}
.btn.btn-twitter.btn-neutral {
  color: #55acee;
  background-color: #FFFFFF;
}
.btn.btn-twitter.btn-neutral:hover, .btn.btn-twitter.btn-neutral:focus, .btn.btn-twitter.btn-neutral:active {
  color: #3ea1ec !important;
}
.btn.btn-pinterest {
  background-color: #cc2127;
  color: #FFFFFF;
}
.btn.btn-pinterest:focus, .btn.btn-pinterest:active, .btn.btn-pinterest:hover {
  background-color: #dd2e34 !important;
  color: #FFFFFF !important;
}
.btn.btn-pinterest.btn-simple {
  color: #cc2127;
  background-color: transparent;
  box-shadow: none;
  border-color: #cc2127;
}
.btn.btn-pinterest.btn-simple:hover, .btn.btn-pinterest.btn-simple:focus, .btn.btn-pinterest.btn-simple:active {
  color: #dd2e34;
  border-color: #dd2e34;
}
.btn.btn-pinterest.btn-neutral {
  color: #cc2127;
  background-color: #FFFFFF;
}
.btn.btn-pinterest.btn-neutral:hover, .btn.btn-pinterest.btn-neutral:focus, .btn.btn-pinterest.btn-neutral:active {
  color: #dd2e34 !important;
}
.btn.btn-google {
  background-color: #dd4b39;
  color: #FFFFFF;
}
.btn.btn-google:focus, .btn.btn-google:active, .btn.btn-google:hover {
  background-color: #d73925 !important;
  color: #FFFFFF !important;
}
.btn.btn-google.btn-simple {
  color: #dd4b39;
  background-color: transparent;
  box-shadow: none;
  border-color: #dd4b39;
}
.btn.btn-google.btn-simple:hover, .btn.btn-google.btn-simple:focus, .btn.btn-google.btn-simple:active {
  color: #d73925;
  border-color: #d73925;
}
.btn.btn-google.btn-neutral {
  color: #dd4b39;
  background-color: #FFFFFF;
}
.btn.btn-google.btn-neutral:hover, .btn.btn-google.btn-neutral:focus, .btn.btn-google.btn-neutral:active {
  color: #d73925 !important;
}
.btn.btn-linkedin {
  background-color: #0077B5;
  color: #FFFFFF;
}
.btn.btn-linkedin:focus, .btn.btn-linkedin:active, .btn.btn-linkedin:hover {
  background-color: #00669c !important;
  color: #FFFFFF !important;
}
.btn.btn-linkedin.btn-simple {
  color: #0077B5;
  background-color: transparent;
  box-shadow: none;
  border-color: #0077B5;
}
.btn.btn-linkedin.btn-simple:hover, .btn.btn-linkedin.btn-simple:focus, .btn.btn-linkedin.btn-simple:active {
  color: #00669c;
  border-color: #00669c;
}
.btn.btn-linkedin.btn-neutral {
  color: #0077B5;
  background-color: #FFFFFF;
}
.btn.btn-linkedin.btn-neutral:hover, .btn.btn-linkedin.btn-neutral:focus, .btn.btn-linkedin.btn-neutral:active {
  color: #00669c !important;
}
.btn.btn-dribbble {
  background-color: #ea4c89;
  color: #FFFFFF;
}
.btn.btn-dribbble:focus, .btn.btn-dribbble:active, .btn.btn-dribbble:hover {
  background-color: #ed679b !important;
  color: #FFFFFF !important;
}
.btn.btn-dribbble.btn-simple {
  color: #ea4c89;
  background-color: transparent;
  box-shadow: none;
  border-color: #ea4c89;
}
.btn.btn-dribbble.btn-simple:hover, .btn.btn-dribbble.btn-simple:focus, .btn.btn-dribbble.btn-simple:active {
  color: #ed679b;
  border-color: #ed679b;
}
.btn.btn-dribbble.btn-neutral {
  color: #ea4c89;
  background-color: #FFFFFF;
}
.btn.btn-dribbble.btn-neutral:hover, .btn.btn-dribbble.btn-neutral:focus, .btn.btn-dribbble.btn-neutral:active {
  color: #ed679b !important;
}
.btn.btn-github {
  background-color: #333333;
  color: #FFFFFF;
}
.btn.btn-github:focus, .btn.btn-github:active, .btn.btn-github:hover {
  background-color: #424242 !important;
  color: #FFFFFF !important;
}
.btn.btn-github.btn-simple {
  color: #333333;
  background-color: transparent;
  box-shadow: none;
  border-color: #333333;
}
.btn.btn-github.btn-simple:hover, .btn.btn-github.btn-simple:focus, .btn.btn-github.btn-simple:active {
  color: #424242;
  border-color: #424242;
}
.btn.btn-github.btn-neutral {
  color: #333333;
  background-color: #FFFFFF;
}
.btn.btn-github.btn-neutral:hover, .btn.btn-github.btn-neutral:focus, .btn.btn-github.btn-neutral:active {
  color: #424242 !important;
}
.btn.btn-youtube {
  background-color: #e52d27;
  color: #FFFFFF;
}
.btn.btn-youtube:focus, .btn.btn-youtube:active, .btn.btn-youtube:hover {
  background-color: #e84842 !important;
  color: #FFFFFF !important;
}
.btn.btn-youtube.btn-simple {
  color: #e52d27;
  background-color: transparent;
  box-shadow: none;
  border-color: #e52d27;
}
.btn.btn-youtube.btn-simple:hover, .btn.btn-youtube.btn-simple:focus, .btn.btn-youtube.btn-simple:active {
  color: #e84842;
  border-color: #e84842;
}
.btn.btn-youtube.btn-neutral {
  color: #e52d27;
  background-color: #FFFFFF;
}
.btn.btn-youtube.btn-neutral:hover, .btn.btn-youtube.btn-neutral:focus, .btn.btn-youtube.btn-neutral:active {
  color: #e84842 !important;
}
.btn.btn-instagram {
  background-color: #125688;
  color: #FFFFFF;
}
.btn.btn-instagram:focus, .btn.btn-instagram:active, .btn.btn-instagram:hover {
  background-color: #1667a3 !important;
  color: #FFFFFF !important;
}
.btn.btn-instagram.btn-simple {
  color: #125688;
  background-color: transparent;
  box-shadow: none;
  border-color: #125688;
}
.btn.btn-instagram.btn-simple:hover, .btn.btn-instagram.btn-simple:focus, .btn.btn-instagram.btn-simple:active {
  color: #1667a3;
  border-color: #1667a3;
}
.btn.btn-instagram.btn-neutral {
  color: #125688;
  background-color: #FFFFFF;
}
.btn.btn-instagram.btn-neutral:hover, .btn.btn-instagram.btn-neutral:focus, .btn.btn-instagram.btn-neutral:active {
  color: #1667a3 !important;
}
.btn.btn-reddit {
  background-color: #ff4500;
  color: #FFFFFF;
}
.btn.btn-reddit:focus, .btn.btn-reddit:active, .btn.btn-reddit:hover {
  background-color: #ff5b1f !important;
  color: #FFFFFF !important;
}
.btn.btn-reddit.btn-simple {
  color: #ff4500;
  background-color: transparent;
  box-shadow: none;
  border-color: #ff4500;
}
.btn.btn-reddit.btn-simple:hover, .btn.btn-reddit.btn-simple:focus, .btn.btn-reddit.btn-simple:active {
  color: #ff5b1f;
  border-color: #ff5b1f;
}
.btn.btn-reddit.btn-neutral {
  color: #ff4500;
  background-color: #FFFFFF;
}
.btn.btn-reddit.btn-neutral:hover, .btn.btn-reddit.btn-neutral:focus, .btn.btn-reddit.btn-neutral:active {
  color: #ff5b1f !important;
}
.btn.btn-tumblr {
  background-color: #35465c;
  color: #FFFFFF;
}
.btn.btn-tumblr:focus, .btn.btn-tumblr:active, .btn.btn-tumblr:hover {
  background-color: #40556f !important;
  color: #FFFFFF !important;
}
.btn.btn-tumblr.btn-simple {
  color: #35465c;
  background-color: transparent;
  box-shadow: none;
  border-color: #35465c;
}
.btn.btn-tumblr.btn-simple:hover, .btn.btn-tumblr.btn-simple:focus, .btn.btn-tumblr.btn-simple:active {
  color: #40556f;
  border-color: #40556f;
}
.btn.btn-tumblr.btn-neutral {
  color: #35465c;
  background-color: #FFFFFF;
}
.btn.btn-tumblr.btn-neutral:hover, .btn.btn-tumblr.btn-neutral:focus, .btn.btn-tumblr.btn-neutral:active {
  color: #40556f !important;
}
.btn.btn-behance {
  background-color: #1769ff;
  color: #FFFFFF;
}
.btn.btn-behance:focus, .btn.btn-behance:active, .btn.btn-behance:hover {
  background-color: #367dff !important;
  color: #FFFFFF !important;
}
.btn.btn-behance.btn-simple {
  color: #1769ff;
  background-color: transparent;
  box-shadow: none;
  border-color: #1769ff;
}
.btn.btn-behance.btn-simple:hover, .btn.btn-behance.btn-simple:focus, .btn.btn-behance.btn-simple:active {
  color: #367dff;
  border-color: #367dff;
}
.btn.btn-behance.btn-neutral {
  color: #1769ff;
  background-color: #FFFFFF;
}
.btn.btn-behance.btn-neutral:hover, .btn.btn-behance.btn-neutral:focus, .btn.btn-behance.btn-neutral:active {
  color: #367dff !important;
}

.icon-property, .btn-move-right i, .btn-move-left i, .btn-magnify i, .btn-rotate i {
  transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);
  position: relative;
  display: inline-block;
}

#animated-buttons .btn i {
  position: relative;
  top: 3px;
  margin-top: -3px;
}

.btn-rotate:hover i, .btn-rotate:focus i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(53deg);
}

.btn-magnify:hover i, .btn-magnify:focus i {
  transform: scale(1.22);
}

.btn-move-left i {
  margin-right: 0;
}
.btn-move-left:hover i, .btn-move-left:focus i {
  transform: translate3d(-5px, 0, 0);
}

.btn-move-right i {
  margin-right: 0;
}
.btn-move-right:hover i, .btn-move-right:focus i {
  transform: translate3d(5px, 0, 0);
}

::-moz-placeholder {
  color: #9A9A9A;
}

:-ms-input-placeholder {
  color: #9A9A9A;
}

::-webkit-input-placeholder {
  color: #9A9A9A;
}

.form-control {
  background-color: #FFFFFF;
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  color: #66615b;
  line-height: normal;
  font-size: 14px;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
  box-shadow: none;
}
.form-control:focus {
  border: 1px solid #9A9A9A;
  box-shadow: none;
  outline: 0 !important;
  color: #66615B;
}
.form-control:focus + .input-group-append .input-group-text, .form-control:focus ~ .input-group-append .input-group-text, .form-control:focus + .input-group-prepend .input-group-text, .form-control:focus ~ .input-group-prepend .input-group-text {
  border: 1px solid #ccc;
  border-left: none;
  background-color: transparent;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  box-shadow: none;
}
.has-success .form-control {
  border: 1px solid #ccc;
  color: #66615b;
}
.has-success .form-control.form-control-success {
  padding-right: 2.5em !important;
}
.has-success .form-control:focus {
  border: 1px solid #6bd098;
  color: #6bd098;
}
.has-danger .form-control {
  background-color: #FFC0A4;
  border: 1px solid #ef8157;
  color: #ef8157;
}
.has-danger .form-control.form-control-danger {
  padding-right: 2.5em !important;
}
.has-danger .form-control:focus {
  background-color: #FFFFFF;
  border: 1px solid #ef8157;
}
.form-control + .form-control-feedback {
  border-radius: 6px;
  font-size: 14px;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 6px 6px 0 0;
  border-bottom-color: transparent;
}
.form-control + .input-group-append .input-group-text, .form-control + .input-group-prepend .input-group-text {
  background-color: #FFFFFF;
}

.form-group.no-border.form-control-lg .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .input-group-append .input-group-text {
  padding: 15px 0 15px 11px;
}
.form-group.no-border.form-control-lg .form-control,
.input-group.no-border.form-control-lg .form-control {
  padding: 15px 11px;
}
.form-group.no-border.form-control-lg .form-control + .input-group-prepend .input-group-text, .form-group.no-border.form-control-lg .form-control + .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .form-control + .input-group-prepend .input-group-text,
.input-group.no-border.form-control-lg .form-control + .input-group-append .input-group-text {
  padding: 15px 11px 15px 0;
}

.form-group.form-control-lg .form-control,
.input-group.form-control-lg .form-control {
  padding: 14px 10px;
}
.form-group.form-control-lg .form-control + .input-group-prepend .input-group-text, .form-group.form-control-lg .form-control + .input-group-append .input-group-text,
.input-group.form-control-lg .form-control + .input-group-prepend .input-group-text,
.input-group.form-control-lg .form-control + .input-group-append .input-group-text {
  padding: 14px 10px 14px 0;
}
.form-group.form-control-lg .input-group-prepend .input-group-text,
.form-group.form-control-lg .input-group-append .input-group-text,
.input-group.form-control-lg .input-group-prepend .input-group-text,
.input-group.form-control-lg .input-group-append .input-group-text {
  padding: 14px 0 15px 10px;
}
.form-group.form-control-lg .input-group-prepend .input-group-text + .form-control,
.form-group.form-control-lg .input-group-append .input-group-text + .form-control,
.input-group.form-control-lg .input-group-prepend .input-group-text + .form-control,
.input-group.form-control-lg .input-group-append .input-group-text + .form-control {
  padding: 15px 10px 15px 8px;
}

.form-group.no-border .form-control,
.input-group.no-border .form-control {
  padding: 11px 11px;
}
.form-group.no-border .form-control + .input-group-prepend .input-group-text, .form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  padding: 11px 11px 11px 0;
}
.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  padding: 11px 0 11px 11px;
}

.form-group .form-control,
.input-group .form-control {
  padding: 10px 10px 10px 10px;
}
.form-group .form-control + .input-group-prepend .input-group-text, .form-group .form-control + .input-group-append .input-group-text,
.input-group .form-control + .input-group-prepend .input-group-text,
.input-group .form-control + .input-group-append .input-group-text {
  padding: 10px 10px 10px 0;
}
.form-group .input-group-prepend .input-group-text,
.form-group .input-group-append .input-group-text,
.input-group .input-group-prepend .input-group-text,
.input-group .input-group-append .input-group-text {
  padding: 10px 0 10px 10px;
}
.form-group .input-group-prepend .input-group-text + .form-control, .form-group .input-group-prepend .input-group-text ~ .form-control,
.form-group .input-group-append .input-group-text + .form-control,
.form-group .input-group-append .input-group-text ~ .form-control,
.input-group .input-group-prepend .input-group-text + .form-control,
.input-group .input-group-prepend .input-group-text ~ .form-control,
.input-group .input-group-append .input-group-text + .form-control,
.input-group .input-group-append .input-group-text ~ .form-control {
  padding: 10px 11px 11px 8px;
}

.input-group.has-success .input-group-prepend .input-group-text,
.input-group.has-success .input-group-append .input-group-text {
  border: 1px solid #ccc;
  color: #66615b;
  background-color: #FFFFFF;
  border-right: none;
}

.form-group.no-border .form-control,
.form-group.no-border .form-control + .input-group-prepend .input-group-text,
.form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
  border: medium none;
}
.form-group.no-border .form-control:focus, .form-group.no-border .form-control:active, .form-group.no-border .form-control:active,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.form-group.no-border .form-control + .input-group-append .input-group-text:active,
.form-group.no-border .form-control + .input-group-append .input-group-text:active,
.input-group.no-border .form-control:focus,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.input-group.no-border .form-control + .input-group-append .input-group-text:active,
.input-group.no-border .form-control + .input-group-append .input-group-text:active {
  border: medium none;
  background-color: rgba(222, 222, 222, 0.5);
}
.form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
  border: none;
}

.has-error .form-control-feedback, .has-error .control-label {
  color: #ef8157;
}

.has-success .form-control-feedback, .has-success .control-label {
  color: #6bd098;
}

.input-group.has-danger .input-group-prepend {
  border-radius: 4px;
}
.input-group.has-danger .input-group-prepend .input-group-text {
  border: 1px solid #ef8157;
  border-right: none;
}
.input-group.has-danger .error {
  display: block;
  width: 100%;
  color: #ef8157;
  margin-top: 3px;
}

.input-group.has-success .input-group-prepend {
  border-radius: 4px;
}
.input-group.has-success .input-group-prepend .input-group-text {
  border-right: none;
}

.input-group-focus .input-group-prepend .input-group-text,
.input-group-focus .input-group-append .input-group-text {
  background-color: #FFFFFF;
  border-color: #9A9A9A;
}
.input-group-focus.no-border .input-group-prepend .input-group-text,
.input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.input-group-focus.has-danger .input-group-append .input-group-text,
.input-group-focus.has-danger .input-group-prepend .input-group-text {
  background-color: #FFC0A4;
}
.input-group-focus.has-success .input-group-append .input-group-text,
.input-group-focus.has-success .input-group-prepend .input-group-text {
  background-color: #ABF3CB;
  border: 1px solid #6bd098;
  border-right: none;
}

.input-group-append .input-group-text,
.input-group-prepend .input-group-text {
  background-color: transparent;
  border: 1px solid #E3E3E3;
  color: #66615B;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  opacity: 0.5;
}
.has-danger .input-group-append .input-group-text,
.has-danger .input-group-prepend .input-group-text {
  background-color: #FFC0A4;
}
.has-success .input-group-append .input-group-text,
.has-success .input-group-prepend .input-group-text {
  background-color: #ABF3CB;
}
.has-danger.input-group-focus .input-group-append .input-group-text,
.has-danger.input-group-focus .input-group-prepend .input-group-text {
  background-color: #FFFFFF;
  color: #ef8157;
}
.has-success.input-group-focus .input-group-append .input-group-text,
.has-success.input-group-focus .input-group-prepend .input-group-text {
  background-color: #FFFFFF;
  color: #6bd098;
}
.has-danger .form-control:focus + .input-group-append .input-group-text,
.has-danger .form-control:focus + .input-group-prepend .input-group-text {
  color: #ef8157;
}
.has-success .form-control:focus + .input-group-append .input-group-text,
.has-success .form-control:focus + .input-group-prepend .input-group-text {
  color: #6bd098;
}
.input-group-append .input-group-text + .form-control, .input-group-append .input-group-text ~ .form-control,
.input-group-prepend .input-group-text + .form-control,
.input-group-prepend .input-group-text ~ .form-control {
  padding: -0.5rem 0.7rem;
  padding-left: 18px;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  width: 17px;
}

.input-group-append,
.input-group-prepend {
  margin: 0;
}

.input-group-append .input-group-text {
  border-left: none;
}

.input-group-prepend .input-group-text {
  border-right: none;
}

.input-group,
.form-group {
  margin-bottom: 10px;
  position: relative;
}
.input-group .form-control-static,
.form-group .form-control-static {
  margin-top: 9px;
}
.input-group.has-danger .error,
.form-group.has-danger .error {
  color: #ef8157;
}

.input-group[disabled] .input-group-prepend .input-group-text,
.input-group[disabled] .input-group-append .input-group-text {
  background-color: #E3E3E3;
}

.input-group .form-control:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0 none;
}

.input-group .form-control:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #E3E3E3;
  color: #66615B;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 11px 0.7rem;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #DDDDDD;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

textarea.form-control {
  max-width: 100%;
  max-height: 80px;
  padding: 10px 10px 0 0;
  resize: none;
  border: none;
  border: 1px solid #E3E3E3;
  border-radius: 4px;
  line-height: 2;
}

.has-success.form-group .form-control, .has-success.form-group.no-border .form-control,
.has-danger.form-group .form-control,
.has-danger.form-group.no-border .form-control {
  padding-right: 32px;
}

.form.form-newsletter .form-group {
  float: left;
  width: 78%;
  margin-right: 2%;
  margin-top: 9px;
}

.input-group .input-group-btn {
  padding: 0 12px;
}

.form-group input[type=file] {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.form-text {
  font-size: 0.8571em;
}

.form-control-lg {
  padding: 0;
  font-size: inherit;
  line-height: 0;
  border-radius: 0;
}

.form-horizontal .col-form-label,
.form-horizontal .label-on-right {
  padding: 10px 5px 0 15px;
  text-align: right;
  max-width: 180px;
}
.form-horizontal .checkbox-radios {
  margin-bottom: 15px;
}
.form-horizontal .checkbox-radios .form-check:first-child {
  margin-top: 8px;
}
.form-horizontal .label-on-right {
  text-align: left;
  padding: 10px 15px 0 5px;
}
.form-horizontal .form-check-inline {
  margin-top: 6px;
}

button,
input,
optgroup,
select,
textarea {
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 400;
}

a {
  color: #51cbce;
}
a:hover, a:focus {
  color: #51cbce;
}

h1, .h1 {
  font-size: 3.5em;
  line-height: 1.15;
  margin-bottom: 30px;
}
h1 small, .h1 small {
  font-weight: 700;
  text-transform: uppercase;
  opacity: 0.8;
}

h2, .h2 {
  font-size: 2.5em;
  margin-bottom: 30px;
}

h3, .h3 {
  font-size: 2em;
  margin-bottom: 30px;
  line-height: 1.4em;
}

h4, .h4 {
  font-size: 1.714em;
  line-height: 1.45em;
  margin-top: 30px;
  margin-bottom: 15px;
}
h4 + .category, h4.title + .category, .h4 + .category, .h4.title + .category {
  margin-top: -10px;
}

h5, .h5 {
  font-size: 1.57em;
  line-height: 1.4em;
  margin-bottom: 15px;
}

h6, .h6 {
  font-size: 1em;
  font-weight: 700;
  text-transform: uppercase;
}

p.description {
  font-size: 1.14em;
}

.title {
  font-weight: 700;
}
.title.title-up {
  text-transform: uppercase;
}
.title.title-up a {
  color: #2c2c2c;
  text-decoration: none;
}
.title + .category {
  margin-top: -10px;
}

.description,
.card-description,
.footer-big p,
.card .footer .stats {
  color: #9A9A9A;
  font-weight: 300;
}

.category,
.card-category {
  text-transform: capitalize;
  font-weight: 400;
  color: #9A9A9A;
  font-size: 0.7142em;
}

.card-category {
  font-size: 1em;
}

.text-primary,
a.text-primary:focus, a.text-primary:hover {
  color: #51cbce !important;
}

.text-info,
a.text-info:focus, a.text-info:hover {
  color: #51bcda !important;
}

.text-success,
a.text-success:focus, a.text-success:hover {
  color: #6bd098 !important;
}

.text-warning,
a.text-warning:focus, a.text-warning:hover {
  color: #fbc658 !important;
}

.text-danger,
a.text-danger:focus, a.text-danger:hover {
  color: #ef8157 !important;
}

.text-gray,
a.text-gray:focus, a.text-gray:hover {
  color: #E3E3E3 !important;
}

.blockquote {
  border-left: none;
  border: 1px solid #66615B;
  padding: 20px;
  font-size: 1.1em;
  line-height: 1.8;
}
.blockquote small {
  color: #66615B;
  font-size: 0.8571em;
  text-transform: uppercase;
}
.blockquote.blockquote-primary {
  border-color: #51cbce;
  color: #51cbce;
}
.blockquote.blockquote-primary small {
  color: #51cbce;
}
.blockquote.blockquote-danger {
  border-color: #ef8157;
  color: #ef8157;
}
.blockquote.blockquote-danger small {
  color: #ef8157;
}
.blockquote.blockquote-white {
  border-color: rgba(255, 255, 255, 0.8);
  color: #FFFFFF;
}
.blockquote.blockquote-white small {
  color: rgba(255, 255, 255, 0.8);
}

body {
  color: #2c2c2c;
  font-size: 14px;
  font-family: "Montserrat", "Helvetica Neue", Arial, sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

.main {
  position: relative;
  background: #FFFFFF;
}

/* Animations */
.nav-pills .nav-link,
.navbar,
.nav-tabs .nav-link,
.sidebar .nav a,
.sidebar .nav a i,
.animation-transition-general,
.card-collapse .card .card-header a[data-toggle=collapse] i,
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span,
.sidebar .user a,
.off-canvas-sidebar .user a,
.sidebar .user .photo,
.off-canvas-sidebar .user .photo,
.sidebar .logo a.logo-mini,
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .nav p,
.off-canvas-sidebar .nav p,
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize,
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span,
.tag,
.tag [data-role=remove],
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .nav p,
.off-canvas-sidebar .nav p,
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
  transition: all 300ms ease 0s;
}

.dropdown-toggle:after,
.bootstrap-switch-label:before,
.caret {
  transition: all 150ms ease 0s;
}

.dropdown-toggle[aria-expanded=true]:after,
a[data-toggle=collapse][aria-expanded=true] .caret,
.card-collapse .card a[data-toggle=collapse][aria-expanded=true] i,
.card-collapse .card a[data-toggle=collapse].expanded i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.button-bar {
  display: block;
  position: relative;
  width: 22px;
  height: 1px;
  border-radius: 1px;
  background: #FFFFFF;
}
.button-bar + .button-bar {
  margin-top: 7px;
}
.button-bar:nth-child(2) {
  width: 17px;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9 ;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.offline-doc .navbar.navbar-transparent {
  padding-top: 25px;
  border-bottom: none;
}
.offline-doc .navbar.navbar-transparent .navbar-minimize {
  display: none;
}
.offline-doc .navbar.navbar-transparent .navbar-brand,
.offline-doc .navbar.navbar-transparent .collapse .navbar-nav .nav-link {
  color: #FFFFFF !important;
}
.offline-doc .footer {
  z-index: 3 !important;
}
.offline-doc .page-header .container {
  z-index: 3;
}
.offline-doc .page-header:after {
  background-color: rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}

.fixed-plugin .dropdown-menu li {
  padding: 2px !important;
}

.badge.badge-default {
  border-color: #66615B;
  background-color: #66615B;
}
.badge.badge-primary {
  border-color: #51cbce;
  background-color: #51cbce;
}
.badge.badge-info {
  border-color: #51bcda;
  background-color: #51bcda;
}
.badge.badge-success {
  border-color: #6bd098;
  background-color: #6bd098;
}
.badge.badge-warning {
  border-color: #fbc658;
  background-color: #fbc658;
}
.badge.badge-danger {
  border-color: #ef8157;
  background-color: #ef8157;
}
.badge.badge-neutral {
  border-color: #FFFFFF;
  background-color: #FFFFFF;
  color: inherit;
}

.card-user form .form-group {
  margin-bottom: 20px;
}

.ct-label.ct-horizontal.ct-end,
.ct-label.ct-vertical.ct-start {
  font-size: 14px;
}

.ct-chart.ct-perfect-fourth .ct-chart-pie .ct-label {
  font-size: 14px;
}

.card .card-footer .footer-line {
  padding-top: 3px;
}
.card.bootstrap-table .dropdown-item.active {
  background-color: #66615B;
  color: #FFFFFF;
}
.card .team-members .avatar {
  margin-top: 5px;
}
.card .team-members .text-right .btn {
  margin-top: 5px;
}

.btn-group-sm .btn-round {
  border-radius: 30px;
}

.heart {
  color: #EB5E28;
  animation: hearthing 1s ease infinite;
}

@keyframes hearthing {
  0% {
    transform: scale(0.75);
  }
  20% {
    transform: scale(1);
  }
  40% {
    transform: scale(0.75);
  }
  60% {
    transform: scale(1);
  }
  80% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(0.75);
  }
}
.datepicker .table-condensed tbody > tr:first-of-type .day {
  padding-top: 5px;
}

.navbar {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  min-height: 53px;
  margin-bottom: 20px;
}
.navbar a {
  vertical-align: middle;
}
.navbar a:not(.btn):not(.dropdown-item) {
  color: #FFFFFF;
}
.navbar a.dropdown-item {
  color: #66615B;
}
.navbar.bg-white .input-group .form-control,
.navbar.bg-white .input-group.no-border .form-control {
  color: #66615B;
}
.navbar.bg-white .input-group .form-control ::-moz-placeholder,
.navbar.bg-white .input-group.no-border .form-control ::-moz-placeholder {
  color: #66615B;
}
.navbar.bg-white .input-group .form-control :-ms-input-placeholder,
.navbar.bg-white .input-group.no-border .form-control :-ms-input-placeholder {
  color: #66615B;
}
.navbar.bg-white .input-group .form-control ::-webkit-input-placeholder,
.navbar.bg-white .input-group.no-border .form-control ::-webkit-input-placeholder {
  color: #66615B;
}
.navbar.bg-white .input-group-prepend .input-group-text i,
.navbar.bg-white .input-group-append .input-group-text i {
  color: #66615B;
  opacity: 0.5;
}
.navbar .form-group,
.navbar .input-group {
  margin: 0;
  margin-left: -3px;
  margin-right: 5px;
}
.navbar .form-group .form-group-addon,
.navbar .form-group .input-group-prepend .input-group-text,
.navbar .form-group .input-group-append .input-group-text,
.navbar .input-group .form-group-addon,
.navbar .input-group .input-group-prepend .input-group-text,
.navbar .input-group .input-group-append .input-group-text {
  color: #66615B;
}
.navbar .form-group .form-group-addon i,
.navbar .form-group .input-group-prepend .input-group-text i,
.navbar .form-group .input-group-append .input-group-text i,
.navbar .input-group .form-group-addon i,
.navbar .input-group .input-group-prepend .input-group-text i,
.navbar .input-group .input-group-append .input-group-text i {
  opacity: 1;
}
.navbar .form-group.no-border .form-control,
.navbar .input-group.no-border .form-control {
  color: #66615B;
}
.navbar .form-group.no-border .form-control ::-moz-placeholder,
.navbar .input-group.no-border .form-control ::-moz-placeholder {
  color: #66615B;
}
.navbar .form-group.no-border .form-control :-ms-input-placeholder,
.navbar .input-group.no-border .form-control :-ms-input-placeholder {
  color: #66615B;
}
.navbar .form-group.no-border .form-control ::-webkit-input-placeholder,
.navbar .input-group.no-border .form-control ::-webkit-input-placeholder {
  color: #66615B;
}
.navbar p {
  display: inline-block;
  margin: 0;
  line-height: 1.8em;
  font-size: 1em;
  font-weight: 400;
}
.navbar.navbar-absolute {
  position: absolute;
  width: 100%;
  padding-top: 10px;
  z-index: 1029;
}
.documentation .navbar.fixed-top {
  left: 0;
  width: auto;
  width: initial;
}
.navbar .navbar-wrapper {
  display: inline-flex;
  align-items: center;
}
.navbar .navbar-wrapper .navbar-minimize {
  padding-right: 10px;
}
.navbar .navbar-wrapper .navbar-minimize .btn {
  margin: 0;
}
.navbar .navbar-wrapper .navbar-toggle .navbar-toggler {
  padding-left: 0;
}
.navbar .navbar-wrapper .navbar-toggle:hover .navbar-toggler-bar.bar2 {
  width: 22px;
}
.navbar .navbar-nav.navbar-logo {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 49px;
  top: -4px;
}
.navbar .navbar-nav .nav-link.btn {
  padding: 11px 22px;
}
.navbar .navbar-nav .nav-link.btn.btn-lg {
  padding: 15px 48px;
}
.navbar .navbar-nav .nav-link.btn.btn-sm {
  padding: 5px 15px;
}
.navbar .navbar-nav .nav-link {
  text-transform: uppercase;
  font-size: 0.7142em;
  padding: 0.5rem 0.7rem;
  line-height: 1.625rem;
  margin-right: 3px;
}
.navbar .navbar-nav .nav-link i.fa + p,
.navbar .navbar-nav .nav-link i.nc-icon + p {
  margin-left: 3px;
}
.navbar .navbar-nav .nav-link i.fa,
.navbar .navbar-nav .nav-link i.nc-icon {
  font-size: 18px;
  position: relative;
  top: 3px;
  text-align: center;
  width: 21px;
}
.navbar .navbar-nav .nav-link i.nc-icon {
  top: 4px;
  font-size: 16px;
}
.navbar .navbar-nav .nav-link.profile-photo .profile-photo-small {
  width: 27px;
  height: 27px;
}
.navbar .navbar-nav .nav-link.disabled {
  opacity: 0.5;
  color: #FFFFFF;
}
.navbar .navbar-nav .nav-item.active .nav-link:not(.btn),
.navbar .navbar-nav .nav-item .nav-link:not(.btn):focus,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar .navbar-nav .nav-item .nav-link:not(.btn):active {
  border-radius: 3px;
  color: #66615B;
}
.navbar .logo-container {
  width: 27px;
  height: 27px;
  overflow: hidden;
  margin: 0 auto;
  border-radius: 50%;
  border: 1px solid transparent;
}
.navbar .navbar-brand {
  text-transform: capitalize;
  font-size: 20px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  line-height: 1.625rem;
}
.navbar .navbar-toggler {
  width: 37px;
  height: 27px;
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
}
.navbar .navbar-toggler .navbar-toggler-bar.navbar-kebab {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin: 0 auto;
}
.navbar .button-dropdown .navbar-toggler-bar:nth-child(2) {
  width: 17px;
}
.navbar.navbar-transparent {
  background-color: transparent !important;
  box-shadow: none;
  border-bottom: 1px solid #ddd;
}
.navbar.navbar-transparent a:not(.dropdown-item):not(.btn) {
  color: #66615B;
}
.navbar.navbar-transparent a:not(.dropdown-item):not(.btn).disabled {
  opacity: 0.5;
  color: #66615B;
}
.navbar.navbar-transparent .button-bar {
  background: #66615B;
}
.navbar.navbar-transparent .nav-item .nav-link:not(.btn) {
  color: #66615B;
}
.navbar.navbar-transparent .nav-item.active .nav-link:not(.btn),
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):hover,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):focus:hover,
.navbar.navbar-transparent .nav-item .nav-link:not(.btn):active {
  color: #51cbce;
}
.navbar.bg-white a:not(.dropdown-item):not(.btn) {
  color: #66615B;
}
.navbar.bg-white a:not(.dropdown-item):not(.btn).disabled {
  opacity: 0.5;
  color: #66615B;
}
.navbar.bg-white .button-bar {
  background: #66615B;
}
.navbar.bg-white .nav-item.active .nav-link:not(.btn),
.navbar.bg-white .nav-item .nav-link:not(.btn):focus,
.navbar.bg-white .nav-item .nav-link:not(.btn):hover,
.navbar.bg-white .nav-item .nav-link:not(.btn):active {
  color: #51bcda;
}
.navbar.bg-white .logo-container {
  border: 1px solid #66615B;
}
.navbar .navbar-collapse .nav-item a {
  font-size: 14px;
}

.bg-default {
  background-color: #66615B !important;
}

.bg-primary {
  background-color: #51cbce !important;
}

.bg-info {
  background-color: #51bcda !important;
}

.bg-success {
  background-color: #6bd098 !important;
}

.bg-danger {
  background-color: #ef8157 !important;
}

.bg-warning {
  background-color: #fbc658 !important;
}

.bg-white {
  background-color: #FFFFFF !important;
}

.dropdown .dropdown-menu,
.dropup .dropdown-menu,
.bootstrap-select .dropdown-menu {
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
  visibility: hidden;
  position: absolute;
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;
}
.dropdown .dropdown-menu[x-placement=top-start],
.dropup .dropdown-menu[x-placement=top-start],
.bootstrap-select .dropdown-menu[x-placement=top-start] {
  transform: translate3d(-20px, 0px, 0) !important;
}
.dropdown .dropdown-menu[x-placement=bottom-start],
.dropup .dropdown-menu[x-placement=bottom-start],
.bootstrap-select .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(-20px, 0px, 0) !important;
}
.dropdown.show .dropdown-menu,
.dropup.show .dropdown-menu,
.bootstrap-select.show .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
}
.dropdown.show .dropdown-menu[x-placement=top-start],
.dropup.show .dropdown-menu[x-placement=top-start],
.bootstrap-select.show .dropdown-menu[x-placement=top-start] {
  transform: translate3d(-20px, -50px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}
.dropdown.show .dropdown-menu[x-placement=bottom-start],
.dropup.show .dropdown-menu[x-placement=bottom-start],
.bootstrap-select.show .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(-20px, 50px, 0) !important;
  bottom: auto !important;
  top: 0 !important;
}

.dropup .dropdown-menu,
.dropdown-btn .dropdown-menu {
  transform: translate3d(-20px, 0px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}

.dropup.show .dropdown-menu,
.dropdown-btn.show .dropdown-menu {
  opacity: 1;
  visibility: visible;
}
.dropup.show .dropdown-menu .dropdown-menu.inner,
.dropdown-btn.show .dropdown-menu .dropdown-menu.inner {
  transform: translate3d(0, 0px, 0) !important;
}

.bootstrap-select.show .dropdown-menu.show[x-placement=top-start] {
  transform: translate3d(-20px, -60px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}
.bootstrap-select.show .dropdown-menu.show li:last-child a:hover {
  border-radius: 0 0 12px 12px;
}

.bootstrap-select.dropup.show:before {
  top: -1px !important;
}
.bootstrap-select.dropup.show:after {
  top: -2px !important;
}

.dropdown-menu {
  background-color: #FFFFFF;
  border: 0 none;
  border-radius: 12px;
  margin-top: 10px;
  padding: 0px;
}
.dropdown-menu .divider {
  background-color: #F1EAE0;
  margin: 0px;
}
.dropdown-menu .dropdown-header {
  color: #9A9A9A;
  font-size: 0.8571em;
  padding: 10px 15px;
}
.dropdown-menu .no-notification {
  color: #9A9A9A;
  font-size: 1.2em;
  padding: 30px 30px;
  text-align: center;
}
.dropdown-menu .dropdown-item {
  color: #66615b;
  font-size: 14px;
  padding: 10px 45px 10px 15px;
  clear: both;
  white-space: nowrap;
  width: 100%;
  display: block;
}
.dropdown-menu .dropdown-item img {
  margin-top: -3px;
}
.dropdown-menu .dropdown-item:focus {
  outline: 0 !important;
}
.btn-group.select .dropdown-menu {
  min-width: 100%;
}
.dropdown-menu .dropdown-item:first-child {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.dropdown-menu .dropdown-item:last-child {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.select .dropdown-menu .dropdown-item:first-child {
  border-radius: 0;
  border-bottom: 0 none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  color: #FFFFFF !important;
  opacity: 1;
  text-decoration: none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  background-color: #66615B;
}
.dropdown-menu.dropdown-primary .dropdown-item:hover, .dropdown-menu.dropdown-primary .dropdown-item:focus {
  background-color: #6dd3d6;
}
.dropdown-menu.dropdown-info .dropdown-item:hover, .dropdown-menu.dropdown-info .dropdown-item:focus {
  background-color: #6ec7e0;
}
.dropdown-menu.dropdown-success .dropdown-item:hover, .dropdown-menu.dropdown-success .dropdown-item:focus {
  background-color: #86d9ab;
}
.dropdown-menu.dropdown-warning .dropdown-item:hover, .dropdown-menu.dropdown-warning .dropdown-item:focus {
  background-color: #fcd27b;
}
.dropdown-menu.dropdown-danger .dropdown-item:hover, .dropdown-menu.dropdown-danger .dropdown-item:focus {
  background-color: #f29978;
}

.dropdown-divider {
  margin: 0 !important;
}

.btn-group.select.open {
  overflow: visible;
}

.dropdown-menu-right {
  right: -2px;
  left: auto;
}

.navbar-nav .dropdown-menu:before,
.dropdown .dropdown-menu[x-placement=bottom-start]:before,
.dropdown .dropdown-menu[x-placement=bottom-end]:before,
.card.card-just-text .dropdown .dropdown-menu:before,
.card-just-text .dropdown .dropdown-menu:before,
.dropdown-btn .dropdown-menu:before {
  border-bottom: 11px solid #F1EAE0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -12px;
}

.navbar-nav .dropdown-menu:after,
.dropdown .dropdown-menu[x-placement=bottom-start]:after,
.dropdown .dropdown-menu[x-placement=bottom-end]:after,
.card.card-just-text .dropdown .dropdown-menu:after,
.card-just-text .dropdown .dropdown-menu:after,
.dropdown-btn .dropdown-menu:after {
  border-bottom: 11px solid #FFFFFF;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -11px;
}

.dropdown .dropdown-menu.dropdown-notification[x-placement=top-start]:before,
.dropdown .dropdown-menu.dropdown-notification[x-placement=bottom-start]:before {
  left: 30px !important;
  right: auto;
}

.dropdown .dropdown-menu.dropdown-notification[x-placement=top-start]:after,
.dropdown .dropdown-menu.dropdown-notification[x-placement=bottom-start]:after {
  left: 30px !important;
  right: auto;
}

@media screen and (min-width: 768px) {
  .navbar-form {
    margin-top: 21px;
    margin-bottom: 21px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .navbar-search-form {
    display: none;
  }
  .navbar-nav .dropdown-item .dropdown-menu,
  .dropdown .dropdown-menu,
  .dropdown-btn .dropdown-menu {
    transform: translate3d(0px, -40px, 0px);
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;
  }
  .navbar-nav .dropdown-item.show .dropdown-menu,
  .dropdown.show .dropdown-menu,
  .dropdown-btn.show .dropdown-menu {
    transform: translate3d(0px, 0px, 0px);
    visibility: visible !important;
  }
  .bootstrap-select .dropdown-menu {
    transition: all 150ms linear;
  }
  .bootstrap-datetimepicker-widget {
    visibility: visible !important;
  }
  .bootstrap-select .show .dropdown-menu {
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;
    transform: translate3d(0px, 0px, 0px);
  }
  .navbar-nav.navbar-right li .dropdown-menu:before,
  .navbar-nav.navbar-right li .dropdown-menu:after {
    left: auto;
    right: 12px;
  }
  .footer:not(.footer-big) nav ul li:first-child {
    margin-left: 0;
  }
  body > .navbar-collapse.collapse {
    display: none !important;
  }
}
.dropdown-sharing .dropup-item {
  color: #66615b;
  font-size: 14px;
}
.dropdown-sharing .dropup-item .social-line {
  line-height: 28px;
  padding: 10px 20px 5px 20px !important;
}
.dropdown-sharing .dropup-item .social-line [class*=icon-] {
  font-size: 20px;
}
.dropdown-sharing .dropup-item:last-child {
  margin: 0 13px;
  display: block;
}
.dropdown-sharing .dropup-item .btn {
  margin: 10px;
}
.dropdown-sharing .dropup-item:hover .social-line,
.dropdown-sharing .dropup-item:hover .action-line,
.dropdown-sharing .dropup-item:focus .social-line,
.dropdown-sharing .dropup-item:focus .action-line {
  background-color: #FFFFFF;
  color: #66615b;
  opacity: 1;
  text-decoration: none;
}

.show .dropdown-sharing,
.show .dropdown-actions {
  margin-bottom: 1px;
}

.dropdown-actions .dropdown-item {
  margin: -15px 35px;
}
.dropdown-actions .dropdown-item .action-line {
  padding: 5px 10px;
  line-height: 24px;
  font-weight: bold;
}
.dropdown-actions .dropdown-item .action-line [class*=icon-] {
  font-size: 24px;
}
.dropdown-actions .dropdown-item .action-line .col-sm-9 {
  line-height: 34px;
}
.dropdown-actions .dropdown-item .link-danger {
  color: #ef8157;
}
.dropdown-actions .dropdown-item .link-danger:hover, .dropdown-actions .dropdown-item .link-danger:active, .dropdown-actions .dropdown-item .link-danger:focus {
  color: #ef8157;
}
.dropdown-actions li:hover a,
.dropdown-actions li:focus a {
  color: #66615b;
  opacity: 1;
  text-decoration: none;
}
.dropdown-actions .action-line .icon-simple {
  margin-left: -15px;
}

.dropdown .dropdown-menu[x-placement=top-start]:before,
.dropdown .dropdown-menu[x-placement=top-end]:before,
.dropup .dropdown-menu:before {
  border-top: 11px solid #DCD9D1;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -12px;
}

.dropdown .dropdown-menu[x-placement=top-start]:after,
.dropdown .dropdown-menu[x-placement=top-end]:after,
.dropup .dropdown-menu:after {
  border-top: 11px solid #FFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -11px;
}

.dropup .dropdown-toggle:after,
.dropdown .dropdown-toggle:after {
  margin-left: 0;
}

.dropdown-notification .dropdown-notification-list .notification-item {
  border-bottom: 1px solid #F1EAE0;
  font-size: 16px;
  color: #66615b;
}
.dropdown-notification .dropdown-notification-list .notification-item .notification-text {
  padding-left: 40px;
  position: relative;
  min-width: 330px;
  min-height: 70px;
  white-space: normal;
}
.dropdown-notification .dropdown-notification-list .notification-item .notification-text .label {
  display: block;
  position: absolute;
  top: 50%;
  margin-top: -12px;
  left: 7px;
}
.dropdown-notification .dropdown-notification-list .notification-item .notification-text .message {
  font-size: 0.9em;
  line-height: 0.7;
  margin-left: 10px;
}
.dropdown-notification .dropdown-notification-list .notification-item .notification-text .time {
  color: #9A9A9A;
  font-size: 0.7em;
  margin-left: 10px;
}
.dropdown-notification .dropdown-notification-list .notification-item .read-notification {
  font-size: 12px;
  opacity: 0;
  position: absolute;
  right: 5px;
  top: 50%;
  margin-top: -12px;
}
.dropdown-notification .dropdown-notification-list .notification-item:hover {
  text-decoration: none;
}
.dropdown-notification .dropdown-notification-list .notification-item:hover .notification-text {
  color: #66615b;
  background-color: #F0EFEB !important;
}
.dropdown-notification .dropdown-notification-list .notification-item:hover .read-notification {
  opacity: 1 !important;
}
.dropdown-notification .dropdown-footer {
  background-color: #E8E7E3;
  border-radius: 0 0 8px 8px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu {
  list-style: outside none none;
  padding: 0px 5px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu li {
  display: inline-block;
  text-align: left;
  padding: 0 10px;
}
.dropdown-notification .dropdown-footer .dropdown-footer-menu li a {
  color: #9C9B99;
  font-size: 0.9em;
  line-height: 35px;
}

.alert {
  border: 0;
  border-radius: 3px;
  color: #FFFFFF;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  position: relative;
}
.alert.alert-success {
  background-color: #7ed6a5;
}
.alert.alert-danger {
  background-color: #f1926e;
}
.alert.alert-warning {
  background-color: #fccf71;
}
.alert.alert-info {
  background-color: #66c4de;
}
.alert.alert-primary {
  background-color: #65d1d4;
}
.alert .close {
  color: #FFFFFF;
  opacity: 0.9;
  text-shadow: none;
  line-height: 0;
  outline: 0;
}
.alert .close i.fa,
.alert .close i.nc-icon {
  font-size: 14px !important;
}
.alert .close:hover, .alert .close:focus {
  opacity: 1;
}
.alert span[data-notify=icon] {
  font-size: 27px;
  display: block;
  left: 19px;
  position: absolute;
  top: 50%;
  margin-top: -11px;
}
.alert button.close {
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -13px;
  width: 25px;
  height: 25px;
  padding: 3px;
}
.alert .close ~ span {
  display: block;
  max-width: 89%;
}
.alert.alert-with-icon {
  padding-left: 65px;
}

img {
  max-width: 100%;
  border-radius: 3px;
}

.img-raised {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

.table .img-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}
.table .img-row {
  max-width: 60px;
  width: 60px;
}
.table .form-check {
  margin: 0;
}
.table .form-check label .form-check-sign::before, .table .form-check label .form-check-sign::after {
  top: -17px;
  left: 4px;
}
.table .btn {
  margin: 0;
}
.table small, .table .small {
  font-weight: 300;
}
.card-tasks .card-body .table {
  margin-bottom: 0;
}
.card-tasks .card-body .table > thead > tr > th,
.card-tasks .card-body .table > tbody > tr > th,
.card-tasks .card-body .table > tfoot > tr > th,
.card-tasks .card-body .table > thead > tr > td,
.card-tasks .card-body .table > tbody > tr > td,
.card-tasks .card-body .table > tfoot > tr > td {
  padding-top: 0;
  padding-bottom: 0;
}
.table > thead > tr > th {
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 0;
  text-transform: uppercase;
  border: 0;
}
.table .radio,
.table .checkbox {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  width: 15px;
}
.table .radio .icons,
.table .checkbox .icons {
  position: relative;
}
.table .radio label:after, .table .radio label:before,
.table .checkbox label:after,
.table .checkbox label:before {
  top: -17px;
  left: -3px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 12px 7px;
  vertical-align: middle;
}
.table .th-description {
  max-width: 150px;
}
.table .td-price {
  font-size: 26px;
  font-weight: 300;
  margin-top: 5px;
  position: relative;
  top: 4px;
  text-align: right;
}
.table .td-total {
  font-weight: 700;
  font-size: 1.57em;
  padding-top: 20px;
  text-align: right;
}
.table .td-actions .btn {
  margin: 0px;
}
.table > tbody > tr {
  position: relative;
}

.table-shopping > thead > tr > th {
  font-size: 1em;
  text-transform: uppercase;
}
.table-shopping > tbody > tr > td {
  font-size: 1em;
}
.table-shopping > tbody > tr > td b {
  display: block;
  margin-bottom: 5px;
}
.table-shopping .td-name {
  font-weight: 400;
  font-size: 1.5em;
}
.table-shopping .td-name small {
  color: #9A9A9A;
  font-size: 0.75em;
  font-weight: 300;
}
.table-shopping .td-number {
  font-weight: 300;
  font-size: 1.714em;
}
.table-shopping .td-name {
  min-width: 200px;
}
.table-shopping .td-number {
  text-align: right;
  min-width: 170px;
}
.table-shopping .td-number small {
  margin-right: 3px;
}
.table-shopping .img-container {
  width: 120px;
  max-height: 160px;
  overflow: hidden;
  display: block;
}
.table-shopping .img-container img {
  width: 100%;
}

.table-responsive {
  overflow: scroll;
  padding-bottom: 10px;
}

#tables .table-responsive {
  margin-bottom: 30px;
}

.table-hover > tbody > tr:hover {
  background-color: #f5f5f5;
}

.footer {
  padding: 24px 0;
}
.footer.footer-default {
  background-color: #f2f2f2;
}
.footer nav {
  display: inline-block;
  float: left;
  padding-left: 0;
}
.footer ul {
  margin-bottom: 0;
  padding: 0;
  list-style: none;
}
.footer ul li {
  display: inline-block;
}
.footer ul li a {
  color: inherit;
  padding: 0.5rem;
  font-size: 0.8571em;
  text-transform: uppercase;
  text-decoration: none;
}
.footer ul li a:hover {
  text-decoration: none;
}
.footer .copyright {
  font-size: 0.8571em;
  line-height: 1.8;
}
.footer:after {
  display: table;
  clear: both;
  content: " ";
}

.fixed-plugin {
  position: fixed;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 120px;
}
.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
}
.fixed-plugin .fa-cog {
  color: #FFFFFF;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}
.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto !important;
  top: -52px !important;
  width: 290px;
  border-radius: 10px;
  padding: 0 10px;
}
.fixed-plugin .dropdown .dropdown-menu .nc-icon {
  top: 2px;
  right: 10px;
  font-size: 14px;
}
.fixed-plugin .dropdown-menu:after,
.fixed-plugin .dropdown-menu:before {
  right: 10px;
  margin-left: auto;
  left: auto;
}
.fixed-plugin .fa-circle-thin {
  color: #FFFFFF;
}
.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}
.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}
.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}
.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}
.fixed-plugin .badge {
  border: 3px solid #FFFFFF;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
}
.fixed-plugin .badge.badge-light {
  border: 1px solid #E3E3E3;
}
.fixed-plugin .badge.badge-light.active, .fixed-plugin .badge.badge-light:hover {
  border: 3px solid #0bf;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #00bbff;
}
.fixed-plugin .badge-blue {
  background-color: #51bcda;
}
.fixed-plugin .badge-green {
  background-color: #6bd098;
}
.fixed-plugin .badge-orange {
  background-color: #51cbce;
}
.fixed-plugin .badge-yellow {
  background-color: #fbc658;
}
.fixed-plugin .badge-red {
  background-color: #ef8157;
}
.fixed-plugin h5 {
  font-size: 14px;
  margin: 10px;
}
.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 15px 2px;
  width: 25%;
  float: left;
}
.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 35px;
  min-height: inherit;
}
.fixed-plugin li.button-container {
  height: auto;
}
.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}
.fixed-plugin #sharrreTitle {
  text-align: center;
  padding: 10px 0;
  height: 50px;
}
.fixed-plugin li.header-title {
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}
.fixed-plugin .adjustments-line p {
  float: left;
  display: inline-block;
  margin-bottom: 0;
  font-size: 1em;
  color: #3C4858;
}
.fixed-plugin .adjustments-line a {
  color: transparent;
}
.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}
.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
  color: transparent;
}
.fixed-plugin .adjustments-line .togglebutton {
  text-align: center;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch {
  position: relative;
  left: -10px;
  font-size: 0.7142em;
  color: #66615B;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {
  left: 10px;
}
.fixed-plugin .adjustments-line .togglebutton .toggle {
  margin-right: 0;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: #FFF;
  border: 3px solid #FFF;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder img {
  margin-top: auto;
}
.fixed-plugin .dropdown-menu > li a.switch-trigger:hover, .fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
  background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder, .fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #FFFFFF;
}
.fixed-plugin .btn-social {
  width: 50%;
  display: block;
  width: 48%;
  float: left;
  font-weight: 600;
}
.fixed-plugin .btn-social i {
  margin-right: 5px;
}
.fixed-plugin .btn-social:first-child {
  margin-right: 2%;
}
.fixed-plugin .dropdown .dropdown-menu {
  transform-origin: 0 0;
}
.fixed-plugin .dropdown .dropdown-menu:before {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid rgba(0, 0, 0, 0.2);
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -27px;
  bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid #FFFFFF;
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -26px;
  bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:before, .fixed-plugin .dropdown .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  width: 16px;
  transform: translateY(-50px);
  -webkit-transform: translateY(-50px);
  -moz-transform: translateY(-50px);
}
.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {
  transform: translate3d(0, -60px, 0) !important;
  bottom: auto !important;
  top: 0 !important;
}
.fixed-plugin .bootstrap-switch {
  margin: 0;
}

.fixed-plugin .show-dropdown .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(0, -100px, 0) !important;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement=bottom-start]:before, .fixed-plugin .show-dropdown .dropdown-menu[x-placement=bottom-start]:after {
  top: 100px;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement=top-start] {
  transform: translate3d(0, 100px, 0) !important;
}
.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement=bottom-start] {
  transform: translate3d(0, -60px, 0) !important;
}
.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement=top-start] {
  transform: translate3d(0, 470px, 0) !important;
}

.from-check,
.form-check-radio {
  margin-bottom: 12px;
  position: relative;
}

.form-check {
  padding-left: 0;
  margin-bottom: 0.5rem;
}
.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 35px;
  line-height: 26px;
  margin-bottom: 0;
}
.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  content: " ";
  display: inline-block;
  position: absolute;
  width: 24px;
  height: 24px;
  left: 0;
  cursor: pointer;
  border-radius: 6px;
  top: 0;
  background-color: #AAA7A4;
  transition: opacity 0.3s linear;
}
.form-check .form-check-sign::after {
  font-family: "FontAwesome";
  content: "\\f00c";
  top: -1px;
  text-align: center;
  font-size: 15px;
  opacity: 0;
  color: #FFF;
  border: 0;
  background-color: inherit;
}
.form-check.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.form-check-radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check .form-check-label input[type=checkbox]:disabled + .form-check-sign,
.form-check-radio input[type=radio]:disabled + .form-check-sign {
  pointer-events: none !important;
}

.form-check-radio {
  margin-left: -3px;
}
.form-check-radio .form-check-label {
  padding-left: 2rem;
}
.form-check-radio.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check-radio .form-check-sign::before {
  font-family: "FontAwesome";
  content: "\\f10c";
  font-size: 22px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  position: absolute;
  opacity: 0.5;
  left: 5px;
  top: -5px;
}

.form-check-label input[type=checkbox]:checked + .form-check-sign:before {
  background-color: #66615B;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
  transition: opacity 0.3s linear;
  content: " ";
  display: block;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  font-family: "FontAwesome";
  content: "\\f192";
  top: -5px;
  position: absolute;
  left: 5px;
  opacity: 1;
  font-size: 22px;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #9A9A9A;
}

.progress {
  background-color: #DDDDDD;
  border-radius: 3px;
  box-shadow: none;
  height: 8px;
}

.progress-thin {
  height: 4px;
}

.progress-bar {
  background-color: #51cbce;
}

.progress-bar-primary {
  background-color: #51cbce;
}

.progress-bar-info {
  background-color: #51bcda;
}

.progress-bar-success {
  background-color: #6bd098;
}

.progress-bar-warning {
  background-color: #fbc658;
}

.progress-bar-danger {
  background-color: #ef8157;
}

/*           badges             */
.badge {
  padding: 4px 8px;
  text-transform: uppercase;
  font-size: 0.7142em;
  line-height: 12px;
  background-color: transparent;
  border: 1px solid;
  text-decoration: none;
  color: #FFFFFF;
  margin-bottom: 5px;
}
.badge:hover, .badge:focus {
  text-decoration: none;
}

.badge-icon {
  padding: 0.4em 0.55em;
}
.badge-icon i {
  font-size: 0.8em;
}

.badge-default {
  border-color: #66615B;
  background-color: #66615B;
}

.badge-primary {
  border-color: #51cbce;
  background-color: #51cbce;
}

.badge-info {
  border-color: #51bcda;
  background-color: #51bcda;
}

.badge-success {
  border-color: #6bd098;
  background-color: #6bd098;
}

.badge-warning {
  border-color: #fbc658;
  background-color: #fbc658;
}

.badge-danger {
  border-color: #ef8157;
  background-color: #ef8157;
}

.badge-neutral {
  border-color: #FFFFFF;
  background-color: #FFFFFF;
  color: inherit;
}

.badge-primary[href]:focus,
.badge-primary[href]:hover {
  color: #FFFFFF;
  background-color: #45c7cb;
  border-color: #45c7cb;
}

.badge-warning[href]:focus,
.badge-warning[href]:hover {
  color: #FFFFFF;
  background-color: #fbc149;
  border-color: #fbc149;
}

.badge-info[href]:focus,
.badge-info[href]:hover {
  color: #FFFFFF;
  background-color: #44b7d7;
  border-color: #44b7d7;
}

.badge-danger[href]:focus,
.badge-danger[href]:hover {
  color: #FFFFFF;
  background-color: #ee7749;
  border-color: #ee7749;
}

.badge-success[href]:focus,
.badge-success[href]:hover {
  color: #FFFFFF;
  background-color: #5fcc90;
  border-color: #5fcc90;
}

.badge-default[href]:focus,
.badge-default[href]:hover {
  color: #FFFFFF;
  background-color: #5e5954;
  border-color: #5e5954;
}

.pagination .page-item .page-link {
  border: 0;
  border-radius: 30px !important;
  transition: all 0.3s;
  padding: 0px 11px;
  margin: 0 3px;
  min-width: 30px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  color: #2c2c2c;
  cursor: pointer;
  font-size: 14px;
  text-transform: uppercase;
  background: transparent;
  outline: none;
}
.pagination .page-item .page-link:hover, .pagination .page-item .page-link:focus {
  color: #2c2c2c;
  background-color: rgba(222, 222, 222, 0.3);
  border: none;
}
.pagination .page-item .page-link:focus, .pagination .page-item .page-link:active:focus {
  box-shadow: none;
}
.pagination .arrow-margin-left,
.pagination .arrow-margin-right {
  position: absolute;
}
.pagination .arrow-margin-right {
  right: 0;
}
.pagination .arrow-margin-left {
  left: 0;
}
.pagination .page-item.active > .page-link {
  color: #FFFFFF;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.pagination .page-item.active > .page-link, .pagination .page-item.active > .page-link:focus, .pagination .page-item.active > .page-link:hover {
  background-color: #51cbce;
  border-color: #51cbce;
  color: #FFFFFF;
}
.pagination .page-item.disabled > .page-link {
  opacity: 0.5;
}
.pagination.pagination-info .page-item.active > .page-link, .pagination.pagination-info .page-item.active > .page-link:focus, .pagination.pagination-info .page-item.active > .page-link:hover {
  background-color: #51bcda;
  border-color: #51bcda;
}
.pagination.pagination-success .page-item.active > .page-link, .pagination.pagination-success .page-item.active > .page-link:focus, .pagination.pagination-success .page-item.active > .page-link:hover {
  background-color: #6bd098;
  border-color: #6bd098;
}
.pagination.pagination-primary .page-item.active > .page-link, .pagination.pagination-primary .page-item.active > .page-link:focus, .pagination.pagination-primary .page-item.active > .page-link:hover {
  background-color: #51cbce;
  border-color: #51cbce;
}
.pagination.pagination-warning .page-item.active > .page-link, .pagination.pagination-warning .page-item.active > .page-link:focus, .pagination.pagination-warning .page-item.active > .page-link:hover {
  background-color: #fbc658;
  border-color: #fbc658;
}
.pagination.pagination-danger .page-item.active > .page-link, .pagination.pagination-danger .page-item.active > .page-link:focus, .pagination.pagination-danger .page-item.active > .page-link:hover {
  background-color: #ef8157;
  border-color: #ef8157;
}
.pagination.pagination-neutral .page-item > .page-link {
  color: #FFFFFF;
}
.pagination.pagination-neutral .page-item > .page-link:focus, .pagination.pagination-neutral .page-item > .page-link:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.pagination.pagination-neutral .page-item.active > .page-link, .pagination.pagination-neutral .page-item.active > .page-link:focus, .pagination.pagination-neutral .page-item.active > .page-link:hover {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
  color: #51cbce;
}

.info.info-hover .info-title {
  transition: color 0.4s;
}
.info.info-hover:hover .icon {
  transform: translate3d(0, -0.5rem, 0) !important;
}
.info.info-hover:hover .icon.icon-primary.icon-circle {
  box-shadow: 0px 15px 30px 0px rgba(249, 99, 50, 0.3);
}
.info.info-hover:hover .icon.icon-info.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(44, 168, 255, 0.3);
}
.info.info-hover:hover .icon.icon-success.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(24, 206, 15, 0.3);
}
.info.info-hover:hover .icon.icon-warning.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(255, 178, 54, 0.3);
}
.info.info-hover:hover .icon.icon-danger.icon-circle {
  box-shadow: 0px 15px 35px 0px rgba(255, 54, 54, 0.3);
}
.info.info-hover:hover .icon.icon-info + .info-title {
  color: #51bcda;
}
.info.info-hover:hover .icon.icon-warning + .info-title {
  color: #fbc658;
}
.info.info-hover:hover .icon.icon-danger + .info-title {
  color: #ef8157;
}
.info.info-hover:hover .icon.icon-primary + .info-title {
  color: #51cbce;
}
.info.info-hover:hover .icon.icon-success + .info-title {
  color: #6bd098;
}
.info .icon {
  color: #66615B;
  transition: transform 0.4s, box-shadow 0.4s;
}
.info .icon > i {
  font-size: 2.3em;
}
.info .icon.icon-circle {
  max-width: 70px;
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border-radius: 50%;
  box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);
  font-size: 0.7142em;
  background-color: #FFFFFF;
  position: relative;
}
.info .icon.icon-circle i {
  line-height: 2.6em;
}
.info .info-title {
  margin: 15px 0 5px;
  padding: 0 15px;
  color: #2c2c2c;
  font-weight: 700;
}
.info p {
  color: #66615B;
  padding: 0 15px;
  font-size: 1.1em;
}

.info-horizontal {
  text-align: left !important;
}
.info-horizontal .icon {
  float: left;
  margin-top: 23px;
  margin-right: 10px;
}
.info-horizontal .icon > i {
  font-size: 2em;
}
.info-horizontal .icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin-top: 8px;
}
.info-horizontal .icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 3.5;
  font-size: 1.9em;
}
.info-horizontal .description {
  overflow: hidden;
}

.icon.icon-primary {
  color: #51cbce;
}
.icon.icon-primary.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(81, 203, 206, 0.5);
}
.icon.icon-info {
  color: #51bcda;
}
.icon.icon-info.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(81, 188, 218, 0.5);
}
.icon.icon-success {
  color: #6bd098;
}
.icon.icon-success.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(107, 208, 152, 0.5);
}
.icon.icon-warning {
  color: #fbc658;
}
.icon.icon-warning.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(251, 198, 88, 0.5);
}
.icon.icon-danger {
  color: #ef8157;
}
.icon.icon-danger.icon-circle {
  box-shadow: 0px 9px 30px -6px rgba(239, 129, 87, 0.5);
}
.icon.icon-white {
  color: #FFFFFF;
}

/*             Navigation Pills               */
.nav-pills .nav-item + .nav-link {
  margin-left: 0;
}
.nav-pills .nav-item .nav-link {
  border: 1px solid #66615B;
  border-radius: 0;
  color: #66615B;
  font-weight: 700;
  margin-left: -1px;
  padding: 10px 25px;
}
.nav-pills .nav-item.active .nav-link,
.nav-pills .nav-item.active .nav-link:hover,
.nav-pills .nav-item.active .nav-link:focus {
  background-color: #66615B;
  color: #FFFFFF;
}
.nav-pills .nav-item:first-child .nav-link {
  border-radius: 30px 0 0 30px !important;
  margin: 0;
}
.nav-pills .nav-item:last-child .nav-link {
  border-radius: 0 30px 30px 0 !important;
}
.nav-pills .nav-item .nav-link.active {
  background-color: #66615B;
  color: #FFFFFF;
}

.nav-pills-primary .nav-item .nav-link {
  border: 1px solid #51cbce;
  color: #51cbce;
}
.nav-pills-primary .nav-item .nav-link.active {
  border: 1px solid #51cbce;
  background: #51cbce;
  color: #FFFFFF;
}

.nav-pills-danger .nav-item .nav-link {
  border: 1px solid #ef8157;
  color: #ef8157;
}
.nav-pills-danger .nav-item .nav-link.active {
  border: 1px solid #ef8157;
  background: #ef8157;
  color: #FFFFFF;
}

.nav-pills-info .nav-item .nav-link {
  border: 1px solid #51bcda;
  color: #51bcda;
}
.nav-pills-info .nav-item .nav-link.active {
  border: 1px solid #51bcda;
  background: #51bcda;
  color: #FFFFFF;
}

.nav-pills-success .nav-item .nav-link {
  border: 1px solid #6bd098;
  color: #6bd098;
}
.nav-pills-success .nav-item .nav-link.active {
  border: 1px solid #6bd098;
  background: #6bd098;
  color: #FFFFFF;
}

.nav-pills-warning .nav-item .nav-link {
  border: 1px solid #fbc658;
  color: #fbc658;
}
.nav-pills-warning .nav-item .nav-link.active {
  border: 1px solid #fbc658;
  background: #fbc658;
  color: #FFFFFF;
}

.page-item:first-child .page-link,
.page-item:last-child .page-link {
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
}

.nav-pills-default .nav-item.show .nav-link,
.nav-pills-default .nav-link.active {
  background-color: #66615B !important;
}

.nav-pills-primary .nav-item.show .nav-link,
.nav-pills-primary .nav-link.active {
  background-color: #51cbce !important;
}

.nav-pills-info .nav-item.show .nav-link,
.nav-pills-info .nav-link.active {
  background-color: #51bcda !important;
}

.nav-pills-warning .nav-item.show .nav-link,
.nav-pills-warning .nav-link.active {
  background-color: #fbc658 !important;
}

.nav-pills-success .nav-item.show .nav-link,
.nav-pills-success .nav-link.active {
  background-color: #6bd098 !important;
}

.nav-pills-danger .nav-item.show .nav-link,
.nav-pills-danger .nav-link.active {
  background-color: #ef8157 !important;
}

/*             Navigation Tabs                 */
.nav-tabs-navigation {
  text-align: center;
  border-bottom: 1px solid #F1EAE0;
  margin-bottom: 30px;
}
.nav-tabs-navigation .nav > .nav-item > .nav-link {
  padding-bottom: 20px;
}

.nav-tabs-wrapper {
  display: inline-block;
  margin-bottom: -6px;
  margin-left: 1.25%;
  margin-right: 1.25%;
  position: relative;
  width: auto;
}

.nav-tabs {
  border-bottom: 0 none;
  font-size: 14px;
  font-weight: 400;
}
.nav-tabs .nav-item .nav-link {
  border: 0 none;
  color: #A49E93;
  background-color: transparent;
}
.nav-tabs .nav-item .nav-link:hover {
  color: #66615b;
}
.nav-tabs .nav-item .nav-link.active {
  color: #66615b;
}
.nav-tabs .nav-item {
  color: #66615b;
  position: relative;
}
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item .nav-link.active:hover,
.nav-tabs .nav-item .nav-link.active:focus {
  background-color: transparent;
  border: 0 none;
}
.nav-tabs .nav-item .nav-link.active:after,
.nav-tabs .nav-item .nav-link.active:hover:after,
.nav-tabs .nav-item .nav-link.active:focus:after {
  border-bottom: 11px solid #FFFFFF;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 40%;
  bottom: 5px;
}
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border-bottom: 11px solid #F1EAE0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 40%;
  bottom: 6px;
}
.nav-tabs .nav-item.show .nav-link {
  background-color: transparent;
}
.nav-tabs .dropdown-menu {
  margin-top: -6px;
  margin-left: -46px;
  border-radius: 8px;
}
.nav-tabs .dropdown-menu .dropdown-item:hover,
.nav-tabs .dropdown-menu .dropdown-item.active {
  color: #FFFFFF;
  background-color: #68B3C8;
}
.nav-tabs .dropdown-menu :before {
  border-bottom: 11px solid #F1EAE0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -11px;
}
.nav-tabs .dropdown-menu :after {
  border-bottom: 11px solid #FFFCF5;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -10px;
}

.profile-content .tab-content .tab-pane {
  min-height: 200px;
}
.profile-content .tab-content #tweets, .profile-content .tab-content #connections, .profile-content .tab-content #media {
  height: 100%;
}

.nav-text, .nav-icons {
  margin: 0 0 10px 0;
}
.nav-text > li > a, .nav-icons > li > a {
  display: block;
  padding: 0px 0.7rem;
  color: #9A9A9A;
  text-align: center;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.nav-text > li > a:hover, .nav-text > li > a:focus, .nav-icons > li > a:hover, .nav-icons > li > a:focus {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
}
.nav-text > li:first-child a, .nav-icons > li:first-child a {
  padding-left: 0;
}
.nav-text > li.active a, .nav-icons > li.active a {
  color: #51bcda;
}

.nav-icons > li {
  display: inline-block;
}
.nav-icons > li > a {
  padding: 0 10px;
  margin-bottom: 10px;
}
.nav-icons > li > a i {
  font-size: 1.714em;
  margin-bottom: 10px;
  width: 1.714em;
}

.nav-icons.nav-stacked > li {
  display: block;
}
.nav-icons.nav-stacked > li > a {
  margin-bottom: 20px;
}

.nav-blue > li.active a {
  color: #51cbce;
}

.nav-azure > li.active a {
  color: #51bcda;
}

.nav-green > li.active a {
  color: #6bd098;
}

.nav-orange > li.active a {
  color: #fbc658;
}

.nav-red > li.active a {
  color: #ef8157;
}

.nav-text {
  margin: 0 0 10px 0;
}
.nav-text > li > a {
  font-size: 1em;
  text-transform: uppercase;
  padding: 3px 0;
  text-align: left;
  font-weight: 600;
}
.nav-text > li:first-child > a {
  padding-top: 0;
}
.nav-text h4 {
  margin-top: 0;
}

.nav-text:not(.nav-stacked) > li {
  display: inline-block;
}
.nav-text:not(.nav-stacked) > li > a {
  margin-right: 15px;
}

.tab-space {
  padding: 20px 0 50px;
}

.verical-navs .nav-stacked .nav-link.active:before,
.verical-navs .nav-stacked .nav-link.active:hover:before,
.verical-navs .nav-stacked .nav-link.active.show:before {
  border-right: 11px solid #F1EAE0;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 0;
  bottom: 20px;
}

.verical-navs .nav-stacked .nav-link.active:after,
.verical-navs .nav-stacked .nav-link.active:hover:after,
.verical-navs .nav-stacked .nav-link.active.show:after {
  border-right: 11px solid #FFFFFF;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: -1px;
  bottom: 20px;
}

#second-tabs {
  margin-left: 20px;
}

.nav-tabs-navigation.verical-navs {
  border-right: 1px solid #F1EAE0;
  font-size: 16px;
  padding: 0 37px;
  border-bottom: none;
}

.popover {
  font-size: 14px;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  border: none;
  line-height: 1.7;
  max-width: 240px;
}
.popover.bs-popover-top .arrow:before, .popover.bs-popover-left .arrow:before, .popover.bs-popover-right .arrow:before, .popover.bs-popover-bottom .arrow:before {
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.popover .popover-header {
  color: rgba(182, 182, 182, 0.6);
  font-size: 14px;
  text-transform: capitalize;
  font-weight: 600;
  margin: 0;
  margin-top: 5px;
  border: none;
  background-color: transparent;
}
.popover:before {
  display: none;
}
.popover.bs-tether-element-attached-top:after {
  border-bottom-color: #FFFFFF;
  top: -9px;
}
.popover.popover-primary {
  background-color: #51cbce;
}
.popover.popover-primary .popover-body {
  color: #FFFFFF;
}
.popover.popover-primary.bs-popover-right .arrow:after {
  border-right-color: #51cbce;
}
.popover.popover-primary.bs-popover-top .arrow:after {
  border-top-color: #51cbce;
}
.popover.popover-primary.bs-popover-bottom .arrow:after {
  border-bottom-color: #51cbce;
}
.popover.popover-primary.bs-popover-left .arrow:after {
  border-left-color: #51cbce;
}
.popover.popover-primary .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-info {
  background-color: #51bcda;
}
.popover.popover-info .popover-body {
  color: #FFFFFF;
}
.popover.popover-info.bs-popover-right .arrow:after {
  border-right-color: #51bcda;
}
.popover.popover-info.bs-popover-top .arrow:after {
  border-top-color: #51bcda;
}
.popover.popover-info.bs-popover-bottom .arrow:after {
  border-bottom-color: #51bcda;
}
.popover.popover-info.bs-popover-left .arrow:after {
  border-left-color: #51bcda;
}
.popover.popover-info .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-warning {
  background-color: #fbc658;
}
.popover.popover-warning .popover-body {
  color: #FFFFFF;
}
.popover.popover-warning.bs-popover-right .arrow:after {
  border-right-color: #fbc658;
}
.popover.popover-warning.bs-popover-top .arrow:after {
  border-top-color: #fbc658;
}
.popover.popover-warning.bs-popover-bottom .arrow:after {
  border-bottom-color: #fbc658;
}
.popover.popover-warning.bs-popover-left .arrow:after {
  border-left-color: #fbc658;
}
.popover.popover-warning .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-danger {
  background-color: #ef8157;
}
.popover.popover-danger .popover-body {
  color: #FFFFFF;
}
.popover.popover-danger.bs-popover-right .arrow:after {
  border-right-color: #ef8157;
}
.popover.popover-danger.bs-popover-top .arrow:after {
  border-top-color: #ef8157;
}
.popover.popover-danger.bs-popover-bottom .arrow:after {
  border-bottom-color: #ef8157;
}
.popover.popover-danger.bs-popover-left .arrow:after {
  border-left-color: #ef8157;
}
.popover.popover-danger .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}
.popover.popover-success {
  background-color: #6bd098;
}
.popover.popover-success .popover-body {
  color: #FFFFFF;
}
.popover.popover-success.bs-popover-right .arrow:after {
  border-right-color: #6bd098;
}
.popover.popover-success.bs-popover-top .arrow:after {
  border-top-color: #6bd098;
}
.popover.popover-success.bs-popover-bottom .arrow:after {
  border-bottom-color: #6bd098;
}
.popover.popover-success.bs-popover-left .arrow:after {
  border-left-color: #6bd098;
}
.popover.popover-success .popover-header {
  color: #FFFFFF;
  opacity: 0.6;
}

.tooltip.bs-tooltip-right .arrow:before {
  border-right-color: #FFFFFF;
}
.tooltip.bs-tooltip-top .arrow:before {
  border-top-color: #FFFFFF;
}
.tooltip.bs-tooltip-bottom .arrow:before {
  border-bottom-color: #FFFFFF;
}
.tooltip.bs-tooltip-left .arrow:before {
  border-left-color: #FFFFFF;
}

.tooltip-inner {
  padding: 0.5rem 0.7rem;
  min-width: 130px;
  background-color: #FFFFFF;
  font-size: 14px;
  color: inherit;
  box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}

.modal-header {
  border-bottom: 1px solid #DDDDDD;
  padding: 20px;
  text-align: center;
  display: block !important;
}
.modal-header.no-border-header {
  border-bottom: 0 none !important;
}
.modal-header.no-border-header .modal-title {
  margin-top: 20px;
}
.modal-header button.close:focus {
  outline: none;
}
.modal-header .modal-profile {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  text-align: center;
  line-height: 6.4;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
.modal-header .modal-profile i {
  font-size: 30px;
}

.modal-dialog.modal-sm .modal-header button.close, .modal-dialog.modal-register .modal-header button.close {
  margin-top: 0;
}

.modal-content {
  border: 0 none;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);
}
.modal-content .modal-header h6 {
  margin-top: 10px;
}

.modal-dialog {
  padding-top: 60px;
}

.modal-body {
  padding: 20px 50px;
  color: #000;
}

.modal-footer {
  border-top: 1px solid #DDDDDD;
  padding: 0px;
}
.modal-footer.no-border-footer {
  border-top: 0 none;
}

.modal-footer .left-side,
.modal-footer .right-side {
  display: inline-block;
  text-align: center;
  width: 50%;
  padding: 5px;
}

.modal-footer .btn-link {
  padding: 20px;
  width: 100%;
  margin: 0;
}

.modal-footer .divider {
  background-color: #DDDDDD;
  display: inline-block;
  float: inherit;
  height: 63px;
  margin: 0px -3px;
  width: 1px;
}

.modal-register .modal-footer {
  text-align: center;
  margin-bottom: 25px;
  padding: 20px 0 15px;
}
.modal-register .modal-footer span {
  width: 100%;
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
  display: block;
}

.carousel .carousel-inner {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}
.carousel .nc-icon {
  font-size: 2em;
}

.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
}
.wrapper.wrapper-full-page {
  min-height: 100vh;
  height: auto;
}

.sidebar,
.off-canvas-sidebar {
  position: fixed;
  top: 0;
  height: 100%;
  bottom: 0;
  width: 260px;
  left: 0;
  z-index: 999;
}
.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
  position: relative;
  height: calc(100vh - 75px);
  overflow: auto;
  width: 260px;
  z-index: 4;
  padding-bottom: 100px;
}
.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,
.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {
  display: none !important;
}
.sidebar .sidebar-wrapper .navbar-form,
.off-canvas-sidebar .sidebar-wrapper .navbar-form {
  border: none;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span {
  display: inline-block;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  margin: 0;
  position: relative;
  transform: translateX(0px);
  opacity: 1;
  white-space: nowrap;
  display: block;
  line-height: 20px;
  z-index: 1;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  text-transform: uppercase;
  width: 34px;
  margin-right: 10px;
  margin-left: 0px;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  position: relative;
  float: left;
  z-index: 1;
  display: inherit;
  color: rgba(255, 255, 255, 0.5);
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  text-transform: capitalize;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a i,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a i,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a i,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a i {
  font-size: 17px;
  line-height: 20px;
  width: 26px;
}
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
  position: absolute;
  right: 20px;
  top: 2px;
  opacity: 1;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar .nav,
.off-canvas-sidebar .nav {
  margin-top: 20px;
  display: block;
}
.sidebar .nav .caret,
.off-canvas-sidebar .nav .caret {
  top: 14px;
  position: absolute;
  right: 10px;
}
.sidebar .nav li > a + div .nav li > a,
.off-canvas-sidebar .nav li > a + div .nav li > a {
  margin-top: 7px;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  margin: 10px 15px 0;
  color: #FFFFFF;
  display: block;
  text-decoration: none;
  position: relative;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 12px;
  padding: 10px 8px;
  line-height: 30px;
  opacity: 0.7;
}
.sidebar .nav li .nav > li > a,
.off-canvas-sidebar .nav li .nav > li > a {
  padding: 5px 8px;
}
.sidebar .nav li.active > a, .sidebar .nav li.active > a > i,
.off-canvas-sidebar .nav li.active > a,
.off-canvas-sidebar .nav li.active > a > i {
  opacity: 1;
}
.sidebar .nav li:hover:not(.active) > a, .sidebar .nav li:focus:not(.active) > a,
.off-canvas-sidebar .nav li:hover:not(.active) > a,
.off-canvas-sidebar .nav li:focus:not(.active) > a {
  opacity: 1;
}
.sidebar .nav li.active > a[data-toggle=collapse], .sidebar .nav li.active > a[data-toggle=collapse] i, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #ef8157;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a, .sidebar .nav li.active > a[data-toggle=collapse] i + div .nav .active a, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i + div .nav .active a, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a + div .nav .active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] i + div .nav .active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i + div .nav .active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a + div .nav .active a {
  background-color: transparent;
  box-shadow: none;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a:after, .sidebar .nav li.active > a[data-toggle=collapse] i + div .nav .active a:after, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i + div .nav .active a:after, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] i + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a + div .nav .active a:after {
  content: "";
  position: absolute;
  width: calc(100% - 5px);
  z-index: 0;
}
.sidebar .nav li.active > a[data-toggle=collapse] ~ div > .nav,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > .nav {
  margin-top: 0;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
  margin: 0;
  line-height: 30px;
  position: relative;
  display: block;
  height: auto;
  white-space: nowrap;
  font-weight: 600;
}
.sidebar .nav i,
.off-canvas-sidebar .nav i {
  font-size: 24px;
  float: left;
  margin-right: 12px;
  line-height: 30px;
  width: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  position: relative;
}
.sidebar .nav .collapse .nav,
.sidebar .nav .collapsing .nav,
.off-canvas-sidebar .nav .collapse .nav,
.off-canvas-sidebar .nav .collapsing .nav {
  margin-top: 0;
}
.sidebar .sidebar-background,
.off-canvas-sidebar .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.sidebar .sidebar-background:after,
.off-canvas-sidebar .sidebar-background:after {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  content: "";
  display: block;
  background: #FFFFFF;
  opacity: 1;
}
.sidebar .logo,
.off-canvas-sidebar .logo {
  position: relative;
  padding: 7px 0.7rem;
  z-index: 4;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
  opacity: 0;
  float: left;
  width: 34px;
  text-align: center;
  margin-left: 10px;
  margin-right: 12px;
}
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-normal {
  display: block;
  opacity: 1;
  padding: 11px 0 8px;
  transform: translate3d(0px, 0, 0);
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.5);
}
.sidebar .logo p,
.off-canvas-sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #FFFFFF;
  line-height: 20px;
  font-family: "Muli", "Helvetica", Arial, sans-serif;
}
.sidebar .logo .simple-text,
.off-canvas-sidebar .logo .simple-text {
  text-transform: uppercase;
  padding: 0.5rem 0;
  display: block;
  white-space: nowrap;
  font-size: 1rem;
  color: #FFFFFF;
  text-decoration: none;
  font-weight: 400;
  line-height: 30px;
  overflow: hidden;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar:before, .sidebar:after,
.off-canvas-sidebar:before,
.off-canvas-sidebar:after {
  display: block;
  content: "";
  opacity: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.sidebar:after,
.off-canvas-sidebar:after {
  background: #66615B;
  background: linear-gradient(#66615B 0%, #000 80%);
  z-index: 3;
}
.sidebar[data-color=white]:after,
.off-canvas-sidebar[data-color=white]:after {
  background: #FFFFFF;
}
.sidebar[data-color=white] .nav li a,
.sidebar[data-color=white] .nav li a i,
.sidebar[data-color=white] .nav li a[data-toggle=collapse],
.sidebar[data-color=white] .nav li a[data-toggle=collapse] i,
.sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li .sidebar-mini-icon,
.sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li > a,
.off-canvas-sidebar[data-color=white] .nav li a,
.off-canvas-sidebar[data-color=white] .nav li a i,
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse],
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse] i,
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li .sidebar-mini-icon,
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li > a {
  color: #66615B;
  opacity: 0.7;
}
.sidebar[data-color=white] .nav li:hover:not(.active) > a, .sidebar[data-color=white] .nav li:focus:not(.active) > a,
.off-canvas-sidebar[data-color=white] .nav li:hover:not(.active) > a,
.off-canvas-sidebar[data-color=white] .nav li:focus:not(.active) > a {
  opacity: 1;
}
.sidebar[data-color=white] .logo .simple-text,
.off-canvas-sidebar[data-color=white] .logo .simple-text {
  color: #66615B;
}
.sidebar[data-color=white] .logo:after,
.off-canvas-sidebar[data-color=white] .logo:after {
  background-color: #66615B;
  opacity: 0.4;
}
.sidebar[data-color=white] .user .info a span,
.sidebar[data-color=white] .user .nav .sidebar-mini-icon,
.sidebar[data-color=white] .user .nav .sidebar-normal,
.off-canvas-sidebar[data-color=white] .user .info a span,
.off-canvas-sidebar[data-color=white] .user .nav .sidebar-mini-icon,
.off-canvas-sidebar[data-color=white] .user .nav .sidebar-normal {
  color: #66615B !important;
}
.sidebar[data-color=white] .user:after,
.off-canvas-sidebar[data-color=white] .user:after {
  background-color: #66615B;
  opacity: 0.4;
}
.sidebar[data-color=brown]:after,
.off-canvas-sidebar[data-color=brown]:after {
  background: #66615B;
}
.sidebar[data-active-color=primary] .nav li.active > a, .sidebar[data-active-color=primary] .nav li.active > a i, .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #51cbce;
  opacity: 1;
}
.sidebar[data-active-color=info] .nav li.active > a, .sidebar[data-active-color=info] .nav li.active > a i, .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #51bcda;
  opacity: 1;
}
.sidebar[data-active-color=success] .nav li.active > a, .sidebar[data-active-color=success] .nav li.active > a i, .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #6bd098;
  opacity: 1;
}
.sidebar[data-active-color=warning] .nav li.active > a, .sidebar[data-active-color=warning] .nav li.active > a i, .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #fbc658;
  opacity: 1;
}
.sidebar[data-active-color=danger] .nav li.active > a, .sidebar[data-active-color=danger] .nav li.active > a i, .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #ef8157;
  opacity: 1;
}
.sidebar .user,
.off-canvas-sidebar .user {
  padding-bottom: 20px;
  margin: 20px auto 0;
  position: relative;
}
.sidebar .user:after,
.off-canvas-sidebar .user:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.3);
}
.sidebar .user .photo,
.off-canvas-sidebar .user .photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  float: left;
  z-index: 5;
  margin-right: 10px;
  border-radius: 50%;
  margin-left: 23px;
}
.sidebar .user .photo img,
.off-canvas-sidebar .user .photo img {
  width: 100%;
}
.sidebar .user a,
.off-canvas-sidebar .user a {
  color: #FFFFFF;
  text-decoration: none;
  padding: 0.5rem 15px;
  white-space: nowrap;
}
.sidebar .user .info > a,
.off-canvas-sidebar .user .info > a {
  display: block;
  line-height: 18px;
}
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span {
  display: block;
  position: relative;
  opacity: 1;
}
.sidebar .user .info .caret,
.off-canvas-sidebar .user .info .caret {
  position: absolute;
  top: 8px;
  right: 18px;
}

.visible-on-sidebar-regular {
  display: inline-block !important;
}

.visible-on-sidebar-mini {
  display: none !important;
}

.off-canvas-sidebar .nav > li > a,
.off-canvas-sidebar .nav > li > a:hover {
  color: #FFFFFF;
}
.off-canvas-sidebar .nav > li > a:focus {
  background: rgba(200, 200, 200, 0.2);
}

.main-panel {
  position: relative;
  float: right;
  width: calc(100% - 260px);
  background-color: #f4f3ef;
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.main-panel > .content {
  padding: 0 30px 30px;
  min-height: calc(100vh - 123px);
  margin-top: 93px;
}
.main-panel > .navbar {
  margin-bottom: 0;
}
.main-panel .header {
  margin-bottom: 50px;
}

.perfect-scrollbar-on .sidebar,
.perfect-scrollbar-on .main-panel {
  height: 100%;
  max-height: 100%;
}

@media (min-width: 991px) {
  .sidebar,
  .main-panel,
  .sidebar-wrapper {
    transition-property: top, bottom, width;
    transition-duration: 0.2s, 0.2s, 0.35s;
    transition-timing-function: linear, linear, ease;
    -webkit-overflow-scrolling: touch;
  }
  .sidebar-mini .visible-on-sidebar-regular {
    display: none !important;
  }
  .sidebar-mini .visible-on-sidebar-mini {
    display: inline-block !important;
  }
  .sidebar-mini .sidebar,
  .sidebar-mini .sidebar .sidebar-wrapper {
    width: 80px;
  }
  .sidebar-mini .main-panel {
    width: calc(100% - 80px);
  }
  .sidebar-mini .sidebar {
    display: block;
    z-index: 1030;
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
    transform: translate3d(-25px, 0, 0);
  }
  .sidebar-mini .sidebar .logo a.logo-mini {
    opacity: 1;
  }
  .sidebar-mini .sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar:hover {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .logo a.logo-normal {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  .sidebar-mini .sidebar:hover .navbar-minimize {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {
    transform: translate3d(0px, 0, 0);
    opacity: 1;
  }
}
.panel-header {
  height: 260px;
  padding-top: 80px;
  padding-bottom: 45px;
  background: #141E30; /* fallback for old browsers */
  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);
  position: relative;
  overflow: hidden;
}
.panel-header .header .title {
  color: #FFFFFF;
}
.panel-header .header .category {
  max-width: 600px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 auto;
  font-size: 13px;
}
.panel-header .header .category a {
  color: #FFFFFF;
}

.panel-header-sm {
  height: 135px;
}

.panel-header-lg {
  height: 380px;
}

.sidebar .logo .simple-text .logo-img {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  background: #FFFFFF;
  border-radius: 50%;
  text-align: center;
  overflow: hidden;
}
.sidebar .logo .simple-text .logo-img img {
  width: 51%;
  vertical-align: baseline;
  vertical-align: initial;
  height: 55px;
}

.sidebar[data-color=white] {
  border-right: 1px solid #ddd;
}

.card-timeline .timeline {
  list-style: none;
  padding: 20px 0 20px;
  position: relative;
}
.card-timeline .timeline:before {
  top: 0;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 3px;
  background-color: #dbdbdb;
  left: 50%;
  margin-left: -1.5px;
}
.card-timeline .timeline .timeline-footer .btn {
  margin: 0;
}
.card-timeline .timeline h6 {
  color: #9A9A9A;
  font-weight: 400;
  margin: 10px 0px 0px;
}
.card-timeline .timeline.timeline-simple:before {
  left: 5%;
}
.card-timeline .timeline.timeline-simple > li > .timeline-panel {
  width: 86%;
}
.card-timeline .timeline.timeline-simple > li > .timeline-badge {
  left: 5%;
}
.card-timeline .timeline > li {
  margin-bottom: 20px;
  position: relative;
}
.card-timeline .timeline > li:before, .card-timeline .timeline > li:after {
  content: " ";
  display: table;
}
.card-timeline .timeline > li:after {
  clear: both;
}
.card-timeline .timeline > li > .timeline-panel {
  width: 45%;
  float: left;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  background-color: #FFFFFF;
  color: #2c2c2c;
  margin-bottom: 20px;
  position: relative;
}
.card-timeline .timeline > li > .timeline-panel:before {
  position: absolute;
  top: 26px;
  right: -15px;
  display: inline-block;
  border-top: 15px solid transparent;
  border-left: 15px solid #E3E3E3;
  border-right: 0 solid #E3E3E3;
  border-bottom: 15px solid transparent;
  content: " ";
}
.card-timeline .timeline > li > .timeline-panel:after {
  position: absolute;
  top: 27px;
  right: -14px;
  display: inline-block;
  border-top: 14px solid transparent;
  border-left: 14px solid #FFFFFF;
  border-right: 0 solid #FFFFFF;
  border-bottom: 14px solid transparent;
  content: " ";
}
.card-timeline .timeline > li > .timeline-badge {
  color: #FFFFFF;
  width: 50px;
  height: 50px;
  text-align: center;
  position: absolute;
  top: 16px;
  left: 50%;
  margin-left: -25px;
  background-color: #9A9A9A;
  z-index: 100;
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
  border: 3px solid #f4f3ef;
}
.card-timeline .timeline > li > .timeline-badge [class^=fa-],
.card-timeline .timeline > li > .timeline-badge [class*=" fa-"] {
  line-height: inherit;
}
.card-timeline .timeline > li > .timeline-badge .nc-icon {
  line-height: 2.1;
  width: 25px;
  text-align: center;
  font-size: 21px;
}
.card-timeline .timeline > li.timeline-inverted > .timeline-panel {
  float: right;
  background-color: #fff;
}
.card-timeline .timeline > li.timeline-inverted > .timeline-panel:before {
  border-left-width: 0;
  border-right-width: 15px;
  left: -15px;
  right: auto;
}
.card-timeline .timeline > li.timeline-inverted > .timeline-panel:after {
  border-left-width: 0;
  border-right-width: 14px;
  left: -14px;
  right: auto;
}
.card-timeline .timeline-heading {
  margin-bottom: 15px;
}
.card-timeline .timeline-badge.primary {
  background-color: #51bcda !important;
}
.card-timeline .timeline-badge.info {
  background-color: #51bcda !important;
}
.card-timeline .timeline-badge.success {
  background-color: #6bd098 !important;
}
.card-timeline .timeline-badge.warning {
  background-color: #fbc658 !important;
}
.card-timeline .timeline-badge.danger {
  background-color: #ef8157 !important;
}
.card-timeline .timeline-title {
  margin-top: 0;
  color: inherit;
}
.card-timeline .timeline-body > p,
.card-timeline .timeline-body > ul {
  margin-bottom: 0;
}
.card-timeline .timeline-body > p + p {
  margin-top: 5px;
}

.card {
  border-radius: 12px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
  background-color: #FFFFFF;
  color: #252422;
  margin-bottom: 20px;
  position: relative;
  border: 0 none;
  transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;
}
.card .card-body {
  padding: 15px 15px 10px 15px;
}
.card .card-body.table-full-width {
  padding-left: 0;
  padding-right: 0;
}
.card .card-header {
  padding: 15px 15px 0;
  border: 0;
}
.card .card-header:not([data-background-color]) {
  background-color: transparent;
}
.card .card-header .card-title {
  margin-top: 10px;
}
.card .map {
  border-radius: 3px;
}
.card .map.map-big {
  height: 400px;
}
.card[data-background-color=orange] {
  background-color: #51cbce;
}
.card[data-background-color=orange] .card-header {
  background-color: #51cbce;
}
.card[data-background-color=orange] .card-footer .stats {
  color: #FFFFFF;
}
.card[data-background-color=red] {
  background-color: #ef8157;
}
.card[data-background-color=yellow] {
  background-color: #fbc658;
}
.card[data-background-color=blue] {
  background-color: #51bcda;
}
.card[data-background-color=green] {
  background-color: #6bd098;
}
.card .image {
  overflow: hidden;
  height: 200px;
  position: relative;
}
.card .avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 15px;
}
.card .numbers {
  font-size: 2em;
}
.card .big-title {
  font-size: 12px;
  text-align: center;
  font-weight: 500;
  padding-bottom: 15px;
}
.card label {
  font-size: 0.8571em;
  margin-bottom: 5px;
  color: #9A9A9A;
}
.card .card-footer {
  background-color: transparent;
  border: 0;
}
.card .card-footer .stats i {
  margin-right: 5px;
  position: relative;
  top: 0px;
  color: #66615B;
}
.card .card-footer .btn {
  margin: 0;
}
.card.card-plain {
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
}
.card.card-plain .card-body {
  padding-left: 5px;
  padding-right: 5px;
}
.card.card-plain img {
  border-radius: 12px;
}

.card-chart .card-header .card-title {
  margin-top: 10px;
  margin-bottom: 0;
}
.card-chart .card-header .card-category {
  margin-bottom: 5px;
}
.card-chart .table {
  margin-bottom: 0;
}
.card-chart .table td {
  border-top: none;
  border-bottom: 1px solid #e9ecef;
}
.card-chart .card-progress {
  margin-top: 30px;
}
.card-chart .chart-area {
  height: 190px;
  width: calc(100% + 30px);
  margin-left: -15px;
  margin-right: -15px;
}
.card-chart .card-footer {
  margin-top: 15px;
}
.card-chart .card-footer .stats {
  color: #9A9A9A;
}
.card-chart .dropdown {
  position: absolute;
  right: 20px;
  top: 20px;
}
.card-chart .dropdown .btn {
  margin: 0;
}

.map {
  height: 500px;
}

.card-user .image {
  height: 130px;
}
.card-user .image img {
  border-radius: 12px;
}
.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: -77px;
}
.card-user .author a + p.description {
  margin-top: -7px;
}
.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 1px solid #FFFFFF;
  position: relative;
}
.card-user .card-body {
  min-height: 240px;
}
.card-user hr {
  margin: 5px 15px 15px;
}
.card-user .card-body + .card-footer {
  padding-top: 0;
}
.card-user .card-footer h5 {
  font-size: 1.25em;
  margin-bottom: 0;
}
.card-user .button-container {
  margin-bottom: 6px;
  text-align: center;
}

.card-background {
  background-position: center center;
  background-size: cover;
  text-align: center;
}
.card-background .card-body {
  position: relative;
  z-index: 2;
  min-height: 370px;
  max-width: 530px;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 60px;
}
.card-background .card-footer {
  position: relative;
  z-index: 2;
}
.card-background.card-background-product .card-body {
  max-width: 400px;
}
.card-background.card-background-product .card-body .card-title {
  margin-top: 30px;
}
.card-background .stats {
  color: #FFFFFF;
}
.card-background .card-footer .stats-link > a {
  color: #FFFFFF;
  line-height: 1.9;
}
.card-background .category,
.card-background .card-description,
.card-background small {
  color: rgba(255, 255, 255, 0.8);
}
.card-background .card-title {
  color: #FFFFFF;
  margin-top: 130px;
}
.card-background:not(.card-pricing) .btn {
  margin-bottom: 0;
}
.card-background::after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.63);
  border-radius: 6px;
}

.card-collapse {
  padding-bottom: 10px;
}
.card-collapse .card {
  margin-bottom: 0px;
}
.card-collapse .card .card-header {
  position: relative;
  padding: 20px 0;
}
.card-collapse .card .card-header a[data-toggle=collapse] {
  display: block;
  color: #444;
}
.card-collapse .card .card-header a[data-toggle=collapse] i {
  float: right;
  position: relative;
  color: #f96332;
  top: 3px;
  right: 5px;
}
.card-collapse .card .card-header:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #E3E3E3;
}
.card-collapse .card .card-body {
  padding: 20px 15px;
}

.card-contributions .card-description {
  max-width: 350px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.card-contributions .card-title {
  padding-top: 35px;
}
.card-contributions .card-stats {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 11px;
}
.card-contributions .card-footer [class*=col-]:not(:first-child):before {
  content: "";
  position: absolute;
  left: 0;
  width: 1px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}
.card-contributions .bootstrap-switch {
  margin: 0;
}
.card-contributions span {
  padding-left: 15px;
  text-align: left;
  max-width: 125px;
}

.card .info-area {
  padding: 40px 0 40px;
  text-align: center;
  position: relative;
  z-index: 2;
}

.card-lock .card-header img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-top: -70px;
}

.card-pricing {
  text-align: center;
}
.card-pricing .card-body {
  padding: 15px !important;
}
.card-pricing .card-category {
  margin: 10px 0 10px;
  color: #2c2c2c;
}
.card-pricing .card-icon {
  padding: 15px 0 5px;
  transform: translateY(0%);
  color: #2c2c2c;
}
.card-pricing .card-icon.icon-info {
  color: #51bcda;
}
.card-pricing .card-icon.icon-danger {
  color: #ef8157;
}
.card-pricing .card-icon.icon-primary {
  color: #51cbce;
}
.card-pricing .card-icon.icon-success {
  color: #6bd098;
}
.card-pricing .card-icon.icon-warning {
  color: #fbc658;
}
.card-pricing .card-icon i {
  font-size: 40px;
  width: 105px;
  border: 2px solid #ccc;
  border-radius: 50%;
  height: 105px;
  line-height: 105px;
}
.card-pricing .card-title {
  margin-top: 30px !important;
}
.card-pricing ul {
  list-style: none;
  padding: 0;
  max-width: 240px;
  margin: 20px auto;
}
.card-pricing ul li {
  padding: 5px 0;
  list-style-type: none;
}
.card-pricing ul li b {
  font-weight: 600;
  color: #2c2c2c;
}
.card-pricing .btn-neutral {
  color: #66615B;
}
.card-pricing .btn-neutral:hover, .card-pricing .btn-neutral :focus {
  color: #403D39;
}
.card-pricing.card-background-image ul li {
  color: #FFFFFF;
  text-align: center;
  border-color: rgba(255, 255, 255, 0.3);
}
.card-pricing.card-background-image ul li b {
  color: #FFFFFF !important;
}
.card-pricing.card-background-image .card-description {
  color: #FFFFFF !important;
}
.card-pricing.card-background-image .card-title small {
  color: rgba(255, 255, 255, 0.6);
}

.card-pricing.card-plain .card-category,
.card-pricing.card-plain .card-title {
  color: #2c2c2c;
}
.card-pricing.card-plain ul li b {
  font-weight: 600;
  color: #2c2c2c;
}

.card[data-background=image] .card-icon i,
.card[data-background=color] .card-icon i,
.card[data-color] .card-icon i {
  color: #FFFFFF;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.card-profile {
  margin-top: 30px;
  text-align: center;
}
.card-profile .card-body .card-title {
  margin-top: 0;
}
.card-profile [class*=col-] .card-description {
  margin-bottom: 0;
}
.card-profile [class*=col-] .card-description + .card-footer {
  margin-top: 8px;
}
.card-profile .card-header-avatar {
  max-width: 130px;
  max-height: 130px;
  margin: -60px auto 0;
}
.card-profile .card-header-avatar img {
  border-radius: 50% !important;
}
.card-profile .card-header-avatar + .card-body {
  margin-top: 15px;
}
.card-plain.card-profile .card-header-avatar {
  margin-top: 0;
}
.card-profile .card-body .card-avatar {
  margin: 0 auto 30px;
}

.card-signup .header {
  margin-left: 20px;
  margin-right: 20px;
  padding: 30px 0;
}
.card-signup .text-divider {
  margin-top: 30px;
  margin-bottom: 0px;
  text-align: center;
}
.card-signup .content {
  padding: 0px 30px;
}
.card-signup .form-check {
  margin-top: 20px;
}
.card-signup .form-check label {
  margin-left: 7px;
  padding-left: 38px;
}
.card-signup .social-line {
  margin-top: 20px;
  text-align: center;
}
.card-signup .social-line .btn.btn-icon,
.card-signup .social-line .btn.btn-icon .btn-icon {
  margin-left: 5px;
  margin-right: 5px;
  box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);
}
.card-signup .card-footer {
  margin-bottom: 10px;
  margin-top: 24px;
}

.card-stats-mini.card-background::after {
  background-image: linear-gradient(to right, #434343 0%, black 100%);
  opacity: 0.94;
}
.card-stats-mini .card-body::after {
  clear: both;
  content: "";
  display: block;
}
.card-stats-mini .card-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin: 0 15px;
}
.card-stats-mini.card-background .card-body {
  min-height: auto;
  padding-top: 15px;
  padding-bottom: 15px;
}
.card-stats-mini .card-title {
  margin-top: 0;
  margin-bottom: 5px;
}
.card-stats-mini .info-area {
  text-align: left;
  width: 40%;
  float: left;
  padding: 15px 0;
}
.card-stats-mini .info-area .icon > i {
  font-size: 2em;
}
.card-stats-mini .chart-area {
  float: left;
  width: 60%;
}
.card-stats-mini .stats {
  text-align: left;
  color: #FFFFFF;
}

.card-contributions hr {
  margin: 5px 15px;
}

.card-stats .card-body {
  padding: 15px 15px 0px;
}
.card-stats .card-body .numbers {
  text-align: right;
  font-size: 2em;
}
.card-stats .card-body .numbers p {
  margin-bottom: 0;
}
.card-stats .card-body .numbers .card-category {
  color: #9A9A9A;
  font-size: 16px;
  line-height: 1.4em;
}
.card-stats .card-footer {
  padding: 0px 15px 15px;
}
.card-stats .card-footer .stats {
  color: #9A9A9A;
}
.card-stats .card-footer hr {
  margin-top: 10px;
  margin-bottom: 15px;
}
.card-stats .icon-big {
  font-size: 3em;
  min-height: 64px;
}
.card-stats .icon-big i {
  line-height: 59px;
}

.card-subcategories .card-body {
  padding-bottom: 30px;
}

.card-testimonial {
  margin-top: 30px;
  text-align: center;
}
.card-testimonial .icon {
  padding: 0;
}
.card-testimonial .icon i {
  font-size: 30px;
  border: 0;
  display: block;
  line-height: 100px;
  margin: 0px auto;
  margin-bottom: 0px;
}
.card-testimonial .card-body {
  padding: 15px 30px;
}
.card-testimonial .card-body .card-description {
  font-style: italic;
  font-size: 16px;
}
.card-testimonial .card-body .card-category {
  margin-bottom: 20px;
}
.card-testimonial .card-body + .card-footer {
  padding-top: 0;
  margin-top: -20px;
}
.card-testimonial .card-avatar {
  margin-top: 0;
}
.card-testimonial .card-avatar .img {
  border-radius: 50%;
  width: 100px;
  height: 100px;
}
.card-testimonial .card-footer .card-title {
  color: #2c2c2c;
  text-align: center;
}
.card-testimonial .card-footer .card-category {
  color: #9A9A9A;
}
.card-testimonial .card-footer .card-avatar {
  margin-top: 20px;
}
.card-testimonial .card-footer .card-avatar .img {
  border-radius: 50%;
  width: 60px;
  height: 60px;
}

.card-testimonial .card-description + .card-title {
  margin-top: 30px;
}
.card-testimonial .card-description + .card-title .card-image .img {
  border-radius: 12px;
}
.card-testimonial .card-description + .card-title .card-image .card-title {
  text-align: center;
}

.card-tasks {
  text-align: left;
}
.card-tasks .table tbody td:last-child {
  padding-right: 0;
  display: inline-flex;
}
.card-tasks .table tbody td:last-child .btn {
  padding: 3px;
}
.card-tasks .table tbody td:first-child {
  padding-left: 0;
}
.card-tasks .table tbody td {
  padding: 12px 8px !important;
}
.card-tasks .table-full-width {
  padding-bottom: 0 !important;
}
.card-tasks .card-footer {
  padding-top: 0;
}
.card-tasks .table {
  margin-bottom: 0 !important;
}

.login-page .content .container {
  margin-top: 8vh;
}
.login-page .card-login {
  border-radius: 6px;
  padding-bottom: 0.7rem;
}
.login-page .card-login .btn-wd {
  min-width: 180px;
}
.login-page .card-login .logo-container {
  width: 65px;
  margin: 0 auto;
  margin-bottom: 55px;
}
.login-page .card-login .logo-container img {
  width: 100%;
}
.login-page .card-login .input-group:last-child {
  margin-bottom: 40px;
}
.login-page .card-login.card-plain .form-control::-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-ms-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-control:focus {
  border-color: #FFFFFF;
  background-color: transparent;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .has-success:after,
.login-page .card-login.card-plain .has-danger:after {
  color: #FFFFFF;
}
.login-page .card-login.card-plain .has-danger .form-control {
  background-color: transparent;
}
.login-page .card-login.card-plain .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group-append .input-group-text {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .input-group-focus .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group-focus .input-group-append .input-group-text {
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control,
.login-page .card-login.card-plain .input-group.no-border .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus, .login-page .card-login.card-plain .form-group.no-border .form-control:active, .login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
}
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .login-page .card-login.card-plain .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .form-group.no-border .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .input-group-addon,
.login-page .card-login.card-plain .form-group.no-border .input-group-addon,
.login-page .card-login.card-plain .input-group.no-border .input-group-addon {
  color: rgba(255, 255, 255, 0.8);
}
.login-page .link {
  font-size: 10px;
  color: #FFFFFF;
  text-decoration: none;
}

.full-page > .content, .full-page > .footer {
  position: relative;
  z-index: 4;
}
.full-page.section-image {
  position: static;
  position: initial;
}
.full-page > .content {
  padding-top: 21vh;
}
.full-page .footer {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.full-page .footer .container {
  color: #FFFFFF;
}
.full-page .full-page-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.full-page:after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.6);
}
.full-page.pricing-page .description {
  margin-bottom: 65px;
}
.full-page.register-page .content > .container {
  margin-top: 5vh;
}
.full-page.register-page .info-horizontal {
  padding: 0px 0px 20px;
}
.full-page.register-page .info-horizontal {
  text-align: left !important;
}
.full-page.register-page .info-horizontal .icon {
  margin-top: 0;
}
.full-page.register-page .info-horizontal .icon > i {
  font-size: 2em;
}
.full-page.register-page .info-horizontal .icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin-top: 8px;
}
.full-page.register-page .info-horizontal .icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 3.5;
  font-size: 1.9em;
}
.full-page.register-page .info-horizontal .description {
  overflow: hidden;
}
.full-page.lock-page .content > .container {
  margin-top: 10vh;
}

.register-page .navbar .navbar-collapse .nav-item .nav-link,
.login-page .navbar .navbar-collapse .nav-item .nav-link,
.lock-page .navbar .navbar-collapse .nav-item .nav-link {
  text-transform: capitalize;
  color: #FFFFFF !important;
}
.register-page .navbar.navbar-transparent,
.login-page .navbar.navbar-transparent,
.lock-page .navbar.navbar-transparent {
  border-bottom: 1px solid transparent;
  margin-top: 25px;
}
.register-page .navbar .navbar-brand,
.login-page .navbar .navbar-brand,
.lock-page .navbar .navbar-brand {
  color: #FFFFFF !important;
}

@media screen and (max-width: 991px) {
  .register-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,
  .login-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,
  .lock-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab {
    background: #66615B !important;
  }
  .register-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,
  .login-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,
  .lock-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link {
    color: #66615B !important;
  }
  .register-page .navbar.bg-white .navbar-brand,
  .login-page .navbar.bg-white .navbar-brand,
  .lock-page .navbar.bg-white .navbar-brand {
    color: #66615B !important;
  }
  .register-page .navbar.navbar-transparent .navbar-toggle,
  .login-page .navbar.navbar-transparent .navbar-toggle,
  .lock-page .navbar.navbar-transparent .navbar-toggle {
    display: none;
  }
  .register-page .navbar.navbar-transparent .navbar-toggler .navbar-toggler-bar.navbar-kebab,
  .login-page .navbar.navbar-transparent .navbar-toggler .navbar-toggler-bar.navbar-kebab,
  .lock-page .navbar.navbar-transparent .navbar-toggler .navbar-toggler-bar.navbar-kebab {
    background: #FFFFFF !important;
  }
}
.section {
  padding: 70px 0;
  position: relative;
  background: #FFFFFF;
}
.section .row + .category {
  margin-top: 15px;
}

.section-navbars {
  padding-bottom: 0;
}

.section-full-screen {
  height: 100vh;
}

.section-signup {
  padding-top: 20vh;
}

.parallax-s {
  overflow: hidden;
  height: 500px;
  width: 100%;
}

.section-image {
  background-size: cover;
  background-position: center center;
  position: relative;
  width: 100%;
}
.section-image .title,
.section-image .card-plain .card-title {
  color: #FFFFFF;
}
.section-image .nav-pills .nav-link {
  background-color: #FFFFFF;
}
.section-image .nav-pills .nav-link:hover, .section-image .nav-pills .nav-link:focus {
  background-color: #FFFFFF;
}
.section-image .info-title,
.section-image .info-area.info-horizontal .icon i,
.section-image .card-pricing.card-plain ul li {
  color: #FFFFFF;
}
.section-image .description,
.section-image .info-area .icon:not(.icon-circle) {
  color: rgba(255, 255, 255, 0.8);
}
.section-image .card:not(.card-plain) .info-title {
  color: #2c2c2c;
}
.section-image .card:not(.card-plain) .info-area p,
.section-image .card:not(.card-plain) .info-area .icon,
.section-image .card:not(.card-plain) .description {
  color: #9A9A9A;
}
.section-image .footer {
  color: #FFFFFF;
}
.section-image .card-plain [class*=text-],
.section-image .card-plain ul li b {
  color: #FFFFFF;
}
.section-image .card-plain .category {
  color: rgba(255, 255, 255, 0.5);
}
.section-image:after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.7);
}
.section-image .container {
  z-index: 2;
  position: relative;
}

.page-header {
  min-height: 100vh;
  max-height: 999px;
  padding: 0;
  color: #FFFFFF;
  position: relative;
}
.page-header .page-header-image {
  position: absolute;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.page-header .content-center {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #FFFFFF;
  padding: 0 15px;
  width: 100%;
  max-width: 880px;
}
.page-header footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.page-header .container {
  height: 100%;
  z-index: 1;
}
.page-header .category,
.page-header .description {
  color: rgba(255, 255, 255, 0.8);
}
.page-header.page-header-small {
  min-height: 60vh;
  max-height: 440px;
}
.page-header.page-header-mini {
  min-height: 40vh;
  max-height: 340px;
}
.page-header .title {
  margin-bottom: 15px;
}
.page-header .title + h4 {
  margin-top: 10px;
}
.page-header:after, .page-header:before {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
}
.page-header:before {
  background-color: rgba(0, 0, 0, 0.3);
}
.page-header[filter-color=orange] {
  background: rgba(44, 44, 44, 0.2); /* For browsers that do not support gradients */ /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(0deg, rgba(44, 44, 44, 0.2), rgba(224, 23, 3, 0.6)); /* Standard syntax */
}

.clear-filter:after, .clear-filter:before {
  display: none;
}

.section-story-overview {
  padding: 50px 0;
}
.section-story-overview .image-container {
  height: 335px;
  position: relative;
  background-position: center center;
  background-size: cover;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
  border-radius: 0.25rem;
}
.section-story-overview .image-container + .category {
  padding-top: 15px;
}
.section-story-overview .image-container.image-right {
  z-index: 2;
}
.section-story-overview .image-container.image-right + h3.title {
  margin-top: 120px;
}
.section-story-overview .image-container.image-left {
  z-index: 1;
}
.section-story-overview .image-container img {
  width: 100%;
  left: 0;
  top: 0;
  height: auto;
  position: absolute;
}
.section-story-overview .image-container:nth-child(2) {
  margin-top: 420px;
  margin-left: -105px;
}
.section-story-overview p.blockquote {
  width: 220px;
  min-height: 180px;
  text-align: left;
  position: absolute;
  top: 376px;
  right: 155px;
  z-index: 0;
}

.section-nucleo-icons .nucleo-container img {
  width: auto;
  left: 0;
  top: 0;
  height: 100%;
  position: absolute;
}
.section-nucleo-icons .nucleo-container {
  height: 335px;
  position: relative;
}
.section-nucleo-icons h5 {
  margin-bottom: 35px;
}
.section-nucleo-icons .icons-container {
  position: relative;
  max-width: 450px;
  height: 300px;
  max-height: 300px;
  margin: 0 auto;
}
.section-nucleo-icons .icons-container i {
  font-size: 34px;
  position: absolute;
  left: 0;
  top: 0;
}
.section-nucleo-icons .icons-container i:nth-child(1) {
  top: 5%;
  left: 7%;
}
.section-nucleo-icons .icons-container i:nth-child(2) {
  top: 28%;
  left: 24%;
}
.section-nucleo-icons .icons-container i:nth-child(3) {
  top: 40%;
}
.section-nucleo-icons .icons-container i:nth-child(4) {
  top: 18%;
  left: 62%;
}
.section-nucleo-icons .icons-container i:nth-child(5) {
  top: 74%;
  left: 3%;
}
.section-nucleo-icons .icons-container i:nth-child(6) {
  top: 36%;
  left: 44%;
  font-size: 65px;
  color: #f96332;
  padding: 1px;
}
.section-nucleo-icons .icons-container i:nth-child(7) {
  top: 59%;
  left: 26%;
}
.section-nucleo-icons .icons-container i:nth-child(8) {
  top: 60%;
  left: 69%;
}
.section-nucleo-icons .icons-container i:nth-child(9) {
  top: 72%;
  left: 47%;
}
.section-nucleo-icons .icons-container i:nth-child(10) {
  top: 88%;
  left: 27%;
}
.section-nucleo-icons .icons-container i:nth-child(11) {
  top: 31%;
  left: 80%;
}
.section-nucleo-icons .icons-container i:nth-child(12) {
  top: 88%;
  left: 68%;
}
.section-nucleo-icons .icons-container i:nth-child(13) {
  top: 5%;
  left: 81%;
}
.section-nucleo-icons .icons-container i:nth-child(14) {
  top: 58%;
  left: 90%;
}
.section-nucleo-icons .icons-container i:nth-child(15) {
  top: 6%;
  left: 40%;
}

.section-images {
  max-height: 670px;
  height: 670px;
}
.section-images .hero-images-container,
.section-images .hero-images-container-1,
.section-images .hero-images-container-2 {
  margin-top: -38vh;
}
.section-images .hero-images-container {
  max-width: 670px;
}
.section-images .hero-images-container-1 {
  max-width: 390px;
  position: absolute;
  top: 55%;
  right: 18%;
}
.section-images .hero-images-container-2 {
  max-width: 225px;
  position: absolute;
  top: 68%;
  right: 12%;
}

[data-background-color=gray] {
  background-color: #cac7c3;
}

[data-background-color=orange] {
  background-color: #e95e38;
}

[data-background-color=black] {
  background-color: #2c2c2c;
}

[data-background-color]:not([data-background-color=gray]) {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .separator-line {
  background-color: rgba(255, 255, 255, 0.5);
}
[data-background-color]:not([data-background-color=gray]) .footer.footer-white .footer-brand, [data-background-color]:not([data-background-color=gray]) .footer.footer-white ul li > a.nav-link:not(.btn-icon) {
  color: #000;
  color: initial;
}
[data-background-color]:not([data-background-color=gray]) .pagination .page-item.disabled > .page-link {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .category,
[data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .card-description, [data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .category, [data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .category {
  color: #9A9A9A;
}
[data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .card-title, [data-background-color]:not([data-background-color=gray]) .card:not(.card-plain) .card-title {
  color: #000;
  color: initial;
}
[data-background-color]:not([data-background-color=gray]) .carousel .carousel-inner {
  box-shadow: none;
}
[data-background-color]:not([data-background-color=gray]) .title,
[data-background-color]:not([data-background-color=gray]) .social-description h2,
[data-background-color]:not([data-background-color=gray]) p,
[data-background-color]:not([data-background-color=gray]) p.blockquote,
[data-background-color]:not([data-background-color=gray]) p.blockquote small,
[data-background-color]:not([data-background-color=gray]) h1, [data-background-color]:not([data-background-color=gray]) h2, [data-background-color]:not([data-background-color=gray]) h3, [data-background-color]:not([data-background-color=gray]) h4, [data-background-color]:not([data-background-color=gray]) h5, [data-background-color]:not([data-background-color=gray]) h6,
[data-background-color]:not([data-background-color=gray]) a:not(.btn):not(.dropdown-item):not(.card-link),
[data-background-color]:not([data-background-color=gray]) .icons-container i, [data-background-color]:not([data-background-color=gray]).card-pricing ul li,
[data-background-color]:not([data-background-color=gray]) .info.info-horizontal .icon i,
[data-background-color]:not([data-background-color=gray]) .card-pricing.card-plain ul li {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]).card a:not(.btn):not(.dropdown-item) {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]).card a:not(.btn):not(.dropdown-item):hover, [data-background-color]:not([data-background-color=gray]).card a:not(.btn):not(.dropdown-item):focus {
  border-color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]).footer hr, [data-background-color]:not([data-background-color=gray]).card-pricing .icon i, [data-background-color]:not([data-background-color=gray]).card-pricing ul li {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color=gray]) .card-footer .stats i, [data-background-color]:not([data-background-color=gray]).card-plain .category,
[data-background-color]:not([data-background-color=gray]) .card-plain .category,
[data-background-color]:not([data-background-color=gray]) .card-header:after {
  color: rgba(255, 255, 255, 0.5);
}
[data-background-color]:not([data-background-color=gray]).card-pricing ul li i, [data-background-color]:not([data-background-color=gray]).card-pricing ul li b,
[data-background-color]:not([data-background-color=gray]) .card-pricing.card-plain ul li b,
[data-background-color]:not([data-background-color=gray]) .card-category,
[data-background-color]:not([data-background-color=gray]) .author span,
[data-background-color]:not([data-background-color=gray]) .card-pricing.card-plain ul li i {
  color: rgba(255, 255, 255, 0.8) !important;
}
[data-background-color]:not([data-background-color=gray]) .separator {
  background-color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .navbar.bg-white p {
  color: #66615B;
}
[data-background-color]:not([data-background-color=gray]) .description,
[data-background-color]:not([data-background-color=gray]) .social-description p {
  color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color=gray]) p.blockquote {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color=gray]) .checkbox label::before,
[data-background-color]:not([data-background-color=gray]) .checkbox label::after,
[data-background-color]:not([data-background-color=gray]) .radio label::before,
[data-background-color]:not([data-background-color=gray]) .radio label::after {
  border-color: rgba(255, 255, 255, 0.2);
}
[data-background-color]:not([data-background-color=gray]) .checkbox label::after,
[data-background-color]:not([data-background-color=gray]) .checkbox label,
[data-background-color]:not([data-background-color=gray]) .radio label {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .checkbox input[type=checkbox]:disabled + label,
[data-background-color]:not([data-background-color=gray]) .radio input[type=radio]:disabled + label {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .radio input[type=radio]:not(:disabled):hover + label::after,
[data-background-color]:not([data-background-color=gray]) .radio input[type=radio]:checked + label::after {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-control::-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control:-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control::-webkit-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control:-ms-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
[data-background-color]:not([data-background-color=gray]) .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-control:focus {
  border-color: #FFFFFF;
  background-color: transparent;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .has-success:after,
[data-background-color]:not([data-background-color=gray]) .has-danger:after {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .has-danger .form-control {
  background-color: transparent;
}
[data-background-color]:not([data-background-color=gray]) .input-group-prepend .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group-append .input-group-text {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .input-group-focus .input-group-prepend .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group-focus .input-group-append .input-group-text {
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:focus, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:active, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:focus,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-prepend .input-group-text,
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-append .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-prepend .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-append .input-group-text:active,
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control + .input-group-append .input-group-text:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-append .input-group-text:active,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, [data-background-color]:not([data-background-color=gray]) .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .input-group-prepend .input-group-text,
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .input-group-append .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .input-group-prepend .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
[data-background-color]:not([data-background-color=gray]) .form-group.no-border.input-group-focus .input-group-append .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .input-group-addon,
[data-background-color]:not([data-background-color=gray]) .form-group.no-border .input-group-addon,
[data-background-color]:not([data-background-color=gray]) .input-group.no-border .input-group-addon {
  color: rgba(255, 255, 255, 0.8);
}
[data-background-color]:not([data-background-color=gray]) .subscribe-line .form-control {
  background-color: transparent;
  border: 1px solid #E3E3E3;
  color: #2c2c2c;
}
[data-background-color]:not([data-background-color=gray]) .subscribe-line .form-control:last-child {
  border-left: 0 none;
}
[data-background-color]:not([data-background-color=gray]) .subscribe-line .input-group-addon,
[data-background-color]:not([data-background-color=gray]) .subscribe-line .form-group.no-border .input-group-addon,
[data-background-color]:not([data-background-color=gray]) .subscribe-line .input-group.no-border .input-group-addon {
  color: #555555;
  border: 1px solid #E3E3E3;
}
[data-background-color]:not([data-background-color=gray]) .btn.btn-simple {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .btn.btn-simple:hover, [data-background-color]:not([data-background-color=gray]) .btn.btn-simple:hover, [data-background-color]:not([data-background-color=gray]) .btn.btn-simple:focus, [data-background-color]:not([data-background-color=gray]) .btn.btn-simple:active {
  background-color: transparent;
  border-color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]) .nav-tabs > .nav-item > .nav-link i.nc-icon {
  color: #FFFFFF;
}
[data-background-color]:not([data-background-color=gray]).section-nucleo-icons .icons-container i:nth-child(6) {
  color: #FFFFFF;
}

@media screen and (max-width: 991px) {
  .navbar {
    padding: 0;
  }
  .navbar.navbar-absolute {
    padding-top: 0;
  }
  .navbar .navbar-brand {
    font-size: 16px;
    margin-right: 0;
  }
  .profile-photo .profile-photo-small {
    margin-left: -2px;
  }
  .button-dropdown {
    display: none;
  }
  #minimizeSidebar {
    display: none;
  }
  .navbar .container-fluid {
    padding-right: 15px;
    padding-left: 15px;
  }
  .navbar .navbar-collapse .input-group {
    margin: 0;
    margin-top: 5px;
  }
  .navbar .navbar-nav .nav-item:first-child {
    margin-top: 10px;
  }
  .navbar .navbar-nav .nav-item:not(:last-child) {
    margin-bottom: 10px;
  }
  .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .navbar .dropdown.show .dropdown-menu,
  .navbar .dropdown .dropdown-menu {
    border: 0;
    transition: none;
    -webkit-box-shadow: none;
    width: auto;
    margin: 0px 1rem;
    margin-top: 0px;
    box-shadow: none;
    position: static;
    padding-left: 10px;
  }
  .navbar .dropdown.show .dropdown-menu:before,
  .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .navbar .dropdown-menu .dropdown-item:focus,
  .navbar .dropdown-menu .dropdown-item:hover {
    color: #FFFFFF;
  }
  .navbar.bg-white .dropdown-menu .dropdown-item:focus, .navbar.bg-white .dropdown-menu .dropdown-item:hover {
    color: #66615B;
  }
  .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #66615B;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {
    margin-top: 3px;
  }
  .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background-color: #66615B;
  }
  .navbar .toggled .navbar-toggler-bar {
    width: 24px;
  }
  .navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 5px;
  }
  .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .main-panel {
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .nav-open .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open body {
    position: relative;
    overflow-x: hidden;
  }
  .nav-open .menu-on-right .main-panel {
    transform: translate3d(-260px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-collapse,
  .nav-open .menu-on-right .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-translate {
    transform: translate3d(-300px, 0, 0);
  }
  .nav-open .menu-on-right #bodyClick {
    right: 260px;
    left: auto;
  }
  .menu-on-right .sidebar {
    left: auto;
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .bar1,
  .bar2,
  .bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    right: 0;
    left: 260px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .footer .copyright {
    text-align: right;
  }
  .section-nucleo-icons .icons-container {
    margin-top: 65px;
  }
  .navbar-nav .nav-link i.fa,
  .navbar-nav .nav-link i.nc-icon {
    opacity: 0.5;
  }
  .sidebar,
  .bootstrap-navbar {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    width: 260px;
    right: auto;
    left: 0;
    z-index: 1032;
    visibility: visible;
    overflow-y: visible;
    padding: 0;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(-260px, 0, 0);
  }
  .main-panel {
    width: 100%;
  }
  .timeline:before {
    left: 5% !important;
  }
  .timeline > li > .timeline-badge {
    left: 5% !important;
  }
  .timeline > li > .timeline-panel {
    float: right !important;
    width: 82% !important;
  }
  .timeline > li > .timeline-panel:before {
    border-left-width: 0 !important;
    border-right-width: 15px !important;
    left: -15px !important;
    right: auto !important;
  }
  .timeline > li > .timeline-panel:after {
    border-left-width: 0 !important;
    border-right-width: 14px !important;
    left: -14px !important;
    right: auto !important;
  }
}
@media (max-width: 991px) and (min-width: 768px) {
  .nav-tabs-navigation.verical-navs {
    padding: 0px 2px;
  }
}
@media screen and (min-width: 768px) {
  .footer .footer-nav {
    padding-left: 21px;
  }
  .footer .credits {
    padding-right: 15px;
  }
}
@media screen and (min-width: 992px) {
  .navbar-collapse {
    background: none !important;
  }
  .navbar .navbar-toggle {
    display: none;
  }
  .navbar-nav .nav-link.profile-photo {
    padding: 0;
    margin: 7px 0.7rem;
  }
  .section-nucleo-icons .icons-container {
    margin: 0 0 0 auto;
  }
  .dropdown-menu .dropdown-item {
    color: inherit;
  }
  .footer .copyright {
    float: right;
    padding-right: 15px;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=collapse]):before,
  .sidebar .sidebar-wrapper li.active > [data-toggle=collapse] + div .nav li:before {
    border-right: 17px solid #DDDDDD;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    content: "";
    display: inline-block;
    position: absolute;
    right: -16px;
    opacity: 1;
    top: 7px;
    transition: opacity 150ms ease-in;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=collapse]):after,
  .sidebar .sidebar-wrapper li.active > [data-toggle=collapse] + div .nav li:after {
    border-right: 17px solid #f4f3ef;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    content: "";
    display: inline-block;
    position: absolute;
    right: -17px;
    opacity: 1;
    top: 7px;
    transition: opacity 150ms ease-in;
  }
  .sidebar .sidebar-wrapper li.active > [data-toggle=collapse] + div .nav li a:before, .sidebar .sidebar-wrapper li.active > [data-toggle=collapse] + div .nav li a:after {
    top: 0;
  }
}
@media screen and (max-width: 768px) {
  .card-stats [class*=col-] .statistics::after {
    display: none;
  }
  .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  }
  .footer nav {
    display: block;
    margin-bottom: 5px;
    float: none;
  }
  .landing-page .section-story-overview .image-container:nth-child(2) {
    margin-left: 0;
    margin-bottom: 30px;
  }
  .card .form-horizontal .col-md-3.col-form-label {
    text-align: left;
  }
}
@media screen and (max-width: 767px) {
  .nav-tabs-navigation.verical-navs {
    padding: 0 28px;
  }
  .typography-line {
    padding-left: 23% !important;
  }
  .typography-line span {
    width: 60px !important;
  }
  .login-page .navbar,
  .lock-page .navbar,
  .register-page .navbar {
    padding: 0.5rem 1rem;
  }
  .footer .footer-nav,
  .footer .credits {
    margin: 0 auto !important;
  }
  .footer .footer-nav {
    margin-bottom: 10px !important;
  }
  .register-page .content {
    padding-top: 5vh;
  }
  .register-page .footer {
    position: relative;
  }
  .register-page .info-area.info-horizontal {
    margin-top: 0;
  }
}
@media screen and (max-width: 374px) {
  .login-page .content {
    padding-top: 10vh;
  }
}
@media screen and (max-width: 413px) {
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {
    width: 225px !important;
  }
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show[x-placement=top-start] {
    transform: translate3d(0, 400px, 0) !important;
  }
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before, .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {
    bottom: 360px !important;
  }
}
@media screen and (max-width: 576px) {
  .navbar[class*=navbar-toggleable-] .container {
    margin-left: 0;
    margin-right: 0;
  }
  .card-contributions .card-stats {
    flex-direction: column;
  }
  .card-contributions .card-stats .bootstrap-switch {
    margin-bottom: 15px;
  }
  .footer .copyright {
    text-align: center;
  }
  .section-nucleo-icons .icons-container i {
    font-size: 30px;
  }
  .section-nucleo-icons .icons-container i:nth-child(6) {
    font-size: 48px;
  }
  .page-header .container h6.category-absolute {
    width: 90%;
  }
  .card-timeline .timeline .timeline-panel {
    width: 38%;
    padding: 15px;
  }
}
.alert .close {
  font-size: 1.8rem;
  font-weight: 300;
}

/*           badges             */
.badge + .badge {
  margin-left: 5px;
}

.btn i,
.navbar .navbar-nav > a.btn i {
  margin-right: 3px;
}

.table :not(.btn-group) .btn + .btn,
.table .btn-group + .btn-group {
  margin-left: 4px;
}

.btn + .btn,
.btn-group + .btn-group {
  margin-left: 5px;
}

.card .card-footer .stats i {
  margin-right: 9px;
}
.card .card-footer .legend i {
  margin-right: 4px;
}

.dropup .dropdown-toggle:after,
.dropdown .dropdown-toggle:after {
  margin-left: 3px;
}

.login-page .card-login {
  border-radius: 6px;
  padding-bottom: 0.7rem;
}
.login-page .card-login .btn-wd {
  min-width: 180px;
}
.login-page .card-login .logo-container {
  width: 65px;
  margin: 0 auto;
  margin-bottom: 55px;
}
.login-page .card-login .logo-container img {
  width: 100%;
}
.login-page .card-login .input-group:last-child {
  margin-bottom: 40px;
}
.login-page .card-login.card-plain .form-control::-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-moz-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control::-webkit-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control:-ms-input-placeholder {
  color: #ebebeb;
  opacity: 1;
  filter: alpha(opacity=100);
}
.login-page .card-login.card-plain .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-control:focus {
  border-color: #FFFFFF;
  background-color: transparent;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .has-success:after,
.login-page .card-login.card-plain .has-danger:after {
  color: #FFFFFF;
}
.login-page .card-login.card-plain .has-danger .form-control {
  background-color: transparent;
}
.login-page .card-login.card-plain .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group-append .input-group-text {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.5);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .input-group-focus .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group-focus .input-group-append .input-group-text {
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control,
.login-page .card-login.card-plain .input-group.no-border .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus, .login-page .card-login.card-plain .form-group.no-border .form-control:active, .login-page .card-login.card-plain .form-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control:active,
.login-page .card-login.card-plain .input-group.no-border .form-control:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
}
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-plain .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.login-page .card-login.card-plain .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .login-page .card-login.card-plain .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .form-group.no-border .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  color: #FFFFFF;
}
.login-page .card-login.card-plain .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.login-page .card-login.card-plain .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.login-page .card-login.card-plain .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
}
.login-page .card-login.card-plain .input-group-addon,
.login-page .card-login.card-plain .form-group.no-border .input-group-addon,
.login-page .card-login.card-plain .input-group.no-border .input-group-addon {
  color: rgba(255, 255, 255, 0.8);
}
.login-page .link {
  font-size: 10px;
  color: #FFFFFF;
  text-decoration: none;
}

.full-page {
  align-items: center;
  min-height: 100vh;
  padding: 100px 0 120px;
}
.full-page > .footer {
  position: relative;
  z-index: 4;
}
.full-page .footer {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.full-page .footer .container {
  color: #FFFFFF;
}
.full-page .full-page-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.full-page:after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.6);
}
.full-page .pricing-page .description {
  margin-bottom: 65px;
}
.full-page .register-page > .container {
  margin-top: 5vh;
}
.full-page .register-page .info-horizontal {
  padding: 0px 0px 20px;
}
.full-page .register-page .info-horizontal {
  text-align: left !important;
}
.full-page .register-page .info-horizontal .icon {
  margin-top: 0;
}
.full-page .register-page .info-horizontal .icon > i {
  font-size: 2em;
}
.full-page .register-page .info-horizontal .icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin-top: 8px;
}
.full-page .register-page .info-horizontal .icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 3.5;
  font-size: 1.9em;
}
.full-page .register-page .info-horizontal .description {
  overflow: hidden;
}

.register-page .navbar .navbar-collapse .nav-item .nav-link,
.login-page .navbar .navbar-collapse .nav-item .nav-link,
.lock-page .navbar .navbar-collapse .nav-item .nav-link {
  text-transform: capitalize;
  color: #FFFFFF !important;
}
.register-page .navbar .navbar-collapse .nav-item .nav-link i,
.login-page .navbar .navbar-collapse .nav-item .nav-link i,
.lock-page .navbar .navbar-collapse .nav-item .nav-link i {
  margin-right: 4px;
}
.register-page .navbar.navbar-transparent,
.login-page .navbar.navbar-transparent,
.lock-page .navbar.navbar-transparent {
  border-bottom: 1px solid transparent;
  margin-top: 25px;
}
.register-page .navbar .navbar-brand,
.login-page .navbar .navbar-brand,
.lock-page .navbar .navbar-brand {
  color: #FFFFFF !important;
}

.register-page,
.login-page,
.lock-page {
  width: 100%;
}

@media screen and (max-width: 991px) {
  .register-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,
  .login-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab,
  .lock-page .navbar.bg-white .navbar-toggler .navbar-toggler-bar.navbar-kebab {
    background: #66615B !important;
  }
  .register-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,
  .login-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link,
  .lock-page .navbar.bg-white .navbar-collapse .navbar-nav .nav-item .nav-link {
    color: #66615B !important;
  }
  .register-page .navbar.bg-white .navbar-brand,
  .login-page .navbar.bg-white .navbar-brand,
  .lock-page .navbar.bg-white .navbar-brand {
    color: #66615B !important;
  }
  .register-page .navbar.navbar-transparent .navbar-toggle,
  .login-page .navbar.navbar-transparent .navbar-toggle,
  .lock-page .navbar.navbar-transparent .navbar-toggle {
    display: none;
  }
  .register-page .navbar.navbar-transparent .navbar-toggler .navbar-toggler-bar.navbar-kebab,
  .login-page .navbar.navbar-transparent .navbar-toggler .navbar-toggler-bar.navbar-kebab,
  .lock-page .navbar.navbar-transparent .navbar-toggler .navbar-toggler-bar.navbar-kebab {
    background: #FFFFFF !important;
  }
}
.btn-file {
  position: relative;
  overflow: hidden;
  vertical-align: middle;
}

.btn-file > input {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  font-size: 23px;
  cursor: pointer;
  filter: alpha(opacity=0);
  opacity: 0;
  direction: ltr;
}

.fileinput {
  display: inline-block;
  margin-bottom: 9px;
}
.fileinput input[type=file] {
  display: none;
}

.fileinput .form-control {
  display: inline-block;
  padding-top: 7px;
  padding-bottom: 5px;
  margin-bottom: 0;
  vertical-align: middle;
  cursor: text;
}

.fileinput .thumbnail {
  display: inline-block;
  margin-bottom: 10px;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  max-width: 250px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.fileinput .thumbnail.img-circle {
  border-radius: 50%;
  max-width: 100px;
}

.fileinput .thumbnail > img {
  max-height: 100%;
}

.fileinput .btn {
  vertical-align: middle;
}

.fileinput-exists .fileinput-new,
.fileinput-new .fileinput-exists {
  display: none;
}

.fileinput-inline .fileinput-controls {
  display: inline;
}

.fileinput-filename {
  display: inline-block;
  overflow: hidden;
  vertical-align: middle;
}

.form-control .fileinput-filename {
  vertical-align: bottom;
}

.fileinput.input-group {
  display: table;
}

.fileinput.input-group > * {
  position: relative;
  z-index: 2;
}

.fileinput.input-group > .btn-file {
  z-index: 1;
}

.fileinput-new.input-group .btn-file,
.fileinput-new .input-group .btn-file {
  border-radius: 0 4px 4px 0;
}

.fileinput-new.input-group .btn-file.btn-xs,
.fileinput-new .input-group .btn-file.btn-xs,
.fileinput-new.input-group .btn-file.btn-sm,
.fileinput-new .input-group .btn-file.btn-sm {
  border-radius: 0 3px 3px 0;
}

.fileinput-new.input-group .btn-file.btn-lg,
.fileinput-new .input-group .btn-file.btn-lg {
  border-radius: 0 6px 6px 0;
}

.form-group.has-warning .fileinput .fileinput-preview {
  color: #fbc658;
}

.form-group.has-warning .fileinput .thumbnail {
  border-color: #fbc658;
}

.form-group.has-error .fileinput .fileinput-preview {
  color: #ef8157;
}

.form-group.has-error .fileinput .thumbnail {
  border-color: #ef8157;
}

.form-group.has-success .fileinput .fileinput-preview {
  color: #6bd098;
}

.form-group.has-success .fileinput .thumbnail {
  border-color: #6bd098;
}

.input-group-addon:not(:first-child) {
  border-left: 0;
}

.thumbnail {
  border: 0 none;
  border-radius: 3px;
  padding: 0;
}

.picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}

.picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 1px solid #E3E3E3;
  color: #FFFFFF;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.picture:hover {
  border-color: #2ca8ff;
}

.picture input[type=file] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}

.picture-src {
  width: 100%;
}

.fixed-plugin {
  position: fixed;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 120px;
}
.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
}
.fixed-plugin .fa-cog {
  color: #FFFFFF;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}
.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto !important;
  top: -52px !important;
  width: 290px;
  border-radius: 10px;
  padding: 0 10px;
}
.fixed-plugin .dropdown .dropdown-menu .nc-icon {
  top: 2px;
  right: 10px;
  font-size: 14px;
}
.fixed-plugin .dropdown-menu:after,
.fixed-plugin .dropdown-menu:before {
  right: 10px;
  margin-left: auto;
  left: auto;
}
.fixed-plugin .fa-circle-thin {
  color: #FFFFFF;
}
.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}
.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}
.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}
.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}
.fixed-plugin .badge {
  border: 3px solid #FFFFFF;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
}
.fixed-plugin .badge.badge-light {
  border-color: #F5F5F5;
  background-color: #F5F5F5;
  border: 3px solid #FFFFFF;
}
.fixed-plugin .badge.badge-dark {
  border-color: #2c2c2c;
  background-color: #2c2c2c;
  border: 3px solid #FFFFFF;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #00bbff;
}
.fixed-plugin .badge-blue {
  background-color: #51bcda;
}
.fixed-plugin .badge-green {
  background-color: #6bd098;
}
.fixed-plugin .badge-orange {
  background-color: #51cbce;
}
.fixed-plugin .badge-yellow {
  background-color: #fbc658;
}
.fixed-plugin .badge-red {
  background-color: #ef8157;
}
.fixed-plugin h5 {
  font-size: 14px;
  margin: 10px;
}
.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 15px 2px;
  width: 25%;
  float: left;
}
.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 35px;
  min-height: inherit;
}
.fixed-plugin li.button-container {
  height: auto;
}
.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}
.fixed-plugin #sharrreTitle {
  text-align: center;
  padding: 10px 0;
  height: 50px;
}
.fixed-plugin li.header-title {
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}
.fixed-plugin .adjustments-line p {
  float: left;
  display: inline-block;
  margin-bottom: 0;
  font-size: 1em;
  color: #3C4858;
}
.fixed-plugin .adjustments-line a {
  color: transparent;
}
.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}
.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
  color: transparent;
}
.fixed-plugin .adjustments-line .togglebutton {
  text-align: center;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch {
  position: relative;
  left: -10px;
  font-size: 0.7142em;
  color: #66615B;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {
  left: 10px;
}
.fixed-plugin .adjustments-line .togglebutton .toggle {
  margin-right: 0;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: #FFF;
  border: 3px solid #FFF;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder img {
  margin-top: auto;
}
.fixed-plugin .dropdown-menu > li a.switch-trigger:hover, .fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
  background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder, .fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #FFFFFF;
}
.fixed-plugin .btn-social {
  width: 50%;
  display: block;
  width: 48%;
  float: left;
  font-weight: 600;
}
.fixed-plugin .btn-social i {
  margin-right: 5px;
}
.fixed-plugin .btn-social:first-child {
  margin-right: 2%;
}
.fixed-plugin .dropdown .dropdown-menu {
  transform-origin: 0 0;
}
.fixed-plugin .dropdown .dropdown-menu:before {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid rgba(0, 0, 0, 0.2);
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -27px;
  bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid #FFFFFF;
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -26px;
  bottom: 425px;
}
.fixed-plugin .dropdown .dropdown-menu:before, .fixed-plugin .dropdown .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  width: 16px;
  transform: translateY(-50px);
  -webkit-transform: translateY(-50px);
  -moz-transform: translateY(-50px);
}
.fixed-plugin .dropdown.show-dropdown .show .dropdown-menu .show {
  transform: translate3d(0, -60px, 0) !important;
  bottom: auto !important;
  top: 0 !important;
}
.fixed-plugin .bootstrap-switch {
  margin: 0;
}

.fixed-plugin .show-dropdown .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(0, -100px, 0) !important;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement=bottom-start]:before, .fixed-plugin .show-dropdown .dropdown-menu[x-placement=bottom-start]:after {
  top: 100px;
}
.fixed-plugin .show-dropdown .dropdown-menu[x-placement=top-start] {
  transform: translate3d(0, 100px, 0) !important;
}
.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement=bottom-start] {
  transform: translate3d(0, -60px, 0) !important;
}
.fixed-plugin .show-dropdown.show .dropdown-menu.show[x-placement=top-start] {
  transform: translate3d(0, 470px, 0) !important;
}

.form-control {
  height: auto;
  height: initial;
}

.form-group input[type=file] {
  opacity: 1;
  position: static;
  position: initial;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  height: initial;
  z-index: auto;
  z-index: initial;
}

.modal-footer .left-side,
.modal-footer .right-side {
  display: flex;
  flex: 1 1;
  text-align: center;
  width: auto;
  width: initial;
  padding: 5px;
}

.navbar .navbar-nav .nav-link i.fa + p,
.navbar .navbar-nav .nav-link i.nc-icon + p {
  margin-left: 7px;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "nucleo-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
/* all icon font classes list here */
/*             Navigation Pills               */
.nav-pills .nav-item + .nav-link {
  margin-left: 0;
}
.nav-pills .nav-item .nav-link {
  border: 1px solid #66615B;
  border-radius: 0;
  color: #66615B;
  font-weight: 700;
  margin-left: -1px;
  padding: 10px 25px;
}
.nav-pills .nav-item.active .nav-link,
.nav-pills .nav-item.active .nav-link:hover,
.nav-pills .nav-item.active .nav-link:focus {
  background-color: #66615B;
  color: #FFFFFF;
}
.nav-pills:not(.flex-column) .nav-item:first-child .nav-link {
  border-radius: 30px 0 0 30px !important;
  margin: 0;
}
.nav-pills:not(.flex-column) .nav-item:last-child .nav-link {
  border-radius: 0 30px 30px 0 !important;
}
.nav-pills.flex-column .nav-item .nav-link {
  border-radius: 30px !important;
  margin-bottom: 15px;
}
.nav-pills .nav-item .nav-link.active {
  background-color: #66615B;
  color: #FFFFFF;
}

.nav-pills-primary .nav-item .nav-link {
  border: 1px solid #51cbce;
  color: #51cbce;
}
.nav-pills-primary .nav-item .nav-link.active {
  border: 1px solid #51cbce;
  background: #51cbce;
  color: #FFFFFF;
}

.nav-pills-danger .nav-item .nav-link {
  border: 1px solid #ef8157;
  color: #ef8157;
}
.nav-pills-danger .nav-item .nav-link.active {
  border: 1px solid #ef8157;
  background: #ef8157;
  color: #FFFFFF;
}

.nav-pills-info .nav-item .nav-link {
  border: 1px solid #51bcda;
  color: #51bcda;
}
.nav-pills-info .nav-item .nav-link.active {
  border: 1px solid #51bcda;
  background: #51bcda;
  color: #FFFFFF;
}

.nav-pills-success .nav-item .nav-link {
  border: 1px solid #6bd098;
  color: #6bd098;
}
.nav-pills-success .nav-item .nav-link.active {
  border: 1px solid #6bd098;
  background: #6bd098;
  color: #FFFFFF;
}

.nav-pills-warning .nav-item .nav-link {
  border: 1px solid #fbc658;
  color: #fbc658;
}
.nav-pills-warning .nav-item .nav-link.active {
  border: 1px solid #fbc658;
  background: #fbc658;
  color: #FFFFFF;
}

.page-item:first-child .page-link,
.page-item:last-child .page-link {
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
}

.nav-pills-default .nav-item.show .nav-link,
.nav-pills-default .nav-link.active {
  background-color: #66615B !important;
}

.nav-pills-primary .nav-item.show .nav-link,
.nav-pills-primary .nav-link.active {
  background-color: #51cbce !important;
}

.nav-pills-info .nav-item.show .nav-link,
.nav-pills-info .nav-link.active {
  background-color: #51bcda !important;
}

.nav-pills-warning .nav-item.show .nav-link,
.nav-pills-warning .nav-link.active {
  background-color: #fbc658 !important;
}

.nav-pills-success .nav-item.show .nav-link,
.nav-pills-success .nav-link.active {
  background-color: #6bd098 !important;
}

.nav-pills-danger .nav-item.show .nav-link,
.nav-pills-danger .nav-link.active {
  background-color: #ef8157 !important;
}

@media screen and (max-width: 991px) {
  .navbar {
    padding: 0;
  }
  .navbar.navbar-absolute {
    padding-top: 0;
  }
  .navbar .navbar-brand {
    font-size: 16px;
    margin-right: 0;
  }
  .profile-photo .profile-photo-small {
    margin-left: -2px;
  }
  .button-dropdown {
    display: none;
  }
  #minimizeSidebar {
    display: none;
  }
  .navbar .container-fluid {
    padding-right: 15px;
    padding-left: 15px;
  }
  .navbar .navbar-collapse .input-group {
    margin: 0;
    margin-top: 5px;
  }
  .navbar .navbar-nav .nav-item:first-child {
    margin-top: 10px;
  }
  .navbar .navbar-nav .nav-item:not(:last-child) {
    margin-bottom: 10px;
  }
  .navbar .dropdown.show .dropdown-menu {
    display: block !important;
    transform: translate3d(0px, 0px, 0px) !important;
  }
  .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .navbar .dropdown.show .dropdown-menu,
  .navbar .dropdown .dropdown-menu {
    border: 0;
    transition: none;
    -webkit-box-shadow: none;
    width: auto;
    margin: 0px 1rem;
    margin-top: 0px;
    box-shadow: none;
    position: static !important;
    padding-left: 10px;
  }
  .navbar .dropdown.show .dropdown-menu:before,
  .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .navbar .dropdown-menu .dropdown-item:focus,
  .navbar .dropdown-menu .dropdown-item:hover {
    color: #FFFFFF;
  }
  .navbar.bg-white .dropdown-menu .dropdown-item:focus, .navbar.bg-white .dropdown-menu .dropdown-item:hover {
    color: #66615B;
  }
  .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #66615B;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {
    margin-top: 3px;
  }
  .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background-color: #66615B;
  }
  .navbar .toggled .navbar-toggler-bar {
    width: 24px;
  }
  .navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 5px;
  }
  .wrapper {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .main-panel {
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .nav-open .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open body {
    position: relative;
    overflow-x: hidden;
  }
  .nav-open .menu-on-right .main-panel {
    transform: translate3d(-260px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-collapse,
  .nav-open .menu-on-right .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-translate {
    transform: translate3d(-300px, 0, 0);
  }
  .nav-open .menu-on-right #bodyClick {
    left: auto;
  }
  .menu-on-right .sidebar {
    left: auto;
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .bar1,
  .bar2,
  .bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    right: 0;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .footer .copyright {
    text-align: right;
  }
  .section-nucleo-icons .icons-container {
    margin-top: 65px;
  }
  .navbar-nav .nav-link i.fa,
  .navbar-nav .nav-link i.nc-icon {
    opacity: 0.5;
  }
  .sidebar,
  .bootstrap-navbar {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    width: 260px;
    right: auto;
    left: 0;
    z-index: 1032;
    visibility: visible;
    overflow-y: visible;
    padding: 0;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(-260px, 0, 0);
  }
  .main-panel {
    width: 100%;
  }
  .timeline:before {
    left: 5% !important;
  }
  .timeline > li > .timeline-badge {
    left: 5% !important;
  }
  .timeline > li > .timeline-panel {
    float: right !important;
    width: 82% !important;
  }
  .timeline > li > .timeline-panel:before {
    border-left-width: 0 !important;
    border-right-width: 15px !important;
    left: -15px !important;
    right: auto !important;
  }
  .timeline > li > .timeline-panel:after {
    border-left-width: 0 !important;
    border-right-width: 14px !important;
    left: -14px !important;
    right: auto !important;
  }
  .fixed-plugin {
    width: 54px;
  }
  .fixed-plugin .dropdown-menu {
    max-width: 230px;
    right: 80px;
  }
}
@media (max-width: 991px) and (min-width: 768px) {
  .nav-tabs-navigation.verical-navs {
    padding: 0px 2px;
  }
}
@media screen and (min-width: 768px) {
  .footer .footer-nav {
    padding-left: 21px;
  }
  .footer .credits {
    padding-right: 15px;
  }
}
@media screen and (min-width: 992px) {
  .navbar-collapse {
    background: none !important;
  }
  .navbar .navbar-toggle {
    display: none;
  }
  .navbar-nav .nav-link.profile-photo {
    padding: 0;
    margin: 7px 0.7rem;
  }
  .section-nucleo-icons .icons-container {
    margin: 0 0 0 auto;
  }
  .dropdown-menu .dropdown-item {
    color: inherit;
  }
  .footer .copyright {
    float: right;
    padding-right: 15px;
  }
  .sidebar .sidebar-wrapper li > [data-toggle=collapse] + div .nav li.active a:before {
    top: -2px;
  }
  .sidebar .sidebar-wrapper li > [data-toggle=collapse] + div .nav li.active a:after {
    top: -1px;
  }
  .sidebar .sidebar-wrapper li.active > [data-toggle=collapse] + div .nav li:before, .sidebar .sidebar-wrapper li.active > [data-toggle=collapse] + div .nav li:after {
    display: none !important;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=collapse]):before {
    border-right: 18px solid #DDDDDD;
    border-top: 18px solid transparent;
    border-bottom: 18px solid transparent;
    content: "";
    display: inline-block;
    position: absolute;
    right: -15px;
    opacity: 1;
    top: 6px;
    transition: opacity 150ms ease-in;
  }
  .sidebar .sidebar-wrapper li.active > a:not([data-toggle=collapse]):after {
    border-right: 17px solid #f4f3ef;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    content: "";
    display: inline-block;
    position: absolute;
    right: -15px;
    opacity: 1;
    top: 7px;
    transition: opacity 150ms ease-in;
  }
}
@media screen and (max-width: 768px) {
  .card-stats [class*=col-] .statistics::after {
    display: none;
  }
  .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  }
  .footer nav {
    display: block;
    margin-bottom: 5px;
    float: none;
  }
  .landing-page .section-story-overview .image-container:nth-child(2) {
    margin-left: 0;
    margin-bottom: 30px;
  }
  .card .form-horizontal .col-md-3.col-form-label {
    text-align: left;
  }
}
@media screen and (max-width: 767px) {
  .typography-line {
    padding-left: 23% !important;
  }
  .typography-line span {
    width: 60px !important;
  }
  .login-page .navbar,
  .lock-page .navbar,
  .register-page .navbar {
    padding: 0.5rem 1rem;
  }
  .footer .footer-nav,
  .footer .credits {
    margin: 0 auto !important;
  }
  .footer .footer-nav {
    margin-bottom: 10px !important;
  }
  .register-page .content {
    padding-top: 5vh;
  }
  .register-page .footer {
    position: relative;
  }
  .register-page .info-area.info-horizontal {
    margin-top: 0;
  }
}
@media screen and (max-width: 413px) {
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show {
    width: 225px !important;
  }
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show[x-placement=top-start] {
    transform: translate3d(0, 400px, 0) !important;
  }
  .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:before, .fixed-plugin .dropdown.show-dropdown.show .dropdown-menu.show:after {
    bottom: 360px !important;
  }
}
@media screen and (max-width: 576px) {
  .navbar[class*=navbar-toggleable-] .container {
    margin-left: 0;
    margin-right: 0;
  }
  .card-contributions .card-stats {
    flex-direction: column;
  }
  .card-contributions .card-stats .bootstrap-switch {
    margin-bottom: 15px;
  }
  .footer .copyright {
    text-align: center;
  }
  .section-nucleo-icons .icons-container i {
    font-size: 30px;
  }
  .section-nucleo-icons .icons-container i:nth-child(6) {
    font-size: 48px;
  }
  .page-header .container h6.category-absolute {
    width: 90%;
  }
  .card-timeline .timeline .timeline-panel {
    width: 38%;
    padding: 15px;
  }
}
.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
  overflow-x: hidden;
}
.wrapper.wrapper-full-page {
  min-height: 100vh;
  height: auto;
}
.wrapper.wrapper-full-page .full-page {
  display: flex;
}

.sidebar,
.off-canvas-sidebar {
  position: fixed;
  top: 0;
  height: 100%;
  bottom: 0;
  width: 260px;
  left: 0;
  z-index: 999;
}
.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
  position: relative;
  height: calc(100vh - 75px);
  overflow: auto;
  width: 260px;
  z-index: 4;
  padding-bottom: 100px;
}
.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,
.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {
  display: none !important;
}
.sidebar .sidebar-wrapper .navbar-form,
.off-canvas-sidebar .sidebar-wrapper .navbar-form {
  border: none;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span {
  display: inline-block;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  margin: 0;
  position: relative;
  transform: translateX(0px);
  opacity: 1;
  white-space: nowrap;
  display: block;
  line-height: 20px;
  z-index: 1;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  text-transform: uppercase;
  width: 34px;
  margin-right: 10px;
  margin-left: 0px;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  position: relative;
  float: left;
  z-index: 1;
  display: inherit;
  color: rgba(255, 255, 255, 0.5);
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  text-transform: capitalize;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a i,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a i,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a i,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a i {
  font-size: 17px;
  line-height: 20px;
  width: 26px;
}
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
  position: absolute;
  right: 20px;
  top: 2px;
  opacity: 1;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar .nav,
.off-canvas-sidebar .nav {
  margin-top: 20px;
  display: block;
}
.sidebar .nav .caret,
.off-canvas-sidebar .nav .caret {
  top: 14px;
  position: absolute;
  right: 10px;
}
.sidebar .nav li > a + div .nav li > a,
.off-canvas-sidebar .nav li > a + div .nav li > a {
  margin-top: 7px;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  margin: 10px 15px 0;
  color: #FFFFFF;
  display: block;
  text-decoration: none;
  position: relative;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 12px;
  padding: 10px 8px;
  line-height: 30px;
  opacity: 0.7;
}
.sidebar .nav li .nav > li > a,
.off-canvas-sidebar .nav li .nav > li > a {
  padding: 5px 8px;
}
.sidebar .nav li.active > a, .sidebar .nav li.active > a > i,
.off-canvas-sidebar .nav li.active > a,
.off-canvas-sidebar .nav li.active > a > i {
  opacity: 1;
}
.sidebar .nav li:hover:not(.active) > a, .sidebar .nav li:focus:not(.active) > a,
.off-canvas-sidebar .nav li:hover:not(.active) > a,
.off-canvas-sidebar .nav li:focus:not(.active) > a {
  opacity: 1;
}
.sidebar .nav li.active > a[data-toggle=collapse], .sidebar .nav li.active > a[data-toggle=collapse] i, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #ef8157;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a, .sidebar .nav li.active > a[data-toggle=collapse] i + div .nav .active a, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i + div .nav .active a, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a + div .nav .active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] i + div .nav .active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i + div .nav .active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a + div .nav .active a {
  background-color: transparent;
  box-shadow: none;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a:after, .sidebar .nav li.active > a[data-toggle=collapse] i + div .nav .active a:after, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i + div .nav .active a:after, .sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] i + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active i + div .nav .active a:after,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a + div .nav .active a:after {
  content: "";
  position: absolute;
  width: calc(100% - 5px);
  z-index: 0;
}
.sidebar .nav li.active > a[data-toggle=collapse] ~ div > .nav,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] ~ div > .nav {
  margin-top: 0;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
  margin: 0;
  line-height: 30px;
  position: relative;
  display: block;
  height: auto;
  white-space: nowrap;
  font-weight: 600;
}
.sidebar .nav i,
.off-canvas-sidebar .nav i {
  font-size: 24px;
  float: left;
  margin-right: 12px;
  line-height: 30px;
  width: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  position: relative;
}
.sidebar .nav .collapse .nav,
.sidebar .nav .collapsing .nav,
.off-canvas-sidebar .nav .collapse .nav,
.off-canvas-sidebar .nav .collapsing .nav {
  margin-top: 0;
}
.sidebar .sidebar-background,
.off-canvas-sidebar .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.sidebar .sidebar-background:after,
.off-canvas-sidebar .sidebar-background:after {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  content: "";
  display: block;
  background: #FFFFFF;
  opacity: 1;
}
.sidebar .logo,
.off-canvas-sidebar .logo {
  position: relative;
  padding: 7px 0.7rem;
  z-index: 4;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
  opacity: 0;
  float: left;
  width: 34px;
  text-align: center;
  margin-left: 12px;
  margin-right: 12px;
}
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-normal {
  display: block;
  opacity: 1;
  padding: 11px 0 8px;
  transform: translate3d(0px, 0, 0);
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.5);
}
.sidebar .logo p,
.off-canvas-sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #FFFFFF;
  line-height: 20px;
  font-family: "Muli", "Helvetica", Arial, sans-serif;
}
.sidebar .logo .simple-text,
.off-canvas-sidebar .logo .simple-text {
  text-transform: uppercase;
  padding: 0.5rem 0;
  display: block;
  white-space: nowrap;
  font-size: 1rem;
  color: #FFFFFF;
  text-decoration: none;
  font-weight: 400;
  line-height: 30px;
  overflow: hidden;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar:before, .sidebar:after,
.off-canvas-sidebar:before,
.off-canvas-sidebar:after {
  display: block;
  content: "";
  opacity: 1;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.sidebar:after,
.off-canvas-sidebar:after {
  background: #66615B;
  background: linear-gradient(#66615B 0%, #000 80%);
  z-index: 3;
}
.sidebar[data-color=white]:after,
.off-canvas-sidebar[data-color=white]:after {
  background: #FFFFFF;
}
.sidebar[data-color=white] .nav li a,
.sidebar[data-color=white] .nav li a i,
.sidebar[data-color=white] .nav li a[data-toggle=collapse],
.sidebar[data-color=white] .nav li a[data-toggle=collapse] i,
.sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li .sidebar-mini-icon,
.sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li > a,
.off-canvas-sidebar[data-color=white] .nav li a,
.off-canvas-sidebar[data-color=white] .nav li a i,
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse],
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse] i,
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li .sidebar-mini-icon,
.off-canvas-sidebar[data-color=white] .nav li a[data-toggle=collapse] ~ div > ul > li > a {
  color: #66615B;
  opacity: 0.7;
}
.sidebar[data-color=white] .nav li:hover:not(.active) > a, .sidebar[data-color=white] .nav li:focus:not(.active) > a,
.off-canvas-sidebar[data-color=white] .nav li:hover:not(.active) > a,
.off-canvas-sidebar[data-color=white] .nav li:focus:not(.active) > a {
  opacity: 1;
}
.sidebar[data-color=white] .logo .simple-text,
.off-canvas-sidebar[data-color=white] .logo .simple-text {
  color: #66615B;
}
.sidebar[data-color=white] .logo:after,
.off-canvas-sidebar[data-color=white] .logo:after {
  background-color: #66615B;
  opacity: 0.4;
}
.sidebar[data-color=white] .user .info a span,
.sidebar[data-color=white] .user .nav .sidebar-mini-icon,
.sidebar[data-color=white] .user .nav .sidebar-normal,
.off-canvas-sidebar[data-color=white] .user .info a span,
.off-canvas-sidebar[data-color=white] .user .nav .sidebar-mini-icon,
.off-canvas-sidebar[data-color=white] .user .nav .sidebar-normal {
  color: #66615B !important;
}
.sidebar[data-color=white] .user:after,
.off-canvas-sidebar[data-color=white] .user:after {
  background-color: #66615B;
  opacity: 0.4;
}
.sidebar[data-color=brown]:after,
.off-canvas-sidebar[data-color=brown]:after {
  background: #66615B;
}
.sidebar[data-active-color=primary] .nav li.active > a, .sidebar[data-active-color=primary] .nav li.active > a i, .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=primary] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #51cbce;
  opacity: 1;
}
.sidebar[data-active-color=info] .nav li.active > a, .sidebar[data-active-color=info] .nav li.active > a i, .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=info] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #51bcda;
  opacity: 1;
}
.sidebar[data-active-color=success] .nav li.active > a, .sidebar[data-active-color=success] .nav li.active > a i, .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=success] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #6bd098;
  opacity: 1;
}
.sidebar[data-active-color=warning] .nav li.active > a, .sidebar[data-active-color=warning] .nav li.active > a i, .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=warning] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #fbc658;
  opacity: 1;
}
.sidebar[data-active-color=danger] .nav li.active > a, .sidebar[data-active-color=danger] .nav li.active > a i, .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse], .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] i, .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon, .sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a i,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active .sidebar-mini-icon,
.off-canvas-sidebar[data-active-color=danger] .nav li.active > a[data-toggle=collapse] ~ div > ul > li.active > a {
  color: #ef8157;
  opacity: 1;
}
.sidebar .user,
.off-canvas-sidebar .user {
  padding-bottom: 20px;
  margin: 20px auto 0;
  position: relative;
}
.sidebar .user:after,
.off-canvas-sidebar .user:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background-color: rgba(255, 255, 255, 0.3);
}
.sidebar .user .photo,
.off-canvas-sidebar .user .photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  float: left;
  z-index: 5;
  margin-right: 12px;
  border-radius: 50%;
  margin-left: 23px;
}
.sidebar .user .photo img,
.off-canvas-sidebar .user .photo img {
  width: 100%;
}
.sidebar .user a,
.off-canvas-sidebar .user a {
  color: #FFFFFF;
  text-decoration: none;
  padding: 0.5rem 15px;
  white-space: nowrap;
}
.sidebar .user .info > a,
.off-canvas-sidebar .user .info > a {
  display: block;
  line-height: 18px;
}
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span {
  display: block;
  position: relative;
  opacity: 1;
}
.sidebar .user .info .caret,
.off-canvas-sidebar .user .info .caret {
  position: absolute;
  top: 8px;
  right: 18px;
}

.visible-on-sidebar-regular {
  display: inline-block !important;
}

.visible-on-sidebar-mini {
  display: none !important;
}

.off-canvas-sidebar .nav > li > a,
.off-canvas-sidebar .nav > li > a:hover {
  color: #FFFFFF;
}
.off-canvas-sidebar .nav > li > a:focus {
  background: rgba(200, 200, 200, 0.2);
}

.main-panel {
  position: relative;
  float: right;
  background-color: #f4f3ef;
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.main-panel > .content {
  padding: 0 30px 30px;
  min-height: calc(100vh - 123px);
  margin-top: 93px;
}
.main-panel > .map-content {
  min-height: calc(100vh - 123px);
  margin-top: 63px;
}
.main-panel > .navbar {
  margin-bottom: 0;
}
.main-panel .header {
  margin-bottom: 50px;
}

.perfect-scrollbar-on .sidebar,
.perfect-scrollbar-on .main-panel {
  height: 100%;
  max-height: 100%;
}

@media (min-width: 991px) {
  .sidebar,
  .main-panel,
  .sidebar-wrapper {
    transition-property: top, bottom, width;
    transition-duration: 0.2s, 0.2s, 0.35s;
    transition-timing-function: linear, linear, ease;
    -webkit-overflow-scrolling: touch;
  }
  .sidebar-mini .visible-on-sidebar-regular {
    display: none !important;
  }
  .sidebar-mini .visible-on-sidebar-mini {
    display: inline-block !important;
  }
  .sidebar-mini .sidebar,
  .sidebar-mini .sidebar .sidebar-wrapper {
    width: 80px;
  }
  .sidebar-mini .main-panel {
    width: calc(100% - 80px);
  }
  .sidebar-mini .sidebar {
    display: block;
    z-index: 1030;
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
    transform: translate3d(-25px, 0, 0);
  }
  .sidebar-mini .sidebar .logo a.logo-mini {
    opacity: 1;
  }
  .sidebar-mini .sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar:hover {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .logo a.logo-normal {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  .sidebar-mini .sidebar:hover .navbar-minimize {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {
    transform: translate3d(0px, 0, 0);
    opacity: 1;
  }
}
.panel-header {
  height: 260px;
  padding-top: 80px;
  padding-bottom: 45px;
  background: #141E30; /* fallback for old browsers */
  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);
  position: relative;
  overflow: hidden;
}
.panel-header .header .title {
  color: #FFFFFF;
}
.panel-header .header .category {
  max-width: 600px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 auto;
  font-size: 13px;
}
.panel-header .header .category a {
  color: #FFFFFF;
}

.panel-header-sm {
  height: 135px;
}

.panel-header-lg {
  height: 380px;
}

.sidebar .logo .simple-text .logo-img {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  background: #FFFFFF;
  border-radius: 50%;
  text-align: center;
  overflow: hidden;
}
.sidebar .logo .simple-text .logo-img img {
  width: 51%;
  vertical-align: baseline;
  vertical-align: initial;
  height: 51%;
}

.sidebar[data-color=white] {
  border-right: 1px solid #ddd;
}

/*             Navigation Tabs                 */
.nav-tabs-navigation {
  text-align: center;
  border-bottom: 1px solid #F1EAE0;
  margin-bottom: 30px;
}
.nav-tabs-navigation .nav > .nav-item > .nav-link {
  padding-bottom: 20px;
}

.nav-tabs-wrapper {
  display: inline-block;
  margin-bottom: -6px;
  position: relative;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.nav-tabs {
  justify-content: center;
  border-bottom: 0 none;
  font-size: 14px;
  font-weight: 400;
}
.nav-tabs .nav-item .nav-link {
  border: 0 none;
  color: #A49E93;
  background-color: transparent;
}
.nav-tabs .nav-item .nav-link:hover {
  color: #66615b;
}
.nav-tabs .nav-item .nav-link.active {
  color: #66615b;
}
.nav-tabs .nav-item {
  color: #66615b;
  position: relative;
}
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item .nav-link.active:hover,
.nav-tabs .nav-item .nav-link.active:focus {
  background-color: transparent;
  border: 0 none;
}
.nav-tabs .nav-item .nav-link.active:after,
.nav-tabs .nav-item .nav-link.active:hover:after,
.nav-tabs .nav-item .nav-link.active:focus:after {
  border-bottom: 11px solid #FFFFFF;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 40%;
  bottom: 5px;
}
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border-bottom: 11px solid #F1EAE0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 40%;
  bottom: 6px;
}
.nav-tabs .nav-item.show .nav-link {
  background-color: transparent;
}
.nav-tabs .dropdown-menu {
  margin-top: -6px;
  margin-left: -46px;
  border-radius: 8px;
}
.nav-tabs .dropdown-menu .dropdown-item:hover,
.nav-tabs .dropdown-menu .dropdown-item.active {
  color: #FFFFFF;
  background-color: #68B3C8;
}
.nav-tabs .dropdown-menu :before {
  border-bottom: 11px solid #F1EAE0;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -11px;
}
.nav-tabs .dropdown-menu :after {
  border-bottom: 11px solid #FFFCF5;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -10px;
}

.profile-content .tab-content .tab-pane {
  min-height: 200px;
}
.profile-content .tab-content #tweets, .profile-content .tab-content #connections, .profile-content .tab-content #media {
  height: 100%;
}

.nav-text, .nav-icons {
  margin: 0 0 10px 0;
}
.nav-text > li > a, .nav-icons > li > a {
  display: block;
  padding: 0px 0.7rem;
  color: #9A9A9A;
  text-align: center;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.nav-text > li > a:hover, .nav-text > li > a:focus, .nav-icons > li > a:hover, .nav-icons > li > a:focus {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
}
.nav-text > li:first-child a, .nav-icons > li:first-child a {
  padding-left: 0;
}
.nav-text > li.active a, .nav-icons > li.active a {
  color: #51bcda;
}

.nav-icons > li {
  display: inline-block;
}
.nav-icons > li > a {
  padding: 0 10px;
  margin-bottom: 10px;
}
.nav-icons > li > a i {
  font-size: 1.714em;
  margin-bottom: 10px;
  width: 1.714em;
}

.nav-icons.nav-stacked > li {
  display: block;
}
.nav-icons.nav-stacked > li > a {
  margin-bottom: 20px;
}

.nav-blue > li.active a {
  color: #51cbce;
}

.nav-azure > li.active a {
  color: #51bcda;
}

.nav-green > li.active a {
  color: #6bd098;
}

.nav-orange > li.active a {
  color: #fbc658;
}

.nav-red > li.active a {
  color: #ef8157;
}

.nav-text {
  margin: 0 0 10px 0;
}
.nav-text > li > a {
  font-size: 1em;
  text-transform: uppercase;
  padding: 3px 0;
  text-align: left;
  font-weight: 600;
}
.nav-text > li:first-child > a {
  padding-top: 0;
}
.nav-text h4 {
  margin-top: 0;
}

.nav-text:not(.nav-stacked) > li {
  display: inline-block;
}
.nav-text:not(.nav-stacked) > li > a {
  margin-right: 15px;
}

.tab-space {
  padding: 20px 0 50px;
}

.verical-navs .nav-stacked .nav-link.active:before,
.verical-navs .nav-stacked .nav-link.active:hover:before,
.verical-navs .nav-stacked .nav-link.active:focus:before,
.verical-navs .nav-stacked .nav-link.active.show:before {
  border-right: 11px solid #F1EAE0;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 0;
  bottom: 20px;
}

.verical-navs .nav-stacked .nav-link.active:after,
.verical-navs .nav-stacked .nav-link.active:hover:after,
.verical-navs .nav-stacked .nav-link.active:focus:after,
.verical-navs .nav-stacked .nav-link.active.show:after {
  border-right: 11px solid #FFFFFF;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: -1px;
  bottom: 20px;
}

#second-tabs {
  margin-left: 20px;
}

.nav-tabs-navigation.verical-navs {
  border-right: 1px solid #F1EAE0;
  font-size: 16px;
  border-bottom: none;
}

.card-timeline .timeline h6 i {
  margin-right: 4px;
}

/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
.noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {
  left: 0;
  right: auto;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
  transition: all 0.3s ease;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 8px;
}

.noUi-horizontal .noUi-handle {
  width: 15px;
  height: 15px;
  right: -7px;
  top: 0px;
}

.noUi-vertical {
  width: 8px;
}

.noUi-vertical .noUi-handle {
  width: 15px;
  height: 15px;
  right: 0px;
  top: -7px;
}

.noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {
  left: -17px;
  right: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background: hsla(0, 0%, 71.4%, 0.3);
  border-radius: 4px;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #3FB8AF;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border: none !important;
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
}

.noUi-active {
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
}

/* Handle stripes;
 */
.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}

.noUi-vertical .noUi-handle:after {
  top: 17px;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.noUi-horizontal .noUi-origin > .noUi-tooltip {
  transform: translate(50%, 0);
  left: auto;
  bottom: 10px;
}

.noUi-vertical .noUi-origin > .noUi-tooltip {
  transform: translate(0, -18px);
  top: auto;
  right: 28px;
}

.noUi-active {
  transform: scale3d(1.5, 1.5, 1);
}

.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full,
.rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis,
.rbc-event-label,
.rbc-row-segment .rbc-event-content,
.rbc-show-more {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: #333333;
  opacity: 0.3;
}

.rbc-header {
  overflow: hidden;
  flex: 1 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: right;
  vertical-align: middle;
  font-weight: bold;
  font-size: 1em;
  min-height: 0;
  border-bottom: 1px solid #DDD;
  color: #999999;
}
.rbc-header:last-child span {
  padding-right: 15px;
}

.rbc-header > a,
.rbc-header > a:active,
.rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-content {
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  z-index: 4;
  min-height: 153px;
}

.rbc-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.rbc-toolbar .rbc-toolbar-label {
  flex-grow: 1;
  padding: 0 10px;
  text-align: center;
  font-family: inherit;
  line-height: 1.5em;
  color: inherit;
  font-weight: 500;
  margin: 0;
  font-size: 2.5em;
}

.rbc-toolbar button {
  background-color: #66615B;
  color: #FFFFFF;
  border-width: 2px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin: 5px 1px;
  border: none;
  margin: 10px 1px;
  border-radius: 30px;
  padding: 6px 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  outline: none;
}
.rbc-toolbar button:hover, .rbc-toolbar button:focus, .rbc-toolbar button:active, .rbc-toolbar button.active, .rbc-toolbar button:active:focus, .rbc-toolbar button:active:hover, .rbc-toolbar button.active:focus, .rbc-toolbar button.active:hover, .show > .rbc-toolbar button.dropdown-toggle, .show > .rbc-toolbar button.dropdown-toggle:focus, .show > .rbc-toolbar button.dropdown-toggle:hover {
  background-color: #403D39 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.rbc-toolbar button:not([data-action]):hover {
  box-shadow: none;
}
.rbc-toolbar button.disabled, .rbc-toolbar button.disabled:hover, .rbc-toolbar button.disabled:focus, .rbc-toolbar button.disabled.focus, .rbc-toolbar button.disabled:active, .rbc-toolbar button.disabled.active, .rbc-toolbar button:disabled, .rbc-toolbar button:disabled:hover, .rbc-toolbar button:disabled:focus, .rbc-toolbar button:disabled.focus, .rbc-toolbar button:disabled:active, .rbc-toolbar button:disabled.active, .rbc-toolbar button[disabled], .rbc-toolbar button[disabled]:hover, .rbc-toolbar button[disabled]:focus, .rbc-toolbar button[disabled].focus, .rbc-toolbar button[disabled]:active, .rbc-toolbar button[disabled].active, fieldset[disabled] .rbc-toolbar button, fieldset[disabled] .rbc-toolbar button:hover, fieldset[disabled] .rbc-toolbar button:focus, fieldset[disabled] .rbc-toolbar button.focus, fieldset[disabled] .rbc-toolbar button:active, fieldset[disabled] .rbc-toolbar button.active {
  background-color: #66615B;
  border-color: #66615B;
}
.rbc-toolbar button.btn-simple {
  color: #66615B;
  border-color: #66615B;
}
.rbc-toolbar button.btn-simple:hover, .rbc-toolbar button.btn-simple:focus, .rbc-toolbar button.btn-simple:active {
  background-color: transparent;
  color: #403D39;
  border-color: #403D39;
  box-shadow: none;
}
.rbc-toolbar button.btn-link {
  color: #66615B;
}
.rbc-toolbar button.btn-link:hover, .rbc-toolbar button.btn-link:focus, .rbc-toolbar button.btn-link:active, .rbc-toolbar button.btn-link:active:focus {
  background-color: transparent;
  color: #403D39;
  text-decoration: none;
  box-shadow: none;
}

.rbc-toolbar button:focus {
  outline: none;
}

.rbc-btn-group {
  display: inline-block;
}

.rbc-btn-group button {
  margin: 0 0 0 2px;
  border-radius: 30px;
}

@media screen and (max-width: 526px) {
  .rbc-btn-group button {
    margin: 2px !important;
  }
}
.rbc-btn-group button + button {
  margin: 0 0 0 2px;
  border-radius: 30px;
}

.rbc-btn-group + .rbc-btn-group,
.rbc-btn-group + button {
  margin-left: 10px;
}

.rbc-slot-selecting .rbc-event {
  cursor: inherit;
  pointer-events: none;
}

.rbc-event.rbc-selected {
  background-color: #265985;
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-day-after {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-day-prior {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 2px 6px 1px;
}

.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
}

.rbc-month-view {
  position: relative;
  border: 1px solid #DDD;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
  height: 100%;
  border-left: none;
  border-right: none;
}

.rbc-month-view {
  border-top: none;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  -ms-flex-preferred-size: 0px;
  overflow: hidden;
  height: 100%;
}

.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #DDD;
}

.rbc-date-cell {
  flex: 1 1;
  min-width: 0;
  padding-left: 5px;
  text-align: left;
}

.rbc-date-cell.rbc-now {
  font-weight: bold;
}

.rbc-date-cell > a,
.rbc-date-cell > a:active,
.rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
}

.rbc-day-bg {
  flex: 1 0;
}

.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}

.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}

.rbc-agenda-view table.rbc-agenda-table {
  width: 100%;
  border: 1px solid #DDD;
  border-spacing: 0;
  border-collapse: collapse;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}

.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-top: 1px solid #DDD;
}

.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #DDD;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
}

.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}

.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #DDD;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}

.rbc-day-slot .rbc-events-container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 10px;
  top: 0;
}

.rbc-day-slot .rbc-events-container.rbc-is-rtl {
  left: 10px;
  right: 0;
}

.rbc-day-slot .rbc-event {
  display: flex;
  max-height: 100%;
  min-height: 20px;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
}

.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
  font-weight: bold;
  box-sizing: content-box;
  color: #fff;
  white-space: nowrap;
}

.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}

.rbc-day-slot .rbc-time-slot + .rbc-time-slot {
  border-top: 1px dotted #ddd;
}

.rbc-time-slot {
  flex: 1 0;
}

.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 75%;
  width: 100%;
  padding: 3px;
}

.rbc-slot-selecting {
  cursor: move;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  border: 1px solid #DDD;
  min-height: 0;
  border-left: none;
  border-right: none;
  border-top: none;
}

.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
}

.rbc-time-view .rbc-allday-cell {
  box-sizing: content-box;
  width: 100%;
  position: relative;
}

.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}

.rbc-time-view .rbc-row {
  box-sizing: border-box;
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
}

.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #DDD;
}

.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #DDD;
}

.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #DDD;
}

.rbc-time-header > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #DDD;
}

.rbc-time-header-content {
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-time-header-content {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #DDD;
  overflow-y: auto;
  position: relative;
}

.rbc-time-content > .rbc-time-gutter {
  flex: none;
}

.rbc-time-content > * + * > * {
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-time-content > .rbc-day-slot {
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 3;
  height: 1px;
  background-color: #74ad31;
  pointer-events: none;
}

.rbc-event {
  width: 100%;
  position: relative; /* for resize handle and other inner positioning */
  display: block; /* make the <a> tag block */
  font-size: 0.85em;
  border-radius: 2px;
  padding: 0;
  background-color: rgba(81, 203, 206, 0.2); /* default BACKGROUND color */
  font-weight: normal; /* undo jqui's ui-widget-header bold */
  text-align: left;
  border: none;
  padding-bottom: 1px;
  line-height: 1.2;
}
.rbc-event.event-azure {
  background-color: rgba(81, 188, 218, 0.2);
}
.rbc-event.event-green {
  background-color: rgba(107, 208, 152, 0.2);
}
.rbc-event.event-orange {
  background-color: rgba(251, 198, 88, 0.2);
}
.rbc-event.event-red {
  background-color: rgba(239, 129, 87, 0.2);
}
.rbc-event .rbc-event-content {
  position: relative;
  z-index: 2;
  white-space: nowrap;
  overflow: hidden;
  color: inherit;
  padding: 0 5px;
}

.rbc-day-slot .rbc-event {
  display: block !important;
  height: auto !important;
  height: initial !important;
  max-height: none !important;
  max-height: initial !important;
}

.rbc-today {
  background-color: #F5F5F5;
}

@media screen and (max-width: 1373px) {
  .rbc-toolbar {
    display: block;
  }
  .rbc-toolbar .rbc-btn-group {
    display: block;
    text-align: center;
  }
  .rbc-toolbar .rbc-toolbar-label {
    display: block;
    flex-grow: initial;
    padding: 0;
  }
}
.sweet-alert:focus {
  outline: none;
}

.sweet-alert {
  margin: auto !important;
}

.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  overflow: hidden;
  margin-bottom: 5px;
  line-height: 8px;
  width: 61px !important;
  height: 26px;
  outline: none;
  z-index: 0;
  margin-right: 1px;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 26px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 10px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}
.bootstrap-switch .bootstrap-switch-handle-on i,
.bootstrap-switch .bootstrap-switch-handle-off i,
.bootstrap-switch .bootstrap-switch-label i {
  font-size: 12px;
  line-height: 14px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  width: 50% !important;
  background-color: #66615B;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {
  color: #fff;
  background: #7A9E9F;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {
  color: #fff;
  background: #68B3C8;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {
  color: #fff;
  background: #7AC29A;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {
  background: #F3BB45;
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {
  color: #fff;
  background: #EB5E28;
}

.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
  color: #fff;
  background: #cfcfca;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 22px !important;
  height: 22px;
  margin: 2px -11px;
  border-radius: 12px;
  position: relative;
  float: left;
  padding: 0;
  background-color: #FFFFFF;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type=radio],
.bootstrap-switch input[type=checkbox] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch input[type=radio].form-control,
.bootstrap-switch input[type=checkbox].form-control {
  height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
  padding: 6px 16px;
  font-size: 18px;
  line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -37px !important;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px -13px -11px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {
  background-color: #66615B;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {
  background-color: #cfcfca;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {
  background-color: #EB5E28;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {
  background-color: #F3BB45;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {
  background-color: #7AC29A;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {
  background-color: #7A9E9F;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {
  background-color: #68B3C8;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {
  background-color: #66615B;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {
  background-color: #cfcfca;
}

.bootstrap-switch.wrapper {
  min-height: auto;
  height: auto;
}

.card-wizard {
  min-height: 410px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  opacity: 0;
  transition: all 300ms linear;
}
.card-wizard[data-color=primary] .moving-tab {
  color: #51cbce;
}
.card-wizard[data-color=primary] .picture:hover {
  border-color: #51cbce;
}
.card-wizard[data-color=primary] .choice:hover .icon, .card-wizard[data-color=primary] .choice.active .icon {
  border-color: #51cbce;
  color: #51cbce;
}
.card-wizard[data-color=primary] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #51cbce;
}
.card-wizard[data-color=primary] .radio input[type=radio]:checked ~ .check {
  background-color: #51cbce;
}
.card-wizard[data-color=primary] .radio input[type=radio]:checked ~ .circle {
  border-color: #51cbce;
}
.card-wizard[data-color=white] .moving-tab {
  color: #FFFFFF;
}
.card-wizard[data-color=white] .picture:hover {
  border-color: #FFFFFF;
}
.card-wizard[data-color=white] .choice:hover .icon, .card-wizard[data-color=white] .choice.active .icon {
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.card-wizard[data-color=white] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #FFFFFF;
}
.card-wizard[data-color=white] .radio input[type=radio]:checked ~ .check {
  background-color: #FFFFFF;
}
.card-wizard[data-color=white] .radio input[type=radio]:checked ~ .circle {
  border-color: #FFFFFF;
}
.card-wizard[data-color=green] .moving-tab {
  color: #6bd098;
}
.card-wizard[data-color=green] .picture:hover {
  border-color: #6bd098;
}
.card-wizard[data-color=green] .choice:hover .icon, .card-wizard[data-color=green] .choice.active .icon {
  border-color: #6bd098;
  color: #6bd098;
}
.card-wizard[data-color=green] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #6bd098;
}
.card-wizard[data-color=green] .radio input[type=radio]:checked ~ .check {
  background-color: #6bd098;
}
.card-wizard[data-color=green] .radio input[type=radio]:checked ~ .circle {
  border-color: #6bd098;
}
.card-wizard[data-color=blue] .moving-tab {
  color: #51bcda;
}
.card-wizard[data-color=blue] .picture:hover {
  border-color: #51bcda;
}
.card-wizard[data-color=blue] .choice:hover .icon, .card-wizard[data-color=blue] .choice.active .icon {
  border-color: #51bcda;
  color: #51bcda;
}
.card-wizard[data-color=blue] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #51bcda;
}
.card-wizard[data-color=blue] .radio input[type=radio]:checked ~ .check {
  background-color: #51bcda;
}
.card-wizard[data-color=blue] .radio input[type=radio]:checked ~ .circle {
  border-color: #51bcda;
}
.card-wizard[data-color=orange] .moving-tab {
  color: #fbc658;
}
.card-wizard[data-color=orange] .picture:hover {
  border-color: #fbc658;
}
.card-wizard[data-color=orange] .choice:hover .icon, .card-wizard[data-color=orange] .choice.active .icon {
  border-color: #fbc658;
  color: #fbc658;
}
.card-wizard[data-color=orange] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #fbc658;
}
.card-wizard[data-color=orange] .radio input[type=radio]:checked ~ .check {
  background-color: #fbc658;
}
.card-wizard[data-color=orange] .radio input[type=radio]:checked ~ .circle {
  border-color: #fbc658;
}
.card-wizard[data-color=red] .moving-tab {
  color: #ef8157;
}
.card-wizard[data-color=red] .picture:hover {
  border-color: #ef8157;
}
.card-wizard[data-color=red] .choice:hover .icon, .card-wizard[data-color=red] .choice.active .icon {
  border-color: #ef8157;
  color: #ef8157;
}
.card-wizard[data-color=red] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #ef8157;
}
.card-wizard[data-color=red] .radio input[type=radio]:checked ~ .check {
  background-color: #ef8157;
}
.card-wizard[data-color=red] .radio input[type=radio]:checked ~ .circle {
  border-color: #ef8157;
}
.card-wizard.active {
  opacity: 1;
}
.card-wizard .card-header {
  padding: 15px 0 !important;
  padding-bottom: 40px;
  background-color: transparent;
}
.card-wizard .card-header .card-title {
  color: #252422;
}
.card-wizard .card-header .card-title + .description {
  color: #9A9A9A;
}
.card-wizard .nav-pills .nav-item .nav-link {
  padding: 12px;
}
.card-wizard .nav-pills .nav-item .nav-link,
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link:hover,
.card-wizard .nav-pills .nav-item .nav-link:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
  background-color: transparent;
  box-shadow: none;
}
.card-wizard .picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}
.card-wizard .wizard-navigation {
  position: relative;
}
.card-wizard .wizard-navigation .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-wizard .wizard-navigation .nav-link i,
.card-wizard .moving-tab i {
  display: inline-block;
  font-size: 19px;
  line-height: normal;
  line-height: initial;
  margin-right: 6px;
  padding: 0;
  vertical-align: bottom;
}
.card-wizard .moving-tab i {
  margin-right: 9px;
}
.card-wizard .picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 1px solid #E3E3E3;
  color: #FFFFFF;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .picture:hover {
  border-color: #2ca8ff;
}
.card-wizard .moving-tab {
  position: absolute;
  text-align: center;
  padding: 12px;
  font-size: 12px;
  text-transform: uppercase;
  -webkit-font-smoothing: subpixel-antialiased;
  top: 0px;
  left: 0px;
  background-color: #66615B;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #FFFFFF !important;
  cursor: pointer;
  font-weight: 500;
}
.card-wizard .picture input[type=file] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
.card-wizard .picture-src {
  width: 100%;
}
.card-wizard .tab-content {
  min-height: 355px;
  padding: 20px 0;
}
.card-wizard .wizard-footer {
  padding: 0 15px;
}
.card-wizard .wizard-footer .checkbox {
  margin-top: 16px;
}
.card-wizard .disabled {
  display: none;
}
.card-wizard .wizard-header {
  text-align: center;
  padding: 25px 0 35px;
}
.card-wizard .wizard-header h5 {
  margin: 5px 0 0;
}
.card-wizard .nav-pills > li {
  text-align: center;
}
.card-wizard .btn {
  text-transform: uppercase;
}
.card-wizard .info-text {
  text-align: center;
  font-weight: 300;
  margin: 10px 0 30px;
}
.card-wizard .choice {
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.card-wizard .choice[disabled] {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.card-wizard .choice .icon {
  text-align: center;
  vertical-align: middle;
  height: 116px;
  width: 116px;
  border-radius: 50%;
  color: #66615B;
  margin: 0 auto 20px;
  border: 1px solid #E3E3E3;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .choice i {
  font-size: 30px;
  line-height: 116px;
  position: absolute;
  left: 0;
  right: 0;
}
.card-wizard .choice:hover .icon, .card-wizard .choice.active .icon {
  border-color: #2ca8ff;
}
.card-wizard .choice input[type=radio],
.card-wizard .choice input[type=checkbox] {
  position: absolute;
  left: -10000px;
  z-index: -1;
}
.card-wizard .btn-finish {
  display: none;
}
.card-wizard .card-title + .description {
  font-size: 17px;
  margin-bottom: 32px;
}
.card-wizard .wizard-title {
  margin: 0;
}
.card-wizard .nav-pills {
  background-color: #9A9A9A;
}
.card-wizard .nav-pills > li + li {
  margin-left: 0;
}
.card-wizard .nav-pills > li > a {
  border: 0 !important;
  border-radius: 0;
  line-height: 18px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  min-width: 100px;
  text-align: center;
  color: #FFFFFF !important;
}
.card-wizard .nav-pills > li.active > a,
.card-wizard .nav-pills > li.active > a:hover,
.card-wizard .nav-pills > li.active > a:focus,
.card-wizard .nav-pills > li > a:hover,
.card-wizard .nav-pills > li > a:focus {
  background-color: inherit;
  box-shadow: none;
}
.card-wizard .nav-pills > li i {
  display: block;
  font-size: 30px;
  padding: 15px 0;
}
.card-wizard .form-group.select-wizard {
  margin-top: 15px;
}
.card-wizard .dropdown.show .dropdown-menu,
.card-wizard .dropup.show .dropdown-menu {
  transform: translate3d(0, 0px, 0) !important;
}

/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  width: 260px;
  padding: 4px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border-radius: 0.125rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #FFFFFF;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.rdtPicker:after {
  border-bottom: 0.4em solid #FFFFFF;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  top: -5px;
  left: 10px;
}

.rdtPicker {
  display: block;
  top: 40px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #FFFFFF !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  height: 30px;
  line-height: 33px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover {
  background-color: #51cbce !important;
  color: #FFFFFF;
}

.rdtDays tr .dow {
  text-align: center;
  border-bottom: 1px solid #E3E3E3;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: inherit;
  padding-bottom: 5px;
  padding-top: 10px;
}
.rdtDays tr .rdtOld,
.rdtDays tr .rdtNew {
  color: #DDDDDD;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker .dow {
  width: 14.2857%;
  border-bottom: none;
}

.rdtPicker th.rdtSwitch {
  width: 50px;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 21px;
  vertical-align: top;
  border-radius: 50%;
  line-height: 33px;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
  color: #51cbce;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: inherit;
  margin: 3px;
  border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #51cbce;
  border-radius: 50%;
  border: 1px solid #51cbce;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #DDDDDD;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: inherit;
  line-height: 25px;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: inherit;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive,
.rdtMonths .rdtYear.rdtActive,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtYear.rdtActive {
  background-color: #51cbce !important;
  color: #FFFFFF;
}

svg {
  touch-action: none;
}

.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #CDCDCD;
  border-radius: 3px;
  background: #292929;
  color: white;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
}

.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #292929;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin, .jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

/**
* React Select v1.0.0-rc.10
* ============
* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/
* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
* MIT License: https://github.com/JedWatson/react-select
*/
/*
This file was modified entirely by Creative Tim for React-Select v2.0.0
*/
.react-select .react-select__menu {
  top: 105%;
  max-width: 94%;
  width: 94%;
  right: 3%;
  border-radius: 12px;
  border: 0;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.125);
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;
  background-color: #FFFFFF;
  box-sizing: border-box;
  max-height: 200px;
  position: absolute;
  z-index: 2;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 10px;
  margin-bottom: 0;
  margin-bottom: initial;
  margin-top: 0;
  margin-top: initial;
}
.react-select .react-select__menu:before {
  border-bottom: 11px solid #f1eae0;
  top: -11px;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 15px;
}
.react-select .react-select__menu:after {
  top: -10px;
  border-bottom: 11px solid #fffcf5;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 15px;
}
.react-select .react-select__menu-list {
  max-height: 198px;
  overflow-y: auto;
  padding-bottom: 0;
  padding-bottom: initial;
  padding-top: 0;
  padding-top: initial;
  position: relative;
}
.react-select .react-select__option {
  font-size: 0.8571em;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin-top: 5px;
  transition: all 150ms linear;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: block;
  outline: none;
  color: #292b2c;
}
.react-select .react-select__menu .react-select__option, .react-select .react-select__menu .react-select__option:active {
  background-color: transparent;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-selected, .react-select .react-select__menu .react-select__option.react-select__option--is-selected:active, .react-select .react-select__menu .react-select__option.react-select__option--is-selected.react-select__option--is-focused, .react-select .react-select__menu .react-select__option.react-select__option--is-selected.react-select__option--is-focused:active {
  background-color: #DDDDDD;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-focused, .react-select .react-select__menu .react-select__option.react-select__option--is-focused:active {
  background-color: #F5F5F5;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-disabled, .react-select .react-select__menu .react-select__option.react-select__option--is-disabled:active {
  color: #cccccc;
  cursor: default;
}
.react-select .react-select__control {
  border-radius: 4px;
  min-height: 40px;
  height: 40px;
  box-sizing: border-box;
  border-collapse: separate;
  display: table;
  width: 100%;
}
.react-select .react-select__control, .react-select .react-select__control:hover {
  border: 1px solid #E3E3E3;
  box-shadow: none;
  background-color: transparent;
}
.react-select .react-select__control.react-select__control--is-focused .react-select__dropdown-indicator:after {
  transform: rotate(180deg);
  top: -4px;
}
.react-select .react-select__control.react-select__control--is-focused, .react-select .react-select__control.react-select__control--is-focused:hover {
  border: 1px solid #51cbce;
  box-shadow: none;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value {
  display: inline-flex;
  border-radius: 4px;
  background-color: transparent;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value + div:not(.react-select__multi-value) {
  display: inline-flex;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value .react-select__multi-value__label {
  font-size: 0.9em;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__single-value {
  top: 48%;
  color: #2c2c2c;
}
.react-select .react-select__control .react-select__placeholder {
  color: #9A9A9A;
  line-height: normal;
  font-size: 0.8571em;
  top: 48%;
}
.react-select .react-select__control .react-select__value-container,
.react-select .react-select__control .react-select__indicators {
  display: table-cell;
}
.react-select .react-select__control .react-select__indicators {
  width: 60px;
  padding-right: 10px;
  align-items: flex-end;
  vertical-align: middle;
  text-align: right;
}
.react-select .react-select__control .react-select__indicators .react-select__indicator-separator {
  display: none;
}
.react-select .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0;
  display: inline-block;
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator:after {
  transition: all 150ms ease 0s;
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
  position: relative;
  content: "";
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator:hover:after {
  border-top-color: #666666;
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator > * {
  display: none;
}
.react-select .react-select__control .react-select__indicators .react-select__clear-indicator:before {
  content: "×";
  display: inline-block;
  font-size: 18px;
  line-height: 1;
  top: 2px;
  position: relative;
  margin-right: 3px;
}
.react-select .react-select__control .react-select__indicators .react-select__clear-indicator > * {
  display: none;
}
.react-select.primary .react-select__control.react-select__control--is-focused, .react-select.primary .react-select__control.react-select__control--is-focused:hover {
  border-color: #51cbce;
}
.react-select.primary .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.primary .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #51cbce;
}
.react-select.primary .react-select__multi-value {
  border: 1px solid #51cbce;
}
.react-select.primary .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(249, 99, 50, 0.3);
  border-left: 1px solid rgba(249, 99, 50, 0.3);
}
.react-select.primary .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #51cbce;
  background-color: transparent;
}
.react-select.success .react-select__control.react-select__control--is-focused, .react-select.success .react-select__control.react-select__control--is-focused:hover {
  border-color: #6bd098;
}
.react-select.success .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.success .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #6bd098;
}
.react-select.success .react-select__multi-value {
  border: 1px solid #6bd098;
}
.react-select.success .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(24, 206, 15, 0.3);
  border-left: 1px solid rgba(24, 206, 15, 0.3);
}
.react-select.success .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #6bd098;
  background-color: transparent;
}
.react-select.info .react-select__control.react-select__control--is-focused, .react-select.info .react-select__control.react-select__control--is-focused:hover {
  border-color: #51bcda;
}
.react-select.info .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.info .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #51bcda;
}
.react-select.info .react-select__multi-value {
  border: 1px solid #51bcda;
}
.react-select.info .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(44, 168, 255, 0.3);
  border-left: 1px solid rgba(44, 168, 255, 0.3);
}
.react-select.info .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #51bcda;
  background-color: transparent;
}
.react-select.warning .react-select__control.react-select__control--is-focused, .react-select.warning .react-select__control.react-select__control--is-focused:hover {
  border-color: #fbc658;
}
.react-select.warning .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.warning .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #fbc658;
}
.react-select.warning .react-select__multi-value {
  border: 1px solid #fbc658;
}
.react-select.warning .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(255, 178, 54, 0.3);
  border-left: 1px solid rgba(255, 178, 54, 0.3);
}
.react-select.warning .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #fbc658;
  background-color: transparent;
}
.react-select.danger .react-select__control.react-select__control--is-focused, .react-select.danger .react-select__control.react-select__control--is-focused:hover {
  border-color: #ef8157;
}
.react-select.danger .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.danger .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #ef8157;
}
.react-select.danger .react-select__multi-value {
  border: 1px solid #ef8157;
}
.react-select.danger .react-select__multi-value .react-select__multi-value__remove {
  color: rgba(255, 54, 54, 0.3);
  border-left: 1px solid rgba(255, 54, 54, 0.3);
}
.react-select.danger .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #ef8157;
  background-color: transparent;
}
.react-select .react-select__multi-value {
  border: 1px solid #9A9A9A;
}
.react-select .react-select__multi-value .react-select__multi-value__remove {
  position: relative;
  color: rgba(222, 222, 222, 0.8);
  border-left: 1px solid rgba(222, 222, 222, 0.8);
}
.react-select .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #9A9A9A;
  background-color: transparent;
}
.react-select.react-select--is-disabled .react-select__multi-value--is-disabled .react-select__multi-value__remove {
  display: none;
}
.react-select.react-select--is-disabled .react-select__multi-value--is-disabled.react-select__multi-value {
  background-color: #fcfcfc;
  border: 1px solid #e3e3e3;
}
.react-select.react-select--is-disabled .react-select__control--is-disabled {
  background-color: #f9f9f9;
}

.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: transparent;
}
.ReactTable.primary-pagination .-pagination .-btn {
  background-color: #51cbce;
  color: #FFFFFF;
}
.ReactTable.primary-pagination .-pagination .-btn:hover, .ReactTable.primary-pagination .-pagination .-btn:focus, .ReactTable.primary-pagination .-pagination .-btn:active, .ReactTable.primary-pagination .-pagination .-btn.active, .ReactTable.primary-pagination .-pagination .-btn:active:focus, .ReactTable.primary-pagination .-pagination .-btn:active:hover, .ReactTable.primary-pagination .-pagination .-btn.active:focus, .ReactTable.primary-pagination .-pagination .-btn.active:hover, .show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle, .show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle:focus, .show > .ReactTable.primary-pagination .-pagination .-btn.dropdown-toggle:hover {
  background-color: #34b5b8 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.ReactTable.primary-pagination .-pagination .-btn:not([data-action]):hover {
  box-shadow: none;
}
.ReactTable.primary-pagination .-pagination .-btn.disabled, .ReactTable.primary-pagination .-pagination .-btn.disabled:hover, .ReactTable.primary-pagination .-pagination .-btn.disabled:focus, .ReactTable.primary-pagination .-pagination .-btn.disabled.focus, .ReactTable.primary-pagination .-pagination .-btn.disabled:active, .ReactTable.primary-pagination .-pagination .-btn.disabled.active, .ReactTable.primary-pagination .-pagination .-btn:disabled, .ReactTable.primary-pagination .-pagination .-btn:disabled:hover, .ReactTable.primary-pagination .-pagination .-btn:disabled:focus, .ReactTable.primary-pagination .-pagination .-btn:disabled.focus, .ReactTable.primary-pagination .-pagination .-btn:disabled:active, .ReactTable.primary-pagination .-pagination .-btn:disabled.active, .ReactTable.primary-pagination .-pagination .-btn[disabled], .ReactTable.primary-pagination .-pagination .-btn[disabled]:hover, .ReactTable.primary-pagination .-pagination .-btn[disabled]:focus, .ReactTable.primary-pagination .-pagination .-btn[disabled].focus, .ReactTable.primary-pagination .-pagination .-btn[disabled]:active, .ReactTable.primary-pagination .-pagination .-btn[disabled].active, fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn, fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:hover, fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:focus, fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn.focus, fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn:active, fieldset[disabled] .ReactTable.primary-pagination .-pagination .-btn.active {
  background-color: #51cbce;
  border-color: #51cbce;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-simple {
  color: #51cbce;
  border-color: #51cbce;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-simple:hover, .ReactTable.primary-pagination .-pagination .-btn.btn-simple:focus, .ReactTable.primary-pagination .-pagination .-btn.btn-simple:active {
  background-color: transparent;
  color: #34b5b8;
  border-color: #34b5b8;
  box-shadow: none;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-link {
  color: #51cbce;
}
.ReactTable.primary-pagination .-pagination .-btn.btn-link:hover, .ReactTable.primary-pagination .-pagination .-btn.btn-link:focus, .ReactTable.primary-pagination .-pagination .-btn.btn-link:active, .ReactTable.primary-pagination .-pagination .-btn.btn-link:active:focus {
  background-color: transparent;
  color: #34b5b8;
  text-decoration: none;
  box-shadow: none;
}
.ReactTable.primary-pagination .-pagination .-btn:disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
  cursor: not-allowed;
}
.ReactTable.info-pagination .-pagination .-btn {
  background-color: #51bcda;
  color: #FFFFFF;
}
.ReactTable.info-pagination .-pagination .-btn:hover, .ReactTable.info-pagination .-pagination .-btn:focus, .ReactTable.info-pagination .-pagination .-btn:active, .ReactTable.info-pagination .-pagination .-btn.active, .ReactTable.info-pagination .-pagination .-btn:active:focus, .ReactTable.info-pagination .-pagination .-btn:active:hover, .ReactTable.info-pagination .-pagination .-btn.active:focus, .ReactTable.info-pagination .-pagination .-btn.active:hover, .show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle, .show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle:focus, .show > .ReactTable.info-pagination .-pagination .-btn.dropdown-toggle:hover {
  background-color: #2ba9cd !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.ReactTable.info-pagination .-pagination .-btn:not([data-action]):hover {
  box-shadow: none;
}
.ReactTable.info-pagination .-pagination .-btn.disabled, .ReactTable.info-pagination .-pagination .-btn.disabled:hover, .ReactTable.info-pagination .-pagination .-btn.disabled:focus, .ReactTable.info-pagination .-pagination .-btn.disabled.focus, .ReactTable.info-pagination .-pagination .-btn.disabled:active, .ReactTable.info-pagination .-pagination .-btn.disabled.active, .ReactTable.info-pagination .-pagination .-btn:disabled, .ReactTable.info-pagination .-pagination .-btn:disabled:hover, .ReactTable.info-pagination .-pagination .-btn:disabled:focus, .ReactTable.info-pagination .-pagination .-btn:disabled.focus, .ReactTable.info-pagination .-pagination .-btn:disabled:active, .ReactTable.info-pagination .-pagination .-btn:disabled.active, .ReactTable.info-pagination .-pagination .-btn[disabled], .ReactTable.info-pagination .-pagination .-btn[disabled]:hover, .ReactTable.info-pagination .-pagination .-btn[disabled]:focus, .ReactTable.info-pagination .-pagination .-btn[disabled].focus, .ReactTable.info-pagination .-pagination .-btn[disabled]:active, .ReactTable.info-pagination .-pagination .-btn[disabled].active, fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn, fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:hover, fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:focus, fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn.focus, fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn:active, fieldset[disabled] .ReactTable.info-pagination .-pagination .-btn.active {
  background-color: #51bcda;
  border-color: #51bcda;
}
.ReactTable.info-pagination .-pagination .-btn.btn-simple {
  color: #51bcda;
  border-color: #51bcda;
}
.ReactTable.info-pagination .-pagination .-btn.btn-simple:hover, .ReactTable.info-pagination .-pagination .-btn.btn-simple:focus, .ReactTable.info-pagination .-pagination .-btn.btn-simple:active {
  background-color: transparent;
  color: #2ba9cd;
  border-color: #2ba9cd;
  box-shadow: none;
}
.ReactTable.info-pagination .-pagination .-btn.btn-link {
  color: #51bcda;
}
.ReactTable.info-pagination .-pagination .-btn.btn-link:hover, .ReactTable.info-pagination .-pagination .-btn.btn-link:focus, .ReactTable.info-pagination .-pagination .-btn.btn-link:active, .ReactTable.info-pagination .-pagination .-btn.btn-link:active:focus {
  background-color: transparent;
  color: #2ba9cd;
  text-decoration: none;
  box-shadow: none;
}
.ReactTable.info-pagination .-pagination .-btn:disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
  cursor: not-allowed;
}
.ReactTable.success-pagination .-pagination .-btn {
  background-color: #6bd098;
  color: #FFFFFF;
}
.ReactTable.success-pagination .-pagination .-btn:hover, .ReactTable.success-pagination .-pagination .-btn:focus, .ReactTable.success-pagination .-pagination .-btn:active, .ReactTable.success-pagination .-pagination .-btn.active, .ReactTable.success-pagination .-pagination .-btn:active:focus, .ReactTable.success-pagination .-pagination .-btn:active:hover, .ReactTable.success-pagination .-pagination .-btn.active:focus, .ReactTable.success-pagination .-pagination .-btn.active:hover, .show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle, .show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle:focus, .show > .ReactTable.success-pagination .-pagination .-btn.dropdown-toggle:hover {
  background-color: #44c47d !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.ReactTable.success-pagination .-pagination .-btn:not([data-action]):hover {
  box-shadow: none;
}
.ReactTable.success-pagination .-pagination .-btn.disabled, .ReactTable.success-pagination .-pagination .-btn.disabled:hover, .ReactTable.success-pagination .-pagination .-btn.disabled:focus, .ReactTable.success-pagination .-pagination .-btn.disabled.focus, .ReactTable.success-pagination .-pagination .-btn.disabled:active, .ReactTable.success-pagination .-pagination .-btn.disabled.active, .ReactTable.success-pagination .-pagination .-btn:disabled, .ReactTable.success-pagination .-pagination .-btn:disabled:hover, .ReactTable.success-pagination .-pagination .-btn:disabled:focus, .ReactTable.success-pagination .-pagination .-btn:disabled.focus, .ReactTable.success-pagination .-pagination .-btn:disabled:active, .ReactTable.success-pagination .-pagination .-btn:disabled.active, .ReactTable.success-pagination .-pagination .-btn[disabled], .ReactTable.success-pagination .-pagination .-btn[disabled]:hover, .ReactTable.success-pagination .-pagination .-btn[disabled]:focus, .ReactTable.success-pagination .-pagination .-btn[disabled].focus, .ReactTable.success-pagination .-pagination .-btn[disabled]:active, .ReactTable.success-pagination .-pagination .-btn[disabled].active, fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn, fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:hover, fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:focus, fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn.focus, fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn:active, fieldset[disabled] .ReactTable.success-pagination .-pagination .-btn.active {
  background-color: #6bd098;
  border-color: #6bd098;
}
.ReactTable.success-pagination .-pagination .-btn.btn-simple {
  color: #6bd098;
  border-color: #6bd098;
}
.ReactTable.success-pagination .-pagination .-btn.btn-simple:hover, .ReactTable.success-pagination .-pagination .-btn.btn-simple:focus, .ReactTable.success-pagination .-pagination .-btn.btn-simple:active {
  background-color: transparent;
  color: #44c47d;
  border-color: #44c47d;
  box-shadow: none;
}
.ReactTable.success-pagination .-pagination .-btn.btn-link {
  color: #6bd098;
}
.ReactTable.success-pagination .-pagination .-btn.btn-link:hover, .ReactTable.success-pagination .-pagination .-btn.btn-link:focus, .ReactTable.success-pagination .-pagination .-btn.btn-link:active, .ReactTable.success-pagination .-pagination .-btn.btn-link:active:focus {
  background-color: transparent;
  color: #44c47d;
  text-decoration: none;
  box-shadow: none;
}
.ReactTable.success-pagination .-pagination .-btn:disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
  cursor: not-allowed;
}
.ReactTable.warning-pagination .-pagination .-btn {
  background-color: #fbc658;
  color: #FFFFFF;
}
.ReactTable.warning-pagination .-pagination .-btn:hover, .ReactTable.warning-pagination .-pagination .-btn:focus, .ReactTable.warning-pagination .-pagination .-btn:active, .ReactTable.warning-pagination .-pagination .-btn.active, .ReactTable.warning-pagination .-pagination .-btn:active:focus, .ReactTable.warning-pagination .-pagination .-btn:active:hover, .ReactTable.warning-pagination .-pagination .-btn.active:focus, .ReactTable.warning-pagination .-pagination .-btn.active:hover, .show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle, .show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle:focus, .show > .ReactTable.warning-pagination .-pagination .-btn.dropdown-toggle:hover {
  background-color: #fab526 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.ReactTable.warning-pagination .-pagination .-btn:not([data-action]):hover {
  box-shadow: none;
}
.ReactTable.warning-pagination .-pagination .-btn.disabled, .ReactTable.warning-pagination .-pagination .-btn.disabled:hover, .ReactTable.warning-pagination .-pagination .-btn.disabled:focus, .ReactTable.warning-pagination .-pagination .-btn.disabled.focus, .ReactTable.warning-pagination .-pagination .-btn.disabled:active, .ReactTable.warning-pagination .-pagination .-btn.disabled.active, .ReactTable.warning-pagination .-pagination .-btn:disabled, .ReactTable.warning-pagination .-pagination .-btn:disabled:hover, .ReactTable.warning-pagination .-pagination .-btn:disabled:focus, .ReactTable.warning-pagination .-pagination .-btn:disabled.focus, .ReactTable.warning-pagination .-pagination .-btn:disabled:active, .ReactTable.warning-pagination .-pagination .-btn:disabled.active, .ReactTable.warning-pagination .-pagination .-btn[disabled], .ReactTable.warning-pagination .-pagination .-btn[disabled]:hover, .ReactTable.warning-pagination .-pagination .-btn[disabled]:focus, .ReactTable.warning-pagination .-pagination .-btn[disabled].focus, .ReactTable.warning-pagination .-pagination .-btn[disabled]:active, .ReactTable.warning-pagination .-pagination .-btn[disabled].active, fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn, fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:hover, fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:focus, fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn.focus, fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn:active, fieldset[disabled] .ReactTable.warning-pagination .-pagination .-btn.active {
  background-color: #fbc658;
  border-color: #fbc658;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-simple {
  color: #fbc658;
  border-color: #fbc658;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-simple:hover, .ReactTable.warning-pagination .-pagination .-btn.btn-simple:focus, .ReactTable.warning-pagination .-pagination .-btn.btn-simple:active {
  background-color: transparent;
  color: #fab526;
  border-color: #fab526;
  box-shadow: none;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-link {
  color: #fbc658;
}
.ReactTable.warning-pagination .-pagination .-btn.btn-link:hover, .ReactTable.warning-pagination .-pagination .-btn.btn-link:focus, .ReactTable.warning-pagination .-pagination .-btn.btn-link:active, .ReactTable.warning-pagination .-pagination .-btn.btn-link:active:focus {
  background-color: transparent;
  color: #fab526;
  text-decoration: none;
  box-shadow: none;
}
.ReactTable.warning-pagination .-pagination .-btn:disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
  cursor: not-allowed;
}
.ReactTable.danger-pagination .-pagination .-btn {
  background-color: #ef8157;
  color: #FFFFFF;
}
.ReactTable.danger-pagination .-pagination .-btn:hover, .ReactTable.danger-pagination .-pagination .-btn:focus, .ReactTable.danger-pagination .-pagination .-btn:active, .ReactTable.danger-pagination .-pagination .-btn.active, .ReactTable.danger-pagination .-pagination .-btn:active:focus, .ReactTable.danger-pagination .-pagination .-btn:active:hover, .ReactTable.danger-pagination .-pagination .-btn.active:focus, .ReactTable.danger-pagination .-pagination .-btn.active:hover, .show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle, .show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle:focus, .show > .ReactTable.danger-pagination .-pagination .-btn.dropdown-toggle:hover {
  background-color: #eb6532 !important;
  color: #FFFFFF !important;
  box-shadow: none !important;
}
.ReactTable.danger-pagination .-pagination .-btn:not([data-action]):hover {
  box-shadow: none;
}
.ReactTable.danger-pagination .-pagination .-btn.disabled, .ReactTable.danger-pagination .-pagination .-btn.disabled:hover, .ReactTable.danger-pagination .-pagination .-btn.disabled:focus, .ReactTable.danger-pagination .-pagination .-btn.disabled.focus, .ReactTable.danger-pagination .-pagination .-btn.disabled:active, .ReactTable.danger-pagination .-pagination .-btn.disabled.active, .ReactTable.danger-pagination .-pagination .-btn:disabled, .ReactTable.danger-pagination .-pagination .-btn:disabled:hover, .ReactTable.danger-pagination .-pagination .-btn:disabled:focus, .ReactTable.danger-pagination .-pagination .-btn:disabled.focus, .ReactTable.danger-pagination .-pagination .-btn:disabled:active, .ReactTable.danger-pagination .-pagination .-btn:disabled.active, .ReactTable.danger-pagination .-pagination .-btn[disabled], .ReactTable.danger-pagination .-pagination .-btn[disabled]:hover, .ReactTable.danger-pagination .-pagination .-btn[disabled]:focus, .ReactTable.danger-pagination .-pagination .-btn[disabled].focus, .ReactTable.danger-pagination .-pagination .-btn[disabled]:active, .ReactTable.danger-pagination .-pagination .-btn[disabled].active, fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn, fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:hover, fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:focus, fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn.focus, fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn:active, fieldset[disabled] .ReactTable.danger-pagination .-pagination .-btn.active {
  background-color: #ef8157;
  border-color: #ef8157;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-simple {
  color: #ef8157;
  border-color: #ef8157;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-simple:hover, .ReactTable.danger-pagination .-pagination .-btn.btn-simple:focus, .ReactTable.danger-pagination .-pagination .-btn.btn-simple:active {
  background-color: transparent;
  color: #eb6532;
  border-color: #eb6532;
  box-shadow: none;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-link {
  color: #ef8157;
}
.ReactTable.danger-pagination .-pagination .-btn.btn-link:hover, .ReactTable.danger-pagination .-pagination .-btn.btn-link:focus, .ReactTable.danger-pagination .-pagination .-btn.btn-link:active, .ReactTable.danger-pagination .-pagination .-btn.btn-link:active:focus {
  background-color: transparent;
  color: #eb6532;
  text-decoration: none;
  box-shadow: none;
}
.ReactTable.danger-pagination .-pagination .-btn:disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
  cursor: not-allowed;
}

.ReactTable .actions-right {
  text-align: right;
}
.ReactTable .actions-left {
  text-align: left;
}
.ReactTable .actions-center {
  text-align: center;
}

.ReactTable * {
  box-sizing: border-box;
}

.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}

.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-thead.-filters input, .ReactTable .rt-thead.-filters select {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  color: #565656;
  font-weight: 400;
  height: 28px;
  background-color: inherit;
  padding-left: 0.8em;
}
.ReactTable .rt-thead.-filters input:focus, .ReactTable .rt-thead.-filters select:focus {
  outline: none;
  border: 1px solid #aaa;
  color: #333;
}

.ReactTable .rt-thead .rt-tr {
  text-align: center;
}

.ReactTable .rt-thead .rt-th:last-child {
  text-align: right;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:after {
  opacity: 0.6;
  content: "\\f0dc";
  position: relative;
  display: inline-block;
  bottom: 0px;
  right: -7px;
  font-family: "FontAwesome";
}

.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-desc > div:first-of-type:after {
  content: "\\f0dd";
  top: -3px;
  position: relative;
  display: inline-block;
  bottom: 0px;
  right: -7px;
  font-family: "FontAwesome";
  opacity: 1;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-asc > div:first-of-type:after {
  content: "\\f0de";
  top: 3px;
  position: relative;
  display: inline-block;
  bottom: 0px;
  right: -7px;
  font-family: "FontAwesome";
  opacity: 1;
}

.ReactTable .rt-thead .rt-th, .ReactTable .rt-thead .rt-td {
  font-size: 1.063rem;
  text-align: left;
  font-weight: 300;
  line-height: 2.5em !important;
  padding: 5px 5px;
  line-height: normal;
  position: relative;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer, .ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}

.ReactTable .rt-thead .rt-th:last-child, .ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-thead .rt-resizable-header {
  overflow: visible;
}

.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}

.ReactTable .rt-thead .rt-resizable-header-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-resizable-header-content:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}

.ReactTable .rt-thead .rt-header-pivot:after, .ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}

.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}

.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}

.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
}

.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}

.ReactTable .rt-th, .ReactTable .rt-td {
  flex: 1 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 12px 7px;
  overflow: hidden;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
  line-height: 2;
}

.ReactTable .rt-th.-hidden, .ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}

.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  margin: 0;
  color: transparent;
  margin: 0 10px;
}

.ReactTable .rt-expander:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}

.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}

.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}

.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}

.ReactTable.-striped .rt-tr.-odd {
  background: rgba(0, 0, 0, 0.03);
}

.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: rgba(0, 0, 0, 0.05);
}

.ReactTable .-pagination {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 3px;
}

.ReactTable .-pagination input, .ReactTable .-pagination select {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  color: #565656;
  font-weight: 400;
  height: 28px;
  background-color: inherit;
  text-align: center;
}
.ReactTable .-pagination input:focus, .ReactTable .-pagination select:focus {
  outline: none;
  border: 1px solid #aaa;
  color: #333;
}

.ReactTable .-pagination .-btn {
  -webkit-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 3px;
  padding: 6px;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.6);
  background: rgba(0, 0, 0, 0.1);
  transition: all 0.1s ease;
  cursor: pointer;
  outline: none;
}

.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.ReactTable .-pagination .-btn:not([disabled]):hover {
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
}

.ReactTable .-pagination .-previous, .ReactTable .-pagination .-next {
  flex: 1 1;
  text-align: center;
}

.ReactTable .-pagination .-center {
  flex: 1.5 1;
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.ReactTable .-pagination .-pageInfo {
  display: inline-block;
  margin: 3px 10px;
  white-space: nowrap;
}

.ReactTable .-pagination .-pageJump {
  display: inline-block;
}

.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}

.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}

.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}

.ReactTable .-loading > div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}

.ReactTable .-loading.-active > div {
  transform: translateY(50%);
}

.ReactTable .rt-resizing .rt-th, .ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead .rt-th:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-th {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  border: 0;
}

.ReactTable .rt-table {
  border: 1px solid #dee2e6;
}

.ReactTable .rt-table .rt-td {
  border-top: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}

.ReactTable .btn.btn-icon {
  margin: 0 3px;
  padding: 5px 8px;
}

.react-tagsinput {
  display: inline-block;
  padding: 4px 6px;
  max-width: 100%;
  line-height: 22px;
}

.react-tagsinput-tag {
  transition: all 0.17s linear;
  cursor: pointer;
  margin: 5px 3px 5px 0;
  position: relative;
  padding: 4px 8px 3px 0.8em;
  border-radius: 12px;
  color: #fff;
  font-size: 0.75em;
  font-weight: 500;
  display: inline-block;
  line-height: 1.5em;
  text-transform: uppercase;
  border: 1px solid;
}

.react-tagsinput-remove {
  cursor: pointer;
  font-weight: bold;
}

.react-tagsinput-tag a::before {
  font-family: "nucleo-icons";
  content: "\\ea4f";
  padding: 0px 2px;
}

.react-tagsinput-tag a {
  cursor: pointer;
  position: absolute;
  top: 3px;
  right: 0px;
  opacity: 0;
  background-color: transparent;
}

.react-tagsinput-input {
  background: transparent;
  border: 0;
  color: #777;
  font-family: sans-serif;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 6px;
  margin-top: 1px;
  outline: none;
  padding: 5px;
  width: 80px;
}

.react-tagsinput .react-tagsinput-tag {
  transition: all 300ms ease 0s;
  border-color: #66615B;
  background-color: #66615B;
}
.react-tagsinput .react-tagsinput-tag:hover {
  padding-right: 22px;
}
.react-tagsinput .react-tagsinput-tag:hover a {
  opacity: 1;
  padding-right: 4px;
}
.react-tagsinput .react-tagsinput-tag.primary {
  border-color: #51cbce;
  background-color: #51cbce;
}
.react-tagsinput .react-tagsinput-tag.info {
  border-color: #51bcda;
  background-color: #51bcda;
}
.react-tagsinput .react-tagsinput-tag.success {
  border-color: #6bd098;
  background-color: #6bd098;
}
.react-tagsinput .react-tagsinput-tag.warning {
  border-color: #fbc658;
  background-color: #fbc658;
}
.react-tagsinput .react-tagsinput-tag.danger {
  border-color: #ef8157;
  background-color: #ef8157;
}
.react-tagsinput .react-tagsinput-tag.neutral {
  border-color: #FFFFFF;
  background-color: #FFFFFF;
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/paper-dashboard.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-bootstrap-switch.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-bootstrap-table.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-nouislider.scss","webpack://./src/assets/scss/paper-dashboard/_variables.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-animate-bootstrap-notify.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-perfect-scrollbar.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-sweetalert2.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-card-wizard.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_wizard.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_vendor-prefixes-extend.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-datetimepicker.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-bootstrap-select.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-jasny-fileupload.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-tagsinput.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-datatables.net.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-jquery.jvectormap.scss","webpack://./src/assets/scss/paper-dashboard/plugins/_plugin-fullcalendar.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_buttons.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_transparency.scss","webpack://./src/assets/scss/paper-dashboard/_nucleo-outline.scss","webpack://./src/assets/scss/paper-dashboard/_buttons.scss","webpack://./src/assets/scss/paper-dashboard/_social-buttons.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_social-buttons.scss","webpack://./src/assets/scss/paper-dashboard/_animated-buttons.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_inputs.scss","webpack://./src/assets/scss/paper-dashboard/_inputs.scss","webpack://./src/assets/scss/paper-dashboard/_typography.scss","webpack://./src/assets/scss/paper-dashboard/_misc.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_badges.scss","webpack://./src/assets/scss/paper-dashboard/_misc-extend.scss","webpack://./src/assets/scss/paper-dashboard/_navbar.scss","webpack://./src/assets/scss/paper-dashboard/_dropdown.scss","webpack://./src/assets/scss/paper-dashboard/_alerts.scss","webpack://./src/assets/scss/paper-dashboard/_images.scss","webpack://./src/assets/scss/paper-dashboard/_tables.scss","webpack://./src/assets/scss/paper-dashboard/_footers.scss","webpack://./src/assets/scss/paper-dashboard/_fixed-plugin.scss","webpack://./src/assets/scss/paper-dashboard/_checkboxes-radio.scss","webpack://./src/assets/scss/paper-dashboard/_progress.scss","webpack://./src/assets/scss/paper-dashboard/_badges.scss","webpack://./src/assets/scss/paper-dashboard/_pagination.scss","webpack://./src/assets/scss/paper-dashboard/_info-areas.scss","webpack://./src/assets/scss/paper-dashboard/_pills.scss","webpack://./src/assets/scss/paper-dashboard/_tabs.scss","webpack://./src/assets/scss/paper-dashboard/_popups.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_popovers.scss","webpack://./src/assets/scss/paper-dashboard/_modals.scss","webpack://./src/assets/scss/paper-dashboard/_carousel.scss","webpack://./src/assets/scss/paper-dashboard/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/paper-dashboard/_timeline.scss","webpack://./src/assets/scss/paper-dashboard/_cards.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-chart.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-map.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-user.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-background.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-collapse.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-contributions.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-info-area.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-lock.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-pricing.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-profile.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-signup.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-stats-mini.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-stats.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-subcategories.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-testimonials.scss","webpack://./src/assets/scss/paper-dashboard/cards/_card-tasks.scss","webpack://./src/assets/scss/paper-dashboard/_example-pages.scss","webpack://./src/assets/scss/paper-dashboard/_sections.scss","webpack://./src/assets/scss/paper-dashboard/mixins/_page-header.scss","webpack://./src/assets/scss/paper-dashboard/_responsive.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_alerts.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_badges.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_buttons.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_cards.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_dropdown.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_example-pages.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_fileupload.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_fixed-plugin.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_inputs.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_modals.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_navbar.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_nucleo-outline.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_pills.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_responsive.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_tabs.scss","webpack://./src/assets/scss/paper-dashboard/react/custom/_timeline.scss","webpack://./src/assets/scss/paper-dashboard/react/plugins/_plugin-nouislider.scss","webpack://./src/assets/scss/paper-dashboard/react/plugins/_plugin-react-big-calendar.scss","webpack://./src/assets/scss/paper-dashboard/react/plugins/_plugin-react-bootstrap-sweetalert.scss","webpack://./src/assets/scss/paper-dashboard/react/plugins/_plugin-react-bootstrap-switch.scss","webpack://./src/assets/scss/paper-dashboard/react/plugins/_plugin-react-bootstrap-wizard.scss","webpack://./src/assets/scss/paper-dashboard/react/plugins/_plugin-react-datetime.scss","webpack://./src/assets/scss/paper-dashboard/react/plugins/_plugin-react-jvectormap.scss","webpack://./src/assets/scss/paper-dashboard/react/plugins/_plugin-react-select.scss","webpack://./src/assets/scss/paper-dashboard/react/plugins/_plugin-react-table.scss","webpack://./src/assets/scss/paper-dashboard/react/plugins/_plugin-react-tagsinput.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;EAAA;ACYC;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EAEA,wEAAA;ADIH;;ACDC;EACE,oBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EAEA,+BAAA;EACA,uBAAA;ADIH;;ACDC;;;EAKI,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,0BAAA;ADIL;ACFK;;;EACI,eAAA;EACA,iBAAA;ADMT;;ACFC;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;ADKH;;ACFC;;EAEE,WAAA;EACA,mBAAA;ADKH;;ACFC;;EAEE,WAAA;EACA,mBAAA;ADKH;;ACFC;;EAEE,WAAA;EACA,mBAAA;ADKH;;ACFC;;EAEE,mBAAA;EACA,WAAA;ADKH;;ACFC;;EAEE,WAAA;EACA,mBAAA;ADKH;;ACDC;EACE,WAAA;EACA,mBAAA;ADIH;;ACDC;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kEAAA;ADIH;;ACDC;EACE,8BAAA;EACA,2BAAA;ADIH;;ACDC;EACE,gBAAA;ADIH;;ACDC;;EAEE,6BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;ADIH;;ACDC;;EAEE,YAAA;ADIH;;ACDC;;;EAGE,gBAAA;EACA,eAAA;EACA,gBAAA;ADIH;;ACDC;;;EAGE,iBAAA;EACA,eAAA;EACA,gBAAA;ADIH;;ACDC;;;EAGE,iBAAA;EACA,eAAA;EACA,iBAAA;ADIH;;ACDC;;;EAGE,0BAAA;ADIH;;ACDC;;;;;;;;;EASE,YAAA;EACA,yBAAA;EACA,0BAAA;ADIH;;ACDC;EAEE,4BAAA;ADIH;;ACDC;EACE,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;ADIH;;ACDC;EACE,6BAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;ADIH;;ACDC;EACE,4BAAA;ADIH;;ACDC;EACE,6BAAA;ADIH;;ACDC;EACE,sBAAA;EACA,iBAAA;ADIH;;ACDC;EACE,sBAAA;EACA,6BAAA;ADIH;;ACDC;EACE,yBAAA;ADIH;;ACDC;EACE,yBAAA;ADIH;;ACDC;EACE,yBAAA;ADIH;;ACDC;EACE,yBAAA;ADIH;;ACDC;EACE,yBAAA;ADIH;;ACDC;EACE,yBAAA;ADIH;;ACDC;EACE,yBAAA;ADIH;;ACFC;EACE,yBAAA;ADKH;;ACFC;;;;;EAKE,yBAAA;ADKH;;AErRA;;;;EAAA;AAMA;EACI,2BAAA;EACA,gCAAA;EACA,oCAAA;EACA,kBAAA;AFuRJ;;AEpRA;;;;;;EAMI,YAAA;AFuRJ;;AEpRA;;EAEI,mCAAA;AFuRJ;;AEpRA;EACI,kBAAA;AFuRJ;;AEpRA;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;AFuRJ;;AEpRA;EACI,6BAAA;AFuRJ;;AEpRA;;EAEI,gBAAA;AFuRJ;;AEpRA;EACI,6BAAA;AFuRJ;;AEpRA;EACI,gBAAA;EACA,gBAAA;EACA,YAAA;AFuRJ;;AEpRA;EACI,WAAA;AFuRJ;;AEpRA;EACI,SAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;AFuRJ;;AEpRA;EACI,4BAAA;AFuRJ;;AEpRA;EACI,iBAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AFuRJ;;AEpRA;;EAEI,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AFuRJ;;AEpRA;EACI,eAAA;EACA,0BAAA;EACA,4BAAA;EACA,mBAAA;AFuRJ;;AEpRA;EACI,yDAAA;AFuRJ;;AEpRA;EACI,yDAAA;AFuRJ;;AEpRA;EACI,yDAAA;AFuRJ;;AEpRA;EACI,WAAA;AFuRJ;;AEpRA;EACI,8BAAA;AFuRJ;;AEpRA;EACI,gBAAA;AFuRJ;;AEpRA;EACI,iBAAA;AFuRJ;;AEpRA,gCAAA;AACA;EACI,yBAAA;AFuRJ;;AEpRA;EACI,kBAAA;AFuRJ;;AEpRA;;EAEI,yBAAA;AFuRJ;;AEpRA;EACI,kBAAA;AFuRJ;;AEpRA;;EAEI,gBAAA;EACA,mBAAA;AFuRJ;;AEpRA;EACI,SAAA;AFuRJ;;AEpRA;EACI,iBAAA;EACA,wBAAA;AFuRJ;;AEpRA;EACI,iBAAA;EACA,iBAAA;AFuRJ;;AEpRA;EACI,kBAAA;EACA,qBAAA;EACA,sBAAA;AFuRJ;;AEpRA;EACI,gBAAA;AFuRJ;;AEpRA;EACI,qBAAA;AFuRJ;;AEpRA;EACI,iBAAA;AFuRJ;;AEpRA;EACI,gBAAA;AFuRJ;;AEpRA;EACI,cAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;AFuRJ;;AEpRA;;;EAGI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AFuRJ;;AEpRA;EACI,oBAAA;EACA,eAAA;AFuRJ;;AEpRA;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AFuRJ;;AEpRA;EACI,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;AFuRJ;;AEpRA,wBAAA;AACA;EACI,sBAAA;AFuRJ;;AEpRA;EACI,sBAAA;EACA,sBAAA;AFuRJ;;AEpRA;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AFuRJ;;AEpRA;EACI,qBAAA;EACA,4BAAA;AFuRJ;;AEpRA;EACI,gBAAA;AFuRJ;;AEpRA;EACI,2BAAA;EACA,8BAAA;AFuRJ;;AEpRA;EACI,4BAAA;EACA,+BAAA;AFuRJ;;AEpRA;EACI,sBAAA;EACA,6BAAA;AFuRJ;;AEpRA,wBAAA;AACA;EACI,UAAA;EACA,SAAA;AFuRJ;;AEpRA;EACI,qBAAA;AFuRJ;;AEpRA;EACI,mBAAA;EACA,gBAAA;EACA,qBAAA;AFuRJ;;AEpRA;EACI,QAAA;EACA,UAAA;AFuRJ;;AEpRA,8BAAA;AACA;EACI,WAAA;EACA,aAAA;AFuRJ;;AEpRA;EACI,MAAA;EACA,OAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AFuRJ;;AEpRA,6BAAA;AACA;EACI,WAAA;EACA,cAAA;EACA,WAAA;AFuRJ;;AEpRA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AFuRJ;;AEhRI;EACE,wCAAA;EACA,2CAAA;EACA,iBAAA;AFmRN;;AGzlBA,8CAAA;AAGA;;;EAAA;AAIA;;EAEA,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEC,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AH0lBD;;AGxlBA;EACC,kBAAA;EACA,cAAA;AH2lBD;;AGzlBA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA,EAAA,YAAA;AH4lBD;;AG1lBA;EACC,kBAAA;EACA,QAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;AH6lBD;;AG3lBA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;AH8lBD;;AG5lBA;EACC,kBAAA;EACA,UAAA;AH+lBD;;AG7lBA;;EAGC,wDAAA;AHgmBD;;AG9lBA;EACC,0BAAA;AHimBD;;AG9lBA;;EAAA;AAGA;;EAGC,+BAAA;AHimBD;;AG9lBA;EAAA;AAEA;EACC,WAAA;AHimBD;;AG/lBA;EACI,8BAAA,EAAA,iBAAA,EACA,WAAA,EACA,oBAAA,EACA,yBAAA,EACA,iBAAA,EACA,UAAA;EACA,sFAAA,EAAA,QAAA;EACA,wHAAA,EAAA,UAAA;EAEA,kBAAA;EACA,iEAAA;EACH,YAAA;EACA,WAAA;EACA,eAAA;EACG,kBAAA;EACA,gBAAA;AHimBJ;;AG/lBA;EACC,WAAA;AHkmBD;;AGhmBA;EACC,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AHmmBD;;AGhmBA;EAAA;AAEA;EACC,yBAAA;EACA,kBAAA;AHmmBD;;AG/lBA;EACC,mBAAA;EAEG,kBAAA;EAEH,4BAAA;AHimBD;;AG9lBA;EAAA;AAEA;EACC,iBAAA;AHimBD;;AG/lBA;EACC,iBAAA;AHkmBD;;AGhmBA;EAEC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;AHkmBD;;AG9lBA;EACC,yEAAA;AHimBD;;AG5lBA;EAAA;AA2BA;EAAA;AAGA;EACC,mBAAA;AHqkBD;;AGnkBA;;;EAGC,mBAAA;AHskBD;;AGlkBA;;EAAA;AAGA;;EAGC,sBAAA;AHqkBD;;AGnkBA;EACC,kBAAA;EACA,WAAA;AHskBD;;AGnkBA;;EAAA;AAGA;EACC,kBAAA;EACA,kBAAA;AHskBD;;AGpkBA;EACC,WAAA;EACA,eAAA;AHukBD;;AGpkBA;;EAAA;AAGA;EACC,kBAAA;EACA,gBAAA;AHukBD;;AGrkBA;EACC,gBAAA;AHwkBD;;AGtkBA;EACC,gBAAA;AHykBD;;AGtkBA;;EAAA;AAGA;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AHykBD;;AGvkBA;EAEC,oCAAA;AH0kBD;;AGvkBA;EACC,iBAAA;EACA,UAAA;EACA,WAAA;AH0kBD;;AGxkBA;EACC,YAAA;AH2kBD;;AGzkBA;EACC,YAAA;AH4kBD;;AGzkBA;;EAAA;AAGA;EACC,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AH4kBD;;AG1kBA;EAEC,iCAAA;EACA,kBAAA;AH6kBD;;AG1kBA;EACC,UAAA;EACA,WAAA;EACA,gBAAA;AH6kBD;;AG3kBA;EACC,WAAA;AH8kBD;;AG5kBA;EACC,WAAA;AH+kBD;;AG5kBA;EACC,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AH+kBD;;AG7kBA;EAEI,6BAAA;EACA,SAAA;EACA,YAAA;AHglBJ;;AG9kBA;EAEI,6BAAA;EACA,QAAA;EACA,WAAA;AHilBJ;;AG1kBQ;EAEI,yBC9NiB;AJ0yB7B;AGzkBQ;EACI,qBClOiB;AJ6yB7B;AGvkBQ;EAEI,yBC3OiB;AJmzB7B;AGrkBQ;EACI,qBC/OiB;AJszB7B;AGnkBQ;EAEI,yBC/OiB;AJmzB7B;AGjkBQ;EACI,qBCnPiB;AJszB7B;AG/jBQ;EAEI,yBCtPiB;AJszB7B;AG7jBQ;EACI,qBC1PiB;AJyzB7B;;AKz2BA;;;;;CAAA;AAOA;EAEE,sBAAA;EAEA,yBAAA;AL22BF;;AKx2BA;EAEE,mCAAA;AL22BF;;AKx2BA;EAEE,sBAAA;AL22BF;;AKx2BA;;EAGE,yBAAA;AL22BF;;AKx2BA;;EAGE,yBAAA;AL22BF;AKv1BA;EACE;IAEE,+BAAA;ELw2BF;EKr2BA;IAEE,mCAAA;ELu2BF;EKp2BA;IAEE,kCAAA;ELs2BF;AACF;AKn2BA;EAEE,qBAAA;ALq2BF;AKl1BA;EACE;IACE,UAAA;IAEA,mCAAA;ELi2BF;EK91BA;IACE,UAAA;IAEA,eAAA;ELg2BF;AACF;AK71BA;EAEE,0BAAA;AL+1BF;AKj1BA;EACE;IACE,UAAA;EL41BF;EKz1BA;IACE,UAAA;EL21BF;AACF;AKx1BA;EAEE,uBAAA;AL01BF;AK30BA;EACE;IACE,UAAA;ELw1BF;EKr1BA;IACE,UAAA;IAEA,kCAAA;ELu1BF;AACF;AKp1BA;EAEE,2BAAA;ALs1BF;AKv0BA;EACE;IACE,UAAA;ELo1BF;EKj1BA;IACE,UAAA;IAEA,mCAAA;ELm1BF;AACF;AKh1BA;EAEE,yBAAA;ALk1BF;;AMnjCA,8BAAA;AACA;EAEE,kBAAA;EACA,2BAAA;EACA,wBAAA;ANsjCF;;AMrjCE;EACE;IACE,yBAAA;ENwjCJ;AACF;AMxjCE;EACE;IACE,yBAAA;EN0jCJ;AACF;AM1jCE;;EAEE,cAAA;EACA,6BAAA;AN4jCJ;;AM3jCE;EACE,sBAAA;EACA,YAAA;AN8jCJ;;AM7jCI;EACE,sBAAA;EACA,YAAA;ANgkCN;;AM/jCE;EACE,sBAAA;EACA,YAAA;ANkkCJ;;AMjkCI;EACE,sBAAA;EACA,WAAA;ANokCN;;AMnkCE;EACE,aAAA;EACA,kBAAA;EACA,mCAAA;EACA,UAAA;EAIA,6DAAA;EACA,WAAA;EACA,mDAAA;EACA,YAAA;ANskCJ;;AMrkCI;EACE,kBAAA;EACA,mCAAA;EACA,sBAAA;EAGA,kBAAA;EAKA,oHAAA;EAEA,WAAA;EACA,8CAAA;EACA,WAAA;ANwkCN;;AMvkCI;EACE,YAAA;AN0kCN;;AMzkCE;EACE,aAAA;EACA,kBAAA;EACA,mCAAA;EACA,UAAA;EAIA,6DAAA;EACA,QAAA;EACA,kDAAA;EACA,WAAA;AN4kCJ;;AM3kCI;EACE,kBAAA;EACA,mCAAA;EACA,sBAAA;EAGA,kBAAA;EAKA,oHAAA;EAEA,UAAA;EACA,6CAAA;EACA,UAAA;AN8kCN;;AM7kCI;EACE,WAAA;ANglCN;;AM/kCE;EACE,sBAAA;EACA,YAAA;ANklCJ;;AMjlCI;EACE,sBAAA;EACA,YAAA;ANolCN;;AMnlCE;EACE,sBAAA;EACA,YAAA;ANslCJ;;AMrlCI;EACE,sBAAA;EACA,WAAA;ANwlCN;;AMvlCE;;EAEE,YAAA;AN0lCJ;;AMzlCE;EACE,sBAAA;EACA,YAAA;AN4lCJ;;AM3lCI;EACE,sBAAA;AN8lCN;;AM7lCE;EACE,sBAAA;EACA,YAAA;ANgmCJ;;AM/lCI;EACE,sBAAA;ANkmCN;;AOltCA;EACE,kBAAA;APqtCF;;AOntCA;EACE,eAAA;EACA,OAAA;EACA,QAAA;APstCF;;AOptCA;EAGE,aAAA;EAGQ,mBAAA;EACR,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,6BAAA;EACA,aAAA;APutCF;;AOttCE;EAEE,iCAAA;APytCJ;;AOxtCE;EACE,oCAAA;AP2tCJ;;AOztCA;EACE,sBAAA;EACA,2DAAA;EACA,kBAAA;EAEQ,sBAAA;EACR,kBAAA;EACA,YAAA;EACA,8CHmPyB;EGlPzB,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AP4tCF;;AO3tCE;EACE,aAAA;AP8tCJ;;AO7tCE;EACE,kBAAA;APguCJ;;AO/tCE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;APkuCJ;;AOjuCE;EACE,gBAAA;APouCJ;;AOnuCI;EACE,YAAA;EACA,eAAA;APsuCN;;AOruCI;EAEU,sBAAA;EACR,6BAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EAEQ,wDAAA;EACR,yBAAA;EAGQ,iBAAA;APwuCd;;AOvuCI;EACE,iBAAA;EACA,kBAAA;AP0uCN;;AOzuCI;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EAEQ,4BAAA;EACR,+BAAA;EACA,kBAAA;EAEQ,wDAAA;AP4uCd;;AO3uCE;EACE,SAAA;EACA,kBAAA;EAEQ,gBAAA;EACR,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AP8uCJ;;AO7uCI;EACE,aAAA;EAEQ,6DAAA;APgvCd;;AO/uCE;EACE,iBAAA;EACA,eAAA;APkvCJ;;AOjvCE;EACE,uBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EAEA,2BAAA;APovCJ;;AOnvCI;EACE,WAAA;APsvCN;;AOrvCE;;;;;;EAME,aAAA;APwvCJ;;AOvvCE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AP0vCJ;;AOzvCE;;;;;;EAME,iBAAA;AP4vCJ;;AO3vCE;;;EAGE,WAAA;EAEQ,sBAAA;EACR,eAAA;EACA,kBAAA;EACA,yBAAA;EAEQ,+CAAA;EAGR,8CAAA;AP+vCJ;;AO7vCI;;;EAGE,gCAAA;EAEQ,sCAAA;APgwCd;;AO/vCI;;;EAGE,aAAA;EACA,yBAAA;EAEQ,2BAAA;APkwCd;;AOzvCI;;;EAGE,cAAA;APwwCN;;AOvwCE;EACE,WAAA;EACA,UAAA;AP0wCJ;;AOzwCE;EACE,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AP4wCJ;;AO3wCE;;EAEE,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;AP8wCJ;;AO7wCE;EACE,YAAA;EACA,eAAA;APgxCJ;;AO/wCI;EACE,gBAAA;APkxCN;;AOjxCE;EACE,eAAA;APoxCJ;;AOnxCE;EACE,aAAA;EACA,aAAA;APsxCJ;;AOrxCE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;APwxCJ;;AOvxCE;EACE,SAAA;AP0xCJ;;AOzxCI;EACE,iBAAA;AP4xCN;;AO3xCI;;EAEE,sBAAA;AP8xCN;;AO7xCI;EACE,iBAAA;APgyCN;;AO/xCE;EACE,cAAA;APkyCJ;;AOjyCI;;EAEE,sBAAA;APoyCN;;AOnyCE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;APsyCJ;;AOryCI;EACE,YAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;APwyCN;;AOtyCA;EACE;IACE,sBAAA;EPyyCF;EOxyCA;IACE,aAAA;EP0yCF;AACF;AOzyCA;EACE;IACE,sBAAA;EP2yCF;EO1yCA;IACE,aAAA;EP4yCF;AACF;AO3yCA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EAEQ,uBAAA;EACR,eAAA;EACA,yBAAA;EAGQ,iBAAA;AP6yCV;;AO5yCE;EACE,oCAAA;AP+yCJ;;AO9yCI;EACE,kBAAA;EACA,cAAA;APizCN;;AOhzCI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;APmzCN;;AOlzCM;EAEU,wBAAA;EACR,UAAA;APqzCR;;AOpzCM;EAEU,yBAAA;EACR,WAAA;APuzCR;;AOtzCE;EACE,2DAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;APyzCJ;;AOxzCE;EACE,oCAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AP2zCJ;;AO1zCE;EACE,2DAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AP6zCJ;;AO5zCE;EACE,qBAAA;AP+zCJ;;AO9zCI;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EAEQ,wBAAA;APi0Cd;;AOh0CM;EACE,8BAAA;EACA,SAAA;EACA,WAAA;EAEQ,yBAAA;EAEA,2BAAA;APm0ChB;;AOl0CM;EACE,8BAAA;EACA,UAAA;EACA,UAAA;EAEQ,yBAAA;EAEA,wBAAA;APq0ChB;;AOp0CI;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EAEQ,uBAAA;EACR,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;APu0CN;;AOt0CI;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEQ,yBAAA;APy0Cd;;AOx0CI;EACE,WAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AP20CN;;AO10CM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEQ,wBAAA;AP60ChB;;AO50CM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEQ,yBAAA;AP+0ChB;;AO70CA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;APg1CF;;AO/0CE;EACE,qBAAA;EACA,kBAAA;APk1CJ;;AOj1CE;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;APo1CJ;;AOn1CI;EACE,cAAA;APs1CN;;AOr1CI;EACE,eAAA;APw1CN;;AOv1CI;EACE,mBAAA;AP01CN;;AOz1CM;EACE,mBAAA;AP41CR;;AO31CM;EACE,mBAAA;AP81CR;;AO71CE;EACE,mBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;APg2CJ;;AO91CA;EACE,wCAAA;APi2CF;AOj1CA;EACE;IAEU,qBAAA;EPs2CV;EOr2CA;IAEU,sBAAA;EPu2CV;EOt2CA;IAEU,sBAAA;EPw2CV;EOv2CA;IAEU,mBAAA;EPy2CV;AACF;AO91CA;EACE;IAEU,mBAAA;IACR,UAAA;EP42CF;EO32CA;IAEU,qBAAA;IACR,UAAA;EP62CF;AACF;AO52CA;EAEU,8BAAA;AP82CV;;AO72CE;EAEU,eAAA;APg3CZ;;AO92CA;EAEU,wCAAA;APi3CV;;AOh3CE;EAEU,eAAA;APm3CZ;AO31CA;EACE;IACE,QAAA;IACA,SAAA;IACA,SAAA;EPy3CF;EOx3CA;IACE,QAAA;IACA,SAAA;IACA,SAAA;EP03CF;EOz3CA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EP23CF;EO13CA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EP43CF;EO33CA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EP63CF;AACF;AO12CA;EACE;IACE,QAAA;IACA,WAAA;IACA,SAAA;EPk4CF;EOj4CA;IACE,QAAA;IACA,WAAA;IACA,SAAA;EPm4CF;EOl4CA;IACE,WAAA;IACA,QAAA;IACA,SAAA;EPo4CF;EOn4CA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EPq4CF;AACF;AOt3CA;EACE;IAEU,yBAAA;EP04CV;EOz4CA;IAEU,yBAAA;EP24CV;EO14CA;IAEU,0BAAA;EP44CV;EO34CA;IAEU,0BAAA;EP64CV;AACF;AO54CA;EAEU,oCAAA;AP84CV;;AO54CA;EAEU,qCAAA;AP+4CV;;AO74CA;EAEU,0CAAA;APg5CV;AOp4CA;EACE;IAEU,0BAAA;IACR,UAAA;EPm5CF;EOl5CA;IAEU,wBAAA;IACR,UAAA;EPo5CF;AACF;AOn5CA;EAEU,kCAAA;APq5CV;AO93CA;EACE;IAEU,qBAAA;IACR,gBAAA;IACA,UAAA;EP05CF;EOz5CA;IAEU,qBAAA;IACR,gBAAA;IACA,UAAA;EP25CF;EO15CA;IAEU,sBAAA;IACR,gBAAA;EP45CF;EO35CA;IAEU,mBAAA;IACR,aAAA;IACA,UAAA;EP65CF;AACF;AO55CA;EAEU,8BAAA;AP85CV;AOp5CA;EACE;IAEU,uBAAA;EPi6CV;EOh6CA;IAEU,yBAAA;EPk6CV;AACF;AQnmEA;EACI,iBAAA;EACA,8CJsRuB;EIrRvB,UAAA;ECOA,4BAAA;ATmmEJ;AQvmEI;EACI,UAAA;ARymER;AQtmEI;EACE,0BAAA;EACA,oBAAA;ARwmEN;AQrmEI;EACI,aAAA;ARumER;AQpmEI;;;;;;EAMI,6BAAA;EACA,gBAAA;ARsmER;AQnmEI;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;ARqmER;AQlmEI;EACE,kBAAA;ARomEN;AQlmEM;EACE,aAAA;EACA,mBAAA;EAEA,uBAAA;ARomER;AQhmEI;;EAEE,qBAAA;EACA,eAAA;EACA,mBAAA;EAAA,oBAAA;EACA,iBAAA;EACA,UAAA;EACA,sBAAA;ARkmEN;AQ/lEI;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;ARimER;AQ/lEQ;EACI,qBAAA;ARimEZ;AQ7lEI;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,4CAAA;EACA,QAAA;EACA,SAAA;EACA,yBJrBqB;EIsBrB,8CJqMmB;EIpMnB,yBAAA;EACA,eAAA;EACA,gBAAA;AR+lER;AUprEM;EACI,cNoEmB;AJknE7B;AUlrEQ;EACI,qBN+DiB;AJqnE7B;AU7qEY;EACI,qBNuDa;EMtDb,cNsDa;AJynE7B;AUnqEQ;EACI,yBNyCiB;AJ4nE7B;AUjqEI;EACI,yBNoCqB;AJ+nE7B;AUhqEI;EACI,qBNgCqB;AJkoE7B;AUvsEM;EACI,cNYmB;AJ6rE7B;AUrsEQ;EACI,qBNOiB;AJgsE7B;AUhsEY;EACI,qBNDa;EMEb,cNFa;AJosE7B;AUtrEQ;EACI,yBNfiB;AJusE7B;AUprEI;EACI,yBNpBqB;AJ0sE7B;AUnrEI;EACI,qBNxBqB;AJ6sE7B;AU1tEM;EACI,cNuEmB;AJqpE7B;AUxtEQ;EACI,qBNkEiB;AJwpE7B;AUntEY;EACI,qBN0Da;EMzDb,cNyDa;AJ4pE7B;AUzsEQ;EACI,yBN4CiB;AJ+pE7B;AUvsEI;EACI,yBNuCqB;AJkqE7B;AUtsEI;EACI,qBNmCqB;AJqqE7B;AU7uEM;EACI,cN0EmB;AJqqE7B;AU3uEQ;EACI,qBNqEiB;AJwqE7B;AUtuEY;EACI,qBN6Da;EM5Db,cN4Da;AJ4qE7B;AU5tEQ;EACI,yBN+CiB;AJ+qE7B;AU1tEI;EACI,yBN0CqB;AJkrE7B;AUztEI;EACI,qBNsCqB;AJqrE7B;AUhwEM;EACI,cN6EmB;AJqrE7B;AU9vEQ;EACI,qBNwEiB;AJwrE7B;AUzvEY;EACI,qBNgEa;EM/Db,cN+Da;AJ4rE7B;AU/uEQ;EACI,yBNkDiB;AJ+rE7B;AU7uEI;EACI,yBN6CqB;AJksE7B;AU5uEI;EACI,qBNyCqB;AJqsE7B;AUnxEM;EACI,cNgFmB;AJqsE7B;AUjxEQ;EACI,qBN2EiB;AJwsE7B;AU5wEY;EACI,qBNmEa;EMlEb,cNkEa;AJ4sE7B;AUlwEQ;EACI,yBNqDiB;AJ+sE7B;AUhwEI;EACI,yBNgDqB;AJktE7B;AU/vEI;EACI,qBN4CqB;AJqtE7B;AQvrEI;EACI,eAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;ARyrER;AQtrEI;EACI,WAAA;ARwrER;AQrrEI;EACI,iBAAA;EACA,eAAA;ARurER;AQprEI;EACI,eAAA;ARsrER;AQprEQ;EACI,gBAAA;ARsrEZ;AQlrEI;EACI,aAAA;ARorER;AQjrEI;EACI,kBAAA;EACA,oBAAA;ARmrER;AQjrEQ;EACG,eAAA;ARmrEX;AQ/qEI;EACI,kBAAA;ARirER;AQ9qEI;EACI,yBAAA;ARgrER;AQ7qEI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;AR+qER;AQ5qEI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AR8qER;AQ5qEQ;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;AR8qEZ;AQ3qEQ;EACI,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,cJ3HiB;EI4HjB,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;AR6qEZ;AQ1qEQ;EACI,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AR4qEZ;AQvqEY;EACI,qBAAA;ARyqEhB;AQrqEQ;;EAEI,kBAAA;EACA,cAAA;EACA,WAAA;ARuqEZ;AQnqEI;EACI,aAAA;ARqqER;AQlqEI;EACI,eAAA;EACA,mBAAA;ARoqER;AQjqEI;EACI,SAAA;ARmqER;AQhqEI;EACI,yBJtMqB;AJw2E7B;AQhqEQ;EACI,cAAA;ARkqEZ;AQ/pEQ;EACI,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;ARiqEZ;AQ9pEQ;;;;;EAKI,yBAAA;EACA,gBAAA;ARgqEZ;AQ7pEQ;EACI,cAAA;EACA,eAAA;EACA,eAAA;AR+pEZ;AQ3pEE;EACE,gBAAA;AR6pEJ;AQxpEI;;EGvPI,4CAAA;AXu5ER;;AY56EA;;;;EAAA;AAKA;;;;;;;;;;;;;EAaE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AZ+6EF;;AY56EA;EACE,gBAAA;AZ+6EF;;AY76EA;EACE,6BAAA;AZg7EF;;AY96EA;EACE,YAAA;EACA,WAAA;AZi7EF;;AY/6EA;EACE;IACE,WAAA;EZk7EF;AACF;AYh7EA;EACE;IACE,WAAA;EZk7EF;AACF;AYh7EA;EACE;IACE,WAAA;EZk7EF;AACF;AYh7EA;EACI,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AZk7EJ;;AYh7EA;EACI,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AZm7EJ;;AYj7EA;EACE,gBAAA;EACA,oBAAA;AZo7EF;;AYl7EA;EACE,gBAAA;EACA,kBAAA;AZq7EF;;AYn7EA;EACE,UAAA;EACA,UAAA;AZs7EF;;AYp7EA;EACE,UAAA;EACA,UAAA;AZu7EF;;AYr7EA;EACE,SAAA;AZw7EF;;AYt7EA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;AZy7EF;;AYv7EA;;EAEI,yBAAA;AZ07EJ;;AYx7EA;EACE,6BAAA;EACA,gCAAA;AZ27EF;;AYz7EA;EACE,gBAAA;AZ47EF;;AY17EA;;;EAGE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AZ67EF;;AY37EA;EACE,WAAA;EACA,YAAA;EACA,UAAA;AZ87EF;;AY37EA;EACE,0BAAA;AZ87EF;;AY57EA;EACE,4BAAA;AZ+7EF;;AY77EA;EACE,0BAAA;AZg8EF;;AY97EA;EACE,4BAAA;AZi8EF;;AY/7EA;EACE,qBAAA;AZk8EF;;AYh8EA;EACE,uBAAA;AZm8EF;;AYj8EA;EACE,uBAAA;AZo8EF;;AYl8EA;EACE,2BAAA;AZq8EF;;AYn8EA;EACE,gCAAA;AZs8EF;;AYp8EA;EACE,kBAAA;EACA,kBAAA;AZu8EF;;AYr8EA;EACE,uCAAA;AZw8EF;;AYt8EA;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AZy8EF;;AYv8EA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;AZ08EF;;AYx8EA;EACE,WAAA;EACA,SAAA;AZ28EF;;AYz8EA;EACE,kBAAA;AZ48EF;;AY18EA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;AZ68EF;;AY38EA;EACE,YAAA;AZ88EF;;AY58EA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AZ+8EF;;AY78EA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AZg9EF;;AY98EA;EACE,yBAAA;AZi9EF;;AY/8EA;EACE,qBAAA;AZk9EF;;AYh9EA;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AZm9EF;;AYj9EA;EACE,eAAA;AZo9EF;;AYl9EA;EACE,mBAAA;AZq9EF;;AYn9EA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AZs9EF;;AYp9EA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AZu9EF;;AYr9EA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AZw9EF;;AYp9EQ;EHnPJ,4BAAA;AT+sFJ;;AYv9EA;EACE,kBAAA;AZ09EF;;AYx9EA;EACE,mBAAA;EACA,eAAA;AZ29EF;;AYz9EA;EACE,cAAA;AZ49EF;;AY19EA;EACE,WAAA;EACA,qBAAA;EACA,qCAAA;EACA,4BAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AZ69EF;;AY39EA;EACE,yBAAA;EACA,cAAA;AZ89EF;;AY59EA;EACE,4BAAA;AZ+9EF;;AY79EA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AZg+EF;;AY99EA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AZi+EF;;AY/9EA;EACE,mBAAA;AZk+EF;;AYh+EA;EACE,yBAAA;EACA,cAAA;AZm+EF;;AYj+EA;EACE,cAAA;AZo+EF;;AYl+EA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AZq+EF;;AYn+EA;;;EAGE,6BAAA;AZs+EF;;AYp+EA;EACE,YAAA;EACA,iBAAA;AZu+EF;;AYp+EA;EACE,eAAA;AZu+EF;;AYp+EA;;;;;;EAME,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AZu+EF;;AYr+EA;EACE,UAAA;EAEA,yEAAA;EDlUM,8CAAA;AX+yFR;AY1+EE;EDrUM,6CAAA;ECuUJ,UAAA;AZg/EJ;AY7+EE;EACE,UAAA;EACA,iEAAA;ED5UI,4CAAA;AXg0FR;;AYh/EA;EACE,UAAA;EDjVM,6CAAA;ECmVN,iEAAA;AZu/EF;AYr/EI;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AZu/ER;AYr/EI;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AZu/ER;;Aan3FA;;;;;EAAA;AA+BC;;EAEE,wBAAA;Ab61FH;;Aa11FC;EACE,YAAA,EAAA,gBAAA;Ab61FH;Aa11FG;EACE,WAAA;EACA,mBAAA;EACA,UAAA;Ab41FL;Aaz1FG;EACE,6BAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;Ab21FL;Aaz1FK;EACE,MAAA;EACA,OAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;Ab21FP;Aat1FG;EAEE,8BTwCa;AJ+yFlB;Aap1FG;EACE,sBAAA;Abs1FL;Aan1FG;EACE,YAAA;Abq1FL;;Aaj1FC;EACE,gBAAA;EACA,UAAA;EACA,YAAA;Abo1FH;Aal1FG;EACE,WAAA;Abo1FL;Aaj1FG;EACE,aAAA;Abm1FL;Aah1FO;EACE,gBAAA;Abk1FT;;Aa10FG;EAEE,WAAA;EACA,qBAAA;EACA,cAAA;Ab40FL;Aar0FK;EACE,YAAA;Abu0FP;Aan0FG;EAGE,gBAAA;Abm0FL;Aah0FG;EAEE,UAAA;Abi0FL;Aa/zFK;EACE,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;Abi0FP;Aa3zFG;EACE,WAAA;Ab6zFL;Aa1zFG;;EAtIA,mBAAA;Abo8FH;Aa1zFK;;EACE,wBAAA;Ab6zFP;AazzFG;EACE,kBAAA;EACA,oBAAA;EACA,qBAAA;Ab2zFL;AazzFK;EACE,aTqPkB;AJskFzB;AarzFK;EACE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AbuzFP;AanzFG;EACE,WAAA;AbqzFL;AajzFG;EACE,eAAA;EAnKM,sBAoKc;AbqzFzB;AanzFK;EACE,gBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AbqzFP;AalzFK;EACE,kBAAA;AbozFP;AalzFO;EACE,WAAA;AbozFT;AajzFO;EA3LJ,mBAAA;Ab++FH;AahzFO;EACI,cAAA;EACA,eAAA;EACA,0BAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AbkzFX;AahzFS;EACI,yBAAA;EACA,+BAAA;EACA,UAAA;EACA,qBAAA;AbkzFb;AahzFS;EACE,kBAAA;EACA,oBAAA;AbkzFX;Aa/yFS;EACE,aAAA;AbizFX;Aa9yFS;EACE,qBAAA;AbgzFX;Aa5yFO;EACE,mBAAA;Ab8yFT;Aa1yFK;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,8BAAA;EACA,oCAAA;EA9NI,+CA+NgB;EACpB,oBAAA;EACA,YAAA;EAtOI,sBAuOgB;Ab+yF3B;Aa3yFG;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;Ab6yFL;AazyFK;EACE,gBAAA;Ab2yFP;AatyFK;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;AbwyFP;AaryFK;EACE,kBAAA;AbuyFP;;AajyFG;EACE,aAAA;AboyFL;AahyFK;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,iDAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;AbkyFP;Aa/xFK;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;AbiyFP;Aa5xFK;EACE,YAAA;EACA,SAAA;EACA,8CAAA;EACA,gBAAA;Ab8xFP;Aa3xFK;EACE,YAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;Ab6xFP;AaxxFK;EACE,WAAA;EACA,UAAA;Ab0xFP;AavxFK;EACE,WAAA;EACA,UAAA;AbyxFP;AapxFK;EAEE,cAAA;AbqxFP;;AahxFC;;;EAGE,gBAAA;AbmxFH;;AahxFC;EACE,WAAA;EA9UQ,sBA+UY;AbqxFvB;AanxFG;EACE,UAAA;AbqxFL;;AajxFC;EACE,WAAA;EACA,WAAA;EAxVQ,sBAyVY;AbsxFvB;AapxFG;EACE,WAAA;AbsxFL;;AajxFG;EACE,kBAAA;AboxFL;AajxFG;EACE,gBAAA;EACA,WAAA;EACA,WAAA;AbmxFL;;AahxFC;EACI,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AbmxFL;;AahxFC;EACI,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AbmxFL;;AajxFC;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AboxFL;;AalxFC;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AbqxFL;;Aa/wFS;EF9YD,0CAAA;AXqqGR;AapxFa;EAEI,aAAA;AbqxFjB;AahxFS;EFxZD,8CAAA;AX+qGR;;AcpsGA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;AdusGF;;AcrsGA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,wBAAA;EACA,UAAA;EAEA,cAAA;AdusGF;;AcrsGA;EACE,qBAAA;EACA,kBAAA;AdwsGF;;ActsGA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;AdysGF;;AcvsGA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,8CVkPyB;AJw9F3B;AcxsGE;EACI,kBAAA;EACA,gBAAA;Ad0sGN;;AcvsGA;EACE,gBAAA;Ad0sGF;;AcxsGA;EACE,sBAAA;Ad2sGF;;AczsGA;;EAEE,aAAA;Ad4sGF;;Ac1sGA;EACE,eAAA;Ad6sGF;;Ac3sGA;EACE,qBAAA;EACA,gBAAA;EACA,sBAAA;Ad8sGF;;Ac5sGA;EACE,sBAAA;Ad+sGF;;Ac7sGA;EACE,cAAA;AdgtGF;;Ac9sGA;EACE,kBAAA;EACA,UAAA;AditGF;;Ac/sGA;EACE,UAAA;AdktGF;;AchtGA;;EAEE,0BAAA;AdmtGF;;AcjtGA;;;;EAIE,0BAAA;AdotGF;;AcltGA;;EAEE,0BAAA;AdqtGF;;AcntGA;EACE,cVZ2B;AJkuG7B;;AcptGA;EACE,qBVf2B;AJsuG7B;;AcrtGA;EACE,cVf2B;AJuuG7B;;ActtGA;EACE,qBVlB2B;AJ2uG7B;;AcvtGA;EACE,cV9B2B;AJwvG7B;;AcxtGA;EACE,qBVjC2B;AJ4vG7B;;AcztGA;EACE,cAAA;Ad4tGF;;Ac1tGA;EACI,cAAA;EACA,kBAAA;EACA,UAAA;Ad6tGJ;;Ae30GA;EACE,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;Af80GF;Ae50GE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;Af80GJ;Ae50GI;EACE,YAAA;EACA,gBAAA;Af80GN;Ae30GI;EACE,WXmXoB;EWlXpB,UAAA;Af60GN;Ae10GI;EACE,WX8WoB;AJ89F1B;Aez0GI;EACE,WX0WoB;AJi+F1B;Aet0GI;EACE,WXoWoB;AJo+F1B;Aep0GI;EACE,WX+VoB;AJu+F1B;Aen0GI;EACE,WX2VoB;AJ0+F1B;Aej0GE;EAKE,4BAAA;Afm0GJ;Aeh0GE;EACE,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;Afk0GJ;Aeh0GI;EACE,mBAAA;Afk0GN;Aeh0GI;EACE,UAAA;EACA,kBAAA;Afk0GN;Ae/zGI;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;Afi0GN;Ae/zGM;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,6CAAA;Afi0GR;Ae9zGQ;EACE,gDAAA;EACA,UAAA;Afg0GV;;Ae1zGA;EACE,yBAAA;Af6zGF;;AgB36GA;;;;;;;;;;EAAA;AAaC;EACE,WAAA;EACA,0BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;AhB46GH;;AgB16GC;;EAIE,uBAAA;AhB66GH;;AgB36GC;;EAEE,kBAAA;AhB86GH;;AgB56GC;;EAEE,mBAAA;AhB+6GH;;AgB56GC;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AhB+6GH;;AgB76GC;EACE,WAAA;EACA,qBAAA;AhBg7GH;;AgB96GC;EACE,iBAAA;AhBi7GH;;AgB/6GC;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;AhBk7GH;;AgBh7GC;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AhBm7GH;;AgBj7GC;EACE,gBAAA;EACA,mBAAA;AhBo7GH;;AgBl7GC;EACE,SAAA;EACA,mBAAA;EACA,iBAAA;AhBq7GH;;AgBn7GC;EACE,aAAA;EACA,mBAAA;AhBs7GH;;AgBp7GC;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AhBu7GH;;AgBp7GC;;;;EAIE,mBAAA;AhBu7GH;;AgBr7GC;;EAEE,aAAA;AhBw7GH;;AgBt7GC;;;;;EAKE,eAAA;EACA,kBAAA;AhBy7GH;;AgBv7GC;;;;;EAKE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,mCAAA;EACA,YAAA;AhB07GH;;AgBx7GC;EACE,YAAA;EACA,gBAAA;EACA,SAAA;AhB27GH;;AgBz7GC;EACE,gBAAA;EACA,uBAAA;AhB47GH;;AgB17GC;EACE,gBAAA;EACA,2BAAA;AhB67GH;;AgB37GC;;EAEE,WAAA;AhB87GH;;AgB37GC;EACE,2BAAA;AhB87GH;;AgB37GC;EACE,gBAAA;EACA,wBAAA;EACA,2BAAA;AhB87GH;;AgB57GC;;;EAGE,aAAA;AhB+7GH;;AgB77GC;;EAEE,gBAAA;AhBg8GH;;AgB77GC;EACE,wBAAA;EACA,gBAAA;AhBg8GH;;AgB77GC;EACE;;;;IAIE,kBAAA;EhBg8GH;AACF;AgB97GC;EACE,mBAAA;AhBg8GH;;AgB97GC;;;EAGE,QAAA;EACA,UAAA;AhBi8GH;;AgB97GC;;EAEE,oBAAA;AhBi8GH;;AgB/7GC;;;EAGE,qBAAA;AhBk8GH;;AgBh8GC;;EAEE,sBAAA;AhBm8GH;;AgBh8GC;EACE,sBAAA;AhBm8GH;;AgBh8GC;EACE,SAAA;AhBm8GH;;AgBj8GC;EACE,eAAA;AhBo8GH;;AgBl8GC;EACE,gBAAA;AhBq8GH;;AgBx7Ga;;;;;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,YAAA;AhB+7GjB;AgBr7GiB;;;;;EACI,aAAA;AhB27GrB;AgBr7Ga;EACI,YAAA;EACA,gBAAA;AhBu7GjB;AgBl7Ga;EACI,gBAAA;EACA,QAAA;AhBo7GjB;AgB/6Ga;EACI,gBAAA;EACA,SAAA;AhBi7GjB;AgB56GK;EACQ,yBAAA;AhB86Gb;AgBz6GS;;;;;;EAMI,uBAAA;EACA,UAAA;AhB26Gb;AgBv6GK;EACI,aAAA;EACA,gBAAA;AhBy6GT;;AgBn6GK;EACQ,UAAA;AhBs6Gb;;AgBj6GK;;;EAGI,0BAAA;AhBo6GT;AgB95GS;;;EACI,wBAAA;AhBk6Gb;AgB95GK;;EAEI,kBAAA;EACA,kBAAA;EACA,eAAA;AhBg6GT;AgB35GS;;EACI,QAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AhB85Gb;AgBx5GS;;EACI,YAAA;EACA,cAAA;AhB25Gb;AgBt5GS;EACI,aAAA;AhBw5Gb;;AgB/4GS;;EACI,kBAAA;AhBm5Gb;AgB74GS;;EACI,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AhBg5Gb;;AgB14GK;;EAEI,kBAAA;EACA,eAAA;AhB64GT;AgBx4GS;;EACI,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;AhB24Gb;AgBr4GS;;EACI,YAAA;EACA,yBAAA;AhBw4Gb;;AgBl4GK;EACI,kBAAA;AhBq4GT;AgBj4GS;EACI,kCAAA;AhBm4Gb;AgB/3GK;EACI,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;AhBi4GT;AgB93GK;EACI,gCAAA;EACA,gBAAA;AhBg4GT;AgB53GS;EACI,cAAA;AhB83Gb;AgBz3GS;EACI,mBAAA;AhB23Gb;AgBv3GK;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;AhBy3GT;;AgBr3GC;EACI,eAAA;EACA,sBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AhBw3GL;AgBt3GK;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;EACA,0CAAA;AhBw3GT;AgBr3GK;EACI,kBAAA;EACA,YAAA;AhBu3GT;AgBp3GK;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AhBs3GT;AgBl3GS;EACI,yBAAA;AhBo3Gb;AgBh3GK;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;AhBk3GT;;AgB92GC;EACI;IACI,UAAA;EhBi3GP;AACF;AiBp3HA;EACI,kBAAA;AjBs3HJ;;AiBn3HA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AjBs3HJ;;AiBn3HA;EACI,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AjBs3HJ;;AiBn3HA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AjBs3HJ;;AiBn3HA;EACI,WAAA;EACA,YAAA;AjBs3HJ;;AiBn3HA;EACI,SAAA;AjBs3HJ;;AiBn3HA;EACI,SAAA;AjBs3HJ;;AiBn3HA;EACI,YAAA;EACA,aAAA;EACA,YAAA;AjBs3HJ;;AiBn3HA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oEAAA;AjBs3HJ;;AiBn3HA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;AjBs3HJ;;AiBn3HA;EACI,kBAAA;AjBs3HJ;;AiBn3HA;EACI,SAAA;EACA,QAAA;AjBs3HJ;;AiBn3HA;EACI,MAAA;EACA,QAAA;AjBs3HJ;;AiBn3HA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;AjBs3HJ;;AiBn3HA;EACI,WAAA;EACA,qBAAA;EACA,wBAAA;AjBs3HJ;;AiBn3HA;EACI,WAAA;AjBs3HJ;;AiBn3HA;EACI,qBAAA;EACA,YAAA;AjBs3HJ;;AiBn3HA;EACI,WAAA;AjBs3HJ;;AiBn3HA;EACI,YAAA;AjBs3HJ;;AiBn3HA;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;AjBs3HJ;;AiBn3HA;EACI,eAAA;AjBs3HJ;;AiBn3HA;EACI,kBAAA;AjBs3HJ;;AiBn3HA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AjBs3HJ;;AkB3/HA;;;;EAAA;AAMA;EACC,cAAA;EACA,gBAAA;AlB6/HD;;AkB1/HA;EACC,iBAAA;AlB6/HD;;AkB1/HA,WAAA,sCAAA;EACC,cAAA;AlB6/HD;;AkBz/HA;mGAAA;AAGA;;;;;;;EAOC,kBAAA;AlB2/HD;;AkBx/HA;EACC,yBdpB4B;AJ+gI7B;;AkBx/HA;;EAEC,mBdX4B;AJsgI7B;;AkBx/HA;EACC,cd0C4B;AJi9H7B;;AkBx/HA;EACC,mBd7B4B;AJwhI7B;;AkBx/HA,gBAAA,iCAAA;EACC,mBAAA;EACA,YAAA;EACA,yBAAA,EAAA,WAAA;AlB2/HD;;AkBx/HA,cAAA,uCAAA;EACC,8BAAA;EACA,YAAA;EACA,yBAAA,EAAA,WAAA;AlB2/HD;;AkBx/HA,kBAAA,8CAAA;EACC,sCAAA;EACA,mBAAA;AlB2/HD;;AkBv/HA;mGAAA;AAGA;EACC,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;EAEA,uCAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;AlBw/HD;;AkBr/HA;;;;;;CAAA;AAQA;EACC,kBAAA;EACA,cAAA,EAAA,4DAAA;AlBu/HD;;AkBp/HA;EACC,YAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,QAAA;AlBu/HD;;AkBp/HA;EACC,YAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AlBu/HD;;AkBp/HA;EACC,YAAA;EACA,eAAA;EACA,QAAA;AlBu/HD;;AkBp/HA;EACC,YAAA;EACA,eAAA;EACA,QAAA;AlBu/HD;;AkBp/HA;EACC,YAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;AlBu/HD;;AkBp/HA;EACC,YAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;AlBu/HD;;AkBp/HA;EACC,YAAA;EACA,eAAA;EACA,OAAA;AlBu/HD;;AkBp/HA;EACC,YAAA;EACA,eAAA;EACA,OAAA;AlBu/HD;;AkBn/HA;mGAAA;AAGA;EACC,mBdd8B;Ece3B,sBAAA;EACA,iBdxJyB;EcyJzB,6BdnHyB;EcoHzB,ed+F2B;Ec9F3B,gBdkG4B;EchG5B,sBAAA;ECvKA,yBf2DyB;Ee8DrB,cf7GqB;EKJzB,4BAAA;AT0pIJ;AmBhqII;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBwpIR;AmBrpII;EACI,gBAAA;AnBupIR;AmBhpIQ;EAMI,yBf2BiB;Ee1BjB,qBf0BiB;AJmnI7B;AmBljII;EACI,cflEqB;EemErB,qBfnEqB;AJunI7B;AmBljIQ;EAGI,6BfnFiB;EeoFjB,cfvEiB;EewEjB,qBfxEiB;EeyEjB,gBAAA;AnBkjIZ;AmB9iII;EACI,cfhFqB;AJgoI7B;AmB9iIQ;EAII,6BfjGiB;EekGjB,cfrFiB;EesFjB,qBAAA;EACA,gBAAA;AnB6iIZ;AkBrhII;EAEI,qBAAA;AlBshIR;AkBphII;EL9JO,gBKiKkB;EACpB,qBAAA;AlBqhIT;AkBlhII;EACI,mBAAA;EACA,iBAAA;AlBohIR;AkBnhIQ;EACE,iBAAA;AlBqhIV;;AkB9gIA,yCAAA;AACA;EAA+B,SAAA;EAAW,UAAA;AlBmhI1C;;AkBjhIA,oBAAA,cAAA;EACC,iBAAA;AlBohID;;AkBvgIA,qBAAA;AAEA,sBAAA,cAAA;EACC,kBAAA;EACA,YAAA,EAAA,kDAAA;EACA,eAAA;EACA,sBAAA;AlBygID;;AkBtgIA;;;CAAA;AAKA;;;EAGC,cd/M4B;EcgN5B,yBAAA;AlBwgID;;AkBrgIA;;;EAGI,yBdjNyB;EckNzB,qBdlNyB;EcmNzB,eAAA;EE5OF,aF6OgB;EE1OhB,yBAAA;EF2OD,cd7O4B;AJsvI7B;;AkBtgIA;EACC,yBdnO4B;AJ4uI7B;;AkBtgIA;;;;;;EAMC,yBdjM4B;EckMzB,cdjPyB;AJ0vI7B;;AkBpgIA;mGAAA;AAGA;EACC,qBAAA;AlBsgID;;AkBngIA;;;CAAA;AAKA,2BAAA,yDAAA;EACC,WAAA;EACA,iBAAA;AlBqgID;;AkBlgIA,sCAAA,SAAA;EACC,cAAA;AlBqgID;;AkBjgIA;mGAAA;AAGA;EACC,kBAAA;EL1QU,gDTkQgB;AJ6gI3B;;AkBjgIA,yBAAA,kDAAA;EACC,gBAAA;AlBogID;;AkBjgIA;EACC,aAAA;AlBogID;;AkBjgIA;EACC,eAAA;AlBogID;;AkBjgIA;;EAEC,WAAA;AlBogID;;AkBjgIA;;EAEC,YAAA;AlBogID;;AkBjgIA,aAAA;AAEA;EACC,iBAAA;EACA,mBAAA;AlBmgID;;AkBhgIA;EACC,gBAAA;EACA,eAAA;AlBmgID;;AkBhgIA,gBAAA;AAEA;EACC,aAAA,EAAA,oDAAA;AlBkgID;;AkB9/HA;mGAAA;AAGA;EACC,mBAAA;EACA,iBAAA;AlBggID;;AkB7/HA;EACC,SAAA;EACA,SAAA;EACA,gBAAA,EAAA,yDAAA;EACA,mBAAA;AlBggID;;AkB7/HA;EACC,WAAA;AlBggID;;AkB7/HA;;;;EAIC,gEAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AlBggID;;AkB7/HA;EACC,SAAA,EAAA,6BAAA;AlBggID;;AkB7/HA;EACC,YAAA,EAAA,6BAAA;AlBggID;;AkB5/HA;mGAAA;AAGA;EACC,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA,EAAA,4BAAA;AlB8/HD;;AkB3/HA;EACC,iBAAA;EACG,wBAAA;EACA,cdtI2B;EcuI3B,yBAAA;EACA,cdpWyB;EcqWzB,gBd3H4B;Ec4H5B,mBAAA;AlB8/HJ;;AkB3/HA;EACC,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AlB8/HD;;AkB3/HA;EACC,oBAAA,EAAA,iCAAA;AlB8/HD;;AkB3/HA;EACI,SAAA;AlB8/HJ;;AkB3/HA;EACI,gBdxQ2B;AJswI/B;;AkB5/HA;mGAAA;AAGA,cAAA,mFAAA;EACC,+FAAA;EACA,mBAAA;EACA,eAAA;AlB8/HD;;AkB3/HA;EACC;4CAAA;EAEA,iCAAA;EACA,kCAAA;EAEA,8BAAA;EACA,mCAAA;AlB6/HD;;AkB1/HA;EACC,gCAAA,EAAA,+BAAA;AlB6/HD;;AkBz/HA;mGAAA;AAGA;EACC,kBAAA;AlB2/HD;;AkBx/HA;EACC,UAAA;AlB2/HD;;AkBx/HA,mDAAA;AAEA;;EAEC,SAAA,EAAA,sCAAA;AlB0/HD;;AkBv/HA;;EAEC,YAAA,EAAA,sCAAA;AlB0/HD;;AkBv/HA;;EAEC,yBAAA;AlB0/HD;;AkBv/HA;EACC,UAAA;AlB0/HD;;AkBt/HA;EACC,UAAA;AlBy/HD;;AkBt/HA;;;CAAA;AAKA;EACC,kBAAA;EACA,UAAA;EACA,mBAAA,EAAA,uCAAA;AlBw/HD;;AkBr/HA;EACC,UAAA;AlBw/HD;;AkBr/HA;;EAEC,wCAAA;EACA,gBAAA,EAAA,sCAAA;EACA,yBAAA;EAEA,4DAAA;EACA,gBAAA;AlBu/HD;;AkBp/HA;;EAEC,2CAAA;EACA,aAAA;AlBu/HD;;AkBn/HA;mGAAA;AAGA,eAAA,mEAAA;EACC,kBAAA;EACA,kBAAA;AlBq/HD;;AkBl/HA,mBAAA,yCAAA;EACC,kBAAA,EAAA,2BAAA;EACA,WAAA,EAAA,gFAAA;EACA,gBAAA,EAAA,6EAAA;AlBq/HD;;AkBj/HA;mGAAA;AAGA;EACC,kBAAA,EAAA,kDAAA;EACA,cAAA,EAAA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCd1Y4B,Ec0YG,6BAAA;EAC/B,mBAAA,EAAA,sCAAA;AlBm/HD;AkBj/HI;EACI,yCd7YqB;AJg4I7B;AkBj/HI;EACI,0Cd/YqB;AJk4I7B;AkBj/HI;EACI,yCdjZqB;AJo4I7B;AkBj/HI;EACI,yCdnZqB;AJs4I7B;;AkB/+HA,gEAAA;AACA;;;EAGC,cd5gB4B,Ec4gBP,uBAAA;EACrB,qBAAA,EAAA,uBAAA;AlBk/HD;;AkB/+HA;;EAEC,eAAA,EAAA,qEAAA;AlBk/HD;;AkB/+HA;4BAC4B,yCAAA;EAC3B,mBAAA;AlBk/HD;;AkB/+HA,mBAAA,6CAAA;EACC,UAAA;EACA,mBdriB4B;EcsiB5B,aAAA;EACA,yBAAA,EAAA,WAAA;AlBk/HD;;AkB/+HA;EACC,kBAAA;EACA,UAAA;AlBk/HD;;AkB/+HA;EACC,kBAAA;EACA,UAAA;AlBk/HD;;AkB9+HA;mGAAA;AAGA,mGAAA;AAEA;;EAEC,cAAA;EACA,oBAAA;EACA,iBAAA,EAAA,oCAAA;EACA,yBAAA;EACA,4BAAA;AlB++HD;;AkB5+HA;;EAEC,eAAA;EACA,qBAAA;EACA,kBAAA,EAAA,oCAAA;EACA,0BAAA;EACA,6BAAA;AlB++HD;;AkB5+HA,YAAA;AAEA,0BAAA,kDAAA;EACC,SAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AlB8+HD;;AkB3+HA,kBAAA;AACA;;;;;;EAMC,WAAA,EAAA,2CAAA;EACA,gBAAA;AlB8+HD;;AkB3+HA,kBAAA;AACA;;;;;;EAMC,UAAA,EAAA,2CAAA;EACA,gBAAA;AlB8+HD;;AkB1+HA;;;;CAAA;AAMA;EACC,iBAAA,EAAA,qCAAA;EACA,gBAAA;AlB4+HD;;AkBx+HA,iCAAA,qCAAA;EACC,mBAAA;EACA,gBAAA;AlB2+HD;;AkBx+HA;EACC,iBAAA;AlB2+HD;;AkBx+HA,iCAAA,iCAAA;EACC,UAAA;EACA,WAAA;EACA,UAAA;AlB2+HD;;AkBv+HA;mGAAA;AAGA,8CAAA;AAEA;EACC,eAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AlBw+HD;;AkBr+HA;EACC,0BAAA;AlBw+HD;;AkBr+HA,cAAA,4DAAA;EACC,aAAA;AlBw+HD;;AkBr+HA,qDAAA;AAEA;EACC,UAAA,EAAA,iDAAA;AlBu+HD;;AkBp+HA;EACC,UAAA;EACA,YAAA;AlBu+HD;;AkBp+HA;EACC,aAAA;AlBu+HD;;AkBp+HA;mGAAA;AAGA;EACC,kBAAA;EACA,kBAAA;AlBs+HD;;AkBn+HA;EACC,WAAA;EACA,gBAAA;AlBs+HD;;AkBn+HA;EACC,YAAA;AlBs+HD;;AkBn+HA;EACC,qBAAA;AlBs+HD;;AkBn+HA,qDAAA;AACA,0BAAA,uDAAA;EACC,WAAA;EACA,mBAAA;AlBs+HD;;AkBn+HA,0DAAA;AACA,qCAAA,uDAAA;EACC,cAAA;AlBs+HD;;AkBn+HA,eAAA;AAEA;EACC,SAAA;AlBq+HD;;AkBl+HA,4CAAA;AAEA;EACC,kBAAA;AlBo+HD;;AkBj+HA;;EAEC,UAAA;AlBo+HD;;AkBj+HA;EACC,UAAA;AlBo+HD;;AkBj+HA;;EAEC,UAAA;AlBo+HD;;AkBj+HA;EACC,UAAA;AlBo+HD;;AkBh+HA;mGAAA;AAGA,iFAAA;AACA,iGAAA;AACA;;;EAKS,uBAAA;AlBk+HT;;AkB/9HA;mBACmB,6DAAA;EAClB,kBAAA;EACA,UAAA;AlBk+HD;;AkB/9HA;mGAAA;AAGA,sBAAA;AAEA;;EAEC,+DAAA;EACA,gBAAA,EAAA,gEAAA;EACA,mBAAA,EAAA,iEAAA;AlBg+HD;;AkB79HA;EACC,eAAA,EAAA,gDAAA;AlBg+HD;;AkB79HA,gGAAA;AAEA;EACC,gBAAA;AlB+9HD;;AkB59HA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AlB+9HD;;AkB59HA,gCAAA;AAEA;;EAEC,cAAA;AlB89HD;;AkB39HA;;EAEC,YAAA;AlB89HD;;AkB39HA;EACC,kBAAA;AlB89HD;;AkB39HA;EACC,yEAAA;EACA,qBAAA;EACA,iBAAA;AlB89HD;;AkB39HA;EACC,iBAAA;AlB89HD;;AkB39HA;EACC,gBAAA;AlB89HD;;AkB39HA;EACC,YAAA;EACA,yBAAA,EAAA,WAAA;EACA;;qDAAA;AlBg+HD;;AkB39HA;mGAAA;AAGA;EACC,kBAAA;EACA,UAAA,EAAA,uDAAA;AlB69HD;;AkB19HA;EACC,eAAA,EAAA,qDAAA;AlB69HD;;AkB19HA;EACC,gBAAA,EAAA,gEAAA;EACA,mBAAA,EAAA,6DAAA;AlB69HD;;AkBz9HA;mGAAA;AAGA,eAAA,wCAAA;EACC,sBAAA;EACA,cAAA;EACA,mBAAA;AlB29HD;;AkBx9HA;EACC,iBAAA;AlB29HD;;AkBx9HA;EACC,gBAAA;AlB29HD;;AkBx9HA;EACC,mBAAA,EAAA,uCAAA;AlB29HD;;AkBv9HA;mGAAA;AAGA;gBACgB,6DAAA;EACf,kBAAA;EACA,UAAA;AlBy9HD;;AkBt9HA;EACC,gBAAA,EAAA,oEAAA;AlBy9HD;;AkBt9HA,sBAAA,oDAAA;EACC,4BAAA;AlBy9HD;;AkBt9HA;EACC,UAAA;AlBy9HD;;AkBt9HA;qBACqB,mEAAA;EACpB,kBAAA;EACA,UAAA;AlBy9HD;;AkBt9HA;;EAEC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AlBy9HD;;AkBt9HA;EACC,UAAA;AlBy9HD;;AkBt9HA;EACC,UAAA;AlBy9HD;;AkBt9HA;EACC,UAAA;AlBy9HD;;AkBt9HA;EACC,UAAA;AlBy9HD;;AkBr9HA;mGAAA;AAGA;EACC,aAAA;EACA,gBAAA,EAAA,gDAAA;AlBu9HD;;AkBp9HA;EACC,wBAAA;AlBu9HD;;AkBp9HA,6CAAA,mBAAA;EACC,gBAAA,EAAA,yBAAA;AlBu9HD;;AkBn9HA;mGAAA;AAGA,wCAAA,yDAAA;EACC,kBAAA,EAAA,kEAAA;AlBq9HD;;AkBl9HA;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;AlBq9HD;;AkBj9HA;mGAAA;AAGA;sCACsC,uDAAA;EACrC,kBAAA;AlBm9HD;;AkBh9HA,4CAAA,mDAAA;EACC,oBAAA;AlBm9HD;;AkBh9HA,4CAAA,yCAAA;EACC,oBAAA;AlBm9HD;;AkBh9HA;;EAEC,kBAAA;EACA,UAAA,EAAA,0BAAA;AlBm9HD;;AkBh9HA;EACC,6CAAA;EACA,OAAA;EACA,QAAA;AlBm9HD;;AkB/8HA;mGAAA;AAGA,2BAAA,gDAAA;EACC,sDAAA;EACA,mBAAA;EACA,gBAAA;EAEA,+BAAA;EACA,yBAAA;EACA,0BAAA;AlBg9HD;;AkB78HA;EACC,sDAAA;EACA,sBAAA;EACA,mBAAA;EAEA,kCAAA;EACA,4BAAA;EACA,6BAAA;AlB+8HD;;AkB38HA;;;;CAAA;AAMA;EACC,gBAAA,EAAA,+CAAA;AlB68HD;;AkB18HA;;EAEC,cAAA;AlB68HD;;AkB18HA;EACC,iBAAA;EACA,mBAAA;AlB68HD;;AkB18HA,0DAAA;AAEA;EACC,iEAAA;EACA,mBAAA;AlB48HD;;AkBz8HA;;EAEC,4CAAA;EACA,qBAAA;EACA,mBAAA;AlB48HD;;AkBz8HA;EACC,aAAA,EAAA,wCAAA;AlB48HD;;AkBz8HA;EACC,yBAAA,EAAA,4CAAA;AlB48HD;;AkBz8HA;EACC,cAAA,EAAA,4CAAA;AlB48HD;;AkBz8HA;EACC,iBAAA,EAAA,kDAAA;EACA,UAAA,EAAA,4BAAA;AlB48HD;;AkBz8HA,YAAA;AAEA;EACC,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AlB28HD;;AkBx8HA;EACC,YAAA;AlB28HD;;AkBv8HI;EACI,qBAAA;AlB08HR;AkBx8HI;EACI,iBd/7BwB;Ecg8BxB,kBdh8BwB;Eci8BxB,mBdj8BwB;AJ24JhC;AkBx8HI;EACI,cAAA;AlB08HR;AkBx8HI;EACI,eAAA;AlB08HR;AkBx8HI;;EAEI,mBd38BwB;AJq5JhC;AkBx8HI;EACI,mBAAA;AlB08HR;AkBx8HI;EACI,gBAAA;AlB08HR;AkBx8HI;EACI,gBAAA;AlB08HR;;AqB1iKA;;;;;kCAAA;AAMA;EACE,2BAAA;EACA,4CAAA;EACA,qPAAA;EACA,mBAAA;EACA,kBAAA;ArB6iKF;AqB3iKA;;0BAAA;AAGA;EACE,qBAAA;EACA,gDAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,kCAAA;ArB6iKF;;AqB3iKA;;0BAAA;AAGA;EACE,uBAAA;EACA,oBAAA;ArB8iKF;;AqB5iKA;EACE,cAAA;ArB+iKF;;AqB7iKA;EACE,cAAA;ArBgjKF;;AqB9iKA;;oCAAA;AAGA;;EAEE,qBAAA;EACA,oBAAA;EACA,sBAAA;ArBijKF;;AqB/iKA;EACE,kBAAA;ArBkjKF;;AqBhjKA;;0BAAA;AAGA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;ArBmjKF;;AqBjjKA;EACE,kBAAA;ArBojKF;;AqBljKA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;ArBqjKF;;AqBnjKA;EACE,MAAA;EACA,mBAAA;ArBsjKF;;AqBpjKA;;EAEE,kBAAA;EACA,kBAAA;ArBujKF;;AqBrjKA;;0BAAA;AAGA;EAGE,0CAAA;ArBwjKF;AqBtiKA;EACE;IAKE,uBAAA;ErByjKF;EqBvjKA;IAKE,yBAAA;ErByjKF;AACF;AqBvjKA;;0BAAA;AAGA;EACE,gEAAA;EAKA,wBAAA;ArByjKF;;AqBvjKA;EACE,gEAAA;EAKA,yBAAA;ArB0jKF;;AqBxjKA;EACE,gEAAA;EAKA,yBAAA;ArB2jKF;;AqBzjKA;EACE,gEAAA;EAKA,uBAAA;ArB4jKF;;AqB1jKA;EACE,gEAAA;EAKA,uBAAA;ArB6jKF;;AqB3jKA;;0BAAA;AAIA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqB1jKA;EACI,gBAAA;ArB6jKJ;;AqBzjKA,oCAAA;ACrjBA;;EAEE,iBlBU2B;EkBT3B,gBlBsQ8B;EkBrQ9B,mBlB2P6B;EkB1P7B,mBlB0Q2B;EkBzQ3B,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBlBgJ8B;EkB/I9B,kBAAA;EACA,eAAA;EHTE,yBf2DyB;Ee8DrB,cf7GqB;EKJzB,4BAAA;AT0nLJ;AmBhoLI;;;;;;;;;;;;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBmoLR;AmBhoLI;;EACI,gBAAA;AnBmoLR;AmB5nLQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,yBf2BiB;Ee1BjB,qBf0BiB;AJunL7B;AmBtjLI;;EACI,cflEqB;EemErB,qBfnEqB;AJ4nL7B;AmBvjLQ;;;;EAGI,6BfnFiB;EeoFjB,cfvEiB;EewEjB,qBfxEiB;EeyEjB,gBAAA;AnB0jLZ;AmBtjLI;;EACI,cfhFqB;AJyoL7B;AmBvjLQ;;;;;EAII,6BfjGiB;EekGjB,cfrFiB;EesFjB,qBAAA;EACA,gBAAA;AnB0jLZ;AsBhsLE;;;EFbA,UEemB;EFZnB,0BAAA;EEaE,qBAAA;AtBosLJ;AsBlsLE;;;;ETDS,gBSIa;EACpB,qBAAA;AtBssLJ;AsBnsLE;;EACE,SAAA;AtBssLJ;AsBnsLE;;EAEE,gBlB4M4B;EkB3M5B,mBlB2M4B;EkB1M5B,elB0M4B;EkBzM5B,UAAA;EACA,oBlByM4B;EkBxM5B,gBAAA;EACA,kBAAA;EACA,mBAAA;AtBqsLJ;AsBnsLI;;EACE,UAAA;AtBssLN;AsBnsLI;;EACE,gBlBiM0B;EkBhM1B,mBlBgM0B;EkB/L1B,elB+L0B;AJugLhC;AsBpsLM;;;;;;;;EAIE,oBlBwLwB;AJkhLhC;AsBtsLI;;EACE,clBsL0B;EkBrL1B,iBlBqL0B;EkBpL1B,alBoL0B;AJqhLhC;AsBvsLM;;;;;;;;EAIE,mBlB6KwB;AJgiLhC;AsBzsLI;;;;;EAIE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,sBAAA;EACA,WAAA;AtB4sLN;AsBzsLI;;EACE,eAAA;AtB4sLN;AsBxsLE;;EACE,kBAAA;EACA,QAAA;AtB2sLJ;;AsBrsLA;EHhGI,yBfoEyB;EeqDrB,cf7GqB;AJ8xL7B;AmBxyLI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBgyLR;AmB7xLI;EACI,gBAAA;AnB+xLR;AmBxxLQ;EAMI,yBfoCiB;EenCjB,qBfmCiB;AJkvL7B;AmB1rLI;EACI,cfzDqB;Ee0DrB,qBf1DqB;AJsvL7B;AmB1rLQ;EAGI,6BfnFiB;EeoFjB,cf/DiB;EegEjB,qBfhEiB;EeiEjB,gBAAA;AnB0rLZ;AmBtrLI;EACI,cfvEqB;AJ+vL7B;AmBtrLQ;EAII,6BfjGiB;EekGjB,cf7EiB;Ee8EjB,qBAAA;EACA,gBAAA;AnBqrLZ;;AsBtuLA;EHnGI,yBfuEyB;EekDrB,cf7GqB;AJk0L7B;AmB50LI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBo0LR;AmBj0LI;EACI,gBAAA;AnBm0LR;AmB5zLQ;EAMI,yBfuCiB;EetCjB,qBfsCiB;AJmxL7B;AmB9tLI;EACI,cftDqB;EeuDrB,qBfvDqB;AJuxL7B;AmB9tLQ;EAGI,6BfnFiB;EeoFjB,cf5DiB;Ee6DjB,qBf7DiB;Ee8DjB,gBAAA;AnB8tLZ;AmB1tLI;EACI,cfpEqB;AJgyL7B;AmB1tLQ;EAII,6BfjGiB;EekGjB,cf1EiB;Ee2EjB,qBAAA;EACA,gBAAA;AnBytLZ;;AsBvwLA;EHtGI,yBf0EyB;Ee+CrB,cf7GqB;AJs2L7B;AmBh3LI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBw2LR;AmBr2LI;EACI,gBAAA;AnBu2LR;AmBh2LQ;EAMI,yBf0CiB;EezCjB,qBfyCiB;AJozL7B;AmBlwLI;EACI,cfnDqB;EeoDrB,qBfpDqB;AJwzL7B;AmBlwLQ;EAGI,6BfnFiB;EeoFjB,cfzDiB;Ee0DjB,qBf1DiB;Ee2DjB,gBAAA;AnBkwLZ;AmB9vLI;EACI,cfjEqB;AJi0L7B;AmB9vLQ;EAII,6BfjGiB;EekGjB,cfvEiB;EewEjB,qBAAA;EACA,gBAAA;AnB6vLZ;;AsBxyLA;EHzGI,yBf6EyB;Ee4CrB,cf7GqB;AJ04L7B;AmBp5LI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnB44LR;AmBz4LI;EACI,gBAAA;AnB24LR;AmBp4LQ;EAMI,yBf6CiB;Ee5CjB,qBf4CiB;AJq1L7B;AmBtyLI;EACI,cfhDqB;EeiDrB,qBfjDqB;AJy1L7B;AmBtyLQ;EAGI,6BfnFiB;EeoFjB,cftDiB;EeuDjB,qBfvDiB;EewDjB,gBAAA;AnBsyLZ;AmBlyLI;EACI,cf9DqB;AJk2L7B;AmBlyLQ;EAII,6BfjGiB;EekGjB,cfpEiB;EeqEjB,qBAAA;EACA,gBAAA;AnBiyLZ;;AsBz0LA;EH5GI,yBfgFyB;EeyCrB,cf7GqB;AJ86L7B;AmBx7LI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBg7LR;AmB76LI;EACI,gBAAA;AnB+6LR;AmBx6LQ;EAMI,yBfgDiB;Ee/CjB,qBf+CiB;AJs3L7B;AmB10LI;EACI,cf7CqB;Ee8CrB,qBf9CqB;AJ03L7B;AmB10LQ;EAGI,6BfnFiB;EeoFjB,cfnDiB;EeoDjB,qBfpDiB;EeqDjB,gBAAA;AnB00LZ;AmBt0LI;EACI,cf3DqB;AJm4L7B;AmBt0LQ;EAII,6BfjGiB;EekGjB,cfjEiB;EekEjB,qBAAA;EACA,gBAAA;AnBq0LZ;;AsBx2LA;EHyCI,uBf1GyB;Ee2GzB,oCAAA;EACA,cfjGyB;EgB1D3B,UD4JmB;ECzJnB,0BAAA;ApB69LF;AmBl0LI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;AnB+zLN;AmB9zLM;EACI,qDAAA;AnBg0LV;AmB5zLI;EACI,oCAAA;AnB8zLR;AmBvzLM;EAME,wCAAA;EACA,gCAAA;AnBozLR;;AsB53LA;EHsCI,uBf1GyB;Ee2GzB,oCAAA;EACA,cfxFyB;EgBnE3B,UD4JmB;ECzJnB,0BAAA;ApBo/LF;AmBz1LI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;AnBs1LN;AmBr1LM;EACI,qDAAA;AnBu1LV;AmBn1LI;EACI,oCAAA;AnBq1LR;AmB90LM;EAME,wCAAA;EACA,gCAAA;AnB20LR;;AsBh5LA;EHmCI,uBf1GyB;Ee2GzB,oCAAA;EACA,cfrFyB;EgBtE3B,UD4JmB;ECzJnB,0BAAA;ApB2gMF;AmBh3LI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;AnB62LN;AmB52LM;EACI,qDAAA;AnB82LV;AmB12LI;EACI,oCAAA;AnB42LR;AmBr2LM;EAME,wCAAA;EACA,gCAAA;AnBk2LR;;AsBp6LA;EHgCI,uBf1GyB;Ee2GzB,oCAAA;EACA,cflFyB;EgBzE3B,UD4JmB;ECzJnB,0BAAA;ApBkiMF;AmBv4LI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;AnBo4LN;AmBn4LM;EACI,qDAAA;AnBq4LV;AmBj4LI;EACI,oCAAA;AnBm4LR;AmB53LM;EAME,wCAAA;EACA,gCAAA;AnBy3LR;;AsBx7LA;EH6BI,uBf1GyB;Ee2GzB,oCAAA;EACA,cf/EyB;EgB5E3B,UD4JmB;ECzJnB,0BAAA;ApByjMF;AmB95LI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;AnB25LN;AmB15LM;EACI,qDAAA;AnB45LV;AmBx5LI;EACI,oCAAA;AnB05LR;AmBn5LM;EAME,wCAAA;EACA,gCAAA;AnBg5LR;;AsB58LA;EH0BI,uBf1GyB;Ee2GzB,oCAAA;EACA,cf5EyB;EgB/E3B,UD4JmB;ECzJnB,0BAAA;ApBglMF;AmBr7LI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;AnBk7LN;AmBj7LM;EACI,qDAAA;AnBm7LV;AmB/6LI;EACI,oCAAA;AnBi7LR;AmB16LM;EAME,wCAAA;EACA,gCAAA;AnBu6LR;;AsBh+LA;EHuBI,uBf1GyB;Ee2GzB,oCAAA;EACA,cfhJyB;EgBX3B,UD4JmB;ECzJnB,0BAAA;ApBumMF;AmB58LI;EAME,oCAAA;EACA,0CAAA;EACA,gCAAA;AnBy8LN;AmBx8LM;EACI,qDAAA;AnB08LV;AmBt8LI;EACI,oCAAA;AnBw8LR;AmBj8LM;EAME,wCAAA;EACA,gCAAA;AnB87LR;AsBr/LE;EAEE,clB1EyB;EkB2EzB,yBlB5HyB;AJknM7B;;AsBn/LA;EH3II,yBfYyB;Ee2BrB,cf6BqB;EkByE3B,clBlF2B;AJykM7B;AmBloMI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnB0nMR;AmBvnMI;EACI,gBAAA;AnBynMR;AmBlnMQ;EAMI,yBfpBiB;EeqBjB,qBfrBiB;AJooM7B;AmBvmMQ;EACI,cfsCiB;AJmkM7B;AmBvmMY;EAII,yBAAA;AnBsmMhB;AmBlmMQ;EACI,yBAAA;AnBomMZ;AmBlmMY;EAII,yBAAA;AnBimMhB;AmB7lMQ;EACI,yBAAA;AnB+lMZ;AmB7lMY;EAII,yBAAA;AnB4lMhB;AmBxlMQ;EACI,yBAAA;AnB0lMZ;AmBxlMY;EAII,yBAAA;AnBulMhB;AmBnlMQ;EACI,yBAAA;AnBqlMZ;AmBnlMY;EAII,yBAAA;AnBklMhB;AmB9kMQ;EASI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBwkMZ;AmBrkMQ;EAEI,yBAAA;AnBskMZ;AmBpkMY;EACI,gBAAA;AnBskMhB;AmB7jMI;EACI,cfjHqB;EekHrB,qBflHqB;AJirM7B;AmB7jMQ;EAGI,6BfnFiB;EeoFjB,cfxHiB;EeyHjB,qBfzHiB;Ee0HjB,gBAAA;AnB6jMZ;AmBzjMI;EACI,cf/HqB;AJ0rM7B;AmBzjMQ;EAII,6BfjGiB;EekGjB,cftIiB;EeuIjB,qBAAA;EACA,gBAAA;AnBwjMZ;AsB9jME;EAEE,clBnFyB;AJkpM7B;AsB3jMI;EAEE,clB3FuB;AJupM7B;AsBzjMI;EAGE,yBlBhJuB;EkBiJvB,clBlGuB;AJ2pM7B;AsBrjME;EAEE,6BAAA;AtBsjMJ;;AsBjjME;EFvKA,YE0KmB;EFvKnB,yBAAA;EEwKE,oBAAA;AtBmjMJ;;AsBhjMA;EACE,iBlB8C8B;EkB7C9B,qBlBtH2B;EkBuH3B,kBAAA;EACA,6BlBnI2B;AJsrM7B;;AsB1iMI;;;;;;;;;;;;;;;;;;;;;;;;;EAME,6BlBlJuB;AJktM7B;;AsB3jMA;EACE,SlBhM2B;EkBiM3B,sBAAA;EACA,6BlB1J2B;AJwtM7B;;AsB3jMA;EHXG,ef6D4B;Ee5D5B,kBf1C6B;Ee2C7B,kBAAA;AnB0kMH;AmBxkMG;EACI,kBAAA;AnB0kMP;;AsB5jMA;EHnBG,mBf2D4B;Ee1D5B,kBf5C6B;Ee6C7B,iBAAA;AnBmlMH;AmBjlMG;EACI,iBAAA;AnBmlMP;;AsB5jMA;EACE,gBAAA;AtB+jMF;;AsB7jMA;EACE,WAAA;AtBgkMF;;AsB9jMA;EACE,gBAAA;AtBikMF;;AsB/jMA;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;AtBkkMF;;AsB/jME;EACE,iBAAA;AtBkkMJ;AsB/jMI;EACE,oCAAA;AtBikMN;;AsB5jMA;EACE,iBlBhP2B;EkBiP3B,mBlBnB6B;EkBoB7B,mBlBpD6B;EkBqD7B,kBlBrD6B;AJonM/B;AsB7jME;EACE,kBAAA;AtB+jMJ;;AsB1jME;EACE,aAAA;AtB6jMJ;;AsBzjMA;EACE,uBAAA;EACA,SAAA;AtB4jMF;;AuBr0ME;ECFE,yBpB2VwB;EoB1VxB,cpBWyB;AJg0M7B;AwBz0MI;EAGI,oCAAA;EACA,yBAAA;AxBy0MR;AwBt0MI;EACI,cpBgVoB;EoB/UpB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpB6UoB;AJ2/L5B;AwBt0MQ;EAGI,cpByUuB;EoBxUvB,qBpBwUuB;AJ8/LnC;AwBl0MI;EACI,cpBkUoB;EoBjUpB,yBpBdqB;AJk1M7B;AwBj0MQ;EAGI,yBAAA;AxBi0MZ;AuB51ME;ECLE,yBpBwV+B;EoBvV/B,cpBWyB;AJy1M7B;AwBl2MI;EAGI,oCAAA;EACA,yBAAA;AxBk2MR;AwB/1MI;EACI,cpB6U2B;EoB5U3B,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpB0U2B;AJuhMnC;AwB/1MQ;EAGI,cpBsUuB;EoBrUvB,qBpBqUuB;AJ0hMnC;AwB31MI;EACI,cpB+T2B;EoB9T3B,yBpBdqB;AJ22M7B;AwB11MQ;EAGI,yBAAA;AxB01MZ;AuBl3ME;ECRE,yBpBsXyB;EoBrXzB,cpBWyB;AJk3M7B;AwB33MI;EAGI,oCAAA;EACA,yBAAA;AxB23MR;AwBx3MI;EACI,cpB2WqB;EoB1WrB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpBwWqB;AJkhM7B;AwBx3MQ;EAGI,cpBoWuB;EoBnWvB,qBpBmWuB;AJqhMnC;AwBp3MI;EACI,cpB6VqB;EoB5VrB,yBpBdqB;AJo4M7B;AwBn3MQ;EAGI,yBAAA;AxBm3MZ;AuBx4ME;ECXE,yBpB8VsB;EoB7VtB,cpBWyB;AJ24M7B;AwBp5MI;EAGI,oCAAA;EACA,yBAAA;AxBo5MR;AwBj5MI;EACI,cpBmVkB;EoBlVlB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpBgVkB;AJmkM1B;AwBj5MQ;EAGI,cpB4UuB;EoB3UvB,qBpB2UuB;AJskMnC;AwB74MI;EACI,cpBqUkB;EoBpUlB,yBpBdqB;AJ65M7B;AwB54MQ;EAGI,yBAAA;AxB44MZ;AuB95ME;ECdE,yBpBiW0B;EoBhW1B,cpBWyB;AJo6M7B;AwB76MI;EAGI,oCAAA;EACA,yBAAA;AxB66MR;AwB16MI;EACI,cpBsVsB;EoBrVtB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpBmVsB;AJylM9B;AwB16MQ;EAGI,cpB+UyB;EoB9UzB,qBpB8UyB;AJ4lMrC;AwBt6MI;EACI,cpBwUsB;EoBvUtB,yBpBdqB;AJs7M7B;AwBr6MQ;EAGI,yBAAA;AxBq6MZ;AuBp7ME;ECjBE,yBpByX2B;EoBxX3B,cpBWyB;AJ67M7B;AwBt8MI;EAGI,oCAAA;EACA,yBAAA;AxBs8MR;AwBn8MI;EACI,cpB8WuB;EoB7WvB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpB2WuB;AJ0lM/B;AwBn8MQ;EAGI,cpBuWuB;EoBtWvB,qBpBsWuB;AJ6lMnC;AwB/7MI;EACI,cpBgWuB;EoB/VvB,yBpBdqB;AJ+8M7B;AwB97MQ;EAGI,yBAAA;AxB87MZ;AuB18ME;ECpBE,yBpB4XwB;EoB3XxB,cpBWyB;AJs9M7B;AwB/9MI;EAGI,oCAAA;EACA,yBAAA;AxB+9MR;AwB59MI;EACI,cpBiXoB;EoBhXpB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpB8WoB;AJgnM5B;AwB59MQ;EAGI,cpB0WuB;EoBzWvB,qBpByWuB;AJmnMnC;AwBx9MI;EACI,cpBmWoB;EoBlWpB,yBpBdqB;AJw+M7B;AwBv9MQ;EAGI,yBAAA;AxBu9MZ;AuBh+ME;ECvBE,yBpB+XuB;EoB9XvB,cpBWyB;AJ++M7B;AwBx/MI;EAGI,oCAAA;EACA,yBAAA;AxBw/MR;AwBr/MI;EACI,cpBoXmB;EoBnXnB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpBiXmB;AJsoM3B;AwBr/MQ;EAGI,cpB6WuB;EoB5WvB,qBpB4WuB;AJyoMnC;AwBj/MI;EACI,cpBsWmB;EoBrWnB,yBpBdqB;AJigN7B;AwBh/MQ;EAGI,yBAAA;AxBg/MZ;AuBt/ME;EC1BE,yBpBkY4B;EoBjY5B,cpBWyB;AJwgN7B;AwBjhNI;EAGI,oCAAA;EACA,yBAAA;AxBihNR;AwB9gNI;EACI,cpBuXwB;EoBtXxB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpBoXwB;AJ4pMhC;AwB9gNQ;EAGI,cpBgXuB;EoB/WvB,qBpB+WuB;AJ+pMnC;AwB1gNI;EACI,cpByWwB;EoBxWxB,yBpBdqB;AJ0hN7B;AwBzgNQ;EAGI,yBAAA;AxBygNZ;AuB5gNE;EC7BE,yBpBqYwB;EoBpYxB,cpBWyB;AJiiN7B;AwB1iNI;EAGI,oCAAA;EACA,yBAAA;AxB0iNR;AwBviNI;EACI,cpB0XoB;EoBzXpB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpBuXoB;AJkrM5B;AwBviNQ;EAGI,cpBmXuB;EoBlXvB,qBpBkXuB;AJqrMnC;AwBniNI;EACI,cpB4WoB;EoB3WpB,yBpBdqB;AJmjN7B;AwBliNQ;EAGI,yBAAA;AxBkiNZ;AuBliNE;EChCE,yBpBwYsB;EoBvYtB,cpBWyB;AJ0jN7B;AwBnkNI;EAGI,oCAAA;EACA,yBAAA;AxBmkNR;AwBhkNI;EACI,cpB6XkB;EoB5XlB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpB0XkB;AJwsM1B;AwBhkNQ;EAGI,cpBsXuB;EoBrXvB,qBpBqXuB;AJ2sMnC;AwB5jNI;EACI,cpB+WkB;EoB9WlB,yBpBdqB;AJ4kN7B;AwB3jNQ;EAGI,yBAAA;AxB2jNZ;AuBxjNE;ECnCE,yBpB2YuB;EoB1YvB,cpBWyB;AJmlN7B;AwB5lNI;EAGI,oCAAA;EACA,yBAAA;AxB4lNR;AwBzlNI;EACI,cpBgYmB;EoB/XnB,6BpBoCqB;EoBnCrB,gBAAA;EACA,qBpB6XmB;AJ8tM3B;AwBzlNQ;EAGI,cpByXuB;EoBxXvB,qBpBwXuB;AJiuMnC;AwBrlNI;EACI,cpBkXmB;EoBjXnB,yBpBdqB;AJqmN7B;AwBplNQ;EAGI,yBAAA;AxBolNZ;;AyBpnNA;EhBQI,sDAAA;EgBNA,kBAAA;EACA,qBAAA;AzB2nNJ;;AyBtnNQ;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;AzBynNZ;;AyB7mNQ;EdkCJ,gEAAA;EAGA,wBAAA;AX+kNJ;;AyBvmNQ;EdgCA,sBAAA;AX+kNR;;AyBxmNI;EAEI,eAAA;AzB0mNR;AyBrmNQ;EdvCA,kCAAA;AXmpNR;;AyBrmNI;EAEI,eAAA;AzBumNR;AyBlmNQ;EdrDA,iCAAA;AX8pNR;;A0BnpNE;ECvBA,cvB6B2B;AJipN7B;;A0BppNE;EC1BA,cvB6B2B;AJqpN7B;;A0BrpNE;EC7BA,cvB6B2B;AJypN7B;;A2BlrNA;EACI,yBvBQyB;EuBPzB,yBAAA;EACA,kBvBkJ4B;EuBjJ5B,cvBLyB;EuBMzB,mBAAA;EACA,evBqP2B;EsBhB7B,oGAAA;Eb5NS,gBcPa;A3B0rNxB;A2BtrNI;EACI,yBAAA;EdEG,gBcDiB;EACpB,qBAAA;EACA,cvBwCqB;AJipN7B;A2BvrNQ;EAII,sBAAA;EACA,iBAAA;EACA,6BvBqBiB;AJiqN7B;A2BlrNI;EdbO,gBciBiB;A3BkrN5B;A2B/qNI;EACI,sBAAA;EACA,cvBtCqB;AJutN7B;A2B/qNQ;EACI,+BAAA;A3BirNZ;A2B9qNI;EACI,yBAAA;EACA,cvBuBqB;AJypN7B;A2B9qNI;EACI,yBvBCqB;EuBArB,yBAAA;EACA,cvB2BqB;AJqpN7B;A2B9qNQ;EACI,+BAAA;A3BgrNZ;A2B7qNI;EACI,yBvBhDqB;EuBiDrB,yBAAA;A3B+qNR;A2B5qNI;EACI,kBvBwFwB;EuBvFxB,evB4LuB;EuB3LvB,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;A3B8qNR;A2B3qNI;EACI,0BAAA;EACA,gCAAA;A3B6qNR;A2B1qNI;EAEI,yBvBpEqB;AJ+uN7B;;A0BjtNI;;EACE,yBAAA;A1BqtNN;A0BltNI;;EACE,kBAAA;A1BqtNN;A0BntNM;;;EAEE,yBAAA;A1BstNR;;A0B/sNI;;EACE,kBAAA;A1BmtNN;A0BjtNM;;;EAEE,yBAAA;A1BotNR;A0B/sNI;;;;EAEE,yBAAA;A1BmtNN;A0BjtNM;;;;EACE,2BAAA;A1BstNR;;A0B5sNI;;EACE,kBAAA;A1BgtNN;A0B9sNM;;;EAEE,yBAAA;A1BitNR;A0B7sNI;;;;EAEE,yBAAA;A1BitNN;;A0B3sNI;;EACE,4BAAA;A1B+sNN;A0B5sNM;;;EAEE,yBAAA;A1B+sNR;A0B1sNI;;;;EAEE,yBAAA;A1B8sNN;A0B3sNM;;;;;;;EAEE,2BAAA;A1BktNR;;A2B5uNM;;EACE,sBAAA;EACA,cvB7FqB;EuB8FrB,yBvBpFqB;EuBqFrB,kBAAA;A3BgvNR;;A2BxuNI;;;;;;EAGI,0CvB3EqB;EuB4ErB,mBAAA;A3B8uNR;A2B7uNQ;;;;;;;;;;;;;;;;EAGI,mBAAA;EACA,0CvBhFiB;AJ40N7B;A2BtvNY;;;EAEI,0CvBxFa;AJi1N7B;A2BpvNI;;;;EAEI,0CvBhGqB;EuBiGrB,YAAA;A3BwvNR;;A2BnvNI;EACI,cvBxDqB;AJ8yN7B;;A2BlvNI;EACI,cvBtEqB;AJ2zN7B;;A2BhvNE;EACE,kBvBK4B;AJ8uNhC;A2BlvNI;EACE,yBAAA;EACA,kBAAA;A3BovNN;A2BjvNE;EACE,cAAA;EACA,WAAA;EACA,cvB5EyB;EuB6EzB,eAAA;A3BmvNJ;;A2B9uNE;EACE,kBvBX4B;AJ4vNhC;A2BhvNI;EAEE,kBAAA;A3BivNN;;A2B1uNE;;EAEE,yBvBlKyB;EuBmKzB,qBvBpJyB;AJi4N7B;A2BzuNI;;EAEE,0CvBpJuB;AJ+3N7B;A2BpuNM;;EACE,yBvB1IqB;AJi3N7B;A2B/tNM;;EACE,yBvBlJqB;EuBmJrB,yBAAA;EACA,kBAAA;A3BkuNR;;A2B5tNA;;EAEI,6BAAA;EACA,yBAAA;EACA,cvBxJyB;EuByJzB,4BvB5D4B;EuB6D5B,+BvB7D4B;EsBsF9B,oGAAA;A1B2sNF;A2BluNI;;EACE,YAAA;A3BquNN;A2BhuNI;;EACE,yBvB1KuB;AJ64N7B;A2BjuNI;;EACE,yBvB5KuB;AJg5N7B;A2BluNI;;EACE,yBvBxNuB;EuByNvB,cvBrJuB;AJ03N7B;A2BnuNI;;EACE,yBvB5NuB;EuB6NvB,cvBlKuB;AJw4N7B;A2BpuNI;;EACE,cvB5JuB;AJm4N7B;A2BruNI;;EACE,cvBxKuB;AJg5N7B;A2BruNI;;;EDnPF,uBAAA;ECsPM,kBAAA;A3BwuNR;A2BruNI;;EACI,WAAA;A3BwuNR;;A2BpuNA;;EAEE,SAAA;A3BuuNF;;A2BnuNA;EACE,iBAAA;A3BsuNF;;A2BpuNA;EACE,kBAAA;A3BuuNF;;A2BpuNA;;EAEI,mBAAA;EACA,kBAAA;A3BuuNJ;A2BruNI;;EACI,eAAA;A3BwuNR;A2BruNM;;EACE,cvBpMqB;AJ46N7B;;A2BnuNI;;EAEI,yBvBjQqB;AJu+N7B;;A2BluNA;EACI,kBvBxI4B;EuByI5B,yBAAA;EACA,4BAAA;EACA,mBAAA;A3BquNJ;;A2BluNA;;;EAGI,oBAAA;A3BquNJ;;A2BnuNA;;;EAGI,mBAAA;A3BsuNJ;;A2BpuNA;EACI,yBvBvRyB;EuBwRzB,cvBvPyB;EuBwPzB,mBAAA;A3BuuNJ;;A2BpuNA;EACI,iBvB9SyB;EuB+SzB,oBAAA;A3BuuNJ;;A2BruNA;EACI,qBvBhSyB;AJwgO7B;;A2BruNA;EACI,cAAA;A3BwuNJ;;A2BtuNA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBvBhL4B;EuBiL5B,cAAA;A3ByuNJ;;A2BnuNI;;;EAEI,mBAAA;A3BuuNR;;A2BnuNA;EACI,WAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;A3BsuNJ;;A2BnuNA;EACI,eAAA;A3BsuNJ;;A2BluNA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A3BquNF;;A2BluNA;EACI,mBvBjH2B;AJs1N/B;;A2BluNA;EACI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;A3BquNJ;;A2BjuNI;;EAEI,wBAAA;EACA,iBAAA;EACA,gBAAA;A3BouNR;A2BjuNI;EACI,mBAAA;A3BmuNR;A2BjuNQ;EACG,eAAA;A3BmuNX;A2B/tNI;EACI,gBAAA;EACA,wBAAA;A3BiuNR;A2B9tNI;EACI,eAAA;A3BguNR;;A4BhnOA;;;;;EAKI,8DxBEyB;AJinO7B;;A4BjnOA;EACI,gBxBgQ4B;AJo3NhC;;A4BjnOA;EACI,cxB0DyB;AJ0jO7B;A4BnnOI;EAEI,cxBuDqB;AJ6jO7B;;A4BjnOA;EACI,gBxBkO2B;EwBjO3B,iBAAA;EACA,mBAAA;A5BonOJ;A4BlnOI;EACI,gBxBkPwB;EwBjPxB,yBAAA;EACA,YAAA;A5BonOR;;A4BjnOA;EACI,gBxBwN2B;EwBvN3B,mBAAA;A5BonOJ;;A4BlnOA;EACI,cxBqN2B;EwBpN3B,mBAAA;EACA,kBAAA;A5BqnOJ;;A4BnnOA;EACI,kBxBiN2B;EwBhN3B,mBAAA;EACA,gBAAA;EACA,mBxBqG2B;AJihO/B;A4BpnOI;EAEI,iBAAA;A5BqnOR;;A4BlnOA;EACI,iBxBuM2B;EwBtM3B,kBAAA;EACA,mBAAA;A5BqnOJ;;A4BnnOA;EACI,cxBmM2B;EwBlM3B,gBxBkN4B;EwBjN5B,yBAAA;A5BsnOJ;;A4BnnOI;EACI,iBAAA;A5BsnOR;;A4B5mOA;EACI,gBxBkM4B;AJ66NhC;A4B7mOI;EACI,yBAAA;A5B+mOR;A4B7mOQ;EACI,cxBvDiB;EwBwDjB,qBAAA;A5B+mOZ;A4B5mOI;EACI,iBAAA;A5B8mOR;;A4B1mOA;;;;EAII,cxB7DyB;EwB8DzB,gBxB2K4B;AJk8NhC;;A4B3mOA;;EAEI,0BAAA;EACA,gBxBuK4B;EwBtK5B,cxBpEyB;EwBqEzB,mBxB2J2B;AJm9N/B;;A4B3mOA;EACI,cxBmJ2B;AJ29N/B;;A4B3mOA;;EAEE,yBAAA;A5B8mOF;;A4B5mOA;;EAEE,yBAAA;A5B+mOF;;A4B7mOA;;EAEE,yBAAA;A5BgnOF;;A4B9mOA;;EAEE,yBAAA;A5BinOF;;A4B/mOA;;EAEE,yBAAA;A5BknOF;;A4B/mOA;;EAEI,yBAAA;A5BknOJ;;A4B9mOA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBxB0H2B;EwBzH3B,gBAAA;A5BinOJ;A4B/mOI;EACI,cxBhFqB;EwBiFrB,mBxBiHuB;EwBhHvB,yBAAA;A5BinOR;A4B9mOI;EACI,qBxB7EqB;EwB8ErB,cxB9EqB;AJ8rO7B;A4B9mOQ;EACI,cxBjFiB;AJisO7B;A4B5mOI;EACI,qBxB1EqB;EwB2ErB,cxB3EqB;AJyrO7B;A4B5mOQ;EACI,cxB9EiB;AJ4rO7B;A4B1mOI;EACI,sCxB5HqB;EwB6HrB,cxBxJqB;AJowO7B;A4B1mOQ;EACI,+BxBhIiB;AJ4uO7B;;A6BrxOA;EACI,czBsByB;EyBrBzB,ezB8P2B;EyB7P3B,8DzBIyB;EyBHzB,kCAAA;EACA,mCAAA;A7BwxOJ;;A6BrxOA;EACI,kBAAA;EACA,mBzBIyB;AJoxO7B;;A6BtxOA,eAAA;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EpBHI,6BAAA;ATk0OJ;;A6BlzOA;;;EpBhBI,6BAAA;AT40OJ;;A6BtzOA;;;;EV+KI,gEAAA;EAGA,yBAAA;AnB8oOJ;;A6BzzOA;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBzB9ByB;AJ01O7B;A6B1zOI;EACI,eAAA;A7B4zOR;A6BzzOI;EACI,WAAA;A7B2zOR;;A6BvzOA;EACI,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;A7B0zOJ;;A6BvzOA;EACE,WAAA;A7B0zOF;;A6BxzOA;EACE,YAAA;A7B2zOF;;A6BtzOE;EACE,iBAAA;EACA,mBAAA;A7ByzOJ;A6BvzOI;EACE,aAAA;A7ByzON;A6BvzOI;;EAEE,yBAAA;A7ByzON;A6BtzOE;EACE,qBAAA;A7BwzOJ;A6BrzOI;EACE,UAAA;A7BuzON;A6BrzOI;EACE,oCAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;A7BuzON;;A6BjzOE;EACE,uBAAA;A7BozOJ;;A6B7yOE;ECtHE,qB1B4DyB;E0B3DzB,yB1B2DyB;AJ42O7B;A6B/yOE;ECzHE,qB1BqEyB;E0BpEzB,yB1BoEyB;AJu2O7B;A6BhzOE;EC5HE,qB1B2EyB;E0B1EzB,yB1B0EyB;AJq2O7B;A6BjzOE;EC/HE,qB1BwEyB;E0BvEzB,yB1BuEyB;AJ42O7B;A6BlzOE;EClIE,qB1B8EyB;E0B7EzB,yB1B6EyB;AJ02O7B;A6BnzOE;ECrIE,qB1BiFyB;E0BhFzB,yB1BgFyB;AJ22O7B;A6BpzOE;ECxIE,qB1BayB;E0BZzB,yB1BYyB;EyB6HvB,cAAA;A7BuzON;;A6BjzOI;EACE,mBAAA;A7BozON;;A+Bp8OA;;EAEE,eAAA;A/Bu8OF;;A+Bn8OE;EACE,eAAA;A/Bs8OJ;;A+Bj8OE;EACE,gBAAA;A/Bo8OJ;A+Bh8OI;EACE,yB3ByCuB;E2BxCvB,c3BPuB;AJy8O7B;A+B77OI;EACE,eAAA;A/B+7ON;A+B77OI;EACE,eAAA;A/B+7ON;;A+Bz7OE;EACE,mBAAA;A/B47OJ;;A+Bv7OA;EACE,cAAA;EACA,qCAAA;A/B07OF;;A+Bv7OA;EACE;IAAK,sBAAA;E/B27OL;E+B17OA;IAAM,mBAAA;E/B67ON;E+B57OA;IAAM,sBAAA;E/B+7ON;E+B97OA;IAAM,mBAAA;E/Bi8ON;E+Bh8OA;IAAM,sBAAA;E/Bm8ON;E+Bl8OA;IAAO,sBAAA;E/Bq8OP;AACF;A+B77OM;EACE,gBAAA;A/B+7OR;;AgC9/OA;EACI,qB5BkT6B;E4BjT7B,wB5BiT6B;E4BhT7B,gBAAA;EACA,mBAAA;AhCigPJ;AgC//OI;EACI,sBAAA;AhCigPR;AgC//OQ;EACI,c5BIiB;AJ6/O7B;AgC9/OQ;EACI,c5B+CiB;AJi9O7B;AgCz/OM;;EAEE,c5BsCqB;AJq9O7B;A0B1/OE;;EMEQ,c5BmCmB;AJy9O7B;A0B3/OE;;EMDQ,c5BmCmB;AJ69O7B;A0B5/OE;;EMJQ,c5BmCmB;AJi+O7B;AgCjgPM;;EAEE,c5B8BqB;E4B7BrB,YAAA;AhCmgPR;AgC//OI;;EAEE,SAAA;EACA,iBAAA;EACA,iBAAA;AhCigPN;AgC//OM;;;;;;EAGE,c5BgBqB;AJo/O7B;AgClgPQ;;;;;;EACE,UAAA;AhCygPV;AgCpgPQ;;EACE,c5BOmB;AJggP7B;A0BriPE;;EMiCU,c5BIiB;AJogP7B;A0BtiPE;;EM8BU,c5BIiB;AJwgP7B;A0BviPE;;EM2BU,c5BIiB;AJ4gP7B;AgC1gPI;EACI,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AhC4gPR;AgCzgPI;EACI,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;AhC2gPR;AgCvgPQ;EACI,OAAA;EACA,WAAA;EAAA,cAAA;AhCygPZ;AgCrgPI;EACI,oBAAA;EACA,mBAAA;AhCugPR;AgCrgPQ;EACI,mBAAA;AhCugPZ;AgCrgPY;EACI,SAAA;AhCugPhB;AgClgPY;EACI,eAAA;AhCogPhB;AgChgPgB;EACI,WAAA;AhCkgPpB;AgCz/OQ;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;AhC2/OZ;AgCx/OQ;EACI,kBAAA;AhC0/OZ;AgCz/OY;EACI,kBAAA;AhC2/OhB;AgCz/OY;EACI,iBAAA;AhC2/OhB;AgCv/OQ;EACI,yBAAA;EACA,mB5BwHmB;E4BvHnB,sBAAA;EACA,qB5BqIiB;E4BpIjB,iBAAA;AhCy/OZ;AgCv/OY;;EAEI,gBAAA;AhCy/OhB;AgCt/OY;;EAEI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;AhCw/OhB;AgCr/OY;EACI,QAAA;EACA,eAAA;AhCu/OhB;AgCn/OgB;EACI,WAAA;EACA,YAAA;AhCq/OpB;AgCj/OY;EACI,YAAA;EACA,c5BzJa;AJ4oP7B;AgC/+OQ;;;;EAII,kB5BtBoB;E4BuBpB,c5BnHiB;AJomP7B;AgC7+OI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AhC++OR;AgC5+OI;EACI,0BAAA;EACA,e5BmEuB;E4BlEvB,mB5BMuB;E4BLvB,sB5BKuB;E4BJvB,qB5B2EqB;AJm6O7B;AgC3+OI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;AhC6+OR;AgC3+OQ;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AhC6+OZ;AgCx+OQ;EACI,WAAA;AhC0+OZ;AgCt+OI;EACE,wCAAA;EACA,gBAAA;EACA,6BAAA;AhCw+ON;AgCt+OM;EACE,c5BnKqB;AJ2oP7B;AgCt+OQ;EACE,YAAA;EACA,c5BvKmB;AJ+oP7B;AgCp+OO;EACI,mB5B5KkB;AJkpP7B;AgCn+OM;EACE,c5BhLqB;AJqpP7B;AgCn+OM;;;;;EAKE,c5B9KqB;AJmpP7B;AgCh+OQ;EACI,c5B7LiB;AJ+pP7B;AgCh+OY;EACI,YAAA;EACA,c5BjMa;AJmqP7B;AgC99OQ;EACI,mB5BtMiB;AJsqP7B;AgC79OQ;;;;EAII,c5B9LiB;AJ6pP7B;AgC59OQ;EACI,yBAAA;AhC89OZ;AgCx9OQ;EACE,e5BrBqB;AJ++O/B;;AgCp9OA;EACI,oCAAA;AhCu9OJ;;AgCp9OA;EACI,oCAAA;AhCu9OJ;;AgCp9OA;EACI,oCAAA;AhCu9OJ;;AgCp9OA;EACI,oCAAA;AhCu9OJ;;AgCp9OA;EACI,oCAAA;AhCu9OJ;;AgCp9OA;EACI,oCAAA;AhCu9OJ;;AgCp9OA;EACI,oCAAA;AhCu9OJ;;AiCxwPI;;;EACI,cAAA;EbDN,UaEuB;EbCvB,wBAAA;EPcS,gDTkQgB;E6B/QnB,kBAAA;EACA,kBAAA;EACA,yGAAA;AjC+wPR;AiC7wPQ;;;EtByBD,gDAAA;AX6vPP;AiClxPQ;;;EtBqBD,gDAAA;AXswPP;AiCtxPI;;;EbjBF,UakBuB;EbfvB,0BAAA;EagBM,mBAAA;AjC2xPR;AiCzxPQ;;;EtBYD,kDAAA;EsBVK,oBAAA;EACA,oBAAA;AjCiyPZ;AiC9xPQ;;;EtBMD,iDAAA;EsBJK,uBAAA;EACA,iBAAA;AjCsyPZ;;AiChyPA;;EtBHO,gDAAA;EsBMH,oBAAA;EACA,oBAAA;AjCuyPJ;;AiCnyPA;;EAEI,UAAA;EACA,mBAAA;AjCsyPJ;AiCpyPI;;EtB/BI,4CAAA;AX20PR;;AiCryPI;EtBvBG,kDAAA;EsByBC,oBAAA;EACA,oBAAA;AjC4yPR;AiCxyPM;EACE,4BAAA;AjC0yPR;;AiCnyPE;EACE,oBAAA;AjCsyPJ;AiCnyPE;EACE,oBAAA;AjCqyPJ;;AiClyPA;EACI,yB7BrEyB;E6BsEzB,cAAA;EACA,mB7BwE4B;E6BvE5B,gBAAA;EACA,YAAA;AjCqyPJ;AiCnyPI;EACI,yB7BvBqB;E6BwBrB,WAAA;AjCqyPR;AiClyPI;EACI,c7BjEqB;E6BkErB,mB7B+JuB;E6B9JvB,kBAAA;AjCoyPR;AiCjyPI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AjCmyPR;AiChyPI;EACI,c7BxGqB;E6ByGrB,e7BmJuB;E6BlJvB,4BAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AjCkyPR;AiChyPO;EACI,gBAAA;AjCkyPX;AiC9xPI;EACI,qBAAA;AjCgyPR;AiC7xPI;EACI,eAAA;AjC+xPR;AiC5xPI;EACG,4B7B2ByB;E6B1BzB,6B7B0ByB;AJowPhC;AiC3xPI;EACI,+B7BsBwB;E6BrBxB,gC7BqBwB;AJwwPhC;AiC1xPI;EACI,gBAAA;EACA,qBAAA;AjC4xPR;AiCzxPI;;EAEI,yBAAA;EACA,UAAA;EACA,qBAAA;AjC2xPR;AiCxxPI;;EAEI,yB7B5FqB;AJs3P7B;AiCvxPI;EAEI,yB7B7CgB;AJq0PxB;AiCtxPI;EAEI,yB7BhDgB;AJu0PxB;AiCrxPI;EAEI,yB7BnDgB;AJy0PxB;AiCpxPI;EAEI,yB7BtDgB;AJ20PxB;AiCnxPI;EAEI,yB7BzDgB;AJ60PxB;;AiChxPA;EACI,oBAAA;AjCmxPJ;;AiC5wPA;EACI,iBAAA;AjC+wPJ;;AiC7wPA;EACI,WAAA;EACA,UAAA;AjCgxPJ;;AiC7wPA;;;;;;EAMI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AjCgxPJ;;AiC7wPA;;;;;;EAMI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AjCgxPJ;;AiC7wPA;;EAEI,qBAAA;EACA,WAAA;AjCgxPJ;;AiC9wPA;;EAEI,qBAAA;EACA,WAAA;AjCixPJ;;AiC5wPA;EACI;IACE,gBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;EjC+wPJ;EiC7wPE;IACE,aAAA;EjC+wPJ;EiC7wPE;;;IAGE,uCAAA;IACA,yGAAA;EjC+wPJ;EiC7wPE;;;IAGE,qCAAA;IACA,8BAAA;EjC+wPJ;EiC7wPE;IAKE,4BAAA;EjC+wPJ;EiC7wPE;IACE,8BAAA;EjC+wPJ;EiC5wPE;IACE,yGAAA;IACA,qCAAA;EjC8wPJ;EiC3wPE;;IAEI,UAAA;IACA,WAAA;EjC6wPN;EiCvwPS;IACE,cAAA;EjCywPX;EiCnwPE;IACI,wBAAA;EjCqwPN;AACF;AiCjwPI;EACI,c7BxSqB;E6BySrB,e7B7CuB;AJgzP/B;AiCjwPQ;EACI,iBAAA;EACA,sCAAA;AjCmwPZ;AiCjwPY;EACI,eAAA;AjCmwPhB;AiChwPQ;EACI,cAAA;EACA,cAAA;AjCkwPZ;AiChwPQ;EACI,YAAA;AjCkwPZ;AiC5vPQ;;;;EAEI,yB7BtTiB;E6BuTjB,c7BjUiB;E6BkUjB,UAAA;EACA,qBAAA;AjCgwPZ;;AiC5vPA;;EAEI,kBAAA;AjC+vPJ;;AiC3vPI;EACI,kBAAA;AjC8vPR;AiC7vPQ;EACI,iBAAA;EACA,iBAAA;EACA,iBAAA;AjC+vPZ;AiC9vPY;EACI,eAAA;AjCgwPhB;AiC9vPY;EACI,iBAAA;AjCgwPhB;AiC7vPQ;EACI,c7B7QiB;AJ4gQ7B;AiC9vPY;EACI,c7B/Qa;AJ+gQ7B;AiC1vPQ;;EACI,c7BpWiB;E6BqWjB,UAAA;EACA,qBAAA;AjC6vPZ;AiCzvPQ;EACI,kBAAA;AjC2vPZ;;AiCvvPA;;;EAGI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AjC0vPJ;;AiCvvPA;;;EAGI,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AjC0vPJ;;AiCrvPI;;EACI,cAAA;AjCyvPR;;AiCnvPY;EACI,gCAAA;EACA,eAAA;EACA,cAAA;AjCsvPhB;AiCpvPgB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AjCsvPpB;AiCnvPoB;EACI,cAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;AjCqvPxB;AiCnvPoB;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;AjCqvPxB;AiCnvPoB;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;AjCqvPxB;AiClvPgB;EACI,eAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;AjCovPpB;AiClvPgB;EACI,qBAAA;AjCovPpB;AiClvPoB;EACI,cAAA;EACA,oCAAA;AjCovPxB;AiClvPoB;EACI,qBAAA;AjCovPxB;AiC9uPI;EACI,yBAAA;EACA,0BAAA;AjCgvPR;AiC9uPQ;EACI,6BAAA;EACA,gBAAA;AjCgvPZ;AiC/uPY;EACI,qBAAA;EACA,gBAAA;EACA,eAAA;AjCivPhB;AiC/uPgB;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;AjCivPpB;;AkC3sQA;EACI,SAAA;EACA,kB9BuJ4B;E8BtJ5B,c9BWyB;E8BVzB,mBAAA;EACA,sBAAA;EACA,kBAAA;AlC8sQJ;AkC5sQI;EACI,yBAAA;AlC8sQR;AkC3sQI;EACI,yBAAA;AlC6sQR;AkC1sQI;EACI,yBAAA;AlC4sQR;AkCzsQI;EACI,yBAAA;AlC2sQR;AkCxsQI;EACI,yBAAA;AlC0sQR;AkCvsQI;EACE,c9BfuB;E8BgBvB,YAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AlCysQN;AkCvsQM;;EAEI,0BAAA;AlCysQV;AkCtsQM;EAEE,UAAA;AlCusQR;AkCnsQI;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AlCqsQR;AkClsQI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AlCosQR;AkCjsQI;EACI,cAAA;EACA,cAAA;AlCmsQR;AkChsQI;EACI,kBAAA;AlCksQR;;AmCzwQA;EACI,eAAA;EACA,kB/BuJ4B;AJqnQhC;;AmC1wQA;EACI,gD/BkRuB;AJ2/P3B;;AoChxQI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;ApCmxQN;AoChxQI;EACE,eAAA;EACA,WAAA;ApCkxQN;AoC/wQI;EACI,SAAA;ApCixQR;AoC/wQQ;EAEI,UAAA;EACA,SAAA;ApCgxQZ;AoC5wQI;EACI,SAAA;ApC8wQR;AoC3wQI;EACE,gBAAA;ApC6wQN;AoC1wQI;EACI,gBAAA;ApC4wQR;AoC1wQQ;;;;;;EAMI,cAAA;EACA,iBAAA;ApC4wQZ;AoCxwQG;EACI,eAAA;EACA,gBhCyNyB;EgCxNzB,iBAAA;EACA,yBAAA;EACA,SAAA;ApC0wQP;AoCvwQG;;EAEI,aAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;ApCywQP;AoCvwQO;;EACI,kBAAA;ApC0wQX;AoCtwQY;;;EAEI,UAAA;EACA,UAAA;ApCywQhB;AoCrwQG;;;;;;EAMI,iBAAA;EACA,sBAAA;ApCuwQP;AoCpwQG;EACI,gBAAA;ApCswQP;AoCpwQG;EACI,eAAA;EACA,gBhC8KyB;EgC7KzB,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;ApCswQP;AoCpwQG;EACK,gBhC0KwB;EgCzKxB,iBhCwJuB;EgCvJvB,iBAAA;EACA,iBAAA;ApCswQR;AoCnwQG;EACC,WAAA;ApCqwQJ;AoClwQI;EACI,kBAAA;ApCowQR;;AoC/vQI;EACI,chCyIuB;EgCxIvB,yBAAA;ApCkwQR;AoChwQI;EACI,chCuIuB;AJ2nQ/B;AoChwQQ;EACI,cAAA;EACA,kBAAA;ApCkwQZ;AoC/vQI;EACI,gBhC2IwB;EgC1IxB,gBAAA;ApCiwQR;AoChwQQ;EACI,chClGiB;EgCmGjB,iBAAA;EACA,gBhCqIoB;AJ6nQhC;AoC/vQI;EACG,gBhCiIyB;EgChIzB,kBhCiHwB;AJgpQ/B;AoC/vQI;EACI,gBAAA;ApCiwQR;AoC/vQI;EACI,iBAAA;EACA,gBAAA;ApCiwQR;AoC/vQQ;EACI,iBAAA;ApCiwQZ;AoC7vQI;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ApC+vQR;AoC7vQQ;EACI,WAAA;ApC+vQZ;;AoC1vQA;EACE,gBAAA;EACA,oBAAA;ApC6vQF;;AoC1vQA;EACI,mBAAA;ApC6vQJ;;AoC1vQA;EACE,yBAAA;ApC6vQF;;AqCx6QA;EACI,eAAA;ArC26QJ;AqCz6QI;EACI,yBAAA;ArC26QR;AqCx6QI;EACI,qBAAA;EACA,WAAA;EACA,eAAA;ArC06QR;AqCv6QI;EACI,gBAAA;EACA,UAAA;EACA,gBAAA;ArCy6QR;AqCv6QQ;EACI,qBAAA;ArCy6QZ;AqCv6QY;EACI,cAAA;EACA,ejC+Ke;EiC9Kf,mBjCuOe;EiCtOf,yBAAA;EACA,qBAAA;ArCy6QhB;AqCv6QgB;EACI,qBAAA;ArCy6QpB;AqCn6QI;EACI,mBjC2NuB;EiC1NvB,gBAAA;ArCq6QR;AqCl6QI;EACI,cAAA;EACA,WAAA;EACA,YAAA;ArCo6QR;;AsC/8QA;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;AtCk9QJ;AsCh9QI;;EAEI,qBAAA;EACA,6BAAA;EACA,0BAAA;AtCk9QR;AsC/8QI;EACI,cAAA;EACA,aAAA;EACA,0BAAA;EACA,WAAA;AtCi9QR;AsC98QI;EACI,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AtCg9QR;AsC78QI;EACE,QAAA;EACA,WAAA;EACA,eAAA;AtC+8QN;AsC58QI;;EAEI,WAAA;EACA,iBAAA;EACA,UAAA;AtC88QR;AsC38QI;EACI,cAAA;AtC68QR;AsC18QI;EACI,cAAA;AtC48QR;AsCz8QI;;;EAGI,cAAA;EACA,kBAAA;AtC28QR;AsCx8QI;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;AtC08QR;AsCv8QI;;EAEI,gBAAA;AtCy8QR;AsCt8QI;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AtCw8QR;AsCt8QM;EACE,yBAAA;AtCw8QR;AsCt8QQ;EAEE,sBAAA;AtCu8QV;AsCl8QI;;EAEI,qBAAA;AtCo8QR;AsCj8QI;EACI,yBlCvBqB;AJ09Q7B;AsCj8QI;EACI,yBlC7BqB;AJg+Q7B;AsCj8QI;EACI,yBlCnCqB;AJs+Q7B;AsCj8QI;EACI,yBlC7BqB;AJg+Q7B;AsCj8QI;EACI,yBlC7BqB;AJg+Q7B;AsCh8QI;EACI,eAAA;EACA,YAAA;AtCk8QR;AsC/7QI;EACI,cAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;AtCi8QR;AsC97QI;;;EAGI,WAAA;EACA,YAAA;EACA,mBAAA;AtCg8QR;AsC77QI;EACI,YAAA;AtC+7QR;AsC77QQ;EACI,kBAAA;AtC+7QZ;AsC37QI;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AtC67QR;AsC17QI;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AtC47QR;AsCx7QQ;EACI,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AtC07QZ;AsCv7QQ;EACI,kBAAA;AtCy7QZ;AsCv7QY;EACI,kBAAA;EACA,SAAA;AtCy7QhB;AsCt7QY;;EAEI,kBAAA;AtCw7QhB;AsCp7QQ;EACI,kBAAA;AtCs7QZ;AsCp7QY;EACE,kBAAA;EACA,WAAA;EACA,mBlCoEiB;EkCnEjB,clC9He;AJojR7B;AsCp7Qc;EACE,UAAA;AtCs7QhB;AsCl7QY;EACI,eAAA;AtCo7QhB;AsCh7QQ;EACM,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;AtCk7Qd;AsC16QY;EACM,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AtC46QlB;AsC16QkB;EACG,gBAAA;AtC46QrB;AsCx6QY;EAEI,6BAAA;AtCy6QhB;AsCp6QgB;EACI,qCAAA;AtCs6QpB;AsCj6QQ;;EAEI,qBAAA;EACA,yBAAA;AtCm6QZ;AsC95QI;EACI,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AtCg6QR;AsC55QQ;EACI,iBAAA;AtC85QZ;AsC35QQ;EACI,gBAAA;AtC65QZ;AsCx5QQ;EACE,qBAAA;AtC05QV;AsCx5QU;EACG,0CAAA;EACA,0CAAA;EACA,uCAAA;EACA,YAAA;EACA,aAAA;AtC05Qb;AsCv5QU;EACG,0CAAA;EACA,+BAAA;EACA,uCAAA;EACA,YAAA;EACA,aAAA;AtCy5Qb;AsCt5QU;EAEG,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AtCu5Qb;AsCl5QQ;EACE,8CAAA;EACA,uBAAA;EACA,iBAAA;AtCo5QV;AsC/4QI;EACI,SAAA;AtCi5QR;;AsC34QI;E3BnSI,+CAAA;AXsrRR;AsCh5QM;EAEE,UAAA;AtCi5QR;AsC94QI;E3B3SI,8CAAA;AXgsRR;AsCh5QM;E3BhTE,8CAAA;AXusRR;AsCn5QM;E3BpTE,8CAAA;AX8sRR;;AuC1uRA;;EAEI,mBAAA;EACA,kBAAA;AvC6uRJ;;AuC1uRA;EACE,eAAA;EACA,qBAAA;AvC6uRF;AuC3uRI;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AvC6uRR;AuC1uRI;;EAEI,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,yBAAA;EAKA,+BAAA;AvC4uRR;AuC1uRI;EACI,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AvC4uRR;AuCzuRQ;EACI,cnCpBiB;EmCqBjB,YAAA;EACA,mBAAA;AvC2uRZ;;AuChuRA;;EAEI,UAAA;EACA,kBAAA;EACA,kBAAA;AvCmuRJ;;AuCjuRA;EACI,UAAA;AvCouRJ;;AuCjuRA;;EAEI,mBAAA;AvCouRJ;;AuCjuRA;;EAEI,+BAAA;AvCouRJ;;AuCjuRA;EACE,iBAAA;AvCouRF;AuCluRI;EACI,kBAAA;AvCouRR;AuCjuRQ;EACI,cnC7DiB;EmC8DjB,YAAA;EACA,mBAAA;AvCmuRZ;;AuC9tRA;EACI,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;AvCiuRJ;;AuC9tRA;EACI,yBAAA;AvCiuRJ;;AuC9tRA;;EAEI,UAAA;E5B2EA,+BAAA;E4BzEA,YAAA;EACA,cAAA;AvCquRJ;;AuCluRA;EACI,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AvCquRJ;;AuCluRA;EACI,UAAA;AvCquRJ;;AuCjuRA;;EAEI,cnC9GyB;AJk1R7B;;AwCh3RA;EACI,yBpC4ByB;EoC3BzB,kBpCuJ4B;EoCtJ5B,gBAAA;EACA,WAAA;AxCm3RJ;;AwCj3RA;EACI,WAAA;AxCo3RJ;;AwCl3RA;EACI,yBpC4DyB;AJyzR7B;;AwCn3RA;EACI,yBpCyDyB;AJ6zR7B;;AwCp3RA;EACI,yBpC4DyB;AJ2zR7B;;AwCr3RA;EACI,yBpCsDyB;AJk0R7B;;AwCt3RA;EACI,yBpCyDyB;AJg0R7B;;AwCv3RA;EACI,yBpCyDyB;AJi0R7B;;AyCn5RA,iCAAA;AACA;EACI,gBAAA;EACA,yBAAA;EACA,mBrC0P2B;EqCzP3B,iBAAA;EACA,6BrC4CyB;EqC3CzB,iBrCyN4B;EqCxN5B,qBAAA;EACA,crCKyB;EqCJzB,kBAAA;AzCs5RJ;AyCp5RI;EAEE,qBAAA;AzCq5RN;;AyCl5RA;EACI,qBAAA;AzCq5RJ;AyCp5RI;EACG,gBAAA;AzCs5RP;;AyCn5RA;EXtBI,qB1B4DyB;E0B3DzB,yB1B2DyB;AJk3R7B;;AyCr5RA;EXzBI,qB1BqEyB;E0BpEzB,yB1BoEyB;AJ82R7B;;AyCv5RA;EX5BI,qB1B2EyB;E0B1EzB,yB1B0EyB;AJ62R7B;;AyCz5RA;EX/BI,qB1BwEyB;E0BvEzB,yB1BuEyB;AJq3R7B;;AyC35RA;EXlCI,qB1B8EyB;E0B7EzB,yB1B6EyB;AJo3R7B;;AyC75RA;EXrCI,qB1BiFyB;E0BhFzB,yB1BgFyB;AJs3R7B;;AyC/5RA;EXxCI,qB1BayB;E0BZzB,yB1BYyB;EqC6BzB,cAAA;AzCm6RJ;;AyCh6RA;;EXxCI,c1BQyB;E0BPzB,yBWyCsC;EXxCtC,qBWwCsC;AzCq6R1C;;AyCl6RA;;EX7CI,c1BQyB;E0BPzB,yBW8CsC;EX7CtC,qBW6CsC;AzCu6R1C;;AyCp6RA;;EXlDI,c1BQyB;E0BPzB,yBWmDsC;EXlDtC,qBWkDsC;AzCy6R1C;;AyCt6RA;;EXvDI,c1BQyB;E0BPzB,yBWwDsC;EXvDtC,qBWuDsC;AzC26R1C;;AyCx6RA;;EX5DI,c1BQyB;E0BPzB,yBW6DsC;EX5DtC,qBW4DsC;AzC66R1C;;AyC16RA;;EXjEI,c1BQyB;E0BPzB,yBWkEsC;EXjEtC,qBWiEsC;AzC+6R1C;;A0Cv/RI;EACI,SAAA;EACA,8BAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,ctCYqB;EsCXrB,eAAA;EACA,etCmPuB;EsClPvB,yBAAA;EACA,uBAAA;EACA,aAAA;A1C0/RR;A0Cx/RQ;EAEI,ctCGiB;EsCFjB,0CtCciB;EsCbjB,YAAA;A1Cy/RZ;A0Ct/RQ;EAEE,gBAAA;A1Cu/RV;A0Cn/RI;;EAEI,kBAAA;A1Cq/RR;A0Cl/RI;EACI,QAAA;A1Co/RR;A0Cj/RI;EACI,OAAA;A1Cm/RR;A0Ch/RI;EACI,ctC/BqB;EsCgCrB,8CtC0OmB;AJwwR3B;A0Ch/RQ;EAGI,yBtCmBiB;EsClBjB,qBtCkBiB;EsCjBjB,ctCvCiB;AJuhS7B;A0C5+RI;EACI,YAAA;A1C8+RR;A0Cx+RY;EAGI,yBtCSa;EsCRb,qBtCQa;AJg+R7B;A0Cj+RY;EAGI,yBtCLa;EsCMb,qBtCNa;AJu+R7B;A0C19RY;EAGI,yBtCnBa;EsCoBb,qBtCpBa;AJ8+R7B;A0Cn9RY;EAGI,yBtCrBa;EsCsBb,qBtCtBa;AJy+R7B;A0C58RY;EAGI,yBtC7Ba;EsC8Bb,qBtC9Ba;AJ0+R7B;A0Ct8RQ;EACI,ctCzGiB;AJijS7B;A0Ct8RY;EAEI,0CtC3Ea;EsC4Eb,ctC9Ga;AJqjS7B;A0Cl8RY;EAGI,yBtCrHa;EsCsHb,qBtCtHa;EsCuHb,ctChEa;AJkgS7B;;A2CtkSQ;EACI,sBAAA;A3CykSZ;A2CrkSY;EhCcJ,gDAAA;AX8jSR;A2CxkSoB;EACI,oDAAA;A3C0kSxB;A2CtkSoB;EACI,qDAAA;A3CwkSxB;A2CpkSoB;EACI,oDAAA;A3CskSxB;A2ClkSoB;EACI,qDAAA;A3CokSxB;A2ChkSoB;EACI,oDAAA;A3CkkSxB;A2C9jSgB;EACI,cvCuCS;AJyhS7B;A2C7jSgB;EACI,cvCsCS;AJyhS7B;A2C5jSgB;EACI,cvCqCS;AJyhS7B;A2C3jSgB;EACI,cvCqBS;AJwiS7B;A2C1jSgB;EACI,cvCoBS;AJwiS7B;A2CtjSI;EACI,cvCCqB;EuCArB,2CAAA;A3CwjSR;A2CtjSQ;EACI,gBAAA;A3CwjSZ;A2CrjSQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gDAAA;EACA,mBvCoLmB;EuCnLnB,yBvC7DiB;EuC8DjB,kBAAA;A3CujSZ;A2CrjSY;EACI,kBAAA;A3CujShB;A2CljSI;EACI,kBAAA;EACA,eAAA;EACA,cvChEqB;EuCiErB,gBvCkLwB;AJk4RhC;A2CljSI;EACI,cvC9BqB;EuC+BrB,eAAA;EACA,gBAAA;A3CojSR;;A2ChjSA;EACI,2BAAA;A3CmjSJ;A2CjjSI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;A3CmjSR;A2CjjSQ;EACI,cAAA;A3CmjSZ;A2ChjSQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;A3CkjSZ;A2ChjSY;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;A3CkjShB;A2C9iSI;EACI,gBAAA;A3CgjSR;;A2C1iSI;EACI,cvC7DqB;AJ0mS7B;A2C3iSQ;EACI,qDAAA;A3C6iSZ;A2C1iSI;EACI,cvC9DqB;AJ0mS7B;A2C1iSQ;EACI,qDAAA;A3C4iSZ;A2CziSI;EACI,cvCxEqB;AJmnS7B;A2CziSQ;EACI,sDAAA;A3C2iSZ;A2CxiSI;EACI,cvCzEqB;AJmnS7B;A2CxiSQ;EACI,qDAAA;A3C0iSZ;A2CviSI;EACI,cvC7EqB;AJsnS7B;A2CviSQ;EACI,qDAAA;A3CyiSZ;A2CriSI;EACI,cvCzJqB;AJgsS7B;;A4C9sSA,+CAAA;AAGI;EACI,cAAA;A5C+sSR;A4C7sSI;EACI,yBAAA;EACA,gBAAA;EACA,cxCoDqB;EwCnDrB,gBxCgQwB;EwC/PxB,iBAAA;EACA,kBAAA;A5C+sSR;A4C5sSI;;;EAGI,yBxC2CqB;EwC1CrB,cAAA;A5C8sSR;A4C5sSI;EACI,uCAAA;EACA,SAAA;A5C8sSR;A4C5sSI;EACI,uCAAA;A5C8sSR;A4C5sSI;EACI,yBxCgCqB;EwC/BrB,cxChBqB;AJ8tS7B;;A4CxsSQ;EACI,yBAAA;EACA,cxCgCiB;AJ2qS7B;A4C1sSY;EACI,yBAAA;EACA,mBxC6Ba;EwC5Bb,cxC5Ba;AJwuS7B;;A4CrsSQ;EACI,yBAAA;EACA,cxC+BiB;AJyqS7B;A4CvsSY;EACI,yBAAA;EACA,mBxC4Ba;EwC3Bb,cxCzCa;AJkvS7B;;A4ClsSQ;EACI,yBAAA;EACA,cxCYiB;AJyrS7B;A4CpsSY;EACI,yBAAA;EACA,mBxCSa;EwCRb,cxCtDa;AJ4vS7B;;A4C/rSQ;EACI,yBAAA;EACA,cxCJiB;AJssS7B;A4CjsSY;EACI,yBAAA;EACA,mBxCPa;EwCQb,cxCnEa;AJswS7B;;A4C5rSQ;EACI,yBAAA;EACA,cxCXiB;AJ0sS7B;A4C9rSY;EACI,yBAAA;EACA,mBxCda;EwCeb,cxChFa;AJgxS7B;;A4CvrSA;;EAEI,+BAAA;EACH,4BAAA;EACG,gCAAA;EACA,6BAAA;A5C0rSJ;;A4CxrSA;;EAEI,oCAAA;A5C2rSJ;;A4CzrSA;;EAEI,oCAAA;A5C4rSJ;;A4C1rSA;;EAEI,oCAAA;A5C6rSJ;;A4C3rSA;;EAEI,oCAAA;A5C8rSJ;;A4C5rSA;;EAEI,oCAAA;A5C+rSJ;;A4C7rSA;;EAEI,oCAAA;A5CgsSJ;;A6Cn0SA,gDAAA;AACA;EACI,kBAAA;EACA,gCAAA;EACA,mBAAA;A7Cs0SJ;A6Cp0SI;EACI,oBAAA;A7Cs0SR;;A6Cn0SA;EACI,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;A7Cs0SJ;;A6Cp0SA;EACQ,qBAAA;EACA,ezC2OuB;EyC1OvB,gBzCkPwB;AJqlShC;A6Cr0SY;EACI,cAAA;EACA,czC8Ba;EyC7Bb,6BAAA;A7Cu0ShB;A6Cr0SY;EACI,czC1Ba;AJi2S7B;A6Cr0SY;EACI,czC7Ba;AJo2S7B;A6Cn0SQ;EACI,czClCiB;EyCmCjB,kBAAA;A7Cq0SZ;A6Cl0SY;;;EAGI,6BAAA;EACA,cAAA;A7Co0ShB;A6Cl0SgB;;;EACI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;A7Cs0SpB;A6Cn0SgB;;;EACI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;A7Cu0SpB;A6Cl0SQ;EACI,6BAAA;A7Co0SZ;A6Cl0SQ;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;A7Co0SZ;A6Cl0SY;;EAEI,cAAA;EACA,yBAAA;A7Co0ShB;A6Cl0SY;EACI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;A7Co0ShB;A6Cl0SY;EACI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;A7Co0ShB;;A6C9zSQ;EACI,iBAAA;A7Ci0SZ;A6C/zSQ;EACI,YAAA;A7Ci0SZ;;A6C1zSA;EACI,kBzC+B2B;AJ8xS/B;A6C3zSI;EACI,cAAA;EACA,mBAAA;EACA,czChGqB;EyCiGrB,kBAAA;EzB5HN,YyB6HuB;EzB1HvB,yBAAA;ApBw7SF;A6C5zSQ;EAEI,6BzClFiB;EgB/C3B,UyBkI2B;EzB/H3B,0BAAA;ApB67SF;A6C3zSI;EACI,eAAA;A7C6zSR;A6C3zSI;EACG,czChEsB;AJ63S7B;;A6C1zSA;EACI,qBAAA;A7C6zSJ;A6C5zSK;EACG,eAAA;EACA,mBAAA;A7C8zSR;A6C5zSI;EACI,kBzCkGuB;EyCjGvB,mBAAA;EACA,czCgGuB;AJ8tS/B;;A6C3zSA;EACI,cAAA;A7C8zSJ;A6C7zSI;EACI,mBAAA;A7C+zSR;;A6C5zSA;EACI,czC5FyB;AJ25S7B;;A6C7zSA;EACI,czCzFyB;AJy5S7B;;A6C9zSA;EACI,czC/FyB;AJg6S7B;;A6C/zSA;EACI,czC5FyB;AJ85S7B;;A6Ch0SA;EACI,czC5FyB;AJ+5S7B;;A6Ch0SA;EACI,kBzC1B2B;AJ61S/B;A6Cj0SI;EACI,czCqEuB;EyCpEvB,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBzCgFwB;AJmvShC;A6Ch0SI;EACI,cAAA;A7Ck0SR;A6Ch0SI;EACI,aAAA;A7Ck0SR;;A6C7zSI;EACI,qBAAA;A7Cg0SR;A6C9zSI;EACI,kBAAA;A7Cg0SR;;A6C5zSA;EACE,oBAAA;A7C+zSF;;A6C1zSA;;;EAGI,gCAAA;EACA,kCAAA;EACA,qCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;A7C6zSJ;;A6C1zSA;;;EAGI,gCAAA;EACA,kCAAA;EACA,qCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;A7C6zSJ;;A6C3zSA;EACI,iBAAA;A7C8zSJ;;A6C3zSA;EACE,+BAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;A7C8zSF;;A8CljTA;EACI,e1C+P2B;E0C9P3B,gDAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;A9CqjTJ;A8CnjTI;EAII,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;A9CkjTR;A8C/iTI;EACI,+B1C2EqB;E0C1ErB,e1C6OuB;E0C5OvB,0BAAA;EACA,gB1CoPwB;E0CnPxB,SAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;A9CijTR;A8C9iTI;EACI,aAAA;A9CgjTR;A8C7iTI;EACI,4B1CnBqB;E0CoBrB,SAAA;A9C+iTR;A8C5iTI;ECpCA,yB3CqEyB;AJ8gT7B;A+CjlTI;EACI,c3CUqB;AJykT7B;A+C/kTI;EACI,2B3C6DqB;AJohT7B;A+C9kTI;EACI,yB3CyDqB;AJuhT7B;A+C7kTI;EACI,4B3CqDqB;AJ0hT7B;A+C5kTI;EACI,0B3CiDqB;AJ6hT7B;A+C3kTI;EACI,c3CXqB;E2CYrB,YAAA;A/C6kTR;A8C9jTI;ECxCA,yB3C2EyB;AJ8hT7B;A+CvmTI;EACI,c3CUqB;AJ+lT7B;A+CrmTI;EACI,2B3CmEqB;AJoiT7B;A+CpmTI;EACI,yB3C+DqB;AJuiT7B;A+CnmTI;EACI,4B3C2DqB;AJ0iT7B;A+ClmTI;EACI,0B3CuDqB;AJ6iT7B;A+CjmTI;EACI,c3CXqB;E2CYrB,YAAA;A/CmmTR;A8ChlTI;EC5CA,yB3C8EyB;AJijT7B;A+C7nTI;EACI,c3CUqB;AJqnT7B;A+C3nTI;EACI,2B3CsEqB;AJujT7B;A+C1nTI;EACI,yB3CkEqB;AJ0jT7B;A+CznTI;EACI,4B3C8DqB;AJ6jT7B;A+CxnTI;EACI,0B3C0DqB;AJgkT7B;A+CvnTI;EACI,c3CXqB;E2CYrB,YAAA;A/CynTR;A8ClmTI;EChDA,yB3CiFyB;AJokT7B;A+CnpTI;EACI,c3CUqB;AJ2oT7B;A+CjpTI;EACI,2B3CyEqB;AJ0kT7B;A+ChpTI;EACI,yB3CqEqB;AJ6kT7B;A+C/oTI;EACI,4B3CiEqB;AJglT7B;A+C9oTI;EACI,0B3C6DqB;AJmlT7B;A+C7oTI;EACI,c3CXqB;E2CYrB,YAAA;A/C+oTR;A8CpnTI;ECpDA,yB3CwEyB;AJmmT7B;A+CzqTI;EACI,c3CUqB;AJiqT7B;A+CvqTI;EACI,2B3CgEqB;AJymT7B;A+CtqTI;EACI,yB3C4DqB;AJ4mT7B;A+CrqTI;EACI,4B3CwDqB;AJ+mT7B;A+CpqTI;EACI,0B3CoDqB;AJknT7B;A+CnqTI;EACI,c3CXqB;E2CYrB,YAAA;A/CqqTR;;A8CnoTI;EACI,2B1C/CqB;AJqrT7B;A8CnoTI;EACI,yB1CnDqB;AJwrT7B;A8CloTI;EACI,4B1CvDqB;AJ2rT7B;A8CjoTI;EACI,0B1C3DqB;AJ8rT7B;;A8C/nTA;EACI,sBAAA;EACA,gBAAA;EACA,yB1ClEyB;E0CmEzB,e1C+K2B;E0C9K3B,cAAA;EACA,+CAAA;A9CkoTJ;;AgDrtTA;EACI,gCAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AhDwtTJ;AgDttTI;EACI,gCAAA;AhDwtTR;AgDvtTQ;EACI,gBAAA;AhDytTZ;AgDptTM;EACE,aAAA;AhDstTR;AgDltTI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;AhDotTN;AgDltTM;EACE,eAAA;AhDotTR;;AgD5sTY;EACI,aAAA;AhD+sThB;;AgDzsTA;EACI,cAAA;EACA,mBAAA;EACA,wEAAA;AhD4sTJ;AgD1sTQ;EACI,gBAAA;AhD4sTZ;;AgDvsTA;EACI,iBAAA;AhD0sTJ;;AgDxsTA;EACI,kBAAA;EACA,WAAA;AhD2sTJ;;AgDzsTA;EACI,6BAAA;EACA,YAAA;AhD4sTJ;AgD1sTI;EACI,kBAAA;AhD4sTR;;AgDzsTA;;EAEI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AhD4sTJ;;AgD1sTA;EACI,aAAA;EACA,WAAA;EACA,SAAA;AhD6sTJ;;AgD3sTA;EACI,yB5CrDyB;E4CsDzB,qBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EAEA,UAAA;AhD6sTJ;;AgD3sTA;EACI,kBAAA;EACA,mBAAA;EACA,oBAAA;AhD8sTJ;AgD7sTI;EACI,WAAA;AhD+sTR;;AiD7yTA;;;EAGI,cAAA;AjDgzTJ;;AiD5yTI;EACI,gD7C8QmB;AJiiT3B;AiD7yTI;EACI,cAAA;AjD+yTR;;AkD3zTA;EACI,kBAAA;EACA,MAAA;EACA,aAAA;AlD8zTJ;AkD5zTI;EACI,iBAAA;EACA,YAAA;AlD8zTR;;AkD1zTA;;EAEI,eAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;AlD6zTJ;AkD3zTI;;EACI,kBAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;AlD8zTR;AkD5zTQ;;EACE,wBAAA;AlD+zTV;AkD5zTQ;;EACI,YAAA;AlD+zTZ;AkDzzTc;;;;EACE,qBAAA;AlD8zThB;AkD1zTc;;;;EACE,SAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AlD+zThB;AkD5zTc;;;;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,+B9C5Ba;AJ61T7B;AkD9zTc;;;;EACE,0BAAA;AlDm0ThB;AkDh0Tc;;;;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AlDq0ThB;AkD/zTI;;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;AlDk0TN;AkD9zTI;;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AlDi0TN;AkD/zTM;;EACI,WAAA;EACA,YAAA;AlDk0TV;AkD9zTI;;EACI,gBAAA;EACA,cAAA;AlDi0TR;AkD/zTQ;;EACI,SAAA;EACA,kBAAA;EACA,WAAA;AlDk0TZ;AkD9zTY;;EACI,eAAA;AlDi0ThB;AkD9zTY;;EACI,mBAAA;EACA,c9C9Ga;E8C+Gb,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;AlDi0ThB;AkD9zTY;;EACE,gBAAA;AlDi0Td;AkD9zTY;;;EAEE,UAAA;AlDi0Td;AkD7zTY;;;EAEI,UAAA;AlDg0ThB;AkDxzTY;;;;;EAIE,c9C9Ee;AJy4T7B;AkDzzTc;;;;;EACE,6BAAA;EACA,gBAAA;AlD+zThB;AkD7zTgB;;;;;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;AlDm0TlB;AkD9zTY;;EACE,aAAA;AlDi0Td;AkD7zTQ;;EACI,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AlDg0TZ;AkD5zTQ;;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,+B9C9JiB;E8C+JjB,kBAAA;AlD+zTZ;AkD1zTU;;;;EACE,aAAA;AlD+zTZ;AkD1zTI;;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;AlD6zTR;AkD3zTQ;;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AlD8zTZ;AkD1zTI;;EACI,kBAAA;EACA,mBAAA;EACA,UAAA;AlD6zTR;AkDtzTQ;;EACI,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AlDyzTZ;AkDtzTQ;;EACI,cAAA;EACA,UAAA;EACA,mBAAA;EvClPJ,iCAAA;AXgjUR;AkD1zTQ;;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,0C9ClOiB;AJ+hU7B;AkDzzTQ;;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,c9CpQiB;E8CqQjB,iBAAA;EACA,mDAAA;AlD4zTZ;AkDzzTQ;;EACI,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,e9C3BmB;E8C4BnB,c9C/QiB;E8CgRjB,qBAAA;EACA,gB9CvBoB;E8CwBpB,iBAAA;EACA,gBAAA;AlD4zTZ;AkDxzTI;;EACI,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AlD2zTR;AkDzzTQ;;EACI,WAAA;EACA,YAAA;AlD4zTZ;AkDxzTI;;;EAEI,cAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AlD2zTR;AkDxzTI;;EvCxRA,mBPqByB;EOjBzB,iDAAA;EuCsRI,UAAA;AlD+zTR;ASlnUE;;EACE,mBLFyB;AJunU7B;AW97TQ;;;;;;;;;;;;EAME,cPhJmB;EOiJnB,YAAA;AXs8TV;AWn8TQ;;;EAEI,UAAA;AXs8TZ;AWh8TM;;EACE,cP7JqB;AJgmU7B;AWj8TM;;EACE,yBPhKqB;EOiKrB,YAAA;AXo8TR;AW/7TM;;;;;;EAGE,yBAAA;AXo8TR;AWl8TM;;EACE,yBP5KqB;EO6KrB,YAAA;AXq8TR;AShqUE;;EACE,mBL6CyB;AJsnU7B;ASnpUU;;;;;;;EAME,cLgCiB;EK/BjB,UAAA;ATspUZ;AS7pUU;;;;;;;EAME,cLsCiB;EKrCjB,UAAA;ATgqUZ;ASvqUU;;;;;;;EAME,cLmCiB;EKlCjB,UAAA;AT0qUZ;ASjrUU;;;;;;;EAME,cLyCiB;EKxCjB,UAAA;ATorUZ;AS3rUU;;;;;;;EAME,cL4CiB;EK3CjB,UAAA;AT8rUZ;AkDt4TI;;EACI,oBAAA;EACA,mBAAA;EACA,kBAAA;AlDy4TR;AkDv4TQ;;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,0CAAA;AlD04TZ;AkDv4TQ;;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AlD04TZ;AkDv4TY;;EACI,WAAA;AlD04ThB;AkDt4TQ;;EACI,c9CjXiB;E8CkXjB,qBAAA;EACA,oBAAA;EACA,mBAAA;AlDy4TZ;AkDp4TY;;EACG,cAAA;EACA,iBAAA;AlDu4Tf;AkDr4TgB;;EAEG,cAAA;EACA,kBAAA;EACA,UAAA;AlDu4TnB;AkDn4TY;;EACI,kBAAA;EACA,QAAA;EACA,WAAA;AlDs4ThB;;AkDh4TA;EACI,gCAAA;AlDm4TJ;;AkDj4TA;EACI,wBAAA;AlDo4TJ;;AkD/3TQ;;EAEI,c9CzZiB;AJ2xU7B;AkD/3TQ;EACI,oCAAA;AlDi4TZ;;AkD33TA;EACI,kBAAA;EACA,YAAA;EACA,yB9C7EyB;E8C8EzB,yBAAA;EzC3aA,0DAAA;AT8yUJ;AkD/3TI;EACI,oBAAA;EACA,+BAAA;EACA,gBAAA;AlDi4TR;AkD93TI;EACI,gBAAA;AlDg4TR;AkD53TI;EACI,mBAAA;AlD83TR;;AkDx3TE;;EAEI,YAAA;EACA,gBAAA;AlD23TN;;AkDt3TA;EACI;;;IAII,uCAAA;IAEA,sCAAA;IAEA,gDAAA;IACA,iCAAA;ElDy3TN;EkDp3TM;IACE,wBAAA;ElDs3TR;EkDp3TM;IACE,gCAAA;ElDs3TR;EkDn3TM;;IAEE,WAAA;ElDq3TR;EkDl3TM;IACE,wB9CvImB;EJ2/T3B;EkDj3TM;IACE,cAAA;IACA,aAAA;ElDm3TR;EkDh3TY;IACI,UAAA;IvC3eV,mCAAA;EXk2UN;EkDp3TY;IACI,UAAA;ElDs3ThB;EkDj3TU;;;;IvCpfJ,mCAAA;IuCyfQ,UAAA;ElDu3Td;EkDl3TM;IACE,YAAA;ElDo3TR;EkDj3TU;IACI,UAAA;IvCngBR,+BAAA;EX23UN;EkDn3TQ;IACE,UAAA;ElDq3TV;EkDn3TQ;IACE,YAAA;ElDq3TV;EkDn3TU;;;;IvC9gBJ,iCAAA;IuCmhBM,UAAA;ElDy3TZ;AACF;AkDl3TA;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,8BAAA;EAEA,4EAAA;EACA,kBAAA;EACA,gBAAA;AlDo3TF;AkDj3TI;EACE,c9CtiBuB;AJy5U7B;AkDj3TI;EACE,gBAAA;EACA,+B9ChhBuB;E8CihBvB,cAAA;EACA,eAAA;AlDm3TN;AkDj3TM;EACE,c9C/iBqB;AJk6U7B;;AkD72TA;EACE,aAAA;AlDg3TF;;AkD72TA;EACE,aAAA;AlDg3TF;;AkD12TA;EAGI,oBAAA;EAGA,mBAAA;EAGA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AlD62TJ;AkD32TI;EACE,UAAA;EACA,wBAAA;EAAA,uBAAA;EACA,YAAA;AlD62TN;;AkDx2TE;EACE,4BAAA;AlD22TJ;;AmDl9UI;EACI,gBAAA;EACA,oBAAA;EACA,kBAAA;AnDq9UR;AmDn9UQ;EACI,MAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AnDq9UZ;AmDj9UU;EACE,SAAA;AnDm9UZ;AmD/8UQ;EACI,c/CMiB;E+CLjB,gBAAA;EACA,oBAAA;AnDi9UZ;AmD58UY;EACI,QAAA;AnD88UhB;AmD38UY;EACI,UAAA;AnD68UhB;AmD18UY;EACI,QAAA;AnD48UhB;AmDx8UQ;EACI,mBAAA;EACA,kBAAA;AnD08UZ;AmDx8UY;EAEI,YAAA;EACA,cAAA;AnDy8UhB;AmDt8UY;EACI,WAAA;AnDw8UhB;AmDn8UQ;EACI,UAAA;EACA,WAAA;EACA,aAAA;EACA,kB/CyFoB;E+CxFpB,8CAAA;EACA,yB/CpDiB;E+CqDjB,c/C5CiB;E+C6CjB,mBAAA;EACA,kBAAA;AnDq8UZ;AmDn8UY;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,+BAAA;EACA,6BAAA;EACA,qCAAA;EACA,YAAA;AnDq8UhB;AmDl8UY;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,+BAAA;EACA,6BAAA;EACA,qCAAA;EACA,YAAA;AnDo8UhB;AmD97UQ;EACI,c/CrFiB;E+CsFjB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,yB/C7EiB;E+C8EjB,YAAA;EACA,4BAAA;EACA,2BAAA;EACA,+BAAA;EACA,8BAAA;EACA,yBAAA;AnDg8UZ;AmD97UY;;EAEI,oBAAA;AnDg8UhB;AmD77UY;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AnD+7Ud;AmDz7UQ;EACI,YAAA;EACA,sBAAA;AnD27UZ;AmDz7UY;EACI,oBAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;AnD27UhB;AmDx7UY;EACI,oBAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;AnD07UhB;AmDn7UI;EACI,mBAAA;AnDq7UR;AmDn7UI;EACE,oCAAA;AnDq7UN;AmDn7UI;EACE,oCAAA;AnDq7UN;AmDl7UI;EACE,oCAAA;AnDo7UN;AmDj7UI;EACE,oCAAA;AnDm7UN;AmDh7UI;EACE,oCAAA;AnDk7UN;AmD96UI;EACE,aAAA;EACA,cAAA;AnDg7UN;AmD76UI;;EAEE,gBAAA;AnD+6UN;AmD56UI;EACE,eAAA;AnD86UN;;AoDxmVA;EACE,mBhD4J8B;EgD3J9B,+CAAA;EACA,yBAAA;EACA,chD4J0B;EgD3J1B,mBAAA;EACA,kBAAA;EACA,cAAA;EAMA,gFAAA;ApD0mVF;AoDxmVI;EACI,4BAAA;ApD0mVR;AoDxmVQ;EACI,eAAA;EACA,gBAAA;ApD0mVZ;AoDtmVI;EAIE,oBAAA;EACA,SAAA;ApDqmVN;AoDzmVM;EACE,6BAAA;ApD2mVR;AoDtmVM;EACI,gBAAA;ApDwmVV;AoDpmVI;EACI,kBhDoHwB;AJk/UhC;AoDpmVQ;EACE,aAAA;ApDsmVV;AoDlmVI;EACI,yBhDyBqB;AJ2kV7B;AoDlmVQ;EACI,yBhDsBiB;AJ8kV7B;AoDhmVY;EACI,chDvCa;AJyoV7B;AoD7lVI;EACI,yBhDuBqB;AJwkV7B;AoD5lVI;EACI,yBhDgBqB;AJ8kV7B;AoD3lVI;EACI,yBhDSqB;AJolV7B;AoD1lVI;EACI,yBhDEqB;AJ0lV7B;AoDzlVI;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;ApD2lVR;AoDxlVI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;ApD0lVR;AoDvlVI;EACE,cAAA;ApDylVN;AoDtlVI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;ApDwlVN;AoDrlVI;EACI,mBhD2JuB;EgD1JvB,kBAAA;EACA,chDxEqB;AJ+pV7B;AoDplVI;EACI,6BAAA;EACA,SAAA;ApDslVR;AoDllVY;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,chDtDa;AJ0oV7B;AoDhlVQ;EACI,SAAA;ApDklVZ;AoD9kVI;EACI,6BAAA;EACA,gBAAA;EACA,gBAAA;ApDglVR;AoD7kVQ;EACI,iBAAA;EACA,kBAAA;ApD+kVZ;AoD5kVQ;EACI,mBhDqBoB;AJyjVhC;;AqDptVI;EACE,gBAAA;EACA,gBAAA;ArDutVN;AqDrtVI;EACE,kBAAA;ArDutVN;AqDntVE;EACE,gBAAA;ArDqtVJ;AqDntVI;EACE,gBAAA;EACA,gCAAA;ArDqtVN;AqDjtVE;EACE,gBAAA;ArDmtVJ;AqDhtVE;EACE,aAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;ArDktVJ;AqDhtVE;EACE,gBAAA;ArDktVJ;AqDhtVI;EACE,cjDJuB;AJstV7B;AqD9sVE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;ArDgtVJ;AqD9sVI;EACE,SAAA;ArDgtVN;;AsD5vVA;EACI,aAAA;AtD+vVJ;;AuD/vVI;EACI,aAAA;AvDkwVR;AuDhwVM;EACE,mBAAA;AvDkwVR;AuD9vVI;EACI,kBAAA;EACA,oBAAA;EACA,iBAAA;AvDgwVR;AuD9vVQ;EACI,gBAAA;AvDgwVZ;AuD5vVI;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AvD8vVR;AuD3vVI;EACI,iBAAA;AvD6vVR;AuD1vVI;EACI,qBAAA;AvD4vVR;AuDzvVI;EACE,cAAA;AvD2vVN;AuDvvVM;EACE,iBAAA;EACA,gBAAA;AvDyvVR;AuDrvVI;EACI,kBAAA;EACA,kBAAA;AvDuvVR;;AwDtyVA;EACI,kCAAA;EACA,sBAAA;EACA,kBAAA;AxDyyVJ;AwDvyVI;EACI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;AxDyyVR;AwDvyVI;EACE,kBAAA;EACA,UAAA;AxDyyVN;AwDtyVI;EACI,gBAAA;AxDwyVR;AwDvyVQ;EACI,gBAAA;AxDyyVZ;AwDryVI;EACI,cpDbqB;AJozV7B;AwDnyVQ;EACI,cpDlBiB;EoDmBjB,gBAAA;AxDqyVZ;AwDjyVI;;;EAGI,+BpDCqB;AJkyV7B;AwDhyVI;EACI,cpD9BqB;EoD+BrB,iBAAA;AxDkyVR;AwD/xVI;EACI,gBAAA;AxDiyVR;AwD9xVI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,qCAAA;EACA,kBpD6FwB;AJmsVhC;;AyD91VA;EACE,oBAAA;AzDi2VF;AyDh2VI;EACE,kBAAA;AzDk2VN;AyDh2VM;EACE,kBAAA;EACA,eAAA;AzDk2VR;AyDh2VU;EACE,cAAA;EACA,WrDQiB;AJ01V7B;AyDh2Vc;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,UAAA;AzDk2VhB;AyD71VU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,yBrDFiB;AJi2V7B;AyD31VQ;EACE,kBAAA;AzD61VV;;A0D73VE;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;A1Dg4VJ;A0D73VE;EACE,iBAAA;A1D+3VJ;A0D53VE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;A1D83VJ;A0D13VI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,oCtDDuB;AJ63V7B;A0Dx3VE;EACE,SAAA;A1D03VJ;A0Dv3VE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;A1Dy3VJ;;A2D/5VA;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;A3Dk6VF;;A4Dp6VQ;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;A5Du6VZ;;A6D76VA;EACI,kBAAA;A7Dg7VJ;A6D96VI;EACI,wBAAA;A7Dg7VR;A6D96VI;EACI,mBAAA;EACA,czDeqB;AJi6V7B;A6D96VI;EACI,mBAAA;EACA,yBAAA;EACA,czDUqB;AJs6V7B;A6D96VQ;EACI,czD4DiB;AJo3V7B;A6D96VQ;EACI,czD+DiB;AJi3V7B;A6D96VQ;EACI,czDgDiB;AJg4V7B;A6D96VQ;EACI,czDgDiB;AJg4V7B;A6D96VQ;EACI,czDmDiB;AJ63V7B;A6D76VQ;EACE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;A7D+6VV;A6D56VI;EACI,2BAAA;A7D86VR;A6D56VI;EACI,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;A7D86VR;A6D56VQ;EACI,cAAA;EACA,qBAAA;A7D86VZ;A6D76VY;EACI,gBAAA;EACA,czD/Ba;AJ88V7B;A6D36VI;EACI,czDEqB;AJ26V7B;A6D36VQ;EACI,czDCiB;AJ46V7B;A6Dv6VY;EACI,czDvDa;EyDwDb,kBAAA;EACA,sCAAA;A7Dy6VhB;A6Dv6VgB;EACI,yBAAA;A7Dy6VpB;A6Dr6VQ;EACI,yBAAA;A7Du6VZ;A6Dp6VY;EACI,+BAAA;A7Ds6VhB;;A6D/5VI;;EAEI,czDrEqB;AJu+V7B;A6D95VY;EACI,gBAAA;EACA,czD3Ea;AJ2+V7B;;A6Dz5VA;;;EAGE,czD9F2B;EyD+F3B,0CAAA;A7D45VF;;A8DzgWA;EACI,gBAAA;EACA,kBAAA;A9D4gWJ;A8D1gWI;EACI,aAAA;A9D4gWR;A8DxgWQ;EACI,gBAAA;A9D0gWZ;A8DxgWY;EACI,eAAA;A9D0gWhB;A8DngWI;EACI,gBAAA;EACA,iBAAA;EACA,oBAAA;A9DqgWR;A8DngWQ;EACI,6BAAA;A9DqgWZ;A8DlgWQ;EACI,gBAAA;A9DogWZ;A8D//VQ;EACI,aAAA;A9DigWZ;A8D7/VQ;EACI,mBAAA;A9D+/VZ;;A+DviWI;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;A/D0iWR;A+DxiWI;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;A/D0iWR;A+DxiWI;EACI,iBAAA;A/D0iWR;A+DviWI;EACI,gBAAA;A/DyiWR;A+DviWQ;EACE,gBAAA;EACA,kBAAA;A/DyiWV;A+DriWI;EACI,gBAAA;EACA,kBAAA;A/DuiWR;A+DriWQ;;EAEI,gBAAA;EACA,iBAAA;EACA,+CAAA;A/DuiWZ;A+DniWI;EACI,mBAAA;EACA,gBAAA;A/DqiWR;;AgE1kWE;EACE,mEAAA;EACA,aAAA;AhE6kWJ;AgEzkWI;EACE,WAAA;EACA,WAAA;EACA,cAAA;AhE2kWN;AgEvkWE;EACE,8CAAA;EACA,cAAA;AhEykWJ;AgErkWI;EACE,gBAAA;EACA,iBAAA;EACA,oBAAA;AhEukWN;AgEnkWE;EACE,aAAA;EACA,kBAAA;AhEqkWJ;AgElkWE;EACE,gBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;AhEokWJ;AgElkWI;EACE,cAAA;AhEokWN;AgEhkWE;EACE,WAAA;EACA,UAAA;AhEkkWJ;AgE/jWE;EACE,gBAAA;EACA,c5DpCyB;AJqmW7B;;AiElnWE;EACE,gBAAA;AjEqnWJ;;AiE/mWI;EACI,sBAAA;AjEknWR;AiEhnWQ;EACE,iBAAA;EACA,cAAA;AjEknWV;AiEhnWY;EACI,gBAAA;AjEknWhB;AiEhnWY;EACE,c7DWe;E6DVf,eAAA;EACA,kBAAA;AjEknWd;AiE9mWI;EACI,sBAAA;AjEgnWR;AiE9mWQ;EACE,c7DCmB;AJ+mW7B;AiE7mWQ;EACE,gBAAA;EACA,mBAAA;AjE+mWV;AiE5mWI;EACI,cAAA;EACA,gBAAA;AjE8mWR;AiE5mWQ;EACI,iBAAA;AjE8mWZ;;AkExpWA;EACI,oBAAA;AlE2pWJ;;AmE5pWA;EACI,gBAAA;EACA,kBAAA;AnE+pWJ;AmE7pWI;EACI,UAAA;AnE+pWR;AmE7pWQ;EACI,eAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AnE+pWZ;AmE5pWI;EACI,kBAAA;AnE8pWR;AmE5pWQ;EACI,kBAAA;EACA,eAAA;AnE8pWZ;AmE5pWQ;EACI,mBAAA;AnE8pWZ;AmE3pWQ;EACE,cAAA;EACA,iBAAA;AnE6pWV;AmEzpWI;EACI,aAAA;AnE2pWR;AmE1pWQ;EACI,kBAAA;EACA,YAAA;EACA,aAAA;AnE4pWZ;AmEvpWQ;EACI,c/DrBiB;E+DsBjB,kBAAA;AnEypWZ;AmEvpWQ;EACI,c/DlBiB;AJ2qW7B;AmEvpWQ;EACI,gBAAA;AnEypWZ;AmExpWY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AnE0pWhB;;AmEppWA;EACI,gBAAA;AnEupWJ;AmEppWQ;EACI,mB/D2FoB;AJ2jWhC;AmEnpWQ;EACI,kBAAA;AnEqpWZ;;AoE3tWA;EACE,gBAAA;ApE8tWF;AoE5tWQ;EACI,gBAAA;EACA,oBAAA;ApE8tWZ;AoE7tWY;EACI,YAAA;ApE+tWhB;AoE5tWQ;EACI,eAAA;ApE8tWZ;AoE5tWQ;EACE,4BAAA;ApE8tWV;AoE3tWI;EACI,4BAAA;ApE6tWR;AoE3tWI;EACI,cAAA;ApE6tWR;AoE3tWI;EACI,2BAAA;ApE6tWR;;AqEpvWE;EACE,eAAA;ArEuvWJ;AqEpvWI;EACI,kBjEqJwB;EiEpJxB,sBjEgMuB;AJsjW/B;AqEpvWQ;EACI,gBAAA;ArEsvWZ;AqEnvWQ;EACI,WAAA;EACA,cAAA;EACA,mBAAA;ArEqvWZ;AqEnvWY;EACI,WAAA;ArEqvWhB;AqEjvWQ;EACI,mBAAA;ArEmvWZ;A0BtwWE;EACE,cAkIgC;ENrIlC,UMImB;ENDnB,0BAAA;ApB0wWF;A0BvwWE;EACE,cA8HgC;ENrIlC,UMQmB;ENLnB,0BAAA;ApB+wWF;A0BxwWE;EACE,cA0HgC;ENrIlC,UMYmB;ENTnB,0BAAA;ApBoxWF;A0BzwWE;EACE,cAsHgC;ENrIlC,UMgBmB;ENbnB,0BAAA;ApByxWF;A0BrpWE;EACE,sCtBnGyB;EsBoGzB,ctB9HyB;AJqxW7B;A0BrpWI;EACE,qBtBjIuB;EsBkIvB,6BtB9FuB;EsB+FvB,ctBnIuB;AJ0xW7B;A0BjpWI;;EACE,ctB1IuB;AJ8xW7B;A0B/oWI;EACE,6BtB5GuB;AJ6vW7B;A0B7oWE;;EAEE,6BtBlHyB;EsBmHzB,sCtB7HyB;EsB8HzB,ctBxJyB;AJuyW7B;A0B3oWI;;EAEE,6BtB1HuB;EsB2HvB,qBtB/JuB;EsBgKvB,ctBhKuB;AJ6yW7B;A0BvoWI;;EACE,0CtBtIuB;EsBuIvB,ctBxKuB;AJkzW7B;A0BxoWM;;;;EAGE,0CtB3IqB;EsB4IrB,ctB9KqB;AJyzW7B;A0BvoWI;;;;EAEE,0CtBnJuB;AJ8xW7B;A0BzoWM;;;;;;;;;;EAGE,0CtBvJqB;EsBwJrB,ctB1LqB;AJ40W7B;A0B5oWQ;;;EAEE,0CtBhKmB;EsBiKnB,ctBnMmB;AJk1W7B;A0B1oWI;;;;EAEE,0CtBzKuB;EsB0KvB,YAAA;EACA,ctB5MuB;AJ01W7B;A0B1oWM;;;;EAEE,0CtBhLqB;EsBiLrB,ctBnNqB;AJi2W7B;AqEj1WY;;;EAGI,+BjEQa;AJ20W7B;AqE90WI;EACI,eAAA;EACA,cjE1BqB;EiE2BrB,qBAAA;ArEg1WR;;AqE30WI;EAEI,kBAAA;EACA,UAAA;ArE60WR;AqE10WI;EACI,gBAAA;EAAA,iBAAA;ArE40WR;AqEz0WI;EACI,iBAAA;ArE20WR;AqEx0WI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;ArE00WR;AqEx0WQ;EACI,cjEpDiB;AJ83W7B;AqEt0WI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;ArEw0WR;AqEr0WI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,oCAAA;ArEu0WR;AqEn0WQ;EACI,mBAAA;ArEq0WZ;AqEh0WQ;EACE,eAAA;ArEk0WV;AqEh0WQ;EACI,qBAAA;ArEk0WZ;AqE/zWQ;EACI,2BAAA;ArEi0WZ;AqE/zWY;EACI,aAAA;ArEi0WhB;AqE/zWgB;EACI,cAAA;ArEi0WpB;AqE9zWgB;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;ArEg0WpB;AqE9zWoB;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;ArEg0WxB;AqE5zWY;EACI,gBAAA;ArE8zWhB;AqEvzWM;EACE,gBAAA;ArEyzWR;;AqE/yWM;;;EACE,0BAAA;EACA,yBAAA;ArEozWR;AqEhzWI;;;EACE,oCAAA;EACA,gBAAA;ArEozWN;AqEjzWI;;;EACE,yBAAA;ArEqzWN;;AqEhzWA;EAMQ;;;IACI,8BAAA;ErEgzWV;EqE5yWU;;;IACE,yBAAA;ErEgzWZ;EqE5yWM;;;IACE,yBAAA;ErEgzWR;EqE3yWM;;;IACE,aAAA;ErE+yWR;EqE5yWQ;;;IACE,8BAAA;ErEgzWV;AACF;AsEp/WA;EACI,eAAA;EACA,kBAAA;EACA,mBlEWyB;AJ2+W7B;AsEp/WI;EACI,gBlEyIuB;AJ62W/B;;AsEn/WA;EACI,iBAAA;AtEs/WJ;;AsEn/WA;EACI,aAAA;AtEs/WJ;;AsEp/WA;EACI,iBAAA;AtEu/WJ;;AsEp/WA;EACI,gBAAA;EACA,aAAA;EACA,WAAA;AtEu/WJ;;AsEp/WA;EACI,sBAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;AtEu/WJ;AsEr/WI;;EAEI,clEpBqB;AJ2gX7B;AsEp/WI;EACI,yBlExBqB;AJ8gX7B;AsEp/WQ;EAEI,yBlE5BiB;AJihX7B;AsEj/WI;;;EAGI,clEnCqB;AJshX7B;AsEj/WI;;EAEI,+BlEZqB;AJ+/W7B;AsEh/WQ;EACI,clElCiB;AJohX7B;AsEh/WQ;;;EAGI,clEhCiB;AJkhX7B;AsE9+WI;EACI,clErDqB;AJqiX7B;AsE7+WQ;;EAEI,clE1DiB;AJyiX7B;AsE7+WQ;EACI,+BAAA;AtE++WZ;AsE3+WI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,oCAAA;AtE6+WR;AsE1+WI;EACI,UAAA;EACA,kBAAA;AtE4+WR;;AsEx+WA;EACI,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,clEvFyB;EkEwFzB,kBAAA;AtE2+WJ;AsEz+WI;EACI,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AtE2+WR;AsEx+WI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EAGA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AtE0+WR;AsEt+WI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AtEw+WR;AsEr+WI;EACI,YAAA;EACA,UAAA;AtEu+WR;AsEp+WI;;EAEI,+BlErGqB;AJ2kX7B;AsEn+WI;EACI,gBAAA;EACA,iBAAA;AtEq+WR;AsEl+WI;EACI,gBAAA;EACA,iBAAA;AtEo+WR;AsEj+WI;EACI,mBAAA;AtEm+WR;AsEj+WI;EACI,gBAAA;AtEm+WR;AsEh+WI;EAEI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;AtEi+WR;AsE99WI;EACI,oCAAA;AtEg+WR;AsE79WI;ECjLA,iCDkL6B,EClLR,+CAAA,EACrB,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,+EAAA,EAAA,oBAAA;AvEipXJ;;AsE99WI;EAEI,aAAA;AtEg+WR;;AsE59WA;EACI,eAAA;AtE+9WJ;AsE79WI;EACI,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,sBAAA;EACA,gDlEiFmB;EkEhFnB,sBAAA;AtE+9WR;AsE79WQ;EACI,iBAAA;AtE+9WZ;AsE59WQ;EACI,UAAA;AtE89WZ;AsE59WY;EACI,iBAAA;AtE89WhB;AsE19WQ;EACI,UAAA;AtE49WZ;AsEz9WQ;EACI,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;AtE29WZ;AsEx9WQ;EACI,iBAAA;EACA,mBAAA;AtE09WZ;AsEt9WI;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;AtEw9WR;;AsEn9WK;EACG,WAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;AtEs9WR;AsEn9WK;EACG,aAAA;EACA,kBAAA;AtEq9WR;AsEl9WK;EACG,mBAAA;AtEo9WR;AsEj9WK;EACG,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AtEm9WR;AsEh9WK;EACG,eAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AtEk9WR;AsE/8WK;EACG,OAAA;EACA,QAAA;AtEi9WR;AsE98WK;EACI,QAAA;EACA,SAAA;AtEg9WT;AsE78WK;EACI,QAAA;AtE+8WT;AsE58WK;EACI,QAAA;EACA,SAAA;AtE88WT;AsE38WK;EACI,QAAA;EACA,QAAA;AtE68WT;AsE18WK;EACI,QAAA;EACA,SAAA;EACD,eAAA;EACA,cAAA;EACA,YAAA;AtE48WR;AsEz8WK;EACI,QAAA;EACA,SAAA;AtE28WT;AsEx8WK;EACI,QAAA;EACA,SAAA;AtE08WT;AsEv8WK;EACG,QAAA;EACA,SAAA;AtEy8WR;AsEt8WK;EACI,QAAA;EACA,SAAA;AtEw8WT;AsEr8WK;EACI,QAAA;EACA,SAAA;AtEu8WT;AsEp8WK;EACI,QAAA;EACA,SAAA;AtEs8WT;AsEn8WK;EACI,OAAA;EACA,SAAA;AtEq8WT;AsEl8WK;EACI,QAAA;EACA,SAAA;AtEo8WT;AsEj8WK;EACG,OAAA;EACA,SAAA;AtEm8WR;;AsE/7WA;EACI,iBAAA;EACA,aAAA;AtEk8WJ;AsEh8WI;;;EAGI,iBAAA;AtEk8WR;AsE/7WI;EACI,gBAAA;AtEi8WR;AsE97WI;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AtEg8WR;AsE57WI;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AtE87WR;;AsE17WA;EACI,yBAAA;AtE67WJ;;AsE17WA;EACI,yBlEpXyB;AJizX7B;;AsE37WA;EACI,yBlEhXyB;AJ8yX7B;;AsE37WA;EACI,clE7XyB;AJ2zX7B;AsE57WI;EACI,0ClEtWqB;AJoyX7B;AsE17WQ;EAEI,WAAA;EAAA,cAAA;AtE27WZ;AsEv7WI;EACE,0ClEzWuB;EkE0WvB,clE5YuB;AJq0X7B;AsEt7WI;;EAII,clEnYqB;AJyzX7B;AsEn7WI;EAEI,WAAA;EAAA,cAAA;AtEo7WR;AsEj7WI;EACI,gBAAA;AtEm7WR;AsEh7WI;;;;;;;;;;EAWI,clE1aqB;AJ21X7B;AsE96WI;EACI,clE9aqB;AJ81X7B;AsE96WQ;EAEI,qBlElbiB;AJi2X7B;AsE36WI;EAGI,sClEvZqB;AJk0X7B;AsEx6WI;;;EAII,+BlEtaqB;AJ+0X7B;AsEt6WI;;;;;EAMI,0CAAA;AtEu6WR;AsEp6WI;EACI,yBlE7cqB;AJm3X7B;AsEn6WI;EACI,clElaqB;AJu0X7B;AsEl6WI;;EAEI,+BlE3bqB;AJ+1X7B;AsEj6WI;EACI,sClExbqB;AJ21X7B;AsE/5WI;;;;EAII,sClEhcqB;AJi2X7B;AsE95WI;;;EAGI,clExeqB;AJw4X7B;AsE75WI;;EAEI,clE7eqB;AJ44X7B;AsE55WI;;EAEI,yBlElfqB;EkEmfrB,qBlEnfqB;AJi5X7B;A0B15XE;EACE,cAkIgC;ENrIlC,UMImB;ENDnB,0BAAA;ApB85XF;A0B35XE;EACE,cA8HgC;ENrIlC,UMQmB;ENLnB,0BAAA;ApBm6XF;A0B55XE;EACE,cA0HgC;ENrIlC,UMYmB;ENTnB,0BAAA;ApBw6XF;A0B75XE;EACE,cAsHgC;ENrIlC,UMgBmB;ENbnB,0BAAA;ApB66XF;A0BzyXE;EACE,sCtBnGyB;EsBoGzB,ctB9HyB;AJy6X7B;A0BzyXI;EACE,qBtBjIuB;EsBkIvB,6BtB9FuB;EsB+FvB,ctBnIuB;AJ86X7B;A0BryXI;;EACE,ctB1IuB;AJk7X7B;A0BnyXI;EACE,6BtB5GuB;AJi5X7B;A0BjyXE;;EAEE,6BtBlHyB;EsBmHzB,sCtB7HyB;EsB8HzB,ctBxJyB;AJ27X7B;A0B/xXI;;EAEE,6BtB1HuB;EsB2HvB,qBtB/JuB;EsBgKvB,ctBhKuB;AJi8X7B;A0B3xXI;;EACE,0CtBtIuB;EsBuIvB,ctBxKuB;AJs8X7B;A0B5xXM;;;;EAGE,0CtB3IqB;EsB4IrB,ctB9KqB;AJ68X7B;A0B3xXI;;;;EAEE,0CtBnJuB;AJk7X7B;A0B7xXM;;;;;;;;;;EAGE,0CtBvJqB;EsBwJrB,ctB1LqB;AJg+X7B;A0BhyXQ;;;EAEE,0CtBhKmB;EsBiKnB,ctBnMmB;AJs+X7B;A0B9xXI;;;;EAEE,0CtBzKuB;EsB0KvB,YAAA;EACA,ctB5MuB;AJ8+X7B;A0B9xXM;;;;EAEE,0CtBhLqB;EsBiLrB,ctBnNqB;AJq/X7B;AsE5/WI;;;EAGI,+BlEjeqB;AJ+9X7B;AsE1/WQ;EACI,6BlE7diB;EkE8djB,yBAAA;EACA,clE1fiB;AJs/X7B;AsE1/WY;EACI,mBAAA;AtE4/WhB;AsEx/WQ;;;EAGI,clExeiB;EkEyejB,yBAAA;AtE0/WZ;AsEp/WI;EACI,6BlEjfqB;EkEkfrB,sClE5fqB;EkE6frB,clEvhBqB;AJ6gY7B;AsEp/WQ;EAII,6BlEzfiB;EkE0fjB,qBlE9hBiB;AJihY7B;AsE3+WgB;EACI,clEviBS;AJohY7B;AsEv+WI;EACI,clE9iBqB;AJuhY7B;;AwEriYA;EAEE;IACE,UAAA;ExEuiYF;EwEriYE;IACE,cAAA;ExEuiYJ;EwEpiYE;IACE,eAAA;IACA,eAAA;ExEsiYJ;EwEliYE;IACI,iBAAA;ExEoiYN;EwEjiYE;IACI,aAAA;ExEmiYN;EwEhiYE;IACI,aAAA;ExEkiYN;EwE9hYM;IACI,mBAAA;IACA,kBAAA;ExEgiYV;EwE5hYQ;IACE,SAAA;IACA,eAAA;ExE8hYV;EwEzhYU;IACE,gBAAA;ExE2hYZ;EwEzhYU;IACI,mBAAA;ExE2hYd;EwEvhYM;IACI,cAAA;ExEyhYV;EwEthYM;IACI,aAAA;ExEwhYV;EwErhYM;;IAEI,SAAA;IACA,gBAAA;IACA,wBAAA;IACA,WAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;ExEuhYV;EwErhYU;;IACI,aAAA;ExEwhYd;EwEphYM;;IAEI,cpE9DiB;EJolY3B;EwEnhYM;IAEI,cpEpBiB;EJwiY3B;EwEjhYM;IACI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mBpE7BiB;EJgjY3B;EwEjhYU;IACI,eAAA;ExEmhYd;EwEhhYU;IACI,eAAA;ExEkhYd;EwE/gYU;IACI,WAAA;IACA,6BAAA;ExEihYd;EwE7gYM;IACI,yBpE9CiB;EJ6jY3B;EwE5gYM;IACI,WAAA;ExE8gYV;EwE5gYU;IACI,eAAA;ExE8gYd;EwExgYE;I/D9GA,0DAAA;ET6nYF;EwE1gYM;IACI,QAAA;I7DjHJ,mCAAA;EXkoYN;EwE7gYM;I7DrHA,iCAAA;EXyoYN;EwEhhYM;IACI,kBAAA;IACA,kBAAA;ExEkhYV;EwE9gYU;I7D/HJ,oCAAA;EXopYN;EwEjhYU;;I7DnIJ,iCAAA;EX4pYN;EwEphYU;I7DxIJ,oCAAA;EXmqYN;EwEvhYU;IACI,YAAA;IACA,UAAA;ExEyhYd;EwEnhYM;IACI,UAAA;IACA,QAAA;I7DtJJ,mCAAA;EXgrYN;EwErhYE;;;IAGE,8BAAA;ExEuhYJ;EwErhYE;IACE,QAAA;I/DvJD,+BAAA;IAGA,6BAAA;ETirYH;EwE1hYE;IACE,UAAA;ExE4hYJ;EwE1hYE;IACE,WAAA;I/D9JD,kCAAA;IAGA,6BAAA;ET6rYH;EwE/hYE;IACE,QAAA;I/DlKD,4BAAA;IAGA,6BAAA;ETssYH;EwEpiYE;IACE,UAAA;ExEsiYJ;EwEpiYE;IACE,WAAA;I/DzKD,+BAAA;IAGA,6BAAA;ETktYH;EWzpYE;IACE;MAAI,QAAA;MAAU,uBAAA;IX6pYhB;IW5pYE;MAAK,QAAA;MAAU,yBAAA;IXgqYjB;IW/pYE;MAAK,yBAAA;IXkqYP;IWjqYE;MAAM,yBAAA;IXoqYR;EACF;EWppYE;IACE;MAAK,QAAA;MAAU,yBAAA;IXwrYjB;IWvrYE;MAAM,yBAAA;IX0rYR;IWzrYE;MAAM,uBAAA;IX4rYR;IW3rYE;MAAO,QAAA;MAAU,oBAAA;IX+rYnB;EACF;EW7qYE;IACE;MAAI,WAAA;MAAa,uBAAA;IXitYnB;IWhtYE;MAAK,WAAA;MAAa,0BAAA;IXotYpB;IWntYE;MAAK,0BAAA;IXstYP;IWrtYE;MAAM,0BAAA;IXwtYR;EACF;EWxsYE;IACE;MAAK,WAAA;MAAY,0BAAA;IX4uYnB;IW3uYE;MAAM,wBAAA;IX8uYR;IW7uYE;MAAM,wBAAA;IXgvYR;IW/uYE;MAAO,WAAA;MAAY,oBAAA;IXmvYrB;EACF;EwE3rYE;IACE;MAAI,UAAA;IxE8uYN;IwE7uYE;MAAM,UAAA;IxEgvYR;EACF;EwE9uYE;IACI,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,QAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;I/DvNJ,0DAAA;ET48YF;EwEhvYM;IACI,iBAAA;ExEkvYV;EwE9uYE;IACI,gBAAA;ExEgvYN;EwE3uYU;;IAEI,YAAA;ExE6uYd;EwExuYE;;IAEI,eAAA;IACA,cAAA;IACA,MAAA;IACA,YAAA;IACA,YAAA;IACA,WAAA;IACA,OAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,UAAA;I/D1PJ,0DAAA;IEGI,oCAAA;EX2+YN;EwE5uYE;IACE,WAAA;ExE8uYJ;EwE1uYI;IACI,mBAAA;ExE4uYR;EwEzuYI;IACI,mBAAA;ExE2uYR;EwExuYI;IACI,uBAAA;IACA,qBAAA;ExE0uYR;EwExuYQ;IACI,+BAAA;IACA,mCAAA;IACA,sBAAA;IACA,sBAAA;ExE0uYZ;EwEvuYQ;IACI,+BAAA;IACA,mCAAA;IACA,sBAAA;IACA,sBAAA;ExEyuYZ;AACF;AwEpuYA;EACE;IACE,gBAAA;ExEsuYF;AACF;AwEnuYA;EAEI;IACE,kBAAA;ExEouYJ;EwEjuYE;IACE,mBAAA;ExEmuYJ;AACF;AwE/tYA;EACI;IACI,2BAAA;ExEiuYN;EwE9tYE;IACI,aAAA;ExEguYN;EwE3tYU;IACI,UAAA;IACA,kBAAA;ExE6tYd;EwExtYE;IACI,kBAAA;ExE0tYN;EwEvtYE;IACI,cAAA;ExEytYN;EwErtYM;IACI,YAAA;IACA,mBAAA;ExEutYV;EwE9sYU;;IACE,gCAAA;IACA,kCAAA;IACA,qCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IACA,QAAA;IACA,iCAAA;ExEitYZ;EwE9sYU;;IACE,gCAAA;IACA,kCAAA;IACA,qCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IACA,QAAA;IACA,iCAAA;ExEitYZ;EwE5sYY;IAEE,MAAA;ExE6sYd;AACF;AwEpsYA;EACE;IACE,aAAA;ExEssYF;EwEnsYA;IACE,kBAAA;IACA,mBAAA;ExEqsYF;EwEjsYM;IACI,cAAA;IACA,kBAAA;IACA,WAAA;ExEmsYV;EwE/rYE;IACI,cAAA;IACA,mBAAA;ExEisYN;EwE5rYM;IACE,gBAAA;ExE8rYR;AACF;AwExrYA;EACE;IACE,eAAA;ExE0rYF;EwEvrYA;IACE,4BAAA;ExEyrYF;EwEvrYE;IACE,sBAAA;ExEyrYJ;EwElrYE;;;IACE,oBAAA;ExEsrYJ;EwEjrYE;;IAEE,yBAAA;ExEmrYJ;EwEhrYE;IACE,8BAAA;ExEkrYJ;EwE7qYE;IACE,gBAAA;ExE+qYJ;EwE7qYE;IACE,kBAAA;ExE+qYJ;EwE7qYE;IACE,aAAA;ExE+qYJ;AACF;AwE3qYA;EAEI;IACE,iBAAA;ExE4qYJ;AACF;AwExqYA;EAGM;IACE,uBAAA;ExEwqYN;EwEtqYM;IACE,8CAAA;ExEwqYR;EwErqYM;IAEE,wBAAA;ExEsqYR;AACF;AwE9pYA;EACI;IACI,cAAA;IACA,eAAA;ExEgqYN;EwE7pYE;IACE,sBAAA;ExE+pYJ;EwE7pYI;IACE,mBAAA;ExE+pYN;EwE1pYM;IACI,kBAAA;ExE4pYV;EwEtpYU;IACI,eAAA;ExEwpYd;EwEtpYc;IACI,eAAA;ExEwpYlB;EwEjpYM;IACI,UAAA;ExEmpYV;EwE9oYI;IACE,UAAA;IACA,aAAA;ExEgpYN;AACF;AyElrZE;EACE,iBAAA;EACA,gBAAA;AzEorZJ;;A0EvrZA,iCAAA;AAEE;EACE,gBAAA;A1EyrZJ;;A2E1rZE;;EACE,iBAAA;A3E8rZJ;;A2E3rZA;;EAEE,gBAAA;A3E8rZF;;A2E5rZA;;EAEE,gBAAA;A3E+rZF;;A4ExsZM;EACE,iBAAA;A5E2sZR;A4EvsZM;EACE,iBAAA;A5EysZR;;A6EhtZI;;EACI,gBAAA;A7EotZR;;A8ErtZE;EACE,kB1EwJ4B;E0EvJ5B,sB1EmM2B;AJqhZ/B;A8EttZI;EACE,gBAAA;A9EwtZN;A8ErtZI;EACE,WAAA;EACA,cAAA;EACA,mBAAA;A9EutZN;A8ErtZM;EACE,WAAA;A9EutZR;A8EntZI;EACE,mBAAA;A9EqtZN;A0BruZE;EACE,cAkIgC;ENrIlC,UMImB;ENDnB,0BAAA;ApByuZF;A0BtuZE;EACE,cA8HgC;ENrIlC,UMQmB;ENLnB,0BAAA;ApB8uZF;A0BvuZE;EACE,cA0HgC;ENrIlC,UMYmB;ENTnB,0BAAA;ApBmvZF;A0BxuZE;EACE,cAsHgC;ENrIlC,UMgBmB;ENbnB,0BAAA;ApBwvZF;A0BpnZE;EACE,sCtBnGyB;EsBoGzB,ctB9HyB;AJovZ7B;A0BpnZI;EACE,qBtBjIuB;EsBkIvB,6BtB9FuB;EsB+FvB,ctBnIuB;AJyvZ7B;A0BhnZI;;EACE,ctB1IuB;AJ6vZ7B;A0B9mZI;EACE,6BtB5GuB;AJ4tZ7B;A0B5mZE;;EAEE,6BtBlHyB;EsBmHzB,sCtB7HyB;EsB8HzB,ctBxJyB;AJswZ7B;A0B1mZI;;EAEE,6BtB1HuB;EsB2HvB,qBtB/JuB;EsBgKvB,ctBhKuB;AJ4wZ7B;A0BtmZI;;EACE,0CtBtIuB;EsBuIvB,ctBxKuB;AJixZ7B;A0BvmZM;;;;EAGE,0CtB3IqB;EsB4IrB,ctB9KqB;AJwxZ7B;A0BtmZI;;;;EAEE,0CtBnJuB;AJ6vZ7B;A0BxmZM;;;;;;;;;;EAGE,0CtBvJqB;EsBwJrB,ctB1LqB;AJ2yZ7B;A0B3mZQ;;;EAEE,0CtBhKmB;EsBiKnB,ctBnMmB;AJizZ7B;A0BzmZI;;;;EAEE,0CtBzKuB;EsB0KvB,YAAA;EACA,ctB5MuB;AJyzZ7B;A0BzmZM;;;;EAEE,0CtBhLqB;EsBiLrB,ctBnNqB;AJg0Z7B;A8EnzZM;;;EAGE,+B1EWqB;AJ0yZ7B;A8EhzZE;EACE,eAAA;EACA,c1EvByB;E0EwBzB,qBAAA;A9EkzZJ;;A8E9yZA;EACE,mBAAA;EACA,iBAAA;EACA,sBAAA;A9EizZF;A8EhzZE;EACE,kBAAA;EACA,UAAA;A9EkzZJ;A8E3yZE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A9E6yZJ;A8E3yZI;EACE,c1E/CuB;AJ41Z7B;A8EzyZE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;A9E2yZJ;A8ExyZE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,oCAAA;A9E0yZJ;A8EtyZI;EACE,mBAAA;A9EwyZN;A8EnyZI;EACE,eAAA;A9EqyZN;A8EnyZI;EACE,qBAAA;A9EqyZN;A8ElyZI;EACE,2BAAA;A9EoyZN;A8ElyZM;EACE,aAAA;A9EoyZR;A8ElyZQ;EACE,cAAA;A9EoyZV;A8EjyZQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;A9EmyZV;A8EjyZU;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;A9EmyZZ;A8E/xZM;EACE,gBAAA;A9EiyZR;;A8ErxZM;;;EACE,0BAAA;EACA,yBAAA;A9E0xZR;A8EzxZQ;;;EACE,iBAAA;A9E6xZV;A8ExxZI;;;EACE,oCAAA;EACA,gBAAA;A9E4xZN;A8EzxZI;;;EACE,yBAAA;A9E6xZN;;A8ExxZA;;;EAGE,WAAA;A9E2xZF;;A8ExxZA;EAMQ;;;IACE,8BAAA;E9EwxZR;E8EpxZU;;;IACE,yBAAA;E9EwxZZ;E8EpxZM;;;IACE,yBAAA;E9EwxZR;E8EnxZM;;;IACE,aAAA;E9EuxZR;E8EpxZQ;;;IACE,8BAAA;E9EwxZV;AACF;A+E19ZA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;A/E49ZF;;A+E19ZA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,wBAAA;EACA,UAAA;EAEA,cAAA;A/E49ZF;;A+E19ZA;EACE,qBAAA;EACA,kBAAA;A/E69ZF;A+E39ZE;EACE,aAAA;A/E69ZJ;;A+E19ZA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;A/E69ZF;;A+E39ZA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,8C3E8OyB;AJgvZ3B;A+E59ZE;EACI,kBAAA;EACA,gBAAA;A/E89ZN;;A+E39ZA;EACE,gBAAA;A/E89ZF;;A+E59ZA;EACE,sBAAA;A/E+9ZF;;A+E79ZA;;EAEE,aAAA;A/Eg+ZF;;A+E99ZA;EACE,eAAA;A/Ei+ZF;;A+E/9ZA;EACE,qBAAA;EACA,gBAAA;EACA,sBAAA;A/Ek+ZF;;A+Eh+ZA;EACE,sBAAA;A/Em+ZF;;A+Ej+ZA;EACE,cAAA;A/Eo+ZF;;A+El+ZA;EACE,kBAAA;EACA,UAAA;A/Eq+ZF;;A+En+ZA;EACE,UAAA;A/Es+ZF;;A+Ep+ZA;;EAEE,0BAAA;A/Eu+ZF;;A+Er+ZA;;;;EAIE,0BAAA;A/Ew+ZF;;A+Et+ZA;;EAEE,0BAAA;A/Ey+ZF;;A+Ev+ZA;EACE,c3EhB2B;AJ0/Z7B;;A+Ex+ZA;EACE,qB3EnB2B;AJ8/Z7B;;A+Ez+ZA;EACE,c3EnB2B;AJ+/Z7B;;A+E1+ZA;EACE,qB3EtB2B;AJmga7B;;A+E3+ZA;EACE,c3ElC2B;AJgha7B;;A+E5+ZA;EACE,qB3ErC2B;AJoha7B;;A+E7+ZA;EACE,cAAA;A/Eg/ZF;;A+E9+ZA;EACI,cAAA;EACA,kBAAA;EACA,UAAA;A/Ei/ZJ;;A+E/+ZA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;A/Ek/ZJ;;A+E/+ZA;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;A/Ek/ZJ;A+Eh/ZI;EACI,qBAAA;A/Ek/ZR;;A+E/+ZA;EACI,eAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;A/Ek/ZJ;;A+E/+ZA;EACI,WAAA;A/Ek/ZJ;;AgF5oaA;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;AhF+oaJ;AgF7oaI;;EAEI,qBAAA;EACA,6BAAA;EACA,0BAAA;AhF+oaR;AgF5oaI;EACI,cAAA;EACA,aAAA;EACA,0BAAA;EACA,WAAA;AhF8oaR;AgF3oaI;EACI,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AhF6oaR;AgF1oaI;EACE,QAAA;EACA,WAAA;EACA,eAAA;AhF4oaN;AgFzoaI;;EAEI,WAAA;EACA,iBAAA;EACA,UAAA;AhF2oaR;AgFxoaI;EACI,cAAA;AhF0oaR;AgFvoaI;EACI,cAAA;AhFyoaR;AgFtoaI;;;EAGI,cAAA;EACA,kBAAA;AhFwoaR;AgFroaI;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;AhFuoaR;AgFpoaI;;EAEI,gBAAA;AhFsoaR;AgFnoaI;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AhFqoaR;AgFnoaM;ElDlFF,qB1BiByB;E0BhBzB,yB1BgByB;E4EmErB,yBAAA;AhFsoaR;AgFpoaM;ElDtFF,qB1BsByB;E0BrBzB,yB1BqByB;E4EkEnB,yBAAA;AhFuoaV;AgFnoaI;;EAEI,qBAAA;AhFqoaR;AgFloaI;EACI,yB5EvBqB;AJ2pa7B;AgFloaI;EACI,yB5E7BqB;AJiqa7B;AgFloaI;EACI,yB5EnCqB;AJuqa7B;AgFloaI;EACI,yB5E7BqB;AJiqa7B;AgFloaI;EACI,yB5E7BqB;AJiqa7B;AgFjoaI;EACI,eAAA;EACA,YAAA;AhFmoaR;AgFhoaI;EACI,cAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;AhFkoaR;AgF/naI;;;EAGI,WAAA;EACA,YAAA;EACA,mBAAA;AhFioaR;AgF9naI;EACI,YAAA;AhFgoaR;AgF9naQ;EACI,kBAAA;AhFgoaZ;AgF5naI;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AhF8naR;AgF3naI;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AhF6naR;AgFznaQ;EACI,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AhF2naZ;AgFxnaQ;EACI,kBAAA;AhF0naZ;AgFxnaY;EACI,kBAAA;EACA,SAAA;AhF0nahB;AgFvnaY;;EAEI,kBAAA;AhFynahB;AgFrnaQ;EACI,kBAAA;AhFunaZ;AgFrnaY;EACE,kBAAA;EACA,WAAA;EACA,mB5EoEiB;E4EnEjB,c5E9He;AJqva7B;AgFrnac;EACE,UAAA;AhFunahB;AgFnnaY;EACI,eAAA;AhFqnahB;AgFjnaQ;EACM,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;AhFmnad;AgF3maY;EACM,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AhF6malB;AgF3makB;EACG,gBAAA;AhF6marB;AgFzmaY;EAEI,6BAAA;AhF0mahB;AgFrmagB;EACI,qCAAA;AhFumapB;AgFlmaQ;;EAEI,qBAAA;EACA,yBAAA;AhFomaZ;AgF/laI;EACI,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AhFimaR;AgF7laQ;EACI,iBAAA;AhF+laZ;AgF5laQ;EACI,gBAAA;AhF8laZ;AgFzlaQ;EACE,qBAAA;AhF2laV;AgFzlaU;EACG,0CAAA;EACA,0CAAA;EACA,uCAAA;EACA,YAAA;EACA,aAAA;AhF2lab;AgFxlaU;EACG,0CAAA;EACA,+BAAA;EACA,uCAAA;EACA,YAAA;EACA,aAAA;AhF0lab;AgFvlaU;EAEG,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,oCAAA;EACA,iCAAA;AhFwlab;AgFnlaQ;EACE,8CAAA;EACA,uBAAA;EACA,iBAAA;AhFqlaV;AgFhlaI;EACI,SAAA;AhFklaR;;AgF5kaI;ErEnSI,+CAAA;AXu3aR;AgFjlaM;EAEE,UAAA;AhFklaR;AgF/kaI;ErE3SI,8CAAA;AXi4aR;AgFjlaM;ErEhTE,8CAAA;AXw4aR;AgFplaM;ErEpTE,8CAAA;AX+4aR;;AiF36aA;EACE,YAAA;EAAA,eAAA;AjF86aF;;AiF36aA;EACE,UAAA;EACA,gBAAA;EAAA,iBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAAA,eAAA;EACA,aAAA;EAAA,gBAAA;AjF86aF;;AkF37aA;;EAEI,aAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EAAA,cAAA;EACA,YAAA;AlF87aJ;;AmFj8aM;;EAEE,gBAAA;AnFo8aR;;AoFz8aA;;;;;kCAAA;AAMA;EACE,2BAAA;EACA,4CAAA;EACA,qPAAA;EACA,mBAAA;EACA,kBAAA;ApF48aF;AoF18aA,oCAAA;ACbA,+CAAA;AAGI;EACI,cAAA;ArFw9aR;AqFt9aI;EACI,yBAAA;EACA,gBAAA;EACA,cjFoDqB;EiFnDrB,gBjFgQwB;EiF/PxB,iBAAA;EACA,kBAAA;ArFw9aR;AqFr9aI;;;EAGI,yBjF2CqB;EiF1CrB,cAAA;ArFu9aR;AqFr9aI;EACI,uCAAA;EACA,SAAA;ArFu9aR;AqFr9aI;EACI,uCAAA;ArFu9aR;AqFr9aI;EACE,8BAAA;EACA,mBAAA;ArFu9aN;AqFr9aI;EACI,yBjF4BqB;EiF3BrB,cjFpBqB;AJ2+a7B;;AqFj9aQ;EACI,yBAAA;EACA,cjF4BiB;AJw7a7B;AqFn9aY;EACI,yBAAA;EACA,mBjFyBa;EiFxBb,cjFhCa;AJq/a7B;;AqF98aQ;EACI,yBAAA;EACA,cjF2BiB;AJs7a7B;AqFh9aY;EACI,yBAAA;EACA,mBjFwBa;EiFvBb,cjF7Ca;AJ+/a7B;;AqF38aQ;EACI,yBAAA;EACA,cjFQiB;AJs8a7B;AqF78aY;EACI,yBAAA;EACA,mBjFKa;EiFJb,cjF1Da;AJygb7B;;AqFx8aQ;EACI,yBAAA;EACA,cjFRiB;AJm9a7B;AqF18aY;EACI,yBAAA;EACA,mBjFXa;EiFYb,cjFvEa;AJmhb7B;;AqFr8aQ;EACI,yBAAA;EACA,cjFfiB;AJu9a7B;AqFv8aY;EACI,yBAAA;EACA,mBjFlBa;EiFmBb,cjFpFa;AJ6hb7B;;AqFh8aA;;EAEI,+BAAA;EACH,4BAAA;EACG,gCAAA;EACA,6BAAA;ArFm8aJ;;AqFj8aA;;EAEI,oCAAA;ArFo8aJ;;AqFl8aA;;EAEI,oCAAA;ArFq8aJ;;AqFn8aA;;EAEI,oCAAA;ArFs8aJ;;AqFp8aA;;EAEI,oCAAA;ArFu8aJ;;AqFr8aA;;EAEI,oCAAA;ArFw8aJ;;AqFt8aA;;EAEI,oCAAA;ArFy8aJ;;AsFjlbA;EAEE;IACE,UAAA;EtFmlbF;EsFjlbE;IACE,cAAA;EtFmlbJ;EsFhlbE;IACE,eAAA;IACA,eAAA;EtFklbJ;EsF9kbA;IACE,iBAAA;EtFglbF;EsF7kbA;IACE,aAAA;EtF+kbF;EsF5kbA;IACE,aAAA;EtF8kbF;EsF1kbE;IACE,mBAAA;IACA,kBAAA;EtF4kbJ;EsFxkbI;IACE,SAAA;IACA,eAAA;EtF0kbN;EsFrkbI;IACE,gBAAA;EtFukbN;EsFrkbI;IACE,mBAAA;EtFukbN;EsFnkbE;IACE,yBAAA;IACA,gDAAA;EtFqkbJ;EsFlkbE;IACE,aAAA;EtFokbJ;EsFjkbE;;IAEE,SAAA;IACA,gBAAA;IACA,wBAAA;IACA,WAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,2BAAA;IACA,kBAAA;EtFmkbJ;EsFjkbI;;IACE,aAAA;EtFokbN;EsFhkbE;;IAEE,clF/DuB;EJiob3B;EsF/jbE;IAEE,clFrBuB;EJqlb3B;EsF7jbE;IACE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mBlF9BuB;EJ6lb3B;EsF7jbI;IACE,eAAA;EtF+jbN;EsF5jbI;IACE,eAAA;EtF8jbN;EsF3jbI;IACE,WAAA;IACA,6BAAA;EtF6jbN;EsFzjbE;IACE,yBlF/CuB;EJ0mb3B;EsFxjbE;IACE,WAAA;EtF0jbJ;EsFxjbI;IACE,eAAA;EtF0jbN;EsFpjbA;I7E/GE,0DAAA;ET0qbF;EsFtjbE;IACE,QAAA;I3ElHE,mCAAA;EX+qbN;EsFzjbE;I3EtHI,iCAAA;EXsrbN;EsF5jbE;IACE,kBAAA;IACA,kBAAA;EtF8jbJ;EsF1jbI;I3EhIE,oCAAA;EXisbN;EsF7jbI;;I3EpIE,iCAAA;EXysbN;EsFhkbI;I3EzIE,oCAAA;EXgtbN;EsFnkbI;IACE,UAAA;EtFqkbN;EsF/jbE;IACE,UAAA;IACA,QAAA;I3EtJE,mCAAA;EX4tbN;EsFjkbA;;;IAGE,8BAAA;EtFmkbF;EsFjkbA;IACE,QAAA;I7EvJC,+BAAA;IAGA,6BAAA;ET6tbH;EsFtkbA;IACE,UAAA;EtFwkbF;EsFtkbA;IACE,WAAA;I7E9JC,kCAAA;IAGA,6BAAA;ETyubH;EsF3kbA;IACE,QAAA;I7ElKC,4BAAA;IAGA,6BAAA;ETkvbH;EsFhlbA;IACE,UAAA;EtFklbF;EsFhlbA;IACE,WAAA;I7EzKC,+BAAA;IAGA,6BAAA;ET8vbH;EWrsbE;IACE;MAAI,QAAA;MAAU,uBAAA;IXysbhB;IWxsbE;MAAK,QAAA;MAAU,yBAAA;IX4sbjB;IW3sbE;MAAK,yBAAA;IX8sbP;IW7sbE;MAAM,yBAAA;IXgtbR;EACF;EWhsbE;IACE;MAAK,QAAA;MAAU,yBAAA;IXoubjB;IWnubE;MAAM,yBAAA;IXsubR;IWrubE;MAAM,uBAAA;IXwubR;IWvubE;MAAO,QAAA;MAAU,oBAAA;IX2ubnB;EACF;EWztbE;IACE;MAAI,WAAA;MAAa,uBAAA;IX6vbnB;IW5vbE;MAAK,WAAA;MAAa,0BAAA;IXgwbpB;IW/vbE;MAAK,0BAAA;IXkwbP;IWjwbE;MAAM,0BAAA;IXowbR;EACF;EWpvbE;IACE;MAAK,WAAA;MAAY,0BAAA;IXwxbnB;IWvxbE;MAAM,wBAAA;IX0xbR;IWzxbE;MAAM,wBAAA;IX4xbR;IW3xbE;MAAO,WAAA;MAAY,oBAAA;IX+xbrB;EACF;EsFvubA;IACE;MAAI,UAAA;ItF0xbJ;IsFzxbA;MAAM,UAAA;ItF4xbN;EACF;EsF1xbA;IACE,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,QAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;I7EtNA,0DAAA;ETu/bF;EsF5xbE;IACE,iBAAA;EtF8xbJ;EsF1xbA;IACE,gBAAA;EtF4xbF;EsFvxbI;;IAEE,YAAA;EtFyxbN;EsFpxbA;;IAEE,eAAA;IACA,cAAA;IACA,MAAA;IACA,YAAA;IACA,YAAA;IACA,WAAA;IACA,OAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,UAAA;I7EzPA,0DAAA;IEGI,oCAAA;EXshcN;EsFxxbA;IACE,WAAA;EtF0xbF;EsFtxbE;IACE,mBAAA;EtFwxbJ;EsFrxbE;IACE,mBAAA;EtFuxbJ;EsFpxbE;IACE,uBAAA;IACA,qBAAA;EtFsxbJ;EsFpxbI;IACE,+BAAA;IACA,mCAAA;IACA,sBAAA;IACA,sBAAA;EtFsxbN;EsFnxbI;IACE,+BAAA;IACA,mCAAA;IACA,sBAAA;IACA,sBAAA;EtFqxbN;EsFhxbA;IACE,WAAA;EtFkxbF;EsFjxbE;IACE,gBAAA;IACA,WAAA;EtFmxbJ;AACF;AsF/wbA;EACE;IACE,gBAAA;EtFixbF;AACF;AsF9wbA;EAEI;IACE,kBAAA;EtF+wbJ;EsF5wbE;IACE,mBAAA;EtF8wbJ;AACF;AsF1wbA;EACE;IACE,2BAAA;EtF4wbF;EsFzwbA;IACE,aAAA;EtF2wbF;EsFtwbI;IACE,UAAA;IACA,kBAAA;EtFwwbN;EsFnwbA;IACE,kBAAA;EtFqwbF;EsFlwbA;IACE,cAAA;EtFowbF;EsFhwbE;IACE,YAAA;IACA,mBAAA;EtFkwbJ;EsF3vbM;IACE,SAAA;EtF6vbR;EsF3vbM;IACE,SAAA;EtF6vbR;EsFxvbQ;IACE,wBAAA;EtF0vbV;EsFtvbQ;IACE,gCAAA;IACA,kCAAA;IACA,qCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IACA,QAAA;IACA,iCAAA;EtFwvbV;EsFrvbQ;IACE,gCAAA;IACA,kCAAA;IACA,qCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,YAAA;IACA,UAAA;IACA,QAAA;IACA,iCAAA;EtFuvbV;AACF;AsF/ubA;EACE;IACE,aAAA;EtFivbF;EsF9ubA;IACE,kBAAA;IACA,mBAAA;EtFgvbF;EsF5ubE;IACE,cAAA;IACA,kBAAA;IACA,WAAA;EtF8ubJ;EsF1ubA;IACE,cAAA;IACA,mBAAA;EtF4ubF;EsFvubI;IACE,gBAAA;EtFyubN;AACF;AsFnubA;EAEE;IACE,4BAAA;EtFoubF;EsFlubE;IACE,sBAAA;EtFoubJ;EsF7tbE;;;IACE,oBAAA;EtFiubJ;EsF5tbE;;IAEE,yBAAA;EtF8tbJ;EsF3tbE;IACE,8BAAA;EtF6tbJ;EsFxtbE;IACE,gBAAA;EtF0tbJ;EsFxtbE;IACE,kBAAA;EtF0tbJ;EsFxtbE;IACE,aAAA;EtF0tbJ;AACF;AsFttbA;EAGM;IACE,uBAAA;EtFstbN;EsFptbM;IACE,8CAAA;EtFstbR;EsFntbM;IAEE,wBAAA;EtFotbR;AACF;AsF5sbA;EACE;IACE,cAAA;IACA,eAAA;EtF8sbF;EsF3sbA;IACE,sBAAA;EtF6sbF;EsF3sbE;IACE,mBAAA;EtF6sbJ;EsFxsbE;IACE,kBAAA;EtF0sbJ;EsFpsbI;IACE,eAAA;EtFssbN;EsFpsbM;IACE,eAAA;EtFssbR;EsF/rbE;IACE,UAAA;EtFisbJ;EsF5rbE;IACE,UAAA;IACA,aAAA;EtF8rbJ;AACF;AuFjucA;EACI,kBAAA;EACA,MAAA;EACA,aAAA;EACA,kBAAA;AvFmucJ;AuFjucI;EACI,iBAAA;EACA,YAAA;AvFmucR;AuFlucQ;EACE,aAAA;AvFoucV;;AuF/tcA;;EAEI,eAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;AvFkucJ;AuFhucI;;EACI,kBAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;AvFmucR;AuFjucQ;;EACE,wBAAA;AvFoucV;AuFjucQ;;EACI,YAAA;AvFoucZ;AuF9tcc;;;;EACE,qBAAA;AvFmuchB;AuF/tcc;;;;EACE,SAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AvFouchB;AuFjucc;;;;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,+BnFhCa;AJswc7B;AuFnucc;;;;EACE,0BAAA;AvFwuchB;AuFrucc;;;;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AvF0uchB;AuFpucI;;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;AvFuucN;AuFnucI;;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AvFsucN;AuFpucM;;EACI,WAAA;EACA,YAAA;AvFuucV;AuFnucI;;EACI,gBAAA;EACA,cAAA;AvFsucR;AuFpucQ;;EACI,SAAA;EACA,kBAAA;EACA,WAAA;AvFuucZ;AuFnucY;;EACI,eAAA;AvFsuchB;AuFnucY;;EACI,mBAAA;EACA,cnFlHa;EmFmHb,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;AvFsuchB;AuFnucY;;EACE,gBAAA;AvFsucd;AuFnucY;;;EAEE,UAAA;AvFsucd;AuFlucY;;;EAEI,UAAA;AvFquchB;AuF7tcY;;;;;EAIE,cnFlFe;AJkzc7B;AuF9tcc;;;;;EACE,6BAAA;EACA,gBAAA;AvFouchB;AuFlucgB;;;;;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;AvFwuclB;AuFnucY;;EACE,aAAA;AvFsucd;AuFlucQ;;EACI,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AvFqucZ;AuFlucQ;;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,+BnFjKiB;EmFkKjB,kBAAA;AvFqucZ;AuFhucU;;;;EACE,aAAA;AvFqucZ;AuFhucI;;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;AvFmucR;AuFjucQ;;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AvFoucZ;AuFhucI;;EACI,kBAAA;EACA,mBAAA;EACA,UAAA;AvFmucR;AuF5tcQ;;EACI,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AvF+tcZ;AuF5tcQ;;EACI,cAAA;EACA,UAAA;EACA,mBAAA;E5ErPJ,iCAAA;AXy9cR;AuFhucQ;;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,0CnFrOiB;AJw8c7B;AuF/tcQ;;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cnFvQiB;EmFwQjB,iBAAA;EACA,mDAAA;AvFkucZ;AuF/tcQ;;EACI,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,enF9BmB;EmF+BnB,cnFlRiB;EmFmRjB,qBAAA;EACA,gBnF1BoB;EmF2BpB,iBAAA;EACA,gBAAA;AvFkucZ;AuF9tcI;;EACI,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AvFiucR;AuF/tcQ;;EACI,WAAA;EACA,YAAA;AvFkucZ;AuF9tcI;;;EAEI,cAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AvFiucR;AuF9tcI;;E5E3RA,mBPqByB;EOjBzB,iDAAA;E4EyRI,UAAA;AvFqucR;AS3hdE;;EACE,mBLFyB;AJgid7B;AWv2cQ;;;;;;;;;;;;EAME,cPhJmB;EOiJnB,YAAA;AX+2cV;AW52cQ;;;EAEI,UAAA;AX+2cZ;AWz2cM;;EACE,cP7JqB;AJygd7B;AW12cM;;EACE,yBPhKqB;EOiKrB,YAAA;AX62cR;AWx2cM;;;;;;EAGE,yBAAA;AX62cR;AW32cM;;EACE,yBP5KqB;EO6KrB,YAAA;AX82cR;ASzkdE;;EACE,mBL6CyB;AJ+hd7B;AS5jdU;;;;;;;EAME,cLgCiB;EK/BjB,UAAA;AT+jdZ;AStkdU;;;;;;;EAME,cLsCiB;EKrCjB,UAAA;ATykdZ;AShldU;;;;;;;EAME,cLmCiB;EKlCjB,UAAA;ATmldZ;AS1ldU;;;;;;;EAME,cLyCiB;EKxCjB,UAAA;AT6ldZ;ASpmdU;;;;;;;EAME,cL4CiB;EK3CjB,UAAA;ATumdZ;AuF5ycI;;EACI,oBAAA;EACA,mBAAA;EACA,kBAAA;AvF+ycR;AuF7ycQ;;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,0CAAA;AvFgzcZ;AuF7ycQ;;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AvFgzcZ;AuF7ycY;;EACI,WAAA;AvFgzchB;AuF5ycQ;;EACI,cnFpXiB;EmFqXjB,qBAAA;EACA,oBAAA;EACA,mBAAA;AvF+ycZ;AuF1ycY;;EACG,cAAA;EACA,iBAAA;AvF6ycf;AuF3ycgB;;EAEG,cAAA;EACA,kBAAA;EACA,UAAA;AvF6ycnB;AuFzycY;;EACI,kBAAA;EACA,QAAA;EACA,WAAA;AvF4ychB;;AuFtycA;EACI,gCAAA;AvFyycJ;;AuFvycA;EACI,wBAAA;AvF0ycJ;;AuFrycQ;;EAEI,cnF5ZiB;AJosd7B;AuFrycQ;EACI,oCAAA;AvFuycZ;;AuFjycA;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;E9E7aA,0DAAA;ATstdJ;AuFrycI;EACI,oBAAA;EACA,+BAAA;EACA,gBAAA;AvFuycR;AuFpycI;EACI,+BAAA;EACA,gBAAA;AvFsycR;AuFnycI;EACI,gBAAA;AvFqycR;AuFjycI;EACI,mBAAA;AvFmycR;;AuF7xcE;;EAEI,YAAA;EACA,gBAAA;AvFgycN;;AuF3xcA;EACI;;;IAII,uCAAA;IAEA,sCAAA;IAEA,gDAAA;IACA,iCAAA;EvF8xcN;EuFzxcM;IACE,wBAAA;EvF2xcR;EuFzxcM;IACE,gCAAA;EvF2xcR;EuFxxcM;;IAEE,WAAA;EvF0xcR;EuFvxcM;IACE,wBnF9ImB;EJu6c3B;EuFtxcM;IACE,cAAA;IACA,aAAA;EvFwxcR;EuFrxcY;IACI,UAAA;I5ElfV,mCAAA;EX8wdN;EuFzxcY;IACI,UAAA;EvF2xchB;EuFtxcU;;;;I5E3fJ,mCAAA;I4EggBQ,UAAA;EvF4xcd;EuFvxcM;IACE,YAAA;EvFyxcR;EuFtxcU;IACI,UAAA;I5E1gBR,+BAAA;EXuydN;EuFxxcQ;IACE,UAAA;EvF0xcV;EuFxxcQ;IACE,YAAA;EvF0xcV;EuFxxcU;;;;I5ErhBJ,iCAAA;I4E0hBM,UAAA;EvF8xcZ;AACF;AuFvxcA;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA,EAAA,8BAAA;EAEA,4EAAA;EACA,kBAAA;EACA,gBAAA;AvFyxcF;AuFtxcI;EACE,cnF7iBuB;AJq0d7B;AuFtxcI;EACE,gBAAA;EACA,+BnFvhBuB;EmFwhBvB,cAAA;EACA,eAAA;AvFwxcN;AuFtxcM;EACE,cnFtjBqB;AJ80d7B;;AuFlxcA;EACE,aAAA;AvFqxcF;;AuFlxcA;EACE,aAAA;AvFqxcF;;AuF/wcA;EAGI,oBAAA;EAGA,mBAAA;EAGA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AvFkxcJ;AuFhxcI;EACE,UAAA;EACA,wBAAA;EAAA,uBAAA;EACA,WAAA;AvFkxcN;;AuF7wcE;EACE,4BAAA;AvFgxcJ;;AwF93dA,gDAAA;AACA;EACE,kBAAA;EACA,gCAAA;EACA,mBAAA;AxFi4dF;AwF/3dE;EACE,oBAAA;AxFi4dJ;;AwF93dA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AxFi4dF;;AwF/3dA;EACE,uBAAA;EACA,qBAAA;EACA,epF0O6B;EoFzO7B,gBpFiP8B;AJipdhC;AwFh4dI;EACE,cAAA;EACA,cpF6BuB;EoF5BvB,6BAAA;AxFk4dN;AwFh4dI;EACE,cpF3BuB;AJ65d7B;AwFh4dI;EACE,cpF9BuB;AJg6d7B;AwF93dE;EACE,cpFnCyB;EoFoCzB,kBAAA;AxFg4dJ;AwF73dI;;;EAGE,6BAAA;EACA,cAAA;AxF+3dN;AwF73dM;;;EACE,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AxFi4dR;AwF93dM;;;EACE,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AxFk4dR;AwF73dE;EACE,6BAAA;AxF+3dJ;AwF73dE;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;AxF+3dJ;AwF73dI;;EAEE,cAAA;EACA,yBAAA;AxF+3dN;AwF73dI;EACE,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AxF+3dN;AwF73dI;EACE,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AxF+3dN;;AwFz3dI;EACE,iBAAA;AxF43dN;AwF13dI;EACE,YAAA;AxF43dN;;AwFr3dA;EACE,kBpF8B6B;AJ01d/B;AwFt3dE;EACE,cAAA;EACA,mBAAA;EACA,cpFjGyB;EoFkGzB,kBAAA;EpE7HF,YoE8HmB;EpE3HnB,yBAAA;ApBo/dF;AwFv3dI;EAEE,6BpFnFuB;EgB/C3B,UoEmIqB;EpEhIrB,0BAAA;ApBy/dF;AwFt3dE;EACE,eAAA;AxFw3dJ;AwFt3dE;EACE,cpFjEyB;AJy7d7B;;AwFr3dA;EACE,qBAAA;AxFw3dF;AwFv3dE;EACE,eAAA;EACA,mBAAA;AxFy3dJ;AwFv3dE;EACE,kBpFiG2B;EoFhG3B,mBAAA;EACA,cpF+F2B;AJ0xd/B;;AwFt3dA;EACE,cAAA;AxFy3dF;AwFx3dE;EACE,mBAAA;AxF03dJ;;AwFv3dA;EACE,cpF7F2B;AJu9d7B;;AwFx3dA;EACE,cpF1F2B;AJq9d7B;;AwFz3dA;EACE,cpFhG2B;AJ49d7B;;AwF13dA;EACE,cpF7F2B;AJ09d7B;;AwF33dA;EACE,cpF7F2B;AJ29d7B;;AwF33dA;EACE,kBpF3B6B;AJy5d/B;AwF53dE;EACE,cpFoE2B;EoFnE3B,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBpF+E4B;AJ+ydhC;AwF33dE;EACE,cAAA;AxF63dJ;AwF33dE;EACE,aAAA;AxF63dJ;;AwFx3dE;EACE,qBAAA;AxF23dJ;AwFz3dE;EACE,kBAAA;AxF23dJ;;AwFv3dA;EACE,oBAAA;AxF03dF;;AwFt3dA;;;;EAIE,gCAAA;EACA,kCAAA;EACA,qCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AxFy3dF;;AwFt3dA;;;;EAIE,gCAAA;EACA,kCAAA;EACA,qCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AxFy3dF;;AwFv3dA;EACE,iBAAA;AxF03dF;;AwFv3dA;EACE,+BAAA;EACA,eAAA;EACA,mBAAA;AxF03dF;;AyF5meM;EACE,iBAAA;AzF+meR;;A0FnneA;;;EAAA;AAIA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;A1FsneF;;A0FpneA;EACE,kBAAA;A1FuneF;;A0FrneA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;A1FwneF;;A0FtneA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;A1FyneF;;A0FvneA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;A1F0neF;;A0FxneA;EACE,YAAA;EACA,WAAA;A1F2neF;;A0FzneA;EACE,WAAA;EACA,UAAA;A1F4neF;;A0F1neA;EAAA;AAEA;EACE,OAAA;EACA,WAAA;A1F6neF;;A0F3neA;;EAAA;AAGA;EACE,QAAA;A1F8neF;;A0F5neA;EACE,SAAA;A1F+neF;;A0F7neA;EACE,mCAAA;EACA,2BAAA;EACA,kBAAA;EACA,yBAAA;A1FgoeF;;A0F9neA;EACE,YAAA;EACA,WAAA;A1FioeF;;A0F/neA;;EAGE,0BAAA;A1FkoeF;;A0FhoeA;EACE,0BAAA;A1FmoeF;;A0FjoeA;EAAA;AAEA;EACE,WAAA;A1FooeF;;A0FloeA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;A1FqoeF;;A0FnoeA;EACE,UAAA;A1FsoeF;;A0FpoeA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;A1FuoeF;;A0FroeA;EACE,WAAA;EACA,WAAA;A1FwoeF;;A0FtoeA;;EAAA;AAGA;EACE,mCAAA;EACA,kBAAA;A1FyoeF;;A0FroeA;EACE,kBAAA;A1FwoeF;;A0FtoeA;EACE,mBAAA;A1FyoeF;;A0FvoeA;EAAA;AAEA;EACE,iBAAA;A1F0oeF;;A0FxoeA;EACE,iBAAA;A1F2oeF;;A0FzoeA;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;A1F4oeF;;A0F1oeA;EACE,yEAAA;A1F6oeF;;A0F3oeA;EAAA;AAGA;;EAEE,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;A1F6oeF;;A0F3oeA;EACE,SAAA;A1F8oeF;;A0F5oeA;EAAA;AAEA;EACE,mBAAA;A1F+oeF;;A0F7oeA;;;EAGE,mBAAA;A1FgpeF;;A0F9oeA;;EAAA;AAGA;;EAGE,sBAAA;A1FipeF;;A0F/oeA;EACE,kBAAA;EACA,WAAA;A1FkpeF;;A0FhpeA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;A1FmpeF;;A0FjpeA;EACE,WAAA;EACA,eAAA;A1FopeF;;A0FlpeA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;A1FqpeF;;A0FnpeA;EACE,gBAAA;A1FspeF;;A0FppeA;EACE,gBAAA;A1FupeF;;A0FrpeA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;A1FwpeF;;A0FtpeA;EAEE,+BAAA;A1FypeF;;A0FvpeA;EAEE,8BAAA;A1F0peF;;A0FxpeA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;A1F2peF;;A0FzpeA;EACE,YAAA;A1F4peF;;A0F1peA;EACE,YAAA;A1F6peF;;A0F3peA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;A1F8peF;;A0F5peA;EAEE,6BAAA;EACA,kBAAA;A1F+peF;;A0F7peA;EAEE,4BAAA;A1FgqeF;;A0F9peA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;A1FiqeF;;A0F/peA;EACE,WAAA;A1FkqeF;;A0FhqeA;EACE,WAAA;A1FmqeF;;A0FjqeA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;A1FoqeF;;A0FlqeA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;A1FqqeF;;A0FnqeA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;A1FsqeF;;A0FpqeA;EAEE,4BAAA;EACA,UAAA;EACA,YAAA;A1FuqeF;;A0FrqeA;EAEE,8BAAA;EACA,SAAA;EACA,WAAA;A1FwqeF;;A0FtqeA;EACE,+BAAA;A1FyqeF;;A2Fn9eA;EACE,cAAA;EACA,aAAA;EACA,SAAA;A3Fs9eF;;A2Fp9eA;EACE,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;A3Fu9eF;;A2Fr9eA;EACE,mBAAA;A3Fw9eF;;A2Ft9eA;EACE,SAAA;EACA,UAAA;A3Fy9eF;;A2Fv9eA;EACE,sBAAA;EACA,YAAA;EAGA,aAAA;EAGQ,sBAAA;EAGA,oBAAA;A3F09eV;;A2Fx9eA;;;EAGE,mBAAA;A3F29eF;;A2Fz9eA;;EAEE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;A3F49eF;;A2F19eA;;;;EAIE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A3F69eF;;A2F39eA;EACE,cAAA;A3F89eF;;A2F59eA;EACE,cAAA;EACA,YAAA;A3F+9eF;;A2F19eA;EACE,gBAAA;EAGQ,SAAA;EACR,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;EACA,cAAA;A3F69eF;A2F39eI;EACE,mBAAA;A3F69eN;;A2Fz9eA;;;EAGE,cAAA;EACA,qBAAA;A3F49eF;;A2F19eA;EACE,kBAAA;EAGK,iBAAA;EACL,yBAAA;EACA,UAAA;EACA,iBAAA;A3F69eF;;A2F39eA;EAGE,aAAA;EAGQ,mBAAA;EACR,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;A3F89eF;;A2F59eA;EAGU,YAAA;EACR,eAAA;EACA,kBAAA;EACA,oBAAA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;A3F+9eJ;;A2F79eA;ExE5HI,yBf2DyB;Ee8DrB,cf7GqB;EuFkH3B,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,aAAA;A3Fi+eF;AmBxmfI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBgmfR;AmB7lfI;EACI,gBAAA;AnB+lfR;AmBxlfQ;EAMI,yBf2BiB;Ee1BjB,qBf0BiB;AJ2jf7B;AmB1/eI;EACI,cflEqB;EemErB,qBfnEqB;AJ+jf7B;AmB1/eQ;EAGI,6BfnFiB;EeoFjB,cfvEiB;EewEjB,qBfxEiB;EeyEjB,gBAAA;AnB0/eZ;AmBt/eI;EACI,cfhFqB;AJwkf7B;AmBt/eQ;EAII,6BfjGiB;EekGjB,cfrFiB;EesFjB,qBAAA;EACA,gBAAA;AnBq/eZ;;A2F9/eA;EACE,aAAA;A3FigfF;;A2F//eA;EACE,qBAAA;A3FkgfF;;A2F9/eA;EACI,iBAAA;EACA,mBAAA;A3FigfJ;;A2F//eA;EACA;IACE,sBAAA;E3FkgfA;AACF;A2F//eA;EACE,iBAAA;EACA,mBAAA;A3FigfF;;A2F3/eA;;EAEE,iBAAA;A3F8/eF;;A2F3/eA;EACE,eAAA;EACA,oBAAA;A3F8/eF;;A2F5/eA;EACE,yBAAA;A3F+/eF;;A2F7/eA;EACE,cAAA;A3FggfF;;A2F9/eA;EACE,kDAAA;A3FigfF;;A2F//eA;EACE,yBAAA;EACA,4BAAA;A3FkgfF;;A2FhgfA;EACE,0BAAA;EACA,6BAAA;A3FmgfF;;A2FjgfA;EACE,yBAAA;EACA,0BAAA;A3FogfF;;A2FlgfA;EACE,4BAAA;EACA,6BAAA;A3FqgfF;;A2FngfA;EACE,4BAAA;EACA,6BAAA;A3FsgfF;;A2FpgfA;EACE,yBAAA;EACA,0BAAA;A3FugfF;;A2FrgfA;EAGE,aAAA;EAGQ,mBAAA;A3FwgfV;;A2FtgfA;EACE,oBAAA;A3FygfF;;A2FvgfA;EACE,oCAAA;A3F0gfF;;A2FxgfA;EACE,0CAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;A3F2gfF;;A2FzgfA;EACE,kBAAA;EACA,sBAAA;EAGA,aAAA;EAGQ,sBAAA;EAGA,SAAA;EACR,WAAA;EAGK,iBAAA;EACL,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;A3F4gfF;;A2F1gfA;EACE,gBAAA;A3F6gfF;;A2F3gfA;EAGE,aAAA;EAGQ,mBAAA;A3F8gfV;;A2F3gfA;EAGE,aAAA;EACA,kBAAA;EAGQ,sBAAA;EAGA,SAAA;EAEJ,4BAAA;EAEJ,gBAAA;EACA,YAAA;A3F4gfF;;A2F1gfA;EACE,0BAAA;A3F6gfF;;A2F3gfA;EACI,SAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;A3F8gfJ;;A2F5gfA;EACE,iBAAA;A3F+gfF;;A2F7gfA;;;EAGE,cAAA;EACA,qBAAA;A3FghfF;;A2F9gfA;EAGE,aAAA;EAGQ,mBAAA;EAGA,SAAA;EACR,gBAAA;A3FihfF;;A2F/gfA;EAGU,SAAA;A3FkhfV;;A2FhhfA;EACE,2BAAA;A3FmhfF;;A2FjhfA;EACE,oBAAA;EACA,4BAAA;A3FohfF;;A2FlhfA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;A3FqhfF;;A2FnhfA;EACE,eAAA;A3FshfF;;A2FphfA;EACE,gCAAA;EACA,6BAAA;EACA,iBAAA;A3FuhfF;;A2FrhfA;EAGE,aAAA;EAGQ,sBAAA;EAGA,SAAA;EACR,cAAA;A3FwhfF;;A2FthfA;EACE,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;A3FyhfF;;A2FvhfA;EACE,iBAAA;EACA,mBAAA;A3F0hfF;;A2FxhfA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;A3F2hfF;;A2FzhfA;EACE,2BAAA;A3F4hfF;;A2F1hfA;EACE,oBAAA;EACA,4BAAA;A3F6hfF;;A2F3hfA;EACE,0BAAA;A3F8hfF;;A2F5hfA;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;A3F+hfF;;A2F7hfA;EACE,iBAAA;A3FgifF;;A2F9hfA;EACE,yBAAA;A3FiifF;;A2F/hfA;EACE,aAAA;A3FkifF;;A2FhifA;EACE,aAAA;A3FmifF;;A2FjifA;;EAEE,mBAAA;A3FoifF;;A2FlifA;EACE,WAAA;A3FqifF;;A2FnifA;EAGE,aAAA;EAGQ,sBAAA;EACR,gBAAA;A3FsifF;;A2FpifA;EAGU,SAAA;A3FuifV;;A2FrifA;EACE,6BAAA;EACA,gBAAA;EAGA,aAAA;EAGQ,wBAAA;A3FwifV;;A2FtifA;;EAIU,UAAA;A3FyifV;;A2FvifA;EACE,cAAA;A3F0ifF;;A2FxifA;EACE,kBAAA;A3F2ifF;;A2FzifA;EACE,SAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;A3F4ifF;;A2F1ifA;EACE,UAAA;EACA,QAAA;A3F6ifF;;A2F3ifA;EAGE,aAAA;EACA,gBAAA;EACA,gBAAA;EAGQ,sBAAA;EAGA,uBAAA;EACR,gBAAA;EACA,kBAAA;A3F8ifF;;A2F5ifA;EAGU,UAAA;EACR,kBAAA;EACA,WAAA;EACA,iBAAA;EAGA,uBAAA;EACA,WAAA;EACI,mBAAA;A3F+ifN;;A2F7ifA;EACE,WAAA;EAGQ,SAAA;EACR,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;A3FgjfF;;A2F9ifA;EACE,2BAAA;A3FijfF;;A2F/ifA;EAGU,SAAA;A3FkjfV;;A2FhjfA;EACE,iBAAA;A3FmjfF;;A2FjjfA;EACE,kBAAA;A3FojfF;;A2FljfA;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;A3FqjfF;;A2FnjfA;EACE,YAAA;A3FsjfF;;A2FpjfA;EAGE,aAAA;EAGQ,sBAAA;EAGA,SAAA;EACR,WAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;A3FujfF;;A2FrjfA;EACE,mBAAA;A3FwjfF;;A2FtjfA;EACE,uBAAA;EACA,WAAA;EACA,kBAAA;A3FyjfF;;A2FvjfA;EACE,kBAAA;EACA,UAAA;A3F0jfF;;A2FxjfA;EACE,sBAAA;EACA,gBAAA;A3F2jfF;;A2FzjfA;EAGE,aAAA;EAGQ,cAAA;EAGA,mBAAA;A3F4jfV;;A2F1jfA;EACE,4BAAA;A3F6jfF;;A2F3jfA;EACE,qBAAA;EACA,2BAAA;A3F8jfF;;A2F5jfA;EACE,6BAAA;A3F+jfF;;A2F7jfA;EACE,6BAAA;A3FgkfF;;A2F9jfA;EAGU,SAAA;EACR,YAAA;EAGQ,sBAAA;EACR,2BAAA;A3FikfF;;A2F/jfA;EACE,oBAAA;EACA,4BAAA;A3FkkfF;;A2FhkfA;EAGE,aAAA;EAGQ,SAAA;EAGA,uBAAA;EACR,WAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;A3FmkfF;;A2FjkfA;EAGU,UAAA;A3FokfV;;A2FlkfA;EACE,2BAAA;A3FqkfF;;A2FnkfA;EACE,oBAAA;EACA,4BAAA;A3FskfF;;A2FpkfA;EACE,WAAA;EAGK,iBAAA;EACL,yBAAA;A3FukfF;;A2FrkfA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;A3FwkfF;;A2FtkfA;EACE,WAAA;EACA,kBAAA,EAAA,kDAAA;EACA,cAAA,EAAA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,yCvFnf2B,EuFmfI,6BAAA;EAE/B,mBAAA,EAAA,sCAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;A3FwkfF;A2FtkfE;EACE,yCvF3fyB;AJmkgB7B;A2FtkfE;EACE,0CvF7fyB;AJqkgB7B;A2FtkfE;EACE,yCvF/fyB;AJukgB7B;A2FtkfE;EACE,yCvFjgByB;AJykgB7B;A2FrkfE;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;A3FukfJ;;A2FpkfA;EACK,yBAAA;EACA,uBAAA;EAAA,0BAAA;EACA,2BAAA;EAAA,8BAAA;A3FukfL;;A2FpkfA;EACE,yBvF1oB2B;AJitgB7B;;A2FrkfA;EACE;IACE,cAAA;E3FwkfF;E2FvkfE;IACE,cAAA;IACA,kBAAA;E3FykfJ;E2FvkfE;IACE,cAAA;IACA,kBAAA;IACA,UAAA;E3FykfJ;AACF;A4FlvgBA;EACI,aAAA;A5FovgBJ;;A4FlvgBA;EACE,uBAAA;A5FqvgBF;;A6F7ugBA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EAEA,wEAAA;A7FgvgBF;;A6F7ugBA;EACE,oBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EAEA,+BAAA;EACA,uBAAA;A7FgvgBF;;A6F7ugBA;;;EAKE,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,0BAAA;A7FgvgBF;A6F9ugBE;;;EACE,eAAA;EACA,iBAAA;A7FkvgBJ;;A6F9ugBA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;A7FivgBF;;A6F9ugBA;;EAEE,WAAA;EACA,mBAAA;A7FivgBF;;A6F9ugBA;;EAEE,WAAA;EACA,mBAAA;A7FivgBF;;A6F9ugBA;;EAEE,WAAA;EACA,mBAAA;A7FivgBF;;A6F9ugBA;;EAEE,mBAAA;EACA,WAAA;A7FivgBF;;A6F9ugBA;;EAEE,WAAA;EACA,mBAAA;A7FivgBF;;A6F7ugBA;EACE,WAAA;EACA,mBAAA;A7FgvgBF;;A6F7ugBA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kEAAA;A7FgvgBF;;A6F7ugBA;EACE,8BAAA;EACA,2BAAA;A7FgvgBF;;A6F7ugBA;EACE,gBAAA;A7FgvgBF;;A6F7ugBA;;EAEE,6BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;A7FgvgBF;;A6F7ugBA;;EAEE,YAAA;A7FgvgBF;;A6F7ugBA;;;EAGE,gBAAA;EACA,eAAA;EACA,gBAAA;A7FgvgBF;;A6F7ugBA;;;EAGE,iBAAA;EACA,eAAA;EACA,gBAAA;A7FgvgBF;;A6F7ugBA;;;EAGE,iBAAA;EACA,eAAA;EACA,iBAAA;A7FgvgBF;;A6F7ugBA;;;EAGE,0BAAA;A7FgvgBF;;A6F7ugBA;;;;;;;;;EASE,YAAA;EACA,yBAAA;EACA,0BAAA;A7FgvgBF;;A6F7ugBA;EAEE,4BAAA;A7FgvgBF;;A6F7ugBA;EACE,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;A7FgvgBF;;A6F7ugBA;EACE,6BAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;A7FgvgBF;;A6F7ugBA;EACE,4BAAA;A7FgvgBF;;A6F7ugBA;EACE,6BAAA;A7FgvgBF;;A6F7ugBA;EACE,sBAAA;EACA,iBAAA;A7FgvgBF;;A6F7ugBA;EACE,sBAAA;EACA,6BAAA;A7FgvgBF;;A6F7ugBA;EACE,yBAAA;A7FgvgBF;;A6F7ugBA;EACE,yBAAA;A7FgvgBF;;A6F7ugBA;EACE,yBAAA;A7FgvgBF;;A6F7ugBA;EACE,yBAAA;A7FgvgBF;;A6F7ugBA;EACE,yBAAA;A7FgvgBF;;A6F7ugBA;EACE,yBAAA;A7FgvgBF;;A6F7ugBA;EACE,yBAAA;A7FgvgBF;;A6F9ugBA;EACE,yBAAA;A7FivgBF;;A6F9ugBA;;;;;EAKE,yBAAA;A7FivgBF;;A6F/ugBA;EACE,gBAAA;EACA,YAAA;A7FkvgBF;;A8FtghBA;EACI,iBAAA;EACA,8C1FsRuB;E0FrRvB,UAAA;ErFOA,4BAAA;ATughBJ;AUhhhBM;EACI,cNoEmB;AJ88gB7B;AU9ghBQ;EACI,qBN+DiB;AJi9gB7B;AUzghBY;EACI,qBNuDa;EMtDb,cNsDa;AJq9gB7B;AU//gBQ;EACI,yBNyCiB;AJw9gB7B;AU7/gBI;EACI,yBNoCqB;AJ29gB7B;AU5/gBI;EACI,qBNgCqB;AJ89gB7B;AUnihBM;EACI,cNYmB;AJyhhB7B;AUjihBQ;EACI,qBNOiB;AJ4hhB7B;AU5hhBY;EACI,qBNDa;EMEb,cNFa;AJgihB7B;AUlhhBQ;EACI,yBNfiB;AJmihB7B;AUhhhBI;EACI,yBNpBqB;AJsihB7B;AU/ghBI;EACI,qBNxBqB;AJyihB7B;AUtjhBM;EACI,cNuEmB;AJi/gB7B;AUpjhBQ;EACI,qBNkEiB;AJo/gB7B;AU/ihBY;EACI,qBN0Da;EMzDb,cNyDa;AJw/gB7B;AUrihBQ;EACI,yBN4CiB;AJ2/gB7B;AUnihBI;EACI,yBNuCqB;AJ8/gB7B;AUlihBI;EACI,qBNmCqB;AJighB7B;AUzkhBM;EACI,cN0EmB;AJighB7B;AUvkhBQ;EACI,qBNqEiB;AJoghB7B;AUlkhBY;EACI,qBN6Da;EM5Db,cN4Da;AJwghB7B;AUxjhBQ;EACI,yBN+CiB;AJ2ghB7B;AUtjhBI;EACI,yBN0CqB;AJ8ghB7B;AUrjhBI;EACI,qBNsCqB;AJihhB7B;AU5lhBM;EACI,cN6EmB;AJihhB7B;AU1lhBQ;EACI,qBNwEiB;AJohhB7B;AUrlhBY;EACI,qBNgEa;EM/Db,cN+Da;AJwhhB7B;AU3khBQ;EACI,yBNkDiB;AJ2hhB7B;AUzkhBI;EACI,yBN6CqB;AJ8hhB7B;AUxkhBI;EACI,qBNyCqB;AJiihB7B;AU/mhBM;EACI,cNgFmB;AJiihB7B;AU7mhBQ;EACI,qBN2EiB;AJoihB7B;AUxmhBY;EACI,qBNmEa;EMlEb,cNkEa;AJwihB7B;AU9lhBQ;EACI,yBNqDiB;AJ2ihB7B;AU5lhBI;EACI,yBNgDqB;AJ8ihB7B;AU3lhBI;EACI,qBN4CqB;AJijhB7B;A8FxmhBI;EACI,UAAA;A9F0mhBR;A8FvmhBI;EACE,0BAAA;EACA,oBAAA;EACA,6BAAA;A9FymhBN;A8FxmhBM;EACE,c1F4HoB;AJ8+gB5B;A8FzmhBQ;EACE,c1FRmB;AJmnhB7B;A8FtmhBI;EACI,aAAA;A9FwmhBR;A8FrmhBI;;;;;;EAMI,6BAAA;EACA,gBAAA;A9FumhBR;A8FpmhBI;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;A9FsmhBR;A8FnmhBI;EACE,kBAAA;A9FqmhBN;A8FnmhBM;EACE,aAAA;EACA,mBAAA;EAEA,uBAAA;A9FqmhBR;A8FjmhBI;;EAEE,qBAAA;EACA,eAAA;EACA,mBAAA;EAAA,oBAAA;EACA,iBAAA;EACA,UAAA;EACA,sBAAA;A9FmmhBN;A8FjmhBI;EACE,iBAAA;A9FmmhBN;A8FhmhBI;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;A9FkmhBR;A8FhmhBQ;EACI,qBAAA;A9FkmhBZ;A8F9lhBI;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,4CAAA;EACA,QAAA;EACA,SAAA;EACA,yB1FpDqB;E0FqDrB,8C1FsKmB;E0FrKnB,yBAAA;EACA,eAAA;EACA,gBAAA;A9FgmhBR;A8F7lhBI;EACI,eAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;A9F+lhBR;A8F5lhBI;EACI,WAAA;A9F8lhBR;A8F3lhBI;EACI,iBAAA;EACA,eAAA;A9F6lhBR;A8F1lhBI;EACI,eAAA;A9F4lhBR;A8F1lhBQ;EACI,gBAAA;A9F4lhBZ;A8FxlhBI;EACI,aAAA;A9F0lhBR;A8FvlhBI;EACI,kBAAA;EACA,oBAAA;A9FylhBR;A8FvlhBQ;EACG,eAAA;A9FylhBX;A8FrlhBI;EACI,kBAAA;A9FulhBR;A8FplhBI;EACI,yBAAA;A9FslhBR;A8FnlhBI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;A9FqlhBR;A8FllhBI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;A9FolhBR;A8FllhBQ;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;A9FolhBZ;A8FjlhBQ;EACI,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,c1FnIiB;E0FoIjB,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;A9FmlhBZ;A8FhlhBQ;EACI,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;A9FklhBZ;A8F7khBY;EACI,qBAAA;A9F+khBhB;A8F3khBQ;;EAEI,kBAAA;EACA,cAAA;EACA,WAAA;A9F6khBZ;A8FzkhBI;EACI,aAAA;A9F2khBR;A8FxkhBI;EACI,eAAA;EACA,mBAAA;A9F0khBR;A8FvkhBI;EACI,SAAA;A9FykhBR;A8FtkhBI;EACI,yB1F9MqB;AJsxhB7B;A8FtkhBQ;EACI,cAAA;A9FwkhBZ;A8FrkhBQ;EACI,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;A9FukhBZ;A8FpkhBQ;;;;;EAKI,yBAAA;EACA,gBAAA;A9FskhBZ;A8FnkhBQ;EACI,cAAA;EACA,eAAA;EACA,eAAA;A9FqkhBZ;A8FjkhBE;EACE,gBAAA;A9FmkhBJ;A8F9jhBI;;EnF/PI,4CAAA;AXq0hBR;;A+F11hBA;;CAAA;AAGA;EACI,kBAAA;A/F61hBJ;A+F51hBI;EAKI,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;A/F81hBR;A+F31hBQ;EACI,UAAA;EACA,mBAAA;EACA,aAAA;A/F61hBZ;;A+Fz1hBA;EACI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gDAAA;EACA,oCAAA;EACA,4BAAA;EACA,gBAAA;A/F41hBJ;A+F11hBI;EACI,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,0BAAA;EACA,qCAAA;EACA,oCAAA;A/F41hBR;A+F11hBI;EACI,kCAAA;EACA,qCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;A/F41hBR;;A+Fx1hBA;EACI,cAAA;EACA,SAAA;A/F21hBJ;;A+Fz1hBA;EACI,gBAAA;EACA,gBAAA;A/F41hBJ;;A+Fz1hBA;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;A/F41hBJ;;A+Fz1hBA;EACI,WAAA;EACA,SAAA;EACA,gCAAA;A/F41hBJ;;A+F11hBA;;EAEI,kBAAA;EACA,YAAA;A/F61hBJ;;A+F31hBA;EACI,eAAA;A/F81hBJ;;A+F51hBA;EACI,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;A/F+1hBJ;A+F91hBI;EAGI,oCAAA;EACA,c3F1FqB;AJw7hB7B;;A+Fz1hBQ;EACI,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;A/F41hBZ;A+F11hBQ;;EAEI,c3F3FiB;AJu7hB7B;;A+Fv1hBA;;;;;EAKI,mBAAA;EACA,eAAA;A/F01hBJ;;A+Fx1hBA;EACI,kBAAA;A/F21hBJ;;A+Fz1hBA;EACI,yBAAA;A/F41hBJ;;A+F11hBA;;EAEI,gBAAA;EACA,cAAA;EACA,mBAAA;A/F61hBJ;;A+F11hBA;EACI,cAAA;A/F61hBJ;;A+F31hBA;;EAEI,gBAAA;EACA,cAAA;EACA,mBAAA;A/F81hBJ;;A+F51hBA;EACI,eAAA;EACA,mBAAA;A/F+1hBJ;;A+F71hBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A/Fg2hBJ;;A+F91hBA;;EAEI,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;A/Fi2hBJ;;A+F71hBI;;;;;EAKI,c3F5GqB;AJ48hB7B;;A+F31hBA;;EAEI,cAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A/F81hBJ;;A+F11hBA;;EAEI,gBAAA;EACA,cAAA;EACA,mBAAA;A/F61hBJ;;A+F31hBA;EACI,eAAA;A/F81hBJ;;A+F51hBA;EACI,mBAAA;A/F+1hBJ;;A+F31hBA;EACI,YAAA;EACA,gBAAA;EACA,eAAA;A/F81hBJ;;A+F51hBA;EACI,sBAAA;A/F+1hBJ;;A+F51hBA;EACI,WAAA;EACA,YAAA;A/F+1hBJ;;A+F51hBA;;EAEI,YAAA;EACA,UAAA;EACA,eAAA;A/F+1hBJ;;A+F71hBA;;EAEI,gBAAA;A/Fg2hBJ;;A+F71hBA;EACI,qBAAA;A/Fg2hBJ;;A+F51hBI;EACI,WAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;A/F+1hBR;A+F71hBI;EACI,QAAA;EACA,6BAAA;A/F+1hBR;;A+F31hBA;EACI,aAAA;A/F81hBJ;;A+F31hBA;EACI,WAAA;A/F81hBJ;A+F71hBI;EACI,YAAA;EACA,YAAA;EACA,6BAAA;A/F+1hBR;;A+F11hBQ;EACI,c3FrMiB;E2FsMjB,kBAAA;EACA,yBAAA;A/F61hBZ;;A+Fx1hBA;EACI,YAAA;EACA,kBAAA;A/F21hBJ;;A+Fz1hBA;EACI,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,c3F9PyB;E2FmQzB,4BAAA;EAGA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A/F01hBJ;;A+Fx1hBA;EACI,gBAAA;EACA,cAAA;A/F21hBJ;;A+Fz1hBA;EACI,kBAAA;EACA,iBAAA;A/F41hBJ;;A+Fz1hBA;EACI,sBAAA;EACA,iBAAA;EACA,WAAA;A/F41hBJ;;A+Fz1hBA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;A/F41hBJ;;A+F11hBA;;EAEI,oBAAA;A/F61hBJ;A+F51hBI;;;;EAEI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;A/Fg2hBR;A+F91hBQ;;;;EACI,oCAAA;EACA,c3FhUiB;AJmqiB7B;;AgGjriBA;EACI,kBAAA;AhGoriBJ;;AgGjriBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AhGoriBJ;;AgGjriBA;EACI,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AhGoriBJ;;AgGjriBA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AhGoriBJ;;AgGjriBA;EACI,WAAA;EACA,YAAA;AhGoriBJ;;AgGjriBA;EACI,SAAA;AhGoriBJ;;AgGjriBA;EACI,SAAA;AhGoriBJ;;AgGjriBA;EACI,YAAA;EACA,aAAA;EACA,YAAA;AhGoriBJ;;AgGjriBA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oEAAA;AhGoriBJ;;AgGjriBA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;AhGoriBJ;;AgGjriBA;EACI,kBAAA;AhGoriBJ;;AgGjriBA;EACI,SAAA;EACA,QAAA;AhGoriBJ;;AgGjriBA;EACI,MAAA;EACA,QAAA;AhGoriBJ;;AgGjriBA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;AhGoriBJ;;AgGjriBA;EACI,WAAA;EACA,qBAAA;EACA,wBAAA;AhGoriBJ;;AgGjriBA;EACI,WAAA;AhGoriBJ;;AgGjriBA;EACI,qBAAA;EACA,YAAA;AhGoriBJ;;AgGjriBA;EACI,WAAA;AhGoriBJ;;AgGjriBA;EACI,YAAA;AhGoriBJ;;AgGjriBA;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;AhGoriBJ;;AgGjriBA;EACI,eAAA;AhGoriBJ;;AgGjriBA;EACI,kBAAA;AhGoriBJ;;AgGjriBA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AhGoriBJ;;AiGzziBA;;;;;;CAAA;AASA;;CAAA;AAKE;EACE,SAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,gDAAA;EACA,yGAAA;EACA,yB7FRyB;E6FSzB,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,iCAAA;EACA,oBAAA;EACA,gBAAA;EAAA,sBAAA;EACA,aAAA;EAAA,mBAAA;AjGwziBJ;AiGvziBI;EACE,iCAAA;EACA,UAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AjGyziBN;AiGtziBI;EACE,UAAA;EACA,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AjGwziBN;AiGnziBE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EAAA,uBAAA;EACA,cAAA;EAAA,oBAAA;EACA,kBAAA;AjGqziBJ;AiGnziBE;EACE,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EAKA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;AjGqziBJ;AiGjziBM;EACE,6BAAA;AjGmziBR;AiG/yiBU;EACE,yB7F1DiB;AJ22iB7B;AiG5yiBQ;EACE,yB7F3EmB;AJy3iB7B;AiG1yiBQ;EACE,cAAA;EACA,eAAA;AjG4yiBV;AiGvyiBE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;AjGyyiBJ;AiGxyiBI;EACE,yBAAA;EACA,gBAAA;EACA,6BAAA;AjG0yiBN;AiGtyiBQ;EACE,yBAAA;EACA,SAAA;AjGwyiBV;AiGryiBM;EACE,yBAAA;EACA,gBAAA;AjGuyiBR;AiGnyiBM;EACE,oBAAA;EACA,kBAAA;EACA,6BAAA;AjGqyiBR;AiGpyiBQ;EACE,oBAAA;AjGsyiBV;AiGpyiBQ;EACE,gBAAA;AjGsyiBV;AiGnyiBM;EACE,QAAA;EACA,c7FxHqB;AJ65iB7B;AiGlyiBI;EACE,c7FrHuB;E6FsHvB,mBAAA;EACA,mBAAA;EACA,QAAA;AjGoyiBN;AiGlyiBI;;EAEE,mBAAA;AjGoyiBN;AiGlyiBI;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;AjGoyiBN;AiGnyiBM;EACE,aAAA;AjGqyiBR;AiGnyiBM;EACE,UAAA;EACA,qBAAA;AjGqyiBR;AiGlyiBQ;EACE,6BAAA;EACA,0CAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;AjGoyiBV;AiGlyiBQ;EACE,yB7FjGmB;AJq4iB7B;AiGlyiBQ;EACE,aAAA;AjGoyiBV;AiGhyiBQ;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;AjGkyiBV;AiGhyiBQ;EACE,aAAA;AjGkyiBV;AiG1xiBQ;EACE,qB7F1ImB;AJs6iB7B;AiGxxiBQ;;EAEE,c7FhJmB;AJ06iB7B;AiGtxiBI;EACE,yBAAA;AjGwxiBN;AiGvxiBM;EACE,6B7F/HqB;E6FgIrB,6CAAA;AjGyxiBR;AiGxxiBQ;EACE,c7F1JmB;E6F2JnB,6BAAA;AjG0xiBV;AiGlxiBQ;EACE,qB7FjKmB;AJq7iB7B;AiGhxiBQ;;EAEE,c7FvKmB;AJy7iB7B;AiG9wiBI;EACE,yBAAA;AjGgxiBN;AiG/wiBM;EACE,6B7FxJqB;E6FyJrB,6CAAA;AjGixiBR;AiGhxiBQ;EACE,c7FjLmB;E6FkLnB,6BAAA;AjGkxiBV;AiG1wiBQ;EACE,qB7FxLmB;AJo8iB7B;AiGxwiBQ;;EAEE,c7F9LmB;AJw8iB7B;AiGtwiBI;EACE,yBAAA;AjGwwiBN;AiGvwiBM;EACE,8B7FjLqB;E6FkLrB,8CAAA;AjGywiBR;AiGxwiBQ;EACE,c7FxMmB;E6FyMnB,6BAAA;AjG0wiBV;AiGlwiBQ;EACE,qB7F/MmB;AJm9iB7B;AiGhwiBQ;;EAEE,c7FrNmB;AJu9iB7B;AiG9viBI;EACE,yBAAA;AjGgwiBN;AiG/viBM;EACE,8B7F1MqB;E6F2MrB,8CAAA;AjGiwiBR;AiGhwiBQ;EACE,c7F/NmB;E6FgOnB,6BAAA;AjGkwiBV;AiG1viBQ;EACE,qB7FtOmB;AJk+iB7B;AiGxviBQ;;EAEE,c7F5OmB;AJs+iB7B;AiGtviBI;EACE,yBAAA;AjGwviBN;AiGvviBM;EACE,6B7FnOqB;E6FoOrB,6CAAA;AjGyviBR;AiGxviBQ;EACE,c7FtPmB;E6FuPnB,6BAAA;AjG0viBV;AiGrviBE;EACE,yBAAA;AjGuviBJ;AiGtviBI;EACE,kBAAA;EACA,+B7F7SuB;E6F8SvB,+CAAA;AjGwviBN;AiGvviBM;EACE,c7FvTqB;E6FwTrB,6BAAA;AjGyviBR;AiGnviBM;EACE,aAAA;AjGqviBR;AiGnviBM;EACE,yBAAA;EACA,yBAAA;AjGqviBR;AiGlviBI;EACE,yBAAA;AjGoviBN;;AkGzljBA;EACE,kBAAA;EAGA,aAAA;EAIA,sBAAA;EACA,6BAAA;AlG4ljBF;AkGzljBI;E/EVA,yBfoEyB;EeqDrB,cf7GqB;AJ2ljB7B;AmBrmjBI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnB6ljBR;AmB1ljBI;EACI,gBAAA;AnB4ljBR;AmBrljBQ;EAMI,yBfoCiB;EenCjB,qBfmCiB;AJ+ijB7B;AmBv/iBI;EACI,cfzDqB;Ee0DrB,qBf1DqB;AJmjjB7B;AmBv/iBQ;EAGI,6BfnFiB;EeoFjB,cf/DiB;EegEjB,qBfhEiB;EeiEjB,gBAAA;AnBu/iBZ;AmBn/iBI;EACI,cfvEqB;AJ4jjB7B;AmBn/iBQ;EAII,6BfjGiB;EekGjB,cf7EiB;Ee8EjB,qBAAA;EACA,gBAAA;AnBk/iBZ;AkG1njBM;E9EXJ,Y8EYuB;E9ETvB,yBAAA;E8EUM,oBAAA;EACA,mBAAA;AlG6njBR;AkGxnjBI;E/EpBA,yBf0EyB;Ee+CrB,cf7GqB;AJoojB7B;AmB9ojBI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBsojBR;AmBnojBI;EACI,gBAAA;AnBqojBR;AmB9njBQ;EAMI,yBf0CiB;EezCjB,qBfyCiB;AJkljB7B;AmBhijBI;EACI,cfnDqB;EeoDrB,qBfpDqB;AJsljB7B;AmBhijBQ;EAGI,6BfnFiB;EeoFjB,cfzDiB;Ee0DjB,qBf1DiB;Ee2DjB,gBAAA;AnBgijBZ;AmB5hjBI;EACI,cfjEqB;AJ+ljB7B;AmB5hjBQ;EAII,6BfjGiB;EekGjB,cfvEiB;EewEjB,qBAAA;EACA,gBAAA;AnB2hjBZ;AkGzpjBM;E9ErBJ,Y8EsBuB;E9EnBvB,yBAAA;E8EoBM,oBAAA;EACA,mBAAA;AlG4pjBR;AkGvpjBI;E/E9BA,yBfuEyB;EekDrB,cf7GqB;AJ6qjB7B;AmBvrjBI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnB+qjBR;AmB5qjBI;EACI,gBAAA;AnB8qjBR;AmBvqjBQ;EAMI,yBfuCiB;EetCjB,qBfsCiB;AJ8njB7B;AmBzkjBI;EACI,cftDqB;EeuDrB,qBfvDqB;AJkojB7B;AmBzkjBQ;EAGI,6BfnFiB;EeoFjB,cf5DiB;Ee6DjB,qBf7DiB;Ee8DjB,gBAAA;AnBykjBZ;AmBrkjBI;EACI,cfpEqB;AJ2ojB7B;AmBrkjBQ;EAII,6BfjGiB;EekGjB,cf1EiB;Ee2EjB,qBAAA;EACA,gBAAA;AnBokjBZ;AkGxrjBM;E9E/BJ,Y8EgCuB;E9E7BvB,yBAAA;E8E8BM,oBAAA;EACA,mBAAA;AlG2rjBR;AkGtrjBI;E/ExCA,yBf6EyB;Ee4CrB,cf7GqB;AJstjB7B;AmBhujBI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBwtjBR;AmBrtjBI;EACI,gBAAA;AnButjBR;AmBhtjBQ;EAMI,yBf6CiB;Ee5CjB,qBf4CiB;AJiqjB7B;AmBlnjBI;EACI,cfhDqB;EeiDrB,qBfjDqB;AJqqjB7B;AmBlnjBQ;EAGI,6BfnFiB;EeoFjB,cftDiB;EeuDjB,qBfvDiB;EewDjB,gBAAA;AnBknjBZ;AmB9mjBI;EACI,cf9DqB;AJ8qjB7B;AmB9mjBQ;EAII,6BfjGiB;EekGjB,cfpEiB;EeqEjB,qBAAA;EACA,gBAAA;AnB6mjBZ;AkGvtjBM;E9EzCJ,Y8E0CuB;E9EvCvB,yBAAA;E8EwCM,oBAAA;EACA,mBAAA;AlG0tjBR;AkGrtjBI;E/ElDA,yBfgFyB;EeyCrB,cf7GqB;AJ+vjB7B;AmBzwjBI;EAWI,oCAAA;EACA,yBAAA;EACA,2BAAA;AnBiwjBR;AmB9vjBI;EACI,gBAAA;AnBgwjBR;AmBzvjBQ;EAMI,yBfgDiB;Ee/CjB,qBf+CiB;AJusjB7B;AmB3pjBI;EACI,cf7CqB;Ee8CrB,qBf9CqB;AJ2sjB7B;AmB3pjBQ;EAGI,6BfnFiB;EeoFjB,cfnDiB;EeoDjB,qBfpDiB;EeqDjB,gBAAA;AnB2pjBZ;AmBvpjBI;EACI,cf3DqB;AJotjB7B;AmBvpjBQ;EAII,6BfjGiB;EekGjB,cfjEiB;EekEjB,qBAAA;EACA,gBAAA;AnBspjBZ;AkGtvjBM;E9EnDJ,Y8EoDuB;E9EjDvB,yBAAA;E8EkDM,oBAAA;EACA,mBAAA;AlGyvjBR;;AkGnvjBE;EACE,iBAAA;AlGsvjBJ;AkGpvjBE;EACE,gBAAA;AlGsvjBJ;AkGpvjBE;EACE,kBAAA;AlGsvjBJ;;AkGnvjBA;EACE,sBAAA;AlGsvjBF;;AkGpvjBA;EAGE,YAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,oBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AlGuvjBF;;AkGrvjBA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EACA,yBAAA;EAGA,iBAAA;AlGwvjBF;;AkGtvjBA;EACE,+BAAA;EACA,4CAAA;AlGyvjBF;;AkGvvjBA;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AlG0vjBF;AkGzvjBE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AlG2vjBJ;;AkGxvjBA;EACE,kBAAA;AlG2vjBF;;AkGzvjBA;EACE,iBAAA;AlG4vjBF;;AkGzvjBE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;AlG4vjBJ;;AkGxvjBE;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,UAAA;AlG2vjBJ;;AkGvvjBE;EACE,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,UAAA;AlG0vjBJ;;AkGvvjBA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mEAAA;EACA,qCAAA;AlG0vjBF;;AkGxvjBA;EACE,eAAA;AlG2vjBF;;AkGzvjBA;EACE,eAAA;AlG4vjBF;;AkG1vjBA;EACE,iBAAA;AlG6vjBF;;AkG3vjBA;EACE,gBAAA;AlG8vjBF;;AkG5vjBA;EACE,gBAAA;EACA,uBAAA;AlG+vjBF;AkG9vjBE;EACE,aAAA;AlGgwjBJ;;AkG7vjBA;EACE,2BAAA;AlGgwjBF;;AkG9vjBA;EACE,UAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;AlGiwjBF;;AkG/vjBA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AlGkwjBF;;AkGhwjBA;EACE,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;AlGmwjBF;;AkGjwjBA;EAGE,kBAAA;EAGA,aAAA;EAIA,sBAAA;EACA,cAAA;AlGowjBF;;AkGlwjBA;EACE,gBAAA;AlGqwjBF;;AkGnwjBA;EACE,eAAA;AlGswjBF;;AkGpwjBA;EACE,eAAA;AlGuwjBF;;AkGrwjBA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,oBAAA;AlGwwjBF;;AkGtwjBA;EAGE,cAAA;EAGA,oBAAA;AlGywjBF;;AkGvwjBA;EAGE,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uDAAA;EACA,cAAA;AlG0wjBF;;AkGxwjBA;EACE,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;AlG2wjBF;;AkGzwjBA;EACE,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AlG4wjBF;;AkG1wjBA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EAEA,+CAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EACA,eAAA;AlG6wjBF;;AkG3wjBA;EAEE,0CAAA;AlG8wjBF;;AkG5wjBA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AlG+wjBF;;AkG7wjBA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EACA,0CAAA;AlGgxjBF;;AkG9wjBA;EACE,2CAAA;AlGixjBF;;AkG/wjBA;EACE,eAAA;AlGkxjBF;;AkGhxjBA;EACE,+BAAA;AlGmxjBF;;AkGjxjBA;EACE,+BAAA;AlGoxjBF;;AkGlxjBA;EACE,UAAA;EAGA,aAAA;EAGA,8BAAA;EAGA,oBAAA;EAEA,eAAA;EACA,YAAA;AlGqxjBF;;AkGnxjBA;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AlGsxjBF;AkGrxjBE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AlGuxjBJ;;AkGpxjBA;EACE,wBAAA;EAEA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;AlGuxjBF;;AkGrxjBA;EACE,YAAA;EACA,mBAAA;AlGwxjBF;;AkGtxjBA;EACE,8BAAA;EACA,WAAA;AlGyxjBF;;AkGvxjBA;EAGE,SAAA;EACA,kBAAA;AlG0xjBF;;AkGxxjBA;EAGE,WAAA;EACA,kBAAA;EACA,gBAAA;EAGA,aAAA;EAIA,mBAAA;EAEA,eAAA;EAGA,mBAAA;EAEA,6BAAA;AlG2xjBF;;AkGzxjBA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;AlG4xjBF;;AkG1xjBA;EACE,qBAAA;AlG6xjBF;;AkG3xjBA;EACE,gBAAA;AlG8xjBF;;AkG5xjBA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EAEA,gCAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;AlG+xjBF;;AkG7xjBA;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;AlGgyjBF;;AkG9xjBA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,yBAAA;EAEA,2BAAA;EACA,yDAAA;AlGiyjBF;;AkG/xjBA;EACE,UAAA;EACA,UAAA;EACA,mBAAA;AlGkyjBF;;AkGhyjBA;EAEE,0BAAA;AlGmyjBF;;AkGjyjBA;EACE,2BAAA;EACA,kBAAA;EACA,yBAAA;EAGA,iBAAA;AlGoyjBF;;AkGjyjBA;EACE,aAAA;AlGoyjBF;;AkGlyjBA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;AlGqyjBF;;AkGlyjBA;EACE,yBAAA;AlGqyjBF;;AkGlyjBA;EACE,6BAAA;EACA,+BAAA;AlGqyjBF;;AkGlyjBA;EACE,aAAA;EACA,gBAAA;AlGqyjBF;;AmG3ykBA;EACI,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AnG8ykBJ;;AmG3ykBA;EACE,4BAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AnG8ykBF;;AmG3ykBA;EACI,eAAA;EACA,iBAAA;AnG8ykBJ;;AmG3ykBA;EACI,2BAAA;EACA,gBAAA;EACA,gBAAA;AnG8ykBJ;;AmG5ykBA;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;AnG+ykBJ;;AmG1ykBA;EACI,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AnG6ykBJ;;AmGzykBI;EAKI,6BAAA;ErEjEJ,qB1B4DyB;E0B3DzB,yB1B2DyB;AJmzkB7B;AmG5ykBQ;EACI,mBAAA;AnG8ykBZ;AmG5ykBY;EACI,UAAA;EACA,kBAAA;AnG8ykBhB;AmGzykBQ;ErE7EJ,qB1BqEyB;E0BpEzB,yB1BoEyB;AJqzkB7B;AmG1ykBQ;ErEhFJ,qB1B2EyB;E0B1EzB,yB1B0EyB;AJmzkB7B;AmG3ykBQ;ErEnFJ,qB1BwEyB;E0BvEzB,yB1BuEyB;AJ0zkB7B;AmG5ykBQ;ErEtFJ,qB1B8EyB;E0B7EzB,yB1B6EyB;AJwzkB7B;AmG7ykBQ;ErEzFJ,qB1BiFyB;E0BhFzB,yB1BgFyB;AJyzkB7B;AmG9ykBQ;ErE5FJ,qB1BayB;E0BZzB,yB1BYyB;E+FiFjB,cAAA;AnGizkBZ","sourcesContent":["/*!\n\n =========================================================\n * Paper Dashboard PRO React - v1.3.0 based on Paper Dashboard 2 Pro - v2.0.1\n =========================================================\n\n * Product Page: https://dashboard.dcmarketing.ca/product/paper-dashboard-pro-react\n * Copyright 2021 Creative Tim (http://www.creative-tim.com)\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */\n\n@import 'paper-dashboard/variables';\n@import 'paper-dashboard/mixins';\n\n// Plugins CSS\n@import 'paper-dashboard/plugins/plugin-bootstrap-switch';\n@import 'paper-dashboard/plugins/plugin-bootstrap-table';\n@import 'paper-dashboard/plugins/plugin-nouislider';\n@import 'paper-dashboard/plugins/plugin-animate-bootstrap-notify';\n@import 'paper-dashboard/plugins/plugin-perfect-scrollbar';\n@import 'paper-dashboard/plugins/plugin-sweetalert2';\n@import 'paper-dashboard/plugins/plugin-card-wizard';\n@import 'paper-dashboard/plugins/plugin-datetimepicker';\n@import 'paper-dashboard/plugins/plugin-bootstrap-select';\n@import 'paper-dashboard/plugins/plugin-jasny-fileupload';\n@import 'paper-dashboard/plugins/plugin-tagsinput';\n@import 'paper-dashboard/plugins/plugin-datatables.net';\n@import 'paper-dashboard/plugins/plugin-jquery.jvectormap';\n@import 'paper-dashboard/plugins/plugin-fullcalendar';\n\n// Core CSS\n@import 'paper-dashboard/nucleo-outline';\n@import 'paper-dashboard/buttons';\n@import 'paper-dashboard/social-buttons';\n@import 'paper-dashboard/animated-buttons';\n@import 'paper-dashboard/inputs';\n@import 'paper-dashboard/typography';\n@import 'paper-dashboard/misc';\n@import 'paper-dashboard/misc-extend';\n@import 'paper-dashboard/navbar';\n@import 'paper-dashboard/dropdown';\n@import 'paper-dashboard/alerts';\n@import 'paper-dashboard/images';\n@import 'paper-dashboard/tables';\n@import 'paper-dashboard/footers';\n@import 'paper-dashboard/fixed-plugin';\n\n// components\n@import 'paper-dashboard/checkboxes-radio';\n@import 'paper-dashboard/progress';\n@import 'paper-dashboard/badges';\n@import 'paper-dashboard/pagination';\n@import 'paper-dashboard/info-areas';\n@import 'paper-dashboard/pills';\n@import 'paper-dashboard/tabs';\n@import 'paper-dashboard/popups';\n@import 'paper-dashboard/modals';\n@import 'paper-dashboard/carousel';\n@import 'paper-dashboard/sidebar-and-main-panel';\n@import 'paper-dashboard/timeline';\n\n\n\n// cards\n@import 'paper-dashboard/cards';\n@import \"paper-dashboard/cards/card-chart\";\n@import \"paper-dashboard/cards/card-map\";\n@import \"paper-dashboard/cards/card-user\";\n\n@import \"paper-dashboard/cards/card-background\";\n@import \"paper-dashboard/cards/card-collapse\";\n@import \"paper-dashboard/cards/card-contributions\";\n@import \"paper-dashboard/cards/card-info-area\";\n@import \"paper-dashboard/cards/card-lock\";\n@import \"paper-dashboard/cards/card-pricing\";\n@import \"paper-dashboard/cards/card-profile\";\n@import \"paper-dashboard/cards/card-signup\";\n@import \"paper-dashboard/cards/card-stats-mini\";\n@import \"paper-dashboard/cards/card-stats\";\n@import \"paper-dashboard/cards/card-subcategories\";\n@import \"paper-dashboard/cards/card-testimonials\";\n@import \"paper-dashboard/cards/card-tasks\";\n\n\n\n// example pages and sections\n@import 'paper-dashboard/example-pages';\n@import 'paper-dashboard/sections';\n\n\n@import 'paper-dashboard/responsive';\n@import 'paper-dashboard/media-queries';\n\n// react differences\n@import \"paper-dashboard/react/react-differences\";\n","//  ========================================================================\n//  bootstrap-switch - v3.3.2\n//  http://www.bootstrap-switch.org\n// ========================================================================\n//  Copyright 2012-2013 Mattia Larentis\n// http://www.apache.org/licenses/LICENSE-2.0\n//\n\n\n // IMPORTANT! Creative Tim Notice: this file has major changes to fit the Now Ui Dashboard 's design. If you want to use the plugin as it was before our changes, please get the old files from http://www.bootstrap-switch.org\n\n\n .bootstrap-switch {\n   display: inline-block;\n   direction: ltr;\n   cursor: pointer;\n   border-radius: 30px;\n   border: 0;\n   position: relative;\n   text-align: left;\n   overflow: hidden;\n   margin-bottom: 5px;\n   line-height: 8px;\n   width: 61px !important;\n   height: 26px;\n   outline: none;\n   z-index: 0;\n   margin-right: 1px;\n   -webkit-user-select: none;\n   -moz-user-select: none;\n   -ms-user-select: none;\n   user-select: none;\n   vertical-align: middle;\n   -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n   transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n }\n\n .bootstrap-switch .bootstrap-switch-container {\n   display: inline-flex;\n   top: 0;\n   height: 26px;\n   border-radius: 4px;\n   -webkit-transform: translate3d(0, 0, 0);\n   transform: translate3d(0, 0, 0);\n   width: 100px !important;\n }\n\n .bootstrap-switch .bootstrap-switch-handle-on,\n .bootstrap-switch .bootstrap-switch-handle-off,\n .bootstrap-switch .bootstrap-switch-label {\n     -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n     box-sizing: border-box;\n     cursor: pointer;\n     display: inline-block !important;\n     height: 100%;\n     color: #fff;\n     padding: 6px 10px;\n     font-size: 11px;\n     text-indent: -5px;\n     line-height: 15px;\n     -webkit-transition: 0.25s ease-out;\n     transition: 0.25s ease-out;\n\n     i{\n         font-size: 12px;\n         line-height: 14px;\n   }\n }\n\n .bootstrap-switch .bootstrap-switch-handle-on,\n .bootstrap-switch .bootstrap-switch-handle-off {\n   text-align: center;\n   z-index: 1;\n   float: left;\n   width: 50% !important;\n   background-color: #66615B;\n }\n\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {\n   color: #fff;\n   background: #7A9E9F;\n }\n\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {\n   color: #fff;\n   background: #68B3C8;\n }\n\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {\n   color: #fff;\n   background: #7AC29A;\n }\n\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {\n   background: #F3BB45;\n   color: #fff;\n }\n\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {\n   color: #fff;\n   background: #EB5E28;\n }\n\n\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\n   color: #fff;\n   background: #cfcfca;\n }\n\n .bootstrap-switch .bootstrap-switch-label {\n   text-align: center;\n   z-index: 100;\n   color: #333333;\n   background: #ffffff;\n   width: 22px !important;\n   height: 22px;\n   margin: 2px -11px;\n   border-radius: 12px;\n   position: relative;\n   float: left;\n   padding: 0;\n   background-color: #FFFFFF;\n   box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n }\n\n .bootstrap-switch .bootstrap-switch-handle-on {\n   border-bottom-left-radius: 3px;\n   border-top-left-radius: 3px;\n }\n\n .bootstrap-switch .bootstrap-switch-handle-off {\n   text-indent: 6px;\n }\n\n .bootstrap-switch input[type='radio'],\n .bootstrap-switch input[type='checkbox'] {\n   position: absolute !important;\n   top: 0;\n   left: 0;\n   opacity: 0;\n   filter: alpha(opacity=0);\n   z-index: -1;\n }\n\n .bootstrap-switch input[type='radio'].form-control,\n .bootstrap-switch input[type='checkbox'].form-control {\n   height: auto;\n }\n\n .bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\n   padding: 1px 5px;\n   font-size: 12px;\n   line-height: 1.5;\n }\n\n .bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\n   padding: 5px 10px;\n   font-size: 12px;\n   line-height: 1.5;\n }\n\n .bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\n   padding: 6px 16px;\n   font-size: 18px;\n   line-height: 1.33;\n }\n\n .bootstrap-switch.bootstrap-switch-disabled,\n .bootstrap-switch.bootstrap-switch-readonly,\n .bootstrap-switch.bootstrap-switch-indeterminate {\n   cursor: default !important;\n }\n\n .bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\n .bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\n .bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\n .bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\n .bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\n   opacity: 0.5;\n   filter: alpha(opacity=50);\n   cursor: default !important;\n }\n\n .bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n   -webkit-transition: margin-left 0.5s;\n   transition: margin-left 0.5s;\n }\n\n .bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\n   border-bottom-left-radius: 0;\n   border-top-left-radius: 0;\n   border-bottom-right-radius: 3px;\n   border-top-right-radius: 3px;\n }\n\n .bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\n   border-bottom-right-radius: 0;\n   border-top-right-radius: 0;\n   border-bottom-left-radius: 3px;\n   border-top-left-radius: 3px;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\n   margin-left: -2px !important;\n }\n\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\n   margin-left: -37px !important;\n }\n\n .bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\n   width: 26px !important;\n   margin: 2px -15px;\n }\n\n .bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\n   width: 26px !important;\n   margin: 2px -15px -13px -11px;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {\n   background-color: #66615B;\n }\n\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {\n   background-color: #cfcfca;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger  {\n   background-color: #EB5E28;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning  {\n   background-color: #F3BB45;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success  {\n   background-color: #7AC29A;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary  {\n   background-color: #7A9E9F;\n }\n\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info  {\n   background-color: #68B3C8;\n }\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default  {\n   background-color: #66615B;\n }\n\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {\n   background-color: #cfcfca;\n }\n","/**\n * @author zhixin wen <wenzhixin2010@gmail.com>\n * version: 1.12.1\n * https://github.com/wenzhixin/bootstrap-table/\n */\n\n.bootstrap-table .table {\n    margin-bottom: 0 !important;\n    border-bottom: 1px solid #dddddd;\n    border-collapse: collapse !important;\n    border-radius: 1px;\n}\n\n.bootstrap-table .table:not(.table-condensed),\n.bootstrap-table .table:not(.table-condensed) > tbody > tr > th,\n.bootstrap-table .table:not(.table-condensed) > tfoot > tr > th,\n.bootstrap-table .table:not(.table-condensed) > thead > tr > td,\n.bootstrap-table .table:not(.table-condensed) > tbody > tr > td,\n.bootstrap-table .table:not(.table-condensed) > tfoot > tr > td {\n    padding: 8px;\n}\n\n.bootstrap-table .table.table-no-bordered > thead > tr > th,\n.bootstrap-table .table.table-no-bordered > tbody > tr > td {\n    border-right: 2px solid transparent;\n}\n\n.bootstrap-table .table.table-no-bordered > tbody > tr > td:last-child {\n    border-right: none;\n}\n\n.fixed-table-container {\n    position: relative;\n    clear: both;\n    border: 1px solid #dddddd;\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n}\n\n.fixed-table-container.table-no-bordered {\n    border: 1px solid transparent;\n}\n\n.fixed-table-footer,\n.fixed-table-header {\n    overflow: hidden;\n}\n\n.fixed-table-footer {\n    border-top: 1px solid #dddddd;\n}\n\n.fixed-table-body {\n    overflow-x: auto;\n    overflow-y: auto;\n    height: 100%;\n}\n\n.fixed-table-container table {\n    width: 100%;\n}\n\n.fixed-table-container thead th {\n    height: 0;\n    padding: 0;\n    margin: 0;\n    border-left: 1px solid #dddddd;\n}\n\n.fixed-table-container thead th:focus {\n    outline: 0 solid transparent;\n}\n\n.fixed-table-container thead th:first-child:not([data-not-first-th]) {\n    border-left: none;\n    border-top-left-radius: 4px;\n    -webkit-border-top-left-radius: 4px;\n    -moz-border-radius-topleft: 4px;\n}\n\n.fixed-table-container thead th .th-inner,\n.fixed-table-container tbody td .th-inner {\n    padding: 8px;\n    line-height: 24px;\n    vertical-align: top;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.fixed-table-container thead th .sortable {\n    cursor: pointer;\n    background-position: right;\n    background-repeat: no-repeat;\n    padding-right: 30px;\n}\n\n.fixed-table-container thead th .both {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC');\n}\n\n.fixed-table-container thead th .asc {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZ0lEQVQ4y2NgGLKgquEuFxBPAGI2ahhWCsS/gDibUoO0gPgxEP8H4ttArEyuQYxAPBdqEAxPBImTY5gjEL9DM+wTENuQahAvEO9DMwiGdwAxOymGJQLxTyD+jgWDxCMZRsEoGAVoAADeemwtPcZI2wAAAABJRU5ErkJggg==');\n}\n\n.fixed-table-container thead th .desc {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZUlEQVQ4y2NgGAWjYBSggaqGu5FA/BOIv2PBIPFEUgxjB+IdQPwfC94HxLykus4GiD+hGfQOiB3J8SojEE9EM2wuSJzcsFMG4ttQgx4DsRalkZENxL+AuJQaMcsGxBOAmGvopk8AVz1sLZgg0bsAAAAASUVORK5CYII= ');\n}\n\n.fixed-table-container th.detail {\n    width: 30px;\n}\n\n.fixed-table-container tbody td {\n    border-left: 1px solid #dddddd;\n}\n\n.fixed-table-container tbody tr:first-child td {\n    border-top: none;\n}\n\n.fixed-table-container tbody td:first-child {\n    border-left: none;\n}\n\n/* the same color with .active */\n.fixed-table-container tbody .selected td {\n    background-color: #f5f5f5;\n}\n\n.fixed-table-container .bs-checkbox {\n    text-align: center;\n}\n\n.fixed-table-container input[type=\"radio\"],\n.fixed-table-container input[type=\"checkbox\"] {\n    margin: 0 auto !important;\n}\n\n.fixed-table-container .no-records-found {\n    text-align: center;\n}\n\n.fixed-table-pagination div.pagination,\n.fixed-table-pagination .pagination-detail {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.fixed-table-pagination div.pagination .pagination {\n    margin: 0;\n}\n\n.fixed-table-pagination .pagination a {\n    padding: 6px 12px;\n    line-height: 1.428571429;\n}\n\n.fixed-table-pagination .pagination-info {\n    line-height: 34px;\n    margin-right: 5px;\n}\n\n.fixed-table-pagination .btn-group {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.fixed-table-pagination .dropup .dropdown-menu {\n    margin-bottom: 0;\n}\n\n.fixed-table-pagination .page-list {\n    display: inline-block;\n}\n\n.fixed-table-toolbar .columns-left {\n    margin-right: 5px;\n}\n\n.fixed-table-toolbar .columns-right {\n    margin-left: 5px;\n}\n\n.fixed-table-toolbar .columns label {\n    display: block;\n    padding: 3px 20px;\n    clear: both;\n    font-weight: normal;\n    line-height: 1.428571429;\n}\n\n.fixed-table-toolbar .bs-bars,\n.fixed-table-toolbar .search,\n.fixed-table-toolbar .columns {\n    position: relative;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    line-height: 34px;\n}\n\n.fixed-table-pagination li.disabled a {\n    pointer-events: none;\n    cursor: default;\n}\n\n.fixed-table-loading {\n    display: none;\n    position: absolute;\n    top: 42px;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 99;\n    background-color: #fff;\n    text-align: center;\n}\n\n.fixed-table-body .card-view .title {\n    font-weight: bold;\n    display: inline-block;\n    min-width: 30%;\n    text-align: left !important;\n}\n\n/* support bootstrap 2 */\n.fixed-table-body thead th .th-inner {\n    box-sizing: border-box;\n}\n\n.table th, .table td {\n    vertical-align: middle;\n    box-sizing: border-box;\n}\n\n.fixed-table-toolbar .dropdown-menu {\n    text-align: left;\n    max-height: 300px;\n    overflow: auto;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group {\n    display: inline-block;\n    margin-left: -1px !important;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group > .btn {\n    border-radius: 0;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group:first-child > .btn {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group:last-child > .btn {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n\n.bootstrap-table .table > thead > tr > th {\n    vertical-align: bottom;\n    border-bottom: 1px solid #ddd;\n}\n\n/* support bootstrap 3 */\n.bootstrap-table .table thead > tr > th {\n    padding: 0;\n    margin: 0;\n}\n\n.bootstrap-table .fixed-table-footer tbody > tr > td {\n    padding: 0 !important;\n}\n\n.bootstrap-table .fixed-table-footer .table {\n    border-bottom: none;\n    border-radius: 0;\n    padding: 0 !important;\n}\n\n.bootstrap-table .pull-right .dropdown-menu {\n    right: 0;\n    left: auto;\n}\n\n/* calculate scrollbar width */\np.fixed-table-scroll-inner {\n    width: 100%;\n    height: 200px;\n}\n\ndiv.fixed-table-scroll-outer {\n    top: 0;\n    left: 0;\n    visibility: hidden;\n    width: 200px;\n    height: 150px;\n    overflow: hidden;\n}\n\n/* for get correct heights  */\n.fixed-table-toolbar:after, .fixed-table-pagination:after {\n    content: \"\";\n    display: block;\n    clear: both;\n}\n\n.fullscreen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1050;\n    width: 100%!important;\n    background: #FFF;\n}\n\n// small edit\n\n.bootstrap-table {\n  .btn-group {\n    &:last-child .btn{\n      border-top-right-radius: 30px !important;\n      border-bottom-right-radius: 30px !important;\n      margin-left: -2px;\n    }\n  }\n}\n","/*! nouislider - 9.1.0 - 2016-12-10 16:00:32 */\n\n\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n-webkit-touch-callout: none;\n-webkit-tap-highlight-color: rgba(0,0,0,0);\n-webkit-user-select: none;\n-ms-touch-action: none;\n\ttouch-action: none;\n-ms-user-select: none;\n-moz-user-select: none;\n\tuser-select: none;\n-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.noUi-target {\n\tposition: relative;\n\tdirection: ltr;\n}\n.noUi-base {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\tz-index: 1; /* Fix 401 */\n}\n.noUi-connect {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n}\n.noUi-origin {\n\tposition: absolute;\n\theight: 0;\n\twidth: 0;\n}\n.noUi-handle {\n\tposition: relative;\n\tz-index: 1;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n-webkit-transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\n\ttransition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\n}\n.noUi-state-drag * {\n\tcursor: inherit !important;\n}\n\n/* Painting and performance;\n * Browsers can paint handles in their own layer.\n */\n.noUi-base,\n.noUi-handle {\n\t-webkit-transform: translate3d(0,0,0);\n\ttransform: translate3d(0,0,0);\n}\n\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n\theight: 8px;\n}\n.noUi-horizontal .noUi-handle {\n    background: rgb(255,255,255); /* Old browsers */\n    background: -moz-linear-gradient(top,  rgba(255,255,255,1) 0%, rgba(241,241,242,1) 100%); /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(255,255,255,1)), color-stop(100%,rgba(241,241,242,1))); /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* Opera 11.10+ */\n    background: -ms-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* IE10+ */\n    background: linear-gradient(to bottom,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='$white-color', endColorstr='#f1f1f2',GradientType=0 ); /* IE6-9 */\n\n    border-radius: 50%;\n    box-shadow: 0 1px 1px $white-color inset, 0 1px 2px rgba(0, 0, 0, 0.4);\n\theight:15px;\n\twidth:15px;\n\tcursor:pointer;\n    margin-left: -10px;\n    margin-top: -4px;\n}\n.noUi-vertical {\n\twidth: 18px;\n}\n.noUi-vertical .noUi-handle {\n\twidth: 28px;\n\theight: 34px;\n\tleft: -6px;\n\ttop: -17px;\n}\n\n/* Styling;\n */\n.noUi-target {\n\tbackground-color: #E5E5E5;\n\tborder-radius: 3px;\n\t// border: 1px solid #D3D3D3;\n\t// box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;\n}\n.noUi-connect {\n\tbackground: #3FB8AF;\n\t// box-shadow: inset 0 0 3px rgba(51,51,51,0.45);\n    border-radius: 3px;\n-webkit-transition: background 450ms;\n\ttransition: background 450ms;\n}\n\n/* Handles and cursors;\n */\n.noUi-draggable {\n\tcursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n\tcursor: ns-resize;\n}\n.noUi-handle {\n\t// border: 1px solid #D9D9D9;\n\tborder-radius: 3px;\n\tbackground: #FFF;\n\tcursor: default;\n\tbox-shadow: inset 0 0 1px #FFF,\n\t\t\t\tinset 0 1px 7px #EBEBEB,\n\t\t\t\t0 3px 6px -3px #BBB;\n}\n.noUi-active {\n\tbox-shadow: inset 0 0 1px #FFF,\n\t\t\t\tinset 0 1px 7px #DDD,\n\t\t\t\t0 3px 6px -3px #BBB;\n}\n\n/* Handle stripes;\n */\n// .noUi-handle:before,\n// .noUi-handle:after {\n// \tcontent: \"\";\n// \tdisplay: block;\n// \tposition: absolute;\n// \theight: 14px;\n// \twidth: 1px;\n// \tbackground: #E8E7E6;\n// \tleft: 14px;\n// \ttop: 6px;\n// }\n// .noUi-handle:after {\n// \tleft: 17px;\n// }\n// .noUi-vertical .noUi-handle:before,\n// .noUi-vertical .noUi-handle:after {\n// \twidth: 14px;\n// \theight: 1px;\n// \tleft: 6px;\n// \ttop: 14px;\n// }\n// .noUi-vertical .noUi-handle:after {\n// \ttop: 17px;\n// }\n\n/* Disabled state;\n */\n\n[disabled] .noUi-connect {\n\tbackground: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n\tcursor: not-allowed;\n}\n\n\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.noUi-pips {\n\tposition: absolute;\n\tcolor: #999;\n}\n\n/* Values;\n *\n */\n.noUi-value {\n\tposition: absolute;\n\ttext-align: center;\n}\n.noUi-value-sub {\n\tcolor: #ccc;\n\tfont-size: 10px;\n}\n\n/* Markings;\n *\n */\n.noUi-marker {\n\tposition: absolute;\n\tbackground: #CCC;\n}\n.noUi-marker-sub {\n\tbackground: #AAA;\n}\n.noUi-marker-large {\n\tbackground: #AAA;\n}\n\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n\tpadding: 10px 0;\n\theight: 80px;\n\ttop: 100%;\n\tleft: 0;\n\twidth: 100%;\n}\n.noUi-value-horizontal {\n\t-webkit-transform: translate3d(-50%,50%,0);\n\ttransform: translate3d(-50%,50%,0);\n}\n\n.noUi-marker-horizontal.noUi-marker {\n\tmargin-left: -1px;\n\twidth: 2px;\n\theight: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n\theight: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n\theight: 15px;\n}\n\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n\tpadding: 0 10px;\n\theight: 100%;\n\ttop: 0;\n\tleft: 100%;\n}\n.noUi-value-vertical {\n\t-webkit-transform: translate3d(0,50%,0);\n\ttransform: translate3d(0,50%,0);\n\tpadding-left: 25px;\n}\n\n.noUi-marker-vertical.noUi-marker {\n\twidth: 5px;\n\theight: 2px;\n\tmargin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n\twidth: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n\twidth: 15px;\n}\n\n.noUi-tooltip {\n\tdisplay: block;\n\tposition: absolute;\n\tborder: 1px solid #D9D9D9;\n\tborder-radius: 3px;\n\tbackground: #fff;\n\tcolor: #000;\n\tpadding: 5px;\n\ttext-align: center;\n}\n.noUi-horizontal .noUi-tooltip {\n-webkit-transform: translate(-50%, 0);\n    transform: translate(-50%, 0);\n    left: 50%;\n    bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n-webkit-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    top: 50%;\n    right: 120%;\n}\n\n\n.slider {\n\n    &.slider-info{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $info-color;\n        }\n\n        .noUi-handle{\n            border-color: $info-color;\n        }\n    }\n    &.slider-success{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $success-color;\n        }\n\n        .noUi-handle{\n            border-color: $success-color;\n        }\n    }\n    &.slider-warning{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $warning-color;\n        }\n\n        .noUi-handle{\n            border-color: $warning-color;\n        }\n    }\n    &.slider-danger{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $danger-color;\n        }\n\n        .noUi-handle{\n            border-color: $danger-color;\n        }\n    }\n\n}\n","//== Buttons\n//\n//## For each of Bootstrap's buttons, define text, background and border color.\n\n$font-color:                 #66615b !default;\n$fill-font-color:            rgba(255, 255, 255, 0.8);\n$font-family-sans-serif:     'Montserrat', \"Helvetica\", Arial, sans-serif;\n$sans-serif-family:          'Montserrat', 'Helvetica Neue',  Arial, sans-serif;\n\n\n$none:                       0   !default;\n$border-thin:                1px !default;\n$border-thick:               2px !default;\n\n$white-color:                #FFFFFF !default;\n$white-bg:                   #FFFFFF !default;\n$orange-bg:                  #e95e38 !default;\n\n$smoke-bg:                   #F5F5F5 !default;\n$light-black:                #444    !default;\n\n$black-bg:                   rgba(30,30,30,.97) !default;\n\n$black-color:                #2c2c2c !default;\n$black-hr:                   #444444 !default;\n\n$hr-line:                    rgba(0,0,0, .1) !default;\n\n$light-gray:                 #E3E3E3 !default;\n$medium-gray:                #DDDDDD !default;\n$dark-gray:                  #9A9A9A !default;\n\n$table-line-color:           #ccc !default;\n$muted-color:                #a49e93 !default;\n\n$opacity-gray-3:             rgba(222,222,222, .3) !default;\n$opacity-gray-5:             rgba(222,222,222, .5) !default;\n$opacity-gray-8:             rgba(222,222,222, .8) !default;\n\n\n$opacity-5:                  rgba(255,255,255, .5) !default;\n$opacity-8:                  rgba(255,255,255, .8) !default;\n\n$datepicker-color-days:             rgba(255,255,255, .8)  !default;\n$datepicker-color-old-new-days:     rgba(255,255,255, .4)  !default;\n\n\n$opacity-1:                  rgba(255,255,255, .1) !default;\n$opacity-2:                  rgba(255,255,255, .2) !default;\n\n$transparent-bg:             transparent !default;\n$dark-background:            #555555 !default;\n\n$gray-input-bg:              #fffcf5 !default;\n$danger-input-bg:            #FFC0A4 !default;\n$success-input-bg:           #ABF3CB !default;\n$other-medium-gray:          #A49E93 !default;\n$transparent-bg:             transparent !default;\n\n$placeholder-gray:           rgba(210, 210, 210, 1)  !default;\n\n$default-color:              #66615B !default;\n$default-bg:                 #66615B !default;\n$default-states-color:       #403D39 !default;\n\n$smoke-bg:                   #F5F5F5 !default;\n$pale-bg:                    #FFFCF5 !default;\n$medium-pale-bg:             #F1EAE0 !default;\n$default-body-bg:                 #f4f3ef !default;\n\n$primary-color:              #51cbce !default;\n$primary-states-color:       darken($primary-color, 10%) !default;\n\n$success-color:              #6bd098 !default;\n$success-states-color:       darken($success-color, 10%) !default;\n\n$info-color:                 #51bcda !default;\n$info-states-color:          darken($info-color, 10%) !default;\n\n$warning-color:              #fbc658 !default;\n$warning-states-color:       darken($warning-color, 10%) !default;\n\n$danger-color:               #ef8157 !default;\n$danger-states-color:        darken($danger-color, 8%) !default;\n\n$link-disabled-color:        #666666 !default;\n\n$purple-color:               #c178c1 !default;\n$purple-states-color:        darken($purple-color, 8%) !default;\n\n$medium-pale-bg:             #F1EAE0 !default;\n\n$brown-color:                #dcb285 !default;\n$default-color-opacity:      rgba(182, 182, 182, .6) !default;\n$primary-color-opacity:      rgba(249, 99, 50, .3) !default;\n$success-color-opacity:      rgba(24, 206, 15, .3) !default;\n$info-color-opacity:         rgba(44, 168, 255, .3) !default;\n$warning-color-opacity:      rgba(255, 178, 54, .3) !default;\n$danger-color-opacity:       rgba(255, 54, 54, .3) !default;\n\n$new-blue:            #1DC7EA;\n$new-purple:          #9368E9;\n$new-red:             #FB404B;\n$new-green:           #87CB16;\n$new-orange:          #FFA534;\n$new-dark-blue:       #1F77D0;\n$new-black:           #5e5e5e;\n\n$orange-color:               #f96332 !default;\n$color-red-error: rgb(185, 74, 72) !default;\n$color-grey-arrow: rgba(204, 204, 204, 0.2) !default;\n\n$bg-nude:               #FFFCF5 !default;\n$bg-primary:            lighten($primary-color, 7%) !default;\n$bg-info:               lighten($info-color, 7%) !default;\n$bg-success:            lighten($success-color, 7%) !default;\n$bg-warning:            lighten($warning-color, 7%) !default;\n$bg-danger:             lighten($danger-color, 7%) !default;\n$bg-brown:              lighten($brown-color, 7%) !default;\n$bg-purple:             lighten($purple-color, 7%) !default;\n\n//     brand Colors\n$brand-primary:              $primary-color !default;\n$brand-info:                 $info-color !default;\n$brand-success:              $success-color !default;\n$brand-warning:              $warning-color !default;\n$brand-danger:               $danger-color !default;\n$brand-inverse:              $black-color !default;\n\n$link-disabled-color:        #666666 !default;\n$dark-color:                 #212120 !default;\n//     light colors\n$light-blue:                 rgba($primary-color, .2);\n$light-azure:                rgba($info-color, .2);\n$light-green:                rgba($success-color, .2);\n$light-orange:               rgba($warning-color, .2);\n$light-red:                  rgba($danger-color, .2);\n\n// padding for links inside dropdown menu\n$padding-dropdown-vertical:     10px !default;\n$padding-dropdown-horizontal:   15px !default;\n\n$margin-large-vertical:        30px !default;\n$margin-base-vertical:         15px !default;\n\n// border radius for buttons\n$border-radius-none:             0px !default;\n$border-radius-btn-small:      26px !default;\n$border-radius-btn-base:       20px !default;\n$border-radius-btn-large:      50px !default;\n\n\n$margin-bottom:                0 0 10px 0 !default;\n$border-radius-small:           3px !default;\n$border-radius-base:            4px !default;\n$border-radius-large:           6px !default;\n$border-radius-x-large:         8px !default;\n$border-radius-extreme:         12px !default;\n\n//variables used in cards\n$card-black-color:          #252422 !default;\n$card-muted-color:          #ccc5b9 !default;\n\n$card-background-blue:      #b8d8d8 !default;\n$card-font-blue:            #506568 !default;\n$card-subtitle-blue:        #7a9e9f !default;\n\n$card-background-green:      #d5e5a3 !default;\n$card-font-green:            #60773d !default;\n$card-subtitle-green:        #92ac56 !default;\n\n$card-background-yellow:      #ffe28c !default;\n$card-font-yellow:            #b25825 !default;\n$card-subtitle-yellow:        #d88715 !default;\n\n$card-background-brown:      #d6c1ab !default;\n$card-font-brown:            #75442e !default;\n$card-subtitle-brown:        #a47e65 !default;\n\n$card-background-purple:      #baa9ba !default;\n$card-font-purple:            #3a283d !default;\n$card-subtitle-purple:        #5a283d !default;\n\n$card-background-orange:      #ff8f5e !default;\n$card-font-orange:            #772510 !default;\n$card-subtitle-orange:        #e95e37 !default;\n\n\n\n//== Components\n//\n\n$padding-input-vertical:        11px !default;\n$padding-input-horizontal:      11px !default;\n\n$padding-btn-vertical:         11px !default;\n$padding-btn-horizontal:       22px !default;\n\n$padding-base-vertical:        .5rem !default;\n$padding-base-horizontal:      .7rem !default;\n\n$padding-round-horizontal:     23px !default;\n\n$padding-simple-vertical:      10px !default;\n$padding-simple-horizontal:    17px !default;\n\n$padding-large-vertical:       15px !default;\n$padding-large-horizontal:     48px !default;\n\n$padding-small-vertical:        5px !default;\n$padding-small-horizontal:     15px !default;\n\n// $padding-xs-vertical:           1px !default;\n// $padding-xs-horizontal:         5px !default;\n\n$padding-label-vertical:        2px !default;\n$padding-label-horizontal:     12px !default;\n\n$margin-large-vertical:        30px !default;\n$margin-base-vertical:         15px !default;\n\n$margin-base-horizontal:       15px !default;\n\n$margin-bottom:                 10px        !default;\n$border:                        1px solid   !default;\n$border-radius-extra-small:     0.125rem    !default;\n$border-radius-small:           0.1875rem   !default;\n$border-radius-large:           0.25rem     !default;\n$border-radius-extreme:         0.875rem    !default;\n\n$border-radius-large-top:      $border-radius-large $border-radius-large 0 0 !default;\n$border-radius-large-bottom:   0 0 $border-radius-large $border-radius-large !default;\n\n$btn-round-radius:             30px         !default;\n\n$height-base:                  40px         !default;\n\n$btn-icon-size:                 3.5rem       !default;\n$btn-icon-size-regular:         2.375rem      !default;\n$btn-icon-font-size-regular:    0.9375rem     !default;\n$btn-icon-font-size-small:      0.6875rem      !default;\n$btn-icon-size-small:           1.875rem     !default;\n$btn-icon-font-size-lg:         1.325rem     !default;\n$btn-icon-size-lg:              3.6rem         !default;\n\n$font-size-h1:                 3.5em        !default; // ~ 49px\n$font-size-h2:                 2.5em        !default; // ~ 35px\n$font-size-h3:                 2em          !default; // ~ 28px\n$font-size-h4:                 1.714em      !default; // ~ 24px\n$font-size-h5:                 1.57em       !default; // ~ 22px\n$font-size-h6:                 1em          !default; // ~ 14px\n\n$font-paragraph:               1em          !default;\n$font-size-navbar:             1em          !default;\n$font-size-mini:               0.7142em     !default;\n$font-size-small:              0.8571em     !default;\n$font-size-base:               14px         !default;\n$font-size-large:              1rem         !default;\n$font-size-large-navbar:       20px         !default;\n$font-size-blockquote:         1.1em        !default; // ~ 15px\n$font-size-medium:             16px         !default;\n$font-size-xs:                 12px         !default;\n\n$font-weight-light:             300         !default;\n$font-weight-normal:            400         !default;\n$font-weight-semi:              600         !default;\n$font-weight-bold:              700         !default;\n\n$line-height-general:        1.5            !default;\n$line-height-nav-link:       1.625rem       !default;\n$btn-icon-line-height:       2.4em          !default;\n$line-height:                1.35em         !default;\n$line-height-lg:             54px           !default;\n\n\n$border-radius-top:        10px 10px 0 0     !default;\n$border-radius-bottom:     0 0 10px 10px     !default;\n\n$dropdown-shadow:          1px 2px 7px 1px rgba(0,0,0,.125);\n$box-shadow-raised:        0px 10px 25px 0px rgba(0, 0, 0, 0.3);\n$box-shadow:               0 2px 2px rgba(204, 197, 185, 0.5);\n$sidebar-box-shadow:       0px 2px 22px 0 rgba(0, 0, 0,.20), 0px 2px 30px 0 rgba(0, 0, 0,.35);\n\n$general-transition-time:  300ms             !default;\n\n$slow-transition-time:           370ms       !default;\n$dropdown-coordinates:      29px -50px       !default;\n\n$fast-transition-time:           150ms       !default;\n$select-coordinates:         50% -40px       !default;\n\n$transition-linear:         linear           !default;\n$transition-bezier:         cubic-bezier(0.34, 1.61, 0.7, 1) !default;\n$transition-ease:           ease 0s;\n\n\n//$navbar-padding-a:               9px 13px;\n$navbar-margin-a:                15px 0px;\n\n$padding-social-a:               10px 5px;\n\n$navbar-margin-a-btn:            15px 0px;\n$navbar-margin-a-btn-round:      16px 0px;\n\n$navbar-padding-a-icons:         6px 15px;\n$navbar-margin-a-icons:          6px  3px;\n\n$navbar-padding-base:            0.625rem;\n//$navbar-margin-brand:             5px  0px;\n\n$navbar-margin-brand-icons:      12px auto;\n$navbar-margin-btn:              15px  3px;\n\n$height-icon-sm:\t\t\t\t 32px;\n$width-icon-sm:\t\t\t\t\t 32px;\n$padding-icon-sm:\t\t\t     4px;\n$border-radius-icon-sm:\t\t\t 7px;\n\n$height-icon-message:\t\t\t 40px;\n$width-icon-message:\t\t\t 40px;\n\n$height-icon-message-sm: \t\t 20px;\n$width-icon-message-sm:\t\t\t 20px;\n\n$white-navbar:                  rgba(#FFFFFF, .96);\n$primary-navbar:                rgba(#34ACDC, .98);\n$info-navbar:                   rgba(#5BCAFF, .98);\n$success-navbar:                rgba(#4CD964, .98);\n$warning-navbar:                rgba(#FF9500, .98);\n$danger-navbar:                 rgba(#FF4C40, .98);\n\n$topbar-x:             topbar-x !default;\n$topbar-back:          topbar-back !default;\n$bottombar-x:          bottombar-x !default;\n$bottombar-back:       bottombar-back !default;\n\n//Nucleo Icons\n\n$nc-font-path:        '../fonts' !default;\n$nc-font-size-base:   14px !default;\n$nc-css-prefix:       nc !default;\n$nc-background-color:     #eee !default;\n$nc-li-width:         (30em / 14) !default;\n$nc-padding-width:    (1em/3) !default;\n\n// Social icons color\n$social-twitter:                   #55acee !default;\n$social-twitter-state-color:       darken(#55acee, 5%) !default;\n\n$social-facebook: \t\t\t       #3b5998 !default;\n$social-facebook-state-color:      darken(#3b5998, 5%) !default;\n\n$social-google: \t\t\t       #dd4b39 !default;\n$social-google-state-color:        darken(#dd4b39, 5%) !default;\n\n$social-linkedin: \t\t\t         #0077B5 !default;\n$social-linkedin-state-color:        darken(#0077B5, 5%) !default;\n\n// Sidebar variables\n$sidebar-width:              calc(100% - 260px) !default;\n$sidebar-mini-width:         calc(100% - 80px) !default;\n\n\n// Social icons color\n$social-twitter:                   #55acee !default;\n$social-twitter-state-color:       lighten(#55acee, 6%) !default;\n\n$social-facebook: \t\t\t       #3b5998 !default;\n$social-facebook-state-color:      lighten(#3b5998, 6%) !default;\n\n$social-google: \t\t\t       #dd4b39 !default;\n$social-google-state-color:        lighten(#dd4b39, 6%) !default;\n\n$social-linkedin: \t\t\t       #0077B5 !default;\n$social-linkedin-state-color:      lighten(#0077B5, 6%) !default;\n\n$social-pinterest: \t\t\t       #cc2127 !default;\n$social-pinterest-state-color:     lighten(#cc2127, 6%) !default;\n\n$social-dribbble: \t\t           #ea4c89 !default;\n$social-dribbble-state-color:      lighten(#ea4c89, 6%) !default;\n\n$social-github: \t\t      \t   #333333 !default;\n$social-github-state-color:        lighten(#333333, 6%) !default;\n\n$social-youtube: \t\t    \t   #e52d27 !default;\n$social-youtube-state-color:       lighten(#e52d27, 6%) !default;\n\n$social-instagram: \t\t           #125688 !default;\n$social-instagram-state-color:     lighten(#125688, 6%) !default;\n\n$social-reddit: \t\t  \t       #ff4500 !default;\n$social-reddit-state-color:        lighten(#ff4500, 6%) !default;\n\n$social-tumblr: \t\t\t       #35465c !default;\n$social-tumblr-state-color:        lighten(#35465c, 6%) !default;\n\n$social-behance: \t\t\t       #1769ff !default;\n$social-behance-state-color:       lighten(#1769ff, 6%) !default;\n\n// Placeholder text color\n$input-color-placeholder: #999 !default;\n\n$zindex-select-dropdown: 1060 !default; // must be higher than a modal background (1050)\n","\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n// This file was modified by Creative Tim to keep only the animation that we need for Bootstrap Notify\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@charset \"UTF-8\";\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2015 Daniel Eden\n*/\n\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.animated.infinite {\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n}\n\n.animated.hinge {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s;\n}\n\n.animated.bounceIn,\n.animated.bounceOut {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n.animated.flipOutX,\n.animated.flipOutY {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n@-webkit-keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n@keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake;\n}\n\n\n\n@-webkit-keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown;\n}\n\n@-webkit-keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n@keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp;\n}\n","/* perfect-scrollbar v0.6.13 */\n.ps-container {\n  -ms-touch-action: auto;\n  touch-action: auto;\n  overflow: hidden !important;\n  -ms-overflow-style: none; }\n  @supports (-ms-overflow-style: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  .ps-container.ps-active-x > .ps-scrollbar-x-rail,\n  .ps-container.ps-active-y > .ps-scrollbar-y-rail {\n    display: block;\n    background-color: transparent; }\n  .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n      background-color: #999;\n      height: 11px; }\n  .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n      background-color: #999;\n      width: 11px; }\n  .ps-container > .ps-scrollbar-x-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    bottom: 0px;\n    /* there must be 'bottom' for ps-scrollbar-x-rail */\n    height: 15px; }\n    .ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 6px;\n      -moz-border-radius: 6px;\n      border-radius: 6px;\n      -webkit-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, -webkit-border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, -webkit-border-radius .2s ease-in-out;\n      -o-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out;\n      -moz-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out, -moz-border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out, -webkit-border-radius .2s ease-in-out, -moz-border-radius .2s ease-in-out;\n      bottom: 2px;\n      /* there must be 'bottom' for ps-scrollbar-x */\n      height: 6px; }\n    .ps-container > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x, .ps-container > .ps-scrollbar-x-rail:active > .ps-scrollbar-x {\n      height: 11px; }\n  .ps-container > .ps-scrollbar-y-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    right: 0;\n    /* there must be 'right' for ps-scrollbar-y-rail */\n    width: 15px; }\n    .ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 6px;\n      -moz-border-radius: 6px;\n      border-radius: 6px;\n      -webkit-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, -webkit-border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, -webkit-border-radius .2s ease-in-out;\n      -o-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out;\n      -moz-transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out, -moz-border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out;\n      transition: background-color .2s linear, height .2s linear, width .2s ease-in-out, border-radius .2s ease-in-out, -webkit-border-radius .2s ease-in-out, -moz-border-radius .2s ease-in-out;\n      right: 2px;\n      /* there must be 'right' for ps-scrollbar-y */\n      width: 6px; }\n    .ps-container > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y, .ps-container > .ps-scrollbar-y-rail:active > .ps-scrollbar-y {\n      width: 11px; }\n  .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n      background-color: #999;\n      height: 11px; }\n  .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n      background-color: #999;\n      width: 11px; }\n  .ps-container:hover > .ps-scrollbar-x-rail,\n  .ps-container:hover > .ps-scrollbar-y-rail {\n    opacity: 0.6; }\n  .ps-container:hover > .ps-scrollbar-x-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {\n      background-color: #999; }\n  .ps-container:hover > .ps-scrollbar-y-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {\n      background-color: #999; }\n","body.swal2-shown {\n  overflow-y: hidden; }\n\nbody.swal2-iosfix {\n  position: fixed;\n  left: 0;\n  right: 0; }\n\n.swal2-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  padding: 10px;\n  background-color: transparent;\n  z-index: 1060; }\n  .swal2-container.swal2-fade {\n    -webkit-transition: background-color .1s;\n    transition: background-color .1s; }\n  .swal2-container.swal2-shown {\n    background-color: rgba(0, 0, 0, 0.4); }\n\n.swal2-modal {\n  background-color: #fff;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  border-radius: 5px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  text-align: center;\n  margin: auto;\n  box-shadow: $box-shadow;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: none;\n  position: relative;\n  max-width: 100%; }\n  .swal2-modal:focus {\n    outline: none; }\n  .swal2-modal.swal2-loading {\n    overflow-y: hidden; }\n  .swal2-modal .swal2-title {\n    color: #595959;\n    font-size: 30px;\n    text-align: center;\n    font-weight: 600;\n    text-transform: none;\n    position: relative;\n    margin: 0 0 .4em;\n    padding: 0;\n    display: block;\n    word-wrap: break-word; }\n  .swal2-modal .swal2-buttonswrapper {\n    margin-top: 15px; }\n    .swal2-modal .swal2-buttonswrapper:not(.swal2-loading) .swal2-styled[disabled] {\n      opacity: .4;\n      cursor: no-drop; }\n    .swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-confirm {\n      -webkit-box-sizing: border-box;\n              box-sizing: border-box;\n      border: 4px solid transparent;\n      border-color: transparent;\n      width: 40px;\n      height: 40px;\n      padding: 0;\n      margin: 7.5px;\n      vertical-align: top;\n      background-color: transparent !important;\n      color: transparent;\n      cursor: default;\n      border-radius: 100%;\n      -webkit-animation: rotate-loading 1.5s linear 0s infinite normal;\n              animation: rotate-loading 1.5s linear 0s infinite normal;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none; }\n    .swal2-modal .swal2-buttonswrapper.swal2-loading .swal2-styled.swal2-cancel {\n      margin-left: 30px;\n      margin-right: 30px; }\n    .swal2-modal .swal2-buttonswrapper.swal2-loading :not(.swal2-styled).swal2-confirm::after {\n      display: inline-block;\n      content: '';\n      margin-left: 5px;\n      vertical-align: -1px;\n      height: 15px;\n      width: 15px;\n      border: 3px solid #999999;\n      -webkit-box-shadow: 1px 1px 1px #fff;\n              box-shadow: 1px 1px 1px #fff;\n      border-right-color: transparent;\n      border-radius: 50%;\n      -webkit-animation: rotate-loading 1.5s linear 0s infinite normal;\n              animation: rotate-loading 1.5s linear 0s infinite normal; }\n  .swal2-modal .swal2-styled {\n    border: 0;\n    border-radius: 3px;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    color: #fff;\n    cursor: pointer;\n    font-size: 17px;\n    font-weight: 500;\n    margin: 15px 5px 0;\n    padding: 10px 32px; }\n    .swal2-modal .swal2-styled:focus {\n      outline: none;\n      -webkit-box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4);\n              box-shadow: 0 0 0 2px #fff, 0 0 0 4px rgba(50, 100, 150, 0.4); }\n  .swal2-modal .swal2-image {\n    margin: 20px auto;\n    max-width: 100%; }\n  .swal2-modal .swal2-close {\n    background: transparent;\n    border: 0;\n    margin: 0;\n    padding: 0;\n    width: 38px;\n    height: 40px;\n    font-size: 36px;\n    line-height: 40px;\n    font-family: serif;\n    position: absolute;\n    top: 5px;\n    right: 8px;\n    cursor: pointer;\n    color: #cccccc;\n    -webkit-transition: color .1s ease;\n    transition: color .1s ease; }\n    .swal2-modal .swal2-close:hover {\n      color: #d55; }\n  .swal2-modal > .swal2-input,\n  .swal2-modal > .swal2-file,\n  .swal2-modal > .swal2-textarea,\n  .swal2-modal > .swal2-select,\n  .swal2-modal > .swal2-radio,\n  .swal2-modal > .swal2-checkbox {\n    display: none; }\n  .swal2-modal .swal2-content {\n    font-size: 18px;\n    text-align: center;\n    font-weight: 300;\n    position: relative;\n    float: none;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n    color: #545454;\n    word-wrap: break-word; }\n  .swal2-modal .swal2-input,\n  .swal2-modal .swal2-file,\n  .swal2-modal .swal2-textarea,\n  .swal2-modal .swal2-select,\n  .swal2-modal .swal2-radio,\n  .swal2-modal .swal2-checkbox {\n    margin: 20px auto; }\n  .swal2-modal .swal2-input,\n  .swal2-modal .swal2-file,\n  .swal2-modal .swal2-textarea {\n    width: 100%;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    font-size: 18px;\n    border-radius: 3px;\n    border: 1px solid #d9d9d9;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n    -webkit-transition: border-color .3s, -webkit-box-shadow .3s;\n    transition: border-color .3s, -webkit-box-shadow .3s;\n    transition: border-color .3s, box-shadow .3s;\n    transition: border-color .3s, box-shadow .3s, -webkit-box-shadow .3s; }\n    .swal2-modal .swal2-input.swal2-inputerror,\n    .swal2-modal .swal2-file.swal2-inputerror,\n    .swal2-modal .swal2-textarea.swal2-inputerror {\n      border-color: #f27474 !important;\n      -webkit-box-shadow: 0 0 2px #f27474 !important;\n              box-shadow: 0 0 2px #f27474 !important; }\n    .swal2-modal .swal2-input:focus,\n    .swal2-modal .swal2-file:focus,\n    .swal2-modal .swal2-textarea:focus {\n      outline: none;\n      border: 1px solid #b4dbed;\n      -webkit-box-shadow: 0 0 3px #c4e6f5;\n              box-shadow: 0 0 3px #c4e6f5; }\n    .swal2-modal .swal2-input::-webkit-input-placeholder,\n    .swal2-modal .swal2-file::-webkit-input-placeholder,\n    .swal2-modal .swal2-textarea::-webkit-input-placeholder {\n      color: #cccccc; }\n    .swal2-modal .swal2-input:-ms-input-placeholder,\n    .swal2-modal .swal2-file:-ms-input-placeholder,\n    .swal2-modal .swal2-textarea:-ms-input-placeholder {\n      color: #cccccc; }\n    .swal2-modal .swal2-input::placeholder,\n    .swal2-modal .swal2-file::placeholder,\n    .swal2-modal .swal2-textarea::placeholder {\n      color: #cccccc; }\n  .swal2-modal .swal2-range input {\n    float: left;\n    width: 80%; }\n  .swal2-modal .swal2-range output {\n    float: right;\n    width: 20%;\n    font-size: 20px;\n    font-weight: 600;\n    text-align: center; }\n  .swal2-modal .swal2-range input,\n  .swal2-modal .swal2-range output {\n    height: 43px;\n    line-height: 43px;\n    vertical-align: middle;\n    margin: 20px auto;\n    padding: 0; }\n  .swal2-modal .swal2-input {\n    height: 43px;\n    padding: 0 12px; }\n    .swal2-modal .swal2-input[type='number'] {\n      max-width: 150px; }\n  .swal2-modal .swal2-file {\n    font-size: 20px; }\n  .swal2-modal .swal2-textarea {\n    height: 108px;\n    padding: 12px; }\n  .swal2-modal .swal2-select {\n    color: #545454;\n    font-size: inherit;\n    padding: 5px 10px;\n    min-width: 40%;\n    max-width: 100%; }\n  .swal2-modal .swal2-radio {\n    border: 0; }\n    .swal2-modal .swal2-radio label:not(:first-child) {\n      margin-left: 20px; }\n    .swal2-modal .swal2-radio input,\n    .swal2-modal .swal2-radio span {\n      vertical-align: middle; }\n    .swal2-modal .swal2-radio input {\n      margin: 0 3px 0 0; }\n  .swal2-modal .swal2-checkbox {\n    color: #545454; }\n    .swal2-modal .swal2-checkbox input,\n    .swal2-modal .swal2-checkbox span {\n      vertical-align: middle; }\n  .swal2-modal .swal2-validationerror {\n    background-color: #f0f0f0;\n    margin: 0 -20px;\n    overflow: hidden;\n    padding: 10px;\n    color: gray;\n    font-size: 16px;\n    font-weight: 300;\n    display: none; }\n    .swal2-modal .swal2-validationerror::before {\n      content: '!';\n      display: inline-block;\n      width: 24px;\n      height: 24px;\n      border-radius: 50%;\n      background-color: #ea7d7d;\n      color: #fff;\n      line-height: 24px;\n      text-align: center;\n      margin-right: 10px; }\n\n@supports (-ms-accelerator: true) {\n  .swal2-range input {\n    width: 100% !important; }\n  .swal2-range output {\n    display: none; } }\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  .swal2-range input {\n    width: 100% !important; }\n  .swal2-range output {\n    display: none; } }\n\n.swal2-icon {\n  width: 80px;\n  height: 80px;\n  border: 4px solid transparent;\n  border-radius: 50%;\n  margin: 20px auto 30px;\n  padding: 0;\n  position: relative;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  cursor: default;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .swal2-icon.swal2-error {\n    border-color: rgba(255, 54, 54, .3); }\n    .swal2-icon.swal2-error .swal2-x-mark {\n      position: relative;\n      display: block; }\n    .swal2-icon.swal2-error [class^='swal2-x-mark-line'] {\n      position: absolute;\n      height: 5px;\n      width: 47px;\n      background-color: #FF3636;\n      display: block;\n      top: 37px;\n      border-radius: 2px; }\n      .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class$='left'] {\n        -webkit-transform: rotate(45deg);\n                transform: rotate(45deg);\n        left: 17px; }\n      .swal2-icon.swal2-error [class^='swal2-x-mark-line'][class$='right'] {\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg);\n        right: 16px; }\n  .swal2-icon.swal2-warning {\n    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    color: #FFB236;\n    border-color: #FFB236;\n    font-size: 60px;\n    line-height: 80px;\n    text-align: center; }\n  .swal2-icon.swal2-info {\n    font-family: 'Open Sans', sans-serif;\n    color: #3fc3ee;\n    border-color: #9de0f6;\n    font-size: 60px;\n    line-height: 80px;\n    text-align: center; }\n  .swal2-icon.swal2-question {\n    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    color: #87adbd;\n    border-color: #c9dae1;\n    font-size: 60px;\n    line-height: 80px;\n    text-align: center; }\n  .swal2-icon.swal2-success {\n    border-color: #a5dc86; }\n    .swal2-icon.swal2-success [class^='swal2-success-circular-line'] {\n      border-radius: 50%;\n      position: absolute;\n      width: 60px;\n      height: 120px;\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg); }\n      .swal2-icon.swal2-success [class^='swal2-success-circular-line'][class$='left'] {\n        border-radius: 120px 0 0 120px;\n        top: -7px;\n        left: -33px;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg);\n        -webkit-transform-origin: 60px 60px;\n                transform-origin: 60px 60px; }\n      .swal2-icon.swal2-success [class^='swal2-success-circular-line'][class$='right'] {\n        border-radius: 0 120px 120px 0;\n        top: -11px;\n        left: 30px;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg);\n        -webkit-transform-origin: 0 60px;\n                transform-origin: 0 60px; }\n    .swal2-icon.swal2-success .swal2-success-ring {\n      width: 80px;\n      height: 80px;\n      border: 4px solid rgba(24, 206, 15, .3);\n      border-radius: 50%;\n      -webkit-box-sizing: content-box;\n              box-sizing: content-box;\n      position: absolute;\n      left: -4px;\n      top: -4px;\n      z-index: 2; }\n    .swal2-icon.swal2-success .swal2-success-fix {\n      width: 7px;\n      height: 90px;\n      position: absolute;\n      left: 28px;\n      top: 8px;\n      z-index: 1;\n      -webkit-transform: rotate(-45deg);\n              transform: rotate(-45deg); }\n    .swal2-icon.swal2-success [class^='swal2-success-line'] {\n      height: 5px;\n      background-color: #18ce0f;\n      display: block;\n      border-radius: 2px;\n      position: absolute;\n      z-index: 2; }\n      .swal2-icon.swal2-success [class^='swal2-success-line'][class$='tip'] {\n        width: 25px;\n        left: 14px;\n        top: 46px;\n        -webkit-transform: rotate(45deg);\n                transform: rotate(45deg); }\n      .swal2-icon.swal2-success [class^='swal2-success-line'][class$='long'] {\n        width: 47px;\n        right: 8px;\n        top: 38px;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg); }\n\n.swal2-progresssteps {\n  font-weight: 600;\n  margin: 0 0 20px;\n  padding: 0; }\n  .swal2-progresssteps li {\n    display: inline-block;\n    position: relative; }\n  .swal2-progresssteps .swal2-progresscircle {\n    background: #3085d6;\n    border-radius: 2em;\n    color: #fff;\n    height: 2em;\n    line-height: 2em;\n    text-align: center;\n    width: 2em;\n    z-index: 20; }\n    .swal2-progresssteps .swal2-progresscircle:first-child {\n      margin-left: 0; }\n    .swal2-progresssteps .swal2-progresscircle:last-child {\n      margin-right: 0; }\n    .swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep {\n      background: #3085d6; }\n      .swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep ~ .swal2-progresscircle {\n        background: #add8e6; }\n      .swal2-progresssteps .swal2-progresscircle.swal2-activeprogressstep ~ .swal2-progressline {\n        background: #add8e6; }\n  .swal2-progresssteps .swal2-progressline {\n    background: #3085d6;\n    height: .4em;\n    margin: 0 -1px;\n    z-index: 10; }\n\n[class^='swal2'] {\n  -webkit-tap-highlight-color: transparent; }\n\n@-webkit-keyframes showSweetAlert {\n  0% {\n    -webkit-transform: scale(0.7);\n            transform: scale(0.7); }\n  45% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05); }\n  80% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@keyframes showSweetAlert {\n  0% {\n    -webkit-transform: scale(0.7);\n            transform: scale(0.7); }\n  45% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05); }\n  80% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@-webkit-keyframes hideSweetAlert {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; }\n  100% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n    opacity: 0; } }\n\n@keyframes hideSweetAlert {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; }\n  100% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n    opacity: 0; } }\n\n.swal2-show {\n  -webkit-animation: showSweetAlert .3s;\n          animation: showSweetAlert .3s; }\n  .swal2-show.swal2-noanimation {\n    -webkit-animation: none;\n            animation: none; }\n\n.swal2-hide {\n  -webkit-animation: hideSweetAlert .15s forwards;\n          animation: hideSweetAlert .15s forwards; }\n  .swal2-hide.swal2-noanimation {\n    -webkit-animation: none;\n            animation: none; }\n\n@-webkit-keyframes animate-success-tip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px; }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px; }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px; } }\n\n@keyframes animate-success-tip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px; }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px; }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px; } }\n\n@-webkit-keyframes animate-success-long {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px; }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px; } }\n\n@keyframes animate-success-long {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px; }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px; } }\n\n@-webkit-keyframes rotatePlaceholder {\n  0% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  5% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  12% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); }\n  100% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); } }\n\n@keyframes rotatePlaceholder {\n  0% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  5% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  12% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); }\n  100% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); } }\n\n.swal2-animate-success-line-tip {\n  -webkit-animation: animate-success-tip .75s;\n          animation: animate-success-tip .75s; }\n\n.swal2-animate-success-line-long {\n  -webkit-animation: animate-success-long .75s;\n          animation: animate-success-long .75s; }\n\n.swal2-success.swal2-animate-success-icon .swal2-success-circular-line-right {\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\n          animation: rotatePlaceholder 4.25s ease-in; }\n\n@-webkit-keyframes animate-error-icon {\n  0% {\n    -webkit-transform: rotateX(100deg);\n            transform: rotateX(100deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg);\n    opacity: 1; } }\n\n@keyframes animate-error-icon {\n  0% {\n    -webkit-transform: rotateX(100deg);\n            transform: rotateX(100deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg);\n    opacity: 1; } }\n\n.swal2-animate-error-icon {\n  -webkit-animation: animate-error-icon .5s;\n          animation: animate-error-icon .5s; }\n\n@-webkit-keyframes animate-x-mark {\n  0% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  50% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  80% {\n    -webkit-transform: scale(1.15);\n            transform: scale(1.15);\n    margin-top: -6px; }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    margin-top: 0;\n    opacity: 1; } }\n\n@keyframes animate-x-mark {\n  0% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  50% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  80% {\n    -webkit-transform: scale(1.15);\n            transform: scale(1.15);\n    margin-top: -6px; }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    margin-top: 0;\n    opacity: 1; } }\n\n.swal2-animate-x-mark {\n  -webkit-animation: animate-x-mark .5s;\n          animation: animate-x-mark .5s; }\n\n@-webkit-keyframes rotate-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes rotate-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n",".card-wizard{\n    min-height: 410px;\n    box-shadow: $box-shadow;\n    opacity: 0;\n    @include transition($general-transition-time, $transition-linear);\n\n    &.active{\n        opacity: 1;\n    }\n\n    .card-header {\n      padding: 15px 0 !important;\n      padding-bottom: 40px;\n    }\n\n    .nav-pills .nav-item .nav-link{\n        padding: 12px;\n    }\n\n    .nav-pills .nav-item .nav-link,\n    .nav-pills .nav-item .nav-link.active,\n    .nav-pills .nav-item .nav-link:hover,\n    .nav-pills .nav-item .nav-link:focus,\n    .nav-pills .nav-item .nav-link.active:focus,\n    .nav-pills .nav-item .nav-link.active:hover{\n        background-color: transparent;\n        box-shadow: none;\n    }\n\n    .picture-container{\n        position: relative;\n        cursor: pointer;\n        text-align: center;\n    }\n\n    .wizard-navigation{\n      position: relative;\n\n      .nav-link{\n        display: flex;\n        align-items: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n      }\n    }\n\n    .wizard-navigation .nav-link i,\n    .moving-tab i{\n      display: inline-block;\n      font-size: 19px;\n      line-height: initial;\n      margin-right: 6px;\n      padding: 0;\n      vertical-align: bottom;\n    }\n\n    .picture{\n        width: 106px;\n        height: 106px;\n        background-color: #999999;\n        border: 1px solid $light-gray;\n        color: #FFFFFF;\n        border-radius: 50%;\n        margin: 5px auto;\n        overflow: hidden;\n        transition: all 0.2s;\n        -webkit-transition: all 0.2s;\n\n        &:hover{\n            border-color: #2ca8ff;\n        }\n    }\n\n    .moving-tab{\n        position: absolute;\n        text-align: center;\n        padding: 12px;\n        font-size: 12px;\n        text-transform: uppercase;\n        -webkit-font-smoothing: subpixel-antialiased;\n        top: 0px;\n        left: 0px;\n        background-color: $default-color;\n        box-shadow: $box-shadow;\n        color: $white-color !important;\n        cursor: pointer;\n        font-weight: 500;\n    }\n\n    &[data-color=\"primary\"]{\n        @include set-wizard-color($brand-primary);\n    }\n    &[data-color=\"white\"]{\n        @include set-wizard-color($white-color);\n    }\n\n    &[data-color=\"green\"]{\n        @include set-wizard-color($brand-success);\n    }\n\n    &[data-color=\"blue\"]{\n        @include set-wizard-color($brand-info);\n    }\n\n    &[data-color=\"orange\"]{\n        @include set-wizard-color($brand-warning);\n    }\n\n    &[data-color=\"red\"]{\n        @include set-wizard-color($brand-danger);\n    }\n\n    .picture input[type=\"file\"] {\n        cursor: pointer;\n        display: block;\n        height: 100%;\n        left: 0;\n        opacity: 0 !important;\n        position: absolute;\n        top: 0;\n        width: 100%;\n    }\n\n    .picture-src{\n        width: 100%;\n    }\n\n    .tab-content{\n        min-height: 355px;\n        padding: 20px 0;\n    }\n\n    .wizard-footer{\n        padding: 0 15px;\n\n        .checkbox{\n            margin-top: 16px;\n        }\n    }\n\n    .disabled{\n        display: none;\n    }\n\n    .wizard-header{\n        text-align: center;\n        padding: 25px 0 35px;\n\n        h5{\n           margin: 5px 0 0;\n       }\n    }\n\n    .nav-pills > li{\n        text-align: center;\n    }\n\n    .btn{\n        text-transform: uppercase;\n    }\n\n    .info-text{\n        text-align: center;\n        font-weight: 300;\n        margin: 10px 0 30px;\n    }\n\n    .choice{\n        text-align: center;\n        cursor: pointer;\n        margin-top: 20px;\n\n        &[disabled]{\n            pointer-events: none;\n            cursor: not-allowed;\n            opacity: .5;\n        }\n\n        .icon{\n            text-align: center;\n            vertical-align: middle;\n            height: 116px;\n            width: 116px;\n            border-radius: 50%;\n            color: $default-color;\n            margin: 0 auto 20px;\n            border: 1px solid $light-gray;\n            transition: all 0.2s;\n            -webkit-transition: all 0.2s;\n        }\n\n        i{\n            font-size: 30px;\n            line-height: 116px;\n            position: absolute;\n            left: 0;\n            right: 0;\n        }\n\n        &:hover,\n        &.active{\n            .icon{\n                border-color: #2ca8ff;\n            }\n        }\n\n        input[type=\"radio\"],\n        input[type=\"checkbox\"]{\n            position: absolute;\n            left: -10000px;\n            z-index: -1;\n        }\n    }\n\n    .btn-finish{\n        display: none;\n    }\n\n    .card-title + .description{\n        font-size: $font-size-base + 3;\n        margin-bottom: 32px;\n    }\n\n    .wizard-title{\n        margin: 0;\n    }\n\n    .nav-pills{\n        background-color: $dark-gray;\n\n        > li + li {\n            margin-left: 0;\n        }\n\n        > li > a {\n            border: 0 !important;\n            border-radius: 0 ;\n            line-height: 18px;\n            text-transform: uppercase;\n            font-size: 12px;\n            font-weight: 500;\n            min-width: 100px;\n            text-align: center;\n            color: $white-color !important;\n        }\n\n        > li.active > a,\n        > li.active > a:hover,\n        > li.active > a:focus,\n        > li > a:hover,\n        > li > a:focus{\n            background-color: inherit;\n            box-shadow: none;\n        }\n\n        > li i{\n            display: block;\n            font-size: 30px;\n            padding: 15px 0;\n        }\n    }\n\n  .form-group.select-wizard {\n    margin-top: 15px;\n  }\n\n  .dropdown.show,\n  .dropup.show {\n    .dropdown-menu {\n      @include transform-translate-y(0px);\n    }\n  }\n}\n","@mixin box-shadow($shadow...) {\n  -webkit-box-shadow: $shadow; // iOS <4.3 & Android <4.1\n          box-shadow: $shadow;\n}\n\n@mixin transition($time, $type){\n    -webkit-transition: all $time $type;\n    -moz-transition: all $time $type;\n    -o-transition: all $time $type;\n    -ms-transition: all $time $type;\n    transition: all $time $type;\n}\n\n\n@mixin sidebar-color($color){\n  &:after{\n    background: $color;\n  }\n}\n\n@mixin bar-animation($type){\n     -webkit-animation: $type 500ms linear 0s;\n     -moz-animation: $type 500ms linear 0s;\n     animation: $type 500ms 0s;\n     -webkit-animation-fill-mode: forwards;\n     -moz-animation-fill-mode: forwards;\n     animation-fill-mode: forwards;\n}\n\n@mixin sidebar-active-color($font-color){\n    .nav {\n        li {\n          &.active > a,\n          &.active > a i,\n          &.active > a[data-toggle=\"collapse\"],\n          &.active > a[data-toggle=\"collapse\"] i,\n          &.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active .sidebar-mini-icon,\n          &.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active > a {\n            color: $font-color;\n            opacity: 1;\n          }\n        }\n    }\n}\n\n@mixin transition-opacity($time, $type){\n    -webkit-transition: opacity $time $type;\n    -moz-transition: opacity $time $type;\n    -o-transition: opacity $time $type;\n    -ms-transition: opacity $time $type;\n    transition: opacity $time $type;\n}\n\n@mixin transform-translate-y-dropdown($value) {\n    -webkit-transform:  translate3d(-20px,$value,0) !important;\n       -moz-transform: translate3d(-20px,$value,0) !important;\n       -o-transform: translate3d(-20px,$value,0) !important;\n       -ms-transform: translate3d(-20px,$value,0) !important;\n       transform: translate3d(-20px,$value,0) !important;\n}\n\n@mixin transform-translate-x($value){\n     -webkit-transform:  translate3d($value, 0, 0);\n        -moz-transform: translate3d($value, 0, 0);\n        -o-transform: translate3d($value, 0, 0);\n        -ms-transform: translate3d($value, 0, 0);\n        transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-y($value){\n     -webkit-transform:  translate3d(0,$value,0) !important;\n        -moz-transform: translate3d(0,$value,0) !important;\n        -o-transform: translate3d(0,$value,0) !important;\n        -ms-transform: translate3d(0,$value,0) !important;\n        transform: translate3d(0,$value,0) !important;\n}\n\n@mixin transform-translate-y-fixed-plugin($value){\n     -webkit-transform:  translate3d(0,$value,0) !important;\n        -moz-transform: translate3d(0,$value,0) !important;\n        -o-transform: translate3d(0,$value,0) !important;\n        -ms-transform: translate3d(0,$value,0) !important;\n        transform: translate3d(0,$value,0) !important;\n}\n\n@mixin icon-gradient($color, $bottomColor: #000){\n    background: $color;\n    background: -webkit-linear-gradient($color 0%, $bottomColor 80%);\n    background: -o-linear-gradient($color 0%, $bottomColor 80%);\n    background: -moz-linear-gradient($color 0%, $bottomColor 80%);\n    background: linear-gradient($color 0%, $bottomColor 80%);\n}\n\n@mixin topbar-x-rotation(){\n    @keyframes topbar-x {\n      0% {top: 0px; transform: rotate(0deg); }\n      45% {top: 6px; transform: rotate(145deg); }\n      75% {transform: rotate(130deg); }\n      100% {transform: rotate(135deg); }\n    }\n    @-webkit-keyframes topbar-x {\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\n      75% {-webkit-transform: rotate(130deg); }\n      100% { -webkit-transform: rotate(135deg); }\n    }\n    @-moz-keyframes topbar-x {\n      0% {top: 0px; -moz-transform: rotate(0deg); }\n      45% {top: 6px; -moz-transform: rotate(145deg); }\n      75% {-moz-transform: rotate(130deg); }\n      100% { -moz-transform: rotate(135deg); }\n    }\n}\n\n\n@mixin topbar-back-rotation(){\n    @keyframes topbar-back {\n      0% { top: 6px; transform: rotate(135deg); }\n      45% { transform: rotate(-10deg); }\n      75% { transform: rotate(5deg); }\n      100% { top: 0px; transform: rotate(0); }\n    }\n\n    @-webkit-keyframes topbar-back {\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\n      45% { -webkit-transform: rotate(-10deg); }\n      75% { -webkit-transform: rotate(5deg); }\n      100% { top: 0px; -webkit-transform: rotate(0); }\n    }\n\n    @-moz-keyframes topbar-back {\n      0% { top: 6px; -moz-transform: rotate(135deg); }\n      45% { -moz-transform: rotate(-10deg); }\n      75% { -moz-transform: rotate(5deg); }\n      100% { top: 0px; -moz-transform: rotate(0); }\n    }\n}\n\n@mixin bottombar-x-rotation(){\n    @keyframes bottombar-x {\n      0% {bottom: 0px; transform: rotate(0deg);}\n      45% {bottom: 6px; transform: rotate(-145deg);}\n      75% {transform: rotate(-130deg);}\n      100% {transform: rotate(-135deg);}\n    }\n    @-webkit-keyframes bottombar-x {\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\n      75% {-webkit-transform: rotate(-130deg);}\n      100% {-webkit-transform: rotate(-135deg);}\n    }\n    @-moz-keyframes bottombar-x {\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\n      75% {-moz-transform: rotate(-130deg);}\n      100% {-moz-transform: rotate(-135deg);}\n    }\n}\n\n@mixin bottombar-back-rotation{\n    @keyframes bottombar-back {\n      0% { bottom: 6px;transform: rotate(-135deg);}\n      45% { transform: rotate(10deg);}\n      75% { transform: rotate(-5deg);}\n      100% { bottom: 0px;transform: rotate(0);}\n    }\n    @-webkit-keyframes bottombar-back {\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\n      45% {-webkit-transform: rotate(10deg);}\n      75% {-webkit-transform: rotate(-5deg);}\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\n    }\n    @-moz-keyframes bottombar-back {\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\n      45% {-moz-transform: rotate(10deg);}\n      75% {-moz-transform: rotate(-5deg);}\n      100% {bottom: 0px;-moz-transform: rotate(0);}\n    }\n\n}\n\n@mixin sidebar-text-color($text-color){\n    .nav {\n      li {\n        a,\n        a i,\n        a[data-toggle=\"collapse\"],\n        a[data-toggle=\"collapse\"] i,\n        a[data-toggle=\"collapse\"] ~ div > ul > li .sidebar-mini-icon,\n        a[data-toggle=\"collapse\"] ~ div > ul > li > a {\n          color: $text-color;\n          opacity: .7;\n        }\n\n        &:hover:not(.active) > a,\n        &:focus:not(.active) > a {\n            opacity: 1;\n        }\n      }\n    }\n\n    .logo {\n      .simple-text {\n        color: $text-color;\n      }\n      &:after {\n        background-color: $text-color;\n        opacity: .4;\n      }\n    }\n\n    .user {\n      .info a span,\n      .nav .sidebar-mini-icon,\n      .nav .sidebar-normal {\n        color: $text-color !important;\n      }\n      &:after {\n        background-color: $text-color;\n        opacity: .4;\n      }\n    }\n}\n\n@mixin badge-color($color) {\n    border-color: $color;\n    background-color: $color;\n}\n","@mixin set-wizard-color($color) {\n      .moving-tab{\n          color: $color;\n      }\n\n    .picture{\n        &:hover{\n            border-color: $color;\n        }\n    }\n\n    .choice{\n        &:hover,\n        &.active{\n            .icon{\n                border-color: $color;\n                color: $color;\n            }\n        }\n    }\n\n    // .form-group{\n    //     .form-control{\n    //         background-image: linear-gradient($color, $color), linear-gradient($mdb-input-underline-color, $mdb-input-underline-color);\n    //     }\n    // }\n\n    .checkbox input[type=checkbox]:checked + .checkbox-material{\n        .check{\n            background-color: $color;\n        }\n    }\n\n    .radio input[type=radio]:checked ~ .check {\n        background-color: $color;\n    }\n\n    .radio input[type=radio]:checked ~ .circle {\n        border-color: $color;\n    }\n}\n","@mixin transition-input-focus-color() {\n    -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\n}\n\n@mixin transform-translate-x($value){\n     -webkit-transform:  translate3d($value, 0, 0);\n        -moz-transform: translate3d($value, 0, 0);\n        -o-transform: translate3d($value, 0, 0);\n        -ms-transform: translate3d($value, 0, 0);\n        transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-y($value){\n     -webkit-transform:  translate3d(0,$value,0) !important;\n        -moz-transform: translate3d(0,$value,0) !important;\n        -o-transform: translate3d(0,$value,0) !important;\n        -ms-transform: translate3d(0,$value,0) !important;\n        transform: translate3d(0,$value,0) !important;\n}\n@mixin transform-translate-y-fixed-plugin($value){\n     -webkit-transform:  translate3d(0,$value,0) !important;\n        -moz-transform: translate3d(0,$value,0) !important;\n        -o-transform: translate3d(0,$value,0) !important;\n        -ms-transform: translate3d(0,$value,0) !important;\n        transform: translate3d(0,$value,0) !important;\n}\n\n@mixin transform-translate-y-dropdown($value) {\n    -webkit-transform:  translate3d(-20px,$value,0) !important;\n       -moz-transform: translate3d(-20px,$value,0) !important;\n       -o-transform: translate3d(-20px,$value,0) !important;\n       -ms-transform: translate3d(-20px,$value,0) !important;\n       transform: translate3d(-20px,$value,0) !important;\n}\n\n@mixin icon-gradient($color, $bottomColor: #000){\n    background: $color;\n    background: -webkit-linear-gradient($color 0%, $bottomColor 80%);\n    background: -o-linear-gradient($color 0%, $bottomColor 80%);\n    background: -moz-linear-gradient($color 0%, $bottomColor 80%);\n    background: linear-gradient($color 0%, $bottomColor 80%);\n}\n\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\n   font-size: $font-size;\n   border-radius: $border;\n   padding: $padding-vertical $padding-horizontal;\n\n   &.btn-simple{\n       padding: $padding-vertical - 1 $padding-horizontal - 1;\n   }\n\n}\n\n@mixin rotate-53(){\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n    -webkit-transform: rotate(53deg);\n    -ms-transform: rotate(53deg);\n    transform: rotate(53deg);\n}\n\n@mixin transform-scale($value){\n     -webkit-transform: scale($value);\n        -moz-transform: scale($value);\n        -o-transform: scale($value);\n        -ms-transform: scale($value);\n        transform: scale($value);\n}\n\n\n@mixin rotate-180(){\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n\n@mixin topbar-x-rotation(){\n    @keyframes topbar-x {\n      0% {top: 0px; transform: rotate(0deg); }\n      45% {top: 6px; transform: rotate(145deg); }\n      75% {transform: rotate(130deg); }\n      100% {transform: rotate(135deg); }\n    }\n    @-webkit-keyframes topbar-x {\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\n      75% {-webkit-transform: rotate(130deg); }\n      100% { -webkit-transform: rotate(135deg); }\n    }\n    @-moz-keyframes topbar-x {\n      0% {top: 0px; -moz-transform: rotate(0deg); }\n      45% {top: 6px; -moz-transform: rotate(145deg); }\n      75% {-moz-transform: rotate(130deg); }\n      100% { -moz-transform: rotate(135deg); }\n    }\n}\n\n@mixin topbar-back-rotation(){\n    @keyframes topbar-back {\n      0% { top: 6px; transform: rotate(135deg); }\n      45% { transform: rotate(-10deg); }\n      75% { transform: rotate(5deg); }\n      100% { top: 0px; transform: rotate(0); }\n    }\n\n    @-webkit-keyframes topbar-back {\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\n      45% { -webkit-transform: rotate(-10deg); }\n      75% { -webkit-transform: rotate(5deg); }\n      100% { top: 0px; -webkit-transform: rotate(0); }\n    }\n\n    @-moz-keyframes topbar-back {\n      0% { top: 6px; -moz-transform: rotate(135deg); }\n      45% { -moz-transform: rotate(-10deg); }\n      75% { -moz-transform: rotate(5deg); }\n      100% { top: 0px; -moz-transform: rotate(0); }\n    }\n}\n\n@mixin bottombar-x-rotation(){\n    @keyframes bottombar-x {\n      0% {bottom: 0px; transform: rotate(0deg);}\n      45% {bottom: 6px; transform: rotate(-145deg);}\n      75% {transform: rotate(-130deg);}\n      100% {transform: rotate(-135deg);}\n    }\n    @-webkit-keyframes bottombar-x {\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\n      75% {-webkit-transform: rotate(-130deg);}\n      100% {-webkit-transform: rotate(-135deg);}\n    }\n    @-moz-keyframes bottombar-x {\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\n      75% {-moz-transform: rotate(-130deg);}\n      100% {-moz-transform: rotate(-135deg);}\n    }\n}\n\n@mixin bottombar-back-rotation{\n    @keyframes bottombar-back {\n      0% { bottom: 6px;transform: rotate(-135deg);}\n      45% { transform: rotate(10deg);}\n      75% { transform: rotate(-5deg);}\n      100% { bottom: 0px;transform: rotate(0);}\n    }\n    @-webkit-keyframes bottombar-back {\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\n      45% {-webkit-transform: rotate(10deg);}\n      75% {-webkit-transform: rotate(-5deg);}\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\n    }\n    @-moz-keyframes bottombar-back {\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\n      45% {-moz-transform: rotate(10deg);}\n      75% {-moz-transform: rotate(-5deg);}\n      100% {bottom: 0px;-moz-transform: rotate(0);}\n    }\n\n}\n\n@mixin nc-rotate($degrees, $rotation) {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\n  -webkit-transform: rotate($degrees);\n  -moz-transform: rotate($degrees);\n  -ms-transform: rotate($degrees);\n  -o-transform: rotate($degrees);\n  transform: rotate($degrees);\n}\n\n@mixin nc-flip($horiz, $vert, $rotation) {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\n  -webkit-transform: scale($horiz, $vert);\n  -moz-transform: scale($horiz, $vert);\n  -ms-transform: scale($horiz, $vert);\n  -o-transform: scale($horiz, $vert);\n  transform: scale($horiz, $vert);\n}\n\n@mixin transition-opacity($time, $type){\n    -webkit-transition: opacity $time $type;\n    -moz-transition: opacity $time $type;\n    -o-transition: opacity $time $type;\n    -ms-transition: opacity $time $type;\n    transition: opacity $time $type;\n}\n\n\n@mixin sidebar-text-color($text-color){\n    .nav {\n      li {\n        a,\n        a i,\n        a[data-toggle=\"collapse\"],\n        a[data-toggle=\"collapse\"] i,\n        a[data-toggle=\"collapse\"] ~ div > ul > li .sidebar-mini-icon,\n        a[data-toggle=\"collapse\"] ~ div > ul > li > a {\n          color: $text-color;\n          opacity: .7;\n        }\n\n        &:hover:not(.active) > a,\n        &:focus:not(.active) > a {\n            opacity: 1;\n        }\n      }\n    }\n\n    .logo {\n      .simple-text {\n        color: $text-color;\n      }\n      &:after {\n        background-color: $text-color;\n        opacity: .4;\n      }\n    }\n\n    .user {\n      .info a span,\n      .nav .sidebar-mini-icon,\n      .nav .sidebar-normal {\n        color: $text-color !important;\n      }\n      &:after {\n        background-color: $text-color;\n        opacity: .4;\n      }\n    }\n}\n","/*!\n * Datetimepicker for Bootstrap 3\n * ! version : 4.7.14\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\n */\n.sr-only,\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after,\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after,\n.bootstrap-datetimepicker-widget .picker-switch::after,\n.bootstrap-datetimepicker-widget table th.prev::after,\n.bootstrap-datetimepicker-widget table th.next::after {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.bootstrap-datetimepicker-widget {\n  list-style: none;\n}\n.bootstrap-datetimepicker-widget a .btn:hover {\n  background-color: transparent;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu {\n  padding: 4px;\n  width: 16em;\n}\n@media (min-width: 768px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n@media (min-width: 992px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n@media (min-width: 1200px) {\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\n    width: 38em;\n  }\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before{\n    border-bottom: 11px solid $medium-pale-bg;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    left: auto;\n    top: -12px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after{\n    border-bottom: 11px solid $white-color;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    left: auto;\n    top: -11px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.top {\n  margin-top: auto;\n  margin-bottom: -20px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.top.open {\n  margin-top: auto;\n  margin-bottom: 5px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\n  left: auto;\n  right: 6px;\n}\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\n  left: auto;\n  right: 7px;\n}\n.bootstrap-datetimepicker-widget .list-unstyled {\n  margin: 0;\n}\n.bootstrap-datetimepicker-widget a[data-action] {\n  padding: 6px 0;\n  border-width: 0;\n  color: #66615B;\n  background-color: transparent;\n}\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"],\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"]:hover {\n    color: #429cb6 !important;\n}\n.bootstrap-datetimepicker-widget a[data-action]:hover {\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.85);\n}\n.bootstrap-datetimepicker-widget a[data-action]:active {\n  box-shadow: none;\n}\n.bootstrap-datetimepicker-widget .timepicker-hour,\n.bootstrap-datetimepicker-widget .timepicker-minute,\n.bootstrap-datetimepicker-widget .timepicker-second {\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  font-weight: 300;\n  font-size: 1.5em;\n  margin: 3px;\n  border-radius: 50%;\n}\n.bootstrap-datetimepicker-widget button[data-action] {\n  width: 38px;\n  height: 38px;\n  padding: 0;\n}\n\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\n  content: \"Increment Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\n  content: \"Increment Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\n  content: \"Decrement Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\n  content: \"Decrement Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\n  content: \"Show Hours\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\n  content: \"Show Minutes\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\n  content: \"Toggle AM/PM\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\n  content: \"Clear the picker\";\n}\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\n  content: \"Set the date to today\";\n}\n.bootstrap-datetimepicker-widget .picker-switch {\n  text-align: center;\n  border-radius: 4px;\n}\n.bootstrap-datetimepicker-widget .picker-switch::after {\n  content: \"Toggle Date and Time Screens\";\n}\n.bootstrap-datetimepicker-widget .picker-switch td {\n  padding: 0;\n  margin: 0;\n  height: auto;\n  width: auto;\n  line-height: inherit;\n}\n.bootstrap-datetimepicker-widget .picker-switch td span {\n  line-height: 2.5;\n  height: 2.5em;\n  width: 100%;\n  border-radius: 4px;\n  margin: 2px 0px !important;\n}\n.bootstrap-datetimepicker-widget table {\n  width: 100%;\n  margin: 0;\n}\n.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget table th {\n  height: 20px;\n  line-height: 20px;\n  width: 20px;\n}\n.bootstrap-datetimepicker-widget table th.picker-switch {\n  width: 145px;\n}\n.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {\n  border-radius: 4px;\n  height: 27px;\n  width: 27px;\n  line-height: 28px;\n  font-size: 12px;\n  border-radius: 50%;\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget table th.prev::after {\n  content: \"Previous Month\";\n}\n.bootstrap-datetimepicker-widget table th.next::after {\n  content: \"Next Month\";\n}\n.bootstrap-datetimepicker-widget table th.dow {\n  text-align: center;\n  border-bottom: 1px solid #E3E3E3;\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #9A9A9A;\n  font-weight: 400;\n  padding-bottom: 5px;\n  padding-top: 10px;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th {\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {\n  background: #E3E3E3;\n}\n.bootstrap-datetimepicker-widget table td > div {\n  border-radius: 4px;\n  height: 54px;\n  line-height: 54px;\n  width: 54px;\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget table td.cw > div {\n  font-size: .8em;\n  height: 20px;\n  line-height: 20px;\n  color: #cfcfca;\n}\n.bootstrap-datetimepicker-widget table td.day > div {\n  height: 30px;\n  line-height: 31px;\n  width: 30px;\n  text-align: center;\n  padding: 0px;\n  border-radius: 50%;\n  margin: 0 auto;\n  z-index: -1;\n  position: relative;\n}\n.table-condensed{\n    .day:hover{\n        div{\n            @include transition(150ms, linear);\n        }\n    }\n}\n.bootstrap-datetimepicker-widget table td.minute > div, .bootstrap-datetimepicker-widget table td.hour > div {\n  border-radius: 50%;\n}\n.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {\n  background: #E3E3E3;\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {\n  color: #cfcfca;\n}\n.bootstrap-datetimepicker-widget table td.today > div:before {\n  content: '';\n  display: inline-block;\n  border: 0 0 7px 7px solid transparent;\n  border-bottom-color: #68B3C8;\n  border-top-color: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n}\n.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {\n  background-color: #68B3C8;\n  color: #FFFFFF;\n}\n.bootstrap-datetimepicker-widget table td.active.today:before > div {\n  border-bottom-color: #FFFFFF;\n}\n.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget table td span {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  margin: 3px 3px;\n  cursor: pointer;\n  border-radius: 50%;\n  text-align: center;\n}\n.bootstrap-datetimepicker-widget table td span:hover {\n  background: #E3E3E3;\n}\n.bootstrap-datetimepicker-widget table td span.active {\n  background-color: #68B3C8;\n  color: #FFFFFF;\n}\n.bootstrap-datetimepicker-widget table td span.old {\n  color: #cfcfca;\n}\n.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {\n  background: none;\n  color: #cfcfca;\n  cursor: not-allowed;\n}\n.bootstrap-datetimepicker-widget .timepicker-picker span,\n.bootstrap-datetimepicker-widget .timepicker-hours span,\n.bootstrap-datetimepicker-widget .timepicker-minutes span {\n  border-radius: 50% !important;\n}\n.bootstrap-datetimepicker-widget.usetwentyfour td.hour {\n  height: 27px;\n  line-height: 27px;\n}\n\n.input-group.date .input-group-addon {\n  cursor: pointer;\n}\n\n.table-condensed > tbody > tr > td,\n.table-condensed > tbody > tr > th,\n.table-condensed > tfoot > tr > td,\n.table-condensed > tfoot > tr > th,\n.table-condensed > thead > tr > td,\n.table-condensed > thead > tr > th {\n  padding: 1px;\n  text-align: center;\n  z-index: 1;\n  cursor: pointer;\n}\n.bootstrap-datetimepicker-widget{\n  opacity: 0;\n  -webkit-box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);\n  box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);\n  @include transform-translate-y(-10px);\n\n  &.top {\n    @include transform-translate-y(10px);\n    opacity: 0;\n  }\n\n  &.open{\n    opacity: 1;\n    transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n    @include transform-translate-y(2px);\n  }\n}\n.bootstrap-datetimepicker-widget.top.open{\n  opacity: 1;\n  @include transform-translate-y(-7px);\n  transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n\n    &:before{\n        border-top: 11px solid #DCD9D1;\n        border-left: 11px solid transparent;\n        border-right: 11px solid transparent;\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        right: 12px;\n        bottom: -12px;\n    }\n    &:after{\n        border-top: 11px solid $white-color;\n        border-left: 11px solid transparent;\n        border-right: 11px solid transparent;\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        right: 12px;\n        bottom: -11px;\n    }\n}\n","/*!\n * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)\n *\n * Copyright 2013-2017 bootstrap-select\n * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)\n */\n\n // Mixins\n @mixin cursor-disabled() {\n   cursor: not-allowed;\n }\n\n @mixin box-sizing($fmt) {\n   -webkit-box-sizing: $fmt;\n      -moz-box-sizing: $fmt;\n           box-sizing: $fmt;\n }\n\n @mixin box-shadow($fmt) {\n   -webkit-box-shadow: $fmt;\n           box-shadow: $fmt;\n }\n\n @function fade($color, $amnt) {\n   @if $amnt > 1 {\n     $amnt: $amnt / 100; // convert to percentage if int\n   }\n   @return rgba($color, $amnt);\n }\n\n // Rules\n select.bs-select-hidden,\n select.selectpicker {\n   display: none !important;\n }\n\n .bootstrap-select {\n   width: 220px; /*IE9 and below*/\n\n   // The selectpicker button\n   > .dropdown-toggle {\n     width: 100%;\n     padding-right: 25px;\n     z-index: 1;\n   }\n\n   > select {\n     position: absolute !important;\n     bottom: 0;\n     left: 50%;\n     display: block !important;\n     width: 0.5px !important;\n     height: 100% !important;\n     padding: 0 !important;\n     opacity: 0 !important;\n     border: none;\n\n     &.mobile-device {\n       top: 0;\n       left: 0;\n       display: block !important;\n       width: 100% !important;\n       z-index: 2;\n     }\n   }\n\n   // Error display\n   .has-error & .dropdown-toggle,\n   .error & .dropdown-toggle {\n     border-color: $color-red-error;\n   }\n\n   &.fit-width {\n     width: auto !important;\n   }\n\n   &:not([class*=\"col-\"]):not([class*=\"form-control\"]):not(.input-group-btn) {\n     width: 150px;\n   }\n }\n\n .bootstrap-select.form-control {\n   margin-bottom: 0;\n   padding: 0;\n   border: none;\n\n   &:not([class*=\"col-\"]) {\n     width: 100%;\n   }\n\n   &.input-group-btn {\n     z-index: auto;\n\n     &:not(:first-child):not(:last-child) {\n       > .btn {\n         border-radius: 0;\n       }\n     }\n   }\n }\n\n // The selectpicker components\n .bootstrap-select.btn-group {\n   &:not(.input-group-btn),\n   &[class*=\"col-\"] {\n     float: none;\n     display: inline-block;\n     margin-left: 0;\n   }\n\n   // Forces the pull to the right, if necessary\n   &,\n   &[class*=\"col-\"],\n   .row &[class*=\"col-\"] {\n     &.dropdown-menu-right {\n       float: right;\n     }\n   }\n\n   .form-inline &,\n   .form-horizontal &,\n   .form-group & {\n     margin-bottom: 0;\n   }\n\n   .form-group-lg &.form-control,\n   .form-group-sm &.form-control {\n     padding: 0;\n\n     .dropdown-toggle {\n       height: 100%;\n       font-size: inherit;\n       line-height: inherit;\n       border-radius: inherit;\n     }\n   }\n\n   // Set the width of the live search (and any other form control within an inline form)\n   // see https://github.com/silviomoreto/bootstrap-select/issues/685\n   .form-inline & .form-control {\n     width: 100%;\n   }\n\n   &.disabled,\n   > .disabled {\n     @include cursor-disabled();\n\n     &:focus {\n       outline: none !important;\n     }\n   }\n\n   &.bs-container {\n     position: absolute;\n     height: 0 !important;\n     padding: 0 !important;\n\n     .dropdown-menu {\n       z-index: $zindex-select-dropdown;\n     }\n   }\n\n   // The selectpicker button\n   .dropdown-toggle {\n     .filter-option {\n       display: inline-block;\n       overflow: hidden;\n       width: 100%;\n       text-align: left;\n     }\n   }\n\n   &[class*=\"col-\"] .dropdown-toggle {\n     width: 100%;\n   }\n\n   // The selectpicker dropdown\n   .dropdown-menu {\n     min-width: 100%;\n     @include box-sizing(border-box);\n\n     &.inner {\n       position: static;\n       float: none;\n       border: 0;\n       padding: 0;\n       margin: 0;\n     }\n\n     li {\n       position: relative;\n\n       &.active small {\n         color: #fff;\n       }\n\n       &.disabled a {\n         @include cursor-disabled();\n       }\n\n       a {\n           color: #66615b;\n           font-size: 16px;\n           padding: 5px 45px 5px 15px;\n           clear: both;\n           white-space: nowrap;\n           width: 100%;\n           display: block;\n\n         &:hover{\n             background-color: #66615B;\n             color: rgba(255, 255, 255, 0.7);\n             opacity: 1;\n             text-decoration: none;\n         }\n         &.opt {\n           position: relative;\n           padding-left: 2.25em;\n         }\n\n         span.check-mark {\n           display: none;\n         }\n\n         span.text {\n           display: inline-block;\n         }\n       }\n\n       small {\n         padding-left: 0.5em;\n       }\n     }\n\n     .notify {\n       position: absolute;\n       bottom: 5px;\n       width: 96%;\n       margin: 0 2%;\n       min-height: 26px;\n       padding: 3px 5px;\n       background: rgb(245, 245, 245);\n       border: 1px solid rgb(227, 227, 227);\n       @include box-shadow(inset 0 1px 1px fade(rgb(0, 0, 0), 5));\n       pointer-events: none;\n       opacity: 0.9;\n       @include box-sizing(border-box);\n     }\n   }\n\n   .no-results {\n     padding: 3px;\n     background: #f5f5f5;\n     margin: 0 5px;\n     white-space: nowrap;\n   }\n\n   &.fit-width .dropdown-toggle {\n     .filter-option {\n       position: static;\n     }\n   }\n\n   &.show-tick .dropdown-menu li {\n     &.selected a span.check-mark {\n       position: absolute;\n       display: inline-block;\n       right: 15px;\n       margin-top: 5px;\n     }\n\n     a span.text {\n       margin-right: 34px;\n     }\n   }\n }\n\n .bootstrap-select.show-menu-arrow {\n   &.show > .dropdown-toggle {\n     z-index: ($zindex-select-dropdown + 1);\n   }\n\n   .dropdown-toggle {\n     &:before {\n       content: '';\n       border-left: 7px solid transparent;\n       border-right: 7px solid transparent;\n       border-bottom: 7px solid $color-grey-arrow;\n       position: absolute;\n       bottom: -4px;\n       left: 9px;\n       display: none;\n     }\n\n     &:after {\n       content: '';\n       border-left: 6px solid transparent;\n       border-right: 6px solid transparent;\n       border-bottom: 6px solid white;\n       position: absolute;\n       bottom: -4px;\n       left: 10px;\n       display: none;\n     }\n   }\n\n   &.dropup .dropdown-toggle {\n     &:before {\n       bottom: auto;\n       top: -3px;\n       border-top: 7px solid $color-grey-arrow;\n       border-bottom: 0;\n     }\n\n     &:after {\n       bottom: auto;\n       top: -3px;\n       border-top: 6px solid white;\n       border-bottom: 0;\n     }\n   }\n\n   &.pull-right .dropdown-toggle {\n     &:before {\n       right: 12px;\n       left: auto;\n     }\n\n     &:after {\n       right: 13px;\n       left: auto;\n     }\n   }\n\n   &.show > .dropdown-toggle {\n     &:before,\n     &:after {\n       display: block;\n     }\n   }\n }\n\n .bs-searchbox,\n .bs-actionsbox,\n .bs-donebutton {\n   padding: 4px 8px;\n }\n\n .bs-actionsbox {\n   width: 100%;\n   @include box-sizing(border-box);\n\n   & .btn-group button {\n     width: 50%;\n   }\n }\n\n .bs-donebutton {\n   float: left;\n   width: 100%;\n   @include box-sizing(border-box);\n\n   & .btn-group button {\n     width: 100%;\n   }\n }\n\n .bs-searchbox {\n   & + .bs-actionsbox {\n     padding: 0 8px 4px;\n   }\n\n   & .form-control {\n     margin-bottom: 0;\n     width: 100%;\n     float: none;\n   }\n }\n .bootstrap-select.show:before{\n     border-bottom: 11px solid #F1EAE0;\n     border-left: 11px solid transparent;\n     border-right: 11px solid transparent;\n     content: \"\";\n     display: inline-block;\n     position: absolute;\n     right: 15px;\n     top: 50px;\n\n }\n .bootstrap-select.show:after{\n     border-bottom: 11px solid #FFFCF5;\n     border-left: 11px solid transparent;\n     border-right: 11px solid transparent;\n     content: \"\";\n     display: inline-block;\n     position: absolute;\n     right: 15px;\n     top: 51px;\n }\n .bootstrap-select.dropup.show:before{\n     border-top: 11px solid #DCD9D1;\n     border-left: 11px solid transparent;\n     border-right: 11px solid transparent;\n     border-bottom: none;\n     right: 15px;\n     top: -11px;\n }\n .bootstrap-select.dropup.show:after{\n     border-top: 11px solid $white-color;\n     border-left: 11px solid transparent;\n     border-right: 11px solid transparent;\n     border-bottom: none;\n     right: 15px;\n     top: -12px;\n }\n\n\n .bootstrap-select{\n     .dropdown-menu{\n         .dropdown-menu{\n             @include transform-translate-y(0);\n\n             &:after,\n             &:before{\n                 display: none;\n             }\n         }\n     }\n     &.dropup{\n         .dropdown-menu.show{\n             @include transform-translate-y(-60px);\n         }\n     }\n }\n",".btn-file {\n  position: relative;\n  overflow: hidden;\n  vertical-align: middle;\n}\n.btn-file > input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  font-size: 23px;\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  opacity: 0;\n\n  direction: ltr;\n}\n.fileinput {\n  display: inline-block;\n  margin-bottom: 9px;\n}\n.fileinput .form-control {\n  display: inline-block;\n  padding-top: 7px;\n  padding-bottom: 5px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  cursor: text;\n}\n.fileinput .thumbnail {\n  display: inline-block;\n  margin-bottom: 10px;\n  overflow: hidden;\n  text-align: center;\n  vertical-align: middle;\n  max-width: 250px;\n  box-shadow: $box-shadow;\n\n  &.img-circle{\n      border-radius: 50%;\n      max-width: 100px;\n  }\n}\n.fileinput .thumbnail > img {\n  max-height: 100%;\n}\n.fileinput .btn {\n  vertical-align: middle;\n}\n.fileinput-exists .fileinput-new,\n.fileinput-new .fileinput-exists {\n  display: none;\n}\n.fileinput-inline .fileinput-controls {\n  display: inline;\n}\n.fileinput-filename {\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: middle;\n}\n.form-control .fileinput-filename {\n  vertical-align: bottom;\n}\n.fileinput.input-group {\n  display: table;\n}\n.fileinput.input-group > * {\n  position: relative;\n  z-index: 2;\n}\n.fileinput.input-group > .btn-file {\n  z-index: 1;\n}\n.fileinput-new.input-group .btn-file,\n.fileinput-new .input-group .btn-file {\n  border-radius: 0 4px 4px 0;\n}\n.fileinput-new.input-group .btn-file.btn-xs,\n.fileinput-new .input-group .btn-file.btn-xs,\n.fileinput-new.input-group .btn-file.btn-sm,\n.fileinput-new .input-group .btn-file.btn-sm {\n  border-radius: 0 3px 3px 0;\n}\n.fileinput-new.input-group .btn-file.btn-lg,\n.fileinput-new .input-group .btn-file.btn-lg {\n  border-radius: 0 6px 6px 0;\n}\n.form-group.has-warning .fileinput .fileinput-preview {\n  color: $brand-warning;\n}\n.form-group.has-warning .fileinput .thumbnail {\n  border-color: $brand-warning;\n}\n.form-group.has-error .fileinput .fileinput-preview {\n  color: $brand-danger;\n}\n.form-group.has-error .fileinput .thumbnail {\n  border-color: $brand-danger;\n}\n.form-group.has-success .fileinput .fileinput-preview {\n  color: $brand-success;\n}\n.form-group.has-success .fileinput .thumbnail {\n  border-color: $brand-success;\n}\n.input-group-addon:not(:first-child) {\n  border-left: 0;\n}\n.thumbnail{\n    border: 0 none;\n    border-radius: 3px;\n    padding: 0;\n}\n","//\n// bootstrap-tagsinput v0.8.0 for Bootstrap v4.0.0-alpha.6\n// --------------------------------------------------\n\n.bootstrap-tagsinput {\n  background-color: transparent;\n  display: inline-block;\n  padding: 4px 6px;\n  vertical-align: middle;\n  border-radius: 4px;\n  width: 100%;\n  line-height: 22px;\n  cursor: text;\n\n  & input {\n    border: none;\n    box-shadow: none;\n    outline: none;\n    background-color: transparent;\n    padding: 0 6px;\n    margin: 0;\n    width: auto;\n    max-width: inherit;\n\n    &:focus {\n      border: none;\n      box-shadow: none;\n    }\n\n    &::-moz-placeholder {\n      color: $input-color-placeholder;\n      opacity: 1;\n    }\n\n    &:-ms-input-placeholder {\n      color: $input-color-placeholder;\n    }\n\n    &::-webkit-input-placeholder {\n      color: $input-color-placeholder;\n    }\n  }\n\n  &.form-control {\n    & input::-moz-placeholder {\n      color: $input-color-placeholder;\n      // opacity: 1;\n    }\n\n    & input:-ms-input-placeholder {\n      color: $input-color-placeholder;\n    }\n\n    & input::-webkit-input-placeholder {\n      color: $input-color-placeholder;\n    }\n  }\n\n  .badge {\n    -webkit-transition: all 170ms linear;\n    -moz-transition: all 170ms linear;\n    -o-transition: all 170ms linear;\n    -ms-transition: all 170ms linear;\n    transition: all 170ms linear;\n  }\n\n  & .badge {\n    cursor: pointer;\n    margin: 5px 3px 5px 0;\n    position: relative;\n    padding: 4px 8px 3px 0.8em;\n    border-radius: 12px;\n    color: #fff;\n    font-size: 0.75em;\n    font-weight: 500;\n    display: inline-block;\n    line-height: 1.5em;\n    text-transform: uppercase;\n\n    &:hover {\n      padding-right: 25px;\n    }\n    &:hover [data-role=\"remove\"] {\n      opacity: 1;\n      padding-right: 6px;\n    }\n\n    & [data-role=\"remove\"] {\n      cursor: pointer;\n      position: absolute;\n      top: 3.5px;\n      right: 0;\n      opacity: 0;\n\n      &:after {\n        content: \"\\f00d\";\n        padding: 0px 4px;\n        font-size: 18px;\n        font: normal normal normal 10px/1 FontAwesome;\n      }\n      &:hover {\n        &:active {\n          box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n          opacity: 1;\n        }\n      }\n    }\n  }\n}\n.badge-success {\n  background-color: #7ac29a;\n}\n","/*\n * This combined file was created by the DataTables downloader builder:\n *   https://datatables.net/download\n *\n * To rebuild or modify this file with the latest versions of the included\n * software please visit:\n *   https://datatables.net/download/#bs4/dt-1.10.16/cr-1.4.1/fc-3.2.3/fh-3.1.3/r-2.2.0/rg-1.0.2/rr-1.2.3/sc-1.4.3/sl-1.2.3\n *\n * Included libraries:\n *   DataTables 1.10.16, ColReorder 1.4.1, FixedColumns 3.2.3, FixedHeader 3.1.3, Responsive 2.2.0, RowGroup 1.0.2, RowReorder 1.2.3, Scroller 1.4.3, Select 1.2.3\n */\n\n // DataTables.net actual Version 1.10.12\n table.dataTable {\n   clear: both;\n   margin-top: 6px !important;\n   margin-bottom: 6px !important;\n   max-width: none !important;\n   border-collapse: separate !important;\n }\n table.dataTable td,\n table.dataTable th {\n   -webkit-box-sizing: content-box;\n   -moz-box-sizing: content-box;\n   box-sizing: content-box;\n }\n table.dataTable td.dataTables_empty,\n table.dataTable th.dataTables_empty {\n   text-align: center;\n }\n table.dataTable.nowrap th,\n table.dataTable.nowrap td {\n   white-space: nowrap;\n }\n\n div.dataTables_wrapper div.dataTables_length label {\n   font-weight: normal;\n   text-align: left;\n   white-space: nowrap;\n }\n div.dataTables_wrapper div.dataTables_length select {\n   width: 75px;\n   display: inline-block;\n }\n div.dataTables_wrapper div.dataTables_filter {\n   text-align: right;\n }\n div.dataTables_wrapper div.dataTables_filter label {\n   font-weight: normal;\n   white-space: nowrap;\n   text-align: left;\n }\n div.dataTables_wrapper div.dataTables_filter input {\n   margin-left: 0.5em;\n   display: inline-block;\n   width: auto;\n }\n div.dataTables_wrapper div.dataTables_info {\n   padding-top: 8px;\n   white-space: nowrap;\n }\n div.dataTables_wrapper div.dataTables_paginate {\n   margin: 0;\n   white-space: nowrap;\n   text-align: right;\n }\n div.dataTables_wrapper div.dataTables_paginate ul.pagination {\n   margin: 2px 0;\n   white-space: nowrap;\n }\n div.dataTables_wrapper div.dataTables_processing {\n   position: absolute;\n   top: 50%;\n   left: 50%;\n   width: 200px;\n   margin-left: -100px;\n   margin-top: -26px;\n   text-align: center;\n   padding: 1em 0;\n }\n\n table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,\n table.dataTable thead > tr > td.sorting_asc,\n table.dataTable thead > tr > td.sorting_desc,\n table.dataTable thead > tr > td.sorting {\n   padding-right: 30px;\n }\n table.dataTable thead > tr > th:active,\n table.dataTable thead > tr > td:active {\n   outline: none;\n }\n table.dataTable thead .sorting,\n table.dataTable thead .sorting_asc,\n table.dataTable thead .sorting_desc,\n table.dataTable thead .sorting_asc_disabled,\n table.dataTable thead .sorting_desc_disabled {\n   cursor: pointer;\n   position: relative;\n }\n table.dataTable thead .sorting:after,\n table.dataTable thead .sorting_asc:after,\n table.dataTable thead .sorting_desc:after,\n table.dataTable thead .sorting_asc_disabled:after,\n table.dataTable thead .sorting_desc_disabled:after {\n   position: absolute;\n   bottom: 8px;\n   right: 8px;\n   display: block;\n   font-family: 'Glyphicons Halflings';\n   opacity: 0.5;\n }\n table.dataTable thead .sorting:after {\n   opacity: 0.2;\n   content: \"\\e150\";\n   /* sort */\n }\n table.dataTable thead .sorting_asc:after {\n   content: \"\\e155\";\n   /* sort-by-attributes */\n }\n table.dataTable thead .sorting_desc:after {\n   content: \"\\e156\";\n   /* sort-by-attributes-alt */\n }\n table.dataTable thead .sorting_asc_disabled:after,\n table.dataTable thead .sorting_desc_disabled:after {\n   color: #eee;\n }\n\n div.dataTables_scrollHead table.dataTable {\n   margin-bottom: 0 !important;\n }\n\n div.dataTables_scrollBody table {\n   border-top: none;\n   margin-top: 0 !important;\n   margin-bottom: 0 !important;\n }\n div.dataTables_scrollBody table thead .sorting:after,\n div.dataTables_scrollBody table thead .sorting_asc:after,\n div.dataTables_scrollBody table thead .sorting_desc:after {\n   display: none;\n }\n div.dataTables_scrollBody table tbody tr:first-child th,\n div.dataTables_scrollBody table tbody tr:first-child td {\n   border-top: none;\n }\n\n div.dataTables_scrollFoot table {\n   margin-top: 0 !important;\n   border-top: none;\n }\n\n @media screen and (max-width: 767px) {\n   div.dataTables_wrapper div.dataTables_length,\n   div.dataTables_wrapper div.dataTables_filter,\n   div.dataTables_wrapper div.dataTables_info,\n   div.dataTables_wrapper div.dataTables_paginate {\n     text-align: center;\n   }\n }\n table.dataTable.table-condensed > thead > tr > th {\n   padding-right: 20px;\n }\n table.dataTable.table-condensed .sorting:after,\n table.dataTable.table-condensed .sorting_asc:after,\n table.dataTable.table-condensed .sorting_desc:after {\n   top: 6px;\n   right: 6px;\n }\n\n table.table-bordered.dataTable th,\n table.table-bordered.dataTable td {\n   border-left-width: 0;\n }\n table.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,\n table.table-bordered.dataTable td:last-child,\n table.table-bordered.dataTable td:last-child {\n   border-right-width: 0;\n }\n table.table-bordered.dataTable tbody th,\n table.table-bordered.dataTable tbody td {\n   border-bottom-width: 0;\n }\n\n div.dataTables_scrollHead table.table-bordered {\n   border-bottom-width: 0;\n }\n\n div.table-responsive > div.dataTables_wrapper > div.row {\n   margin: 0;\n }\n div.table-responsive > div.dataTables_wrapper > div.row > div[class^=\"col-\"]:first-child {\n   padding-left: 0;\n }\n div.table-responsive > div.dataTables_wrapper > div.row > div[class^=\"col-\"]:last-child {\n   padding-right: 0;\n }\n\n\n table.dataTable{\n\n     thead{\n         .sorting,\n         .sorting_asc,\n         .sorting_desc,\n         .sorting_asc_disabled,\n         .sorting_desc_disabled{\n\n             &:after{\n                 position: relative;\n                 display: inline-block;\n                 bottom: 0px;\n                 right: -7px;\n                 font-family: 'FontAwesome';\n                 opacity: 0.8;\n             }\n\n         }\n\n         .disabled-sorting.sorting,\n         .disabled-sorting.sorting_asc,\n         .disabled-sorting.sorting_desc,\n         .disabled-sorting.sorting_asc_disabled,\n         .disabled-sorting.sorting_desc_disabled{\n                 &:after{\n                     display: none;\n                 }\n\n         }\n\n         .sorting{\n             &:after{\n                 opacity: 0.4;\n                 content: \"\\f0dc\";\n             }\n         }\n\n         .sorting_asc{\n             &:after{\n                 content: \"\\f0de\";\n                 top: 3px;\n             }\n         }\n\n         .sorting_desc{\n             &:after{\n                 content: \"\\f0dd\";\n                 top: -3px;\n             }\n         }\n     }\n\n     .table-hover > tbody > tr:hover {\n             background-color: darken($gray-input-bg, 5%);\n     }\n\n     .table{\n\n         > thead > tr > th,\n         > tbody > tr > th,\n         > tfoot > tr > th,\n         > thead > tr > td,\n         > tbody > tr > td,\n         > tfoot > tr > td{\n             padding: 8px !important;\n             outline: 0;\n         }\n     }\n\n     .btn.btn-icon{\n         margin: 0 3px;\n         padding: 5px 8px;\n     }\n\n }\n\n .dataTables_paginate{\n     a{\n             outline: 0;\n     }\n }\n\n table.dataTable.dtr-inline.collapsed {\n     > tbody > tr > td.child,\n     > tbody > tr > th.child,\n     > tbody > tr > td.dataTables_empty{\n         cursor: default !important;\n     }\n\n     > tbody > tr > td.child,\n     > tbody > tr > th.child,\n     > tbody > tr > td.dataTables_empty{\n         &:before{\n             display: none !important;\n         }\n     }\n\n     > tbody > tr > td:first-child,\n     > tbody > tr > th:first-child{\n         position: relative;\n         padding-left: 30px;\n         cursor: pointer;\n     }\n\n     > tbody > tr > td:first-child,\n     > tbody > tr > th:first-child{\n         &:before{\n             top: 50%;\n             margin-top: -9px;\n             left: 4px;\n             height: 18px;\n             width: 18px;\n             display: block;\n             position: absolute;\n             color: #518607;\n             border: 0px solid white;\n             border-radius: 14px;\n             box-shadow: 0 0 3px #444;\n             box-sizing: content-box;\n             text-align: center;\n             font-family: 'Courier New', Courier, monospace;\n             line-height: 18px;\n             content: '+';\n             background-color: #FFF;\n         }\n     }\n\n     > tbody > tr.parent > td:first-child,\n     > tbody > tr.parent > th:first-child{\n         &:before{\n             content: '-';\n             color: #ED362C;\n         }\n     }\n\n     > tbody > tr.child td{\n         &:before{\n             display: none;\n         }\n     }\n }\n\n\n table.dataTable.dtr-inline.collapsed.compact{\n     > tbody > tr > td,\n     > tbody > tr > th{\n         &:first-child{\n             padding-left: 27px;\n         }\n     }\n\n     > tbody > tr > td,\n     > tbody > tr > th{\n         &:first-child:before{\n             top: 5px;\n             left: 4px;\n             height: 14px;\n             width: 14px;\n             border-radius: 14px;\n             line-height: 14px;\n             text-indent: 3px;\n         }\n     }\n }\n\n table.dataTable.dtr-column{\n     > tbody > tr > td.control,\n     > tbody > tr > th.control{\n         position: relative;\n         cursor: pointer;\n     }\n\n     > tbody > tr > td.control,\n     > tbody > tr > th.control{\n         &:before{\n             top: 50%;\n             left: 50%;\n             height: 16px;\n             width: 16px;\n             margin-top: -10px;\n             margin-left: -10px;\n             display: block;\n             position: absolute;\n             color: white;\n             border: 2px solid white;\n             border-radius: 14px;\n             box-shadow: 0 0 3px #444;\n             box-sizing: content-box;\n             text-align: center;\n             font-family: 'Courier New', Courier, monospace;\n             line-height: 14px;\n             content: '+';\n             background-color: #31b131;\n         }\n     }\n\n     > tbody > tr.parent td.control,\n     > tbody > tr.parent th.control{\n         &:before{\n             content: '-';\n             background-color: #d33333;\n         }\n     }\n }\n\n table.dataTable{\n     > tbody > tr.child {\n         padding: 0.5em 1em;\n     }\n\n     > tbody > tr.child{\n         &:hover{\n             background: transparent !important;\n         }\n     }\n\n     > tbody > tr.child ul {\n         display: inline-block;\n         list-style-type: none;\n         margin: 0;\n         padding: 0;\n     }\n\n     > tbody > tr.child ul li {\n         border-bottom: 1px solid #efefef;\n         padding: 0.5em 0;\n     }\n\n     > tbody > tr.child ul li{\n         &:first-child{\n             padding-top: 0;\n         }\n     }\n\n     > tbody > tr.child ul li{\n         &:last-child{\n             border-bottom: none;\n         }\n     }\n\n     > tbody > tr.child span.dtr-title {\n         display: inline-block;\n         min-width: 75px;\n         font-weight: bold;\n     }\n }\n\n div.dtr-modal {\n     position: fixed;\n     box-sizing: border-box;\n     top: 0;\n     left: 0;\n     height: 100%;\n     width: 100%;\n     z-index: 100;\n     padding: 10em 1em;\n\n     div.dtr-modal-display {\n         position: absolute;\n         top: 0;\n         left: 0;\n         bottom: 0;\n         right: 0;\n         width: 50%;\n         height: 50%;\n         overflow: auto;\n         margin: auto;\n         z-index: 102;\n         overflow: auto;\n         background-color: #f5f5f7;\n         border: 1px solid black;\n         border-radius: 0.5em;\n         box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);\n     }\n\n     div.dtr-modal-content {\n         position: relative;\n         padding: 1em;\n     }\n\n     div.dtr-modal-close {\n         position: absolute;\n         top: 6px;\n         right: 6px;\n         width: 22px;\n         height: 22px;\n         border: 1px solid #eaeaea;\n         background-color: #f9f9f9;\n         text-align: center;\n         border-radius: 3px;\n         cursor: pointer;\n         z-index: 12;\n     }\n\n     div.dtr-modal-close{\n         &:hover{\n             background-color: #eaeaea;\n         }\n     }\n\n     div.dtr-modal-background {\n         position: fixed;\n         top: 0;\n         left: 0;\n         right: 0;\n         bottom: 0;\n         z-index: 101;\n         background: rgba(0, 0, 0, 0.6);\n     }\n }\n\n @media screen and (max-width: 767px) {\n     div.dtr-modal div.dtr-modal-display {\n         width: 95%;\n     }\n }\n","svg {\n    touch-action: none;\n}\n\n.jvectormap-container {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n    touch-action: none;\n}\n\n.jvectormap-tip {\n    position: absolute;\n    display: none;\n    border: solid 1px #CDCDCD;\n    border-radius: 3px;\n    background: #292929;\n    color: white;\n    font-family: sans-serif, Verdana;\n    font-size: smaller;\n    padding: 3px;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {\n    position: absolute;\n    left: 10px;\n    border-radius: 3px;\n    background: #292929;\n    padding: 3px;\n    color: white;\n    cursor: pointer;\n    line-height: 10px;\n    text-align: center;\n    box-sizing: content-box;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout {\n    width: 10px;\n    height: 10px;\n}\n\n.jvectormap-zoomin {\n    top: 10px;\n}\n\n.jvectormap-zoomout {\n    top: 30px;\n}\n\n.jvectormap-goback {\n    bottom: 10px;\n    z-index: 1000;\n    padding: 6px;\n}\n\n.jvectormap-spinner {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: center no-repeat url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n    font-weight: bold;\n    font-size: 14px;\n    text-align: center;\n}\n\n.jvectormap-legend-cnt {\n    position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n    bottom: 0;\n    right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n    top: 0;\n    right: 0;\n}\n\n.jvectormap-legend {\n    background: black;\n    color: white;\n    border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n    float: left;\n    margin: 0 10px 10px 0;\n    padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n    float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n    margin: 10px 10px 0 0;\n    padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n    width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n    height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n    height: 20px;\n    width: 20px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n    font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n    text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 20px;\n    padding-left: 3px;\n}\n","/*!\n * FullCalendar v3.1.0 Stylesheet\n * Docs & License: http://fullcalendar.io/\n * (c) 2016 Adam Shaw\n */\n\n.fc {\n\tdirection: ltr;\n\ttext-align: left;\n}\n\n.fc-rtl {\n\ttext-align: right;\n}\n\nbody .fc { /* extra precedence to overcome jqui */\n\tfont-size: 1em;\n}\n\n\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n\tborder-color: #ddd;\n}\n\n.fc-unthemed .fc-popover {\n\tbackground-color: $white-color;\n}\n\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-popover .fc-header {\n\tbackground: $light-gray;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n\tcolor: $link-disabled-color;\n}\n\n.fc-unthemed .fc-today {\n\tbackground: $smoke-bg;\n}\n\n.fc-highlight { /* when user is selecting cells */\n\tbackground: #bce8f1;\n\topacity: .3;\n\tfilter: alpha(opacity=30); /* for IE */\n}\n\n.fc-bgevent { /* default look for background events */\n\tbackground: rgb(143, 223, 130);\n\topacity: .3;\n\tfilter: alpha(opacity=30); /* for IE */\n}\n\n.fc-nonbusiness { /* default look for non-business-hours areas */\n\t/* will inherit .fc-bgevent's styles */\n\tbackground: #d7d7d7;\n}\n\n\n/* Icons (inline elements with styled text that mock arrow icons)\n--------------------------------------------------------------------------------------------------*/\n\n.fc-icon {\n\tdisplay: inline-block;\n\twidth: 1em;\n\theight: 1em;\n\tline-height: 1em;\n\tfont-size: 1em;\n\ttext-align: center;\n\toverflow: hidden;\n\tfont-family: \"Courier New\", Courier, monospace;\n\n\t/* don't allow browser text-selection */\n\t-webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\t}\n\n/*\nAcceptable font-family overrides for individual icons:\n\t\"Arial\", sans-serif\n\t\"Times New Roman\", serif\n\nNOTE: use percentage font sizes or else old IE chokes\n*/\n\n.fc-icon:after {\n\tposition: relative;\n\tmargin: 0 -1em; /* ensures character will be centered, regardless of width */\n}\n\n.fc-icon-left-single-arrow:after {\n\tcontent: \"\\02039\";\n\tfont-weight: bold;\n\tfont-size: 200%;\n\ttop: -7%;\n\tleft: 3%;\n}\n\n.fc-icon-right-single-arrow:after {\n\tcontent: \"\\0203A\";\n\tfont-weight: bold;\n\tfont-size: 200%;\n\ttop: -7%;\n\tleft: -3%;\n}\n\n.fc-icon-left-double-arrow:after {\n\tcontent: \"\\000AB\";\n\tfont-size: 160%;\n\ttop: -7%;\n}\n\n.fc-icon-right-double-arrow:after {\n\tcontent: \"\\000BB\";\n\tfont-size: 160%;\n\ttop: -7%;\n}\n\n.fc-icon-left-triangle:after {\n\tcontent: \"\\25C4\";\n\tfont-size: 125%;\n\ttop: 3%;\n\tleft: -2%;\n}\n\n.fc-icon-right-triangle:after {\n\tcontent: \"\\25BA\";\n\tfont-size: 125%;\n\ttop: 3%;\n\tleft: 2%;\n}\n\n.fc-icon-down-triangle:after {\n\tcontent: \"\\25BC\";\n\tfont-size: 125%;\n\ttop: 2%;\n}\n\n.fc-icon-x:after {\n\tcontent: \"\\000D7\";\n\tfont-size: 200%;\n\ttop: 6%;\n}\n\n\n/* Buttons (styled <button> tags, normalized to work cross-browser)\n--------------------------------------------------------------------------------------------------*/\n\n.fc button {\n\tborder-radius: $border-radius-btn-base;\n    box-sizing: border-box;\n    border-width: $border-thick;\n    background-color: $transparent-bg;\n    font-size: $font-size-xs;\n    font-weight: $font-weight-semi;\n\n    padding: $padding-base-vertical $padding-base-horizontal;\n\n    @include btn-styles($default-color, $default-states-color);\n    @include transition($fast-transition-time, linear);\n\n    &:hover,\n    &:focus{\n        outline: 0 !important;\n    }\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle {\n         @include box-shadow(none);\n         outline: 0 !important;\n    }\n\n    &.btn-icon{\n        border-radius: 25px;\n        padding: 6px 10px;\n        i{\n          margin-right: 0px;\n        }\n\n    }\n\n}\n\n/* Firefox has an annoying inner border */\n.fc button::-moz-focus-inner { margin: 0; padding: 0; }\n\n.fc-state-default { /* non-theme */\n\tborder: 1px solid;\n}\n\n//.fc-state-default.fc-corner-left { /* non-theme */\n//\tborder-top-left-radius: 4px;\n//\tborder-bottom-left-radius: 4px;\n//}\n\n//.fc-state-default.fc-corner-right { /* non-theme */\n//\tborder-top-right-radius: 4px;\n//\tborder-bottom-right-radius: 4px;\n//}\n\n/* icons in buttons */\n\n.fc button .fc-icon { /* non-theme */\n\tposition: relative;\n\ttop: -0.05em; /* seems to be a good adjustment across browsers */\n\tmargin: 0 .2em;\n\tvertical-align: middle;\n}\n\n/*\n  button states\n  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)\n*/\n\n.fc-state-hover,\n.fc-state-active,\n.fc-state-disabled {\n\tcolor: $black-color;\n\tbackground-color: #e6e6e6;\n}\n\n.fc button[disabled],\n.fc button[disabled]:focus,\n.fc button[disabled]:hover{\n    background-color: $light-gray;\n    border-color: $light-gray;\n    cursor: default;\n\t@include opacity(.65);\n\tcolor: $font-color;\n}\n\n.fc-state-hover {\n\tbackground-color: $smoke-bg;\n}\n\n.fc .fc-state-active,\n.fc .fc-state-active:focus,\n.fc .fc-state-active:hover,\n.fc .fc-state-active:active:focus,\n.fc .fc-state-active:active:hover,\n.fc .fc-state-active:active {\n\tbackground-color: $default-color;\n    color: $white-color;\n}\n\n\n\n/* Buttons Groups\n--------------------------------------------------------------------------------------------------*/\n\n.fc-button-group {\n\tdisplay: inline-block;\n}\n\n/*\nevery button that is not first in a button group should scootch over one pixel and cover the\nprevious button's border...\n*/\n\n.fc .fc-button-group > * { /* extra precedence b/c buttons have margin set to zero */\n\tfloat: left;\n\tmargin: 0 2px 0 0;\n}\n\n.fc .fc-button-group > :first-child { /* same */\n\tmargin-left: 0;\n}\n\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n\n.fc-popover {\n\tposition: absolute;\n\t@include box-shadow($dropdown-shadow);\n}\n\n.fc-popover .fc-header { /* TODO: be more consistent with fc-head/fc-body */\n\tpadding: 2px 4px;\n}\n\n.fc-popover .fc-header .fc-title {\n\tmargin: 0 2px;\n}\n\n.fc-popover .fc-header .fc-close {\n\tcursor: pointer;\n}\n\n.fc-ltr .fc-popover .fc-header .fc-title,\n.fc-rtl .fc-popover .fc-header .fc-close {\n\tfloat: left;\n}\n\n.fc-rtl .fc-popover .fc-header .fc-title,\n.fc-ltr .fc-popover .fc-header .fc-close {\n\tfloat: right;\n}\n\n/* unthemed */\n\n.fc-unthemed .fc-popover {\n\tborder-width: 1px;\n\tborder-style: solid;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n\tfont-size: .9em;\n\tmargin-top: 2px;\n}\n\n/* jqui themed */\n\n.fc-popover > .ui-widget-header + .ui-widget-content {\n\tborder-top: 0; /* where they meet, let the header have the border */\n}\n\n\n/* Misc Reusable Components\n--------------------------------------------------------------------------------------------------*/\n\n.fc-divider {\n\tborder-style: solid;\n\tborder-width: 1px;\n}\n\nhr.fc-divider {\n\theight: 0;\n\tmargin: 0;\n\tpadding: 0 0 2px; /* height is unreliable across browsers, so use padding */\n\tborder-width: 1px 0;\n}\n\n.fc-clear {\n\tclear: both;\n}\n\n.fc-bg,\n.fc-bgevent-skeleton,\n.fc-highlight-skeleton,\n.fc-helper-skeleton {\n\t/* these element should always cling to top-left/right corners */\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.fc-bg {\n\tbottom: 0; /* strech bg to bottom edge */\n}\n\n.fc-bg table {\n\theight: 100%; /* strech bg to bottom edge */\n}\n\n\n/* Tables\n--------------------------------------------------------------------------------------------------*/\n\n.fc table {\n\twidth: 100%;\n\ttable-layout: fixed;\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n\tfont-size: 1em; /* normalize cross-browser */\n}\n\n.fc th {\n\ttext-align: right;\n    border-bottom-width: 1px;\n    font-size: $font-size-h6;\n    text-transform: uppercase;\n    color: $dark-gray;\n    font-weight: $font-weight-normal;\n    padding-bottom: 3px;\n}\n\n.fc td {\n\tborder-style: solid;\n\tborder-width: 1px;\n\tpadding: 0;\n\tvertical-align: top;\n}\n\n.fc td.fc-today {\n\tborder-style: double; /* overcome neighboring borders */\n}\n\n.fc .fc-widget-header{\n    border: 0;\n}\n\n.fc .fc-head .fc-widget-header{\n    margin-top: $margin-base-vertical;\n}\n/* Fake Table Rows\n--------------------------------------------------------------------------------------------------*/\n\n.fc .fc-row { /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */\n\t/* no visible border by default. but make available if need be (scrollbar width compensation) */\n\tborder-style: solid;\n\tborder-width: 0;\n}\n\n.fc-row table {\n\t/* don't put left/right border on anything within a fake row.\n\t   the outer tbody will worry about this */\n\tborder-left: 0 hidden transparent;\n\tborder-right: 0 hidden transparent;\n\n\t/* no bottom borders on rows */\n\tborder-bottom: 0 hidden transparent;\n}\n\n.fc-row:first-child table {\n\tborder-top: 0 hidden transparent; /* no top border on first row */\n}\n\n\n/* Day Row (used within the header and the DayGrid)\n--------------------------------------------------------------------------------------------------*/\n\n.fc-row {\n\tposition: relative;\n}\n\n.fc-row .fc-bg {\n\tz-index: 1;\n}\n\n/* highlighting cells & background event skeleton */\n\n.fc-row .fc-bgevent-skeleton,\n.fc-row .fc-highlight-skeleton {\n\tbottom: 0; /* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-bgevent-skeleton table,\n.fc-row .fc-highlight-skeleton table {\n\theight: 100%; /* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-highlight-skeleton td,\n.fc-row .fc-bgevent-skeleton td {\n\tborder-color: transparent;\n}\n\n.fc-row .fc-bgevent-skeleton {\n\tz-index: 2;\n\n}\n\n.fc-row .fc-highlight-skeleton {\n\tz-index: 3;\n}\n\n/*\nrow content (which contains day/week numbers and events) as well as \"helper\" (which contains\ntemporary rendered events).\n*/\n\n.fc-row .fc-content-skeleton {\n\tposition: relative;\n\tz-index: 4;\n\tpadding-bottom: 2px; /* matches the space above the events */\n}\n\n.fc-row .fc-helper-skeleton {\n\tz-index: 5;\n}\n\n.fc-row .fc-content-skeleton td,\n.fc-row .fc-helper-skeleton td {\n\t/* see-through to the background below */\n\tbackground: none; /* in case <td>s are globally styled */\n\tborder-color: transparent;\n\n\t/* don't put a border between events and/or the day number */\n\tborder-bottom: 0;\n}\n\n.fc-row .fc-content-skeleton tbody td, /* cells with events inside (so NOT the day number cell) */\n.fc-row .fc-helper-skeleton tbody td {\n\t/* don't put a border between event cells */\n\tborder-top: 0;\n}\n\n\n/* Scrolling Container\n--------------------------------------------------------------------------------------------------*/\n\n.fc-scroller { /* this class goes on elements for guaranteed vertical scrollbars */\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n}\n\n.fc-scroller > * { /* we expect an immediate inner element */\n\tposition: relative; /* re-scope all positions */\n\twidth: 100%; /* hack to force re-sizing this inner element when scrollbars appear/disappear */\n\toverflow: hidden; /* don't let negative margins or absolute positioning create further scroll */\n}\n\n\n/* Global Event Styles\n--------------------------------------------------------------------------------------------------*/\n\n.fc-event {\n\tposition: relative; /* for resize handle and other inner positioning */\n\tdisplay: block; /* make the <a> tag block */\n\tfont-size: .85em;\n\tline-height: 1.3;\n\tborder-radius: 2px;\n\tbackground-color: $light-blue; /* default BACKGROUND color */\n\tfont-weight: normal; /* undo jqui's ui-widget-header bold */\n\n    &.event-azure{\n        background-color: $light-azure;\n    }\n    &.event-green{\n        background-color: $light-green;\n    }\n    &.event-orange{\n        background-color: $light-orange;\n    }\n    &.event-red{\n        background-color: $light-red;\n    }\n}\n\n/* overpower some of bootstrap's and jqui's styles on <a> tags */\n.fc-event,\n.fc-event:hover,\n.ui-widget .fc-event {\n\tcolor: $black-color; /* default TEXT color */\n\ttext-decoration: none; /* if <a> has an href */\n}\n\n.fc-event[href],\n.fc-event.fc-draggable {\n\tcursor: pointer; /* give events with links and draggable events a hand mouse pointer */\n}\n\n.fc-not-allowed, /* causes a \"warning\" cursor. applied on body */\n.fc-not-allowed .fc-event { /* to override an event's custom cursor */\n\tcursor: not-allowed;\n}\n\n.fc-event .fc-bg { /* the generic .fc-bg already does position */\n\tz-index: 1;\n\tbackground: $white-color;\n\topacity: .25;\n\tfilter: alpha(opacity=25); /* for IE */\n}\n\n.fc-event .fc-content {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fc-event .fc-resizer {\n\tposition: absolute;\n\tz-index: 3;\n}\n\n\n/* Horizontal Events\n--------------------------------------------------------------------------------------------------*/\n\n/* events that are continuing to/from another week. kill rounded corners and butt up against edge */\n\n.fc-ltr .fc-h-event.fc-not-start,\n.fc-rtl .fc-h-event.fc-not-end {\n\tmargin-left: 0;\n\tborder-left-width: 0;\n\tpadding-left: 1px; /* replace the border with padding */\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.fc-ltr .fc-h-event.fc-not-end,\n.fc-rtl .fc-h-event.fc-not-start {\n\tmargin-right: 0;\n\tborder-right-width: 0;\n\tpadding-right: 1px; /* replace the border with padding */\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n/* resizer */\n\n.fc-h-event .fc-resizer { /* positioned it to overcome the event's borders */\n\ttop: -1px;\n\tbottom: -1px;\n\tleft: -1px;\n\tright: -1px;\n\twidth: 5px;\n}\n\n/* left resizer  */\n.fc-ltr .fc-h-event .fc-start-resizer,\n.fc-ltr .fc-h-event .fc-start-resizer:before,\n.fc-ltr .fc-h-event .fc-start-resizer:after,\n.fc-rtl .fc-h-event .fc-end-resizer,\n.fc-rtl .fc-h-event .fc-end-resizer:before,\n.fc-rtl .fc-h-event .fc-end-resizer:after {\n\tright: auto; /* ignore the right and only use the left */\n\tcursor: w-resize;\n}\n\n/* right resizer */\n.fc-ltr .fc-h-event .fc-end-resizer,\n.fc-ltr .fc-h-event .fc-end-resizer:before,\n.fc-ltr .fc-h-event .fc-end-resizer:after,\n.fc-rtl .fc-h-event .fc-start-resizer,\n.fc-rtl .fc-h-event .fc-start-resizer:before,\n.fc-rtl .fc-h-event .fc-start-resizer:after {\n\tleft: auto; /* ignore the left and only use the right */\n\tcursor: e-resize;\n}\n\n\n/* DayGrid events\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-day-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n\n.fc-day-grid-event {\n\tmargin: 2px 5px 0; /* spacing between events and edges */\n\tpadding: 1px 2px;\n}\n\n\n.fc-day-grid-event .fc-content { /* force events to be one-line tall */\n\twhite-space: nowrap;\n\toverflow: hidden;\n}\n\n.fc-day-grid-event .fc-time {\n\tfont-weight: bold;\n}\n\n.fc-day-grid-event .fc-resizer { /* enlarge the default hit area */\n\tleft: -3px;\n\tright: -3px;\n\twidth: 7px;\n}\n\n\n/* Event Limiting\n--------------------------------------------------------------------------------------------------*/\n\n/* \"more\" link that represents hidden events */\n\na.fc-more {\n\tmargin: 1px 3px;\n\tfont-size: .85em;\n\tcursor: pointer;\n\ttext-decoration: none;\n}\n\na.fc-more:hover {\n\ttext-decoration: underline;\n}\n\n.fc-limited { /* rows and cells that are hidden because of a \"more\" link */\n\tdisplay: none;\n}\n\n/* popover that appears when \"more\" link is clicked */\n\n.fc-day-grid .fc-row {\n\tz-index: 1; /* make the \"more\" popover one higher than this */\n}\n\n.fc-more-popover {\n\tz-index: 2;\n\twidth: 220px;\n}\n\n.fc-more-popover .fc-event-container {\n\tpadding: 10px;\n}\n\n/* Toolbar\n--------------------------------------------------------------------------------------------------*/\n\n.fc-toolbar {\n\ttext-align: center;\n\tmargin-bottom: 1em;\n}\n\n.fc-toolbar .fc-left {\n\tfloat: left;\n\tmin-width: 260px;\n}\n\n.fc-toolbar .fc-right {\n\tfloat: right;\n}\n\n.fc-toolbar .fc-center {\n\tdisplay: inline-block;\n}\n\n/* the things within each left/right/center section */\n.fc .fc-toolbar > * > * { /* extra precedence to override button border margins */\n\tfloat: left;\n\tmargin-left: .75em;\n}\n\n/* the first thing within each left/center/right section */\n.fc .fc-toolbar > * > :first-child { /* extra precedence to override button border margins */\n\tmargin-left: 0;\n}\n\n/* title text */\n\n.fc-toolbar h2 {\n\tmargin: 0;\n}\n\n/* button layering (for border precedence) */\n\n.fc-toolbar button {\n\tposition: relative;\n}\n\n.fc-toolbar .fc-state-hover,\n.fc-toolbar .ui-state-hover {\n\tz-index: 2;\n}\n\n.fc-toolbar .fc-state-down {\n\tz-index: 3;\n}\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active {\n\tz-index: 4;\n}\n\n.fc-toolbar button:focus {\n\tz-index: 5;\n}\n\n\n/* View Structure\n--------------------------------------------------------------------------------------------------*/\n\n/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */\n/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */\n.fc-view-container *,\n.fc-view-container *:before,\n.fc-view-container *:after {\n\t-webkit-box-sizing: content-box;\n\t   -moz-box-sizing: content-box;\n\t        box-sizing: content-box;\n}\n\n.fc-view, /* scope positioning and z-index's for everything within the view */\n.fc-view > table { /* so dragged elements can be above the view's main element */\n\tposition: relative;\n\tz-index: 1;\n}\n\n/* BasicView\n--------------------------------------------------------------------------------------------------*/\n\n/* day row structure */\n\n.fc-basicWeek-view .fc-content-skeleton,\n.fc-basicDay-view .fc-content-skeleton {\n\t/* we are sure there are no day numbers in these views, so... */\n\tpadding-top: 1px; /* add a pixel to make sure there are 2px padding above events */\n\tpadding-bottom: 1em; /* ensure a space at bottom of cell for user selecting/clicking */\n}\n\n.fc-basic-view .fc-body .fc-row {\n\tmin-height: 4em; /* ensure that all rows are at least this tall */\n}\n\n/* a \"rigid\" row will take up a constant amount of height because content-skeleton is absolute */\n\n.fc-row.fc-rigid {\n\toverflow: hidden;\n}\n\n.fc-row.fc-rigid .fc-content-skeleton {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n/* week and day number styling */\n\n.fc-basic-view .fc-week-number,\n.fc-basic-view .fc-day-number {\n\tpadding: 0 2px;\n}\n\n.fc-basic-view td.fc-week-number span,\n.fc-basic-view td.fc-day-number {\n\tpadding: 8px;\n}\n\n.fc-basic-view .fc-week-number {\n\ttext-align: center;\n}\n\n.fc-basic-view .fc-week-number span {\n\t/* work around the way we do column resizing and ensure a minimum width */\n\tdisplay: inline-block;\n\tmin-width: 1.25em;\n}\n\n.fc-ltr .fc-basic-view .fc-day-number {\n\ttext-align: right;\n}\n\n.fc-rtl .fc-basic-view .fc-day-number {\n\ttext-align: left;\n}\n\n.fc-day-number.fc-other-month {\n\topacity: 0.3;\n\tfilter: alpha(opacity=30); /* for IE */\n\t/* opacity with small font can sometimes look too faded\n\t   might want to set the 'color' property instead\n\t   making day-numbers bold also fixes the problem */\n}\n\n/* AgendaView all-day area\n--------------------------------------------------------------------------------------------------*/\n\n.fc-agenda-view .fc-day-grid {\n\tposition: relative;\n\tz-index: 2; /* so the \"more..\" popover will be over the time grid */\n}\n\n.fc-agenda-view .fc-day-grid .fc-row {\n\tmin-height: 3em; /* all-day section will never get shorter than this */\n}\n\n.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {\n\tpadding-top: 1px; /* add a pixel to make sure there are 2px padding above events */\n\tpadding-bottom: 1em; /* give space underneath events for clicking/selecting days */\n}\n\n\n/* TimeGrid axis running down the side (for both the all-day area and the slot area)\n--------------------------------------------------------------------------------------------------*/\n\n.fc .fc-axis { /* .fc to overcome default cell styles */\n\tvertical-align: middle;\n\tpadding: 0 4px;\n\twhite-space: nowrap;\n}\n\n.fc-ltr .fc-axis {\n\ttext-align: right;\n}\n\n.fc-rtl .fc-axis {\n\ttext-align: left;\n}\n\n.ui-widget td.fc-axis {\n\tfont-weight: normal; /* overcome jqui theme making it bold */\n}\n\n\n/* TimeGrid Structure\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid-container, /* so scroll container's z-index is below all-day */\n.fc-time-grid { /* so slats/bg/content/etc positions get scoped within here */\n\tposition: relative;\n\tz-index: 1;\n}\n\n.fc-time-grid {\n\tmin-height: 100%; /* so if height setting is 'auto', .fc-bg stretches to fill height */\n}\n\n.fc-time-grid table { /* don't put outer borders on slats/bg/content/etc */\n\tborder: 0 hidden transparent;\n}\n\n.fc-time-grid > .fc-bg {\n\tz-index: 1;\n}\n\n.fc-time-grid .fc-slats,\n.fc-time-grid > hr { /* the <hr> AgendaView injects when grid is shorter than scroller */\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fc-time-grid .fc-bgevent-skeleton,\n.fc-time-grid .fc-content-skeleton {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.fc-time-grid .fc-bgevent-skeleton {\n\tz-index: 3;\n}\n\n.fc-time-grid .fc-highlight-skeleton {\n\tz-index: 4;\n}\n\n.fc-time-grid .fc-content-skeleton {\n\tz-index: 5;\n}\n\n.fc-time-grid .fc-helper-skeleton {\n\tz-index: 6;\n}\n\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid .fc-slats td {\n\theight: 1.5em;\n\tborder-bottom: 0; /* each cell is responsible for its top border */\n}\n\n.fc-time-grid .fc-slats .fc-minor td {\n\tborder-top-style: dotted;\n}\n\n.fc-time-grid .fc-slats .ui-widget-content { /* for jqui theme */\n\tbackground: none; /* see through to fc-bg */\n}\n\n\n/* TimeGrid Highlighting Slots\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid .fc-highlight-container { /* a div within a cell within the fc-highlight-skeleton */\n\tposition: relative; /* scopes the left/right of the fc-highlight to be in the column */\n}\n\n.fc-time-grid .fc-highlight {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\t/* top and bottom will be in by JS */\n}\n\n\n/* TimeGrid Event Containment\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid .fc-event-container, /* a div within a cell within the fc-content-skeleton */\n.fc-time-grid .fc-bgevent-container { /* a div within a cell within the fc-bgevent-skeleton */\n\tposition: relative;\n}\n\n.fc-ltr .fc-time-grid .fc-event-container { /* space on the sides of events for LTR (default) */\n\tmargin: 0 2.5% 0 2px;\n}\n\n.fc-rtl .fc-time-grid .fc-event-container { /* space on the sides of events for RTL */\n\tmargin: 0 2px 0 2.5%;\n}\n\n.fc-time-grid .fc-event,\n.fc-time-grid .fc-bgevent {\n\tposition: absolute;\n\tz-index: 1; /* scope inner z-index's */\n}\n\n.fc-time-grid .fc-bgevent {\n\t/* background events always span full width */\n\tleft: 0;\n\tright: 0;\n}\n\n\n/* Generic Vertical Event\n--------------------------------------------------------------------------------------------------*/\n\n.fc-v-event.fc-not-start { /* events that are continuing from another day */\n\t/* replace space made by the top border with padding */\n\tborder-top-width: 0;\n\tpadding-top: 1px;\n\n\t/* remove top rounded corners */\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n.fc-v-event.fc-not-end {\n\t/* replace space made by the top border with padding */\n\tborder-bottom-width: 0;\n\tpadding-bottom: 1px;\n\n\t/* remove bottom rounded corners */\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n\n/* TimeGrid Event Styling\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-time-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n\n.fc-time-grid-event {\n\toverflow: hidden; /* don't let the bg flow over rounded corners */\n}\n\n.fc-time-grid-event .fc-time,\n.fc-time-grid-event .fc-title {\n\tpadding: 0 1px;\n}\n\n.fc-time-grid-event .fc-time {\n\tfont-size: .85em;\n\twhite-space: nowrap;\n}\n\n/* short mode, where time and title are on the same line */\n\n.fc-time-grid-event.fc-short .fc-content {\n\t/* don't wrap to second line (now that contents will be inline) */\n\twhite-space: nowrap;\n}\n\n.fc-time-grid-event.fc-short .fc-time,\n.fc-time-grid-event.fc-short .fc-title {\n\t/* put the time and title on the same line */\n\tdisplay: inline-block;\n\tvertical-align: top;\n}\n\n.fc-time-grid-event.fc-short .fc-time span {\n\tdisplay: none; /* don't display the full time text... */\n}\n\n.fc-time-grid-event.fc-short .fc-time:before {\n\tcontent: attr(data-start); /* ...instead, display only the start time */\n}\n\n.fc-time-grid-event.fc-short .fc-time:after {\n\tcontent: \"\\000A0-\\000A0\"; /* seperate with a dash, wrapped in nbsp's */\n}\n\n.fc-time-grid-event.fc-short .fc-title {\n\tfont-size: .85em; /* make the title text the same size as the time */\n\tpadding: 0; /* undo padding from above */\n}\n\n/* resizer */\n\n.fc-time-grid-event .fc-resizer {\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\theight: 8px;\n\toverflow: hidden;\n\tline-height: 8px;\n\tfont-size: 11px;\n\tfont-family: monospace;\n\ttext-align: center;\n\tcursor: s-resize;\n}\n\n.fc-time-grid-event .fc-resizer:after {\n\tcontent: \"=\";\n}\n\n.card-calendar{\n    .content{\n        padding: 0 !important;\n    }\n    .fc-toolbar{\n        padding-top: $padding-dropdown-horizontal;\n        padding-left: $padding-dropdown-horizontal;\n        padding-right: $padding-dropdown-horizontal;\n    }\n    .fc td:first-child{\n        border-left: 0;\n    }\n    .fc td:last-child{\n        border-right: 0;\n    }\n    .fc-basic-view td:last-child.fc-week-number span,\n    .fc-basic-view td:last-child.fc-day-number{\n        padding-right: $padding-dropdown-horizontal;\n    }\n    .fc .fc-day-header:last-child{\n        padding-right: 15px;\n    }\n    .fc .fc-row:last-child td{\n        border-bottom: 0;\n    }\n    .fc .fc-body .fc-widget-content{\n        border-bottom: 0;\n    }\n}\n","// Mixin for generating new styles\n@mixin btn-styles($btn-color, $btn-states-color) {\n    background-color: $btn-color;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    &:active:focus,\n    &:active:hover,\n    &.active:focus,\n    &.active:hover,\n    .show > &.dropdown-toggle,\n    .show > &.dropdown-toggle:focus,\n    .show > &.dropdown-toggle:hover {\n        background-color: $btn-states-color !important;\n        color: $white-color !important;\n        box-shadow: none !important;\n    }\n\n    &:not([data-action]):hover{\n        box-shadow:  none;\n    }\n\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n        &,\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: $btn-color;\n            border-color: $btn-color;\n        }\n    }\n\n    // btn-neutral style\n    @if $btn-color == $white-color{\n        color: $primary-color;\n\n        &.btn-danger{\n            color: $danger-color;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $danger-states-color !important;\n            }\n        }\n\n        &.btn-info{\n            color: $info-color !important;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $info-states-color !important;\n            }\n        }\n\n        &.btn-warning{\n            color: $warning-color !important;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $warning-states-color !important;\n            }\n        }\n\n        &.btn-success{\n            color: $success-color !important;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $success-states-color !important;\n            }\n        }\n\n        &.btn-default{\n            color: $default-color !important;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:active:focus{\n                color: $default-states-color !important;\n            }\n        }\n\n        &.active,\n        &:active,\n        &:active:focus,\n        &:active:hover,\n        &.active:focus,\n        &.active:hover,\n        .show > &.dropdown-toggle,\n        .show > &.dropdown-toggle:focus,\n        .show > &.dropdown-toggle:hover {\n            background-color: $white-color !important;\n            color: $primary-states-color !important;\n            box-shadow: none !important;\n        }\n\n        &:hover,\n        &:focus{\n            color: $primary-states-color !important;\n\n            &:not(.nav-link){\n                box-shadow: none;\n            }\n\n        }\n\n    } @else {\n        color: $white-color;\n    }\n\n    &.btn-simple{\n        color: $btn-color;\n        border-color: $btn-color;\n\n        &:hover,\n        &:focus,\n        &:active{\n            background-color: $transparent-bg;\n            color: $btn-states-color;\n            border-color: $btn-states-color;\n            box-shadow: none;\n        }\n    }\n\n    &.btn-link{\n        color: $btn-color;\n\n        &:hover,\n        &:focus,\n        &:active,\n        &:active:focus {\n            background-color: $transparent-bg;\n            color: $btn-states-color;\n            text-decoration: none;\n            box-shadow: none;\n        }\n    }\n}\n\n@mixin btn-outline-styles($btn-color, $btn-states-color){\n    background: $transparent-bg;\n    border: 2px solid $btn-color !important;\n    color: $btn-color;\n    @include opacity(1);\n\n    &:hover,\n    &:focus,\n    &:active,\n    &:focus:active,\n    &.active,\n    .open > &.dropdown-toggle {\n      background-color: $btn-color !important;\n      color: $fill-font-color !important;\n      border-color: $btn-color !important;\n      .caret{\n          border-top-color: $fill-font-color !important;\n      }\n    }\n\n    .caret{\n        border-top-color: $white-color !important;\n    }\n\n    &.disabled,\n    &:disabled,\n    &[disabled],\n    fieldset[disabled] & {\n      &,\n      &:hover,\n      &:focus,\n      &.focus,\n      &:active,\n      &.active {\n        background-color: $transparent-bg !important;\n        border-color: $btn-color !important;\n      }\n    }\n}\n\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\n   font-size: $font-size;\n   border-radius: $border;\n   padding: $padding-vertical $padding-horizontal;\n\n   &.btn-simple{\n       padding: $padding-vertical - 1 $padding-horizontal - 1;\n   }\n\n}\n\n@mixin rotate-180(){\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n","// Opacity\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  // IE8 filter\n  $opacity-ie: ($opacity * 100);\n  filter: #{alpha(opacity=$opacity-ie)};\n}\n","/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n  font-family: 'nucleo-icons';\n  src: url('~assets/fonts/nucleo-icons.eot');\n  src: url('~assets/fonts/nucleo-icons.eot') format('embedded-opentype'), url('~assets/fonts/nucleo-icons.woff2') format('woff2'), url('~assets/fonts/nucleo-icons.woff') format('woff'), url('~assets/fonts/nucleo-icons.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n/*------------------------\n\tbase class definition\n-------------------------*/\n.nc-icon {\n  display: inline-block;\n  font: normal normal normal 14px/1 'nucleo-icons';\n  font-size: inherit;\n  speak: none;\n  text-transform: none;\n  /* Better Font Rendering */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n/*------------------------\n  change icon size\n-------------------------*/\n.nc-icon.lg {\n  font-size: 1.33333333em;\n  vertical-align: -16%;\n}\n.nc-icon.x2 {\n  font-size: 2em;\n}\n.nc-icon.x3 {\n  font-size: 3em;\n}\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n.nc-icon.square,\n.nc-icon.circle {\n  padding: 0.33333333em;\n  vertical-align: -16%;\n  background-color: #eee;\n}\n.nc-icon.circle {\n  border-radius: 50%;\n}\n/*------------------------\n  list icons\n-------------------------*/\n.nc-icon-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.nc-icon-ul > li {\n  position: relative;\n}\n.nc-icon-ul > li > .nc-icon {\n  position: absolute;\n  left: -1.57142857em;\n  top: 0.14285714em;\n  text-align: center;\n}\n.nc-icon-ul > li > .nc-icon.lg {\n  top: 0;\n  left: -1.35714286em;\n}\n.nc-icon-ul > li > .nc-icon.circle,\n.nc-icon-ul > li > .nc-icon.square {\n  top: -0.19047619em;\n  left: -1.9047619em;\n}\n/*------------------------\n  spinning icons\n-------------------------*/\n.nc-icon.spin {\n  -webkit-animation: nc-icon-spin 2s infinite linear;\n  -moz-animation: nc-icon-spin 2s infinite linear;\n  animation: nc-icon-spin 2s infinite linear;\n}\n@-webkit-keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@-moz-keyframes nc-icon-spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n.nc-icon.rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.nc-icon.rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.nc-icon.rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.nc-icon.flip-y {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n.nc-icon.flip-x {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n/*------------------------\n\tfont icons\n-------------------------*/\n\n.nc-air-baloon::before {\n    content: \"\\ea01\";\n}\n\n.nc-album-2::before {\n    content: \"\\ea02\";\n}\n\n.nc-alert-circle-i::before {\n    content: \"\\ea04\";\n}\n\n.nc-align-center::before {\n    content: \"\\ea03\";\n}\n\n.nc-align-left-2::before {\n    content: \"\\ea05\";\n}\n\n.nc-ambulance::before {\n    content: \"\\ea06\";\n}\n\n.nc-app::before {\n    content: \"\\ea07\";\n}\n\n.nc-atom::before {\n    content: \"\\ea08\";\n}\n\n.nc-badge::before {\n    content: \"\\ea09\";\n}\n\n.nc-bag-16::before {\n    content: \"\\ea0a\";\n}\n\n.nc-bank::before {\n    content: \"\\ea0b\";\n}\n\n.nc-basket::before {\n    content: \"\\ea0c\";\n}\n\n.nc-bell-55::before {\n    content: \"\\ea0d\";\n}\n\n.nc-bold::before {\n    content: \"\\ea0e\";\n}\n\n.nc-book-bookmark::before {\n    content: \"\\ea0f\";\n}\n\n.nc-bookmark-2::before {\n    content: \"\\ea10\";\n}\n\n.nc-box-2::before {\n    content: \"\\ea11\";\n}\n\n.nc-box::before {\n    content: \"\\ea12\";\n}\n\n.nc-briefcase-24::before {\n    content: \"\\ea13\";\n}\n\n.nc-bulb-63::before {\n    content: \"\\ea14\";\n}\n\n.nc-bullet-list-67::before {\n    content: \"\\ea15\";\n}\n\n.nc-bus-front-12::before {\n    content: \"\\ea16\";\n}\n\n.nc-button-pause::before {\n    content: \"\\ea17\";\n}\n\n.nc-button-play::before {\n    content: \"\\ea18\";\n}\n\n.nc-button-power::before {\n    content: \"\\ea19\";\n}\n\n.nc-calendar-60::before {\n    content: \"\\ea1a\";\n}\n\n.nc-camera-compact::before {\n    content: \"\\ea1b\";\n}\n\n.nc-caps-small::before {\n    content: \"\\ea1c\";\n}\n\n.nc-cart-simple::before {\n    content: \"\\ea1d\";\n}\n\n.nc-chart-bar-32::before {\n    content: \"\\ea1e\";\n}\n\n.nc-chart-pie-36::before {\n    content: \"\\ea1f\";\n}\n\n.nc-chat-33::before {\n    content: \"\\ea20\";\n}\n\n.nc-check-2::before {\n    content: \"\\ea21\";\n}\n\n.nc-circle-10::before {\n    content: \"\\ea22\";\n}\n\n.nc-cloud-download-93::before {\n    content: \"\\ea23\";\n}\n\n.nc-cloud-upload-94::before {\n    content: \"\\ea24\";\n}\n\n.nc-compass-05::before {\n    content: \"\\ea25\";\n}\n\n.nc-controller-modern::before {\n    content: \"\\ea26\";\n}\n\n.nc-credit-card::before {\n    content: \"\\ea27\";\n}\n\n.nc-delivery-fast::before {\n    content: \"\\ea28\";\n}\n\n.nc-diamond::before {\n    content: \"\\ea29\";\n}\n\n.nc-email-85::before {\n    content: \"\\ea2a\";\n}\n\n.nc-favourite-28::before {\n    content: \"\\ea2b\";\n}\n\n.nc-glasses-2::before {\n    content: \"\\ea2c\";\n}\n\n.nc-globe-2::before {\n    content: \"\\ea2d\";\n}\n\n.nc-globe::before {\n    content: \"\\ea2e\";\n}\n\n.nc-hat-3::before {\n    content: \"\\ea2f\";\n}\n\n.nc-headphones::before {\n    content: \"\\ea30\";\n}\n\n.nc-html5::before {\n    content: \"\\ea31\";\n}\n\n.nc-image::before {\n    content: \"\\ea32\";\n}\n\n.nc-istanbul::before {\n    content: \"\\ea33\";\n}\n\n.nc-key-25::before {\n    content: \"\\ea34\";\n}\n\n.nc-laptop::before {\n    content: \"\\ea35\";\n}\n\n.nc-layout-11::before {\n    content: \"\\ea36\";\n}\n\n.nc-lock-circle-open::before {\n    content: \"\\ea37\";\n}\n\n.nc-map-big::before {\n    content: \"\\ea38\";\n}\n\n.nc-minimal-down::before {\n    content: \"\\ea39\";\n}\n\n.nc-minimal-left::before {\n    content: \"\\ea3a\";\n}\n\n.nc-minimal-right::before {\n    content: \"\\ea3b\";\n}\n\n.nc-minimal-up::before {\n    content: \"\\ea3c\";\n}\n\n.nc-mobile::before {\n    content: \"\\ea3d\";\n}\n\n.nc-money-coins::before {\n    content: \"\\ea3e\";\n}\n\n.nc-note-03::before {\n    content: \"\\ea3f\";\n}\n\n.nc-palette::before {\n    content: \"\\ea40\";\n}\n\n.nc-paper::before {\n    content: \"\\ea41\";\n}\n\n.nc-pin-3::before {\n    content: \"\\ea42\";\n}\n\n.nc-planet::before {\n    content: \"\\ea43\";\n}\n\n.nc-refresh-69::before {\n    content: \"\\ea44\";\n}\n\n.nc-ruler-pencil::before {\n    content: \"\\ea45\";\n}\n\n.nc-satisfied::before {\n    content: \"\\ea46\";\n}\n\n.nc-scissors::before {\n    content: \"\\ea47\";\n}\n\n.nc-send::before {\n    content: \"\\ea48\";\n}\n\n.nc-settings-gear-65::before {\n    content: \"\\ea49\";\n}\n\n.nc-settings::before {\n    content: \"\\ea4a\";\n}\n\n.nc-share-66::before {\n    content: \"\\ea4b\";\n}\n\n.nc-shop::before {\n    content: \"\\ea4c\";\n}\n\n.nc-simple-add::before {\n    content: \"\\ea4d\";\n}\n\n.nc-simple-delete::before {\n    content: \"\\ea4e\";\n}\n\n.nc-simple-remove::before {\n    content: \"\\ea4f\";\n}\n\n.nc-single-02::before {\n    content: \"\\ea50\";\n}\n\n.nc-single-copy-04::before {\n    content: \"\\ea51\";\n}\n\n.nc-sound-wave::before {\n    content: \"\\ea52\";\n}\n\n.nc-spaceship::before {\n    content: \"\\ea53\";\n}\n\n.nc-sun-fog-29::before {\n    content: \"\\ea54\";\n}\n\n.nc-support-17::before {\n    content: \"\\ea55\";\n}\n\n.nc-tablet-2::before {\n    content: \"\\ea56\";\n}\n\n.nc-tag-content::before {\n    content: \"\\ea57\";\n}\n\n.nc-tap-01::before {\n    content: \"\\ea58\";\n}\n\n.nc-tie-bow::before {\n    content: \"\\ea59\";\n}\n\n.nc-tile-56::before {\n    content: \"\\ea5a\";\n}\n\n.nc-time-alarm::before {\n    content: \"\\ea5b\";\n}\n\n.nc-touch-id::before {\n    content: \"\\ea5c\";\n}\n\n.nc-trophy::before {\n    content: \"\\ea5d\";\n}\n\n.nc-tv-2::before {\n    content: \"\\ea5e\";\n}\n\n.nc-umbrella-13::before {\n    content: \"\\ea5f\";\n}\n\n.nc-user-run::before {\n    content: \"\\ea60\";\n}\n\n.nc-vector::before {\n    content: \"\\ea61\";\n}\n\n.nc-watch-time::before {\n    content: \"\\ea62\";\n}\n\n.nc-world-2::before {\n    content: \"\\ea63\";\n}\n\n.nc-zoom-split::before {\n    content: \"\\ea64\";\n}\n\n\n/* all icon font classes list here */\n",".btn,\n.navbar .navbar-nav > a.btn {\n  border-width: $border-thick;\n  font-weight: $font-weight-semi;\n  font-size: $font-size-small;\n  line-height: $line-height;\n  text-transform: uppercase;\n  border: none;\n  margin: 10px 1px;\n  border-radius: $border-radius-small;\n  padding: $padding-btn-vertical $padding-btn-horizontal;\n  cursor: pointer;\n\n  @include btn-styles($default-color, $default-states-color);\n  @include transition($fast-transition-time, linear);\n\n  &:hover,\n  &:focus {\n    @include opacity(1);\n    outline: 0 !important;\n  }\n  &:active,\n  &.active,\n  .open > &.dropdown-toggle {\n    @include box-shadow(none);\n    outline: 0 !important;\n  }\n\n  .badge {\n    margin: 0;\n  }\n\n  &.btn-icon {\n    // see above for color variations\n    height: $btn-icon-size-regular;\n    min-width: $btn-icon-size-regular;\n    width: $btn-icon-size-regular;\n    padding: 0;\n    font-size: $btn-icon-font-size-regular;\n    overflow: hidden;\n    position: relative;\n    line-height: normal;\n\n    &.btn-simple {\n      padding: 0;\n    }\n\n    &.btn-sm {\n      height: $btn-icon-size-small;\n      min-width: $btn-icon-size-small;\n      width: $btn-icon-size-small;\n\n      .fa,\n      .far,\n      .fas,\n      .nc-icon {\n        font-size: $btn-icon-font-size-small;\n      }\n    }\n\n    &.btn-lg {\n      height: $btn-icon-size-lg;\n      min-width: $btn-icon-size-lg;\n      width: $btn-icon-size-lg;\n\n      .fa,\n      .far,\n      .fas,\n      .nc-icon {\n        font-size: $btn-icon-font-size-lg;\n      }\n    }\n\n    &:not(.btn-footer) .nc-icon,\n    &:not(.btn-footer) .fa,\n    &:not(.btn-footer) .far,\n    &:not(.btn-footer) .fas {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-12px, -12px);\n      line-height: 1.5626rem;\n      width: 24px;\n    }\n\n    &.btn-neutral {\n      font-size: 20px;\n    }\n  }\n\n  &:not(.btn-icon) .nc-icon {\n    position: relative;\n    top: 1px;\n  }\n}\n\n// Apply the mixin to the buttons\n// .btn-default { @include btn-styles($default-color, $default-states-color); }\n.btn-primary {\n  @include btn-styles($primary-color, $primary-states-color);\n}\n.btn-success {\n  @include btn-styles($success-color, $success-states-color);\n}\n.btn-info {\n  @include btn-styles($info-color, $info-states-color);\n}\n.btn-warning {\n  @include btn-styles($warning-color, $warning-states-color);\n}\n.btn-danger {\n  @include btn-styles($danger-color, $danger-states-color);\n}\n// .btn-neutral { @include btn-styles($white-color, $white-color); }\n\n.btn-outline-default {\n  @include btn-outline-styles($default-color, $default-states-color);\n}\n.btn-outline-primary {\n  @include btn-outline-styles($primary-color, $primary-states-color);\n}\n.btn-outline-success {\n  @include btn-outline-styles($success-color, $success-states-color);\n}\n.btn-outline-info {\n  @include btn-outline-styles($info-color, $info-states-color);\n}\n.btn-outline-warning {\n  @include btn-outline-styles($warning-color, $warning-states-color);\n}\n.btn-outline-danger {\n  @include btn-outline-styles($danger-color, $danger-states-color);\n}\n.btn-outline-neutral {\n  @include btn-outline-styles($white-color, $default-states-color);\n  &:hover,\n  &:focus {\n    color: $default-states-color;\n    background-color: $white-color;\n  }\n}\n.btn-neutral {\n  @include btn-styles($white-color, $white-color);\n  color: $default-color;\n  &:hover,\n  &:focus {\n    color: $default-states-color;\n  }\n\n  &.btn-border {\n    &:hover,\n    &:focus {\n      color: $default-color;\n    }\n\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle {\n      background-color: $white-color;\n      color: $default-color;\n    }\n  }\n\n  &.btn-link:active,\n  &.btn-link.active {\n    background-color: transparent;\n  }\n}\n\n.btn {\n  &:disabled,\n  &[disabled],\n  &.disabled {\n    @include opacity(0.5);\n    pointer-events: none;\n  }\n}\n.btn-simple {\n  border: $border;\n  border-color: $default-color;\n  padding: $padding-btn-vertical - 1 $padding-round-horizontal - 1;\n  background-color: $transparent-bg;\n}\n\n.btn-simple,\n.btn-link {\n  &.disabled,\n  &:disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      background-color: $transparent-bg;\n    }\n  }\n}\n\n.btn-link {\n  border: $none;\n  padding: $padding-base-vertical $padding-base-horizontal;\n  background-color: $transparent-bg;\n}\n\n.btn-lg {\n  @include btn-size(\n    $padding-large-vertical,\n    $padding-large-horizontal,\n    $font-size-large,\n    $border-radius-large\n  );\n}\n.btn-sm {\n  @include btn-size(\n    $padding-small-vertical,\n    $padding-small-horizontal,\n    $font-size-small,\n    $border-radius-small\n  );\n}\n\n.btn-wd {\n  min-width: 140px;\n}\n.btn-group.select {\n  width: 100%;\n}\n.btn-group.select .btn {\n  text-align: left;\n}\n.btn-group.select .caret {\n  position: absolute;\n  top: 50%;\n  margin-top: -1px;\n  right: 8px;\n}\n.btn-group {\n  .btn + .btn {\n    margin-left: -3px;\n  }\n  .btn {\n    &:focus {\n      background-color: $info-color !important;\n    }\n  }\n}\n\n.btn-round {\n  border-width: $border-thin;\n  border-radius: $btn-round-radius;\n  padding-right: $padding-round-horizontal;\n  padding-left: $padding-round-horizontal;\n\n  &.btn-simple {\n    padding: $padding-btn-vertical - 1 $padding-round-horizontal - 1;\n  }\n}\n\n.no-caret {\n  &.dropdown-toggle::after {\n    display: none;\n  }\n}\n\nbutton[type=\"button\"] {\n  background: transparent;\n  border: 0;\n}\n","\n\n.btn{\n  // social buttons\n  &.btn-facebook {\n    @include social-buttons-color($social-facebook, $social-facebook-state-color);\n  }\n  &.btn-twitter {\n    @include social-buttons-color($social-twitter, $social-twitter-state-color);\n  }\n  &.btn-pinterest {\n    @include social-buttons-color($social-pinterest, $social-pinterest-state-color);\n  }\n  &.btn-google {\n    @include social-buttons-color($social-google, $social-google-state-color);\n  }\n  &.btn-linkedin {\n    @include social-buttons-color($social-linkedin, $social-linkedin-state-color);\n  }\n  &.btn-dribbble {\n    @include social-buttons-color($social-dribbble, $social-dribbble-state-color);\n  }\n  &.btn-github {\n    @include social-buttons-color($social-github, $social-github-state-color);\n  }\n  &.btn-youtube {\n    @include social-buttons-color($social-youtube, $social-youtube-state-color);\n  }\n  &.btn-instagram {\n    @include social-buttons-color($social-instagram, $social-instagram-state-color);\n  }\n  &.btn-reddit {\n    @include social-buttons-color($social-reddit, $social-reddit-state-color);\n  }\n  &.btn-tumblr {\n    @include social-buttons-color($social-tumblr, $social-tumblr-state-color);\n  }\n  &.btn-behance {\n    @include social-buttons-color($social-behance, $social-behance-state-color);\n  }\n}\n","// for social buttons\n@mixin social-buttons-color ($color, $state-color){\n    background-color: $color;\n    color: $white-color;\n\n    &:focus,\n    &:active,\n    &:hover{\n        background-color: $state-color !important;\n        color: $white-color !important;\n    }\n\n    &.btn-simple{\n        color: $color;\n        background-color: $transparent-bg;\n        box-shadow: none;\n        border-color: $color;\n\n        &:hover,\n        &:focus,\n        &:active{\n            color: $state-color;\n            border-color: $state-color;\n        }\n    }\n\n    &.btn-neutral{\n        color: $color;\n        background-color: $white-color;\n\n\n        &:hover,\n        &:focus,\n        &:active{\n            color: $state-color !important;\n        }\n    }\n}\n","//animations\n\n.icon-property{\n    @include transition($slow-transition-time, $transition-bezier);\n    position: relative;\n    display: inline-block;\n}\n\n#animated-buttons{\n    .btn{\n        i{\n            position: relative;\n            top: 3px;\n            margin-top: -3px;\n        }\n    }\n}\n\n.btn-rotate{\n    i{\n        @extend .icon-property;\n    }\n\n    &:hover,\n    &:focus{\n        i{\n            @include rotate-53();\n        }\n    }\n}\n\n.btn-magnify{\n    i{\n        @extend .icon-property;\n    }\n\n    &:hover,\n    &:focus{\n        i{\n            @include transform-scale(1.22);\n        }\n    }\n}\n\n.btn-move-left{\n    i{\n        @extend .icon-property;\n        margin-right: 0;\n    }\n\n    &:hover,\n    &:focus{\n        i{\n            @include transform-translate-x(-5px);\n        }\n    }\n}\n\n.btn-move-right{\n    i{\n        @extend .icon-property;\n        margin-right: 0;\n    }\n\n    &:hover,\n    &:focus{\n        i{\n            @include transform-translate-x(5px);\n        }\n    }\n}\n","@mixin input-size($padding-vertical, $padding-horizontal) {\n  padding: $padding-vertical $padding-horizontal;\n}\n\n@mixin form-control-placeholder($color, $opacity) {\n  .form-control::-moz-placeholder {\n    color: $color;\n    @include opacity(1);\n  }\n  .form-control:-moz-placeholder {\n    color: $color;\n    @include opacity(1);\n  }\n  .form-control::-webkit-input-placeholder {\n    color: $color;\n    @include opacity(1);\n  }\n  .form-control:-ms-input-placeholder {\n    color: $color;\n    @include opacity(1);\n  }\n}\n\n@mixin placeholder() {\n  ::-moz-placeholder {\n    @content;\n  } // Firefox\n  :-ms-input-placeholder {\n    @content;\n  } // Internet Explorer 10+\n  ::-webkit-input-placeholder {\n    @content;\n  } // Safari and Chrome\n}\n\n@mixin light-form() {\n  border-radius: 0;\n  border: 0;\n  padding: 0;\n  background-color: transparent;\n}\n\n@mixin form-control-lg-padding($padding-vertical, $padding-horizontal) {\n  .form-group.no-border.form-control-lg,\n  .input-group.no-border.form-control-lg {\n    .input-group-append .input-group-text {\n      padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\n    }\n\n    .form-control {\n      padding: $padding-vertical $padding-horizontal;\n\n      & + .input-group-prepend .input-group-text,\n      & + .input-group-append .input-group-text {\n        padding: $padding-vertical $padding-horizontal $padding-vertical 0;\n      }\n    }\n  }\n\n  .form-group.form-control-lg,\n  .input-group.form-control-lg {\n    .form-control {\n      padding: $padding-vertical - 1 $padding-horizontal - 1;\n\n      & + .input-group-prepend .input-group-text,\n      & + .input-group-append .input-group-text {\n        padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical -\n          1 0;\n      }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      padding: $padding-vertical - 1 0 $padding-vertical $padding-horizontal - 1;\n\n      & + .form-control {\n        padding: $padding-vertical $padding-horizontal - 1 $padding-vertical\n          $padding-horizontal - 3;\n      }\n    }\n  }\n}\n\n@mixin input-base-padding($padding-vertical, $padding-horizontal) {\n  .form-group.no-border,\n  .input-group.no-border {\n    .form-control {\n      padding: $padding-vertical $padding-horizontal;\n\n      & + .input-group-prepend .input-group-text,\n      & + .input-group-append .input-group-text {\n        padding: $padding-vertical $padding-horizontal $padding-vertical 0;\n      }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\n    }\n  }\n\n  .form-group,\n  .input-group {\n    .form-control {\n      padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical -\n        1 $padding-horizontal - 1;\n\n      & + .input-group-prepend .input-group-text,\n      & + .input-group-append .input-group-text {\n        padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical -\n          1 0;\n      }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      padding: $padding-vertical - 1 0 $padding-vertical - 1 $padding-horizontal -\n        1;\n\n      & + .form-control,\n      & ~ .form-control {\n        padding: $padding-vertical - 1 $padding-horizontal $padding-vertical\n          $padding-horizontal - 3;\n      }\n    }\n  }\n}\n\n//color1 = $opacity-5\n//color2 = $opacity-8\n//color3 = $white-color\n//color4 = $transparent-bg\n//color5 = $opacity-1\n//color6 = $opacity-2\n\n@mixin input-coloured-bg($color1, $color2, $color3, $color4, $color5, $color6) {\n  @include form-control-placeholder(darken($color2, 8%), 1);\n\n  .form-control {\n    border-color: $color1;\n    color: $color2;\n\n    &:focus {\n      border-color: $color3;\n      background-color: $color4;\n      color: $color3;\n    }\n  }\n\n  .has-success,\n  .has-danger {\n    &:after {\n      color: $color3;\n    }\n  }\n\n  .has-danger {\n    .form-control {\n      background-color: $color4;\n    }\n  }\n\n  .input-group-prepend .input-group-text,\n  .input-group-append .input-group-text {\n    background-color: $color4;\n    border-color: $color1;\n    color: $color2;\n  }\n\n  .input-group-focus {\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      background-color: $color4;\n      border-color: $color3;\n      color: $color3;\n    }\n  }\n\n  .form-group.no-border,\n  .input-group.no-border {\n    .form-control {\n      background-color: $color5;\n      color: $color2;\n\n      &:focus,\n      &:active,\n      &:active {\n        background-color: $color6;\n        color: $color3;\n      }\n    }\n\n    .form-control + .input-group-prepend .input-group-text,\n    .form-control + .input-group-append .input-group-text {\n      background-color: $color5;\n\n      &:focus,\n      &:active,\n      &:active {\n        background-color: $color6;\n        color: $color3;\n      }\n    }\n\n    .form-control {\n      &:focus {\n        & + .input-group-prepend .input-group-text,\n        & + .input-group-append .input-group-text {\n          background-color: $color6;\n          color: $color3;\n        }\n      }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text {\n      background-color: $color5;\n      border: none;\n      color: $color2;\n    }\n\n    &.input-group-focus {\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text {\n        background-color: $color6;\n        color: $color3;\n      }\n    }\n  }\n}\n\n@mixin transition-input-focus-color() {\n  -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,\n    background-color 0.3s ease-in-out;\n}\n","@include placeholder() {\n  color: $dark-gray;\n};\n\n\n.form-control {\n    background-color: $white-color;\n    border: 1px solid $medium-gray;\n    border-radius: $border-radius-base;\n    color: $font-color;\n    line-height: normal;\n    font-size: $font-size-base;\n    @include transition-input-focus-color();\n    @include box-shadow(none);\n\n\n\n    &:focus{\n        border: 1px solid $dark-gray;\n        @include box-shadow(none);\n        outline: 0 !important;\n        color: $default-color;\n\n        & + .input-group-append .input-group-text,\n        & ~ .input-group-append .input-group-text,\n        & + .input-group-prepend .input-group-text,\n        & ~ .input-group-prepend .input-group-text{\n            border: 1px solid #ccc;\n            border-left: none;\n            background-color: $transparent-bg;\n        }\n    }\n\n    .has-success &,\n    .has-error &,\n    .has-success &:focus,\n    .has-error &:focus{\n        @include box-shadow(none);\n    }\n\n    .has-success &{\n        border: 1px solid $table-line-color;\n        color: $font-color;\n\n        &.form-control-success{\n            padding-right: 2.5em !important;\n        }\n    }\n    .has-success &:focus{\n        border: 1px solid $success-color;\n        color: $success-color;\n    }\n    .has-danger &{\n        background-color: $danger-input-bg;\n        border: 1px solid $danger-color;\n        color: $danger-color;\n\n        &.form-control-danger{\n            padding-right: 2.5em !important;\n        }\n    }\n    .has-danger &:focus{\n        background-color: $white-color;\n        border: 1px solid $danger-color;\n    }\n\n    & + .form-control-feedback{\n        border-radius: $border-radius-large;\n        font-size: $font-size-base;\n        margin-top: -7px;\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        vertical-align: middle;\n    }\n\n    .open &{\n        border-radius: $border-radius-large $border-radius-large 0 0;\n        border-bottom-color: transparent;\n    }\n\n    & + .input-group-append .input-group-text,\n    & + .input-group-prepend .input-group-text{\n        background-color: $white-bg;\n    }\n}\n\n\n@include form-control-lg-padding($padding-large-vertical, $padding-input-horizontal);\n@include input-base-padding($padding-input-vertical, $padding-input-horizontal);\n\n.input-group {\n  &.has-success {\n    .input-group-prepend,\n    .input-group-append {\n      .input-group-text {\n        border: 1px solid $table-line-color;\n        color: $font-color;\n        background-color: $white-color;\n        border-right: none;\n      }\n    }\n  }\n}\n\n.form-group.no-border,\n.input-group.no-border{\n    .form-control,\n    .form-control + .input-group-prepend .input-group-text,\n    .form-control + .input-group-append .input-group-text{\n        background-color: $opacity-gray-3;\n        border: medium none;\n        &:focus,\n        &:active,\n        &:active{\n            border: medium none;\n            background-color: $opacity-gray-5;\n        }\n    }\n\n    .form-control{\n        &:focus{\n            & + .input-group-prepend .input-group-text,\n            & + .input-group-append .input-group-text{\n                background-color: $opacity-gray-5;\n            }\n        }\n    }\n\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n        background-color: $opacity-gray-3;\n        border: none;\n    }\n}\n\n.has-error{\n    .form-control-feedback, .control-label{\n        color: $danger-color;\n    }\n}\n.has-success{\n    .form-control-feedback, .control-label{\n        color: $success-color;\n    }\n}\n\n.input-group.has-danger {\n  .input-group-prepend {\n    border-radius: $border-radius-base;\n    .input-group-text {\n      border: 1px solid $danger-color;\n      border-right: none;\n    }\n  }\n  .error {\n    display: block;\n    width: 100%;\n    color: $danger-color;\n    margin-top: 3px;\n  }\n}\n\n.input-group.has-success {\n  .input-group-prepend {\n    border-radius: $border-radius-base;\n    .input-group-text {\n      // border: 1px solid $success-color;\n      border-right: none;\n    }\n  }\n}\n\n\n.input-group-focus{\n  .input-group-prepend .input-group-text,\n  .input-group-append .input-group-text{\n    background-color: $white-bg;\n    border-color: $dark-gray;\n  }\n\n  &.no-border{\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n      background-color: $opacity-gray-5;\n    }\n  }\n\n  &.has-danger {\n    .input-group-append,\n    .input-group-prepend {\n      .input-group-text {\n        background-color: $danger-input-bg;\n      }\n    }\n  }\n\n  &.has-success {\n    .input-group-append,\n    .input-group-prepend {\n      .input-group-text {\n        background-color: $success-input-bg;\n        border: 1px solid $success-color;\n        border-right: none;\n      }\n    }\n  }\n}\n\n.input-group-append .input-group-text,\n.input-group-prepend .input-group-text {\n    background-color: transparent;\n    border: 1px solid $light-gray;\n    color: $default-color;\n    border-top-right-radius: $border-radius-base;\n    border-bottom-right-radius: $border-radius-base;\n\n    & i{\n      opacity: .5;\n    }\n\n    @include transition-input-focus-color();\n\n    .has-danger &{\n      background-color: $danger-input-bg;\n    }\n    .has-success &{\n      background-color: $success-input-bg;\n    }\n    .has-danger.input-group-focus &{\n      background-color: $white-color;\n      color: $danger-color;\n    }\n    .has-success.input-group-focus &{\n      background-color: $white-color;\n      color: $success-color;\n    }\n    .has-danger .form-control:focus + &{\n      color: $danger-color;\n    }\n    .has-success .form-control:focus + &{\n      color: $success-color;\n    }\n\n    & + .form-control,\n    & ~ .form-control{\n        @include input-size($padding-base-vertical - 1, $padding-base-horizontal);\n        padding-left: 18px;\n    }\n\n    i{\n        width: 17px;\n    }\n}\n\n.input-group-append,\n.input-group-prepend{\n  margin: 0;\n}\n\n\n.input-group-append .input-group-text{\n  border-left: none;\n}\n.input-group-prepend .input-group-text{\n  border-right: none;\n}\n\n.input-group,\n.form-group{\n    margin-bottom: 10px;\n    position: relative;\n\n    .form-control-static{\n        margin-top: 9px;\n    }\n    &.has-danger {\n      .error {\n        color: $danger-color;\n      }\n    }\n}\n.input-group[disabled]{\n    .input-group-prepend .input-group-text,\n    .input-group-append .input-group-text{\n        background-color: $light-gray;\n    }\n}\n\n.input-group .form-control:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child){\n    border-radius: $border-radius-base;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-left: 0 none;\n}\n\n.input-group .form-control:first-child,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n    border-right: 0 none;\n}\n.input-group .form-control:last-child,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n    border-left: 0 none;\n}\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\n    background-color: $light-gray;\n    color: $default-color;\n    cursor: not-allowed;\n}\n\n.input-group-btn .btn{\n    border-width: $border-thin;\n    padding: $padding-btn-vertical  $padding-base-horizontal;\n}\n.input-group-btn .btn-default:not(.btn-fill){\n    border-color: $medium-gray;\n}\n\n.input-group-btn:last-child > .btn{\n    margin-left: 0;\n}\ntextarea.form-control{\n    max-width: 100%;\n    max-height: 80px;\n    padding: 10px 10px 0 0;\n    resize: none;\n    border: none;\n    border: 1px solid $light-gray;\n    border-radius: $border-radius-base;\n    line-height: 2;\n}\n\n.has-success,\n.has-danger{\n\n    &.form-group .form-control,\n    &.form-group.no-border .form-control{\n        padding-right: $padding-input-horizontal + 21;\n    }\n}\n\n.form.form-newsletter .form-group{\n    float: left;\n    width: 78%;\n    margin-right: 2%;\n    margin-top: 9px;\n}\n\n.input-group .input-group-btn{\n    padding: 0 12px;\n}\n\n// Input files - hide actual input - requires specific markup in the sample.\n.form-group input[type=file] {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.form-text{\n    font-size: $font-size-small;\n}\n\n.form-control-lg{\n    padding: 0;\n    font-size: inherit;\n    line-height: 0;\n    border-radius: 0;\n}\n\n.form-horizontal{\n    .col-form-label,\n    .label-on-right{\n        padding: 10px 5px 0 15px;\n        text-align: right;\n        max-width: 180px;\n    }\n\n    .checkbox-radios{\n        margin-bottom: 15px;\n\n        .form-check:first-child{\n           margin-top: 8px;\n       }\n    }\n\n    .label-on-right{\n        text-align: left;\n        padding: 10px 15px 0 5px;\n    }\n\n    .form-check-inline{\n        margin-top: 6px;\n    }\n}\n","button,\ninput,\noptgroup,\nselect,\ntextarea{\n    font-family: $sans-serif-family;\n}\nh1,h2,h3,h4,h5,h6{\n    font-weight: $font-weight-normal;\n}\n\na{\n    color: $primary-color;\n    &:hover,\n    &:focus{\n        color: $primary-color;\n    }\n}\nh1, .h1 {\n    font-size: $font-size-h1;\n    line-height: 1.15;\n    margin-bottom: $margin-base-vertical * 2;\n\n    small{\n        font-weight: $font-weight-bold;\n        text-transform: uppercase;\n        opacity: .8;\n    }\n}\nh2, .h2{\n    font-size: $font-size-h2;\n    margin-bottom: $margin-base-vertical * 2;\n}\nh3, .h3{\n    font-size: $font-size-h3;\n    margin-bottom: $margin-base-vertical * 2;\n    line-height: 1.4em;\n}\nh4, .h4{\n    font-size: $font-size-h4;\n    line-height: 1.45em;\n    margin-top: $margin-base-vertical * 2;\n    margin-bottom: $margin-base-vertical;\n\n    & + .category,\n    &.title + .category{\n        margin-top: -10px;\n    }\n}\nh5, .h5 {\n    font-size: $font-size-h5;\n    line-height: 1.4em;\n    margin-bottom: 15px;\n}\nh6, .h6{\n    font-size: $font-size-h6;\n    font-weight: $font-weight-bold;\n    text-transform: uppercase;\n}\np{\n    &.description{\n        font-size: 1.14em;\n    }\n}\n\n// i.fa{\n//     font-size: 18px;\n//     position: relative;\n//     top: 1px;\n// }\n\n.title{\n    font-weight: $font-weight-bold;\n\n    &.title-up{\n        text-transform: uppercase;\n\n        a{\n            color: $black-color;\n            text-decoration: none;\n        }\n    }\n    & + .category{\n        margin-top: -10px;\n    }\n}\n\n.description,\n.card-description,\n.footer-big p,\n.card .footer .stats{\n    color: $dark-gray;\n    font-weight: $font-weight-light;\n}\n.category,\n.card-category{\n    text-transform: capitalize;\n    font-weight: $font-weight-normal;\n    color: $dark-gray;\n    font-size: $font-size-mini;\n}\n\n.card-category{\n    font-size: $font-size-h6;\n}\n\n.text-primary,\na.text-primary:focus, a.text-primary:hover {\n  color: $brand-primary !important;\n}\n.text-info,\na.text-info:focus, a.text-info:hover {\n  color: $brand-info !important;\n}\n.text-success,\na.text-success:focus, a.text-success:hover {\n  color: $brand-success !important;\n}\n.text-warning,\na.text-warning:focus, a.text-warning:hover {\n  color: $brand-warning !important;\n}\n.text-danger,\na.text-danger:focus, a.text-danger:hover {\n  color: $brand-danger !important;\n}\n\n.text-gray,\na.text-gray:focus, a.text-gray:hover{\n    color: $light-gray !important;\n}\n\n\n.blockquote{\n    border-left: none;\n    border: 1px solid $default-color;\n    padding: 20px;\n    font-size: $font-size-blockquote;\n    line-height: 1.8;\n\n    small{\n        color: $default-color;\n        font-size: $font-size-small;\n        text-transform: uppercase;\n    }\n\n    &.blockquote-primary{\n        border-color: $primary-color;\n        color: $primary-color;\n\n        small{\n            color: $primary-color;\n        }\n    }\n\n    &.blockquote-danger{\n        border-color: $danger-color;\n        color: $danger-color;\n\n        small{\n            color: $danger-color;\n        }\n    }\n\n    &.blockquote-white{\n        border-color: $opacity-8;\n        color: $white-color;\n\n        small{\n            color: $opacity-8;\n        }\n    }\n}\n","body{\n    color: $black-color;\n    font-size: $font-size-base;\n    font-family: $sans-serif-family;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n}\n\n.main{\n    position: relative;\n    background: $white-color;\n}\n/* Animations */\n.nav-pills .nav-link,\n.navbar,\n.nav-tabs .nav-link,\n.sidebar .nav a,\n.sidebar .nav a i,\n.animation-transition-general,\n.tag,\n.tag [data-role=\"remove\"],\n.animation-transition-general{\n    @include transition($general-transition-time, $transition-ease);\n}\n\n//transition for dropdown caret\n.dropdown-toggle:after,\n.bootstrap-switch-label:before,\n.caret{\n    @include transition($fast-transition-time, $transition-ease);\n}\n\n.dropdown-toggle[aria-expanded=\"true\"]:after,\na[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n.card-collapse .card a[data-toggle=\"collapse\"][aria-expanded=\"true\"] i,\n.card-collapse .card a[data-toggle=\"collapse\"].expanded i{\n    @include rotate-180();\n}\n\n.button-bar{\n    display: block;\n    position: relative;\n    width: 22px;\n    height: 1px;\n    border-radius: 1px;\n    background: $white-bg;\n\n    & + .button-bar{\n        margin-top: 7px;\n    }\n\n    &:nth-child(2){\n        width: 17px;\n    }\n}\n\n.caret{\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: 2px;\n    vertical-align: middle;\n    border-top: 4px dashed;\n    border-top: 4px solid\\9;\n    border-right: 4px solid transparent;\n    border-left: 4px solid transparent;\n}\n\n.pull-left{\n  float: left;\n}\n.pull-right{\n  float: right;\n}\n\n\n.offline-doc {\n  .navbar.navbar-transparent{\n    padding-top: 25px;\n    border-bottom: none;\n\n    .navbar-minimize {\n      display: none;\n    }\n    .navbar-brand,\n    .collapse .navbar-nav .nav-link {\n      color: $white-color !important;\n    }\n  }\n  .footer {\n    z-index: 3 !important;\n  }\n  .page-header{\n    .container {\n      z-index: 3;\n    }\n    &:after {\n      background-color: rgba(0, 0, 0, 0.5);\n      content: \"\";\n      display: block;\n      height: 100%;\n      left: 0;\n      position: absolute;\n      top: 0;\n      width: 100%;\n      z-index: 2;\n    }\n  }\n}\n\n.fixed-plugin {\n  .dropdown-menu li {\n    padding: 2px !important;\n  }\n}\n\n// badge color\n\n.badge{\n  &.badge-default{\n      @include badge-color($default-color);\n  }\n  &.badge-primary{\n      @include badge-color($primary-color);\n  }\n  &.badge-info{\n      @include badge-color($info-color);\n  }\n  &.badge-success{\n      @include badge-color($success-color);\n  }\n  &.badge-warning{\n      @include badge-color($warning-color);\n  }\n  &.badge-danger{\n      @include badge-color($danger-color);\n  }\n  &.badge-neutral{\n      @include badge-color($white-color);\n      color: inherit;\n  }\n}\n\n.card-user {\n  form {\n    .form-group {\n      margin-bottom: 20px;\n    }\n  }\n}\n","@mixin badge-color($color) {\n    border-color: $color;\n    background-color: $color;\n}\n\n@mixin badge-hover-href($color, $bg-color) {\n    color: $color;\n    background-color: $bg-color;\n    border-color: $bg-color;\n}\n\n@mixin badges-color($color){\n    .tag{\n        background-color: $color;\n        color: $white-color;\n\n        .tagsinput-remove-link{\n            color: $white-color;\n        }\n    }\n}\n@mixin create-colored-badges(){\n    &.primary-badge{\n        @include badges-color($brand-primary);\n    }\n    &.info-badge {\n        @include badges-color($brand-info);\n    }\n    &.success-badge{\n        @include badges-color($brand-success);\n    }\n    &.warning-badge{\n        @include badges-color($brand-warning);\n    }\n    &.danger-badge{\n        @include badges-color($brand-danger);\n    }\n\n}\n","\n\n.ct-label.ct-horizontal.ct-end,\n.ct-label.ct-vertical.ct-start {\n  font-size: 14px;\n}\n\n.ct-chart.ct-perfect-fourth {\n  .ct-chart-pie .ct-label {\n    font-size: 14px;\n  }\n}\n\n.card {\n  .card-footer .footer-line {\n    padding-top: 3px;\n  }\n\n  &.bootstrap-table {\n    .dropdown-item.active {\n      background-color: $default-color;\n      color: $white-color;\n    }\n  }\n\n  .team-members {\n    .avatar {\n      margin-top: 5px;\n    }\n    .text-right .btn{\n      margin-top: 5px;\n    }\n  }\n}\n\n.btn-group-sm {\n  .btn-round {\n    border-radius: 30px;\n  }\n}\n\n// Pulsing Heart (footer)\n.heart {\n  color: #EB5E28;\n  animation: hearthing 1s ease infinite,;\n}\n\n@keyframes hearthing {\n  0% { transform: scale( .75 ); }\n  20% { transform: scale( 1 ); }\n  40% { transform: scale( .75 ); }\n  60% { transform: scale( 1 ); }\n  80% { transform: scale( .75 ); }\n  100% { transform: scale( .75 ); }\n}\n\n\n// Datetimepicker\n\n.datepicker {\n  .table-condensed {\n    tbody > tr:first-of-type {\n      .day {\n        padding-top: 5px;\n      }\n    }\n  }\n}\n",".navbar{\n    padding-top: $navbar-padding-base;\n    padding-bottom: $navbar-padding-base;\n    min-height: 53px;\n    margin-bottom: 20px;\n\n    a{\n        vertical-align: middle;\n\n        &:not(.btn):not(.dropdown-item){\n            color: $white-color;\n        }\n\n        &.dropdown-item{\n            color: $default-color;\n        }\n    }\n\n\n\n    &.bg-white{\n      .input-group .form-control,\n      .input-group.no-border .form-control{\n        color: $default-color;\n\n        @include placeholder(){\n          color: $default-color;\n        };\n      }\n      .input-group-prepend .input-group-text i,\n      .input-group-append .input-group-text i{\n        color: $default-color;\n        opacity: .5;\n      }\n    }\n\n    .form-group,\n    .input-group{\n      margin: 0;\n      margin-left: -3px;\n      margin-right: 5px;\n\n      .form-group-addon,\n      .input-group-prepend .input-group-text,\n      .input-group-append .input-group-text{\n        color: $default-color;\n\n        i {\n          opacity: 1;\n        }\n      }\n\n      &.no-border{\n        .form-control{\n          color: $default-color;\n\n          @include placeholder(){\n            color: $default-color;\n          };\n        }\n      }\n    }\n\n    p{\n        display: inline-block;\n        margin: 0;\n        line-height: 1.8em;\n        font-size: 1em;\n        font-weight: 400;\n    }\n\n    &.navbar-absolute{\n        position: absolute;\n        width: 100%;\n        padding-top: 10px;\n        z-index: 1029;\n    }\n\n    .documentation &{\n        &.fixed-top{\n            left: 0;\n            width: initial;\n        }\n    }\n\n    .navbar-wrapper{\n        display: inline-flex;\n        align-items: center;\n\n        .navbar-minimize{\n            padding-right: 10px;\n\n            .btn{\n                margin: 0;\n            }\n        }\n\n        .navbar-toggle{\n            .navbar-toggler{\n                padding-left: 0;\n            }\n\n            &:hover{\n                & .navbar-toggler-bar.bar2{\n                    width: 22px;\n                }\n            }\n        }\n    }\n\n\n\n    .navbar-nav{\n        &.navbar-logo{\n            position: absolute;\n            left: 0;\n            right: 0;\n            margin: 0 auto;\n            width: 49px;\n            top: -4px;\n        }\n\n        .nav-link.btn{\n            padding: $padding-btn-vertical $padding-btn-horizontal;\n            &.btn-lg{\n                padding: $padding-large-vertical $padding-large-horizontal;\n            }\n            &.btn-sm{\n                padding: $padding-small-vertical $padding-small-horizontal;\n            }\n        }\n\n        .nav-link{\n            text-transform: uppercase;\n            font-size: $font-size-mini;\n            padding: $padding-base-vertical $padding-base-horizontal;\n            line-height: $line-height-nav-link;\n            margin-right: 3px;\n\n            i.fa + p,\n            i.nc-icon + p{\n                margin-left: 3px;\n            }\n\n            i.fa,\n            i.nc-icon{\n                font-size: 18px;\n                position: relative;\n                top: 3px;\n                text-align: center;\n                width: 21px;\n            }\n\n            i.nc-icon{\n                top: 4px;\n                font-size: 16px;\n            }\n\n            &.profile-photo{\n                .profile-photo-small{\n                    width: 27px;\n                    height: 27px;\n                }\n            }\n\n            &.disabled{\n                opacity: .5;\n                color: $white-color;\n            }\n        }\n\n        .nav-item.active .nav-link:not(.btn),\n        .nav-item .nav-link:not(.btn):focus,\n        .nav-item .nav-link:not(.btn):hover,\n        .nav-item .nav-link:not(.btn):active{\n            border-radius: $border-radius-small;\n            color: $default-color;\n        }\n    }\n\n    .logo-container{\n        width: 27px;\n        height: 27px;\n        overflow: hidden;\n        margin: 0 auto;\n        border-radius: 50%;\n        border: 1px solid transparent;\n    }\n\n    .navbar-brand{\n        text-transform: capitalize;\n        font-size: $font-size-large-navbar;\n        padding-top: $padding-base-vertical;\n        padding-bottom: $padding-base-vertical;\n        line-height: $line-height-nav-link;\n    }\n\n    .navbar-toggler{\n        width: 37px;\n        height: 27px;\n        vertical-align: middle;\n        outline: 0;\n        cursor: pointer;\n\n        & .navbar-toggler-bar.navbar-kebab{\n            width: 3px;\n            height: 3px;\n            border-radius: 50%;\n            margin: 0 auto;\n        }\n    }\n\n    .button-dropdown{\n        .navbar-toggler-bar:nth-child(2){\n            width: 17px;\n        }\n    }\n\n    &.navbar-transparent{\n      background-color: $transparent-bg !important;\n      box-shadow: none;\n      border-bottom: 1px solid #ddd;\n\n      a:not(.dropdown-item):not(.btn){\n        color: $default-color;\n\n        &.disabled{\n          opacity: .5;\n          color: $default-color;\n         }\n       }\n\n       .button-bar{\n           background: $default-color;\n       }\n\n      .nav-item .nav-link:not(.btn){\n        color: $default-color;\n      }\n      .nav-item.active .nav-link:not(.btn),\n      .nav-item .nav-link:not(.btn):focus,\n      .nav-item .nav-link:not(.btn):hover,\n      .nav-item .nav-link:not(.btn):focus:hover,\n      .nav-item .nav-link:not(.btn):active {\n        color: $primary-color;\n      }\n    }\n\n    &.bg-white {\n        a:not(.dropdown-item):not(.btn){\n            color: $default-color;\n\n            &.disabled{\n                opacity: .5;\n                color: $default-color;\n            }\n        }\n\n        .button-bar{\n            background: $default-color;\n        }\n\n        .nav-item.active .nav-link:not(.btn),\n        .nav-item .nav-link:not(.btn):focus,\n        .nav-item .nav-link:not(.btn):hover,\n        .nav-item .nav-link:not(.btn):active{\n            color: $info-color;\n        }\n\n        .logo-container{\n            border: 1px solid $default-color;\n        }\n    }\n\n    .navbar-collapse {\n      .nav-item {\n        a {\n          font-size: $font-size-base;\n        }\n      }\n    }\n}\n\n.bg-default{\n    background-color: $default-color !important;\n}\n\n.bg-primary{\n    background-color: $primary-color !important;\n}\n\n.bg-info{\n    background-color: $info-color !important;\n}\n\n.bg-success{\n    background-color: $success-color !important;\n}\n\n.bg-danger{\n    background-color: $danger-color !important;\n}\n\n.bg-warning{\n    background-color: $warning-color !important;\n}\n\n.bg-white{\n    background-color: $white-color !important;\n}\n",".dropdown,\n.dropup,\n.bootstrap-select{\n    .dropdown-menu{\n        display: block;\n        @include opacity(0);\n        @include box-shadow($dropdown-shadow);\n        visibility: hidden;\n        position: absolute;\n        transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;\n\n        &[x-placement=\"top-start\"]{\n            @include transform-translate-y-dropdown(0px);\n\n        }\n        &[x-placement=\"bottom-start\"]{\n            @include transform-translate-y-dropdown(0px);\n        }\n    }\n\n    &.show .dropdown-menu{\n        @include opacity(1);\n        visibility: visible;\n\n        &[x-placement=\"top-start\"]{\n            @include transform-translate-y-dropdown(-50px);\n            top: auto !important;\n            bottom: 0 !important;\n\n        }\n        &[x-placement=\"bottom-start\"]{\n            @include transform-translate-y-dropdown(50px);\n            bottom: auto !important;\n            top: 0 !important;\n        }\n    }\n\n}\n\n.dropup .dropdown-menu,\n.dropdown-btn .dropdown-menu{\n    @include transform-translate-y-dropdown(0px);\n    top: auto !important;\n    bottom: 0 !important;\n\n}\n\n.dropup.show .dropdown-menu,\n.dropdown-btn.show .dropdown-menu{\n    opacity: 1;\n    visibility: visible;\n\n    .dropdown-menu.inner{\n      @include transform-translate-y(0px);\n    }\n}\n\n.bootstrap-select.show{\n  .dropdown-menu.show{\n    &[x-placement=\"top-start\"]{\n        @include transform-translate-y-dropdown(-60px);\n        top: auto !important;\n        bottom: 0 !important;\n    }\n\n    li:last-child {\n      a:hover{\n        border-radius: 0 0 12px 12px;\n      }\n    }\n  }\n}\n\n.bootstrap-select.dropup.show{\n  &:before {\n    top: -1px !important;\n  }\n\n  &:after {\n    top: -2px !important;\n  }\n}\n.dropdown-menu{\n    background-color: $white-color;\n    border: 0 none;\n    border-radius: $border-radius-extreme;\n    margin-top: 10px;\n    padding: 0px;\n\n    .divider{\n        background-color: $medium-pale-bg;\n        margin: 0px;\n    }\n\n    .dropdown-header{\n        color: $dark-gray;\n        font-size: $font-size-small;\n        padding: $padding-dropdown-vertical $padding-dropdown-horizontal;\n    }\n\n    .no-notification{\n        color: #9A9A9A;\n        font-size: 1.2em;\n        padding: 30px 30px;\n        text-align: center;\n    }\n\n    .dropdown-item{\n        color: $font-color;\n        font-size: $font-size-base;\n        padding: 10px 45px 10px 15px;\n        clear: both;\n        white-space: nowrap;\n        width: 100%;\n        display: block;\n\n       img{\n           margin-top: -3px;\n       }\n\n    }\n    .dropdown-item:focus{\n        outline: 0 !important;\n    }\n\n    .btn-group.select &{\n        min-width: 100%;\n    }\n\n    .dropdown-item:first-child{\n       border-top-left-radius: $border-radius-extreme;\n       border-top-right-radius: $border-radius-extreme;\n    }\n\n    .dropdown-item:last-child{\n        border-bottom-left-radius: $border-radius-extreme;\n        border-bottom-right-radius: $border-radius-extreme;\n    }\n\n    .select & .dropdown-item:first-child{\n        border-radius: 0;\n        border-bottom: 0 none;\n    }\n\n    .dropdown-item:hover,\n    .dropdown-item:focus{\n        color: $white-color !important;\n        opacity: 1;\n        text-decoration: none;\n\n    }\n    .dropdown-item:hover,\n    .dropdown-item:focus{\n        background-color: $default-color;\n    }\n\n    &.dropdown-primary .dropdown-item:hover,\n    &.dropdown-primary .dropdown-item:focus{\n        background-color: $bg-primary;\n    }\n    &.dropdown-info .dropdown-item:hover,\n    &.dropdown-info .dropdown-item:focus{\n        background-color: $bg-info;\n    }\n    &.dropdown-success .dropdown-item:hover,\n    &.dropdown-success .dropdown-item:focus{\n        background-color: $bg-success;\n    }\n    &.dropdown-warning .dropdown-item:hover,\n    &.dropdown-warning .dropdown-item:focus{\n        background-color: $bg-warning;\n    }\n    &.dropdown-danger .dropdown-item:hover,\n    &.dropdown-danger .dropdown-item:focus{\n        background-color: $bg-danger;\n    }\n\n}\n.dropdown-divider{\n    margin: 0 !important;\n}\n\n//fix bug for the select items in btn-group\n.btn-group.select{\n    // overflow: hidden;\n}\n.btn-group.select.open{\n    overflow: visible;\n}\n.dropdown-menu-right{\n    right: -2px;\n    left: auto;\n}\n\n.navbar-nav .dropdown-menu:before,\n.dropdown .dropdown-menu[x-placement=\"bottom-start\"]:before,\n.dropdown .dropdown-menu[x-placement=\"bottom-end\"]:before,\n.card.card-just-text .dropdown .dropdown-menu:before,\n.card-just-text .dropdown .dropdown-menu:before,\n.dropdown-btn .dropdown-menu:before{\n    border-bottom: 11px solid $medium-pale-bg;\n    border-left: 11px solid rgba(0, 0, 0, 0);\n    border-right: 11px solid rgba(0, 0, 0, 0);\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    top: -12px;\n}\n\n.navbar-nav .dropdown-menu:after,\n.dropdown .dropdown-menu[x-placement=\"bottom-start\"]:after,\n.dropdown .dropdown-menu[x-placement=\"bottom-end\"]:after,\n.card.card-just-text .dropdown .dropdown-menu:after,\n.card-just-text .dropdown .dropdown-menu:after,\n.dropdown-btn .dropdown-menu:after{\n    border-bottom: 11px solid $white-color;\n    border-left: 11px solid rgba(0, 0, 0, 0);\n    border-right: 11px solid rgba(0, 0, 0, 0);\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    top: -11px;\n}\n\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"top-start\"]:before,\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"bottom-start\"]:before{\n    left: 30px !important;\n    right: auto;\n}\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"top-start\"]:after,\n.dropdown .dropdown-menu.dropdown-notification[x-placement=\"bottom-start\"]:after{\n    left: 30px !important;\n    right: auto;\n}\n//  the style for opening dropdowns on mobile devices; for the desktop version check the _responsive.scss file\n//  code from _responsive.scss\n\n@media screen and (min-width: 768px){\n    .navbar-form {\n      margin-top: 21px;\n      margin-bottom: 21px;\n      padding-left: 5px;\n      padding-right: 5px;\n    }\n    .navbar-search-form{\n      display: none;\n    }\n    .navbar-nav .dropdown-item .dropdown-menu,\n    .dropdown .dropdown-menu,\n    .dropdown-btn .dropdown-menu{\n      transform: translate3d(0px, -40px, 0px);\n      transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;\n    }\n    .navbar-nav .dropdown-item.show .dropdown-menu,\n    .dropdown.show .dropdown-menu,\n    .dropdown-btn.show .dropdown-menu{\n      transform: translate3d(0px, 0px, 0px);\n      visibility: visible !important;\n    }\n    .bootstrap-select .dropdown-menu{\n      -webkit-transition: all 150ms linear;\n      -moz-transition: all 150ms linear;\n      -o-transition: all 150ms linear;\n      -ms-transition: all 150ms linear;\n      transition: all 150ms linear;\n    }\n    .bootstrap-datetimepicker-widget{\n      visibility: visible !important;\n    }\n\n    .bootstrap-select .show .dropdown-menu{\n      transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;\n      transform: translate3d(0px, 0px, 0px);\n    }\n\n    .navbar-nav.navbar-right li .dropdown-menu:before,\n    .navbar-nav.navbar-right li .dropdown-menu:after{\n        left: auto;\n        right: 12px;\n    }\n\n\n    .footer:not(.footer-big){\n        nav ul{\n           li:first-child{\n             margin-left: 0;\n           }\n        }\n    }\n\n// no dragging the others navs in page\n    body > .navbar-collapse.collapse{\n        display: none !important;\n    }\n}\n\n.dropdown-sharing{\n    .dropup-item{\n        color: $font-color;\n        font-size: $font-size-base;\n\n        .social-line{\n            line-height: 28px;\n            padding: 10px 20px 5px 20px !important;\n\n            [class*=\"icon-\"]{\n                font-size: 20px;\n            }\n        }\n        &:last-child{\n            margin: 0 13px;\n            display: block;\n        }\n        .btn{\n            margin: 10px;\n        }\n    }\n\n    .dropup-item:hover,\n    .dropup-item:focus{\n        .social-line,\n        .action-line{\n            background-color: $white-color;\n            color: $font-color;\n            opacity: 1;\n            text-decoration: none;\n        }\n    }\n}\n.show .dropdown-sharing,\n.show .dropdown-actions{\n    margin-bottom: 1px;\n}\n\n.dropdown-actions{\n    .dropdown-item{\n        margin: -15px 35px;\n        .action-line{\n            padding: 5px 10px;\n            line-height: 24px;\n            font-weight: bold;\n            [class*=\"icon-\"]{\n                font-size: 24px;\n            }\n            .col-sm-9{\n                line-height: 34px;\n            }\n        }\n        .link-danger{\n            color: $danger-color;\n            &:hover, &:active, &:focus{\n                color: $danger-color;\n            }\n        }\n    }\n    li:hover,\n    li:focus{\n        a{\n            color: $font-color;\n            opacity: 1;\n            text-decoration: none;\n        }\n    }\n    .action-line{\n        .icon-simple{\n            margin-left: -15px;\n        }\n    }\n}\n.dropdown .dropdown-menu[x-placement=\"top-start\"]:before,\n.dropdown .dropdown-menu[x-placement=\"top-end\"]:before,\n.dropup .dropdown-menu:before{\n    border-top: 11px solid #DCD9D1;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    bottom: -12px;\n}\n\n.dropdown .dropdown-menu[x-placement=\"top-start\"]:after,\n.dropdown .dropdown-menu[x-placement=\"top-end\"]:after,\n.dropup .dropdown-menu:after{\n    border-top: 11px solid #FFF;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    bottom: -11px;\n}\n\n.dropup,\n.dropdown{\n    .dropdown-toggle:after{\n        margin-left: 0;\n    }\n}\n\n.dropdown-notification{\n    .dropdown-notification-list{\n            .notification-item{\n                border-bottom: 1px solid #F1EAE0;\n                font-size: 16px;\n                color: #66615b;\n\n                .notification-text{\n                    padding-left: 40px;\n                    position: relative;\n                    min-width: 330px;\n                    min-height: 70px;\n                    white-space: normal;\n\n\n                    .label{\n                        display: block;\n                        position: absolute;\n                        top: 50%;\n                        margin-top: -12px;\n                        left: 7px;\n                    }\n                    .message{\n                        font-size: 0.9em;\n                        line-height: 0.7;\n                        margin-left: 10px;\n                    }\n                    .time{\n                        color: #9A9A9A;\n                        font-size: 0.7em;\n                        margin-left: 10px;\n                    }\n                }\n                .read-notification{\n                    font-size: 12px;\n                    opacity: 0;\n                    position: absolute;\n                    right: 5px;\n                    top: 50%;\n                    margin-top: -12px;\n                }\n                &:hover{\n                    text-decoration: none;\n\n                    .notification-text{\n                        color: #66615b;\n                        background-color: #F0EFEB !important;\n                    }\n                    .read-notification{\n                        opacity: 1 !important;\n                    }\n                }\n            }\n\n    }\n    .dropdown-footer{\n        background-color: #E8E7E3;\n        border-radius: 0 0 8px 8px;\n\n        .dropdown-footer-menu{\n            list-style: outside none none;\n            padding: 0px 5px;\n            li{\n                display: inline-block;\n                text-align: left;\n                padding: 0 10px;\n\n                a{\n                    color: #9C9B99;\n                    font-size: 0.9em;\n                    line-height: 35px;\n                }\n            }\n        }\n    }\n}\n",".alert{\n    border: 0;\n    border-radius: $border-radius-small;\n    color: $white-color;\n    padding-top: .9rem;\n    padding-bottom: .9rem;\n    position: relative;\n\n    &.alert-success{\n        background-color: lighten($success-color, 5%);\n    }\n\n    &.alert-danger{\n        background-color: lighten($danger-color, 5%);\n    }\n\n    &.alert-warning{\n        background-color: lighten($warning-color, 5%);\n    }\n\n    &.alert-info{\n        background-color: lighten($info-color, 5%);\n    }\n\n    &.alert-primary{\n        background-color: lighten($primary-color, 5%);\n    }\n\n    .close{\n      color: $white-color;\n      opacity: .9;\n      text-shadow: none;\n      line-height: 0;\n      outline: 0;\n\n      i.fa,\n      i.nc-icon{\n          font-size: 14px !important;\n      }\n\n      &:hover,\n      &:focus {\n        opacity: 1;\n      }\n    }\n\n    span[data-notify=\"icon\"]{\n        font-size: 27px;\n        display: block;\n        left: 19px;\n        position: absolute;\n        top: 50%;\n        margin-top: -11px;\n    }\n\n    button.close{\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        margin-top: -13px;\n        width: 25px;\n        height: 25px;\n        padding: 3px;\n    }\n\n    .close ~ span{\n        display: block;\n        max-width: 89%;\n    }\n\n    &.alert-with-icon{\n        padding-left: 65px;\n    }\n}\n","img{\n    max-width: 100%;\n    border-radius: $border-radius-small;\n}\n.img-raised{\n    box-shadow: $box-shadow-raised;\n}\n",".table{\n\n    .img-wrapper{\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      overflow: hidden;\n      margin: 0 auto;\n    }\n\n    .img-row{\n      max-width: 60px;\n      width: 60px;\n    }\n\n    .form-check{\n        margin: 0;\n\n        & label .form-check-sign::before,\n        & label .form-check-sign::after{\n            top: -17px;\n            left: 4px;\n        }\n    }\n\n    .btn{\n        margin: 0;\n    }\n\n    small,.small{\n      font-weight: 300;\n    }\n\n    .card-tasks .card-body &{\n        margin-bottom: 0;\n\n        > thead > tr > th,\n        > tbody > tr > th,\n        > tfoot > tr > th,\n        > thead > tr > td,\n        > tbody > tr > td,\n        > tfoot > tr > td{\n            padding-top: 0;\n            padding-bottom: 0;\n        }\n    }\n\n   > thead > tr > th{\n       font-size: 14px;\n       font-weight: $font-weight-bold;\n       padding-bottom: 0;\n       text-transform: uppercase;\n       border: 0;\n   }\n\n   .radio,\n   .checkbox{\n       margin-top: 0;\n       margin-bottom: 0;\n       padding: 0;\n       width: 15px;\n\n       .icons{\n           position: relative;\n       }\n\n        label{\n            &:after,\n            &:before{\n                top: -17px;\n                left: -3px;\n            }\n        }\n   }\n   > thead > tr > th,\n   > tbody > tr > th,\n   > tfoot > tr > th,\n   > thead > tr > td,\n   > tbody > tr > td,\n   > tfoot > tr > td{\n       padding: 12px 7px;\n       vertical-align: middle;\n   }\n\n   .th-description{\n       max-width: 150px;\n   }\n   .td-price{\n       font-size: 26px;\n       font-weight: $font-weight-light;\n       margin-top: 5px;\n       position: relative;\n       top: 4px;\n       text-align: right;\n   }\n   .td-total{\n        font-weight: $font-weight-bold;\n        font-size: $font-size-h5;\n        padding-top: 20px;\n        text-align: right;\n    }\n\n   .td-actions .btn{\n    margin: 0px;\n    }\n\n    > tbody > tr{\n        position: relative;\n    }\n}\n\n.table-shopping{\n    > thead > tr > th{\n        font-size: $font-size-h6;\n        text-transform: uppercase;\n    }\n    > tbody > tr > td{\n        font-size: $font-paragraph;\n\n        b{\n            display: block;\n            margin-bottom: 5px;\n        }\n    }\n    .td-name{\n        font-weight: $font-weight-normal;\n        font-size: 1.5em;\n        small{\n            color: $dark-gray;\n            font-size: 0.75em;\n            font-weight: $font-weight-light;\n        }\n    }\n    .td-number{\n       font-weight: $font-weight-light;\n       font-size: $font-size-h4;\n   }\n    .td-name{\n        min-width: 200px;\n    }\n    .td-number{\n        text-align: right;\n        min-width: 170px;\n\n        small{\n            margin-right: 3px;\n        }\n    }\n\n    .img-container{\n        width: 120px;\n        max-height: 160px;\n        overflow: hidden;\n        display: block;\n\n        img{\n            width: 100%;\n        }\n    }\n}\n\n.table-responsive{\n  overflow: scroll;\n  padding-bottom: 10px;\n}\n\n#tables .table-responsive{\n    margin-bottom: 30px;\n}\n\n.table-hover>tbody>tr:hover{\n  background-color: #f5f5f5;\n}\n",".footer{\n    padding: 24px 0;\n\n    &.footer-default{\n        background-color: #f2f2f2;\n    }\n\n    nav{\n        display: inline-block;\n        float: left;\n        padding-left: 0;\n    }\n\n    ul{\n        margin-bottom: 0;\n        padding: 0;\n        list-style: none;\n\n        li{\n            display: inline-block;\n\n            a{\n                color: inherit;\n                padding: $padding-base-vertical;\n                font-size: $font-size-small;\n                text-transform: uppercase;\n                text-decoration: none;\n\n                &:hover{\n                    text-decoration: none;\n                }\n            }\n        }\n    }\n\n    .copyright{\n        font-size: $font-size-small;\n        line-height: 1.8;\n    }\n\n    &:after{\n        display: table;\n        clear: both;\n        content: \" \";\n    }\n}\n",".fixed-plugin{\n    position: fixed;\n    right: 0;\n    width: 64px;\n    background: rgba(0,0,0,.3);\n    z-index: 1031;\n    border-radius: 8px 0 0 8px;\n    text-align: center;\n    top: 120px;\n\n    li > a,\n    .badge{\n        transition: all .34s;\n        -webkit-transition: all .34s;\n        -moz-transition: all .34s;\n    }\n\n    .fa-cog{\n        color: #FFFFFF;\n        padding: 10px;\n        border-radius: 0 0 6px 6px;\n        width: auto;\n    }\n\n    .dropdown-menu{\n        right: 80px;\n        left: auto !important;\n        top: -52px !important;\n        width: 290px;\n        border-radius: 10px;\n        padding: 0 10px;\n    }\n\n    .dropdown .dropdown-menu .nc-icon{\n      top: 2px;\n      right: 10px;\n      font-size: 14px;\n    }\n\n    .dropdown-menu:after,\n    .dropdown-menu:before{\n        right: 10px;\n        margin-left: auto;\n        left: auto;\n    }\n\n    .fa-circle-thin{\n        color: #FFFFFF;\n    }\n\n    .active .fa-circle-thin{\n        color: #00bbff;\n    }\n\n    .dropdown-menu > .active > a,\n    .dropdown-menu > .active > a:hover,\n    .dropdown-menu > .active > a:focus{\n        color: #777777;\n        text-align: center;\n    }\n\n    img{\n        border-radius: 0;\n        width: 100%;\n        height: 100px;\n        margin: 0 auto;\n    }\n\n    .dropdown-menu li > a:hover,\n    .dropdown-menu li > a:focus{\n        box-shadow: none;\n    }\n\n    .badge{\n        border: 3px solid #FFFFFF;\n        border-radius: 50%;\n        cursor: pointer;\n        display: inline-block;\n        height: 23px;\n        margin-right: 5px;\n        position: relative;\n        width: 23px;\n\n      &.badge-light {\n        border: 1px solid $light-gray;\n\n        &.active,\n        &:hover {\n          border: 3px solid #0bf;\n        }\n      }\n    }\n\n    .badge.active,\n    .badge:hover{\n        border-color: #00bbff;\n    }\n\n    .badge-blue{\n        background-color: $brand-info;\n    }\n    .badge-green{\n        background-color: $brand-success;\n    }\n    .badge-orange{\n        background-color: $brand-primary;\n    }\n    .badge-yellow{\n        background-color: $brand-warning;\n    }\n    .badge-red{\n        background-color: $brand-danger;\n    }\n\n    h5{\n        font-size: 14px;\n        margin: 10px;\n    }\n\n    .dropdown-menu li{\n        display: block;\n        padding: 15px 2px;\n        width: 25%;\n        float: left;\n    }\n\n    li.adjustments-line,\n    li.header-title,\n    li.button-container{\n        width: 100%;\n        height: 35px;\n        min-height: inherit;\n    }\n\n    li.button-container{\n        height: auto;\n\n        div{\n            margin-bottom: 5px;\n        }\n    }\n\n    #sharrreTitle{\n        text-align: center;\n        padding: 10px 0;\n        height: 50px;\n    }\n\n    li.header-title{\n        height: 30px;\n        line-height: 25px;\n        font-size: 12px;\n        font-weight: 600;\n        text-align: center;\n        text-transform: uppercase;\n    }\n\n    .adjustments-line{\n        p{\n            float: left;\n            display: inline-block;\n            margin-bottom: 0;\n            font-size: 1em;\n            color: #3C4858;\n        }\n\n        a{\n            color: transparent;\n\n            .badge-colors{\n                position: relative;\n                top: -2px;\n            }\n\n            a:hover,\n            a:focus{\n                color: transparent;\n            }\n        }\n\n        .togglebutton{\n            text-align: center;\n\n            .label-switch{\n              position: relative;\n              left: -10px;\n              font-size: $font-size-mini;\n              color: $default-color;\n\n              &.label-right{\n                left: 10px;\n              }\n            }\n\n            .toggle{\n                margin-right: 0;\n            }\n        }\n\n        .dropdown-menu > li.adjustments-line > a{\n              padding-right: 0;\n              padding-left: 0;\n              border-bottom: 1px solid #ddd;\n              border-radius: 0;\n              margin: 0;\n        }\n    }\n\n\n\n    .dropdown-menu{\n        > li{\n            & > a.img-holder{\n                  font-size: 16px;\n                  text-align: center;\n                  border-radius: 10px;\n                  background-color: #FFF;\n                  border: 3px solid #FFF;\n                  padding-left: 0;\n                  padding-right: 0;\n                  opacity: 1;\n                  cursor: pointer;\n                  display: block;\n                  max-height: 100px;\n                  overflow: hidden;\n                  padding: 0;\n\n                  img{\n                     margin-top: auto;\n                  }\n            }\n\n            a.switch-trigger:hover,\n            & > a.switch-trigger:focus{\n                background-color: transparent;\n            }\n\n            &:hover,\n            &:focus{\n                > a.img-holder{\n                    border-color: rgba(0, 187, 255, 0.53);;\n                }\n            }\n        }\n\n        > .active > a.img-holder,\n        > .active > a.img-holder{\n            border-color: #00bbff;\n            background-color: #FFFFFF;\n        }\n\n    }\n\n    .btn-social{\n        width: 50%;\n        display: block;\n        width: 48%;\n        float: left;\n        font-weight: 600;\n    }\n\n    .btn-social{\n        i{\n            margin-right: 5px;\n        }\n\n        &:first-child{\n            margin-right: 2%;\n        }\n    }\n\n    .dropdown{\n        .dropdown-menu{\n          transform-origin: 0 0;\n\n          &:before{\n             border-bottom: 16px solid rgba(0, 0, 0, 0);\n             border-left: 16px solid rgba(0,0,0,0.2);\n             border-top: 16px solid rgba(0,0,0,0);\n             right: -27px;\n             bottom: 425px;\n          }\n\n          &:after{\n             border-bottom: 16px solid rgba(0, 0, 0, 0);\n             border-left: 16px solid #FFFFFF;\n             border-top: 16px solid rgba(0,0,0,0);\n             right: -26px;\n             bottom: 425px;\n          }\n\n          &:before,\n          &:after{\n             content: \"\";\n             display: inline-block;\n             position: absolute;\n             width: 16px;\n             transform: translateY(-50px);\n             -webkit-transform: translateY(-50px);\n             -moz-transform: translateY(-50px);\n          }\n        }\n\n      &.show-dropdown .show{\n        .dropdown-menu .show{\n          transform: translate3d(0, -60px, 0)!important;\n          bottom: auto!important;\n          top: 0!important;\n        }\n      }\n    }\n\n    .bootstrap-switch{\n        margin:0;\n    }\n}\n\n.fixed-plugin {\n  .show-dropdown {\n    .dropdown-menu[x-placement=bottom-start] {\n      @include transform-translate-y-fixed-plugin (-100px);\n\n      &:before,\n      &:after {\n        top: 100px;\n      }\n    }\n    .dropdown-menu[x-placement=top-start] {\n      @include transform-translate-y-fixed-plugin (100px);\n    }\n\n    &.show {\n      .dropdown-menu.show[x-placement=bottom-start] {\n        @include transform-translate-y-fixed-plugin (-60px);\n      }\n\n      .dropdown-menu.show[x-placement=top-start] {\n        @include transform-translate-y-fixed-plugin (470px);\n      }\n    }\n  }\n}\n",".from-check,\n.form-check-radio {\n    margin-bottom: 12px;\n    position: relative;\n}\n\n.form-check {\n  padding-left: 0;\n  margin-bottom: .5rem;\n\n    .form-check-label{\n        display: inline-block;\n        position: relative;\n        cursor: pointer;\n        padding-left: 35px;\n        line-height: 26px;\n        margin-bottom: 0;\n    }\n\n    .form-check-sign::before,\n    .form-check-sign::after {\n        content: \" \";\n        display: inline-block;\n        position: absolute;\n        width: 24px;\n        height: 24px;\n        left: 0;\n        cursor: pointer;\n        border-radius: 6px;\n        top: 0;\n        background-color: #AAA7A4;\n        -webkit-transition: opacity 0.3s linear;\n        -moz-transition: opacity 0.3s linear;\n        -o-transition: opacity 0.3s linear;\n        -ms-transition: opacity 0.3s linear;\n        transition: opacity 0.3s linear;\n    }\n    .form-check-sign::after {\n        font-family: 'FontAwesome';\n        content: \"\\f00c\";\n        top: -1px;\n        text-align: center;\n        font-size: 15px;\n        opacity: 0;\n        color: #FFF;\n        border: 0;\n        background-color: inherit;\n    }\n    &.disabled{\n        .form-check-label{\n            color: $dark-gray;\n            opacity: .5;\n            cursor: not-allowed;\n        }\n    }\n\n}\n\n.form-check.disabled .form-check-label,\n.form-check.disabled .form-check-label {\n\n}\n\n.form-check input[type=\"checkbox\"],\n.form-check-radio input[type=\"radio\"]{\n    opacity: 0;\n    position: absolute;\n    visibility: hidden;\n}\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\n    opacity: 1;\n}\n\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\n    cursor: not-allowed;\n}\n\n.form-check .form-check-label input[type=\"checkbox\"]:disabled + .form-check-sign,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign{\n    pointer-events: none !important;\n}\n\n.form-check-radio{\n  margin-left: -3px;\n\n    .form-check-label{\n        padding-left: 2rem;\n    }\n    &.disabled{\n        .form-check-label{\n            color: $dark-gray;\n            opacity: .5;\n            cursor: not-allowed;\n        }\n    }\n}\n\n.form-check-radio .form-check-sign::before{\n    font-family: 'FontAwesome';\n    content: \"\\f10c\";\n    font-size: 22px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    display: inline-block;\n    position: absolute;\n    opacity: .50;\n    left: 5px;\n    top: -5px;\n}\n\n.form-check-label input[type=\"checkbox\"]:checked + .form-check-sign:before{\n    background-color: #66615B;\n}\n\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\n.form-check-radio input[type=\"radio\"] {\n    opacity: 0;\n    @include transition-opacity(0.3s, linear);\n    content:\" \";\n    display: block;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n    font-family: 'FontAwesome';\n    content: \"\\f192\";\n    top: -5px;\n    position: absolute;\n    left: 5px;\n    opacity: 1;\n    font-size: 22px;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\n    opacity: 1;\n}\n\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\n    color: $dark-gray;\n}\n",".progress {\n    background-color: $medium-gray;\n    border-radius: $border-radius-small;\n    box-shadow: none;\n    height: 8px;\n}\n.progress-thin{\n    height: 4px;\n}\n.progress-bar{\n    background-color: $primary-color;\n}\n.progress-bar-primary{\n    background-color: $primary-color;\n}\n.progress-bar-info{\n    background-color: $info-color;\n}\n.progress-bar-success{\n    background-color: $success-color;\n}\n.progress-bar-warning{\n    background-color: $warning-color;\n}\n.progress-bar-danger{\n    background-color: $danger-color;\n}\n","/*           badges             */\n.badge{\n    padding: 4px 8px;\n    text-transform: uppercase;\n    font-size: $font-size-mini;\n    line-height: 12px;\n    background-color: $transparent-bg;\n    border: $border;\n    text-decoration: none;\n    color: $white-color;\n    margin-bottom: 5px;\n\n    &:hover,\n    &:focus{\n      text-decoration: none;\n    }\n}\n.badge-icon{\n    padding: 0.4em 0.55em;\n    i{\n       font-size: 0.8em;\n    }\n}\n.badge-default{\n    @include badge-color($default-color);\n}\n.badge-primary{\n    @include badge-color($primary-color);\n}\n.badge-info{\n    @include badge-color($info-color);\n}\n.badge-success{\n    @include badge-color($success-color);\n}\n.badge-warning{\n    @include badge-color($warning-color);\n}\n.badge-danger{\n    @include badge-color($danger-color);\n}\n.badge-neutral{\n    @include badge-color($white-color);\n    color: inherit;\n}\n\n.badge-primary[href]:focus,\n.badge-primary[href]:hover{\n  @include badge-hover-href($white-color, darken($primary-color, 3%));\n}\n\n.badge-warning[href]:focus,\n.badge-warning[href]:hover{\n  @include badge-hover-href($white-color, darken($warning-color, 3%));\n}\n\n.badge-info[href]:focus,\n.badge-info[href]:hover{\n  @include badge-hover-href($white-color, darken($info-color, 3%));\n}\n\n.badge-danger[href]:focus,\n.badge-danger[href]:hover{\n  @include badge-hover-href($white-color, darken($danger-color, 3%));\n}\n\n.badge-success[href]:focus,\n.badge-success[href]:hover{\n  @include badge-hover-href($white-color, darken($success-color, 3%));\n}\n\n.badge-default[href]:focus,\n.badge-default[href]:hover{\n  @include badge-hover-href($white-color, darken($default-color, 3%));\n}\n",".pagination {\n    .page-item .page-link {\n        border: 0;\n        border-radius: 30px !important;\n        transition: all .3s;\n        padding: 0px 11px;\n        margin: 0 3px;\n        min-width: 30px;\n        text-align: center;\n        height: 30px;\n        line-height: 30px;\n        color: $black-color;\n        cursor: pointer;\n        font-size: $font-size-base;\n        text-transform: uppercase;\n        background: transparent;\n        outline: none;\n\n        &:hover,\n        &:focus {\n            color: $black-color;\n            background-color: $opacity-gray-3;\n            border: none;\n        }\n\n        &:focus,\n        &:active:focus {\n          box-shadow: none;\n        }\n    }\n\n    .arrow-margin-left,\n    .arrow-margin-right {\n        position: absolute;\n    }\n\n    .arrow-margin-right {\n        right: 0;\n    }\n\n    .arrow-margin-left {\n        left: 0;\n    }\n\n    .page-item.active > .page-link {\n        color: $white-color;\n        box-shadow: $box-shadow;\n\n        &,\n        &:focus,\n        &:hover{\n            background-color: $primary-color;\n            border-color: $primary-color;\n            color: $white-color;\n        }\n    }\n\n    .page-item.disabled > .page-link{\n        opacity: .5;\n    }\n\n    // Colors\n    &.pagination-info{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $brand-info;\n                border-color: $brand-info;\n            }\n        }\n    }\n\n    &.pagination-success{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $brand-success;\n                border-color: $brand-success;\n            }\n        }\n    }\n\n    &.pagination-primary{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $brand-primary;\n                border-color: $brand-primary;\n            }\n        }\n    }\n\n    &.pagination-warning{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $brand-warning;\n                border-color: $brand-warning;\n            }\n        }\n    }\n\n    &.pagination-danger{\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $brand-danger;\n                border-color: $brand-danger;\n            }\n        }\n    }\n\n    &.pagination-neutral{\n        .page-item > .page-link{\n            color: $white-color;\n\n            &:focus,\n            &:hover{\n                background-color: $opacity-2;\n                color: $white-color;\n            }\n        }\n\n        .page-item.active > .page-link{\n            &,\n            &:focus,\n            &:hover{\n                background-color: $white-bg;\n                border-color: $white-bg;\n                color: $brand-primary;\n            }\n        }\n    }\n\n}\n",".info{\n    &.info-hover{\n        .info-title{\n            transition: color .4s;\n        }\n\n        &:hover{\n            .icon{\n                @include transform-translate-y(-.5rem);\n\n                &.icon-primary{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 30px 0px rgba(249, 99, 50, 0.3);\n                    }\n                }\n                &.icon-info{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(44, 168, 255, 0.3);\n                    }\n                }\n                &.icon-success{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(24, 206, 15, 0.3);\n                    }\n                }\n                &.icon-warning{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(255, 178, 54, 0.3);\n                    }\n                }\n                &.icon-danger{\n                    &.icon-circle{\n                        box-shadow: 0px 15px 35px 0px rgba(255, 54, 54, 0.3);\n                    }\n                }\n\n                &.icon-info + .info-title{\n                    color: $info-color;\n                }\n\n                &.icon-warning + .info-title{\n                    color: $warning-color;\n                }\n\n                &.icon-danger + .info-title{\n                    color: $danger-color;\n                }\n\n                &.icon-primary + .info-title{\n                    color: $primary-color;\n                }\n\n                &.icon-success + .info-title{\n                    color: $success-color;\n                }\n            }\n        }\n    }\n\n    .icon{\n        color: $default-color;\n        transition: transform .4s, box-shadow .4s;\n\n        > i{\n            font-size: 2.3em;\n        }\n\n        &.icon-circle{\n            max-width: 70px;\n            width: 70px;\n            height: 70px;\n            margin: 0 auto;\n            border-radius: 50%;\n            box-shadow: 0px 9px 35px -6px rgba(0, 0, 0, 0.3);\n            font-size: $font-size-mini;\n            background-color: $white-color;\n            position: relative;\n\n            i{\n                line-height: 2.6em;\n            }\n        }\n    }\n\n    .info-title{\n        margin: $margin-base-vertical 0 5px;\n        padding: 0 15px;\n        color: $black-color;\n        font-weight: $font-weight-bold;\n    }\n    p{\n        color: $default-color;\n        padding: 0 15px;\n        font-size: 1.1em;\n    }\n}\n\n.info-horizontal{\n    text-align: left !important;\n\n    .icon{\n        float: left;\n        margin-top: 23px;\n        margin-right: 10px;\n\n        >i{\n            font-size: 2em;\n        }\n\n        &.icon-circle{\n            width: 65px;\n            height: 65px;\n            max-width: 65px;\n            margin-top: 8px;\n\n            i{\n                display: table;\n                margin: 0 auto;\n                line-height: 3.5;\n                font-size: 1.9em;\n            }\n        }\n    }\n    .description{\n        overflow: hidden;\n    }\n\n}\n\n.icon{\n    &.icon-primary{\n        color: $brand-primary;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px rgba($primary-color, .5);\n        }\n    }\n    &.icon-info{\n        color: $brand-info;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px rgba($info-color, .5);\n        }\n    }\n    &.icon-success{\n        color: $brand-success;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px rgba($success-color, .5);\n        }\n    }\n    &.icon-warning{\n        color: $brand-warning;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px rgba($warning-color, .5);\n        }\n    }\n    &.icon-danger{\n        color: $brand-danger;\n\n        &.icon-circle{\n            box-shadow: 0px 9px 30px -6px rgba($danger-color, .5);\n        }\n    }\n\n    &.icon-white{\n        color: $white-color;\n    }\n}\n","/*             Navigation Pills               */\n\n.nav-pills {\n    .nav-item + .nav-link {\n        margin-left: 0;\n    }\n    .nav-item .nav-link {\n        border: 1px solid $default-color;\n        border-radius: 0;\n        color: $default-color;\n        font-weight: $font-weight-bold;\n        margin-left: -1px;\n        padding: 10px 25px;\n\n    }\n    .nav-item.active .nav-link,\n    .nav-item.active .nav-link:hover,\n    .nav-item.active .nav-link:focus {\n        background-color: $default-color;\n        color: #FFFFFF;\n    }\n    .nav-item:first-child .nav-link{\n        border-radius: 30px 0 0 30px !important;\n        margin: 0;\n    }\n    .nav-item:last-child .nav-link{\n        border-radius: 0 30px 30px 0 !important;\n    }\n    .nav-item .nav-link.active{\n        background-color: $default-color;\n        color: $white-color;\n    }\n\n}\n.nav-pills-primary{\n    .nav-item{\n        .nav-link{\n            border: 1px solid $primary-color;\n            color: $primary-color;\n            &.active{\n                border: 1px solid $primary-color;\n                background: $primary-color;\n                color: $white-color;\n            }\n        }\n    }\n}\n.nav-pills-danger{\n    .nav-item{\n        .nav-link{\n            border: 1px solid $danger-color;\n            color: $danger-color;\n            &.active{\n                border: 1px solid $danger-color;\n                background: $danger-color;\n                color: $white-color;\n            }\n        }\n    }\n}\n.nav-pills-info{\n    .nav-item{\n        .nav-link{\n            border: 1px solid $info-color;\n            color: $info-color;\n            &.active{\n                border: 1px solid $info-color;\n                background: $info-color;\n                color: $white-color;\n            }\n        }\n    }\n}\n.nav-pills-success{\n    .nav-item{\n        .nav-link{\n            border: 1px solid $success-color;\n            color: $success-color;\n            &.active{\n                border: 1px solid $success-color;\n                background: $success-color;\n                color: $white-color;\n            }\n        }\n    }\n}\n.nav-pills-warning{\n    .nav-item{\n        .nav-link{\n            border: 1px solid $warning-color;\n            color: $warning-color;\n            &.active{\n                border: 1px solid $warning-color;\n                background: $warning-color;\n                color: $white-color;\n            }\n        }\n    }\n}\n\n\n\n\n.page-item:first-child .page-link,\n.page-item:last-child .page-link{\n    border-bottom-left-radius: 20px;\n\tborder-top-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n    border-top-right-radius: 20px;\n}\n.nav-pills-default .nav-item.show .nav-link,\n.nav-pills-default .nav-link.active{\n    background-color: $default-color !important;\n}\n.nav-pills-primary .nav-item.show .nav-link,\n.nav-pills-primary .nav-link.active{\n    background-color: $primary-color !important;\n}\n.nav-pills-info .nav-item.show .nav-link,\n.nav-pills-info .nav-link.active{\n    background-color: $info-color !important;\n}\n.nav-pills-warning .nav-item.show .nav-link,\n.nav-pills-warning .nav-link.active{\n    background-color: $warning-color !important;\n}\n.nav-pills-success .nav-item.show .nav-link,\n.nav-pills-success .nav-link.active{\n    background-color: $success-color !important;\n}\n.nav-pills-danger .nav-item.show .nav-link,\n.nav-pills-danger .nav-link.active{\n    background-color: $danger-color !important;\n}\n","\n/*             Navigation Tabs                 */\n.nav-tabs-navigation{\n    text-align: center;\n    border-bottom: 1px solid $medium-pale-bg;\n    margin-bottom: 30px;\n\n    .nav > .nav-item > .nav-link{\n        padding-bottom: 20px;\n    }\n}\n.nav-tabs-wrapper{\n    display: inline-block;\n    margin-bottom: -6px;\n    margin-left: 1.25%;\n    margin-right: 1.25%;\n    position: relative;\n    width: auto;\n}\n.nav-tabs {\n        border-bottom: 0 none;\n        font-size: $font-size-base;\n        font-weight: $font-weight-normal;\n        .nav-item{\n            .nav-link{\n                border: 0 none;\n                color: $other-medium-gray;\n                background-color: transparent;\n            }\n            .nav-link:hover{\n                color: $font-color;\n            }\n            .nav-link.active{\n                color: $font-color;\n            }\n        }\n\n        .nav-item{\n            color: $font-color;\n            position: relative;\n\n\n            .nav-link.active,\n            .nav-link.active:hover,\n            .nav-link.active:focus{\n                background-color: transparent;\n                border: 0 none;\n                //height: 50px;\n                &:after{\n                    border-bottom: 11px solid $white-color;\n                    border-left: 11px solid rgba(0, 0, 0, 0);\n                    border-right: 11px solid rgba(0, 0, 0, 0);\n                    content: \"\";\n                    display: inline-block;\n                    position: absolute;\n                    right: 40%;\n                    bottom: 5px;\n                }\n\n                &:before{\n                    border-bottom: 11px solid $medium-pale-bg;\n                    border-left: 11px solid rgba(0, 0, 0, 0);\n                    border-right: 11px solid rgba(0, 0, 0, 0);\n                    content: \"\";\n                    display: inline-block;\n                    position: absolute;\n                    right: 40%;\n                    bottom: 6px;\n                }\n            }\n\n        }\n        .nav-item.show .nav-link{\n            background-color: transparent;\n        }\n        .dropdown-menu{\n            margin-top: -6px;\n            margin-left: -46px;\n            border-radius: 8px;\n\n            .dropdown-item:hover,\n            .dropdown-item.active{\n                color: #FFFFFF;\n                background-color: #68B3C8;\n            }\n            :before{\n                border-bottom: 11px solid $medium-pale-bg;\n                border-left: 11px solid rgba(0, 0, 0, 0);\n                border-right: 11px solid rgba(0, 0, 0, 0);\n                content: \"\";\n                display: inline-block;\n                position: absolute;\n                right: 12px;\n                top: -11px;\n            }\n            :after{\n                border-bottom: 11px solid $pale-bg;\n                border-left: 11px solid rgba(0, 0, 0, 0);\n                border-right: 11px solid rgba(0, 0, 0, 0);\n                content: \"\";\n                display: inline-block;\n                position: absolute;\n                right: 12px;\n                top: -10px;\n            }\n        }\n}\n.profile-content{\n    & .tab-content{\n        & .tab-pane{\n            min-height: 200px;\n        }\n        & #tweets, #connections, #media{\n            height: 100%;\n        }\n    }\n}\n\n\n\n.nav-text, .nav-icons{\n    margin: $margin-bottom;\n\n    > li > a{\n        display: block;\n        padding: 0px $padding-base-horizontal;\n        color: $dark-gray;\n        text-align: center;\n        @include opacity(0.8);\n\n        &:hover,\n        &:focus{\n            background-color: $transparent-bg;\n            @include opacity(1);\n        }\n    }\n    > li:first-child a{\n        padding-left: 0;\n    }\n    > li.active a{\n       color: $info-color;\n    }\n}\n.nav-icons > li{\n    display: inline-block;\n     > a{\n        padding: 0 10px;\n        margin-bottom: 10px;\n    }\n    > a i{\n        font-size: $font-size-h4;\n        margin-bottom: 10px;\n        width: $font-size-h4;\n    }\n}\n.nav-icons.nav-stacked > li{\n    display: block;\n    > a {\n        margin-bottom: 20px;\n    }\n}\n.nav-blue > li.active a{\n    color: $primary-color;\n}\n.nav-azure > li.active a{\n    color: $info-color;\n}\n.nav-green > li.active a{\n    color: $success-color;\n}\n.nav-orange > li.active a{\n    color: $warning-color;\n}\n.nav-red > li.active a{\n    color: $danger-color;\n}\n\n.nav-text{\n    margin: $margin-bottom;\n\n    > li > a{\n        font-size: $font-size-h6;\n        text-transform: uppercase;\n        padding: 3px 0;\n        text-align: left;\n        font-weight: $font-weight-semi;\n\n    }\n    > li:first-child > a{\n        padding-top: 0;\n    }\n    h4{\n        margin-top: 0;\n    }\n}\n\n.nav-text:not(.nav-stacked){\n    > li{\n        display: inline-block;\n    }\n    > li > a{\n        margin-right: 15px;\n    }\n}\n\n.tab-space {\n  padding: 20px 0 50px;\n}\n\n// Vertical navs\n\n.verical-navs .nav-stacked .nav-link.active:before,\n.verical-navs .nav-stacked .nav-link.active:hover:before,\n.verical-navs .nav-stacked .nav-link.active.show:before{\n    border-right: 11px solid #F1EAE0;\n    border-top: 11px solid transparent;\n    border-bottom: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 0;\n    bottom: 20px;\n}\n\n.verical-navs .nav-stacked .nav-link.active:after,\n.verical-navs .nav-stacked .nav-link.active:hover:after,\n.verical-navs .nav-stacked .nav-link.active.show:after{\n    border-right: 11px solid $white-color;\n    border-top: 11px solid transparent;\n    border-bottom: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: -1px;\n    bottom: 20px;\n}\n#second-tabs{\n    margin-left: 20px;\n}\n\n.nav-tabs-navigation.verical-navs {\n  border-right: 1px solid #F1EAE0;\n  font-size: 16px;\n  padding: 0 37px;\n  border-bottom: none;\n}\n",".popover{\n    font-size: $font-size-base;\n    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n    border: none;\n    line-height: 1.7;\n    max-width: 240px;\n\n    &.bs-popover-top .arrow:before,\n    &.bs-popover-left .arrow:before,\n    &.bs-popover-right .arrow:before,\n    &.bs-popover-bottom .arrow:before,{\n        border-top-color: transparent;\n        border-left-color: transparent;\n        border-right-color: transparent;\n        border-bottom-color: transparent;\n    }\n\n    .popover-header{\n        color: $default-color-opacity;\n        font-size: $font-size-base;\n        text-transform: capitalize;\n        font-weight: $font-weight-semi;\n        margin: 0;\n        margin-top: 5px;\n        border: none;\n        background-color: transparent;\n    }\n\n    &:before{\n        display: none;\n    }\n\n    &.bs-tether-element-attached-top:after{\n        border-bottom-color:$white-color;\n        top: -9px;\n    }\n\n    &.popover-primary{\n        @include popover-color($primary-color, $white-color);\n    }\n\n    &.popover-info{\n        @include popover-color($info-color, $white-color);\n    }\n\n    &.popover-warning{\n        @include popover-color($warning-color, $white-color);\n    }\n\n    &.popover-danger{\n        @include popover-color($danger-color, $white-color);\n    }\n\n    &.popover-success{\n        @include popover-color($success-color, $white-color);\n    }\n}\n\n\n.tooltip{\n    &.bs-tooltip-right .arrow:before{\n        border-right-color:$white-color;\n    }\n\n    &.bs-tooltip-top .arrow:before{\n        border-top-color:$white-color;\n    }\n\n    &.bs-tooltip-bottom .arrow:before{\n        border-bottom-color:$white-color;\n    }\n\n    &.bs-tooltip-left .arrow:before{\n        border-left-color:$white-color;\n    }\n}\n\n.tooltip-inner{\n    padding: $padding-base-vertical $padding-base-horizontal;\n    min-width: 130px;\n    background-color: $white-color;\n    font-size: $font-size-base;\n    color: inherit;\n    box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);\n}\n","@mixin popover-color($color, $text-color) {\n    background-color: $color;\n\n    .popover-body{\n        color: $text-color;\n    }\n\n\n    &.bs-popover-right .arrow:after{\n        border-right-color:$color;\n    }\n\n    &.bs-popover-top .arrow:after{\n        border-top-color:$color;\n    }\n\n    &.bs-popover-bottom .arrow:after{\n        border-bottom-color:$color;\n    }\n\n    &.bs-popover-left .arrow:after{\n        border-left-color:$color;\n    }\n\n    .popover-header{\n        color: $text-color;\n        opacity: .6;\n    }\n}\n",".modal-header {\n    border-bottom: 1px solid $medium-gray;\n    padding: 20px;\n    text-align: center;\n    display: block !important;\n\n    &.no-border-header{\n        border-bottom: 0 none !important;\n        & .modal-title{\n            margin-top: 20px;\n\n        }\n    }\n    button.close{\n      &:focus {\n        outline: none;\n      }\n    }\n\n    .modal-profile {\n      width: 70px;\n      height: 70px;\n      border-radius: 50%;\n      text-align: center;\n      line-height: 6.4;\n      border: 1px solid rgba(0,0,0,.3);\n\n      i {\n        font-size: 30px;\n      }\n    }\n}\n.modal-dialog{\n    &.modal-sm,\n    &.modal-register{\n        .modal-header{\n            button.close{\n                margin-top: 0;\n            }\n        }\n    }\n}\n\n.modal-content {\n    border: 0 none;\n    border-radius: 10px;\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);\n    .modal-header{\n        h6{\n            margin-top: 10px;\n        }\n    }\n}\n\n.modal-dialog {\n    padding-top: 60px;\n}\n.modal-body{\n    padding: 20px 50px;\n    color: #000;\n}\n.modal-footer {\n    border-top: 1px solid $medium-gray;\n    padding: 0px;\n\n    &.no-border-footer{\n        border-top: 0 none;\n    }\n}\n.modal-footer .left-side,\n.modal-footer .right-side{\n    display: inline-block;\n    text-align: center;\n    width: 50%;\n    padding: 5px;\n}\n.modal-footer .btn-link{\n    padding: 20px;\n    width: 100%;\n    margin: 0;\n}\n.modal-footer .divider{\n    background-color: $medium-gray;\n    display: inline-block;\n    float: inherit;\n    height: 63px;\n    margin: 0px -3px;\n    // position: absolute;\n    width: 1px;\n}\n.modal-register .modal-footer{\n    text-align: center;\n    margin-bottom: 25px;\n    padding: 20px 0 15px;\n    span{\n        width: 100%;\n    }\n}\n","// display flex was causing errors\n.carousel-item-next,\n.carousel-item-prev,\n.carousel-item.active{\n    display: block;\n}\n\n.carousel{\n    .carousel-inner{\n        box-shadow: $box-shadow-raised;\n    }\n    .nc-icon{\n        font-size: 2em;\n    }\n}\n",".wrapper{\n    position: relative;\n    top: 0;\n    height: 100vh;\n\n    &.wrapper-full-page{\n        min-height: 100vh;\n        height: auto;\n    }\n}\n\n.sidebar,\n.off-canvas-sidebar{\n    position: fixed;\n    top: 0;\n    height: 100%;\n    bottom: 0;\n    width: 260px;\n    left: 0;\n    z-index: 999;\n\n    .sidebar-wrapper{\n        position: relative;\n        height: calc(100vh - 75px);\n        overflow: auto;\n        width: 260px;\n        z-index: 4;\n        padding-bottom: 100px;\n\n        .dropdown .dropdown-backdrop{\n          display: none !important;\n        }\n\n        .navbar-form{\n            border: none;\n        }\n\n        > .nav,\n        .user .info{\n          [data-toggle=\"collapse\"] ~ div > ul > li > a{\n              span{\n                display: inline-block;\n                @extend .animation-transition-general;\n              }\n\n              .sidebar-normal {\n                margin: 0;\n                position: relative;\n                transform: translateX(0px);\n                opacity: 1;\n                white-space: nowrap;\n                display: block;\n                line-height: 20px;\n                z-index: 1;\n              }\n\n              .sidebar-mini-icon {\n                text-transform: uppercase;\n                width: 34px;\n                margin-right: 10px;\n                margin-left: 0px;\n                font-size: 12px;\n                text-align: center;\n                line-height: 20px;\n                position: relative;\n                float: left;\n                z-index: 1;\n                display: inherit;\n                color: $opacity-5;\n              }\n\n              .sidebar-normal {\n                text-transform: capitalize;\n              }\n\n              i{\n                font-size: 17px;\n                line-height: 20px;\n                width: 26px;\n              }\n            }\n        }\n    }\n\n    .navbar-minimize{\n      position: absolute;\n      right: 20px;\n      top: 2px;\n      opacity: 1;\n\n      @extend .animation-transition-general;\n    }\n    .logo-tim{\n      border-radius: 50%;\n      border: 1px solid #333;\n      display: block;\n      height: 61px;\n      width: 61px;\n      float: left;\n      overflow: hidden;\n\n      img{\n          width: 60px;\n          height: 60px;\n      }\n    }\n\n    .nav{\n        margin-top: 20px;\n        display: block;\n\n        .caret{\n            top: 14px;\n            position: absolute;\n            right: 10px;\n        }\n\n        li{\n            > a + div .nav li > a{\n                margin-top: 7px;\n            }\n\n            > a{\n                margin: 10px 15px 0;\n                color: $white-color;\n                display: block;\n                text-decoration: none;\n                position: relative;\n                text-transform: uppercase;\n                cursor: pointer;\n                font-size: 12px;\n                padding: 10px 8px;\n                line-height: 30px;\n                opacity: .7;\n            }\n\n            .nav > li > a{\n              padding: 5px 8px;\n            }\n\n            &.active > a,\n            &.active > a > i {\n              opacity: 1;\n              // color: $danger-color;\n            }\n\n            &:hover:not(.active) > a,\n            &:focus:not(.active) > a {\n                opacity: 1;\n            }\n\n            &.active > a[data-toggle=\"collapse\"] > {\n                background-color: transparent;\n                box-shadow: $box-shadow;\n            }\n\n            &.active > a[data-toggle=\"collapse\"],\n            &.active > a[data-toggle=\"collapse\"] i,\n            &.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active i,\n            &.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active > a {\n              color: $danger-color;\n\n              & + div .nav .active a {\n                background-color: transparent;\n                box-shadow: none;\n\n                &:after {\n                  content: \"\";\n                  position: absolute;\n                  width: calc(100% - 5px);\n                  z-index: 0;\n                }\n              }\n            }\n\n            &.active > a[data-toggle=\"collapse\"] ~ div > .nav {\n              margin-top: 0;\n            }\n        }\n\n        p{\n            margin: 0;\n            line-height: 30px;\n            position: relative;\n            display: block;\n            height: auto;\n            white-space: nowrap;\n            font-weight: 600;\n            @extend .animation-transition-general;\n        }\n\n        i{\n            font-size: 24px;\n            float: left;\n            margin-right: 12px;\n            line-height: 30px;\n            width: 34px;\n            text-align: center;\n            color: $opacity-5;\n            position: relative;\n        }\n\n        .collapse,\n        .collapsing {\n          .nav {\n            margin-top: 0;\n          }\n        }\n    }\n\n    .sidebar-background{\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n\n        &:after{\n            position: absolute;\n            z-index: 3;\n            width: 100%;\n            height: 100%;\n            content: \"\";\n            display: block;\n            background: #FFFFFF;\n            opacity: 1;\n        }\n    }\n\n    .logo{\n        position: relative;\n        padding: 7px $padding-base-horizontal;\n        z-index: 4;\n\n        a.logo-mini,\n        a.logo-normal{\n            @extend .animation-transition-general;\n        }\n\n        a.logo-mini{\n            opacity: 0;\n            float: left;\n            width: 34px;\n            text-align: center;\n            margin-left: 10px;\n            margin-right: 12px;\n        }\n\n        a.logo-normal{\n            display: block;\n            opacity: 1;\n            padding: 11px 0 8px;\n            @include transform-translate-x(0px);\n        }\n\n        &:after{\n            content: '';\n            position: absolute;\n            bottom: 0;\n            right: 15px;\n            height: 1px;\n            width: calc(100% - 30px);\n            background-color: $opacity-5;\n\n        }\n\n        p{\n            float: left;\n            font-size: 20px;\n            margin: 10px 10px;\n            color: $white-color;\n            line-height: 20px;\n            font-family: 'Muli', \"Helvetica\", Arial, sans-serif;\n        }\n\n        .simple-text{\n            text-transform: uppercase;\n            padding: $padding-base-vertical 0;\n            display: block;\n            white-space: nowrap;\n            font-size: $font-size-large;\n            color: $white-color;\n            text-decoration: none;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n            overflow: hidden;\n        }\n    }\n\n    .logo-tim{\n        border-radius: 50%;\n        border: 1px solid #333;\n        display: block;\n        height: 61px;\n        width: 61px;\n        float: left;\n        overflow: hidden;\n\n        img{\n            width: 60px;\n            height: 60px;\n        }\n    }\n\n    &:before,\n    &:after{\n        display: block;\n        content: \"\";\n        opacity: 1;\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n    }\n\n    &:after{\n        @include icon-gradient($default-color);\n        z-index: 3;\n    }\n\n    &[data-color=\"white\"]{\n      @include sidebar-color($white-color);\n      @include sidebar-text-color($default-color);\n    }\n    &[data-color=\"brown\"]{\n      @include sidebar-color($default-color);\n    }\n\n    // Active color changing\n\n    &[data-active-color=\"primary\"]{\n        @include sidebar-active-color($primary-color);\n    }\n    &[data-active-color=\"info\"]{\n        @include sidebar-active-color($info-color);\n    }\n    &[data-active-color=\"success\"]{\n        @include sidebar-active-color($success-color);\n    }\n    &[data-active-color=\"warning\"]{\n        @include sidebar-active-color($warning-color);\n    }\n    &[data-active-color=\"danger\"]{\n        @include sidebar-active-color($danger-color);\n    }\n\n    .user{\n        padding-bottom: 20px;\n        margin:20px auto 0;\n        position: relative;\n\n        &:after{\n            content: '';\n            position: absolute;\n            bottom: 0;\n            right: 15px;\n            height: 1px;\n            width: calc(100% - 30px);\n            background-color: rgba(255,255,255, .3);\n        }\n\n        .photo{\n            width: 34px;\n            height: 34px;\n            overflow: hidden;\n            float: left;\n            z-index: 5;\n            margin-right: 10px;\n            border-radius: 50%;\n            margin-left: 23px;\n            @extend .animation-transition-general;\n\n            img{\n                width: 100%;\n            }\n        }\n\n        a{\n            color: $white-color;\n            text-decoration: none;\n            padding: $padding-base-vertical 15px;\n            white-space: nowrap;\n            @extend .animation-transition-general;\n        }\n\n        .info{\n            > a{\n               display: block;\n               line-height: 18px;\n\n                > span{\n                   @extend .animation-transition-general;\n                   display: block;\n                   position: relative;\n                   opacity: 1;\n                }\n            }\n\n            .caret{\n                position: absolute;\n                top: 8px;\n                right: 18px;\n            }\n        }\n    }\n}\n\n.visible-on-sidebar-regular{\n    display: inline-block !important;\n}\n.visible-on-sidebar-mini{\n    display: none !important;\n}\n\n.off-canvas-sidebar{\n    .nav {\n        > li > a,\n        > li > a:hover{\n            color: $white-color;\n        }\n\n        > li > a:focus{\n            background: rgba(200, 200, 200, 0.2);\n        }\n    }\n}\n\n\n.main-panel{\n    position: relative;\n    float: right;\n    width: $sidebar-width;\n    background-color: #f4f3ef;\n\n    @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n    > .content{\n        padding: 0 30px 30px;\n        min-height: calc(100vh - 123px);\n        margin-top: 93px;\n    }\n\n    > .navbar{\n        margin-bottom: 0;\n    }\n\n\n    .header{\n        margin-bottom: 50px;\n    }\n}\n\n\n.perfect-scrollbar-on{\n  .sidebar,\n  .main-panel{\n      height: 100%;\n      max-height: 100%;\n  }\n}\n\n\n@media (min-width: 991px) {\n    .sidebar,\n    .main-panel,\n    .sidebar-wrapper{\n        -webkit-transition-property: top,bottom,width;\n        transition-property: top,bottom, width;\n        -webkit-transition-duration: .2s,.2s, .35s;\n        transition-duration: .2s,.2s, .35s;\n        -webkit-transition-timing-function: linear,linear,ease;\n        transition-timing-function: linear,linear,ease;\n        -webkit-overflow-scrolling: touch;\n    }\n\n\n    .sidebar-mini{\n        .visible-on-sidebar-regular{\n          display: none !important;\n        }\n        .visible-on-sidebar-mini{\n          display: inline-block !important;\n        }\n\n        .sidebar,\n        .sidebar .sidebar-wrapper{\n          width: 80px;\n        }\n\n        .main-panel{\n          width: $sidebar-mini-width;\n        }\n\n        .sidebar{\n          display: block;\n          z-index: 1030;\n\n          .logo{\n              a.logo-normal{\n                  opacity: 0;\n                  @include transform-translate-x(-25px);\n              }\n              a.logo-mini{\n                  opacity: 1;\n              }\n          }\n\n          .sidebar-wrapper{\n            > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n            .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n            .user .info > a > span,\n            > .nav li > a p{\n                @include transform-translate-x(-25px);\n                opacity: 0;\n            }\n          }\n        }\n\n        .sidebar:hover {\n          width: 260px;\n\n          .logo {\n            a.logo-normal {\n                opacity: 1;\n                @include transform-translate-x(0);\n            }\n          }\n\n          .navbar-minimize{\n            opacity: 1;\n          }\n          .sidebar-wrapper{\n            width: 260px;\n\n            > .nav li > a p,\n            > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n            .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n            .user .info > a > span{\n              @include transform-translate-x(0px);\n              opacity: 1;\n            }\n          }\n        }\n  }\n\n}\n\n.panel-header {\n  height: 260px;\n  padding-top: 80px;\n  padding-bottom: 45px;\n  background: #141E30;  /* fallback for old browsers */\n  background: -webkit-gradient(linear, left top, right top, from(#0c2646), color-stop(60%, #204065), to(#2a5788));\n  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);\n  position: relative;\n  overflow: hidden;\n\n  .header{\n    .title{\n      color: $white-color;\n    }\n    .category{\n      max-width: 600px;\n      color: $opacity-5;\n      margin: 0 auto;\n      font-size: 13px;\n\n      a{\n        color: $white-color;\n      }\n    }\n  }\n}\n\n.panel-header-sm{\n  height: 135px;\n}\n\n.panel-header-lg{\n  height: 380px;\n}\n\n\n// Stying for logos\n\n.sidebar .logo .simple-text .logo-img{\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    height: 34px;\n    width: 34px;\n    background: #FFFFFF;\n    border-radius: 50%;\n    text-align: center;\n    overflow: hidden;\n\n    img{\n      width: 51%;\n      vertical-align: unset;\n      height: 55px;\n    }\n}\n\n.sidebar {\n  &[data-color=\"white\"] {\n    border-right: 1px solid #ddd;\n  }\n}\n",".card-timeline{\n    .timeline {\n        list-style: none;\n        padding: 20px 0 20px;\n        position: relative;\n\n        &:before {\n            top: 0;\n            bottom: 0;\n            position: absolute;\n            content: \" \";\n            width: 3px;\n            background-color: darken($light-gray, 3%);\n            left: 50%;\n            margin-left: -1.5px;\n        }\n\n        .timeline-footer{\n          .btn{\n            margin: 0;\n          }\n        }\n\n        h6{\n            color: $dark-gray;\n            font-weight: 400;\n            margin: 10px 0px 0px;\n        }\n\n        &.timeline-simple{\n\n            &:before{\n                left: 5%;\n            }\n\n            > li > .timeline-panel{\n                width: 86%;\n            }\n\n            > li > .timeline-badge{\n                left: 5%;\n            }\n        }\n\n        > li {\n            margin-bottom: 20px;\n            position: relative;\n\n            &:before,\n            &:after {\n                content: \" \";\n                display: table;\n            }\n\n            &:after {\n                clear: both;\n            }\n\n        }\n\n        > li > .timeline-panel {\n            width: 45%;\n            float: left;\n            padding: 20px;\n            border-radius: $border-radius-small;\n            box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\n            background-color: $white-color;\n            color: $black-color;\n            margin-bottom: 20px;\n            position: relative;\n\n            &:before {\n                position: absolute;\n                top: 26px;\n                right: -15px;\n                display: inline-block;\n                border-top: 15px solid transparent;\n                border-left: 15px solid $light-gray;\n                border-right: 0 solid $light-gray;\n                border-bottom: 15px solid transparent;\n                content: \" \";\n            }\n\n            &:after {\n                position: absolute;\n                top: 27px;\n                right: -14px;\n                display: inline-block;\n                border-top: 14px solid transparent;\n                border-left: 14px solid $white-color;\n                border-right: 0 solid $white-color;\n                border-bottom: 14px solid transparent;\n                content: \" \";\n            }\n        }\n\n\n\n        > li > .timeline-badge {\n            color: $white-color;\n            width: 50px;\n            height: 50px;\n            text-align: center;\n            position: absolute;\n            top: 16px;\n            left: 50%;\n            margin-left: -25px;\n            background-color: $dark-gray;\n            z-index: 100;\n            border-top-right-radius: 50%;\n            border-top-left-radius: 50%;\n            border-bottom-right-radius: 50%;\n            border-bottom-left-radius: 50%;\n            border: 3px solid #f4f3ef;\n\n            [class^=\"fa-\"],\n            [class*=\" fa-\"]{\n                line-height: inherit;\n            }\n\n            .nc-icon{\n              line-height: 2.1;\n              width: 25px;\n              text-align: center;\n              font-size: 21px;\n            }\n        }\n\n\n\n        > li.timeline-inverted > .timeline-panel {\n            float: right;\n            background-color: #fff;\n\n            &:before {\n                border-left-width: 0;\n                border-right-width: 15px;\n                left: -15px;\n                right: auto;\n            }\n\n            &:after {\n                border-left-width: 0;\n                border-right-width: 14px;\n                left: -14px;\n                right: auto;\n            }\n\n        }\n\n\n    }\n    .timeline-heading{\n        margin-bottom: 15px;\n    }\n    .timeline-badge.primary {\n      background-color: $info-color !important;\n    }\n    .timeline-badge.info {\n      background-color: $info-color !important;\n    }\n\n    .timeline-badge.success {\n      background-color: $success-color !important;\n    }\n\n    .timeline-badge.warning {\n      background-color: $warning-color !important;\n    }\n\n    .timeline-badge.danger {\n      background-color: $danger-color !important;\n    }\n\n\n    .timeline-title {\n      margin-top: 0;\n      color: inherit;\n    }\n\n    .timeline-body > p,\n    .timeline-body > ul {\n      margin-bottom: 0;\n    }\n\n    .timeline-body > p + p {\n      margin-top: 5px;\n    }\n}\n",".card{\n  border-radius: $border-radius-extreme;\n  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);\n  background-color: #FFFFFF;\n  color: $card-black-color;\n  margin-bottom: 20px;\n  position: relative;\n  border: 0 none;\n\n  -webkit-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\n  -moz-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\n  -o-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\n  -ms-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\n  transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\n\n    .card-body{\n        padding: 15px 15px 10px 15px;\n\n        &.table-full-width{\n            padding-left: 0;\n            padding-right: 0;\n        }\n    }\n\n    .card-header{\n      &:not([data-background-color]){\n        background-color: transparent;\n      }\n      padding: 15px 15px 0;\n      border: 0;\n\n      .card-title{\n          margin-top: 10px;\n      }\n    }\n\n    .map{\n        border-radius: $border-radius-small;\n\n        &.map-big{\n          height: 400px;\n        }\n    }\n\n    &[data-background-color=\"orange\"]{\n        background-color: $primary-color;\n\n        .card-header{\n            background-color: $primary-color;\n        }\n\n        .card-footer{\n            .stats{\n                color: $white-color;\n            }\n        }\n    }\n\n    &[data-background-color=\"red\"]{\n        background-color: $danger-color;\n    }\n\n    &[data-background-color=\"yellow\"]{\n        background-color: $warning-color;\n    }\n\n    &[data-background-color=\"blue\"]{\n        background-color: $info-color;\n    }\n\n    &[data-background-color=\"green\"]{\n        background-color: $success-color;\n    }\n\n    .image{\n        overflow: hidden;\n        height: 200px;\n        position: relative;\n    }\n\n    .avatar{\n        width: 30px;\n        height: 30px;\n        overflow: hidden;\n        border-radius: 50%;\n        margin-bottom: 15px;\n    }\n\n    .numbers {\n      font-size: 2em;\n    }\n\n    .big-title {\n      font-size: 12px;\n      text-align: center;\n      font-weight: 500;\n      padding-bottom: 15px;\n    }\n\n    label{\n        font-size: $font-size-small;\n        margin-bottom: 5px;\n        color: $dark-gray;\n    }\n\n    .card-footer{\n        background-color: transparent;\n        border: 0;\n\n\n        .stats{\n            i{\n                margin-right: 5px;\n                position: relative;\n                top: 0px;\n                color: $default-color;\n            }\n        }\n\n        .btn{\n            margin: 0;\n        }\n    }\n\n    &.card-plain{\n        background-color: transparent;\n        box-shadow: none;\n        border-radius: 0;\n\n\n        .card-body{\n            padding-left: 5px;\n            padding-right: 5px;\n        }\n\n        img{\n            border-radius: $border-radius-extreme;\n        }\n    }\n}\n",".card-chart {\n  .card-header{\n    .card-title{\n      margin-top: 10px;\n      margin-bottom: 0;\n    }\n    .card-category{\n      margin-bottom: 5px;\n    }\n  }\n\n  .table{\n    margin-bottom: 0;\n\n    td{\n      border-top: none;\n      border-bottom: 1px solid #e9ecef;\n    }\n  }\n\n  .card-progress {\n    margin-top: 30px;\n  }\n\n  .chart-area {\n    height: 190px;\n    width: calc(100% + 30px);\n    margin-left: -15px;\n    margin-right: -15px;\n  }\n  .card-footer {\n    margin-top: 15px;\n\n    .stats{\n      color: $dark-gray;\n    }\n  }\n\n  .dropdown{\n    position: absolute;\n    right: 20px;\n    top: 20px;\n\n    .btn{\n      margin: 0;\n    }\n  }\n}\n",".map{\n    height: 500px;\n}\n",".card-user{\n    .image{\n        height: 130px;\n\n      img {\n        border-radius: 12px;\n      }\n    }\n\n    .author{\n        text-align: center;\n        text-transform: none;\n        margin-top: -77px;\n\n        a +  p.description{\n            margin-top: -7px;\n        }\n    }\n\n    .avatar{\n        width: 124px;\n        height: 124px;\n        border: 1px solid $white-color;\n        position: relative;\n    }\n\n    .card-body{\n        min-height: 240px;\n    }\n\n    hr{\n        margin: 5px 15px 15px;\n    }\n\n    .card-body + .card-footer {\n      padding-top: 0;\n    }\n\n    .card-footer {\n      h5 {\n        font-size: 1.25em;\n        margin-bottom: 0;\n      }\n    }\n\n    .button-container{\n        margin-bottom: 6px;\n        text-align: center;\n    }\n}\n",".card-background{\n    background-position: center center;\n    background-size: cover;\n    text-align: center;\n\n    .card-body{\n        position: relative;\n        z-index: 2;\n        min-height: 370px;\n        max-width: 530px;\n        margin: 0 auto;\n        padding-top: 60px;\n        padding-bottom: 60px;;\n    }\n    .card-footer{\n      position: relative;\n      z-index: 2;\n    }\n\n    &.card-background-product .card-body{\n        max-width: 400px;\n        .card-title{\n            margin-top: 30px;\n        }\n    }\n\n    .stats{\n        color: $white-color;\n    }\n\n    .card-footer{\n        .stats-link > a{\n            color: $white-color;\n            line-height: 1.9;\n        }\n    }\n\n    .category,\n    .card-description,\n    small{\n        color: $opacity-8;\n    }\n\n    .card-title {\n        color: $white-color;\n        margin-top: 130px;\n    }\n\n    &:not(.card-pricing) .btn {\n        margin-bottom: 0;\n    }\n\n    &::after {\n        position: absolute;\n        z-index: 1;\n        width: 100%;\n        height: 100%;\n        display: block;\n        left: 0;\n        top: 0;\n        content: \"\";\n        background-color: rgba(0,0,0,.63);\n        border-radius: $border-radius-large;\n    }\n}\n",".card-collapse{\n  padding-bottom: 10px;\n    .card{\n      margin-bottom: 0px;\n\n      .card-header{\n        position: relative;\n        padding: 20px 0;\n\n          a[data-toggle=\"collapse\"]{\n            display: block;\n            color: $light-black;\n\n              i{\n                float: right;\n                position: relative;\n                color: #f96332;\n                top: 3px;\n                right: 5px;\n                @extend .animation-transition-general;\n              }\n          }\n\n          &:after{\n            content: \"\";\n            position: absolute;\n            bottom: 0;\n            left: 0;\n            width: 100%;\n            height: 1px;\n            background-color: $light-gray;\n          }\n        }\n\n        .card-body{\n          padding: 20px 15px;\n        }\n    }\n}\n",".card-contributions{\n  @extend %card-stats;\n\n  .card-description{\n    max-width: 350px;\n    margin: 0 auto;\n    margin-bottom: 20px;\n  }\n\n  .card-title{\n    padding-top: 35px;\n  }\n\n  .card-stats{\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    padding: 11px;\n  }\n\n  .card-footer{\n    [class*=\"col-\"]:not(:first-child):before{\n      content: \"\";\n      position: absolute;\n      left: 0;\n      width: 1px;\n      height: 100%;\n      background-color: $hr-line;\n    }\n  }\n\n  .bootstrap-switch{\n    margin: 0;\n  }\n\n  span{\n    padding-left: 15px;\n    text-align: left;\n    max-width: 125px;\n  }\n\n}\n",".card .info-area{\n  padding: 40px 0 40px;\n  text-align: center;\n  position: relative;\n  z-index: 2;\n}\n",".card-lock{\n    .card-header{\n        img{\n            width: 120px;\n            height: 120px;\n            border-radius: 50%;\n            margin-top: -70px;\n        }\n    }\n\n}\n",".card-pricing{\n    text-align: center;\n\n    .card-body{\n        padding: 15px!important;\n    }\n    .card-category{\n        margin: 10px 0 10px;\n        color: $black-color;\n    }\n    .card-icon{\n        padding: 15px 0 5px;\n        transform: translateY(0%);\n        color: $black-color;\n\n        &.icon-info{\n            color: $info-color;\n        }\n        &.icon-danger{\n            color: $danger-color;\n        }\n        &.icon-primary{\n            color: $primary-color;\n        }\n        &.icon-success{\n            color: $success-color;\n        }\n        &.icon-warning{\n            color: $warning-color;\n        }\n\n        i {\n          font-size: 40px;\n          width: 105px;\n          border: 2px solid $table-line-color;\n          border-radius: 50%;\n          height: 105px;\n          line-height: 105px;\n        }\n    }\n    .card-title{\n        margin-top: 30px !important;\n    }\n    ul{\n        list-style: none;\n        padding: 0;\n        max-width: 240px;\n        margin: 20px auto;\n\n        li{\n            padding: 5px 0;\n            list-style-type: none;\n            b{\n                font-weight: 600;\n                color: $black-color;\n            }\n        }\n    }\n    .btn-neutral{\n        color: $default-color;\n\n        &:hover, :focus{\n            color: $default-states-color;\n        }\n    }\n\n    &.card-background-image{\n        ul{\n            li{\n                color: $white-color;\n                text-align: center;\n                border-color: rgba(255,255,255,.3);\n\n                b{\n                    color: $white-color !important;\n                }\n            }\n        }\n        .card-description{\n            color: $white-color !important;\n        }\n        .card-title{\n            small{\n                color: rgba(255, 255, 255, 0.6);\n            }\n        }\n    }\n}\n\n.card-pricing.card-plain{\n    .card-category,\n    .card-title{\n        color: $black-color;\n    }\n    ul{\n        li{\n            b{\n                font-weight: 600;\n                color: $black-color;\n            }\n        }\n    }\n}\n\n\n.card[data-background=\"image\"] .card-icon i,\n.card[data-background=\"color\"] .card-icon i,\n.card[data-color] .card-icon i {\n  color: $white-color;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n}\n","%card-profile{\n    margin-top: 30px;\n    text-align: center;\n\n    .card-body .card-title{\n        margin-top: 0;\n    }\n\n     [class*=col-]{\n        .card-description{\n            margin-bottom: 0;\n\n            & + .card-footer{\n                margin-top: 8px;\n            }\n        }\n\n\n     }\n\n    .card-header-avatar{\n        max-width: 130px;\n        max-height: 130px;\n        margin: -60px auto 0;\n\n        img{\n            border-radius: 50% !important;\n        }\n\n        & + .card-body{\n            margin-top: 15px;\n        }\n    }\n\n    &.card-plain{\n        .card-header-avatar{\n            margin-top: 0;\n        }\n    }\n    .card-body{\n        .card-avatar{\n            margin: 0 auto 30px;\n        }\n    }\n}\n\n.card-profile{\n  @extend %card-profile;\n}\n",".card-signup{\n    .header{\n        margin-left: 20px;\n        margin-right: 20px;\n        padding: 30px 0;\n    }\n    .text-divider{\n        margin-top: 30px;\n        margin-bottom: 0px;\n        text-align: center;\n    }\n    .content{\n        padding: 0px 30px;\n    }\n\n    .form-check{\n        margin-top: 20px;\n\n        label{\n          margin-left: 7px;\n          padding-left: 38px;\n        }\n    }\n\n    .social-line{\n        margin-top: 20px;\n        text-align: center;\n\n        .btn.btn-icon ,\n        .btn.btn-icon .btn-icon{\n            margin-left: 5px;\n            margin-right: 5px;\n            box-shadow: 0px 5px 50px 0px rgba(0, 0, 0, 0.2);\n        }\n    }\n\n    .card-footer{\n        margin-bottom: 10px;\n        margin-top: 24px;\n    }\n}\n",".card-stats-mini {\n  &.card-background::after {\n    background-image: linear-gradient(to right, #434343 0%, black 100%);\n    opacity: .94;\n  }\n\n  .card-body {\n    &::after {\n      clear: both;\n      content: '';\n      display: block;\n    }\n  }\n\n  .card-footer {\n    border-top: 1px solid $opacity-2;\n    margin: 0 15px;\n  }\n\n  &.card-background {\n    .card-body {\n      min-height: auto;\n      padding-top: 15px;\n      padding-bottom: 15px;\n    }\n  }\n\n  .card-title {\n    margin-top: 0;\n    margin-bottom: 5px;\n  }\n\n  .info-area {\n    text-align: left;\n    width: 40%;\n    float: left;\n    padding: 15px 0;\n\n    .icon > i {\n      font-size: 2em;\n    }\n  }\n\n  .chart-area {\n    float: left;\n    width: 60%;\n  }\n\n  .stats {\n    text-align: left;\n    color: $white-color;\n  }\n}\n","%card-stats{\n  hr{\n    margin: 5px 15px;\n  }\n}\n\n\n.card-stats{\n    .card-body{\n        padding: 15px 15px 0px;\n\n        .numbers{\n          text-align: right;\n          font-size: 2em;\n\n            p{\n                margin-bottom: 0;\n            }\n            .card-category {\n              color: $dark-gray;\n              font-size: 16px;\n              line-height: 1.4em;\n            }\n        }\n    }\n    .card-footer{\n        padding: 0px 15px 15px;\n\n        .stats{\n          color: $dark-gray;\n        }\n\n        hr{\n          margin-top: 10px;\n          margin-bottom: 15px;\n        }\n    }\n    .icon-big {\n        font-size: 3em;\n        min-height: 64px;\n\n        i{\n            line-height: 59px;\n        }\n    }\n\n\n}\n",".card-subcategories .card-body{\n    padding-bottom: 30px;\n}\n",".card-testimonial{\n    margin-top: 30px;\n    text-align: center;\n\n    .icon{\n        padding: 0;\n\n        i{\n            font-size: 30px;\n            border: 0;\n            display: block;\n            line-height: 100px;\n            margin: 0px auto;\n            margin-bottom: 0px;\n        }\n    }\n    .card-body{\n        padding: 15px 30px;\n\n        .card-description{\n            font-style: italic;\n            font-size: 16px;\n        }\n        .card-category{\n            margin-bottom: 20px;\n        }\n\n        +.card-footer {\n          padding-top: 0;\n          margin-top: -20px;\n        }\n    }\n\n    .card-avatar{\n        margin-top: 0;\n        .img{\n            border-radius: 50%;\n            width: 100px;\n            height: 100px;\n        }\n    }\n\n    .card-footer{\n        .card-title{\n            color: $black-color;\n            text-align: center;\n        }\n        .card-category{\n            color: $dark-gray;\n        }\n        .card-avatar{\n            margin-top: 20px;\n            .img{\n                border-radius: 50%;\n                width: 60px;\n                height: 60px;\n            }\n        }\n    }\n}\n\n.card-testimonial .card-description + .card-title{\n    margin-top: 30px;\n\n    & .card-image{\n        .img{\n            border-radius: $border-radius-extreme;\n        }\n\n        .card-title{\n            text-align: center;\n        }\n    }\n}\n",".card-tasks{\n  text-align: left;\n    .table tbody{\n        td:last-child{\n            padding-right: 0;\n            display: inline-flex;\n            .btn{\n                padding: 3px;\n            }\n        }\n        td:first-child{\n            padding-left: 0;\n        }\n        td {\n          padding: 12px 8px !important;\n        }\n    }\n    .table-full-width{\n        padding-bottom: 0 !important;\n    }\n    .card-footer{\n        padding-top: 0;\n    }\n    .table{\n        margin-bottom: 0 !important;\n    }\n}\n",".login-page{\n  .content .container {\n    margin-top: 8vh;\n  }\n\n    .card-login{\n        border-radius: $border-radius-large;\n        padding-bottom: $padding-base-horizontal;\n\n        .btn-wd{\n            min-width: 180px;\n        }\n\n        .logo-container{\n            width: 65px;\n            margin: 0 auto;\n            margin-bottom: 55px;\n\n            img{\n                width: 100%;\n            }\n        }\n\n        .input-group:last-child{\n            margin-bottom: 40px;\n        }\n\n        &.card-plain{\n            @include input-coloured-bg($opacity-5, $white-color, $white-color, $transparent-bg, $opacity-1, $opacity-2);\n\n            .input-group-addon,\n            .form-group.no-border .input-group-addon,\n            .input-group.no-border .input-group-addon{\n                color: $opacity-8;\n            }\n        }\n    }\n\n    .link{\n        font-size: 10px;\n        color: $white-color;\n        text-decoration: none;\n    }\n}\n\n.full-page{\n    & > .content,\n    & > .footer{\n        position: relative;\n        z-index: 4;\n    }\n\n    &.section-image{\n        position: initial;\n    }\n\n    & > .content{\n        padding-top: 21vh;\n    }\n\n    .footer{\n        position: absolute;\n        width: 100%;\n        bottom: 0;\n\n        .container{\n            color: $white-color;\n        }\n    }\n\n    .full-page-background{\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n    }\n\n    &:after{\n        position: absolute;\n        z-index: 1;\n        width: 100%;\n        height: 100%;\n        display: block;\n        left: 0;\n        top: 0;\n        content: \"\";\n        background-color: rgba(0, 0, 0, 0.6);\n    }\n\n    &.pricing-page{\n        .description{\n            margin-bottom: 65px;\n        }\n    }\n\n    &.register-page{\n        .content > .container {\n          margin-top: 5vh;\n        }\n        .info-horizontal{\n            padding: 0px 0px 20px;\n        }\n\n        .info-horizontal{\n            text-align: left !important;\n\n            .icon{\n                margin-top: 0;\n\n                >i{\n                    font-size: 2em;\n                }\n\n                &.icon-circle{\n                    width: 65px;\n                    height: 65px;\n                    max-width: 65px;\n                    margin-top: 8px;\n\n                    i{\n                        display: table;\n                        margin: 0 auto;\n                        line-height: 3.5;\n                        font-size: 1.9em;\n                    }\n                }\n            }\n            .description{\n                overflow: hidden;\n            }\n\n        }\n    }\n\n    &.lock-page {\n      .content > .container {\n        margin-top: 10vh;\n      }\n    }\n}\n\n.register-page,\n.login-page,\n.lock-page {\n  .navbar {\n    .navbar-collapse {\n      .nav-item .nav-link {\n        text-transform: capitalize;\n        color: $white-color !important;\n      }\n    }\n\n    &.navbar-transparent {\n      border-bottom: 1px solid transparent;\n      margin-top: 25px;\n    }\n\n    .navbar-brand {\n      color: $white-color !important;\n    }\n  }\n}\n\n@media screen and (max-width: 991px){\n  .register-page,\n  .login-page,\n  .lock-page {\n    .navbar {\n      &.bg-white {\n        .navbar-toggler .navbar-toggler-bar.navbar-kebab {\n            background: $default-color !important;\n          }\n        .navbar-collapse {\n          .navbar-nav {\n            .nav-item .nav-link {\n              color: $default-color !important;\n            }\n          }\n        }\n        .navbar-brand {\n          color: $default-color !important;\n        }\n      }\n\n      &.navbar-transparent {\n        .navbar-toggle {\n          display: none;\n        }\n        .navbar-toggler {\n          .navbar-toggler-bar.navbar-kebab {\n            background: $white-color !important;\n          }\n        }\n      }\n    }\n  }\n}\n",".section{\n    padding: 70px 0;\n    position: relative;\n    background: $white-color;\n\n    .row + .category{\n        margin-top: $margin-base-vertical;\n    }\n}\n.section-navbars{\n    padding-bottom: 0;\n}\n\n.section-full-screen{\n    height: 100vh;\n}\n.section-signup{\n    padding-top: 20vh;\n}\n\n.parallax-s{\n    overflow: hidden;\n    height: 500px;\n    width: 100%;\n}\n\n.section-image{\n    background-size: cover;\n    background-position: center center;\n    position: relative;\n    width: 100%;\n\n    .title,\n    .card-plain .card-title{\n        color: $white-color;\n    }\n\n    .nav-pills .nav-link{\n        background-color: $white-color;\n\n        &:hover,\n        &:focus{\n            background-color: $white-color;\n        }\n    }\n\n    .info-title,\n    .info-area.info-horizontal .icon i,\n    .card-pricing.card-plain ul li{\n        color: $white-color;\n    }\n    .description,\n    .info-area .icon:not(.icon-circle){\n        color: $opacity-8;\n    }\n    .card:not(.card-plain){\n        .info-title{\n            color: $black-color;\n        }\n        .info-area p,\n        .info-area .icon,\n        .description{\n            color: $dark-gray;\n        }\n    }\n\n    .footer{\n        color: $white-color;\n    }\n    .card-plain{\n        [class*=\"text-\"],\n        ul li b{\n            color: $white-color;\n        }\n        .category{\n            color: rgba($white-color,.5);\n        }\n    }\n\n    &:after{\n        position: absolute;\n        z-index: 1;\n        width: 100%;\n        height: 100%;\n        display: block;\n        left: 0;\n        top: 0;\n        content: \"\";\n        background-color: rgba(0,0,0,.7);\n    }\n\n    .container{\n        z-index: 2;\n        position: relative;\n    }\n}\n\n.page-header{\n    min-height: 100vh;\n    max-height: 999px;\n    padding: 0;\n    color: $white-color;\n    position: relative;\n\n    .page-header-image{\n        position: absolute;\n        background-size: cover;\n        background-position: center center;\n        width: 100%;\n        height: 100%;\n        z-index: -1;\n    }\n\n    .content-center{\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        z-index: 2;\n        -ms-transform: translate(-50%, -50%);\n        -webkit-transform: translate(-50%, -50%);\n        transform: translate(-50%, -50%);\n        text-align: center;\n        color: #FFFFFF;\n        padding: 0 15px;\n        width: 100%;\n        max-width: 880px;\n\n    }\n\n    footer{\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .container{\n        height: 100%;\n        z-index: 1;\n    }\n\n    .category,\n    .description{\n        color: $opacity-8;\n    }\n\n    &.page-header-small{\n        min-height: 60vh;\n        max-height: 440px;\n    }\n\n    &.page-header-mini{\n        min-height: 40vh;\n        max-height: 340px;\n    }\n\n    .title{\n        margin-bottom: 15px;\n    }\n    .title + h4{\n        margin-top: 10px;\n    }\n\n    &:after,\n    &:before{\n        position: absolute;\n        z-index: 0;\n        width: 100%;\n        height: 100%;\n        display: block;\n        left: 0;\n        top: 0;\n        content: \"\";\n    }\n\n    &:before{\n        background-color: rgba(0,0,0,.3);\n    }\n\n    &[filter-color=\"orange\"]{\n        @include linear-gradient(rgba($black-color,.20), rgba(224, 23, 3, 0.6));\n    }\n}\n\n.clear-filter{\n    &:after,\n    &:before{\n        display: none;\n    }\n}\n\n.section-story-overview{\n    padding: 50px 0;\n\n    .image-container{\n        height: 335px;\n        position: relative;\n        background-position: center center;\n        background-size: cover;\n        box-shadow: $box-shadow-raised;\n        border-radius: .25rem;\n\n        & + .category{\n            padding-top: 15px;\n        }\n\n        &.image-right{\n            z-index: 2;\n\n            + h3.title{\n                margin-top: 120px;\n            }\n        }\n\n        &.image-left{\n            z-index: 1;\n        }\n\n        img{\n            width: 100%;\n            left: 0;\n            top: 0;\n            height: auto;\n            position: absolute;\n        }\n\n        &:nth-child(2){\n            margin-top: 420px;\n            margin-left: -105px;\n        }\n    }\n\n    p.blockquote{\n        width: 220px;\n        min-height: 180px;\n        text-align: left;\n        position: absolute;\n        top: 376px;\n        right: 155px;\n        z-index: 0;\n    }\n}\n\n.section-nucleo-icons{\n     .nucleo-container img{\n        width: auto;\n        left: 0;\n        top: 0;\n        height: 100%;\n        position: absolute;\n    }\n\n     .nucleo-container{\n        height: 335px;\n        position: relative;\n    }\n\n     h5{\n        margin-bottom: 35px;\n    }\n\n     .icons-container{\n        position: relative;\n        max-width: 450px;\n        height: 300px;\n        max-height: 300px;\n        margin: 0 auto;\n\n    }\n     .icons-container i{\n        font-size: 34px;\n        position: absolute;\n        left: 0;\n        top: 0;\n    }\n\n     .icons-container i:nth-child(1){\n        top: 5%;\n        left: 7%;\n    }\n\n     .icons-container i:nth-child(2){\n         top: 28%;\n         left: 24%;\n    }\n\n     .icons-container i:nth-child(3){\n         top: 40%;\n    }\n\n     .icons-container i:nth-child(4){\n         top: 18%;\n         left: 62%;\n    }\n\n     .icons-container i:nth-child(5){\n         top: 74%;\n         left: 3%;\n    }\n\n     .icons-container i:nth-child(6){\n         top: 36%;\n         left: 44%;\n        font-size: 65px;\n        color: #f96332;\n        padding: 1px;\n    }\n\n     .icons-container i:nth-child(7){\n         top: 59%;\n         left: 26%;\n    }\n\n     .icons-container i:nth-child(8){\n         top: 60%;\n         left: 69%;\n    }\n\n     .icons-container i:nth-child(9){\n        top: 72%;\n        left: 47%;\n    }\n\n     .icons-container i:nth-child(10){\n         top: 88%;\n         left: 27%;\n    }\n\n     .icons-container i:nth-child(11){\n         top: 31%;\n         left: 80%;\n    }\n\n     .icons-container i:nth-child(12){\n         top: 88%;\n         left: 68%;\n    }\n\n     .icons-container i:nth-child(13){\n         top: 5%;\n         left: 81%;\n    }\n\n     .icons-container i:nth-child(14){\n         top: 58%;\n         left: 90%;\n    }\n\n     .icons-container i:nth-child(15){\n        top: 6%;\n        left: 40%;\n    }\n}\n\n.section-images{\n    max-height: 670px;\n    height: 670px;\n\n    .hero-images-container,\n    .hero-images-container-1,\n    .hero-images-container-2{\n        margin-top: -38vh;\n    }\n\n    .hero-images-container{\n        max-width: 670px;\n    }\n\n    .hero-images-container-1{\n        max-width: 390px;\n        position: absolute;\n        top: 55%;\n        right: 18%;\n\n    }\n\n    .hero-images-container-2{\n        max-width: 225px;\n        position: absolute;\n        top: 68%;\n        right: 12%;\n    }\n}\n\n[data-background-color=\"gray\"]{\n    background-color: lighten($default-color, 40%);\n}\n\n[data-background-color=\"orange\"]{\n    background-color: $orange-bg;\n}\n[data-background-color=\"black\"]{\n    background-color: $black-color;\n}\n\n[data-background-color]:not([data-background-color=\"gray\"]){\n    color: $white-color;\n\n    .separator-line{\n        background-color: $opacity-5;\n    }\n\n    .footer{\n        &.footer-white .footer-brand,\n        &.footer-white ul li > a.nav-link:not(.btn-icon){\n            color: initial;\n        }\n    }\n\n    .pagination .page-item.disabled > .page-link{\n      background-color: $opacity-2; \n      color: $white-color;\n    }\n\n    .card:not(.card-plain) .category,\n    .card:not(.card-plain) .card-description,\n    & .card:not(.card-plain) .category,\n    & .card:not(.card-plain) .category{\n        color: $dark-gray;\n    }\n\n    .card:not(.card-plain) .card-title,\n    & .card:not(.card-plain) .card-title{\n        color: initial;\n    }\n\n    .carousel .carousel-inner{\n        box-shadow: none;\n    }\n\n    .title,\n    .social-description h2,\n    p,\n    p.blockquote,\n    p.blockquote small,\n    h1,h2,h3,h4,h5,h6,\n    a:not(.btn):not(.dropdown-item):not(.card-link),\n    .icons-container i,\n    &.card-pricing ul li,\n    .info.info-horizontal .icon i,\n    .card-pricing.card-plain ul li{\n        color: $white-color;\n    }\n\n    &.card a:not(.btn):not(.dropdown-item){\n        color: $white-color;\n\n        &:hover,\n        &:focus{\n            border-color: $white-color;\n        }\n    }\n\n    &.footer hr,\n    &.card-pricing .icon i,\n    &.card-pricing ul li{\n        border-color: $opacity-2;\n    }\n\n    .card-footer .stats i,\n    &.card-plain .category,\n    .card-plain .category,\n    .card-header:after{\n        color: $opacity-5;\n    }\n\n    &.card-pricing ul li i,\n    &.card-pricing ul li b,\n    .card-pricing.card-plain ul li b,\n    .card-category,\n    .author span,\n    .card-pricing.card-plain ul li i{\n        color: $opacity-8 !important;\n    }\n\n    .separator{\n        background-color: $white-color;\n    }\n\n    .navbar.bg-white p{\n        color: $default-color;\n    }\n\n    .description,\n    .social-description p{\n        color: $opacity-8;\n    }\n\n    p.blockquote{\n        border-color: $opacity-2;\n    }\n\n    //radio and checkboxes\n    .checkbox label::before,\n    .checkbox label::after,\n    .radio label::before,\n    .radio label::after{\n        border-color: $opacity-2;\n    }\n\n    .checkbox label::after,\n    .checkbox label,\n    .radio label{\n        color: $white-color;\n    }\n\n    .checkbox input[type=\"checkbox\"]:disabled + label,\n    .radio input[type=\"radio\"]:disabled + label  {\n        color: $white-color;\n    }\n\n    .radio input[type=\"radio\"]:not(:disabled):hover + label::after,\n    .radio input[type=\"radio\"]:checked + label::after {\n        background-color: $white-color;\n        border-color: $white-color;\n    }\n\n    //inputs\n    @include input-coloured-bg($opacity-5, $white-color, $white-color, $transparent-bg, $opacity-1, $opacity-2);\n\n    .input-group-addon,\n    .form-group.no-border .input-group-addon,\n    .input-group.no-border .input-group-addon{\n        color: $opacity-8;\n    }\n\n    .subscribe-line{\n        .form-control{\n            background-color: $transparent-bg;\n            border: 1px solid $light-gray;\n            color: $black-color;\n\n            &:last-child{\n                border-left: 0 none;\n            }\n        }\n\n        .input-group-addon,\n        .form-group.no-border .input-group-addon,\n        .input-group.no-border .input-group-addon{\n            color: $dark-background;\n            border: 1px solid $light-gray;\n        }\n    }\n\n\n    //buttons\n    .btn.btn-simple{\n        background-color: $transparent-bg;\n        border-color: $opacity-5;\n        color: $white-color;\n\n        &:hover,\n        &:hover,\n        &:focus,\n        &:active{\n            background-color: $transparent-bg;\n            border-color: $white-color;\n        }\n    }\n\n    //tabs\n    .nav-tabs{\n        > .nav-item{\n            >.nav-link{\n                i.nc-icon{\n                    color: $white-color;\n                }\n            }\n        }\n    }\n\n    &.section-nucleo-icons .icons-container i:nth-child(6){\n        color: $white-color;\n    }\n}\n","@mixin linear-gradient($color1, $color2){\n    background: $color1; /* For browsers that do not support gradients */\n    background: -webkit-linear-gradient(90deg, $color1 , $color2); /* For Safari 5.1 to 6.0 */\n    background: -o-linear-gradient(90deg, $color1, $color2); /* For Opera 11.1 to 12.0 */\n    background: -moz-linear-gradient(90deg, $color1, $color2); /* For Firefox 3.6 to 15 */\n    background: linear-gradient(0deg, $color1 , $color2); /* Standard syntax */\n}\n","@media screen and (max-width: 991px){\n\n  .navbar {\n    padding: 0;\n\n    &.navbar-absolute {\n      padding-top: 0;\n    }\n\n    .navbar-brand {\n      font-size: 16px;\n      margin-right: 0;\n    }\n  }\n\n    .profile-photo .profile-photo-small{\n        margin-left: -2px;\n    }\n\n    .button-dropdown{\n        display: none;\n    }\n\n    #minimizeSidebar{\n        display: none;\n    }\n\n    .navbar{\n        .container-fluid{\n            padding-right: 15px;\n            padding-left: 15px;\n        }\n\n        .navbar-collapse{\n          .input-group{\n            margin: 0;\n            margin-top: 5px;\n          }\n        }\n\n        .navbar-nav{\n            .nav-item:first-child{\n              margin-top: 10px;\n            }\n            .nav-item:not(:last-child){\n                margin-bottom: 10px;\n            }\n        }\n\n        .dropdown.show .dropdown-menu{\n            display: block;\n        }\n\n        .dropdown .dropdown-menu{\n            display: none;\n        }\n\n        .dropdown.show .dropdown-menu,\n        .dropdown .dropdown-menu{\n            border: 0;\n            transition: none;\n            -webkit-box-shadow: none;\n            width: auto;\n            margin: 0px 1rem;\n            margin-top: 0px;\n            box-shadow: none;\n            position: static;\n            padding-left: 10px;\n\n            &:before{\n                display: none;\n            }\n        }\n\n        .dropdown-menu .dropdown-item:focus,\n        .dropdown-menu .dropdown-item:hover{\n            color: $white-color;\n        }\n\n        &.bg-white .dropdown-menu .dropdown-item:focus,\n        &.bg-white .dropdown-menu .dropdown-item:hover{\n            color: $default-color;\n        }\n\n        .navbar-toggler-bar{\n            display: block;\n            position: relative;\n            width: 22px;\n            height: 1px;\n            border-radius: 1px;\n            background: $default-color;\n\n            & + .navbar-toggler-bar{\n                margin-top: 7px;\n            }\n\n            & + .navbar-toggler-bar.navbar-kebab{\n                margin-top: 3px;\n            }\n\n            &.bar2{\n                width: 17px;\n                transition: width .2s linear;\n            }\n        }\n\n        &.bg-white:not(.navbar-transparent) .navbar-toggler-bar{\n            background-color: $default-color;\n        }\n\n        & .toggled .navbar-toggler-bar{\n            width: 24px;\n\n            & + .navbar-toggler-bar{\n                margin-top: 5px;\n            }\n        }\n\n    }\n\n    .wrapper{\n        @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n    .nav-open{\n        .main-panel{\n            right: 0;\n            @include transform-translate-x(260px);\n        }\n\n        .sidebar{\n            @include transform-translate-x(0px);\n        }\n\n        body{\n            position: relative;\n            overflow-x: hidden;\n        }\n\n        .menu-on-right{\n            .main-panel{\n                @include transform-translate-x(-260px);\n            }\n\n            .navbar-collapse,\n            .sidebar{\n                @include transform-translate-x(0px);\n            }\n\n            .navbar-translate{\n                @include transform-translate-x(-300px);\n            }\n\n            #bodyClick{\n                right: 260px;\n                left: auto;\n            }\n        }\n    }\n\n    .menu-on-right{\n        .sidebar{\n            left: auto;\n            right:0;\n            @include transform-translate-x(260px);\n        }\n    }\n\n    .bar1,\n    .bar2,\n    .bar3 {\n      outline: 1px solid transparent;\n    }\n    .bar1 {\n      top: 0px;\n      @include bar-animation($topbar-back);\n    }\n    .bar2 {\n      opacity: 1;\n    }\n    .bar3 {\n      bottom: 0px;\n      @include bar-animation($bottombar-back);\n    }\n    .toggled .bar1 {\n      top: 6px;\n      @include bar-animation($topbar-x);\n    }\n    .toggled .bar2 {\n      opacity: 0;\n    }\n    .toggled .bar3 {\n      bottom: 6px;\n      @include bar-animation($bottombar-x);\n    }\n\n    @include topbar-x-rotation();\n    @include topbar-back-rotation();\n    @include bottombar-x-rotation();\n    @include bottombar-back-rotation();\n\n    @-webkit-keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n    @-moz-keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n    @keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n\n    #bodyClick{\n        height: 100%;\n        width: 100%;\n        position: fixed;\n        opacity: 1;\n        top: 0;\n        right: 0;\n        left: 260px;\n        content: \"\";\n        z-index: 9999;\n        overflow-x: hidden;\n        background-color: transparent;\n        @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n    .footer{\n        .copyright{\n            text-align: right;\n        }\n    }\n\n    .section-nucleo-icons .icons-container{\n        margin-top: 65px;\n    }\n\n    .navbar-nav{\n        .nav-link{\n            i.fa,\n            i.nc-icon{\n                opacity: .5;\n            }\n        }\n    }\n\n    .sidebar,\n    .bootstrap-navbar {\n        position: fixed;\n        display: block;\n        top: 0;\n        height: 100%;\n        width: 260px;\n        right: auto;\n        left: 0;\n        z-index: 1032;\n        visibility: visible;\n        overflow-y: visible;\n        padding: 0;\n        @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n        @include transform-translate-x(-260px);\n    }\n\n\n\n    .main-panel{\n      width: 100%;\n    }\n\n    .timeline{\n      &:before{\n          left: 5% !important;\n      }\n\n      > li > .timeline-badge{\n          left: 5% !important;\n      }\n\n      > li > .timeline-panel{\n          float: right !important;\n          width: 82% !important;\n\n          &:before{\n              border-left-width: 0 !important;\n              border-right-width: 15px !important;\n              left: -15px !important;\n              right: auto !important;\n          }\n\n          &:after{\n              border-left-width: 0 !important;\n              border-right-width: 14px !important;\n              left: -14px !important;\n              right: auto !important;\n          }\n      }\n  }\n\n}\n@media (max-width: 991px) and (min-width: 768px){\n  .nav-tabs-navigation.verical-navs {\n    padding: 0px 2px;\n  }\n}\n\n@media screen and (min-width: 768px){\n  .footer {\n    .footer-nav {\n      padding-left: 21px;\n    }\n\n    .credits {\n      padding-right: 15px;\n    }\n  }\n}\n\n@media screen and (min-width: 992px){\n    .navbar-collapse{\n        background: none !important;\n    }\n\n    .navbar .navbar-toggle{\n        display: none;\n    }\n\n    .navbar-nav{\n        .nav-link{\n            &.profile-photo{\n                padding: 0;\n                margin: 7px $padding-base-horizontal;\n            }\n        }\n    }\n\n    .section-nucleo-icons .icons-container{\n        margin: 0 0 0 auto;\n    }\n\n    .dropdown-menu .dropdown-item{\n        color: inherit;\n    }\n\n    .footer{\n        .copyright{\n            float: right;\n            padding-right: 15px;\n        }\n    }\n\n    .sidebar{\n      .sidebar-wrapper{\n        li.active{\n          > a:not([data-toggle=\"collapse\"]),\n          > [data-toggle=\"collapse\"] + div .nav li {\n            &:before{\n              border-right: 17px solid $medium-gray;\n              border-top: 17px solid transparent;\n              border-bottom: 17px solid transparent;\n              content: \"\";\n              display: inline-block;\n              position: absolute;\n              right: -16px;\n              opacity: 1;\n              top: 7px;\n              transition: opacity 150ms ease-in;\n            }\n\n            &:after{\n              border-right: 17px solid $default-body-bg;\n              border-top: 17px solid transparent;\n              border-bottom: 17px solid transparent;\n              content: \"\";\n              display: inline-block;\n              position: absolute;\n              right: -17px;\n              opacity: 1;\n              top: 7px;\n              transition: opacity 150ms ease-in;\n            }\n          }\n          >[data-toggle=\"collapse\"] + div .nav li {\n            a{\n              &:before,\n              &:after {\n                top: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n\n}\n\n@media screen and (max-width: 768px){\n  .card-stats [class*=\"col-\"] .statistics::after {\n    display: none;\n  }\n\n  .main-panel .content {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n    .footer{\n        nav{\n            display: block;\n            margin-bottom: 5px;\n            float: none;\n        }\n    }\n\n    .landing-page .section-story-overview .image-container:nth-child(2){\n        margin-left: 0;\n        margin-bottom: 30px;\n    }\n\n    .card {\n      .form-horizontal {\n        .col-md-3.col-form-label {\n          text-align: left;\n        }\n      }\n    }\n\n}\n\n@media screen and (max-width: 767px){\n  .nav-tabs-navigation.verical-navs{\n    padding: 0 28px;\n  }\n\n  .typography-line {\n    padding-left: 23% !important;\n\n    span {\n      width: 60px !important;\n    }\n  }\n\n  .login-page,\n  .lock-page,\n  .register-page {\n    .navbar{\n      padding: .5rem 1rem;\n    }\n  }\n\n  .footer {\n    .footer-nav,\n    .credits {\n      margin: 0 auto !important;\n    }\n\n    .footer-nav {\n      margin-bottom: 10px !important;\n    }\n  }\n\n  .register-page {\n    .content {\n      padding-top: 5vh;\n    }\n    .footer {\n      position: relative;\n    }\n    .info-area.info-horizontal {\n      margin-top: 0;\n    }\n  }\n}\n\n@media screen and (max-width: 374px){\n  .login-page {\n    .content {\n      padding-top: 10vh;\n    }\n  }\n}\n\n@media screen and (max-width: 413px){\n  .fixed-plugin {\n    .dropdown.show-dropdown.show{\n      .dropdown-menu.show {\n        width: 225px !important;\n\n        &[x-placement=top-start] {\n          transform: translate3d(0,400px,0)!important;\n        }\n\n        &:before,\n        &:after {\n          bottom: 360px !important;\n        }\n      }\n    }\n  }\n\n}\n\n\n@media screen and (max-width: 576px){\n    .navbar[class*='navbar-toggleable-'] .container{\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    .card-contributions .card-stats{\n      flex-direction: column;\n\n      .bootstrap-switch{\n        margin-bottom: 15px;\n      }\n    }\n\n    .footer{\n        .copyright{\n            text-align: center;\n        }\n    }\n\n    .section-nucleo-icons{\n        .icons-container{\n            i{\n                font-size: 30px;\n\n                &:nth-child(6){\n                    font-size: 48px;\n                }\n            }\n        }\n    }\n\n    .page-header{\n        .container h6.category-absolute{\n            width: 90%;\n        }\n    }\n\n    .card-timeline .timeline {\n      .timeline-panel {\n        width: 38%;\n        padding: 15px;\n      }\n    }\n}\n",".alert{\n  .close{\n    font-size: 1.8rem;\n    font-weight: 300;\n  }\n}\n","/*           badges             */\n.badge{\n  & + .badge{\n    margin-left: 5px;\n  }\n}\n",".btn,\n.navbar .navbar-nav > a.btn{\n  i {\n    margin-right: 3px;\n  }\n}\n.table :not(.btn-group) .btn + .btn,\n.table .btn-group + .btn-group{\n  margin-left: 4px;\n}\n.btn + .btn,\n.btn-group + .btn-group {\n  margin-left: 5px;\n}\n",".card{\n  .card-footer{\n    .stats{\n      i{\n        margin-right: 9px;\n      }\n    }\n    .legend{\n      i{\n        margin-right: 4px;\n      }\n    }\n  }\n}\n",".dropup,\n.dropdown{\n    .dropdown-toggle:after{\n        margin-left: 3px;\n    }\n}\n",".login-page{\n\n  .card-login{\n    border-radius: $border-radius-large;\n    padding-bottom: $padding-base-horizontal;\n\n    .btn-wd{\n      min-width: 180px;\n    }\n\n    .logo-container{\n      width: 65px;\n      margin: 0 auto;\n      margin-bottom: 55px;\n\n      img{\n        width: 100%;\n      }\n    }\n\n    .input-group:last-child{\n      margin-bottom: 40px;\n    }\n\n    &.card-plain{\n      @include input-coloured-bg($opacity-5, $white-color, $white-color, $transparent-bg, $opacity-1, $opacity-2);\n\n      .input-group-addon,\n      .form-group.no-border .input-group-addon,\n      .input-group.no-border .input-group-addon{\n        color: $opacity-8;\n      }\n    }\n  }\n\n  .link{\n    font-size: 10px;\n    color: $white-color;\n    text-decoration: none;\n  }\n}\n\n.full-page{\n  align-items: center;\n  min-height: 100vh;\n  padding: 100px 0 120px;\n  & > .footer{\n    position: relative;\n    z-index: 4;\n  }\n\n  &.section-image{\n    // position: initial;\n  }\n\n  .footer{\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n\n    .container{\n      color: $white-color;\n    }\n  }\n\n  .full-page-background{\n    position: absolute;\n    z-index: 1;\n    height: 100%;\n    width: 100%;\n    display: block;\n    top: 0;\n    left: 0;\n    background-size: cover;\n    background-position: center center;\n  }\n\n  &:after{\n    position: absolute;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    display: block;\n    left: 0;\n    top: 0;\n    content: \"\";\n    background-color: rgba(0, 0, 0, 0.6);\n  }\n\n  .pricing-page{\n    .description{\n      margin-bottom: 65px;\n    }\n  }\n\n  .register-page{\n    & > .container {\n      margin-top: 5vh;\n    }\n    .info-horizontal{\n      padding: 0px 0px 20px;\n    }\n\n    .info-horizontal{\n      text-align: left !important;\n\n      .icon{\n        margin-top: 0;\n\n        >i{\n          font-size: 2em;\n        }\n\n        &.icon-circle{\n          width: 65px;\n          height: 65px;\n          max-width: 65px;\n          margin-top: 8px;\n\n          i{\n            display: table;\n            margin: 0 auto;\n            line-height: 3.5;\n            font-size: 1.9em;\n          }\n        }\n      }\n      .description{\n        overflow: hidden;\n      }\n\n    }\n  }\n}\n\n.register-page,\n.login-page,\n.lock-page {\n  .navbar {\n    .navbar-collapse {\n      .nav-item .nav-link {\n        text-transform: capitalize;\n        color: $white-color !important;\n        i{\n          margin-right: 4px;\n        }\n      }\n    }\n\n    &.navbar-transparent {\n      border-bottom: 1px solid transparent;\n      margin-top: 25px;\n    }\n\n    .navbar-brand {\n      color: $white-color !important;\n    }\n  }\n}\n\n.register-page,\n.login-page,\n.lock-page {\n  width: 100%;\n}\n\n@media screen and (max-width: 991px){\n  .register-page,\n  .login-page,\n  .lock-page {\n    .navbar {\n      &.bg-white {\n        .navbar-toggler .navbar-toggler-bar.navbar-kebab {\n          background: $default-color !important;\n        }\n        .navbar-collapse {\n          .navbar-nav {\n            .nav-item .nav-link {\n              color: $default-color !important;\n            }\n          }\n        }\n        .navbar-brand {\n          color: $default-color !important;\n        }\n      }\n\n      &.navbar-transparent {\n        .navbar-toggle {\n          display: none;\n        }\n        .navbar-toggler {\n          .navbar-toggler-bar.navbar-kebab {\n            background: $white-color !important;\n          }\n        }\n      }\n    }\n  }\n}\n",".btn-file {\n  position: relative;\n  overflow: hidden;\n  vertical-align: middle;\n}\n.btn-file > input {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  font-size: 23px;\n  cursor: pointer;\n  filter: alpha(opacity=0);\n  opacity: 0;\n\n  direction: ltr;\n}\n.fileinput {\n  display: inline-block;\n  margin-bottom: 9px;\n\n  input[type=\"file\"]{\n    display: none;\n  }\n}\n.fileinput .form-control {\n  display: inline-block;\n  padding-top: 7px;\n  padding-bottom: 5px;\n  margin-bottom: 0;\n  vertical-align: middle;\n  cursor: text;\n}\n.fileinput .thumbnail {\n  display: inline-block;\n  margin-bottom: 10px;\n  overflow: hidden;\n  text-align: center;\n  vertical-align: middle;\n  max-width: 250px;\n  box-shadow: $box-shadow;\n\n  &.img-circle{\n      border-radius: 50%;\n      max-width: 100px;\n  }\n}\n.fileinput .thumbnail > img {\n  max-height: 100%;\n}\n.fileinput .btn {\n  vertical-align: middle;\n}\n.fileinput-exists .fileinput-new,\n.fileinput-new .fileinput-exists {\n  display: none;\n}\n.fileinput-inline .fileinput-controls {\n  display: inline;\n}\n.fileinput-filename {\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: middle;\n}\n.form-control .fileinput-filename {\n  vertical-align: bottom;\n}\n.fileinput.input-group {\n  display: table;\n}\n.fileinput.input-group > * {\n  position: relative;\n  z-index: 2;\n}\n.fileinput.input-group > .btn-file {\n  z-index: 1;\n}\n.fileinput-new.input-group .btn-file,\n.fileinput-new .input-group .btn-file {\n  border-radius: 0 4px 4px 0;\n}\n.fileinput-new.input-group .btn-file.btn-xs,\n.fileinput-new .input-group .btn-file.btn-xs,\n.fileinput-new.input-group .btn-file.btn-sm,\n.fileinput-new .input-group .btn-file.btn-sm {\n  border-radius: 0 3px 3px 0;\n}\n.fileinput-new.input-group .btn-file.btn-lg,\n.fileinput-new .input-group .btn-file.btn-lg {\n  border-radius: 0 6px 6px 0;\n}\n.form-group.has-warning .fileinput .fileinput-preview {\n  color: $brand-warning;\n}\n.form-group.has-warning .fileinput .thumbnail {\n  border-color: $brand-warning;\n}\n.form-group.has-error .fileinput .fileinput-preview {\n  color: $brand-danger;\n}\n.form-group.has-error .fileinput .thumbnail {\n  border-color: $brand-danger;\n}\n.form-group.has-success .fileinput .fileinput-preview {\n  color: $brand-success;\n}\n.form-group.has-success .fileinput .thumbnail {\n  border-color: $brand-success;\n}\n.input-group-addon:not(:first-child) {\n  border-left: 0;\n}\n.thumbnail{\n    border: 0 none;\n    border-radius: 3px;\n    padding: 0;\n}\n.picture-container{\n    position: relative;\n    cursor: pointer;\n    text-align: center;\n}\n\n.picture{\n    width: 106px;\n    height: 106px;\n    background-color: #999999;\n    border: 1px solid $light-gray;\n    color: #FFFFFF;\n    border-radius: 50%;\n    margin: 5px auto;\n    overflow: hidden;\n    transition: all 0.2s;\n    -webkit-transition: all 0.2s;\n\n    &:hover{\n        border-color: #2ca8ff;\n    }\n}\n.picture input[type=\"file\"] {\n    cursor: pointer;\n    display: block;\n    height: 100%;\n    left: 0;\n    opacity: 0 !important;\n    position: absolute;\n    top: 0;\n    width: 100%;\n}\n\n.picture-src{\n    width: 100%;\n}\n",".fixed-plugin{\n    position: fixed;\n    right: 0;\n    width: 64px;\n    background: rgba(0,0,0,.3);\n    z-index: 1031;\n    border-radius: 8px 0 0 8px;\n    text-align: center;\n    top: 120px;\n\n    li > a,\n    .badge{\n        transition: all .34s;\n        -webkit-transition: all .34s;\n        -moz-transition: all .34s;\n    }\n\n    .fa-cog{\n        color: #FFFFFF;\n        padding: 10px;\n        border-radius: 0 0 6px 6px;\n        width: auto;\n    }\n\n    .dropdown-menu{\n        right: 80px;\n        left: auto !important;\n        top: -52px !important;\n        width: 290px;\n        border-radius: 10px;\n        padding: 0 10px;\n    }\n\n    .dropdown .dropdown-menu .nc-icon{\n      top: 2px;\n      right: 10px;\n      font-size: 14px;\n    }\n\n    .dropdown-menu:after,\n    .dropdown-menu:before{\n        right: 10px;\n        margin-left: auto;\n        left: auto;\n    }\n\n    .fa-circle-thin{\n        color: #FFFFFF;\n    }\n\n    .active .fa-circle-thin{\n        color: #00bbff;\n    }\n\n    .dropdown-menu > .active > a,\n    .dropdown-menu > .active > a:hover,\n    .dropdown-menu > .active > a:focus{\n        color: #777777;\n        text-align: center;\n    }\n\n    img{\n        border-radius: 0;\n        width: 100%;\n        height: 100px;\n        margin: 0 auto;\n    }\n\n    .dropdown-menu li > a:hover,\n    .dropdown-menu li > a:focus{\n        box-shadow: none;\n    }\n\n    .badge{\n        border: 3px solid #FFFFFF;\n        border-radius: 50%;\n        cursor: pointer;\n        display: inline-block;\n        height: 23px;\n        margin-right: 5px;\n        position: relative;\n        width: 23px;\n\n      &.badge-light {\n        @include badge-color($smoke-bg);\n        border: 3px solid #FFFFFF;\n      }\n      &.badge-dark{\n          @include badge-color($black-color);\n          border: 3px solid #FFFFFF;\n      }\n    }\n\n    .badge.active,\n    .badge:hover{\n        border-color: #00bbff;\n    }\n\n    .badge-blue{\n        background-color: $brand-info;\n    }\n    .badge-green{\n        background-color: $brand-success;\n    }\n    .badge-orange{\n        background-color: $brand-primary;\n    }\n    .badge-yellow{\n        background-color: $brand-warning;\n    }\n    .badge-red{\n        background-color: $brand-danger;\n    }\n\n    h5{\n        font-size: 14px;\n        margin: 10px;\n    }\n\n    .dropdown-menu li{\n        display: block;\n        padding: 15px 2px;\n        width: 25%;\n        float: left;\n    }\n\n    li.adjustments-line,\n    li.header-title,\n    li.button-container{\n        width: 100%;\n        height: 35px;\n        min-height: inherit;\n    }\n\n    li.button-container{\n        height: auto;\n\n        div{\n            margin-bottom: 5px;\n        }\n    }\n\n    #sharrreTitle{\n        text-align: center;\n        padding: 10px 0;\n        height: 50px;\n    }\n\n    li.header-title{\n        height: 30px;\n        line-height: 25px;\n        font-size: 12px;\n        font-weight: 600;\n        text-align: center;\n        text-transform: uppercase;\n    }\n\n    .adjustments-line{\n        p{\n            float: left;\n            display: inline-block;\n            margin-bottom: 0;\n            font-size: 1em;\n            color: #3C4858;\n        }\n\n        a{\n            color: transparent;\n\n            .badge-colors{\n                position: relative;\n                top: -2px;\n            }\n\n            a:hover,\n            a:focus{\n                color: transparent;\n            }\n        }\n\n        .togglebutton{\n            text-align: center;\n\n            .label-switch{\n              position: relative;\n              left: -10px;\n              font-size: $font-size-mini;\n              color: $default-color;\n\n              &.label-right{\n                left: 10px;\n              }\n            }\n\n            .toggle{\n                margin-right: 0;\n            }\n        }\n\n        .dropdown-menu > li.adjustments-line > a{\n              padding-right: 0;\n              padding-left: 0;\n              border-bottom: 1px solid #ddd;\n              border-radius: 0;\n              margin: 0;\n        }\n    }\n\n\n\n    .dropdown-menu{\n        > li{\n            & > a.img-holder{\n                  font-size: 16px;\n                  text-align: center;\n                  border-radius: 10px;\n                  background-color: #FFF;\n                  border: 3px solid #FFF;\n                  padding-left: 0;\n                  padding-right: 0;\n                  opacity: 1;\n                  cursor: pointer;\n                  display: block;\n                  max-height: 100px;\n                  overflow: hidden;\n                  padding: 0;\n\n                  img{\n                     margin-top: auto;\n                  }\n            }\n\n            a.switch-trigger:hover,\n            & > a.switch-trigger:focus{\n                background-color: transparent;\n            }\n\n            &:hover,\n            &:focus{\n                > a.img-holder{\n                    border-color: rgba(0, 187, 255, 0.53);;\n                }\n            }\n        }\n\n        > .active > a.img-holder,\n        > .active > a.img-holder{\n            border-color: #00bbff;\n            background-color: #FFFFFF;\n        }\n\n    }\n\n    .btn-social{\n        width: 50%;\n        display: block;\n        width: 48%;\n        float: left;\n        font-weight: 600;\n    }\n\n    .btn-social{\n        i{\n            margin-right: 5px;\n        }\n\n        &:first-child{\n            margin-right: 2%;\n        }\n    }\n\n    .dropdown{\n        .dropdown-menu{\n          transform-origin: 0 0;\n\n          &:before{\n             border-bottom: 16px solid rgba(0, 0, 0, 0);\n             border-left: 16px solid rgba(0,0,0,0.2);\n             border-top: 16px solid rgba(0,0,0,0);\n             right: -27px;\n             bottom: 425px;\n          }\n\n          &:after{\n             border-bottom: 16px solid rgba(0, 0, 0, 0);\n             border-left: 16px solid #FFFFFF;\n             border-top: 16px solid rgba(0,0,0,0);\n             right: -26px;\n             bottom: 425px;\n          }\n\n          &:before,\n          &:after{\n             content: \"\";\n             display: inline-block;\n             position: absolute;\n             width: 16px;\n             transform: translateY(-50px);\n             -webkit-transform: translateY(-50px);\n             -moz-transform: translateY(-50px);\n          }\n        }\n\n      &.show-dropdown .show{\n        .dropdown-menu .show{\n          transform: translate3d(0, -60px, 0)!important;\n          bottom: auto!important;\n          top: 0!important;\n        }\n      }\n    }\n\n    .bootstrap-switch{\n        margin:0;\n    }\n}\n\n.fixed-plugin {\n  .show-dropdown {\n    .dropdown-menu[x-placement=bottom-start] {\n      @include transform-translate-y-fixed-plugin (-100px);\n\n      &:before,\n      &:after {\n        top: 100px;\n      }\n    }\n    .dropdown-menu[x-placement=top-start] {\n      @include transform-translate-y-fixed-plugin (100px);\n    }\n\n    &.show {\n      .dropdown-menu.show[x-placement=bottom-start] {\n        @include transform-translate-y-fixed-plugin (-60px);\n      }\n\n      .dropdown-menu.show[x-placement=top-start] {\n        @include transform-translate-y-fixed-plugin (470px);\n      }\n    }\n  }\n}\n",".form-control {\n  height: unset\n}\n// Input files - hide actual input - requires specific markup in the sample.\n.form-group input[type=file] {\n  opacity: 1;\n  position: unset;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: unset;\n  z-index: unset;\n}\n",".modal-footer .left-side,\n.modal-footer .right-side{\n    display: flex;\n    flex: 1;\n    text-align: center;\n    width: unset;\n    padding: 5px;\n}\n",".navbar{\n  .navbar-nav{\n    .nav-link{\n      i.fa + p,\n      i.nc-icon + p{\n        margin-left: 7px;\n      }\n    }\n  }\n}\n","/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n  font-family: 'nucleo-icons';\n  src: url('~assets/fonts/nucleo-icons.eot');\n  src: url('~assets/fonts/nucleo-icons.eot') format('embedded-opentype'), url('~assets/fonts/nucleo-icons.woff2') format('woff2'), url('~assets/fonts/nucleo-icons.woff') format('woff'), url('~assets/fonts/nucleo-icons.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n/* all icon font classes list here */\n","/*             Navigation Pills               */\n\n.nav-pills {\n    .nav-item + .nav-link {\n        margin-left: 0;\n    }\n    .nav-item .nav-link {\n        border: 1px solid $default-color;\n        border-radius: 0;\n        color: $default-color;\n        font-weight: $font-weight-bold;\n        margin-left: -1px;\n        padding: 10px 25px;\n\n    }\n    .nav-item.active .nav-link,\n    .nav-item.active .nav-link:hover,\n    .nav-item.active .nav-link:focus {\n        background-color: $default-color;\n        color: #FFFFFF;\n    }\n    &:not(.flex-column) .nav-item:first-child .nav-link{\n        border-radius: 30px 0 0 30px !important;\n        margin: 0;\n    }\n    &:not(.flex-column) .nav-item:last-child .nav-link{\n        border-radius: 0 30px 30px 0 !important;\n    }\n    &.flex-column .nav-item .nav-link{\n      border-radius: 30px!important;\n      margin-bottom: 15px;\n    }\n    .nav-item .nav-link.active{\n        background-color: $default-color;\n        color: $white-color;\n    }\n\n}\n.nav-pills-primary{\n    .nav-item{\n        .nav-link{\n            border: 1px solid $primary-color;\n            color: $primary-color;\n            &.active{\n                border: 1px solid $primary-color;\n                background: $primary-color;\n                color: $white-color;\n            }\n        }\n    }\n}\n.nav-pills-danger{\n    .nav-item{\n        .nav-link{\n            border: 1px solid $danger-color;\n            color: $danger-color;\n            &.active{\n                border: 1px solid $danger-color;\n                background: $danger-color;\n                color: $white-color;\n            }\n        }\n    }\n}\n.nav-pills-info{\n    .nav-item{\n        .nav-link{\n            border: 1px solid $info-color;\n            color: $info-color;\n            &.active{\n                border: 1px solid $info-color;\n                background: $info-color;\n                color: $white-color;\n            }\n        }\n    }\n}\n.nav-pills-success{\n    .nav-item{\n        .nav-link{\n            border: 1px solid $success-color;\n            color: $success-color;\n            &.active{\n                border: 1px solid $success-color;\n                background: $success-color;\n                color: $white-color;\n            }\n        }\n    }\n}\n.nav-pills-warning{\n    .nav-item{\n        .nav-link{\n            border: 1px solid $warning-color;\n            color: $warning-color;\n            &.active{\n                border: 1px solid $warning-color;\n                background: $warning-color;\n                color: $white-color;\n            }\n        }\n    }\n}\n\n\n\n\n.page-item:first-child .page-link,\n.page-item:last-child .page-link{\n    border-bottom-left-radius: 20px;\n\tborder-top-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n    border-top-right-radius: 20px;\n}\n.nav-pills-default .nav-item.show .nav-link,\n.nav-pills-default .nav-link.active{\n    background-color: $default-color !important;\n}\n.nav-pills-primary .nav-item.show .nav-link,\n.nav-pills-primary .nav-link.active{\n    background-color: $primary-color !important;\n}\n.nav-pills-info .nav-item.show .nav-link,\n.nav-pills-info .nav-link.active{\n    background-color: $info-color !important;\n}\n.nav-pills-warning .nav-item.show .nav-link,\n.nav-pills-warning .nav-link.active{\n    background-color: $warning-color !important;\n}\n.nav-pills-success .nav-item.show .nav-link,\n.nav-pills-success .nav-link.active{\n    background-color: $success-color !important;\n}\n.nav-pills-danger .nav-item.show .nav-link,\n.nav-pills-danger .nav-link.active{\n    background-color: $danger-color !important;\n}\n","@media screen and (max-width: 991px){\n\n  .navbar {\n    padding: 0;\n\n    &.navbar-absolute {\n      padding-top: 0;\n    }\n\n    .navbar-brand {\n      font-size: 16px;\n      margin-right: 0;\n    }\n  }\n\n  .profile-photo .profile-photo-small{\n    margin-left: -2px;\n  }\n\n  .button-dropdown{\n    display: none;\n  }\n\n  #minimizeSidebar{\n    display: none;\n  }\n\n  .navbar{\n    .container-fluid{\n      padding-right: 15px;\n      padding-left: 15px;\n    }\n\n    .navbar-collapse{\n      .input-group{\n        margin: 0;\n        margin-top: 5px;\n      }\n    }\n\n    .navbar-nav{\n      .nav-item:first-child{\n        margin-top: 10px;\n      }\n      .nav-item:not(:last-child){\n        margin-bottom: 10px;\n      }\n    }\n\n    .dropdown.show .dropdown-menu{\n      display: block !important;\n      transform: translate3d(0px, 0px, 0px) !important;\n    }\n\n    .dropdown .dropdown-menu{\n      display: none;\n    }\n\n    .dropdown.show .dropdown-menu,\n    .dropdown .dropdown-menu{\n      border: 0;\n      transition: none;\n      -webkit-box-shadow: none;\n      width: auto;\n      margin: 0px 1rem;\n      margin-top: 0px;\n      box-shadow: none;\n      position: static !important;\n      padding-left: 10px;\n\n      &:before{\n        display: none;\n      }\n    }\n\n    .dropdown-menu .dropdown-item:focus,\n    .dropdown-menu .dropdown-item:hover{\n      color: $white-color;\n    }\n\n    &.bg-white .dropdown-menu .dropdown-item:focus,\n    &.bg-white .dropdown-menu .dropdown-item:hover{\n      color: $default-color;\n    }\n\n    .navbar-toggler-bar{\n      display: block;\n      position: relative;\n      width: 22px;\n      height: 1px;\n      border-radius: 1px;\n      background: $default-color;\n\n      & + .navbar-toggler-bar{\n        margin-top: 7px;\n      }\n\n      & + .navbar-toggler-bar.navbar-kebab{\n        margin-top: 3px;\n      }\n\n      &.bar2{\n        width: 17px;\n        transition: width .2s linear;\n      }\n    }\n\n    &.bg-white:not(.navbar-transparent) .navbar-toggler-bar{\n      background-color: $default-color;\n    }\n\n    & .toggled .navbar-toggler-bar{\n      width: 24px;\n\n      & + .navbar-toggler-bar{\n        margin-top: 5px;\n      }\n    }\n\n  }\n\n  .wrapper{\n    @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n  }\n\n  .nav-open{\n    .main-panel{\n      right: 0;\n      @include transform-translate-x(260px);\n    }\n\n    .sidebar{\n      @include transform-translate-x(0px);\n    }\n\n    body{\n      position: relative;\n      overflow-x: hidden;\n    }\n\n    .menu-on-right{\n      .main-panel{\n        @include transform-translate-x(-260px);\n      }\n\n      .navbar-collapse,\n      .sidebar{\n        @include transform-translate-x(0px);\n      }\n\n      .navbar-translate{\n        @include transform-translate-x(-300px);\n      }\n\n      #bodyClick{\n        left: auto;\n      }\n    }\n  }\n\n  .menu-on-right{\n    .sidebar{\n      left: auto;\n      right:0;\n      @include transform-translate-x(260px);\n    }\n  }\n\n  .bar1,\n  .bar2,\n  .bar3 {\n    outline: 1px solid transparent;\n  }\n  .bar1 {\n    top: 0px;\n    @include bar-animation($topbar-back);\n  }\n  .bar2 {\n    opacity: 1;\n  }\n  .bar3 {\n    bottom: 0px;\n    @include bar-animation($bottombar-back);\n  }\n  .toggled .bar1 {\n    top: 6px;\n    @include bar-animation($topbar-x);\n  }\n  .toggled .bar2 {\n    opacity: 0;\n  }\n  .toggled .bar3 {\n    bottom: 6px;\n    @include bar-animation($bottombar-x);\n  }\n\n  @include topbar-x-rotation();\n  @include topbar-back-rotation();\n  @include bottombar-x-rotation();\n  @include bottombar-back-rotation();\n\n  @-webkit-keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n  @-moz-keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n  @keyframes fadeIn {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n\n  #bodyClick{\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    opacity: 1;\n    top: 0;\n    right: 0;\n    content: \"\";\n    z-index: 9999;\n    overflow-x: hidden;\n    background-color: transparent;\n    @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n  }\n\n  .footer{\n    .copyright{\n      text-align: right;\n    }\n  }\n\n  .section-nucleo-icons .icons-container{\n    margin-top: 65px;\n  }\n\n  .navbar-nav{\n    .nav-link{\n      i.fa,\n      i.nc-icon{\n        opacity: .5;\n      }\n    }\n  }\n\n  .sidebar,\n  .bootstrap-navbar {\n    position: fixed;\n    display: block;\n    top: 0;\n    height: 100%;\n    width: 260px;\n    right: auto;\n    left: 0;\n    z-index: 1032;\n    visibility: visible;\n    overflow-y: visible;\n    padding: 0;\n    @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n    @include transform-translate-x(-260px);\n  }\n\n\n\n  .main-panel{\n    width: 100%;\n  }\n\n  .timeline{\n    &:before{\n      left: 5% !important;\n    }\n\n    > li > .timeline-badge{\n      left: 5% !important;\n    }\n\n    > li > .timeline-panel{\n      float: right !important;\n      width: 82% !important;\n\n      &:before{\n        border-left-width: 0 !important;\n        border-right-width: 15px !important;\n        left: -15px !important;\n        right: auto !important;\n      }\n\n      &:after{\n        border-left-width: 0 !important;\n        border-right-width: 14px !important;\n        left: -14px !important;\n        right: auto !important;\n      }\n    }\n  }\n\n  .fixed-plugin{\n    width: 54px;\n    .dropdown-menu{\n      max-width: 230px;\n      right: 80px;\n    }\n  }\n\n}\n@media (max-width: 991px) and (min-width: 768px){\n  .nav-tabs-navigation.verical-navs {\n    padding: 0px 2px;\n  }\n}\n\n@media screen and (min-width: 768px){\n  .footer {\n    .footer-nav {\n      padding-left: 21px;\n    }\n\n    .credits {\n      padding-right: 15px;\n    }\n  }\n}\n\n@media screen and (min-width: 992px){\n  .navbar-collapse{\n    background: none !important;\n  }\n\n  .navbar .navbar-toggle{\n    display: none;\n  }\n\n  .navbar-nav{\n    .nav-link{\n      &.profile-photo{\n        padding: 0;\n        margin: 7px $padding-base-horizontal;\n      }\n    }\n  }\n\n  .section-nucleo-icons .icons-container{\n    margin: 0 0 0 auto;\n  }\n\n  .dropdown-menu .dropdown-item{\n    color: inherit;\n  }\n\n  .footer{\n    .copyright{\n      float: right;\n      padding-right: 15px;\n    }\n  }\n\n  .sidebar{\n    .sidebar-wrapper{\n      li > [data-toggle=\"collapse\"] + div .nav li.active a{\n        &:before{\n          top: -2px;\n        }\n        &:after {\n          top: -1px;\n        }\n      }\n      li.active{\n        > [data-toggle=\"collapse\"] + div .nav li {\n          &:before,&:after{\n            display: none !important;\n          }\n        }\n        > a:not([data-toggle=\"collapse\"]){\n          &:before{\n            border-right: 18px solid $medium-gray;\n            border-top: 18px solid transparent;\n            border-bottom: 18px solid transparent;\n            content: \"\";\n            display: inline-block;\n            position: absolute;\n            right: -15px;\n            opacity: 1;\n            top: 6px;\n            transition: opacity 150ms ease-in;\n          }\n\n          &:after{\n            border-right: 17px solid $default-body-bg;\n            border-top: 17px solid transparent;\n            border-bottom: 17px solid transparent;\n            content: \"\";\n            display: inline-block;\n            position: absolute;\n            right: -15px;\n            opacity: 1;\n            top: 7px;\n            transition: opacity 150ms ease-in;\n          }\n        }\n      }\n    }\n  }\n\n}\n\n@media screen and (max-width: 768px){\n  .card-stats [class*=\"col-\"] .statistics::after {\n    display: none;\n  }\n\n  .main-panel .content {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  .footer{\n    nav{\n      display: block;\n      margin-bottom: 5px;\n      float: none;\n    }\n  }\n\n  .landing-page .section-story-overview .image-container:nth-child(2){\n    margin-left: 0;\n    margin-bottom: 30px;\n  }\n\n  .card {\n    .form-horizontal {\n      .col-md-3.col-form-label {\n        text-align: left;\n      }\n    }\n  }\n\n}\n\n@media screen and (max-width: 767px){\n\n  .typography-line {\n    padding-left: 23% !important;\n\n    span {\n      width: 60px !important;\n    }\n  }\n\n  .login-page,\n  .lock-page,\n  .register-page {\n    .navbar{\n      padding: .5rem 1rem;\n    }\n  }\n\n  .footer {\n    .footer-nav,\n    .credits {\n      margin: 0 auto !important;\n    }\n\n    .footer-nav {\n      margin-bottom: 10px !important;\n    }\n  }\n\n  .register-page {\n    .content {\n      padding-top: 5vh;\n    }\n    .footer {\n      position: relative;\n    }\n    .info-area.info-horizontal {\n      margin-top: 0;\n    }\n  }\n}\n\n@media screen and (max-width: 413px){\n  .fixed-plugin {\n    .dropdown.show-dropdown.show{\n      .dropdown-menu.show {\n        width: 225px !important;\n\n        &[x-placement=top-start] {\n          transform: translate3d(0,400px,0)!important;\n        }\n\n        &:before,\n        &:after {\n          bottom: 360px !important;\n        }\n      }\n    }\n  }\n\n}\n\n\n@media screen and (max-width: 576px){\n  .navbar[class*='navbar-toggleable-'] .container{\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .card-contributions .card-stats{\n    flex-direction: column;\n\n    .bootstrap-switch{\n      margin-bottom: 15px;\n    }\n  }\n\n  .footer{\n    .copyright{\n      text-align: center;\n    }\n  }\n\n  .section-nucleo-icons{\n    .icons-container{\n      i{\n        font-size: 30px;\n\n        &:nth-child(6){\n          font-size: 48px;\n        }\n      }\n    }\n  }\n\n  .page-header{\n    .container h6.category-absolute{\n      width: 90%;\n    }\n  }\n\n  .card-timeline .timeline {\n    .timeline-panel {\n      width: 38%;\n      padding: 15px;\n    }\n  }\n}\n",".wrapper{\n    position: relative;\n    top: 0;\n    height: 100vh;\n    overflow-x: hidden;\n\n    &.wrapper-full-page{\n        min-height: 100vh;\n        height: auto;\n        .full-page{\n          display: flex;\n        }\n    }\n}\n\n.sidebar,\n.off-canvas-sidebar{\n    position: fixed;\n    top: 0;\n    height: 100%;\n    bottom: 0;\n    width: 260px;\n    left: 0;\n    z-index: 999;\n\n    .sidebar-wrapper{\n        position: relative;\n        height: calc(100vh - 75px);\n        overflow: auto;\n        width: 260px;\n        z-index: 4;\n        padding-bottom: 100px;\n\n        .dropdown .dropdown-backdrop{\n          display: none !important;\n        }\n\n        .navbar-form{\n            border: none;\n        }\n\n        > .nav,\n        .user .info{\n          [data-toggle=\"collapse\"] ~ div > ul > li > a{\n              span{\n                display: inline-block;\n                @extend .animation-transition-general;\n              }\n\n              .sidebar-normal {\n                margin: 0;\n                position: relative;\n                transform: translateX(0px);\n                opacity: 1;\n                white-space: nowrap;\n                display: block;\n                line-height: 20px;\n                z-index: 1;\n              }\n\n              .sidebar-mini-icon {\n                text-transform: uppercase;\n                width: 34px;\n                margin-right: 10px;\n                margin-left: 0px;\n                font-size: 12px;\n                text-align: center;\n                line-height: 20px;\n                position: relative;\n                float: left;\n                z-index: 1;\n                display: inherit;\n                color: $opacity-5;\n              }\n\n              .sidebar-normal {\n                text-transform: capitalize;\n              }\n\n              i{\n                font-size: 17px;\n                line-height: 20px;\n                width: 26px;\n              }\n            }\n        }\n    }\n\n    .navbar-minimize{\n      position: absolute;\n      right: 20px;\n      top: 2px;\n      opacity: 1;\n\n      @extend .animation-transition-general;\n    }\n    .logo-tim{\n      border-radius: 50%;\n      border: 1px solid #333;\n      display: block;\n      height: 61px;\n      width: 61px;\n      float: left;\n      overflow: hidden;\n\n      img{\n          width: 60px;\n          height: 60px;\n      }\n    }\n\n    .nav{\n        margin-top: 20px;\n        display: block;\n\n        .caret{\n            top: 14px;\n            position: absolute;\n            right: 10px;\n        }\n\n        li{\n            > a + div .nav li > a{\n                margin-top: 7px;\n            }\n\n            > a{\n                margin: 10px 15px 0;\n                color: $white-color;\n                display: block;\n                text-decoration: none;\n                position: relative;\n                text-transform: uppercase;\n                cursor: pointer;\n                font-size: 12px;\n                padding: 10px 8px;\n                line-height: 30px;\n                opacity: .7;\n            }\n\n            .nav > li > a{\n              padding: 5px 8px;\n            }\n\n            &.active > a,\n            &.active > a > i {\n              opacity: 1;\n              // color: $danger-color;\n            }\n\n            &:hover:not(.active) > a,\n            &:focus:not(.active) > a {\n                opacity: 1;\n            }\n\n            &.active > a[data-toggle=\"collapse\"] > {\n                background-color: transparent;\n                box-shadow: $box-shadow;\n            }\n\n            &.active > a[data-toggle=\"collapse\"],\n            &.active > a[data-toggle=\"collapse\"] i,\n            &.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active i,\n            &.active > a[data-toggle=\"collapse\"] ~ div > ul > li.active > a {\n              color: $danger-color;\n\n              & + div .nav .active a {\n                background-color: transparent;\n                box-shadow: none;\n\n                &:after {\n                  content: \"\";\n                  position: absolute;\n                  width: calc(100% - 5px);\n                  z-index: 0;\n                }\n              }\n            }\n\n            &.active > a[data-toggle=\"collapse\"] ~ div > .nav {\n              margin-top: 0;\n            }\n        }\n\n        p{\n            margin: 0;\n            line-height: 30px;\n            position: relative;\n            display: block;\n            height: auto;\n            white-space: nowrap;\n            font-weight: 600;\n        }\n\n        i{\n            font-size: 24px;\n            float: left;\n            margin-right: 12px;\n            line-height: 30px;\n            width: 34px;\n            text-align: center;\n            color: $opacity-5;\n            position: relative;\n        }\n\n        .collapse,\n        .collapsing {\n          .nav {\n            margin-top: 0;\n          }\n        }\n    }\n\n    .sidebar-background{\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n\n        &:after{\n            position: absolute;\n            z-index: 3;\n            width: 100%;\n            height: 100%;\n            content: \"\";\n            display: block;\n            background: #FFFFFF;\n            opacity: 1;\n        }\n    }\n\n    .logo{\n        position: relative;\n        padding: 7px $padding-base-horizontal;\n        z-index: 4;\n\n        a.logo-mini,\n        a.logo-normal{\n            @extend .animation-transition-general;\n        }\n\n        a.logo-mini{\n            opacity: 0;\n            float: left;\n            width: 34px;\n            text-align: center;\n            margin-left: 12px;\n            margin-right: 12px;\n        }\n\n        a.logo-normal{\n            display: block;\n            opacity: 1;\n            padding: 11px 0 8px;\n            @include transform-translate-x(0px);\n        }\n\n        &:after{\n            content: '';\n            position: absolute;\n            bottom: 0;\n            right: 15px;\n            height: 1px;\n            width: calc(100% - 30px);\n            background-color: $opacity-5;\n\n        }\n\n        p{\n            float: left;\n            font-size: 20px;\n            margin: 10px 10px;\n            color: $white-color;\n            line-height: 20px;\n            font-family: 'Muli', \"Helvetica\", Arial, sans-serif;\n        }\n\n        .simple-text{\n            text-transform: uppercase;\n            padding: $padding-base-vertical 0;\n            display: block;\n            white-space: nowrap;\n            font-size: $font-size-large;\n            color: $white-color;\n            text-decoration: none;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n            overflow: hidden;\n        }\n    }\n\n    .logo-tim{\n        border-radius: 50%;\n        border: 1px solid #333;\n        display: block;\n        height: 61px;\n        width: 61px;\n        float: left;\n        overflow: hidden;\n\n        img{\n            width: 60px;\n            height: 60px;\n        }\n    }\n\n    &:before,\n    &:after{\n        display: block;\n        content: \"\";\n        opacity: 1;\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n    }\n\n    &:after{\n        @include icon-gradient($default-color);\n        z-index: 3;\n    }\n\n    &[data-color=\"white\"]{\n      @include sidebar-color($white-color);\n      @include sidebar-text-color($default-color);\n    }\n    &[data-color=\"brown\"]{\n      @include sidebar-color($default-color);\n    }\n\n    // Active color changing\n\n    &[data-active-color=\"primary\"]{\n        @include sidebar-active-color($primary-color);\n    }\n    &[data-active-color=\"info\"]{\n        @include sidebar-active-color($info-color);\n    }\n    &[data-active-color=\"success\"]{\n        @include sidebar-active-color($success-color);\n    }\n    &[data-active-color=\"warning\"]{\n        @include sidebar-active-color($warning-color);\n    }\n    &[data-active-color=\"danger\"]{\n        @include sidebar-active-color($danger-color);\n    }\n\n    .user{\n        padding-bottom: 20px;\n        margin:20px auto 0;\n        position: relative;\n\n        &:after{\n            content: '';\n            position: absolute;\n            bottom: 0;\n            right: 15px;\n            height: 1px;\n            width: calc(100% - 30px);\n            background-color: rgba(255,255,255, .3);\n        }\n\n        .photo{\n            width: 34px;\n            height: 34px;\n            overflow: hidden;\n            float: left;\n            z-index: 5;\n            margin-right: 12px;\n            border-radius: 50%;\n            margin-left: 23px;\n            @extend .animation-transition-general;\n\n            img{\n                width: 100%;\n            }\n        }\n\n        a{\n            color: $white-color;\n            text-decoration: none;\n            padding: $padding-base-vertical 15px;\n            white-space: nowrap;\n            @extend .animation-transition-general;\n        }\n\n        .info{\n            > a{\n               display: block;\n               line-height: 18px;\n\n                > span{\n                   @extend .animation-transition-general;\n                   display: block;\n                   position: relative;\n                   opacity: 1;\n                }\n            }\n\n            .caret{\n                position: absolute;\n                top: 8px;\n                right: 18px;\n            }\n        }\n    }\n}\n\n.visible-on-sidebar-regular{\n    display: inline-block !important;\n}\n.visible-on-sidebar-mini{\n    display: none !important;\n}\n\n.off-canvas-sidebar{\n    .nav {\n        > li > a,\n        > li > a:hover{\n            color: $white-color;\n        }\n\n        > li > a:focus{\n            background: rgba(200, 200, 200, 0.2);\n        }\n    }\n}\n\n\n.main-panel{\n    position: relative;\n    float: right;\n    background-color: #f4f3ef;\n\n    @include transition (0.50s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n    > .content{\n        padding: 0 30px 30px;\n        min-height: calc(100vh - 123px);\n        margin-top: 93px;\n    }\n\n    > .map-content{\n        min-height: calc(100vh - 123px);\n        margin-top: 63px;\n    }\n\n    > .navbar{\n        margin-bottom: 0;\n    }\n\n\n    .header{\n        margin-bottom: 50px;\n    }\n}\n\n\n.perfect-scrollbar-on{\n  .sidebar,\n  .main-panel{\n      height: 100%;\n      max-height: 100%;\n  }\n}\n\n\n@media (min-width: 991px) {\n    .sidebar,\n    .main-panel,\n    .sidebar-wrapper{\n        -webkit-transition-property: top,bottom,width;\n        transition-property: top,bottom, width;\n        -webkit-transition-duration: .2s,.2s, .35s;\n        transition-duration: .2s,.2s, .35s;\n        -webkit-transition-timing-function: linear,linear,ease;\n        transition-timing-function: linear,linear,ease;\n        -webkit-overflow-scrolling: touch;\n    }\n\n\n    .sidebar-mini{\n        .visible-on-sidebar-regular{\n          display: none !important;\n        }\n        .visible-on-sidebar-mini{\n          display: inline-block !important;\n        }\n\n        .sidebar,\n        .sidebar .sidebar-wrapper{\n          width: 80px;\n        }\n\n        .main-panel{\n          width: $sidebar-mini-width;\n        }\n\n        .sidebar{\n          display: block;\n          z-index: 1030;\n\n          .logo{\n              a.logo-normal{\n                  opacity: 0;\n                  @include transform-translate-x(-25px);\n              }\n              a.logo-mini{\n                  opacity: 1;\n              }\n          }\n\n          .sidebar-wrapper{\n            > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n            .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n            .user .info > a > span,\n            > .nav li > a p{\n                @include transform-translate-x(-25px);\n                opacity: 0;\n            }\n          }\n        }\n\n        .sidebar:hover {\n          width: 260px;\n\n          .logo {\n            a.logo-normal {\n                opacity: 1;\n                @include transform-translate-x(0);\n            }\n          }\n\n          .navbar-minimize{\n            opacity: 1;\n          }\n          .sidebar-wrapper{\n            width: 260px;\n\n            > .nav li > a p,\n            > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n            .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n            .user .info > a > span{\n              @include transform-translate-x(0px);\n              opacity: 1;\n            }\n          }\n        }\n  }\n\n}\n\n.panel-header {\n  height: 260px;\n  padding-top: 80px;\n  padding-bottom: 45px;\n  background: #141E30;  /* fallback for old browsers */\n  background: -webkit-gradient(linear, left top, right top, from(#0c2646), color-stop(60%, #204065), to(#2a5788));\n  background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);\n  position: relative;\n  overflow: hidden;\n\n  .header{\n    .title{\n      color: $white-color;\n    }\n    .category{\n      max-width: 600px;\n      color: $opacity-5;\n      margin: 0 auto;\n      font-size: 13px;\n\n      a{\n        color: $white-color;\n      }\n    }\n  }\n}\n\n.panel-header-sm{\n  height: 135px;\n}\n\n.panel-header-lg{\n  height: 380px;\n}\n\n\n// Stying for logos\n\n.sidebar .logo .simple-text .logo-img{\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    height: 34px;\n    width: 34px;\n    background: #FFFFFF;\n    border-radius: 50%;\n    text-align: center;\n    overflow: hidden;\n\n    img{\n      width: 51%;\n      vertical-align: unset;\n      height: 51%;\n    }\n}\n\n.sidebar {\n  &[data-color=\"white\"] {\n    border-right: 1px solid #ddd;\n  }\n}\n","\n/*             Navigation Tabs                 */\n.nav-tabs-navigation{\n  text-align: center;\n  border-bottom: 1px solid $medium-pale-bg;\n  margin-bottom: 30px;\n\n  .nav > .nav-item > .nav-link{\n    padding-bottom: 20px;\n  }\n}\n.nav-tabs-wrapper{\n  display: inline-block;\n  margin-bottom: -6px;\n  position: relative;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n}\n.nav-tabs {\n  justify-content: center;\n  border-bottom: 0 none;\n  font-size: $font-size-base;\n  font-weight: $font-weight-normal;\n  .nav-item{\n    .nav-link{\n      border: 0 none;\n      color: $other-medium-gray;\n      background-color: transparent;\n    }\n    .nav-link:hover{\n      color: $font-color;\n    }\n    .nav-link.active{\n      color: $font-color;\n    }\n  }\n\n  .nav-item{\n    color: $font-color;\n    position: relative;\n\n\n    .nav-link.active,\n    .nav-link.active:hover,\n    .nav-link.active:focus{\n      background-color: transparent;\n      border: 0 none;\n      //height: 50px;\n      &:after{\n        border-bottom: 11px solid $white-color;\n        border-left: 11px solid rgba(0, 0, 0, 0);\n        border-right: 11px solid rgba(0, 0, 0, 0);\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        right: 40%;\n        bottom: 5px;\n      }\n\n      &:before{\n        border-bottom: 11px solid $medium-pale-bg;\n        border-left: 11px solid rgba(0, 0, 0, 0);\n        border-right: 11px solid rgba(0, 0, 0, 0);\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        right: 40%;\n        bottom: 6px;\n      }\n    }\n\n  }\n  .nav-item.show .nav-link{\n    background-color: transparent;\n  }\n  .dropdown-menu{\n    margin-top: -6px;\n    margin-left: -46px;\n    border-radius: 8px;\n\n    .dropdown-item:hover,\n    .dropdown-item.active{\n      color: #FFFFFF;\n      background-color: #68B3C8;\n    }\n    :before{\n      border-bottom: 11px solid $medium-pale-bg;\n      border-left: 11px solid rgba(0, 0, 0, 0);\n      border-right: 11px solid rgba(0, 0, 0, 0);\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      right: 12px;\n      top: -11px;\n    }\n    :after{\n      border-bottom: 11px solid $pale-bg;\n      border-left: 11px solid rgba(0, 0, 0, 0);\n      border-right: 11px solid rgba(0, 0, 0, 0);\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      right: 12px;\n      top: -10px;\n    }\n  }\n}\n.profile-content{\n  & .tab-content{\n    & .tab-pane{\n      min-height: 200px;\n    }\n    & #tweets, #connections, #media{\n      height: 100%;\n    }\n  }\n}\n\n\n\n.nav-text, .nav-icons{\n  margin: $margin-bottom;\n\n  > li > a{\n    display: block;\n    padding: 0px $padding-base-horizontal;\n    color: $dark-gray;\n    text-align: center;\n    @include opacity(0.8);\n\n    &:hover,\n    &:focus{\n      background-color: $transparent-bg;\n      @include opacity(1);\n    }\n  }\n  > li:first-child a{\n    padding-left: 0;\n  }\n  > li.active a{\n    color: $info-color;\n  }\n}\n.nav-icons > li{\n  display: inline-block;\n  > a{\n    padding: 0 10px;\n    margin-bottom: 10px;\n  }\n  > a i{\n    font-size: $font-size-h4;\n    margin-bottom: 10px;\n    width: $font-size-h4;\n  }\n}\n.nav-icons.nav-stacked > li{\n  display: block;\n  > a {\n    margin-bottom: 20px;\n  }\n}\n.nav-blue > li.active a{\n  color: $primary-color;\n}\n.nav-azure > li.active a{\n  color: $info-color;\n}\n.nav-green > li.active a{\n  color: $success-color;\n}\n.nav-orange > li.active a{\n  color: $warning-color;\n}\n.nav-red > li.active a{\n  color: $danger-color;\n}\n\n.nav-text{\n  margin: $margin-bottom;\n\n  > li > a{\n    font-size: $font-size-h6;\n    text-transform: uppercase;\n    padding: 3px 0;\n    text-align: left;\n    font-weight: $font-weight-semi;\n\n  }\n  > li:first-child > a{\n    padding-top: 0;\n  }\n  h4{\n    margin-top: 0;\n  }\n}\n\n.nav-text:not(.nav-stacked){\n  > li{\n    display: inline-block;\n  }\n  > li > a{\n    margin-right: 15px;\n  }\n}\n\n.tab-space {\n  padding: 20px 0 50px;\n}\n\n// Vertical navs\n.verical-navs .nav-stacked .nav-link.active:before,\n.verical-navs .nav-stacked .nav-link.active:hover:before,\n.verical-navs .nav-stacked .nav-link.active:focus:before,\n.verical-navs .nav-stacked .nav-link.active.show:before{\n  border-right: 11px solid #F1EAE0;\n  border-top: 11px solid transparent;\n  border-bottom: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  bottom: 20px;\n}\n\n.verical-navs .nav-stacked .nav-link.active:after,\n.verical-navs .nav-stacked .nav-link.active:hover:after,\n.verical-navs .nav-stacked .nav-link.active:focus:after,\n.verical-navs .nav-stacked .nav-link.active.show:after{\n  border-right: 11px solid $white-color;\n  border-top: 11px solid transparent;\n  border-bottom: 11px solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  right: -1px;\n  bottom: 20px;\n}\n#second-tabs{\n  margin-left: 20px;\n}\n\n.nav-tabs-navigation.verical-navs {\n  border-right: 1px solid #F1EAE0;\n  font-size: 16px;\n  border-bottom: none;\n}\n",".card-timeline{\n  .timeline {\n    h6{\n      i {\n        margin-right: 4px;\n      }\n    }\n  }\n}\n","/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-target {\n  position: relative;\n}\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n.noUi-connect {\n  height: 100%;\n  width: 100%;\n}\n.noUi-origin {\n  height: 10%;\n  width: 10%;\n}\n/* Offset direction\n */\n.noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {\n  left: 0;\n  right: auto;\n}\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n  transition: all .3s ease;\n}\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 8px;\n}\n.noUi-horizontal .noUi-handle {\n  width: 15px;\n  height: 15px;\n  right: -7px;\n  top: 0px;\n}\n.noUi-vertical {\n  width: 8px;\n}\n.noUi-vertical .noUi-handle {\n  width: 15px;\n  height: 15px;\n  right: 0px;\n  top: -7px;\n}\n.noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {\n  left: -17px;\n  right: auto;\n}\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background: hsla(0,0%,71.4%,.3);\n  border-radius: 4px;\n  // border: 1px solid #D3D3D3;\n  // box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;\n}\n.noUi-connects {\n  border-radius: 3px;\n}\n.noUi-connect {\n  background: #3FB8AF;\n}\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n.noUi-handle {\n  border: none!important;\n  border-radius: 3px;\n  background: #FFF;\n  cursor: default;\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;\n}\n.noUi-active {\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;\n}\n/* Handle stripes;\n */\n\n.noUi-vertical .noUi-handle:before,\n.noUi-vertical .noUi-handle:after {\n  width: 14px;\n  height: 1px;\n  left: 6px;\n  top: 14px;\n}\n.noUi-vertical .noUi-handle:after {\n  top: 17px;\n}\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #CCC;\n}\n.noUi-marker-sub {\n  background: #AAA;\n}\n.noUi-marker-large {\n  background: #AAA;\n}\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n.noUi-horizontal .noUi-origin > .noUi-tooltip {\n  -webkit-transform: translate(50%, 0);\n  transform: translate(50%, 0);\n  left: auto;\n  bottom: 10px;\n}\n.noUi-vertical .noUi-origin > .noUi-tooltip {\n  -webkit-transform: translate(0, -18px);\n  transform: translate(0, -18px);\n  top: auto;\n  right: 28px;\n}\n.noUi-active {\n  transform: scale3d(1.5,1.5,1);\n}\n",".rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-align-items: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n}\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n.rbc-abs-full,\n.rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.rbc-ellipsis,\n.rbc-event-label,\n.rbc-row-segment .rbc-event-content,\n.rbc-show-more {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rbc-rtl {\n  direction: rtl;\n}\n.rbc-off-range {\n  color: #333333;\n  opacity: 0.3;\n}\n// .rbc-off-range-bg {\n//   background: #e5e5e5;\n// }\n.rbc-header {\n  overflow: hidden;\n  -webkit-flex: 1 0 0%;\n      -ms-flex: 1 0 0%;\n          flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: right;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 1em;\n  min-height: 0;\n  border-bottom: 1px solid #DDD;\n  color: #999999;\n  &:last-child{\n    span{\n      padding-right: 15px;\n    }\n  }\n}\n.rbc-header > a,\n.rbc-header > a:active,\n.rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-row-content {\n  position: relative;\n  -moz-user-select: none;\n   -ms-user-select: none;\n       user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n  min-height: 153px;\n}\n.rbc-toolbar {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n  padding-top: 20px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  padding: 0 10px;\n  text-align: center;\n  font-family: inherit;\n    line-height: 1.5em;\n    color: inherit;\n    font-weight: 500;\n    margin: 0;\n    font-size: 2.5em;\n}\n.rbc-toolbar button {\n  @include btn-styles($default-color, $default-states-color);\n  border-width: 2px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin: 5px 1px;\n  border: none;\n  margin: 10px 1px;\n  border-radius: 30px;\n  padding: 6px 12px;\n  cursor: pointer;\n  transition: all .2s ease-in-out;\n  outline: none;\n}\n.rbc-toolbar button:focus {\n  outline: none;\n}\n.rbc-btn-group {\n  display: inline-block;\n  // white-space: nowrap;\n}\n\n.rbc-btn-group button {\n    margin: 0 0 0 2px;\n    border-radius: 30px;\n}\n@media screen and (max-width: 526px){\n.rbc-btn-group button {\n  margin: 2px !important;\n}\n}\n\n.rbc-btn-group button + button {\n  margin: 0 0 0 2px;\n  border-radius: 30px;\n}\n// .rbc-rtl .rbc-btn-group button + button {\n//   margin-left: 0;\n//   margin-right: -1px;\n// }\n.rbc-btn-group + .rbc-btn-group,\n.rbc-btn-group + button {\n  margin-left: 10px;\n}\n\n.rbc-slot-selecting .rbc-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n.rbc-event.rbc-selected {\n  background-color: #265985;\n}\n.rbc-event-label {\n  font-size: 80%;\n}\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-day-after {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-day-prior {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.rbc-row-segment {\n  padding: 2px 6px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #DDD;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-flex: 1 0 0;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n  width: 100%;\n  -moz-user-select: none;\n   -ms-user-select: none;\n       user-select: none;\n  -webkit-user-select: none;\n  height: 100%;\n  border-left: none;\n  border-right: none;\n}\n.rbc-month-view {\n  border-top: none;\n}\n.rbc-month-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n\n.rbc-month-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-flex: 1 0 0;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n  // -webkit-flex-basis: 0px;\n      -ms-flex-preferred-size: 0px;\n          // flex-basis: 0px;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #DDD;\n}\n.rbc-date-cell {\n    flex: 1 1;\n    min-width: 0;\n    padding-left: 5px;\n    text-align: left;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a,\n.rbc-date-cell > a:active,\n.rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-row-bg {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-flex: 1 0 0;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n  overflow: hidden;\n}\n.rbc-day-bg {\n  -webkit-flex: 1 0 0%;\n      -ms-flex: 1 0 0%;\n          flex: 1 0 0%;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n.rbc-agenda-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-flex: 1 0 0;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border: 1px solid #DDD;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: 1px solid #DDD;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #DDD;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: ' »';\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: '« ';\n}\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n.rbc-time-column {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.rbc-timeslot-group {\n  border-bottom: 1px solid #DDD;\n  min-height: 40px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-flow: column nowrap;\n      -ms-flex-flow: column nowrap;\n          flex-flow: column nowrap;\n}\n.rbc-time-gutter,\n.rbc-header-gutter {\n  -webkit-flex: none;\n      -ms-flex: none;\n          flex: none;\n}\n.rbc-label {\n  padding: 0 5px;\n}\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-events-container {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 10px;\n  top: 0;\n}\n.rbc-day-slot .rbc-events-container.rbc-is-rtl {\n  left: 10px;\n  right: 0;\n}\n.rbc-day-slot .rbc-event {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  -webkit-flex-flow: column wrap;\n      -ms-flex-flow: column wrap;\n          flex-flow: column wrap;\n  -webkit-align-items: flex-start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n}\n.rbc-day-slot .rbc-event-label {\n  -webkit-flex: none;\n      -ms-flex: none;\n          flex: none;\n  padding-right: 5px;\n  width: auto;\n  font-weight: bold;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  color: #fff;\n      white-space: nowrap;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  -webkit-flex: 1 1 0;\n      -ms-flex: 1 1 0px;\n          flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot + .rbc-time-slot{\n  border-top: 1px dotted #ddd;\n}\n.rbc-time-slot {\n  -webkit-flex: 1 0 0;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n.rbc-day-header {\n  text-align: center;\n}\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px;\n}\n.rbc-slot-selecting {\n  cursor: move;\n}\n.rbc-time-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  width: 100%;\n  border: 1px solid #DDD;\n  min-height: 0;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n}\n.rbc-time-view .rbc-allday-cell {\n  box-sizing: content-box;\n  width: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  box-sizing: border-box;\n  min-height: 20px;\n}\n.rbc-time-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 0 0 auto;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #DDD;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #DDD;\n}\n.rbc-time-header > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #DDD;\n}\n.rbc-time-header-content {\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  min-width: 0;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-header-content {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-time-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 1 0 0%;\n      -ms-flex: 1 0 0%;\n          flex: 1 0 0%;\n  -webkit-align-items: flex-start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #DDD;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  -webkit-flex: none;\n      -ms-flex: none;\n          flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  -moz-user-select: none;\n   -ms-user-select: none;\n       user-select: none;\n  -webkit-user-select: none;\n}\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  height: 1px;\n  background-color: #74ad31;\n  pointer-events: none;\n}\n.rbc-event {\n  width: 100%;\n  position: relative; /* for resize handle and other inner positioning */\n  display: block; /* make the <a> tag block */\n  font-size: .85em;\n  border-radius: 2px;\n  padding: 0;\n  background-color: $light-blue; /* default BACKGROUND color */\n  // @include shadow-big-color($brand-success);\n  font-weight: normal; /* undo jqui's ui-widget-header bold */\n  text-align: left;\n  border: none;\n  padding-bottom: 1px;\n  line-height: 1.2;\n\n  &.event-azure{\n    background-color: $light-azure;\n  }\n  &.event-green{\n    background-color: $light-green;\n  }\n  &.event-orange{\n    background-color: $light-orange;\n  }\n  &.event-red{\n    background-color: $light-red;\n  }\n\n  .rbc-event-content{\n    position: relative;\n    z-index: 2;\n    white-space: nowrap;\n    overflow: hidden;\n    color: inherit;\n    padding: 0 5px;\n  }\n}\n.rbc-day-slot .rbc-event {\n     display: block !important;\n     height: unset !important;\n     max-height: unset !important;\n}\n\n.rbc-today{\n  background-color: $smoke-bg;\n}\n@media screen and (max-width: 1373px){\n  .rbc-toolbar {\n    display: block;\n    .rbc-btn-group{\n      display: block;\n      text-align: center;\n    }\n    .rbc-toolbar-label{\n      display: block;\n      flex-grow: unset;\n      padding: 0;\n    }\n  }\n}\n",".sweet-alert:focus{\n    outline: none;\n}\n.sweet-alert{\n  margin: auto !important;\n}\n","//  ========================================================================\n//  bootstrap-switch - v3.3.2\n//  http://www.bootstrap-switch.org\n// ========================================================================\n//  Copyright 2012-2013 Mattia Larentis\n// http://www.apache.org/licenses/LICENSE-2.0\n//\n\n\n// IMPORTANT! Creative Tim Notice: this file has major changes to fit the Now Ui Dashboard 's design. If you want to use the plugin as it was before our changes, please get the old files from http://www.bootstrap-switch.org\n\n\n.bootstrap-switch {\n  display: inline-block;\n  direction: ltr;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 0;\n  position: relative;\n  text-align: left;\n  overflow: hidden;\n  margin-bottom: 5px;\n  line-height: 8px;\n  width: 61px !important;\n  height: 26px;\n  outline: none;\n  z-index: 0;\n  margin-right: 1px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n  display: inline-flex;\n  top: 0;\n  height: 26px;\n  border-radius: 4px;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  width: 100px !important;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block !important;\n  height: 100%;\n  color: #fff;\n  padding: 6px 10px;\n  font-size: 11px;\n  text-indent: -5px;\n  line-height: 15px;\n  -webkit-transition: 0.25s ease-out;\n  transition: 0.25s ease-out;\n\n  i{\n    font-size: 12px;\n    line-height: 14px;\n  }\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-align: center;\n  z-index: 1;\n  float: left;\n  width: 50% !important;\n  background-color: #66615B;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {\n  color: #fff;\n  background: #7A9E9F;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {\n  color: #fff;\n  background: #68B3C8;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {\n  color: #fff;\n  background: #7AC29A;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {\n  background: #F3BB45;\n  color: #fff;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {\n  color: #fff;\n  background: #EB5E28;\n}\n\n\n.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\n  color: #fff;\n  background: #cfcfca;\n}\n\n.bootstrap-switch .bootstrap-switch-label {\n  text-align: center;\n  z-index: 100;\n  color: #333333;\n  background: #ffffff;\n  width: 22px !important;\n  height: 22px;\n  margin: 2px -11px;\n  border-radius: 12px;\n  position: relative;\n  float: left;\n  padding: 0;\n  background-color: #FFFFFF;\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-indent: 6px;\n}\n\n.bootstrap-switch input[type='radio'],\n.bootstrap-switch input[type='checkbox'] {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  z-index: -1;\n}\n\n.bootstrap-switch input[type='radio'].form-control,\n.bootstrap-switch input[type='checkbox'].form-control {\n  height: auto;\n}\n\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\n  padding: 6px 16px;\n  font-size: 18px;\n  line-height: 1.33;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled,\n.bootstrap-switch.bootstrap-switch-readonly,\n.bootstrap-switch.bootstrap-switch-indeterminate {\n  cursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\n.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\n.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n  -webkit-transition: margin-left 0.5s;\n  transition: margin-left 0.5s;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\n  margin-left: -2px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\n  margin-left: -37px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px;\n}\n\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px -13px -11px;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {\n  background-color: #66615B;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {\n  background-color: #cfcfca;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger  {\n  background-color: #EB5E28;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning  {\n  background-color: #F3BB45;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success  {\n  background-color: #7AC29A;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary  {\n  background-color: #7A9E9F;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info  {\n  background-color: #68B3C8;\n}\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default  {\n  background-color: #66615B;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {\n  background-color: #cfcfca;\n}\n.bootstrap-switch.wrapper{\n  min-height: auto;\n  height: auto;\n}\n",".card-wizard{\n    min-height: 410px;\n    box-shadow: $box-shadow;\n    opacity: 0;\n    @include transition($general-transition-time, $transition-linear);\n    &[data-color=\"primary\"]{\n        @include set-wizard-color($brand-primary);\n    }\n    &[data-color=\"white\"]{\n        @include set-wizard-color($white-color);\n    }\n\n    &[data-color=\"green\"]{\n        @include set-wizard-color($brand-success);\n    }\n\n    &[data-color=\"blue\"]{\n        @include set-wizard-color($brand-info);\n    }\n\n    &[data-color=\"orange\"]{\n        @include set-wizard-color($brand-warning);\n    }\n\n    &[data-color=\"red\"]{\n        @include set-wizard-color($brand-danger);\n    }\n    &.active{\n        opacity: 1;\n    }\n\n    .card-header {\n      padding: 15px 0 !important;\n      padding-bottom: 40px;\n      background-color: transparent;\n      .card-title{\n        color: $card-black-color;\n        & + .description{\n          color: $dark-gray;\n        }\n      }\n    }\n\n    .nav-pills .nav-item .nav-link{\n        padding: 12px;\n    }\n\n    .nav-pills .nav-item .nav-link,\n    .nav-pills .nav-item .nav-link.active,\n    .nav-pills .nav-item .nav-link:hover,\n    .nav-pills .nav-item .nav-link:focus,\n    .nav-pills .nav-item .nav-link.active:focus,\n    .nav-pills .nav-item .nav-link.active:hover{\n        background-color: transparent;\n        box-shadow: none;\n    }\n\n    .picture-container{\n        position: relative;\n        cursor: pointer;\n        text-align: center;\n    }\n\n    .wizard-navigation{\n      position: relative;\n\n      .nav-link{\n        display: flex;\n        align-items: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n      }\n    }\n\n    .wizard-navigation .nav-link i,\n    .moving-tab i{\n      display: inline-block;\n      font-size: 19px;\n      line-height: initial;\n      margin-right: 6px;\n      padding: 0;\n      vertical-align: bottom;\n    }\n    .moving-tab i{\n      margin-right: 9px;\n    }\n\n    .picture{\n        width: 106px;\n        height: 106px;\n        background-color: #999999;\n        border: 1px solid $light-gray;\n        color: #FFFFFF;\n        border-radius: 50%;\n        margin: 5px auto;\n        overflow: hidden;\n        transition: all 0.2s;\n        -webkit-transition: all 0.2s;\n\n        &:hover{\n            border-color: #2ca8ff;\n        }\n    }\n\n    .moving-tab{\n        position: absolute;\n        text-align: center;\n        padding: 12px;\n        font-size: 12px;\n        text-transform: uppercase;\n        -webkit-font-smoothing: subpixel-antialiased;\n        top: 0px;\n        left: 0px;\n        background-color: $default-color;\n        box-shadow: $box-shadow;\n        color: $white-color !important;\n        cursor: pointer;\n        font-weight: 500;\n    }\n\n    .picture input[type=\"file\"] {\n        cursor: pointer;\n        display: block;\n        height: 100%;\n        left: 0;\n        opacity: 0 !important;\n        position: absolute;\n        top: 0;\n        width: 100%;\n    }\n\n    .picture-src{\n        width: 100%;\n    }\n\n    .tab-content{\n        min-height: 355px;\n        padding: 20px 0;\n    }\n\n    .wizard-footer{\n        padding: 0 15px;\n\n        .checkbox{\n            margin-top: 16px;\n        }\n    }\n\n    .disabled{\n        display: none;\n    }\n\n    .wizard-header{\n        text-align: center;\n        padding: 25px 0 35px;\n\n        h5{\n           margin: 5px 0 0;\n       }\n    }\n\n    .nav-pills > li{\n        text-align: center;\n    }\n\n    .btn{\n        text-transform: uppercase;\n    }\n\n    .info-text{\n        text-align: center;\n        font-weight: 300;\n        margin: 10px 0 30px;\n    }\n\n    .choice{\n        text-align: center;\n        cursor: pointer;\n        margin-top: 20px;\n\n        &[disabled]{\n            pointer-events: none;\n            cursor: not-allowed;\n            opacity: .5;\n        }\n\n        .icon{\n            text-align: center;\n            vertical-align: middle;\n            height: 116px;\n            width: 116px;\n            border-radius: 50%;\n            color: $default-color;\n            margin: 0 auto 20px;\n            border: 1px solid $light-gray;\n            transition: all 0.2s;\n            -webkit-transition: all 0.2s;\n        }\n\n        i{\n            font-size: 30px;\n            line-height: 116px;\n            position: absolute;\n            left: 0;\n            right: 0;\n        }\n\n        &:hover,\n        &.active{\n            .icon{\n                border-color: #2ca8ff;\n            }\n        }\n\n        input[type=\"radio\"],\n        input[type=\"checkbox\"]{\n            position: absolute;\n            left: -10000px;\n            z-index: -1;\n        }\n    }\n\n    .btn-finish{\n        display: none;\n    }\n\n    .card-title + .description{\n        font-size: $font-size-base + 3;\n        margin-bottom: 32px;\n    }\n\n    .wizard-title{\n        margin: 0;\n    }\n\n    .nav-pills{\n        background-color: $dark-gray;\n\n        > li + li {\n            margin-left: 0;\n        }\n\n        > li > a {\n            border: 0 !important;\n            border-radius: 0 ;\n            line-height: 18px;\n            text-transform: uppercase;\n            font-size: 12px;\n            font-weight: 500;\n            min-width: 100px;\n            text-align: center;\n            color: $white-color !important;\n        }\n\n        > li.active > a,\n        > li.active > a:hover,\n        > li.active > a:focus,\n        > li > a:hover,\n        > li > a:focus{\n            background-color: inherit;\n            box-shadow: none;\n        }\n\n        > li i{\n            display: block;\n            font-size: 30px;\n            padding: 15px 0;\n        }\n    }\n\n  .form-group.select-wizard {\n    margin-top: 15px;\n  }\n\n  .dropdown.show,\n  .dropup.show {\n    .dropdown-menu {\n      @include transform-translate-y(0px);\n    }\n  }\n}\n","/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n.rdt {\n    position: relative;\n    .rdtPicker{\n        -webkit-transition: all 150ms linear;\n        -moz-transition: all 150ms linear;\n        -o-transition: all 150ms linear;\n        -ms-transition: all 150ms linear;\n        transition: all 150ms linear;\n        margin-top: -20px;\n        visibility: hidden;\n        display: block;\n        opacity: 0;\n    }\n    &.rdtOpen{\n        .rdtPicker{\n            opacity: 1;\n            visibility: visible;\n            margin-top: 0;\n        }\n    }\n}\n.rdtPicker {\n    display: none;\n    position: absolute;\n    width: 260px;\n    padding: 4px;\n    margin-top: 1px;\n    z-index: 99999 !important;\n    background: #fff;\n    border-radius: 0.125rem;\n    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n    -webkit-background-clip: padding-box;\n    background-clip: padding-box;\n    min-width: 160px;\n\n    &:before{\n        display: inline-block;\n        position: absolute;\n        width: 0;\n        height: 0;\n        vertical-align: middle;\n        content: \"\";\n        top: -5px;\n        left: 10px;\n        right: auto;\n        color: #FFFFFF;\n        border-bottom: .4em solid;\n        border-right: .4em solid transparent;\n        border-left: .4em solid transparent;\n    }\n    &:after{\n        border-bottom: .4em solid #FFFFFF;\n        border-right: .4em solid transparent;\n        border-left: .4em solid transparent;\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        top: -5px;\n        left: 10px;\n    }\n}\n\n.rdtPicker {\n    display: block;\n    top: 40px;\n}\n.rdtStatic .rdtPicker {\n    box-shadow: none;\n    position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n    text-align: center;\n    padding: 5px;\n    border-radius: 4px;\n}\n\n.rdtPicker table {\n    width: 100%;\n    margin: 0;\n    border-color: $white-color !important;\n}\n.rdtPicker td,\n.rdtPicker th {\n    text-align: center;\n    padding: 1px;\n}\n.rdtPicker td {\n    cursor: pointer;\n}\n.rdtDay{\n    height: 30px;\n    line-height: 33px;\n    width: 30px;\n    text-align: center;\n    padding: 0px;\n    border-radius: 50%;\n    &.rdtToday.rdtActive,\n    &.rdtActive,\n    &.rdtActive:hover {\n        background-color: $primary-color !important;\n        color: $white-color;\n    }\n}\n.rdtDays{\n    tr{\n        .dow{\n            text-align: center;\n            border-bottom: 1px solid #E3E3E3;\n            font-size: 12px;\n            text-transform: uppercase;\n            font-weight: inherit;\n            padding-bottom: 5px;\n            padding-top: 10px;\n        }\n        .rdtOld,\n        .rdtNew{\n            color: $medium-gray;\n        }\n    }\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover {\n    background: #eeeeee;\n    cursor: pointer;\n}\n.rdtPicker td.rdtToday {\n    position: relative;\n}\n.rdtPicker td.rdtActive.rdtToday:before {\n    border-bottom-color: #fff;\n}\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n    background: none;\n    color: #999999;\n    cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n    color: #999999;\n}\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n    background: none;\n    color: #999999;\n    cursor: not-allowed;\n}\n.rdtPicker .dow {\n    width: 14.2857%;\n    border-bottom: none;\n}\n.rdtPicker th.rdtSwitch {\n    width: 50px;\n    padding: 5px;\n    border-radius: 4px;\n}\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n    font-size: 21px;\n    vertical-align: top;\n    border-radius: 50%;\n    line-height: 33px;\n}\n\n.rdtPicker{\n    .dow,\n    th.rdtSwitch,\n    th.rdtNext,\n    th.rdtPrev,\n    .rdtTimeToggle{\n        color: $primary-color;\n    }\n}\n\n\n.rdtPrev span,\n.rdtNext span {\n    display: block;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none;   /* Chrome/Safari/Opera */\n    -khtml-user-select: none;    /* Konqueror */\n    -moz-user-select: none;      /* Firefox */\n    -ms-user-select: none;       /* Internet Explorer/Edge */\n    user-select: none;\n\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n    background: none;\n    color: #999999;\n    cursor: not-allowed;\n}\n.rdtPicker thead tr:first-child th {\n    cursor: pointer;\n}\n.rdtPicker thead tr:first-child th:hover {\n    background: #eeeeee;\n}\n\n\n.rdtPicker button {\n    border: none;\n    background: none;\n    cursor: pointer;\n}\n.rdtPicker button:hover {\n    background-color: #eee;\n}\n\n.rdtPicker thead button {\n    width: 100%;\n    height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n    height: 50px;\n    width: 25%;\n    cursor: pointer;\n}\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n    background: #eee;\n}\n\n.rdtCounters {\n    display: inline-block;\n}\n\n.rdtCounters{\n    > div {\n        float: left;\n        width: 40px;\n        font-weight: inherit;\n        margin: 3px;\n        border-radius: 50%;\n    }\n    .rdtCounterSeparator{\n        width: 0;\n        border: 1px solid transparent;\n    }\n}\n\n.rdtCounter {\n    height: 100px;\n}\n\n.rdtCounter {\n    width: 40px;\n    .rdtCount{\n        padding: 7px;\n        height: 40px;\n        border: 1px solid transparent;\n    }\n}\n.rdtCounters{\n    .rdtCounter:last-child{\n        .rdtCount{\n            color: $primary-color;\n            border-radius: 50%;\n            border: 1px solid $primary-color;\n        }\n    }\n}\n\n.rdtCounterSeparator {\n    padding: 7px;\n    line-height: 100px;\n}\n.rdtCounter .rdtBtn {\n    line-height: 40px;\n    cursor: pointer;\n    display: block;\n    border-radius: 50%;\n    color: $medium-gray;\n    -webkit-transition: all 60ms ease-in;\n    -moz-transition: all 60ms ease-in;\n    -o-transition: all 60ms ease-in;\n    -ms-transition: all 60ms ease-in;\n    transition: all 60ms ease-in;\n\n\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none;   /* Chrome/Safari/Opera */\n    -khtml-user-select: none;    /* Konqueror */\n    -moz-user-select: none;      /* Firefox */\n    -ms-user-select: none;       /* Internet Explorer/Edge */\n    user-select: none;\n}\n.rdtCounter .rdtBtn:hover {\n    background: #eee;\n    color: #797979;\n}\n.rdtCounter .rdtCount {\n    font-size: inherit;\n    line-height: 25px;\n}\n\n.rdtMilli {\n    vertical-align: middle;\n    padding-left: 8px;\n    width: 48px;\n}\n\n.rdtMilli input {\n    width: 100%;\n    font-size: inherit;\n    margin-top: 37px;\n}\n.rdtMonths,\n.rdtYears{\n    padding-bottom: 10px;\n    .rdtMonth,\n    .rdtYear{\n        display: inline-block;\n        width: 56px;\n        height: 56px;\n        line-height: 56px;\n        margin: 3px 3px;\n        cursor: pointer;\n        border-radius: 50%;\n        text-align: center;\n\n        &.rdtActive{\n            background-color: $primary-color !important;\n            color: $white-color;\n        }\n    }\n}\n","svg {\n    touch-action: none;\n}\n\n.jvectormap-container {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n    touch-action: none;\n}\n\n.jvectormap-tip {\n    position: absolute;\n    display: none;\n    border: solid 1px #CDCDCD;\n    border-radius: 3px;\n    background: #292929;\n    color: white;\n    font-family: sans-serif, Verdana;\n    font-size: smaller;\n    padding: 3px;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {\n    position: absolute;\n    left: 10px;\n    border-radius: 3px;\n    background: #292929;\n    padding: 3px;\n    color: white;\n    cursor: pointer;\n    line-height: 10px;\n    text-align: center;\n    box-sizing: content-box;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout {\n    width: 10px;\n    height: 10px;\n}\n\n.jvectormap-zoomin {\n    top: 10px;\n}\n\n.jvectormap-zoomout {\n    top: 30px;\n}\n\n.jvectormap-goback {\n    bottom: 10px;\n    z-index: 1000;\n    padding: 6px;\n}\n\n.jvectormap-spinner {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: center no-repeat url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n    font-weight: bold;\n    font-size: 14px;\n    text-align: center;\n}\n\n.jvectormap-legend-cnt {\n    position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n    bottom: 0;\n    right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n    top: 0;\n    right: 0;\n}\n\n.jvectormap-legend {\n    background: black;\n    color: white;\n    border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n    float: left;\n    margin: 0 10px 10px 0;\n    padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n    float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n    margin: 10px 10px 0 0;\n    padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n    width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n    height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n    height: 20px;\n    width: 20px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n    font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n    text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 20px;\n    padding-left: 3px;\n}\n","/**\n* React Select v1.0.0-rc.10\n* ============\n* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/\n* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n* MIT License: https://github.com/JedWatson/react-select\n*/\n\n\n/*\nThis file was modified entirely by Creative Tim for React-Select v2.0.0\n*/\n\n.react-select {\n  .react-select__menu{\n    top: 105%;\n    max-width: 94%;\n    width: 94%;\n    right: 3%;\n    border-radius: 12px;\n    border: 0;\n    box-shadow: 1px 2px 7px 1px rgba(0,0,0,.125);\n    transition: all .3s cubic-bezier(.215,.61,.355,1) 0s,opacity .3s ease 0s,height 0s linear .35s;\n    background-color: $white-bg;\n    box-sizing: border-box;\n    max-height: 200px;\n    position: absolute;\n    z-index: 2;\n    -webkit-overflow-scrolling: touch;\n    padding-bottom: 10px;\n    margin-bottom: unset;\n    margin-top: unset;\n    &:before{\n      border-bottom: 11px solid #f1eae0;\n      top: -11px;\n      border-left: 11px solid transparent;\n      border-right: 11px solid transparent;\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      right: 15px;\n    }\n\n    &:after{\n      top: -10px;\n      border-bottom: 11px solid #fffcf5;\n      border-left: 11px solid transparent;\n      border-right: 11px solid transparent;\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      right: 15px;\n\n\n    }\n  }\n  .react-select__menu-list {\n    max-height: 198px;\n    overflow-y: auto;\n    padding-bottom: unset;\n    padding-top: unset;\n    position: relative;\n  }\n  .react-select__option {\n    font-size: 0.8571em;\n    padding-top: .6rem;\n    padding-bottom: .6rem;\n    margin-top: 5px;\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n    display: block;\n    outline: none;\n    color: #292b2c;\n  }\n  .react-select__menu{\n    .react-select__option{\n      &,&:active{\n        background-color: transparent;\n      }\n      &.react-select__option--is-selected{\n        &,&.react-select__option--is-focused{\n          &,&:active{\n            background-color: $medium-gray;\n          }\n        }\n      }\n      &.react-select__option--is-focused {\n        &,&:active{\n          background-color: $smoke-bg;\n        }\n      }\n      &.react-select__option--is-disabled {\n        &,&:active{\n          color: #cccccc;\n          cursor: default;\n        }\n      }\n    }\n  }\n  .react-select__control{\n    border-radius: 4px;\n    min-height: 40px;\n    height: 40px;\n    box-sizing: border-box;\n    border-collapse: separate;\n    display: table;\n    width: 100%;\n    &,&:hover{\n      border: 1px solid $light-gray;\n      box-shadow: none;\n      background-color: transparent;\n    }\n    &.react-select__control--is-focused{\n      .react-select__dropdown-indicator{\n        &:after{\n          transform: rotate(180deg);\n          top: -4px;\n        }\n      }\n      &,&:hover{\n        border: 1px solid $primary-color;\n        box-shadow: none;\n      }\n    }\n    .react-select__value-container--has-value{\n      .react-select__multi-value{\n        display: inline-flex;\n        border-radius: 4px;\n        background-color: transparent;\n        & + div:not(.react-select__multi-value){\n          display: inline-flex;\n        }\n        .react-select__multi-value__label{\n          font-size: 0.9em;\n        }\n      }\n      .react-select__single-value{\n        top: 48%;\n        color: $black-color;\n      }\n    }\n    .react-select__placeholder{\n      color: $dark-gray;\n      line-height: normal;\n      font-size: 0.8571em;\n      top: 48%;\n    }\n    .react-select__value-container,\n    .react-select__indicators{\n      display: table-cell;\n    }\n    .react-select__indicators {\n      width: 60px;\n      padding-right: 10px;\n      align-items: flex-end;\n      vertical-align: middle;\n      text-align: right;\n      .react-select__indicator-separator{\n        display: none;\n      }\n      .react-select__indicator {\n        padding: 0;\n        display: inline-block;\n      }\n      .react-select__dropdown-indicator{\n        &:after{\n          transition: all 150ms ease 0s;\n          border-color: #999 transparent transparent;\n          border-style: solid;\n          border-width: 5px 5px 2.5px;\n          display: inline-block;\n          height: 0;\n          width: 0;\n          position: relative;\n          content: \"\";\n        }\n        &:hover:after{\n          border-top-color: $link-disabled-color;\n        }\n        & > * {\n          display: none;\n        }\n      }\n      .react-select__clear-indicator{\n        &:before{\n          content: \"\\D7\";\n          display: inline-block;\n          font-size: 18px;\n          line-height: 1;\n          top: 2px;\n          position: relative;\n          margin-right: 3px;\n        }\n        & > * {\n          display: none;\n        }\n      }\n    }\n  }\n  &.primary{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $primary-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $primary-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $primary-color;\n      .react-select__multi-value__remove{\n        color: $primary-color-opacity;\n        border-left: 1px solid $primary-color-opacity;\n        &:hover{\n          color: $primary-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.success{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $success-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $success-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $success-color;\n      .react-select__multi-value__remove{\n        color: $success-color-opacity;\n        border-left: 1px solid $success-color-opacity;\n        &:hover{\n          color: $success-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.info{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $info-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $info-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $info-color;\n      .react-select__multi-value__remove{\n        color: $info-color-opacity;\n        border-left: 1px solid $info-color-opacity;\n        &:hover{\n          color: $info-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.warning{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $warning-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $warning-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $warning-color;\n      .react-select__multi-value__remove{\n        color: $warning-color-opacity;\n        border-left: 1px solid $warning-color-opacity;\n        &:hover{\n          color: $warning-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.danger{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $danger-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $danger-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $danger-color;\n      .react-select__multi-value__remove{\n        color: $danger-color-opacity;\n        border-left: 1px solid $danger-color-opacity;\n        &:hover{\n          color: $danger-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  .react-select__multi-value{\n    border: 1px solid $dark-gray;\n    .react-select__multi-value__remove{\n      position: relative;\n      color: $opacity-gray-8;\n      border-left: 1px solid $opacity-gray-8;\n      &:hover{\n        color: $dark-gray;\n        background-color: transparent;\n      }\n    }\n  }\n  &.react-select--is-disabled{\n    .react-select__multi-value--is-disabled{\n      .react-select__multi-value__remove {\n        display: none;\n      }\n      &.react-select__multi-value{\n        background-color: #fcfcfc;\n        border: 1px solid #e3e3e3;\n      }\n    }\n    .react-select__control--is-disabled{\n      background-color: #f9f9f9;\n    }\n  }\n}\n",".ReactTable{\n  position:relative;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-orient:vertical;\n  -webkit-box-direction:normal;\n  -ms-flex-direction:column;\n  flex-direction:column;\n  background-color: transparent;\n\n  &.primary-pagination{\n    .-pagination .-btn{\n      @include btn-styles($primary-color, $primary-states-color);\n      &:disabled{\n        @include opacity(.5);\n        pointer-events: none;\n        cursor: not-allowed;\n      }\n    }\n  }\n  &.info-pagination{\n    .-pagination .-btn{\n      @include btn-styles($info-color, $info-states-color);\n      &:disabled{\n        @include opacity(.5);\n        pointer-events: none;\n        cursor: not-allowed;\n      }\n    }\n  }\n  &.success-pagination{\n    .-pagination .-btn{\n      @include btn-styles($success-color, $success-states-color);\n      &:disabled{\n        @include opacity(.5);\n        pointer-events: none;\n        cursor: not-allowed;\n      }\n    }\n  }\n  &.warning-pagination{\n    .-pagination .-btn{\n      @include btn-styles($warning-color, $warning-states-color);\n      &:disabled{\n        @include opacity(.5);\n        pointer-events: none;\n        cursor: not-allowed;\n      }\n    }\n  }\n  &.danger-pagination{\n    .-pagination .-btn{\n      @include btn-styles($danger-color, $danger-states-color);\n      &:disabled{\n        @include opacity(.5);\n        pointer-events: none;\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n.ReactTable{\n  .actions-right{\n    text-align: right;\n  }\n  .actions-left{\n    text-align: left;\n  }\n  .actions-center{\n    text-align: center;\n  }\n}\n.ReactTable *{\n  box-sizing:border-box\n}\n.ReactTable .rt-table{\n  -webkit-box-flex:1;\n  -ms-flex:auto 1;\n  flex:auto 1;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-orient:vertical;\n  -webkit-box-direction:normal;\n  -ms-flex-direction:column;\n  flex-direction:column;\n  -webkit-box-align:stretch;\n  -ms-flex-align:stretch;\n  align-items:stretch;\n  width:100%;\n  border-collapse:collapse;\n  overflow:auto\n}\n.ReactTable .rt-thead{\n  -webkit-box-flex:1;\n  -ms-flex:1 0 auto;\n  flex:1 0 auto;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-orient:vertical;\n  -webkit-box-direction:normal;\n  -ms-flex-direction:column;\n  flex-direction:column;\n  -webkit-user-select:none;\n  -moz-user-select:none;\n  -ms-user-select:none;\n  user-select:none;\n}\n.ReactTable .rt-thead.-headerGroups{\n  background:rgba(0,0,0,0.03);\n  border-bottom:1px solid rgba(0,0,0,0.05)\n}\n.ReactTable .rt-thead.-filters input,.ReactTable .rt-thead.-filters select{\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  color: #565656;\n  font-weight: 400;\n  height: 28px;\n  background-color: inherit;\n  padding-left: .8em;\n  &:focus{\n    outline: none;\n    border: 1px solid #aaa;\n    color: #333;\n  }\n}\n.ReactTable .rt-thead .rt-tr{\n  text-align:center\n}\n.ReactTable .rt-thead .rt-th:last-child{\n  text-align: right;\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type{\n  &:after{\n    opacity: 0.6;\n    content: \"\\F0DC\";\n    position: relative;\n    display: inline-block;\n    bottom: 0px;\n    right: -7px;\n    font-family: 'FontAwesome';\n  }\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-desc > div:first-of-type{\n  &:after{\n    content: \"\\F0DD\";\n    top: -3px;\n    position: relative;\n    display: inline-block;\n    bottom: 0px;\n    right: -7px;\n    font-family: 'FontAwesome';\n    opacity: 1;\n  }\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-asc > div:first-of-type{\n  &:after{\n    content: \"\\F0DE\";\n    top: 3px;\n    position: relative;\n    display: inline-block;\n    bottom: 0px;\n    right: -7px;\n    font-family: 'FontAwesome';\n    opacity: 1;\n  }\n}\n.ReactTable .rt-thead .rt-th,.ReactTable .rt-thead .rt-td{\n  font-size: 1.063rem;\n  text-align: left;\n  font-weight: 300;\n  line-height: 2.5em !important;\n  padding:5px 5px;\n  line-height:normal;\n  position:relative;\n  transition:box-shadow .3s cubic-bezier(.175,.885,.32,1.275);\n  box-shadow:inset 0 0 0 0 transparent;\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer,.ReactTable .rt-thead .rt-td.-cursor-pointer{\n  cursor:pointer\n}\n.ReactTable .rt-thead .rt-th:last-child,.ReactTable .rt-thead .rt-td:last-child{\n  border-right:0\n}\n.ReactTable .rt-thead .rt-resizable-header{\n  overflow:visible;\n}\n.ReactTable .rt-thead .rt-resizable-header:last-child{\n  overflow:hidden\n}\n.ReactTable .rt-thead .rt-resizable-header-content{\n  overflow:hidden;\n  text-overflow:ellipsis;\n  &:focus{\n    outline: none;\n  }\n}\n.ReactTable .rt-thead .rt-header-pivot{\n  border-right-color:#f7f7f7\n}\n.ReactTable .rt-thead .rt-header-pivot:after,.ReactTable .rt-thead .rt-header-pivot:before{\n  left:100%;\n  top:50%;\n  border:solid transparent;\n  content:\" \";\n  height:0;\n  width:0;\n  position:absolute;\n  pointer-events:none\n}\n.ReactTable .rt-thead .rt-header-pivot:after{\n  border-color:rgba(255,255,255,0);\n  border-left-color:#fff;\n  border-width:8px;\n  margin-top:-8px\n}\n.ReactTable .rt-thead .rt-header-pivot:before{\n  border-color:rgba(102,102,102,0);\n  border-left-color:#f7f7f7;\n  border-width:10px;\n  margin-top:-10px\n}\n.ReactTable .rt-tbody{\n  -webkit-box-flex:99999;\n  -ms-flex:99999 1 auto;\n  flex:99999 1 auto;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-orient:vertical;\n  -webkit-box-direction:normal;\n  -ms-flex-direction:column;\n  flex-direction:column;\n  overflow:auto;\n}\n.ReactTable .rt-tbody .rt-tr-group:last-child{\n  border-bottom:0\n}\n.ReactTable .rt-tbody .rt-td:last-child{\n  border-right:0\n}\n.ReactTable .rt-tbody .rt-expandable{\n  cursor:pointer\n}\n.ReactTable .rt-tr-group{\n  -webkit-box-flex:1;\n  -ms-flex:1 0 auto;\n  flex:1 0 auto;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-orient:vertical;\n  -webkit-box-direction:normal;\n  -ms-flex-direction:column;\n  flex-direction:column;\n  -webkit-box-align:stretch;\n  -ms-flex-align:stretch;\n  align-items:stretch\n}\n.ReactTable .rt-tr{\n  -webkit-box-flex:1;\n  -ms-flex:1 0 auto;\n  flex:1 0 auto;\n  display:-webkit-inline-box;\n  display:-ms-inline-flexbox;\n  display:inline-flex\n}\n.ReactTable .rt-th,.ReactTable .rt-td{\n  -webkit-box-flex:1;\n  -ms-flex:1 0 0px;\n  flex:1 0 0;\n  white-space:nowrap;\n  text-overflow:ellipsis;\n  padding:12px 7px;\n  overflow:hidden;\n  transition:.3s ease;\n  transition-property:width,min-width,padding,opacity;\n  line-height: 2;\n}\n.ReactTable .rt-th.-hidden,.ReactTable .rt-td.-hidden{\n  width:0 !important;\n  min-width:0 !important;\n  padding:0 !important;\n  border:0 !important;\n  opacity:0 !important\n}\n.ReactTable .rt-expander{\n  display:inline-block;\n  position:relative;\n  margin:0;\n  color:transparent;\n  margin:0 10px;\n}\n.ReactTable .rt-expander:after{\n  content:'';\n  position:absolute;\n  width:0;\n  height:0;\n  top:50%;\n  left:50%;\n  -webkit-transform:translate(-50%,-50%) rotate(-90deg);\n  transform:translate(-50%,-50%) rotate(-90deg);\n  border-left:5.04px solid transparent;\n  border-right:5.04px solid transparent;\n  border-top:7px solid rgba(0,0,0,0.8);\n  transition:all .3s cubic-bezier(.175,.885,.32,1.275);\n  cursor:pointer\n}\n.ReactTable .rt-expander.-open:after{\n  -webkit-transform:translate(-50%,-50%) rotate(0);\n  transform:translate(-50%,-50%) rotate(0)\n}\n.ReactTable .rt-resizer{\n  display:inline-block;\n  position:absolute;\n  width:36px;\n  top:0;\n  bottom:0;\n  right:-18px;\n  cursor:col-resize;\n  z-index:10\n}\n.ReactTable .rt-tfoot{\n  -webkit-box-flex:1;\n  -ms-flex:1 0 auto;\n  flex:1 0 auto;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-orient:vertical;\n  -webkit-box-direction:normal;\n  -ms-flex-direction:column;\n  flex-direction:column;\n  box-shadow:0 0 15px 0 rgba(0,0,0,0.15);\n}\n.ReactTable .rt-tfoot .rt-td{\n  border-right:1px solid rgba(0,0,0,0.05);\n}\n.ReactTable .rt-tfoot .rt-td:last-child{\n  border-right:0\n}\n.ReactTable.-striped .rt-tr.-odd{\n  background:rgba(0,0,0,0.03)\n}\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover{\n  background:rgba(0,0,0,0.05)\n}\n.ReactTable .-pagination{\n  z-index:1;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-pack:justify;\n  -ms-flex-pack:justify;\n  justify-content:space-between;\n  -webkit-box-align:stretch;\n  -ms-flex-align:stretch;\n  align-items:stretch;\n  -ms-flex-wrap:wrap;\n  flex-wrap:wrap;\n  padding:3px;\n}\n.ReactTable .-pagination input,.ReactTable .-pagination select{\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  color: #565656;\n  font-weight: 400;\n  height: 28px;\n  background-color: inherit;\n  text-align: center;\n  &:focus{\n    outline: none;\n    border: 1px solid #aaa;\n    color: #333;\n  }\n}\n.ReactTable .-pagination .-btn{\n  -webkit-appearance:none;\n  -moz-appearance:none;\n  appearance:none;\n  display:block;\n  width:100%;\n  height:100%;\n  border:0;\n  border-radius:3px;\n  padding:6px;\n  font-size:1em;\n  color:rgba(0,0,0,0.6);\n  background:rgba(0,0,0,0.1);\n  transition:all .1s ease;\n  cursor:pointer;\n  outline:none;\n}\n.ReactTable .-pagination .-btn[disabled]{\n  opacity:.5;\n  cursor:not-allowed;\n}\n.ReactTable .-pagination .-btn:not([disabled]):hover{\n  background:rgba(0,0,0,0.3);\n  color:#fff\n}\n.ReactTable .-pagination .-previous,.ReactTable .-pagination .-next{\n  -webkit-box-flex:1;\n  -ms-flex:1;\n  flex:1;\n  text-align:center\n}\n.ReactTable .-pagination .-center{\n  -webkit-box-flex:1.5;\n  -ms-flex:1.5;\n  flex:1.5;\n  text-align:center;\n  margin-bottom:0;\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-orient:horizontal;\n  -webkit-box-direction:normal;\n  -ms-flex-direction:row;\n  flex-direction:row;\n  -ms-flex-wrap:wrap;\n  flex-wrap:wrap;\n  -webkit-box-align:center;\n  -ms-flex-align:center;\n  align-items:center;\n  -ms-flex-pack:distribute;\n  justify-content:space-around\n}\n.ReactTable .-pagination .-pageInfo{\n  display:inline-block;\n  margin:3px 10px;\n  white-space:nowrap\n}\n.ReactTable .-pagination .-pageJump{\n  display:inline-block;\n}\n.ReactTable .-pagination .-pageSizeOptions{\n  margin:3px 10px\n}\n.ReactTable .rt-noData{\n  display:block;\n  position:absolute;\n  left:50%;\n  top:50%;\n  -webkit-transform:translate(-50%,-50%);\n  transform:translate(-50%,-50%);\n  background:rgba(255,255,255,0.8);\n  transition:all .3s ease;\n  z-index:1;\n  pointer-events:none;\n  padding:20px;\n  color:rgba(0,0,0,0.5)\n}\n.ReactTable .-loading{\n  display:block;\n  position:absolute;\n  left:0;\n  right:0;\n  top:0;\n  bottom:0;\n  background:rgba(255,255,255,0.8);\n  transition:all .3s ease;\n  z-index:-1;\n  opacity:0;\n  pointer-events:none;\n}\n.ReactTable .-loading > div{\n  position:absolute;\n  display:block;\n  text-align:center;\n  width:100%;\n  top:50%;\n  left:0;\n  font-size:15px;\n  color:rgba(0,0,0,0.6);\n  -webkit-transform:translateY(-52%);\n  transform:translateY(-52%);\n  transition:all .3s cubic-bezier(.25,.46,.45,.94)\n}\n.ReactTable .-loading.-active{\n  opacity:1;\n  z-index:2;\n  pointer-events:all;\n}\n.ReactTable .-loading.-active > div{\n  -webkit-transform:translateY(50%);\n  transform:translateY(50%)\n}\n.ReactTable .rt-resizing .rt-th,.ReactTable .rt-resizing .rt-td{\n  transition:none !important;\n  cursor:col-resize;\n  -webkit-user-select:none;\n  -moz-user-select:none;\n  -ms-user-select:none;\n  user-select:none\n}\n\n.ReactTable .rt-thead .rt-th:focus{\n  outline: none;\n}\n.ReactTable .rt-thead .rt-th{\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  border: 0;\n}\n\n.ReactTable .rt-table{\n  border: 1px solid #dee2e6;\n}\n\n.ReactTable .rt-table .rt-td{\n  border-top: 1px solid #dee2e6;\n  border-right: 1px solid #dee2e6;\n}\n\n.ReactTable .btn.btn-icon{\n  margin: 0 3px;\n  padding: 5px 8px;\n}\n","// Based on the original react-tagsinput styles\n\n.react-tagsinput {\n    display: inline-block;\n    padding: 4px 6px;\n    max-width: 100%;\n    line-height: 22px;\n}\n\n.react-tagsinput-tag {\n  transition: all .17s linear;\n  cursor: pointer;\n  margin: 5px 3px 5px 0;\n  position: relative;\n  padding: 4px 8px 3px .8em;\n  border-radius: 12px;\n  color: #fff;\n  font-size: .75em;\n  font-weight: 500;\n  display: inline-block;\n  line-height: 1.5em;\n  text-transform: uppercase;\n  border: 1px solid;\n}\n\n.react-tagsinput-remove {\n    cursor: pointer;\n    font-weight: bold;\n}\n\n.react-tagsinput-tag a::before {\n    font-family: 'nucleo-icons';\n    content: \"\\ea4f\";\n    padding: 0px 2px;\n}\n.react-tagsinput-tag a{\n    cursor: pointer;\n    position: absolute;\n    top: 3px;\n    right: 0px;\n    opacity: 0;\n    background-color: transparent;\n}\n\n\n\n.react-tagsinput-input {\n    background: transparent;\n    border: 0;\n    color: #777;\n    font-family: sans-serif;\n    font-size: 13px;\n    font-weight: 400;\n    margin-bottom: 6px;\n    margin-top: 1px;\n    outline: none;\n    padding: 5px;\n    width: 80px;\n}\n\n.react-tagsinput{\n    .react-tagsinput-tag{\n        -webkit-transition: all 300ms ease 0s;\n        -moz-transition: all 300ms ease 0s;\n        -o-transition: all 300ms ease 0s;\n        -ms-transition: all 300ms ease 0s;\n        transition: all 300ms ease 0s;\n\n        &:hover{\n            padding-right: 22px;\n\n            a{\n                opacity: 1;\n                padding-right: 4px;\n            }\n        }\n\n        @include badge-color($default-color);\n        &.primary{\n            @include badge-color($primary-color);\n        }\n        &.info{\n            @include badge-color($info-color);\n        }\n        &.success{\n            @include badge-color($success-color);\n        }\n        &.warning{\n            @include badge-color($warning-color);\n        }\n        &.danger{\n            @include badge-color($danger-color);\n        }\n        &.neutral{\n            @include badge-color($white-color);\n            color: inherit;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
